import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  bigint: { input: any; output: any; }
  date: { input: any; output: any; }
  float8: { input: any; output: any; }
  geography: { input: any; output: any; }
  geometry: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  time: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  timetz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

export type AccountLinkDto = {
  __typename?: 'AccountLinkDto';
  created: Scalars['Float']['output'];
  expires_at: Scalars['Float']['output'];
  object: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type AdminCustomerListDto = {
  __typename?: 'AdminCustomerListDto';
  customers: Array<CustomerEntryDto>;
  customersAggregate: Aggregate;
};

export type Aggregate = {
  __typename?: 'Aggregate';
  aggregate: Count;
};

export type AggregateSum = {
  __typename?: 'AggregateSum';
  aggregate: Sum;
};

export type Amount = {
  __typename?: 'Amount';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type Appointment = {
  __typename?: 'Appointment';
  address?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<GeographyCoordinates>;
  createdAt: Scalars['String']['output'];
  createdByUserId: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  employeeId: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jobStatus: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  paymentStatus: Scalars['String']['output'];
  serviceId: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type AppointmentLocationDto = {
  __typename?: 'AppointmentLocationDto';
  address: Scalars['String']['output'];
  id: Scalars['String']['output'];
  radius?: Maybe<Scalars['Float']['output']>;
};

export type AppointmentServiceDto = {
  __typename?: 'AppointmentServiceDto';
  provider: ServiceProviderDto;
  sku: Scalars['String']['output'];
};

export enum ApptPaidBy {
  Customer = 'customer',
  ManualCard = 'manual_card'
}

export type AvailableAppointmentDateTimeSlotsDto = {
  __typename?: 'AvailableAppointmentDateTimeSlotsDto';
  availableSlots: Array<TimeSlotDto>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type BuildingManagerCustomerListDto = {
  __typename?: 'BuildingManagerCustomerListDto';
  allAppointmentsAggregate: Aggregate;
  allCustomersAggregate: Aggregate;
  filteredCustomers: Array<BuildingManagerCustomerListEntryDto>;
  filteredCustomersAggregate: Aggregate;
};

export type BuildingManagerCustomerListEntryDto = {
  __typename?: 'BuildingManagerCustomerListEntryDto';
  address?: Maybe<Scalars['String']['output']>;
  amountSpent?: Maybe<Amount>;
  apartmentNumber?: Maybe<Scalars['String']['output']>;
  bmStripeCustomerId?: Maybe<Scalars['String']['output']>;
  bmStripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  bookings?: Maybe<Aggregate>;
  coordinates?: Maybe<GeographyCoordinates>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isBlocked: Scalars['Boolean']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<CustomerUserDto>;
};

export type BuildingManagerCustomerWithAppointmentsDto = {
  __typename?: 'BuildingManagerCustomerWithAppointmentsDto';
  address?: Maybe<Scalars['String']['output']>;
  amountSpent?: Maybe<Amount>;
  apartmentNumber?: Maybe<Scalars['String']['output']>;
  appointments: Array<CustomerAppointmentData>;
  appointmentsAggregate: Aggregate;
  bmStripeCustomerId?: Maybe<Scalars['String']['output']>;
  bmStripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  bookings?: Maybe<Aggregate>;
  coordinates?: Maybe<GeographyCoordinates>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isBlocked: Scalars['Boolean']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<CustomerUserDto>;
};

export type BuildingManagerRegisterInputDto = {
  buildingAddress: Scalars['String']['input'];
  buildingCoordinates: Array<Scalars['Float']['input']>;
  buildingName: Scalars['String']['input'];
  buildingType: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type CalendarListEntryDto = {
  __typename?: 'CalendarListEntryDto';
  accessRole?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type CheckoutSesssionDto = {
  __typename?: 'CheckoutSesssionDto';
  id: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type CompanyAddressDto = {
  __typename?: 'CompanyAddressDto';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type Count = {
  __typename?: 'Count';
  count: Scalars['Float']['output'];
};

export type CreateAppointmentAnonymousDtoArgs = {
  address: Scalars['String']['input'];
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  coordinates: Array<Scalars['Float']['input']>;
  createApptServiceFormAnswers?: InputMaybe<Array<CreateApptServiceFormAnswers>>;
  createApptServiceOptionAnswers: Array<CreateApptServiceOptionAnswers>;
  date: Scalars['DateTime']['input'];
  email: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
  existingPaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  paidBy?: InputMaybe<ApptPaidBy>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  serviceId: Scalars['String']['input'];
};

export type CreateAppointmentDtoArgs = {
  address: Scalars['String']['input'];
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  coordinates: Array<Scalars['Float']['input']>;
  createApptServiceFormAnswers?: InputMaybe<Array<CreateApptServiceFormAnswers>>;
  createApptServiceOptionAnswers: Array<CreateApptServiceOptionAnswers>;
  customerId: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
  employeeId: Scalars['String']['input'];
  existingPaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  paidBy?: InputMaybe<ApptPaidBy>;
  serviceId: Scalars['String']['input'];
};

export type CreateAppointmentPaymentIntentAnonymousDtoArgs = {
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  createApptServiceFormAnswers?: InputMaybe<Array<CreateApptServiceFormAnswers>>;
  createApptServiceOptionAnswers: Array<CreateApptServiceOptionAnswers>;
  email: Scalars['String']['input'];
  existingPaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  serviceId: Scalars['String']['input'];
};

export type CreateAppointmentPaymentIntentDto = {
  __typename?: 'CreateAppointmentPaymentIntentDto';
  clientSecret: Scalars['String']['output'];
  connectedAccountId: Scalars['String']['output'];
  generatedAppointmentId: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
};

export type CreateAppointmentPaymentIntentDtoArgs = {
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  createApptServiceFormAnswers?: InputMaybe<Array<CreateApptServiceFormAnswers>>;
  createApptServiceOptionAnswers: Array<CreateApptServiceOptionAnswers>;
  customerId: Scalars['String']['input'];
  existingPaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

export type CreateAppointmentPaymentIntentUserDtoArgs = {
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  createApptServiceFormAnswers?: InputMaybe<Array<CreateApptServiceFormAnswers>>;
  createApptServiceOptionAnswers: Array<CreateApptServiceOptionAnswers>;
  existingPaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

export type CreateAppointmentSpDtoArgs = {
  address: Scalars['String']['input'];
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  coordinates: Array<Scalars['Float']['input']>;
  createApptServiceFormAnswers?: InputMaybe<Array<CreateApptServiceFormAnswers>>;
  createApptServiceOptionAnswers: Array<CreateApptServiceOptionAnswers>;
  customerId: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
  employeeId: Scalars['String']['input'];
  existingPaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

export type CreateAppointmentUserDtoArgs = {
  address: Scalars['String']['input'];
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  coordinates: Array<Scalars['Float']['input']>;
  createApptServiceFormAnswers?: InputMaybe<Array<CreateApptServiceFormAnswers>>;
  createApptServiceOptionAnswers: Array<CreateApptServiceOptionAnswers>;
  date: Scalars['DateTime']['input'];
  employeeId: Scalars['String']['input'];
  existingPaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  paidBy?: InputMaybe<ApptPaidBy>;
  serviceId: Scalars['String']['input'];
};

export type CreateApptBm = {
  __typename?: 'CreateApptBM';
  id: Scalars['String']['output'];
};

export type CreateApptSp = {
  __typename?: 'CreateApptSP';
  address: Scalars['String']['output'];
  apartmentNumber?: Maybe<Scalars['String']['output']>;
  coordinates: GeographyCoordinates;
  customerId: Scalars['String']['output'];
  employeeId: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jobStatus: Scalars['String']['output'];
  service: CreateApptSpService;
  startDate: Scalars['String']['output'];
};

export type CreateApptSpService = {
  __typename?: 'CreateApptSPService';
  color: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CreateApptServiceFormAnswers = {
  answer?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['String']['input'];
  formQuestionId: Scalars['String']['input'];
  optionId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApptServiceOptionAnswers = {
  quantity: Scalars['Float']['input'];
  serviceOptionSectionOptionsId: Scalars['String']['input'];
};

export type CreateApptUser = {
  __typename?: 'CreateApptUser';
  id: Scalars['String']['output'];
};

export type CreateBookedAppointmentPaymentIntentDto = {
  __typename?: 'CreateBookedAppointmentPaymentIntentDto';
  clientSecret: Scalars['String']['output'];
  connectedAccountId: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
};

export type CreateEmployeeDto = {
  __typename?: 'CreateEmployeeDto';
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  profilePicture?: Maybe<ProfilePicture>;
  profilePictureFileId?: Maybe<Scalars['String']['output']>;
};

export type CreateEmployeeInputDto = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  profilePictureFileId?: InputMaybe<Scalars['String']['input']>;
};

export type Customer = {
  __typename?: 'Customer';
  address?: Maybe<Scalars['String']['output']>;
  apartmentNumber?: Maybe<Scalars['String']['output']>;
  bmStripeCustomerId?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<GeographyCoordinates>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isBlocked: Scalars['Boolean']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CustomerAppointmentData = {
  __typename?: 'CustomerAppointmentData';
  createdAt: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jobStatus: Scalars['String']['output'];
  location: AppointmentLocationDto;
  paymentStatus: Scalars['String']['output'];
  payments_aggregate?: Maybe<AggregateSum>;
  service: AppointmentServiceDto;
  startDate: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type CustomerCardDto = {
  __typename?: 'CustomerCardDto';
  brand: Scalars['String']['output'];
  expMonth: Scalars['Float']['output'];
  expYear: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  last4: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CustomerDataInputDto = {
  address?: InputMaybe<Scalars['String']['input']>;
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<GeographyCoordinatesInput>;
  email: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerEntryDto = {
  __typename?: 'CustomerEntryDto';
  address?: Maybe<Scalars['String']['output']>;
  amountSpent?: Maybe<Amount>;
  apartmentNumber?: Maybe<Scalars['String']['output']>;
  bmStripeCustomerId?: Maybe<Scalars['String']['output']>;
  bmStripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  bookings?: Maybe<Aggregate>;
  coordinates?: Maybe<GeographyCoordinates>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isBlocked: Scalars['Boolean']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<CustomerUserDto>;
};

export type CustomerServices = {
  __typename?: 'CustomerServices';
  category: Scalars['String']['output'];
  providers: Array<CustomerServicesProvider>;
};

export type CustomerServicesProvider = {
  __typename?: 'CustomerServicesProvider';
  address: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  services: Array<CustomerServicesService>;
};

export type CustomerServicesService = {
  __typename?: 'CustomerServicesService';
  color: Scalars['String']['output'];
  description: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nextAvailableDate?: Maybe<Scalars['String']['output']>;
};

export type CustomerUserDto = {
  __typename?: 'CustomerUserDto';
  address?: Maybe<Scalars['String']['output']>;
  apartmentNumber?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<GeographyCoordinates>;
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<ProfilePictureDto>;
};

export type DeleteCustomerPaymentMethodDto = {
  __typename?: 'DeleteCustomerPaymentMethodDto';
  id: Scalars['String']['output'];
};

export type DeleteFileDto = {
  __typename?: 'DeleteFileDto';
  deletedFile: Scalars['String']['output'];
};

export type DeletePaymentMethodDto = {
  __typename?: 'DeletePaymentMethodDto';
  id: Scalars['String']['output'];
};

export type Employee = {
  __typename?: 'Employee';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profilePicture?: Maybe<ProfilePicture>;
};

export type ExportAppointmentBase64 = {
  __typename?: 'ExportAppointmentBase64';
  base64?: Maybe<Scalars['String']['output']>;
};

export type GeographyCoordinates = {
  __typename?: 'GeographyCoordinates';
  coordinates: Array<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type GeographyCoordinatesInput = {
  coordinates: Array<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
};

export type GetAppointmentPaymentDetails = {
  __typename?: 'GetAppointmentPaymentDetails';
  options: Scalars['Float']['output'];
  serviceFee: Scalars['Float']['output'];
  taxes: Scalars['Float']['output'];
  travelFees: Scalars['Float']['output'];
};

export type GetUpfrontAppointmentDetails = {
  __typename?: 'GetUpfrontAppointmentDetails';
  data: GetUpfrontAppointmentDetailsData;
  errors: GetUpfrontAppointmentDetailsErrors;
};

export type GetUpfrontAppointmentDetailsData = {
  __typename?: 'GetUpfrontAppointmentDetailsData';
  details: GetUpfrontAppointmentDetailsDataDetails;
  formsNames: Array<Scalars['String']['output']>;
  payPrice?: Maybe<GetUpfrontAppointmentDetailsDataPayPrice>;
  price: GetUpfrontAppointmentDetailsDataPrice;
};

export type GetUpfrontAppointmentDetailsDataDetails = {
  __typename?: 'GetUpfrontAppointmentDetailsDataDetails';
  date: Scalars['DateTime']['output'];
  employeeName: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
};

export type GetUpfrontAppointmentDetailsDataPayPrice = {
  __typename?: 'GetUpfrontAppointmentDetailsDataPayPrice';
  deposit?: Maybe<Scalars['Float']['output']>;
  fees?: Maybe<Scalars['Float']['output']>;
  options?: Maybe<Scalars['Float']['output']>;
  serviceFee?: Maybe<Scalars['Float']['output']>;
  taxes?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type GetUpfrontAppointmentDetailsDataPrice = {
  __typename?: 'GetUpfrontAppointmentDetailsDataPrice';
  deposit?: Maybe<Scalars['Float']['output']>;
  fees?: Maybe<Scalars['Float']['output']>;
  options: Array<GetUpfrontAppointmentDetailsDataPriceOptions>;
  service: GetUpfrontAppointmentDetailsDataPriceService;
  subtotal: Scalars['Float']['output'];
  taxes?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type GetUpfrontAppointmentDetailsDataPriceOptions = {
  __typename?: 'GetUpfrontAppointmentDetailsDataPriceOptions';
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
};

export type GetUpfrontAppointmentDetailsDataPriceService = {
  __typename?: 'GetUpfrontAppointmentDetailsDataPriceService';
  duration: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type GetUpfrontAppointmentDetailsDtoArgs = {
  address: Scalars['String']['input'];
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  coordinates: Array<Scalars['Float']['input']>;
  createApptServiceFormAnswers?: InputMaybe<Array<CreateApptServiceFormAnswers>>;
  createApptServiceOptionAnswers: Array<CreateApptServiceOptionAnswers>;
  date: Scalars['DateTime']['input'];
  employeeId: Scalars['String']['input'];
  existingPaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

export type GetUpfrontAppointmentDetailsErrors = {
  __typename?: 'GetUpfrontAppointmentDetailsErrors';
  details?: Maybe<Scalars['Boolean']['output']>;
  forms?: Maybe<Scalars['Boolean']['output']>;
  payPrice?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Boolean']['output']>;
};

export type HaversineDto = {
  __typename?: 'HaversineDto';
  distance: Scalars['Float']['output'];
  inside?: Maybe<Scalars['Boolean']['output']>;
};

export type HaversineInputDto = {
  point1: GeographyCoordinatesInput;
  point2: GeographyCoordinatesInput;
  threshold?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<HaversineUnit_Enum>;
};

export enum HaversineUnit_Enum {
  Km = 'KM',
  Meter = 'METER',
  Mile = 'MILE',
  Nmi = 'NMI'
}

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Location = {
  __typename?: 'Location';
  address: Scalars['String']['output'];
  buildingManager?: Maybe<LocationBuildingManager>;
  buildingManagerId?: Maybe<Scalars['String']['output']>;
  buildingProviders?: Maybe<Array<LocationBuildingProvider>>;
  coordinates?: Maybe<GeographyCoordinates>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partnershipDefaultStatus?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  transitionStatus?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type LocationBuildingManager = {
  __typename?: 'LocationBuildingManager';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isEmailVerified: Scalars['Boolean']['output'];
  isPhoneNumberVerified: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePictureFileId?: Maybe<Scalars['String']['output']>;
};

export type LocationBuildingProvider = {
  __typename?: 'LocationBuildingProvider';
  id: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  partnershipSchedulingType: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type LocationDto = {
  __typename?: 'LocationDto';
  location?: Maybe<Location>;
};

export type LocationHaversineInputDto = {
  locationId: Scalars['String']['input'];
  point: GeographyCoordinatesInput;
};

export type LocationWithDistance = {
  __typename?: 'LocationWithDistance';
  address: Scalars['String']['output'];
  coordinates: GeographyCoordinates;
  distance?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  radius?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type LogoutDto = {
  __typename?: 'LogoutDto';
  deletedSessions: Array<SessionUserId>;
};

export type ModifyAppointmentDtoArgs = {
  address: Scalars['String']['input'];
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  coordinates: Array<Scalars['Float']['input']>;
  date: Scalars['DateTime']['input'];
  employeeId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

export type OnboardingCompletedDto = {
  __typename?: 'OnboardingCompletedDto';
  businessAcc?: Maybe<Scalars['String']['output']>;
  companyAddress?: Maybe<CompanyAddressDto>;
  onboardingCompleted: Scalars['Boolean']['output'];
  payoutsSchedule?: Maybe<PayoutsScheduleDto>;
};

export type PartnershipDto = {
  __typename?: 'PartnershipDto';
  partnership: Nest_BuildingProviders;
};

export type Payment = {
  __typename?: 'Payment';
  currency: Scalars['String']['output'];
  products: Scalars['String']['output'];
};

export type PayoutDto = {
  __typename?: 'PayoutDto';
  amountCaptured: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  fees: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type PayoutsDto = {
  __typename?: 'PayoutsDto';
  data: Array<PayoutDto>;
  totalCount: Scalars['Float']['output'];
};

export type PayoutsScheduleDto = {
  __typename?: 'PayoutsScheduleDto';
  delayDays: Scalars['Float']['output'];
  interval: Scalars['String']['output'];
};

export type ProfilePicture = {
  __typename?: 'ProfilePicture';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  uploadName: Scalars['String']['output'];
};

export type ProfilePictureDto = {
  __typename?: 'ProfilePictureDto';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Provider = {
  __typename?: 'Provider';
  address: Scalars['String']['output'];
  category: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: Scalars['String']['output'];
  stripeConnectAccId?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  visibility: Scalars['String']['output'];
};

export type ProviderPaymentDto = {
  __typename?: 'ProviderPaymentDto';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ProviderPaymentsDto = {
  __typename?: 'ProviderPaymentsDto';
  data: Array<ProviderPaymentDto>;
  totalCount: Scalars['Float']['output'];
};

export type ProviderRegisterInputDto = {
  address: Scalars['String']['input'];
  category: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type ProviderVisibilityDto = {
  __typename?: 'ProviderVisibilityDto';
  status: ProviderVisibilityStatusDto;
  visibility: Scalars['String']['output'];
};

export type ProviderVisibilityStatusDto = {
  __typename?: 'ProviderVisibilityStatusDto';
  hasActiveLocations: Scalars['Boolean']['output'];
  hasActiveServices: Scalars['Boolean']['output'];
  hasEmployeesWithSchedules: Scalars['Boolean']['output'];
  hasGeneralSettings: Scalars['Boolean']['output'];
  hasPaymentMethod: Scalars['Boolean']['output'];
  hasPublicProfileSettings: Scalars['Boolean']['output'];
  isApprovedByAdmin: Scalars['Boolean']['output'];
};

export type ServiceProviderDto = {
  __typename?: 'ServiceProviderDto';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SessionUserId = {
  __typename?: 'SessionUserId';
  id: Scalars['String']['output'];
};

export type SetupCustomerIntentDto = {
  __typename?: 'SetupCustomerIntentDto';
  clientSecret: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type SetupIntentDto = {
  __typename?: 'SetupIntentDto';
  clientSecret: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type Sum = {
  __typename?: 'Sum';
  sum: Amount;
};

export type TimeSlotDto = {
  __typename?: 'TimeSlotDto';
  date: Scalars['DateTime']['output'];
  employeeId: Scalars['String']['output'];
};

export type TimeSlotsDto = {
  appointmentId?: InputMaybe<Scalars['String']['input']>;
  employees: Array<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  locationId: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type UploadFileDto = {
  entityType: Scalars['String']['input'];
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UploadFileUrlDto = {
  __typename?: 'UploadFileUrlDto';
  entityType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
  uploadName: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Scalars['String']['output']>;
  apartmentNumber?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<GeographyCoordinates>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isEmailVerified: Scalars['Boolean']['output'];
  isPhoneNumberVerified: Scalars['Boolean']['output'];
  location?: Maybe<Location>;
  name: Scalars['String']['output'];
  password: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<ProfilePicture>;
  profilePictureFileId?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  userRole?: Maybe<UserRolesEntity>;
};

export type UserLoginInputDto = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type UserRegisterInputDto = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UserRolesEntity = {
  __typename?: 'UserRolesEntity';
  role: Scalars['String']['output'];
};

export type UserSessionDto = {
  __typename?: 'UserSessionDto';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type UserWithoutPassword = {
  __typename?: 'UserWithoutPassword';
  address?: Maybe<Scalars['String']['output']>;
  apartmentNumber?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<GeographyCoordinates>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isEmailVerified: Scalars['Boolean']['output'];
  isPhoneNumberVerified: Scalars['Boolean']['output'];
  location?: Maybe<Location>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<ProfilePicture>;
  profilePictureFileId?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  userRole?: Maybe<UserRolesEntity>;
};

export type ValidateService = {
  __typename?: 'ValidateService';
  canSubmit: Scalars['Boolean']['output'];
  hasEmployees: Scalars['Boolean']['output'];
  hasPrice: Scalars['Boolean']['output'];
  isOverviewValid: Scalars['Boolean']['output'];
  paymentCheckoutValid: Scalars['Boolean']['output'];
};

/** columns and relationships of "appointmentPricing" */
export type AppointmentPricing = {
  __typename?: 'appointmentPricing';
  /** An object relationship */
  appointment: Appointments;
  appointmentId: Scalars['uuid']['output'];
  basePrice: Scalars['float8']['output'];
  checkoutPayment: Scalars['jsonb']['output'];
  currency: Currencies_Enum;
  fees: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  minimumDeposit?: Maybe<Scalars['float8']['output']>;
  paymentFormat: Scalars['String']['output'];
  taxRate?: Maybe<Scalars['float8']['output']>;
  taxes: Scalars['Boolean']['output'];
};


/** columns and relationships of "appointmentPricing" */
export type AppointmentPricingCheckoutPaymentArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "appointmentPricing" */
export type AppointmentPricingFeesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "appointmentPricing" */
export type AppointmentPricing_Aggregate = {
  __typename?: 'appointmentPricing_aggregate';
  aggregate?: Maybe<AppointmentPricing_Aggregate_Fields>;
  nodes: Array<AppointmentPricing>;
};

/** aggregate fields of "appointmentPricing" */
export type AppointmentPricing_Aggregate_Fields = {
  __typename?: 'appointmentPricing_aggregate_fields';
  avg?: Maybe<AppointmentPricing_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AppointmentPricing_Max_Fields>;
  min?: Maybe<AppointmentPricing_Min_Fields>;
  stddev?: Maybe<AppointmentPricing_Stddev_Fields>;
  stddev_pop?: Maybe<AppointmentPricing_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AppointmentPricing_Stddev_Samp_Fields>;
  sum?: Maybe<AppointmentPricing_Sum_Fields>;
  var_pop?: Maybe<AppointmentPricing_Var_Pop_Fields>;
  var_samp?: Maybe<AppointmentPricing_Var_Samp_Fields>;
  variance?: Maybe<AppointmentPricing_Variance_Fields>;
};


/** aggregate fields of "appointmentPricing" */
export type AppointmentPricing_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AppointmentPricing_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AppointmentPricing_Append_Input = {
  checkoutPayment?: InputMaybe<Scalars['jsonb']['input']>;
  fees?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type AppointmentPricing_Avg_Fields = {
  __typename?: 'appointmentPricing_avg_fields';
  basePrice?: Maybe<Scalars['Float']['output']>;
  minimumDeposit?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "appointmentPricing". All fields are combined with a logical 'AND'. */
export type AppointmentPricing_Bool_Exp = {
  _and?: InputMaybe<Array<AppointmentPricing_Bool_Exp>>;
  _not?: InputMaybe<AppointmentPricing_Bool_Exp>;
  _or?: InputMaybe<Array<AppointmentPricing_Bool_Exp>>;
  appointment?: InputMaybe<Appointments_Bool_Exp>;
  appointmentId?: InputMaybe<Uuid_Comparison_Exp>;
  basePrice?: InputMaybe<Float8_Comparison_Exp>;
  checkoutPayment?: InputMaybe<Jsonb_Comparison_Exp>;
  currency?: InputMaybe<Currencies_Enum_Comparison_Exp>;
  fees?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  minimumDeposit?: InputMaybe<Float8_Comparison_Exp>;
  paymentFormat?: InputMaybe<String_Comparison_Exp>;
  taxRate?: InputMaybe<Float8_Comparison_Exp>;
  taxes?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "appointmentPricing" */
export enum AppointmentPricing_Constraint {
  /** unique or primary key constraint on columns "appointmentId" */
  AppointmentPricingAppointmentIdKey = 'appointmentPricing_appointmentId_key',
  /** unique or primary key constraint on columns "id" */
  AppointmentPricingPkey = 'appointmentPricing_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AppointmentPricing_Delete_At_Path_Input = {
  checkoutPayment?: InputMaybe<Array<Scalars['String']['input']>>;
  fees?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AppointmentPricing_Delete_Elem_Input = {
  checkoutPayment?: InputMaybe<Scalars['Int']['input']>;
  fees?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AppointmentPricing_Delete_Key_Input = {
  checkoutPayment?: InputMaybe<Scalars['String']['input']>;
  fees?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "appointmentPricing" */
export type AppointmentPricing_Inc_Input = {
  basePrice?: InputMaybe<Scalars['float8']['input']>;
  minimumDeposit?: InputMaybe<Scalars['float8']['input']>;
  taxRate?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "appointmentPricing" */
export type AppointmentPricing_Insert_Input = {
  appointment?: InputMaybe<Appointments_Obj_Rel_Insert_Input>;
  appointmentId?: InputMaybe<Scalars['uuid']['input']>;
  basePrice?: InputMaybe<Scalars['float8']['input']>;
  checkoutPayment?: InputMaybe<Scalars['jsonb']['input']>;
  currency?: InputMaybe<Currencies_Enum>;
  fees?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  minimumDeposit?: InputMaybe<Scalars['float8']['input']>;
  paymentFormat?: InputMaybe<Scalars['String']['input']>;
  taxRate?: InputMaybe<Scalars['float8']['input']>;
  taxes?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type AppointmentPricing_Max_Fields = {
  __typename?: 'appointmentPricing_max_fields';
  appointmentId?: Maybe<Scalars['uuid']['output']>;
  basePrice?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  minimumDeposit?: Maybe<Scalars['float8']['output']>;
  paymentFormat?: Maybe<Scalars['String']['output']>;
  taxRate?: Maybe<Scalars['float8']['output']>;
};

/** aggregate min on columns */
export type AppointmentPricing_Min_Fields = {
  __typename?: 'appointmentPricing_min_fields';
  appointmentId?: Maybe<Scalars['uuid']['output']>;
  basePrice?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  minimumDeposit?: Maybe<Scalars['float8']['output']>;
  paymentFormat?: Maybe<Scalars['String']['output']>;
  taxRate?: Maybe<Scalars['float8']['output']>;
};

/** response of any mutation on the table "appointmentPricing" */
export type AppointmentPricing_Mutation_Response = {
  __typename?: 'appointmentPricing_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AppointmentPricing>;
};

/** input type for inserting object relation for remote table "appointmentPricing" */
export type AppointmentPricing_Obj_Rel_Insert_Input = {
  data: AppointmentPricing_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AppointmentPricing_On_Conflict>;
};

/** on_conflict condition type for table "appointmentPricing" */
export type AppointmentPricing_On_Conflict = {
  constraint: AppointmentPricing_Constraint;
  update_columns?: Array<AppointmentPricing_Update_Column>;
  where?: InputMaybe<AppointmentPricing_Bool_Exp>;
};

/** Ordering options when selecting data from "appointmentPricing". */
export type AppointmentPricing_Order_By = {
  appointment?: InputMaybe<Appointments_Order_By>;
  appointmentId?: InputMaybe<Order_By>;
  basePrice?: InputMaybe<Order_By>;
  checkoutPayment?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  fees?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  minimumDeposit?: InputMaybe<Order_By>;
  paymentFormat?: InputMaybe<Order_By>;
  taxRate?: InputMaybe<Order_By>;
  taxes?: InputMaybe<Order_By>;
};

/** primary key columns input for table: appointmentPricing */
export type AppointmentPricing_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AppointmentPricing_Prepend_Input = {
  checkoutPayment?: InputMaybe<Scalars['jsonb']['input']>;
  fees?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "appointmentPricing" */
export enum AppointmentPricing_Select_Column {
  /** column name */
  AppointmentId = 'appointmentId',
  /** column name */
  BasePrice = 'basePrice',
  /** column name */
  CheckoutPayment = 'checkoutPayment',
  /** column name */
  Currency = 'currency',
  /** column name */
  Fees = 'fees',
  /** column name */
  Id = 'id',
  /** column name */
  MinimumDeposit = 'minimumDeposit',
  /** column name */
  PaymentFormat = 'paymentFormat',
  /** column name */
  TaxRate = 'taxRate',
  /** column name */
  Taxes = 'taxes'
}

/** input type for updating data in table "appointmentPricing" */
export type AppointmentPricing_Set_Input = {
  appointmentId?: InputMaybe<Scalars['uuid']['input']>;
  basePrice?: InputMaybe<Scalars['float8']['input']>;
  checkoutPayment?: InputMaybe<Scalars['jsonb']['input']>;
  currency?: InputMaybe<Currencies_Enum>;
  fees?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  minimumDeposit?: InputMaybe<Scalars['float8']['input']>;
  paymentFormat?: InputMaybe<Scalars['String']['input']>;
  taxRate?: InputMaybe<Scalars['float8']['input']>;
  taxes?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type AppointmentPricing_Stddev_Fields = {
  __typename?: 'appointmentPricing_stddev_fields';
  basePrice?: Maybe<Scalars['Float']['output']>;
  minimumDeposit?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type AppointmentPricing_Stddev_Pop_Fields = {
  __typename?: 'appointmentPricing_stddev_pop_fields';
  basePrice?: Maybe<Scalars['Float']['output']>;
  minimumDeposit?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type AppointmentPricing_Stddev_Samp_Fields = {
  __typename?: 'appointmentPricing_stddev_samp_fields';
  basePrice?: Maybe<Scalars['Float']['output']>;
  minimumDeposit?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "appointmentPricing" */
export type AppointmentPricing_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AppointmentPricing_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AppointmentPricing_Stream_Cursor_Value_Input = {
  appointmentId?: InputMaybe<Scalars['uuid']['input']>;
  basePrice?: InputMaybe<Scalars['float8']['input']>;
  checkoutPayment?: InputMaybe<Scalars['jsonb']['input']>;
  currency?: InputMaybe<Currencies_Enum>;
  fees?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  minimumDeposit?: InputMaybe<Scalars['float8']['input']>;
  paymentFormat?: InputMaybe<Scalars['String']['input']>;
  taxRate?: InputMaybe<Scalars['float8']['input']>;
  taxes?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type AppointmentPricing_Sum_Fields = {
  __typename?: 'appointmentPricing_sum_fields';
  basePrice?: Maybe<Scalars['float8']['output']>;
  minimumDeposit?: Maybe<Scalars['float8']['output']>;
  taxRate?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "appointmentPricing" */
export enum AppointmentPricing_Update_Column {
  /** column name */
  AppointmentId = 'appointmentId',
  /** column name */
  BasePrice = 'basePrice',
  /** column name */
  CheckoutPayment = 'checkoutPayment',
  /** column name */
  Currency = 'currency',
  /** column name */
  Fees = 'fees',
  /** column name */
  Id = 'id',
  /** column name */
  MinimumDeposit = 'minimumDeposit',
  /** column name */
  PaymentFormat = 'paymentFormat',
  /** column name */
  TaxRate = 'taxRate',
  /** column name */
  Taxes = 'taxes'
}

export type AppointmentPricing_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AppointmentPricing_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AppointmentPricing_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AppointmentPricing_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AppointmentPricing_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AppointmentPricing_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AppointmentPricing_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AppointmentPricing_Set_Input>;
  /** filter the rows which have to be updated */
  where: AppointmentPricing_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AppointmentPricing_Var_Pop_Fields = {
  __typename?: 'appointmentPricing_var_pop_fields';
  basePrice?: Maybe<Scalars['Float']['output']>;
  minimumDeposit?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type AppointmentPricing_Var_Samp_Fields = {
  __typename?: 'appointmentPricing_var_samp_fields';
  basePrice?: Maybe<Scalars['Float']['output']>;
  minimumDeposit?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type AppointmentPricing_Variance_Fields = {
  __typename?: 'appointmentPricing_variance_fields';
  basePrice?: Maybe<Scalars['Float']['output']>;
  minimumDeposit?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "appointments" */
export type Appointments = {
  __typename?: 'appointments';
  abortedByUserId?: Maybe<Scalars['uuid']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  apartmentNumber?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  appointmentPricing?: Maybe<AppointmentPricing>;
  coordinates?: Maybe<Scalars['geography']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customer: Customers;
  customerId: Scalars['uuid']['output'];
  employeeId: Scalars['uuid']['output'];
  endDate: Scalars['timestamptz']['output'];
  eventId?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  formAnswers: Array<FormAnswers>;
  /** An aggregate relationship */
  formAnswers_aggregate: FormAnswers_Aggregate;
  id: Scalars['uuid']['output'];
  jobStatus: JobStatus_Enum;
  /** An object relationship */
  jobStatusByJobstatus: JobStatus;
  /** An object relationship */
  location: Locations;
  locationId: Scalars['uuid']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  paymentStatus: PaymentStatus_Enum;
  /** An object relationship */
  paymentStatusByPaymentstatus: PaymentStatus;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  providerMonthlyPaymentId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  refunds: Array<Refunds>;
  /** An aggregate relationship */
  refunds_aggregate: Refunds_Aggregate;
  /** An object relationship */
  service: Services;
  serviceId: Scalars['uuid']['output'];
  /** An array relationship */
  serviceOptionAnswers: Array<ServiceOptionAnswers>;
  /** An aggregate relationship */
  serviceOptionAnswers_aggregate: ServiceOptionAnswers_Aggregate;
  startDate: Scalars['timestamptz']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  updatedByUserId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  userByAbortedId?: Maybe<Users>;
  /** An object relationship */
  userByEmployeeid: Users;
};


/** columns and relationships of "appointments" */
export type AppointmentsFormAnswersArgs = {
  distinct_on?: InputMaybe<Array<FormAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormAnswers_Order_By>>;
  where?: InputMaybe<FormAnswers_Bool_Exp>;
};


/** columns and relationships of "appointments" */
export type AppointmentsFormAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FormAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormAnswers_Order_By>>;
  where?: InputMaybe<FormAnswers_Bool_Exp>;
};


/** columns and relationships of "appointments" */
export type AppointmentsPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "appointments" */
export type AppointmentsPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "appointments" */
export type AppointmentsRefundsArgs = {
  distinct_on?: InputMaybe<Array<Refunds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refunds_Order_By>>;
  where?: InputMaybe<Refunds_Bool_Exp>;
};


/** columns and relationships of "appointments" */
export type AppointmentsRefunds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refunds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refunds_Order_By>>;
  where?: InputMaybe<Refunds_Bool_Exp>;
};


/** columns and relationships of "appointments" */
export type AppointmentsServiceOptionAnswersArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionAnswers_Order_By>>;
  where?: InputMaybe<ServiceOptionAnswers_Bool_Exp>;
};


/** columns and relationships of "appointments" */
export type AppointmentsServiceOptionAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionAnswers_Order_By>>;
  where?: InputMaybe<ServiceOptionAnswers_Bool_Exp>;
};

/** aggregated selection of "appointments" */
export type Appointments_Aggregate = {
  __typename?: 'appointments_aggregate';
  aggregate?: Maybe<Appointments_Aggregate_Fields>;
  nodes: Array<Appointments>;
};

export type Appointments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Appointments_Aggregate_Bool_Exp_Count>;
};

export type Appointments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Appointments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Appointments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "appointments" */
export type Appointments_Aggregate_Fields = {
  __typename?: 'appointments_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Appointments_Max_Fields>;
  min?: Maybe<Appointments_Min_Fields>;
};


/** aggregate fields of "appointments" */
export type Appointments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Appointments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "appointments" */
export type Appointments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Appointments_Max_Order_By>;
  min?: InputMaybe<Appointments_Min_Order_By>;
};

/** input type for inserting array relation for remote table "appointments" */
export type Appointments_Arr_Rel_Insert_Input = {
  data: Array<Appointments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Appointments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "appointments". All fields are combined with a logical 'AND'. */
export type Appointments_Bool_Exp = {
  _and?: InputMaybe<Array<Appointments_Bool_Exp>>;
  _not?: InputMaybe<Appointments_Bool_Exp>;
  _or?: InputMaybe<Array<Appointments_Bool_Exp>>;
  abortedByUserId?: InputMaybe<Uuid_Comparison_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  apartmentNumber?: InputMaybe<String_Comparison_Exp>;
  appointmentPricing?: InputMaybe<AppointmentPricing_Bool_Exp>;
  coordinates?: InputMaybe<Geography_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdByUserId?: InputMaybe<Uuid_Comparison_Exp>;
  customer?: InputMaybe<Customers_Bool_Exp>;
  customerId?: InputMaybe<Uuid_Comparison_Exp>;
  employeeId?: InputMaybe<Uuid_Comparison_Exp>;
  endDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  eventId?: InputMaybe<String_Comparison_Exp>;
  formAnswers?: InputMaybe<FormAnswers_Bool_Exp>;
  formAnswers_aggregate?: InputMaybe<FormAnswers_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jobStatus?: InputMaybe<JobStatus_Enum_Comparison_Exp>;
  jobStatusByJobstatus?: InputMaybe<JobStatus_Bool_Exp>;
  location?: InputMaybe<Locations_Bool_Exp>;
  locationId?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  paymentStatus?: InputMaybe<PaymentStatus_Enum_Comparison_Exp>;
  paymentStatusByPaymentstatus?: InputMaybe<PaymentStatus_Bool_Exp>;
  payments?: InputMaybe<Payments_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Bool_Exp>;
  providerMonthlyPaymentId?: InputMaybe<Uuid_Comparison_Exp>;
  refunds?: InputMaybe<Refunds_Bool_Exp>;
  refunds_aggregate?: InputMaybe<Refunds_Aggregate_Bool_Exp>;
  service?: InputMaybe<Services_Bool_Exp>;
  serviceId?: InputMaybe<Uuid_Comparison_Exp>;
  serviceOptionAnswers?: InputMaybe<ServiceOptionAnswers_Bool_Exp>;
  serviceOptionAnswers_aggregate?: InputMaybe<ServiceOptionAnswers_Aggregate_Bool_Exp>;
  startDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedByUserId?: InputMaybe<Uuid_Comparison_Exp>;
  userByAbortedId?: InputMaybe<Users_Bool_Exp>;
  userByEmployeeid?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "appointments" */
export enum Appointments_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServicesAppointmentsPkey = 'servicesAppointments_pkey'
}

/** input type for inserting data into table "appointments" */
export type Appointments_Insert_Input = {
  abortedByUserId?: InputMaybe<Scalars['uuid']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  appointmentPricing?: InputMaybe<AppointmentPricing_Obj_Rel_Insert_Input>;
  coordinates?: InputMaybe<Scalars['geography']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  customer?: InputMaybe<Customers_Obj_Rel_Insert_Input>;
  customerId?: InputMaybe<Scalars['uuid']['input']>;
  employeeId?: InputMaybe<Scalars['uuid']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  formAnswers?: InputMaybe<FormAnswers_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobStatus?: InputMaybe<JobStatus_Enum>;
  jobStatusByJobstatus?: InputMaybe<JobStatus_Obj_Rel_Insert_Input>;
  location?: InputMaybe<Locations_Obj_Rel_Insert_Input>;
  locationId?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus_Enum>;
  paymentStatusByPaymentstatus?: InputMaybe<PaymentStatus_Obj_Rel_Insert_Input>;
  payments?: InputMaybe<Payments_Arr_Rel_Insert_Input>;
  providerMonthlyPaymentId?: InputMaybe<Scalars['uuid']['input']>;
  refunds?: InputMaybe<Refunds_Arr_Rel_Insert_Input>;
  service?: InputMaybe<Services_Obj_Rel_Insert_Input>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  serviceOptionAnswers?: InputMaybe<ServiceOptionAnswers_Arr_Rel_Insert_Input>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedByUserId?: InputMaybe<Scalars['uuid']['input']>;
  userByAbortedId?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userByEmployeeid?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Appointments_Max_Fields = {
  __typename?: 'appointments_max_fields';
  abortedByUserId?: Maybe<Scalars['uuid']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  apartmentNumber?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  customerId?: Maybe<Scalars['uuid']['output']>;
  employeeId?: Maybe<Scalars['uuid']['output']>;
  endDate?: Maybe<Scalars['timestamptz']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  locationId?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  providerMonthlyPaymentId?: Maybe<Scalars['uuid']['output']>;
  serviceId?: Maybe<Scalars['uuid']['output']>;
  startDate?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "appointments" */
export type Appointments_Max_Order_By = {
  abortedByUserId?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  apartmentNumber?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdByUserId?: InputMaybe<Order_By>;
  customerId?: InputMaybe<Order_By>;
  employeeId?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locationId?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  providerMonthlyPaymentId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedByUserId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Appointments_Min_Fields = {
  __typename?: 'appointments_min_fields';
  abortedByUserId?: Maybe<Scalars['uuid']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  apartmentNumber?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  customerId?: Maybe<Scalars['uuid']['output']>;
  employeeId?: Maybe<Scalars['uuid']['output']>;
  endDate?: Maybe<Scalars['timestamptz']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  locationId?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  providerMonthlyPaymentId?: Maybe<Scalars['uuid']['output']>;
  serviceId?: Maybe<Scalars['uuid']['output']>;
  startDate?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "appointments" */
export type Appointments_Min_Order_By = {
  abortedByUserId?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  apartmentNumber?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdByUserId?: InputMaybe<Order_By>;
  customerId?: InputMaybe<Order_By>;
  employeeId?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locationId?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  providerMonthlyPaymentId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedByUserId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "appointments" */
export type Appointments_Mutation_Response = {
  __typename?: 'appointments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Appointments>;
};

/** input type for inserting object relation for remote table "appointments" */
export type Appointments_Obj_Rel_Insert_Input = {
  data: Appointments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Appointments_On_Conflict>;
};

/** on_conflict condition type for table "appointments" */
export type Appointments_On_Conflict = {
  constraint: Appointments_Constraint;
  update_columns?: Array<Appointments_Update_Column>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};

/** Ordering options when selecting data from "appointments". */
export type Appointments_Order_By = {
  abortedByUserId?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  apartmentNumber?: InputMaybe<Order_By>;
  appointmentPricing?: InputMaybe<AppointmentPricing_Order_By>;
  coordinates?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdByUserId?: InputMaybe<Order_By>;
  customer?: InputMaybe<Customers_Order_By>;
  customerId?: InputMaybe<Order_By>;
  employeeId?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  formAnswers_aggregate?: InputMaybe<FormAnswers_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  jobStatus?: InputMaybe<Order_By>;
  jobStatusByJobstatus?: InputMaybe<JobStatus_Order_By>;
  location?: InputMaybe<Locations_Order_By>;
  locationId?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  paymentStatus?: InputMaybe<Order_By>;
  paymentStatusByPaymentstatus?: InputMaybe<PaymentStatus_Order_By>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Order_By>;
  providerMonthlyPaymentId?: InputMaybe<Order_By>;
  refunds_aggregate?: InputMaybe<Refunds_Aggregate_Order_By>;
  service?: InputMaybe<Services_Order_By>;
  serviceId?: InputMaybe<Order_By>;
  serviceOptionAnswers_aggregate?: InputMaybe<ServiceOptionAnswers_Aggregate_Order_By>;
  startDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedByUserId?: InputMaybe<Order_By>;
  userByAbortedId?: InputMaybe<Users_Order_By>;
  userByEmployeeid?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: appointments */
export type Appointments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "appointments" */
export enum Appointments_Select_Column {
  /** column name */
  AbortedByUserId = 'abortedByUserId',
  /** column name */
  Address = 'address',
  /** column name */
  ApartmentNumber = 'apartmentNumber',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedByUserId = 'createdByUserId',
  /** column name */
  CustomerId = 'customerId',
  /** column name */
  EmployeeId = 'employeeId',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  JobStatus = 'jobStatus',
  /** column name */
  LocationId = 'locationId',
  /** column name */
  Notes = 'notes',
  /** column name */
  PaymentStatus = 'paymentStatus',
  /** column name */
  ProviderMonthlyPaymentId = 'providerMonthlyPaymentId',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedByUserId = 'updatedByUserId'
}

/** input type for updating data in table "appointments" */
export type Appointments_Set_Input = {
  abortedByUserId?: InputMaybe<Scalars['uuid']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<Scalars['geography']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  customerId?: InputMaybe<Scalars['uuid']['input']>;
  employeeId?: InputMaybe<Scalars['uuid']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobStatus?: InputMaybe<JobStatus_Enum>;
  locationId?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus_Enum>;
  providerMonthlyPaymentId?: InputMaybe<Scalars['uuid']['input']>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "appointments" */
export type Appointments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Appointments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Appointments_Stream_Cursor_Value_Input = {
  abortedByUserId?: InputMaybe<Scalars['uuid']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<Scalars['geography']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  customerId?: InputMaybe<Scalars['uuid']['input']>;
  employeeId?: InputMaybe<Scalars['uuid']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobStatus?: InputMaybe<JobStatus_Enum>;
  locationId?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus_Enum>;
  providerMonthlyPaymentId?: InputMaybe<Scalars['uuid']['input']>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "appointments" */
export enum Appointments_Update_Column {
  /** column name */
  AbortedByUserId = 'abortedByUserId',
  /** column name */
  Address = 'address',
  /** column name */
  ApartmentNumber = 'apartmentNumber',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedByUserId = 'createdByUserId',
  /** column name */
  CustomerId = 'customerId',
  /** column name */
  EmployeeId = 'employeeId',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  JobStatus = 'jobStatus',
  /** column name */
  LocationId = 'locationId',
  /** column name */
  Notes = 'notes',
  /** column name */
  PaymentStatus = 'paymentStatus',
  /** column name */
  ProviderMonthlyPaymentId = 'providerMonthlyPaymentId',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedByUserId = 'updatedByUserId'
}

export type Appointments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Appointments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Appointments_Bool_Exp;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "bookingStatus" */
export type BookingStatus = {
  __typename?: 'bookingStatus';
  value: Scalars['String']['output'];
};

/** aggregated selection of "bookingStatus" */
export type BookingStatus_Aggregate = {
  __typename?: 'bookingStatus_aggregate';
  aggregate?: Maybe<BookingStatus_Aggregate_Fields>;
  nodes: Array<BookingStatus>;
};

/** aggregate fields of "bookingStatus" */
export type BookingStatus_Aggregate_Fields = {
  __typename?: 'bookingStatus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<BookingStatus_Max_Fields>;
  min?: Maybe<BookingStatus_Min_Fields>;
};


/** aggregate fields of "bookingStatus" */
export type BookingStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<BookingStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "bookingStatus". All fields are combined with a logical 'AND'. */
export type BookingStatus_Bool_Exp = {
  _and?: InputMaybe<Array<BookingStatus_Bool_Exp>>;
  _not?: InputMaybe<BookingStatus_Bool_Exp>;
  _or?: InputMaybe<Array<BookingStatus_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "bookingStatus" */
export enum BookingStatus_Constraint {
  /** unique or primary key constraint on columns "value" */
  BookingStatusPkey = 'bookingStatus_pkey'
}

export enum BookingStatus_Enum {
  AutomaticApproval = 'automatic_approval',
  WaitForApproval = 'wait_for_approval'
}

/** Boolean expression to compare columns of type "bookingStatus_enum". All fields are combined with logical 'AND'. */
export type BookingStatus_Enum_Comparison_Exp = {
  _eq?: InputMaybe<BookingStatus_Enum>;
  _in?: InputMaybe<Array<BookingStatus_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<BookingStatus_Enum>;
  _nin?: InputMaybe<Array<BookingStatus_Enum>>;
};

/** input type for inserting data into table "bookingStatus" */
export type BookingStatus_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BookingStatus_Max_Fields = {
  __typename?: 'bookingStatus_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type BookingStatus_Min_Fields = {
  __typename?: 'bookingStatus_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "bookingStatus" */
export type BookingStatus_Mutation_Response = {
  __typename?: 'bookingStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BookingStatus>;
};

/** input type for inserting object relation for remote table "bookingStatus" */
export type BookingStatus_Obj_Rel_Insert_Input = {
  data: BookingStatus_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<BookingStatus_On_Conflict>;
};

/** on_conflict condition type for table "bookingStatus" */
export type BookingStatus_On_Conflict = {
  constraint: BookingStatus_Constraint;
  update_columns?: Array<BookingStatus_Update_Column>;
  where?: InputMaybe<BookingStatus_Bool_Exp>;
};

/** Ordering options when selecting data from "bookingStatus". */
export type BookingStatus_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: bookingStatus */
export type BookingStatus_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "bookingStatus" */
export enum BookingStatus_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "bookingStatus" */
export type BookingStatus_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "bookingStatus" */
export type BookingStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BookingStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type BookingStatus_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "bookingStatus" */
export enum BookingStatus_Update_Column {
  /** column name */
  Value = 'value'
}

export type BookingStatus_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BookingStatus_Set_Input>;
  /** filter the rows which have to be updated */
  where: BookingStatus_Bool_Exp;
};

/** columns and relationships of "buildingProviders" */
export type BuildingProviders = {
  __typename?: 'buildingProviders';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  location: Locations;
  locationId: Scalars['uuid']['output'];
  partnershipSchedulingType: PartnershipSchedulingType_Enum;
  /** An object relationship */
  provider: Providers;
  providerId: Scalars['uuid']['output'];
  /** An object relationship */
  scheduleLocation?: Maybe<Locations>;
  scheduleLocationId?: Maybe<Scalars['uuid']['output']>;
  status: RelationshipStatus_Enum;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "buildingProviders" */
export type BuildingProviders_Aggregate = {
  __typename?: 'buildingProviders_aggregate';
  aggregate?: Maybe<BuildingProviders_Aggregate_Fields>;
  nodes: Array<BuildingProviders>;
};

export type BuildingProviders_Aggregate_Bool_Exp = {
  count?: InputMaybe<BuildingProviders_Aggregate_Bool_Exp_Count>;
};

export type BuildingProviders_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<BuildingProviders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BuildingProviders_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "buildingProviders" */
export type BuildingProviders_Aggregate_Fields = {
  __typename?: 'buildingProviders_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<BuildingProviders_Max_Fields>;
  min?: Maybe<BuildingProviders_Min_Fields>;
};


/** aggregate fields of "buildingProviders" */
export type BuildingProviders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<BuildingProviders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "buildingProviders" */
export type BuildingProviders_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<BuildingProviders_Max_Order_By>;
  min?: InputMaybe<BuildingProviders_Min_Order_By>;
};

/** input type for inserting array relation for remote table "buildingProviders" */
export type BuildingProviders_Arr_Rel_Insert_Input = {
  data: Array<BuildingProviders_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<BuildingProviders_On_Conflict>;
};

/** Boolean expression to filter rows from the table "buildingProviders". All fields are combined with a logical 'AND'. */
export type BuildingProviders_Bool_Exp = {
  _and?: InputMaybe<Array<BuildingProviders_Bool_Exp>>;
  _not?: InputMaybe<BuildingProviders_Bool_Exp>;
  _or?: InputMaybe<Array<BuildingProviders_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Locations_Bool_Exp>;
  locationId?: InputMaybe<Uuid_Comparison_Exp>;
  partnershipSchedulingType?: InputMaybe<PartnershipSchedulingType_Enum_Comparison_Exp>;
  provider?: InputMaybe<Providers_Bool_Exp>;
  providerId?: InputMaybe<Uuid_Comparison_Exp>;
  scheduleLocation?: InputMaybe<Locations_Bool_Exp>;
  scheduleLocationId?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<RelationshipStatus_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "buildingProviders" */
export enum BuildingProviders_Constraint {
  /** unique or primary key constraint on columns "providerId", "locationId" */
  BuildingProvidersLocationIdProviderIdKey = 'buildingProviders_locationId_providerId_key',
  /** unique or primary key constraint on columns "id" */
  BuildingProvidersPkey = 'buildingProviders_pkey'
}

/** input type for inserting data into table "buildingProviders" */
export type BuildingProviders_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Locations_Obj_Rel_Insert_Input>;
  locationId?: InputMaybe<Scalars['uuid']['input']>;
  partnershipSchedulingType?: InputMaybe<PartnershipSchedulingType_Enum>;
  provider?: InputMaybe<Providers_Obj_Rel_Insert_Input>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  scheduleLocation?: InputMaybe<Locations_Obj_Rel_Insert_Input>;
  scheduleLocationId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<RelationshipStatus_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type BuildingProviders_Max_Fields = {
  __typename?: 'buildingProviders_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  locationId?: Maybe<Scalars['uuid']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  scheduleLocationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "buildingProviders" */
export type BuildingProviders_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locationId?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  scheduleLocationId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type BuildingProviders_Min_Fields = {
  __typename?: 'buildingProviders_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  locationId?: Maybe<Scalars['uuid']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  scheduleLocationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "buildingProviders" */
export type BuildingProviders_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locationId?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  scheduleLocationId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "buildingProviders" */
export type BuildingProviders_Mutation_Response = {
  __typename?: 'buildingProviders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BuildingProviders>;
};

/** on_conflict condition type for table "buildingProviders" */
export type BuildingProviders_On_Conflict = {
  constraint: BuildingProviders_Constraint;
  update_columns?: Array<BuildingProviders_Update_Column>;
  where?: InputMaybe<BuildingProviders_Bool_Exp>;
};

/** Ordering options when selecting data from "buildingProviders". */
export type BuildingProviders_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Locations_Order_By>;
  locationId?: InputMaybe<Order_By>;
  partnershipSchedulingType?: InputMaybe<Order_By>;
  provider?: InputMaybe<Providers_Order_By>;
  providerId?: InputMaybe<Order_By>;
  scheduleLocation?: InputMaybe<Locations_Order_By>;
  scheduleLocationId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: buildingProviders */
export type BuildingProviders_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "buildingProviders" */
export enum BuildingProviders_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'locationId',
  /** column name */
  PartnershipSchedulingType = 'partnershipSchedulingType',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ScheduleLocationId = 'scheduleLocationId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "buildingProviders" */
export type BuildingProviders_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  locationId?: InputMaybe<Scalars['uuid']['input']>;
  partnershipSchedulingType?: InputMaybe<PartnershipSchedulingType_Enum>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  scheduleLocationId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<RelationshipStatus_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "buildingProviders" */
export type BuildingProviders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BuildingProviders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type BuildingProviders_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  locationId?: InputMaybe<Scalars['uuid']['input']>;
  partnershipSchedulingType?: InputMaybe<PartnershipSchedulingType_Enum>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  scheduleLocationId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<RelationshipStatus_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "buildingProviders" */
export enum BuildingProviders_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'locationId',
  /** column name */
  PartnershipSchedulingType = 'partnershipSchedulingType',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ScheduleLocationId = 'scheduleLocationId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type BuildingProviders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BuildingProviders_Set_Input>;
  /** filter the rows which have to be updated */
  where: BuildingProviders_Bool_Exp;
};

/** columns and relationships of "buildingType" */
export type BuildingType = {
  __typename?: 'buildingType';
  value: Scalars['String']['output'];
};

/** aggregated selection of "buildingType" */
export type BuildingType_Aggregate = {
  __typename?: 'buildingType_aggregate';
  aggregate?: Maybe<BuildingType_Aggregate_Fields>;
  nodes: Array<BuildingType>;
};

/** aggregate fields of "buildingType" */
export type BuildingType_Aggregate_Fields = {
  __typename?: 'buildingType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<BuildingType_Max_Fields>;
  min?: Maybe<BuildingType_Min_Fields>;
};


/** aggregate fields of "buildingType" */
export type BuildingType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<BuildingType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "buildingType". All fields are combined with a logical 'AND'. */
export type BuildingType_Bool_Exp = {
  _and?: InputMaybe<Array<BuildingType_Bool_Exp>>;
  _not?: InputMaybe<BuildingType_Bool_Exp>;
  _or?: InputMaybe<Array<BuildingType_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "buildingType" */
export enum BuildingType_Constraint {
  /** unique or primary key constraint on columns "value" */
  BuildingTypePkey = 'buildingType_pkey'
}

export enum BuildingType_Enum {
  GroupOfIndependentWorkers = 'group_of_independent_workers',
  Hotel = 'hotel',
  Other = 'other',
  RetirementHome = 'retirement_home'
}

/** Boolean expression to compare columns of type "buildingType_enum". All fields are combined with logical 'AND'. */
export type BuildingType_Enum_Comparison_Exp = {
  _eq?: InputMaybe<BuildingType_Enum>;
  _in?: InputMaybe<Array<BuildingType_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<BuildingType_Enum>;
  _nin?: InputMaybe<Array<BuildingType_Enum>>;
};

/** input type for inserting data into table "buildingType" */
export type BuildingType_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BuildingType_Max_Fields = {
  __typename?: 'buildingType_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type BuildingType_Min_Fields = {
  __typename?: 'buildingType_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "buildingType" */
export type BuildingType_Mutation_Response = {
  __typename?: 'buildingType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BuildingType>;
};

/** input type for inserting object relation for remote table "buildingType" */
export type BuildingType_Obj_Rel_Insert_Input = {
  data: BuildingType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<BuildingType_On_Conflict>;
};

/** on_conflict condition type for table "buildingType" */
export type BuildingType_On_Conflict = {
  constraint: BuildingType_Constraint;
  update_columns?: Array<BuildingType_Update_Column>;
  where?: InputMaybe<BuildingType_Bool_Exp>;
};

/** Ordering options when selecting data from "buildingType". */
export type BuildingType_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: buildingType */
export type BuildingType_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "buildingType" */
export enum BuildingType_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "buildingType" */
export type BuildingType_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "buildingType" */
export type BuildingType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BuildingType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type BuildingType_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "buildingType" */
export enum BuildingType_Update_Column {
  /** column name */
  Value = 'value'
}

export type BuildingType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BuildingType_Set_Input>;
  /** filter the rows which have to be updated */
  where: BuildingType_Bool_Exp;
};

export type Card = {
  __typename?: 'card';
  brand: Scalars['String']['output'];
  expMonth: Scalars['Float']['output'];
  expYear: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  last4: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** used to track anonymous checkout sessions */
export type CheckoutSessions = {
  __typename?: 'checkoutSessions';
  createdAt: Scalars['time']['output'];
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  revokedAt?: Maybe<Scalars['timestamptz']['output']>;
  token: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "checkoutSessions" */
export type CheckoutSessions_Aggregate = {
  __typename?: 'checkoutSessions_aggregate';
  aggregate?: Maybe<CheckoutSessions_Aggregate_Fields>;
  nodes: Array<CheckoutSessions>;
};

/** aggregate fields of "checkoutSessions" */
export type CheckoutSessions_Aggregate_Fields = {
  __typename?: 'checkoutSessions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<CheckoutSessions_Max_Fields>;
  min?: Maybe<CheckoutSessions_Min_Fields>;
};


/** aggregate fields of "checkoutSessions" */
export type CheckoutSessions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CheckoutSessions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "checkoutSessions". All fields are combined with a logical 'AND'. */
export type CheckoutSessions_Bool_Exp = {
  _and?: InputMaybe<Array<CheckoutSessions_Bool_Exp>>;
  _not?: InputMaybe<CheckoutSessions_Bool_Exp>;
  _or?: InputMaybe<Array<CheckoutSessions_Bool_Exp>>;
  createdAt?: InputMaybe<Time_Comparison_Exp>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  revokedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "checkoutSessions" */
export enum CheckoutSessions_Constraint {
  /** unique or primary key constraint on columns "id" */
  CheckoutSessionsPkey = 'checkout_sessions_pkey'
}

/** input type for inserting data into table "checkoutSessions" */
export type CheckoutSessions_Insert_Input = {
  createdAt?: InputMaybe<Scalars['time']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  revokedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type CheckoutSessions_Max_Fields = {
  __typename?: 'checkoutSessions_max_fields';
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  revokedAt?: Maybe<Scalars['timestamptz']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type CheckoutSessions_Min_Fields = {
  __typename?: 'checkoutSessions_min_fields';
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  revokedAt?: Maybe<Scalars['timestamptz']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "checkoutSessions" */
export type CheckoutSessions_Mutation_Response = {
  __typename?: 'checkoutSessions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CheckoutSessions>;
};

/** on_conflict condition type for table "checkoutSessions" */
export type CheckoutSessions_On_Conflict = {
  constraint: CheckoutSessions_Constraint;
  update_columns?: Array<CheckoutSessions_Update_Column>;
  where?: InputMaybe<CheckoutSessions_Bool_Exp>;
};

/** Ordering options when selecting data from "checkoutSessions". */
export type CheckoutSessions_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  revokedAt?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: checkoutSessions */
export type CheckoutSessions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "checkoutSessions" */
export enum CheckoutSessions_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  RevokedAt = 'revokedAt',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "checkoutSessions" */
export type CheckoutSessions_Set_Input = {
  createdAt?: InputMaybe<Scalars['time']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  revokedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "checkoutSessions" */
export type CheckoutSessions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CheckoutSessions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CheckoutSessions_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['time']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  revokedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "checkoutSessions" */
export enum CheckoutSessions_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  RevokedAt = 'revokedAt',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CheckoutSessions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CheckoutSessions_Set_Input>;
  /** filter the rows which have to be updated */
  where: CheckoutSessions_Bool_Exp;
};

/** columns and relationships of "currencies" */
export type Currencies = {
  __typename?: 'currencies';
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  /** An array relationship */
  servicePricings: Array<ServicePricings>;
  /** An aggregate relationship */
  servicePricings_aggregate: ServicePricings_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "currencies" */
export type CurrenciesPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "currencies" */
export type CurrenciesPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "currencies" */
export type CurrenciesServicePricingsArgs = {
  distinct_on?: InputMaybe<Array<ServicePricings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicePricings_Order_By>>;
  where?: InputMaybe<ServicePricings_Bool_Exp>;
};


/** columns and relationships of "currencies" */
export type CurrenciesServicePricings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServicePricings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicePricings_Order_By>>;
  where?: InputMaybe<ServicePricings_Bool_Exp>;
};

/** aggregated selection of "currencies" */
export type Currencies_Aggregate = {
  __typename?: 'currencies_aggregate';
  aggregate?: Maybe<Currencies_Aggregate_Fields>;
  nodes: Array<Currencies>;
};

/** aggregate fields of "currencies" */
export type Currencies_Aggregate_Fields = {
  __typename?: 'currencies_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Currencies_Max_Fields>;
  min?: Maybe<Currencies_Min_Fields>;
};


/** aggregate fields of "currencies" */
export type Currencies_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Currencies_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "currencies". All fields are combined with a logical 'AND'. */
export type Currencies_Bool_Exp = {
  _and?: InputMaybe<Array<Currencies_Bool_Exp>>;
  _not?: InputMaybe<Currencies_Bool_Exp>;
  _or?: InputMaybe<Array<Currencies_Bool_Exp>>;
  payments?: InputMaybe<Payments_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Bool_Exp>;
  servicePricings?: InputMaybe<ServicePricings_Bool_Exp>;
  servicePricings_aggregate?: InputMaybe<ServicePricings_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "currencies" */
export enum Currencies_Constraint {
  /** unique or primary key constraint on columns "value" */
  CurrenciesPkey = 'currencies_pkey'
}

export enum Currencies_Enum {
  Cad = 'CAD',
  Eur = 'EUR',
  Usd = 'USD'
}

/** Boolean expression to compare columns of type "currencies_enum". All fields are combined with logical 'AND'. */
export type Currencies_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Currencies_Enum>;
  _in?: InputMaybe<Array<Currencies_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Currencies_Enum>;
  _nin?: InputMaybe<Array<Currencies_Enum>>;
};

/** input type for inserting data into table "currencies" */
export type Currencies_Insert_Input = {
  payments?: InputMaybe<Payments_Arr_Rel_Insert_Input>;
  servicePricings?: InputMaybe<ServicePricings_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Currencies_Max_Fields = {
  __typename?: 'currencies_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Currencies_Min_Fields = {
  __typename?: 'currencies_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "currencies" */
export type Currencies_Mutation_Response = {
  __typename?: 'currencies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Currencies>;
};

/** input type for inserting object relation for remote table "currencies" */
export type Currencies_Obj_Rel_Insert_Input = {
  data: Currencies_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Currencies_On_Conflict>;
};

/** on_conflict condition type for table "currencies" */
export type Currencies_On_Conflict = {
  constraint: Currencies_Constraint;
  update_columns?: Array<Currencies_Update_Column>;
  where?: InputMaybe<Currencies_Bool_Exp>;
};

/** Ordering options when selecting data from "currencies". */
export type Currencies_Order_By = {
  payments_aggregate?: InputMaybe<Payments_Aggregate_Order_By>;
  servicePricings_aggregate?: InputMaybe<ServicePricings_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: currencies */
export type Currencies_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "currencies" */
export enum Currencies_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "currencies" */
export type Currencies_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "currencies" */
export type Currencies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Currencies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Currencies_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "currencies" */
export enum Currencies_Update_Column {
  /** column name */
  Value = 'value'
}

export type Currencies_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Currencies_Set_Input>;
  /** filter the rows which have to be updated */
  where: Currencies_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "customerAmountSpent" */
export type CustomerAmountSpent = {
  __typename?: 'customerAmountSpent';
  amount?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  customer?: Maybe<Customers>;
  customerId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "customerAmountSpent" */
export type CustomerAmountSpent_Aggregate = {
  __typename?: 'customerAmountSpent_aggregate';
  aggregate?: Maybe<CustomerAmountSpent_Aggregate_Fields>;
  nodes: Array<CustomerAmountSpent>;
};

/** aggregate fields of "customerAmountSpent" */
export type CustomerAmountSpent_Aggregate_Fields = {
  __typename?: 'customerAmountSpent_aggregate_fields';
  avg?: Maybe<CustomerAmountSpent_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<CustomerAmountSpent_Max_Fields>;
  min?: Maybe<CustomerAmountSpent_Min_Fields>;
  stddev?: Maybe<CustomerAmountSpent_Stddev_Fields>;
  stddev_pop?: Maybe<CustomerAmountSpent_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CustomerAmountSpent_Stddev_Samp_Fields>;
  sum?: Maybe<CustomerAmountSpent_Sum_Fields>;
  var_pop?: Maybe<CustomerAmountSpent_Var_Pop_Fields>;
  var_samp?: Maybe<CustomerAmountSpent_Var_Samp_Fields>;
  variance?: Maybe<CustomerAmountSpent_Variance_Fields>;
};


/** aggregate fields of "customerAmountSpent" */
export type CustomerAmountSpent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CustomerAmountSpent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type CustomerAmountSpent_Avg_Fields = {
  __typename?: 'customerAmountSpent_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "customerAmountSpent". All fields are combined with a logical 'AND'. */
export type CustomerAmountSpent_Bool_Exp = {
  _and?: InputMaybe<Array<CustomerAmountSpent_Bool_Exp>>;
  _not?: InputMaybe<CustomerAmountSpent_Bool_Exp>;
  _or?: InputMaybe<Array<CustomerAmountSpent_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  customer?: InputMaybe<Customers_Bool_Exp>;
  customerId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "customerAmountSpent" */
export type CustomerAmountSpent_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  customer?: InputMaybe<Customers_Obj_Rel_Insert_Input>;
  customerId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type CustomerAmountSpent_Max_Fields = {
  __typename?: 'customerAmountSpent_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  customerId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type CustomerAmountSpent_Min_Fields = {
  __typename?: 'customerAmountSpent_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  customerId?: Maybe<Scalars['uuid']['output']>;
};

/** input type for inserting object relation for remote table "customerAmountSpent" */
export type CustomerAmountSpent_Obj_Rel_Insert_Input = {
  data: CustomerAmountSpent_Insert_Input;
};

/** Ordering options when selecting data from "customerAmountSpent". */
export type CustomerAmountSpent_Order_By = {
  amount?: InputMaybe<Order_By>;
  customer?: InputMaybe<Customers_Order_By>;
  customerId?: InputMaybe<Order_By>;
};

/** select columns of table "customerAmountSpent" */
export enum CustomerAmountSpent_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CustomerId = 'customerId'
}

/** aggregate stddev on columns */
export type CustomerAmountSpent_Stddev_Fields = {
  __typename?: 'customerAmountSpent_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type CustomerAmountSpent_Stddev_Pop_Fields = {
  __typename?: 'customerAmountSpent_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type CustomerAmountSpent_Stddev_Samp_Fields = {
  __typename?: 'customerAmountSpent_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "customerAmountSpent" */
export type CustomerAmountSpent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CustomerAmountSpent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CustomerAmountSpent_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  customerId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type CustomerAmountSpent_Sum_Fields = {
  __typename?: 'customerAmountSpent_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type CustomerAmountSpent_Var_Pop_Fields = {
  __typename?: 'customerAmountSpent_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type CustomerAmountSpent_Var_Samp_Fields = {
  __typename?: 'customerAmountSpent_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type CustomerAmountSpent_Variance_Fields = {
  __typename?: 'customerAmountSpent_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "customers" */
export type Customers = {
  __typename?: 'customers';
  address?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  amountSpent?: Maybe<CustomerAmountSpent>;
  apartmentNumber?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  appointments: Array<Appointments>;
  /** An aggregate relationship */
  appointments_aggregate: Appointments_Aggregate;
  /** Stripe Customer Id of the platform account */
  bmStripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** Stripe Payment Method Id of the platform account */
  bmStripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  /** column to track customers created during guest checkout */
  checkoutSessionId?: Maybe<Scalars['uuid']['output']>;
  coordinates?: Maybe<Scalars['geography']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isBlocked: Scalars['Boolean']['output'];
  /** An object relationship */
  location?: Maybe<Locations>;
  locationId?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  provider?: Maybe<Providers>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  stripeClientSecret?: Maybe<Scalars['String']['output']>;
  /** Customer Id of the SP connected account */
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** Payment Method Id of the SP connected account */
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  userId?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "customers" */
export type CustomersAppointmentsArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


/** columns and relationships of "customers" */
export type CustomersAppointments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};

/** aggregated selection of "customers" */
export type Customers_Aggregate = {
  __typename?: 'customers_aggregate';
  aggregate?: Maybe<Customers_Aggregate_Fields>;
  nodes: Array<Customers>;
};

export type Customers_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customers_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customers_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customers_Aggregate_Bool_Exp_Count>;
};

export type Customers_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customers_Select_Column_Customers_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customers_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customers_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customers_Select_Column_Customers_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customers_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customers" */
export type Customers_Aggregate_Fields = {
  __typename?: 'customers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Customers_Max_Fields>;
  min?: Maybe<Customers_Min_Fields>;
};


/** aggregate fields of "customers" */
export type Customers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "customers" */
export type Customers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customers_Max_Order_By>;
  min?: InputMaybe<Customers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customers" */
export type Customers_Arr_Rel_Insert_Input = {
  data: Array<Customers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customers". All fields are combined with a logical 'AND'. */
export type Customers_Bool_Exp = {
  _and?: InputMaybe<Array<Customers_Bool_Exp>>;
  _not?: InputMaybe<Customers_Bool_Exp>;
  _or?: InputMaybe<Array<Customers_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  amountSpent?: InputMaybe<CustomerAmountSpent_Bool_Exp>;
  apartmentNumber?: InputMaybe<String_Comparison_Exp>;
  appointments?: InputMaybe<Appointments_Bool_Exp>;
  appointments_aggregate?: InputMaybe<Appointments_Aggregate_Bool_Exp>;
  bmStripeCustomerId?: InputMaybe<String_Comparison_Exp>;
  bmStripePaymentMethodId?: InputMaybe<String_Comparison_Exp>;
  checkoutSessionId?: InputMaybe<Uuid_Comparison_Exp>;
  coordinates?: InputMaybe<Geography_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isBlocked?: InputMaybe<Boolean_Comparison_Exp>;
  location?: InputMaybe<Locations_Bool_Exp>;
  locationId?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phoneNumber?: InputMaybe<String_Comparison_Exp>;
  provider?: InputMaybe<Providers_Bool_Exp>;
  providerId?: InputMaybe<Uuid_Comparison_Exp>;
  stripeClientSecret?: InputMaybe<String_Comparison_Exp>;
  stripeCustomerId?: InputMaybe<String_Comparison_Exp>;
  stripePaymentMethodId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "customers" */
export enum Customers_Constraint {
  /** unique or primary key constraint on columns "userId", "locationId" */
  CustomersLocationIdUserIdKey = 'customers_locationId_userId_key',
  /** unique or primary key constraint on columns "id" */
  CustomersPkey = 'customers_pkey',
  /** unique or primary key constraint on columns "userId", "locationId" */
  CustomersUserIdLocationIdKey = 'customers_userId_locationId_key',
  /** unique or primary key constraint on columns "userId", "providerId" */
  CustomersUserIdProviderIdKey = 'customers_userId_providerId_key',
  /** unique or primary key constraint on columns "locationId", "email" */
  UniqueCustomerEmailPerBm = 'unique_customer_email_per_bm',
  /** unique or primary key constraint on columns "providerId", "email" */
  UniqueCustomerEmailPerSp = 'unique_customer_email_per_sp'
}

/** input type for inserting data into table "customers" */
export type Customers_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  amountSpent?: InputMaybe<CustomerAmountSpent_Obj_Rel_Insert_Input>;
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  appointments?: InputMaybe<Appointments_Arr_Rel_Insert_Input>;
  /** Stripe Customer Id of the platform account */
  bmStripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  /** Stripe Payment Method Id of the platform account */
  bmStripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  /** column to track customers created during guest checkout */
  checkoutSessionId?: InputMaybe<Scalars['uuid']['input']>;
  coordinates?: InputMaybe<Scalars['geography']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Locations_Obj_Rel_Insert_Input>;
  locationId?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Providers_Obj_Rel_Insert_Input>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  stripeClientSecret?: InputMaybe<Scalars['String']['input']>;
  /** Customer Id of the SP connected account */
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  /** Payment Method Id of the SP connected account */
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Customers_Max_Fields = {
  __typename?: 'customers_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  apartmentNumber?: Maybe<Scalars['String']['output']>;
  /** Stripe Customer Id of the platform account */
  bmStripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** Stripe Payment Method Id of the platform account */
  bmStripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  /** column to track customers created during guest checkout */
  checkoutSessionId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  locationId?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  stripeClientSecret?: Maybe<Scalars['String']['output']>;
  /** Customer Id of the SP connected account */
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** Payment Method Id of the SP connected account */
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "customers" */
export type Customers_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  apartmentNumber?: InputMaybe<Order_By>;
  /** Stripe Customer Id of the platform account */
  bmStripeCustomerId?: InputMaybe<Order_By>;
  /** Stripe Payment Method Id of the platform account */
  bmStripePaymentMethodId?: InputMaybe<Order_By>;
  /** column to track customers created during guest checkout */
  checkoutSessionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locationId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  stripeClientSecret?: InputMaybe<Order_By>;
  /** Customer Id of the SP connected account */
  stripeCustomerId?: InputMaybe<Order_By>;
  /** Payment Method Id of the SP connected account */
  stripePaymentMethodId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customers_Min_Fields = {
  __typename?: 'customers_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  apartmentNumber?: Maybe<Scalars['String']['output']>;
  /** Stripe Customer Id of the platform account */
  bmStripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** Stripe Payment Method Id of the platform account */
  bmStripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  /** column to track customers created during guest checkout */
  checkoutSessionId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  locationId?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  stripeClientSecret?: Maybe<Scalars['String']['output']>;
  /** Customer Id of the SP connected account */
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** Payment Method Id of the SP connected account */
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "customers" */
export type Customers_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  apartmentNumber?: InputMaybe<Order_By>;
  /** Stripe Customer Id of the platform account */
  bmStripeCustomerId?: InputMaybe<Order_By>;
  /** Stripe Payment Method Id of the platform account */
  bmStripePaymentMethodId?: InputMaybe<Order_By>;
  /** column to track customers created during guest checkout */
  checkoutSessionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locationId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  stripeClientSecret?: InputMaybe<Order_By>;
  /** Customer Id of the SP connected account */
  stripeCustomerId?: InputMaybe<Order_By>;
  /** Payment Method Id of the SP connected account */
  stripePaymentMethodId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customers" */
export type Customers_Mutation_Response = {
  __typename?: 'customers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customers>;
};

/** input type for inserting object relation for remote table "customers" */
export type Customers_Obj_Rel_Insert_Input = {
  data: Customers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customers_On_Conflict>;
};

/** on_conflict condition type for table "customers" */
export type Customers_On_Conflict = {
  constraint: Customers_Constraint;
  update_columns?: Array<Customers_Update_Column>;
  where?: InputMaybe<Customers_Bool_Exp>;
};

/** Ordering options when selecting data from "customers". */
export type Customers_Order_By = {
  address?: InputMaybe<Order_By>;
  amountSpent?: InputMaybe<CustomerAmountSpent_Order_By>;
  apartmentNumber?: InputMaybe<Order_By>;
  appointments_aggregate?: InputMaybe<Appointments_Aggregate_Order_By>;
  bmStripeCustomerId?: InputMaybe<Order_By>;
  bmStripePaymentMethodId?: InputMaybe<Order_By>;
  checkoutSessionId?: InputMaybe<Order_By>;
  coordinates?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isBlocked?: InputMaybe<Order_By>;
  location?: InputMaybe<Locations_Order_By>;
  locationId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  provider?: InputMaybe<Providers_Order_By>;
  providerId?: InputMaybe<Order_By>;
  stripeClientSecret?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  stripePaymentMethodId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customers */
export type Customers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "customers" */
export enum Customers_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  ApartmentNumber = 'apartmentNumber',
  /** column name */
  BmStripeCustomerId = 'bmStripeCustomerId',
  /** column name */
  BmStripePaymentMethodId = 'bmStripePaymentMethodId',
  /** column name */
  CheckoutSessionId = 'checkoutSessionId',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IsBlocked = 'isBlocked',
  /** column name */
  LocationId = 'locationId',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  StripeClientSecret = 'stripeClientSecret',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripePaymentMethodId = 'stripePaymentMethodId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** select "customers_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customers" */
export enum Customers_Select_Column_Customers_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsBlocked = 'isBlocked'
}

/** select "customers_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customers" */
export enum Customers_Select_Column_Customers_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsBlocked = 'isBlocked'
}

/** input type for updating data in table "customers" */
export type Customers_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  /** Stripe Customer Id of the platform account */
  bmStripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  /** Stripe Payment Method Id of the platform account */
  bmStripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  /** column to track customers created during guest checkout */
  checkoutSessionId?: InputMaybe<Scalars['uuid']['input']>;
  coordinates?: InputMaybe<Scalars['geography']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  stripeClientSecret?: InputMaybe<Scalars['String']['input']>;
  /** Customer Id of the SP connected account */
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  /** Payment Method Id of the SP connected account */
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "customers" */
export type Customers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customers_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  /** Stripe Customer Id of the platform account */
  bmStripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  /** Stripe Payment Method Id of the platform account */
  bmStripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  /** column to track customers created during guest checkout */
  checkoutSessionId?: InputMaybe<Scalars['uuid']['input']>;
  coordinates?: InputMaybe<Scalars['geography']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  stripeClientSecret?: InputMaybe<Scalars['String']['input']>;
  /** Customer Id of the SP connected account */
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  /** Payment Method Id of the SP connected account */
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "customers" */
export enum Customers_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  ApartmentNumber = 'apartmentNumber',
  /** column name */
  BmStripeCustomerId = 'bmStripeCustomerId',
  /** column name */
  BmStripePaymentMethodId = 'bmStripePaymentMethodId',
  /** column name */
  CheckoutSessionId = 'checkoutSessionId',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IsBlocked = 'isBlocked',
  /** column name */
  LocationId = 'locationId',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  StripeClientSecret = 'stripeClientSecret',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripePaymentMethodId = 'stripePaymentMethodId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Customers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customers_Bool_Exp;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "entityType" */
export type EntityType = {
  __typename?: 'entityType';
  value: Scalars['String']['output'];
};

/** aggregated selection of "entityType" */
export type EntityType_Aggregate = {
  __typename?: 'entityType_aggregate';
  aggregate?: Maybe<EntityType_Aggregate_Fields>;
  nodes: Array<EntityType>;
};

/** aggregate fields of "entityType" */
export type EntityType_Aggregate_Fields = {
  __typename?: 'entityType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<EntityType_Max_Fields>;
  min?: Maybe<EntityType_Min_Fields>;
};


/** aggregate fields of "entityType" */
export type EntityType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EntityType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "entityType". All fields are combined with a logical 'AND'. */
export type EntityType_Bool_Exp = {
  _and?: InputMaybe<Array<EntityType_Bool_Exp>>;
  _not?: InputMaybe<EntityType_Bool_Exp>;
  _or?: InputMaybe<Array<EntityType_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "entityType" */
export enum EntityType_Constraint {
  /** unique or primary key constraint on columns "value" */
  EntityTypePkey = 'entityType_pkey'
}

export enum EntityType_Enum {
  Appointments = 'appointments',
  FormAnswers = 'formAnswers',
  Locations = 'locations',
  Payments = 'payments',
  Providers = 'providers',
  Services = 'services',
  Users = 'users'
}

/** Boolean expression to compare columns of type "entityType_enum". All fields are combined with logical 'AND'. */
export type EntityType_Enum_Comparison_Exp = {
  _eq?: InputMaybe<EntityType_Enum>;
  _in?: InputMaybe<Array<EntityType_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<EntityType_Enum>;
  _nin?: InputMaybe<Array<EntityType_Enum>>;
};

/** input type for inserting data into table "entityType" */
export type EntityType_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EntityType_Max_Fields = {
  __typename?: 'entityType_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type EntityType_Min_Fields = {
  __typename?: 'entityType_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "entityType" */
export type EntityType_Mutation_Response = {
  __typename?: 'entityType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityType>;
};

/** on_conflict condition type for table "entityType" */
export type EntityType_On_Conflict = {
  constraint: EntityType_Constraint;
  update_columns?: Array<EntityType_Update_Column>;
  where?: InputMaybe<EntityType_Bool_Exp>;
};

/** Ordering options when selecting data from "entityType". */
export type EntityType_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: entityType */
export type EntityType_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "entityType" */
export enum EntityType_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "entityType" */
export type EntityType_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "entityType" */
export type EntityType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EntityType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityType_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "entityType" */
export enum EntityType_Update_Column {
  /** column name */
  Value = 'value'
}

export type EntityType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityType_Set_Input>;
  /** filter the rows which have to be updated */
  where: EntityType_Bool_Exp;
};

/** columns and relationships of "files" */
export type Files = {
  __typename?: 'files';
  /** when the file is saved to the database on any entity, an event trigger should go off and update this field */
  assignedId?: Maybe<Scalars['uuid']['output']>;
  /** stores the id of the checkout session for anonymous checkouts */
  checkoutSessionId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  entityType: EntityType_Enum;
  /** An object relationship */
  formAnswer?: Maybe<FormAnswers>;
  id: Scalars['uuid']['output'];
  /** key name on the s3 bucket */
  name: Scalars['String']['output'];
  private: Scalars['Boolean']['output'];
  /** An object relationship */
  provider?: Maybe<Providers>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** raw upload filename for display purposes only */
  uploadName: Scalars['String']['output'];
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userPicture?: Maybe<Users>;
};

/** aggregated selection of "files" */
export type Files_Aggregate = {
  __typename?: 'files_aggregate';
  aggregate?: Maybe<Files_Aggregate_Fields>;
  nodes: Array<Files>;
};

/** aggregate fields of "files" */
export type Files_Aggregate_Fields = {
  __typename?: 'files_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Files_Max_Fields>;
  min?: Maybe<Files_Min_Fields>;
};


/** aggregate fields of "files" */
export type Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp = {
  _and?: InputMaybe<Array<Files_Bool_Exp>>;
  _not?: InputMaybe<Files_Bool_Exp>;
  _or?: InputMaybe<Array<Files_Bool_Exp>>;
  assignedId?: InputMaybe<Uuid_Comparison_Exp>;
  checkoutSessionId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  entityType?: InputMaybe<EntityType_Enum_Comparison_Exp>;
  formAnswer?: InputMaybe<FormAnswers_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  private?: InputMaybe<Boolean_Comparison_Exp>;
  provider?: InputMaybe<Providers_Bool_Exp>;
  providerId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploadName?: InputMaybe<String_Comparison_Exp>;
  uploadedByUserId?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userPicture?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "files" */
export enum Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilesPkey = 'files_pkey'
}

/** input type for inserting data into table "files" */
export type Files_Insert_Input = {
  /** when the file is saved to the database on any entity, an event trigger should go off and update this field */
  assignedId?: InputMaybe<Scalars['uuid']['input']>;
  /** stores the id of the checkout session for anonymous checkouts */
  checkoutSessionId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityType?: InputMaybe<EntityType_Enum>;
  formAnswer?: InputMaybe<FormAnswers_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** key name on the s3 bucket */
  name?: InputMaybe<Scalars['String']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<Providers_Obj_Rel_Insert_Input>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** raw upload filename for display purposes only */
  uploadName?: InputMaybe<Scalars['String']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userPicture?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Files_Max_Fields = {
  __typename?: 'files_max_fields';
  /** when the file is saved to the database on any entity, an event trigger should go off and update this field */
  assignedId?: Maybe<Scalars['uuid']['output']>;
  /** stores the id of the checkout session for anonymous checkouts */
  checkoutSessionId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** key name on the s3 bucket */
  name?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** raw upload filename for display purposes only */
  uploadName?: Maybe<Scalars['String']['output']>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Files_Min_Fields = {
  __typename?: 'files_min_fields';
  /** when the file is saved to the database on any entity, an event trigger should go off and update this field */
  assignedId?: Maybe<Scalars['uuid']['output']>;
  /** stores the id of the checkout session for anonymous checkouts */
  checkoutSessionId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** key name on the s3 bucket */
  name?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** raw upload filename for display purposes only */
  uploadName?: Maybe<Scalars['String']['output']>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "files" */
export type Files_Mutation_Response = {
  __typename?: 'files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Files>;
};

/** input type for inserting object relation for remote table "files" */
export type Files_Obj_Rel_Insert_Input = {
  data: Files_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** on_conflict condition type for table "files" */
export type Files_On_Conflict = {
  constraint: Files_Constraint;
  update_columns?: Array<Files_Update_Column>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** Ordering options when selecting data from "files". */
export type Files_Order_By = {
  assignedId?: InputMaybe<Order_By>;
  checkoutSessionId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  entityType?: InputMaybe<Order_By>;
  formAnswer?: InputMaybe<FormAnswers_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  private?: InputMaybe<Order_By>;
  provider?: InputMaybe<Providers_Order_By>;
  providerId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadName?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userPicture?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: files */
export type Files_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "files" */
export enum Files_Select_Column {
  /** column name */
  AssignedId = 'assignedId',
  /** column name */
  CheckoutSessionId = 'checkoutSessionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EntityType = 'entityType',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Private = 'private',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadName = 'uploadName',
  /** column name */
  UploadedByUserId = 'uploadedByUserId'
}

/** input type for updating data in table "files" */
export type Files_Set_Input = {
  /** when the file is saved to the database on any entity, an event trigger should go off and update this field */
  assignedId?: InputMaybe<Scalars['uuid']['input']>;
  /** stores the id of the checkout session for anonymous checkouts */
  checkoutSessionId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityType?: InputMaybe<EntityType_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** key name on the s3 bucket */
  name?: InputMaybe<Scalars['String']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** raw upload filename for display purposes only */
  uploadName?: InputMaybe<Scalars['String']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "files" */
export type Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Files_Stream_Cursor_Value_Input = {
  /** when the file is saved to the database on any entity, an event trigger should go off and update this field */
  assignedId?: InputMaybe<Scalars['uuid']['input']>;
  /** stores the id of the checkout session for anonymous checkouts */
  checkoutSessionId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityType?: InputMaybe<EntityType_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** key name on the s3 bucket */
  name?: InputMaybe<Scalars['String']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** raw upload filename for display purposes only */
  uploadName?: InputMaybe<Scalars['String']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "files" */
export enum Files_Update_Column {
  /** column name */
  AssignedId = 'assignedId',
  /** column name */
  CheckoutSessionId = 'checkoutSessionId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EntityType = 'entityType',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Private = 'private',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadName = 'uploadName',
  /** column name */
  UploadedByUserId = 'uploadedByUserId'
}

export type Files_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Files_Bool_Exp;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "form" */
export type Form = {
  __typename?: 'form';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  formAnswers: Array<FormAnswers>;
  /** An aggregate relationship */
  formAnswers_aggregate: FormAnswers_Aggregate;
  /** An array relationship */
  formQuestions: Array<FormQuestions>;
  /** An aggregate relationship */
  formQuestions_aggregate: FormQuestions_Aggregate;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  provider: Providers;
  providerId: Scalars['uuid']['output'];
  /** An array relationship */
  servicesForms: Array<ServicesForms>;
  /** An aggregate relationship */
  servicesForms_aggregate: ServicesForms_Aggregate;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "form" */
export type FormFormAnswersArgs = {
  distinct_on?: InputMaybe<Array<FormAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormAnswers_Order_By>>;
  where?: InputMaybe<FormAnswers_Bool_Exp>;
};


/** columns and relationships of "form" */
export type FormFormAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FormAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormAnswers_Order_By>>;
  where?: InputMaybe<FormAnswers_Bool_Exp>;
};


/** columns and relationships of "form" */
export type FormFormQuestionsArgs = {
  distinct_on?: InputMaybe<Array<FormQuestions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormQuestions_Order_By>>;
  where?: InputMaybe<FormQuestions_Bool_Exp>;
};


/** columns and relationships of "form" */
export type FormFormQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FormQuestions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormQuestions_Order_By>>;
  where?: InputMaybe<FormQuestions_Bool_Exp>;
};


/** columns and relationships of "form" */
export type FormServicesFormsArgs = {
  distinct_on?: InputMaybe<Array<ServicesForms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicesForms_Order_By>>;
  where?: InputMaybe<ServicesForms_Bool_Exp>;
};


/** columns and relationships of "form" */
export type FormServicesForms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServicesForms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicesForms_Order_By>>;
  where?: InputMaybe<ServicesForms_Bool_Exp>;
};

/** columns and relationships of "formAnswers" */
export type FormAnswers = {
  __typename?: 'formAnswers';
  answer?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  appointment: Appointments;
  appointmentId: Scalars['uuid']['output'];
  /** An object relationship */
  file?: Maybe<Files>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  form: Form;
  formId: Scalars['uuid']['output'];
  /** An object relationship */
  formQuestion: FormQuestions;
  formQuestionId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  option?: Maybe<FormQuestionOptions>;
  optionId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "formAnswers" */
export type FormAnswers_Aggregate = {
  __typename?: 'formAnswers_aggregate';
  aggregate?: Maybe<FormAnswers_Aggregate_Fields>;
  nodes: Array<FormAnswers>;
};

export type FormAnswers_Aggregate_Bool_Exp = {
  count?: InputMaybe<FormAnswers_Aggregate_Bool_Exp_Count>;
};

export type FormAnswers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<FormAnswers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<FormAnswers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "formAnswers" */
export type FormAnswers_Aggregate_Fields = {
  __typename?: 'formAnswers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<FormAnswers_Max_Fields>;
  min?: Maybe<FormAnswers_Min_Fields>;
};


/** aggregate fields of "formAnswers" */
export type FormAnswers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FormAnswers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "formAnswers" */
export type FormAnswers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<FormAnswers_Max_Order_By>;
  min?: InputMaybe<FormAnswers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "formAnswers" */
export type FormAnswers_Arr_Rel_Insert_Input = {
  data: Array<FormAnswers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<FormAnswers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "formAnswers". All fields are combined with a logical 'AND'. */
export type FormAnswers_Bool_Exp = {
  _and?: InputMaybe<Array<FormAnswers_Bool_Exp>>;
  _not?: InputMaybe<FormAnswers_Bool_Exp>;
  _or?: InputMaybe<Array<FormAnswers_Bool_Exp>>;
  answer?: InputMaybe<String_Comparison_Exp>;
  appointment?: InputMaybe<Appointments_Bool_Exp>;
  appointmentId?: InputMaybe<Uuid_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Uuid_Comparison_Exp>;
  form?: InputMaybe<Form_Bool_Exp>;
  formId?: InputMaybe<Uuid_Comparison_Exp>;
  formQuestion?: InputMaybe<FormQuestions_Bool_Exp>;
  formQuestionId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  option?: InputMaybe<FormQuestionOptions_Bool_Exp>;
  optionId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "formAnswers" */
export enum FormAnswers_Constraint {
  /** unique or primary key constraint on columns "id" */
  FormAnswersPkey = 'formAnswers_pkey'
}

/** input type for inserting data into table "formAnswers" */
export type FormAnswers_Insert_Input = {
  answer?: InputMaybe<Scalars['String']['input']>;
  appointment?: InputMaybe<Appointments_Obj_Rel_Insert_Input>;
  appointmentId?: InputMaybe<Scalars['uuid']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  form?: InputMaybe<Form_Obj_Rel_Insert_Input>;
  formId?: InputMaybe<Scalars['uuid']['input']>;
  formQuestion?: InputMaybe<FormQuestions_Obj_Rel_Insert_Input>;
  formQuestionId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  option?: InputMaybe<FormQuestionOptions_Obj_Rel_Insert_Input>;
  optionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type FormAnswers_Max_Fields = {
  __typename?: 'formAnswers_max_fields';
  answer?: Maybe<Scalars['String']['output']>;
  appointmentId?: Maybe<Scalars['uuid']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  formId?: Maybe<Scalars['uuid']['output']>;
  formQuestionId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  optionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "formAnswers" */
export type FormAnswers_Max_Order_By = {
  answer?: InputMaybe<Order_By>;
  appointmentId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  formId?: InputMaybe<Order_By>;
  formQuestionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  optionId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type FormAnswers_Min_Fields = {
  __typename?: 'formAnswers_min_fields';
  answer?: Maybe<Scalars['String']['output']>;
  appointmentId?: Maybe<Scalars['uuid']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  formId?: Maybe<Scalars['uuid']['output']>;
  formQuestionId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  optionId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "formAnswers" */
export type FormAnswers_Min_Order_By = {
  answer?: InputMaybe<Order_By>;
  appointmentId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  formId?: InputMaybe<Order_By>;
  formQuestionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  optionId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "formAnswers" */
export type FormAnswers_Mutation_Response = {
  __typename?: 'formAnswers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<FormAnswers>;
};

/** input type for inserting object relation for remote table "formAnswers" */
export type FormAnswers_Obj_Rel_Insert_Input = {
  data: FormAnswers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<FormAnswers_On_Conflict>;
};

/** on_conflict condition type for table "formAnswers" */
export type FormAnswers_On_Conflict = {
  constraint: FormAnswers_Constraint;
  update_columns?: Array<FormAnswers_Update_Column>;
  where?: InputMaybe<FormAnswers_Bool_Exp>;
};

/** Ordering options when selecting data from "formAnswers". */
export type FormAnswers_Order_By = {
  answer?: InputMaybe<Order_By>;
  appointment?: InputMaybe<Appointments_Order_By>;
  appointmentId?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  form?: InputMaybe<Form_Order_By>;
  formId?: InputMaybe<Order_By>;
  formQuestion?: InputMaybe<FormQuestions_Order_By>;
  formQuestionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  option?: InputMaybe<FormQuestionOptions_Order_By>;
  optionId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: formAnswers */
export type FormAnswers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "formAnswers" */
export enum FormAnswers_Select_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  AppointmentId = 'appointmentId',
  /** column name */
  FileId = 'fileId',
  /** column name */
  FormId = 'formId',
  /** column name */
  FormQuestionId = 'formQuestionId',
  /** column name */
  Id = 'id',
  /** column name */
  OptionId = 'optionId'
}

/** input type for updating data in table "formAnswers" */
export type FormAnswers_Set_Input = {
  answer?: InputMaybe<Scalars['String']['input']>;
  appointmentId?: InputMaybe<Scalars['uuid']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  formId?: InputMaybe<Scalars['uuid']['input']>;
  formQuestionId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  optionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "formAnswers" */
export type FormAnswers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FormAnswers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FormAnswers_Stream_Cursor_Value_Input = {
  answer?: InputMaybe<Scalars['String']['input']>;
  appointmentId?: InputMaybe<Scalars['uuid']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  formId?: InputMaybe<Scalars['uuid']['input']>;
  formQuestionId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  optionId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "formAnswers" */
export enum FormAnswers_Update_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  AppointmentId = 'appointmentId',
  /** column name */
  FileId = 'fileId',
  /** column name */
  FormId = 'formId',
  /** column name */
  FormQuestionId = 'formQuestionId',
  /** column name */
  Id = 'id',
  /** column name */
  OptionId = 'optionId'
}

export type FormAnswers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FormAnswers_Set_Input>;
  /** filter the rows which have to be updated */
  where: FormAnswers_Bool_Exp;
};

/** columns and relationships of "formQuestionOptions" */
export type FormQuestionOptions = {
  __typename?: 'formQuestionOptions';
  /** An object relationship */
  formQuestion: FormQuestions;
  formQuestionId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "formQuestionOptions" */
export type FormQuestionOptions_Aggregate = {
  __typename?: 'formQuestionOptions_aggregate';
  aggregate?: Maybe<FormQuestionOptions_Aggregate_Fields>;
  nodes: Array<FormQuestionOptions>;
};

export type FormQuestionOptions_Aggregate_Bool_Exp = {
  count?: InputMaybe<FormQuestionOptions_Aggregate_Bool_Exp_Count>;
};

export type FormQuestionOptions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<FormQuestionOptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<FormQuestionOptions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "formQuestionOptions" */
export type FormQuestionOptions_Aggregate_Fields = {
  __typename?: 'formQuestionOptions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<FormQuestionOptions_Max_Fields>;
  min?: Maybe<FormQuestionOptions_Min_Fields>;
};


/** aggregate fields of "formQuestionOptions" */
export type FormQuestionOptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FormQuestionOptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "formQuestionOptions" */
export type FormQuestionOptions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<FormQuestionOptions_Max_Order_By>;
  min?: InputMaybe<FormQuestionOptions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "formQuestionOptions" */
export type FormQuestionOptions_Arr_Rel_Insert_Input = {
  data: Array<FormQuestionOptions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<FormQuestionOptions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "formQuestionOptions". All fields are combined with a logical 'AND'. */
export type FormQuestionOptions_Bool_Exp = {
  _and?: InputMaybe<Array<FormQuestionOptions_Bool_Exp>>;
  _not?: InputMaybe<FormQuestionOptions_Bool_Exp>;
  _or?: InputMaybe<Array<FormQuestionOptions_Bool_Exp>>;
  formQuestion?: InputMaybe<FormQuestions_Bool_Exp>;
  formQuestionId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "formQuestionOptions" */
export enum FormQuestionOptions_Constraint {
  /** unique or primary key constraint on columns "id" */
  FormQuestionOptionsPkey = 'formQuestionOptions_pkey'
}

/** input type for inserting data into table "formQuestionOptions" */
export type FormQuestionOptions_Insert_Input = {
  formQuestion?: InputMaybe<FormQuestions_Obj_Rel_Insert_Input>;
  formQuestionId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type FormQuestionOptions_Max_Fields = {
  __typename?: 'formQuestionOptions_max_fields';
  formQuestionId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "formQuestionOptions" */
export type FormQuestionOptions_Max_Order_By = {
  formQuestionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type FormQuestionOptions_Min_Fields = {
  __typename?: 'formQuestionOptions_min_fields';
  formQuestionId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "formQuestionOptions" */
export type FormQuestionOptions_Min_Order_By = {
  formQuestionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "formQuestionOptions" */
export type FormQuestionOptions_Mutation_Response = {
  __typename?: 'formQuestionOptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<FormQuestionOptions>;
};

/** input type for inserting object relation for remote table "formQuestionOptions" */
export type FormQuestionOptions_Obj_Rel_Insert_Input = {
  data: FormQuestionOptions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<FormQuestionOptions_On_Conflict>;
};

/** on_conflict condition type for table "formQuestionOptions" */
export type FormQuestionOptions_On_Conflict = {
  constraint: FormQuestionOptions_Constraint;
  update_columns?: Array<FormQuestionOptions_Update_Column>;
  where?: InputMaybe<FormQuestionOptions_Bool_Exp>;
};

/** Ordering options when selecting data from "formQuestionOptions". */
export type FormQuestionOptions_Order_By = {
  formQuestion?: InputMaybe<FormQuestions_Order_By>;
  formQuestionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: formQuestionOptions */
export type FormQuestionOptions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "formQuestionOptions" */
export enum FormQuestionOptions_Select_Column {
  /** column name */
  FormQuestionId = 'formQuestionId',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "formQuestionOptions" */
export type FormQuestionOptions_Set_Input = {
  formQuestionId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "formQuestionOptions" */
export type FormQuestionOptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FormQuestionOptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FormQuestionOptions_Stream_Cursor_Value_Input = {
  formQuestionId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "formQuestionOptions" */
export enum FormQuestionOptions_Update_Column {
  /** column name */
  FormQuestionId = 'formQuestionId',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value'
}

export type FormQuestionOptions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FormQuestionOptions_Set_Input>;
  /** filter the rows which have to be updated */
  where: FormQuestionOptions_Bool_Exp;
};

/** columns and relationships of "formQuestionType" */
export type FormQuestionType = {
  __typename?: 'formQuestionType';
  /** An array relationship */
  formQuestions: Array<FormQuestions>;
  /** An aggregate relationship */
  formQuestions_aggregate: FormQuestions_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "formQuestionType" */
export type FormQuestionTypeFormQuestionsArgs = {
  distinct_on?: InputMaybe<Array<FormQuestions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormQuestions_Order_By>>;
  where?: InputMaybe<FormQuestions_Bool_Exp>;
};


/** columns and relationships of "formQuestionType" */
export type FormQuestionTypeFormQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FormQuestions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormQuestions_Order_By>>;
  where?: InputMaybe<FormQuestions_Bool_Exp>;
};

/** aggregated selection of "formQuestionType" */
export type FormQuestionType_Aggregate = {
  __typename?: 'formQuestionType_aggregate';
  aggregate?: Maybe<FormQuestionType_Aggregate_Fields>;
  nodes: Array<FormQuestionType>;
};

/** aggregate fields of "formQuestionType" */
export type FormQuestionType_Aggregate_Fields = {
  __typename?: 'formQuestionType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<FormQuestionType_Max_Fields>;
  min?: Maybe<FormQuestionType_Min_Fields>;
};


/** aggregate fields of "formQuestionType" */
export type FormQuestionType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FormQuestionType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "formQuestionType". All fields are combined with a logical 'AND'. */
export type FormQuestionType_Bool_Exp = {
  _and?: InputMaybe<Array<FormQuestionType_Bool_Exp>>;
  _not?: InputMaybe<FormQuestionType_Bool_Exp>;
  _or?: InputMaybe<Array<FormQuestionType_Bool_Exp>>;
  formQuestions?: InputMaybe<FormQuestions_Bool_Exp>;
  formQuestions_aggregate?: InputMaybe<FormQuestions_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "formQuestionType" */
export enum FormQuestionType_Constraint {
  /** unique or primary key constraint on columns "value" */
  FormQuestionTypePkey = 'formQuestionType_pkey'
}

export enum FormQuestionType_Enum {
  Checkbox = 'checkbox',
  Date = 'date',
  FileDocument = 'file_document',
  FileImage = 'file_image',
  LongText = 'long_text',
  RadioGroup = 'radio_group',
  ShortText = 'short_text'
}

/** Boolean expression to compare columns of type "formQuestionType_enum". All fields are combined with logical 'AND'. */
export type FormQuestionType_Enum_Comparison_Exp = {
  _eq?: InputMaybe<FormQuestionType_Enum>;
  _in?: InputMaybe<Array<FormQuestionType_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<FormQuestionType_Enum>;
  _nin?: InputMaybe<Array<FormQuestionType_Enum>>;
};

/** input type for inserting data into table "formQuestionType" */
export type FormQuestionType_Insert_Input = {
  formQuestions?: InputMaybe<FormQuestions_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type FormQuestionType_Max_Fields = {
  __typename?: 'formQuestionType_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type FormQuestionType_Min_Fields = {
  __typename?: 'formQuestionType_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "formQuestionType" */
export type FormQuestionType_Mutation_Response = {
  __typename?: 'formQuestionType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<FormQuestionType>;
};

/** input type for inserting object relation for remote table "formQuestionType" */
export type FormQuestionType_Obj_Rel_Insert_Input = {
  data: FormQuestionType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<FormQuestionType_On_Conflict>;
};

/** on_conflict condition type for table "formQuestionType" */
export type FormQuestionType_On_Conflict = {
  constraint: FormQuestionType_Constraint;
  update_columns?: Array<FormQuestionType_Update_Column>;
  where?: InputMaybe<FormQuestionType_Bool_Exp>;
};

/** Ordering options when selecting data from "formQuestionType". */
export type FormQuestionType_Order_By = {
  formQuestions_aggregate?: InputMaybe<FormQuestions_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: formQuestionType */
export type FormQuestionType_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "formQuestionType" */
export enum FormQuestionType_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "formQuestionType" */
export type FormQuestionType_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "formQuestionType" */
export type FormQuestionType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FormQuestionType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FormQuestionType_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "formQuestionType" */
export enum FormQuestionType_Update_Column {
  /** column name */
  Value = 'value'
}

export type FormQuestionType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FormQuestionType_Set_Input>;
  /** filter the rows which have to be updated */
  where: FormQuestionType_Bool_Exp;
};

/** columns and relationships of "formQuestions" */
export type FormQuestions = {
  __typename?: 'formQuestions';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  form: Form;
  /** An array relationship */
  formAnswers: Array<FormAnswers>;
  /** An aggregate relationship */
  formAnswers_aggregate: FormAnswers_Aggregate;
  formId: Scalars['uuid']['output'];
  /** An array relationship */
  formQuestionOptions: Array<FormQuestionOptions>;
  /** An aggregate relationship */
  formQuestionOptions_aggregate: FormQuestionOptions_Aggregate;
  /** An object relationship */
  formQuestionType: FormQuestionType;
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  mandatory: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order: Scalars['bigint']['output'];
  questionType: FormQuestionType_Enum;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "formQuestions" */
export type FormQuestionsFormAnswersArgs = {
  distinct_on?: InputMaybe<Array<FormAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormAnswers_Order_By>>;
  where?: InputMaybe<FormAnswers_Bool_Exp>;
};


/** columns and relationships of "formQuestions" */
export type FormQuestionsFormAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FormAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormAnswers_Order_By>>;
  where?: InputMaybe<FormAnswers_Bool_Exp>;
};


/** columns and relationships of "formQuestions" */
export type FormQuestionsFormQuestionOptionsArgs = {
  distinct_on?: InputMaybe<Array<FormQuestionOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormQuestionOptions_Order_By>>;
  where?: InputMaybe<FormQuestionOptions_Bool_Exp>;
};


/** columns and relationships of "formQuestions" */
export type FormQuestionsFormQuestionOptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FormQuestionOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormQuestionOptions_Order_By>>;
  where?: InputMaybe<FormQuestionOptions_Bool_Exp>;
};

/** aggregated selection of "formQuestions" */
export type FormQuestions_Aggregate = {
  __typename?: 'formQuestions_aggregate';
  aggregate?: Maybe<FormQuestions_Aggregate_Fields>;
  nodes: Array<FormQuestions>;
};

export type FormQuestions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<FormQuestions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<FormQuestions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<FormQuestions_Aggregate_Bool_Exp_Count>;
};

export type FormQuestions_Aggregate_Bool_Exp_Bool_And = {
  arguments: FormQuestions_Select_Column_FormQuestions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<FormQuestions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type FormQuestions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: FormQuestions_Select_Column_FormQuestions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<FormQuestions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type FormQuestions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<FormQuestions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<FormQuestions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "formQuestions" */
export type FormQuestions_Aggregate_Fields = {
  __typename?: 'formQuestions_aggregate_fields';
  avg?: Maybe<FormQuestions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<FormQuestions_Max_Fields>;
  min?: Maybe<FormQuestions_Min_Fields>;
  stddev?: Maybe<FormQuestions_Stddev_Fields>;
  stddev_pop?: Maybe<FormQuestions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<FormQuestions_Stddev_Samp_Fields>;
  sum?: Maybe<FormQuestions_Sum_Fields>;
  var_pop?: Maybe<FormQuestions_Var_Pop_Fields>;
  var_samp?: Maybe<FormQuestions_Var_Samp_Fields>;
  variance?: Maybe<FormQuestions_Variance_Fields>;
};


/** aggregate fields of "formQuestions" */
export type FormQuestions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FormQuestions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "formQuestions" */
export type FormQuestions_Aggregate_Order_By = {
  avg?: InputMaybe<FormQuestions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<FormQuestions_Max_Order_By>;
  min?: InputMaybe<FormQuestions_Min_Order_By>;
  stddev?: InputMaybe<FormQuestions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<FormQuestions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<FormQuestions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<FormQuestions_Sum_Order_By>;
  var_pop?: InputMaybe<FormQuestions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<FormQuestions_Var_Samp_Order_By>;
  variance?: InputMaybe<FormQuestions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "formQuestions" */
export type FormQuestions_Arr_Rel_Insert_Input = {
  data: Array<FormQuestions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<FormQuestions_On_Conflict>;
};

/** aggregate avg on columns */
export type FormQuestions_Avg_Fields = {
  __typename?: 'formQuestions_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "formQuestions" */
export type FormQuestions_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "formQuestions". All fields are combined with a logical 'AND'. */
export type FormQuestions_Bool_Exp = {
  _and?: InputMaybe<Array<FormQuestions_Bool_Exp>>;
  _not?: InputMaybe<FormQuestions_Bool_Exp>;
  _or?: InputMaybe<Array<FormQuestions_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  form?: InputMaybe<Form_Bool_Exp>;
  formAnswers?: InputMaybe<FormAnswers_Bool_Exp>;
  formAnswers_aggregate?: InputMaybe<FormAnswers_Aggregate_Bool_Exp>;
  formId?: InputMaybe<Uuid_Comparison_Exp>;
  formQuestionOptions?: InputMaybe<FormQuestionOptions_Bool_Exp>;
  formQuestionOptions_aggregate?: InputMaybe<FormQuestionOptions_Aggregate_Bool_Exp>;
  formQuestionType?: InputMaybe<FormQuestionType_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  mandatory?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Bigint_Comparison_Exp>;
  questionType?: InputMaybe<FormQuestionType_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "formQuestions" */
export enum FormQuestions_Constraint {
  /** unique or primary key constraint on columns "id" */
  FormQuestionsPkey = 'formQuestions_pkey'
}

/** input type for incrementing numeric columns in table "formQuestions" */
export type FormQuestions_Inc_Input = {
  order?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "formQuestions" */
export type FormQuestions_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  form?: InputMaybe<Form_Obj_Rel_Insert_Input>;
  formAnswers?: InputMaybe<FormAnswers_Arr_Rel_Insert_Input>;
  formId?: InputMaybe<Scalars['uuid']['input']>;
  formQuestionOptions?: InputMaybe<FormQuestionOptions_Arr_Rel_Insert_Input>;
  formQuestionType?: InputMaybe<FormQuestionType_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['bigint']['input']>;
  questionType?: InputMaybe<FormQuestionType_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type FormQuestions_Max_Fields = {
  __typename?: 'formQuestions_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  formId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "formQuestions" */
export type FormQuestions_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  formId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type FormQuestions_Min_Fields = {
  __typename?: 'formQuestions_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  formId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "formQuestions" */
export type FormQuestions_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  formId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "formQuestions" */
export type FormQuestions_Mutation_Response = {
  __typename?: 'formQuestions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<FormQuestions>;
};

/** input type for inserting object relation for remote table "formQuestions" */
export type FormQuestions_Obj_Rel_Insert_Input = {
  data: FormQuestions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<FormQuestions_On_Conflict>;
};

/** on_conflict condition type for table "formQuestions" */
export type FormQuestions_On_Conflict = {
  constraint: FormQuestions_Constraint;
  update_columns?: Array<FormQuestions_Update_Column>;
  where?: InputMaybe<FormQuestions_Bool_Exp>;
};

/** Ordering options when selecting data from "formQuestions". */
export type FormQuestions_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  form?: InputMaybe<Form_Order_By>;
  formAnswers_aggregate?: InputMaybe<FormAnswers_Aggregate_Order_By>;
  formId?: InputMaybe<Order_By>;
  formQuestionOptions_aggregate?: InputMaybe<FormQuestionOptions_Aggregate_Order_By>;
  formQuestionType?: InputMaybe<FormQuestionType_Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  mandatory?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  questionType?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: formQuestions */
export type FormQuestions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "formQuestions" */
export enum FormQuestions_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  FormId = 'formId',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Mandatory = 'mandatory',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  QuestionType = 'questionType',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "formQuestions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "formQuestions" */
export enum FormQuestions_Select_Column_FormQuestions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Mandatory = 'mandatory'
}

/** select "formQuestions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "formQuestions" */
export enum FormQuestions_Select_Column_FormQuestions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Mandatory = 'mandatory'
}

/** input type for updating data in table "formQuestions" */
export type FormQuestions_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  formId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['bigint']['input']>;
  questionType?: InputMaybe<FormQuestionType_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type FormQuestions_Stddev_Fields = {
  __typename?: 'formQuestions_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "formQuestions" */
export type FormQuestions_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type FormQuestions_Stddev_Pop_Fields = {
  __typename?: 'formQuestions_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "formQuestions" */
export type FormQuestions_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type FormQuestions_Stddev_Samp_Fields = {
  __typename?: 'formQuestions_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "formQuestions" */
export type FormQuestions_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "formQuestions" */
export type FormQuestions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FormQuestions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FormQuestions_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  formId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['bigint']['input']>;
  questionType?: InputMaybe<FormQuestionType_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type FormQuestions_Sum_Fields = {
  __typename?: 'formQuestions_sum_fields';
  order?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "formQuestions" */
export type FormQuestions_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "formQuestions" */
export enum FormQuestions_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  FormId = 'formId',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Mandatory = 'mandatory',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  QuestionType = 'questionType',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type FormQuestions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<FormQuestions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FormQuestions_Set_Input>;
  /** filter the rows which have to be updated */
  where: FormQuestions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type FormQuestions_Var_Pop_Fields = {
  __typename?: 'formQuestions_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "formQuestions" */
export type FormQuestions_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type FormQuestions_Var_Samp_Fields = {
  __typename?: 'formQuestions_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "formQuestions" */
export type FormQuestions_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type FormQuestions_Variance_Fields = {
  __typename?: 'formQuestions_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "formQuestions" */
export type FormQuestions_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregated selection of "form" */
export type Form_Aggregate = {
  __typename?: 'form_aggregate';
  aggregate?: Maybe<Form_Aggregate_Fields>;
  nodes: Array<Form>;
};

export type Form_Aggregate_Bool_Exp = {
  count?: InputMaybe<Form_Aggregate_Bool_Exp_Count>;
};

export type Form_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Form_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Form_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "form" */
export type Form_Aggregate_Fields = {
  __typename?: 'form_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Form_Max_Fields>;
  min?: Maybe<Form_Min_Fields>;
};


/** aggregate fields of "form" */
export type Form_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Form_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "form" */
export type Form_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Form_Max_Order_By>;
  min?: InputMaybe<Form_Min_Order_By>;
};

/** input type for inserting array relation for remote table "form" */
export type Form_Arr_Rel_Insert_Input = {
  data: Array<Form_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Form_On_Conflict>;
};

/** Boolean expression to filter rows from the table "form". All fields are combined with a logical 'AND'. */
export type Form_Bool_Exp = {
  _and?: InputMaybe<Array<Form_Bool_Exp>>;
  _not?: InputMaybe<Form_Bool_Exp>;
  _or?: InputMaybe<Array<Form_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  formAnswers?: InputMaybe<FormAnswers_Bool_Exp>;
  formAnswers_aggregate?: InputMaybe<FormAnswers_Aggregate_Bool_Exp>;
  formQuestions?: InputMaybe<FormQuestions_Bool_Exp>;
  formQuestions_aggregate?: InputMaybe<FormQuestions_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  provider?: InputMaybe<Providers_Bool_Exp>;
  providerId?: InputMaybe<Uuid_Comparison_Exp>;
  servicesForms?: InputMaybe<ServicesForms_Bool_Exp>;
  servicesForms_aggregate?: InputMaybe<ServicesForms_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "form" */
export enum Form_Constraint {
  /** unique or primary key constraint on columns "id" */
  FormPkey = 'form_pkey'
}

/** input type for inserting data into table "form" */
export type Form_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  formAnswers?: InputMaybe<FormAnswers_Arr_Rel_Insert_Input>;
  formQuestions?: InputMaybe<FormQuestions_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Providers_Obj_Rel_Insert_Input>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  servicesForms?: InputMaybe<ServicesForms_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Form_Max_Fields = {
  __typename?: 'form_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "form" */
export type Form_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Form_Min_Fields = {
  __typename?: 'form_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "form" */
export type Form_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "form" */
export type Form_Mutation_Response = {
  __typename?: 'form_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Form>;
};

/** input type for inserting object relation for remote table "form" */
export type Form_Obj_Rel_Insert_Input = {
  data: Form_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Form_On_Conflict>;
};

/** on_conflict condition type for table "form" */
export type Form_On_Conflict = {
  constraint: Form_Constraint;
  update_columns?: Array<Form_Update_Column>;
  where?: InputMaybe<Form_Bool_Exp>;
};

/** Ordering options when selecting data from "form". */
export type Form_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  formAnswers_aggregate?: InputMaybe<FormAnswers_Aggregate_Order_By>;
  formQuestions_aggregate?: InputMaybe<FormQuestions_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  provider?: InputMaybe<Providers_Order_By>;
  providerId?: InputMaybe<Order_By>;
  servicesForms_aggregate?: InputMaybe<ServicesForms_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: form */
export type Form_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "form" */
export enum Form_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "form" */
export type Form_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "form" */
export type Form_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Form_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Form_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "form" */
export enum Form_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Form_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Form_Set_Input>;
  /** filter the rows which have to be updated */
  where: Form_Bool_Exp;
};

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']['input']>;
  _gt?: InputMaybe<Scalars['geography']['input']>;
  _gte?: InputMaybe<Scalars['geography']['input']>;
  _in?: InputMaybe<Array<Scalars['geography']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geography']['input']>;
  _lte?: InputMaybe<Scalars['geography']['input']>;
  _neq?: InputMaybe<Scalars['geography']['input']>;
  _nin?: InputMaybe<Array<Scalars['geography']['input']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']['input']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']['input']>;
  _gt?: InputMaybe<Scalars['geometry']['input']>;
  _gte?: InputMaybe<Scalars['geometry']['input']>;
  _in?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geometry']['input']>;
  _lte?: InputMaybe<Scalars['geometry']['input']>;
  _neq?: InputMaybe<Scalars['geometry']['input']>;
  _nin?: InputMaybe<Array<Scalars['geometry']['input']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']['input']>;
};

export type Get_Nearby_Locations_Args = {
  lat?: InputMaybe<Scalars['float8']['input']>;
  lon?: InputMaybe<Scalars['float8']['input']>;
  max_distance?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "jobStatus" */
export type JobStatus = {
  __typename?: 'jobStatus';
  /** An array relationship */
  appointments: Array<Appointments>;
  /** An aggregate relationship */
  appointments_aggregate: Appointments_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "jobStatus" */
export type JobStatusAppointmentsArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


/** columns and relationships of "jobStatus" */
export type JobStatusAppointments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};

/** aggregated selection of "jobStatus" */
export type JobStatus_Aggregate = {
  __typename?: 'jobStatus_aggregate';
  aggregate?: Maybe<JobStatus_Aggregate_Fields>;
  nodes: Array<JobStatus>;
};

/** aggregate fields of "jobStatus" */
export type JobStatus_Aggregate_Fields = {
  __typename?: 'jobStatus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<JobStatus_Max_Fields>;
  min?: Maybe<JobStatus_Min_Fields>;
};


/** aggregate fields of "jobStatus" */
export type JobStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<JobStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "jobStatus". All fields are combined with a logical 'AND'. */
export type JobStatus_Bool_Exp = {
  _and?: InputMaybe<Array<JobStatus_Bool_Exp>>;
  _not?: InputMaybe<JobStatus_Bool_Exp>;
  _or?: InputMaybe<Array<JobStatus_Bool_Exp>>;
  appointments?: InputMaybe<Appointments_Bool_Exp>;
  appointments_aggregate?: InputMaybe<Appointments_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "jobStatus" */
export enum JobStatus_Constraint {
  /** unique or primary key constraint on columns "value" */
  JobStatusPkey = 'jobStatus_pkey'
}

export enum JobStatus_Enum {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Draft = 'draft',
  Partial = 'partial',
  Pending = 'pending',
  Rejected = 'rejected',
  Scheduled = 'scheduled'
}

/** Boolean expression to compare columns of type "jobStatus_enum". All fields are combined with logical 'AND'. */
export type JobStatus_Enum_Comparison_Exp = {
  _eq?: InputMaybe<JobStatus_Enum>;
  _in?: InputMaybe<Array<JobStatus_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<JobStatus_Enum>;
  _nin?: InputMaybe<Array<JobStatus_Enum>>;
};

/** input type for inserting data into table "jobStatus" */
export type JobStatus_Insert_Input = {
  appointments?: InputMaybe<Appointments_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type JobStatus_Max_Fields = {
  __typename?: 'jobStatus_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type JobStatus_Min_Fields = {
  __typename?: 'jobStatus_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "jobStatus" */
export type JobStatus_Mutation_Response = {
  __typename?: 'jobStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<JobStatus>;
};

/** input type for inserting object relation for remote table "jobStatus" */
export type JobStatus_Obj_Rel_Insert_Input = {
  data: JobStatus_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<JobStatus_On_Conflict>;
};

/** on_conflict condition type for table "jobStatus" */
export type JobStatus_On_Conflict = {
  constraint: JobStatus_Constraint;
  update_columns?: Array<JobStatus_Update_Column>;
  where?: InputMaybe<JobStatus_Bool_Exp>;
};

/** Ordering options when selecting data from "jobStatus". */
export type JobStatus_Order_By = {
  appointments_aggregate?: InputMaybe<Appointments_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: jobStatus */
export type JobStatus_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "jobStatus" */
export enum JobStatus_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "jobStatus" */
export type JobStatus_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "jobStatus" */
export type JobStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: JobStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type JobStatus_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "jobStatus" */
export enum JobStatus_Update_Column {
  /** column name */
  Value = 'value'
}

export type JobStatus_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobStatus_Set_Input>;
  /** filter the rows which have to be updated */
  where: JobStatus_Bool_Exp;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "locale" */
export type Locale = {
  __typename?: 'locale';
  value: Scalars['String']['output'];
};

/** aggregated selection of "locale" */
export type Locale_Aggregate = {
  __typename?: 'locale_aggregate';
  aggregate?: Maybe<Locale_Aggregate_Fields>;
  nodes: Array<Locale>;
};

/** aggregate fields of "locale" */
export type Locale_Aggregate_Fields = {
  __typename?: 'locale_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Locale_Max_Fields>;
  min?: Maybe<Locale_Min_Fields>;
};


/** aggregate fields of "locale" */
export type Locale_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Locale_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "locale". All fields are combined with a logical 'AND'. */
export type Locale_Bool_Exp = {
  _and?: InputMaybe<Array<Locale_Bool_Exp>>;
  _not?: InputMaybe<Locale_Bool_Exp>;
  _or?: InputMaybe<Array<Locale_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "locale" */
export enum Locale_Constraint {
  /** unique or primary key constraint on columns "value" */
  LocalePkey = 'locale_pkey'
}

export enum Locale_Enum {
  En = 'en',
  Fr = 'fr'
}

/** Boolean expression to compare columns of type "locale_enum". All fields are combined with logical 'AND'. */
export type Locale_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Locale_Enum>;
  _in?: InputMaybe<Array<Locale_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Locale_Enum>;
  _nin?: InputMaybe<Array<Locale_Enum>>;
};

/** input type for inserting data into table "locale" */
export type Locale_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Locale_Max_Fields = {
  __typename?: 'locale_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Locale_Min_Fields = {
  __typename?: 'locale_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "locale" */
export type Locale_Mutation_Response = {
  __typename?: 'locale_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Locale>;
};

/** on_conflict condition type for table "locale" */
export type Locale_On_Conflict = {
  constraint: Locale_Constraint;
  update_columns?: Array<Locale_Update_Column>;
  where?: InputMaybe<Locale_Bool_Exp>;
};

/** Ordering options when selecting data from "locale". */
export type Locale_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: locale */
export type Locale_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "locale" */
export enum Locale_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "locale" */
export type Locale_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "locale" */
export type Locale_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locale_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locale_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "locale" */
export enum Locale_Update_Column {
  /** column name */
  Value = 'value'
}

export type Locale_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Locale_Set_Input>;
  /** filter the rows which have to be updated */
  where: Locale_Bool_Exp;
};

/** columns and relationships of "locationStatus" */
export type LocationStatus = {
  __typename?: 'locationStatus';
  /** An array relationship */
  locations: Array<Locations>;
  /** An aggregate relationship */
  locations_aggregate: Locations_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "locationStatus" */
export type LocationStatusLocationsArgs = {
  distinct_on?: InputMaybe<Array<Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locations_Order_By>>;
  where?: InputMaybe<Locations_Bool_Exp>;
};


/** columns and relationships of "locationStatus" */
export type LocationStatusLocations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locations_Order_By>>;
  where?: InputMaybe<Locations_Bool_Exp>;
};

/** aggregated selection of "locationStatus" */
export type LocationStatus_Aggregate = {
  __typename?: 'locationStatus_aggregate';
  aggregate?: Maybe<LocationStatus_Aggregate_Fields>;
  nodes: Array<LocationStatus>;
};

/** aggregate fields of "locationStatus" */
export type LocationStatus_Aggregate_Fields = {
  __typename?: 'locationStatus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<LocationStatus_Max_Fields>;
  min?: Maybe<LocationStatus_Min_Fields>;
};


/** aggregate fields of "locationStatus" */
export type LocationStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<LocationStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "locationStatus". All fields are combined with a logical 'AND'. */
export type LocationStatus_Bool_Exp = {
  _and?: InputMaybe<Array<LocationStatus_Bool_Exp>>;
  _not?: InputMaybe<LocationStatus_Bool_Exp>;
  _or?: InputMaybe<Array<LocationStatus_Bool_Exp>>;
  locations?: InputMaybe<Locations_Bool_Exp>;
  locations_aggregate?: InputMaybe<Locations_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "locationStatus" */
export enum LocationStatus_Constraint {
  /** unique or primary key constraint on columns "value" */
  LocationStatusPkey = 'locationStatus_pkey'
}

export enum LocationStatus_Enum {
  Active = 'active',
  Disabled = 'disabled',
  Pending = 'pending'
}

/** Boolean expression to compare columns of type "locationStatus_enum". All fields are combined with logical 'AND'. */
export type LocationStatus_Enum_Comparison_Exp = {
  _eq?: InputMaybe<LocationStatus_Enum>;
  _in?: InputMaybe<Array<LocationStatus_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<LocationStatus_Enum>;
  _nin?: InputMaybe<Array<LocationStatus_Enum>>;
};

/** input type for inserting data into table "locationStatus" */
export type LocationStatus_Insert_Input = {
  locations?: InputMaybe<Locations_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type LocationStatus_Max_Fields = {
  __typename?: 'locationStatus_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type LocationStatus_Min_Fields = {
  __typename?: 'locationStatus_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "locationStatus" */
export type LocationStatus_Mutation_Response = {
  __typename?: 'locationStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<LocationStatus>;
};

/** input type for inserting object relation for remote table "locationStatus" */
export type LocationStatus_Obj_Rel_Insert_Input = {
  data: LocationStatus_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<LocationStatus_On_Conflict>;
};

/** on_conflict condition type for table "locationStatus" */
export type LocationStatus_On_Conflict = {
  constraint: LocationStatus_Constraint;
  update_columns?: Array<LocationStatus_Update_Column>;
  where?: InputMaybe<LocationStatus_Bool_Exp>;
};

/** Ordering options when selecting data from "locationStatus". */
export type LocationStatus_Order_By = {
  locations_aggregate?: InputMaybe<Locations_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: locationStatus */
export type LocationStatus_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "locationStatus" */
export enum LocationStatus_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "locationStatus" */
export type LocationStatus_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "locationStatus" */
export type LocationStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: LocationStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type LocationStatus_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "locationStatus" */
export enum LocationStatus_Update_Column {
  /** column name */
  Value = 'value'
}

export type LocationStatus_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LocationStatus_Set_Input>;
  /** filter the rows which have to be updated */
  where: LocationStatus_Bool_Exp;
};

/** columns and relationships of "locationType" */
export type LocationType = {
  __typename?: 'locationType';
  /** An array relationship */
  locations: Array<Locations>;
  /** An aggregate relationship */
  locations_aggregate: Locations_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "locationType" */
export type LocationTypeLocationsArgs = {
  distinct_on?: InputMaybe<Array<Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locations_Order_By>>;
  where?: InputMaybe<Locations_Bool_Exp>;
};


/** columns and relationships of "locationType" */
export type LocationTypeLocations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locations_Order_By>>;
  where?: InputMaybe<Locations_Bool_Exp>;
};

/** aggregated selection of "locationType" */
export type LocationType_Aggregate = {
  __typename?: 'locationType_aggregate';
  aggregate?: Maybe<LocationType_Aggregate_Fields>;
  nodes: Array<LocationType>;
};

/** aggregate fields of "locationType" */
export type LocationType_Aggregate_Fields = {
  __typename?: 'locationType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<LocationType_Max_Fields>;
  min?: Maybe<LocationType_Min_Fields>;
};


/** aggregate fields of "locationType" */
export type LocationType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<LocationType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "locationType". All fields are combined with a logical 'AND'. */
export type LocationType_Bool_Exp = {
  _and?: InputMaybe<Array<LocationType_Bool_Exp>>;
  _not?: InputMaybe<LocationType_Bool_Exp>;
  _or?: InputMaybe<Array<LocationType_Bool_Exp>>;
  locations?: InputMaybe<Locations_Bool_Exp>;
  locations_aggregate?: InputMaybe<Locations_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "locationType" */
export enum LocationType_Constraint {
  /** unique or primary key constraint on columns "value" */
  LocationTypePkey = 'locationType_pkey'
}

export enum LocationType_Enum {
  Commercial = 'commercial',
  HomeRadius = 'home_radius'
}

/** Boolean expression to compare columns of type "locationType_enum". All fields are combined with logical 'AND'. */
export type LocationType_Enum_Comparison_Exp = {
  _eq?: InputMaybe<LocationType_Enum>;
  _in?: InputMaybe<Array<LocationType_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<LocationType_Enum>;
  _nin?: InputMaybe<Array<LocationType_Enum>>;
};

/** input type for inserting data into table "locationType" */
export type LocationType_Insert_Input = {
  locations?: InputMaybe<Locations_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type LocationType_Max_Fields = {
  __typename?: 'locationType_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type LocationType_Min_Fields = {
  __typename?: 'locationType_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "locationType" */
export type LocationType_Mutation_Response = {
  __typename?: 'locationType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<LocationType>;
};

/** input type for inserting object relation for remote table "locationType" */
export type LocationType_Obj_Rel_Insert_Input = {
  data: LocationType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<LocationType_On_Conflict>;
};

/** on_conflict condition type for table "locationType" */
export type LocationType_On_Conflict = {
  constraint: LocationType_Constraint;
  update_columns?: Array<LocationType_Update_Column>;
  where?: InputMaybe<LocationType_Bool_Exp>;
};

/** Ordering options when selecting data from "locationType". */
export type LocationType_Order_By = {
  locations_aggregate?: InputMaybe<Locations_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: locationType */
export type LocationType_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "locationType" */
export enum LocationType_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "locationType" */
export type LocationType_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "locationType" */
export type LocationType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: LocationType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type LocationType_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "locationType" */
export enum LocationType_Update_Column {
  /** column name */
  Value = 'value'
}

export type LocationType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LocationType_Set_Input>;
  /** filter the rows which have to be updated */
  where: LocationType_Bool_Exp;
};

/** columns and relationships of "locations" */
export type Locations = {
  __typename?: 'locations';
  additionalCities?: Maybe<Array<Scalars['String']['output']>>;
  address: Scalars['String']['output'];
  /** An array relationship */
  appointments: Array<Appointments>;
  /** An aggregate relationship */
  appointments_aggregate: Appointments_Aggregate;
  /** An object relationship */
  buildingManager?: Maybe<Users>;
  buildingManagerId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  buildingProviders: Array<BuildingProviders>;
  /** An aggregate relationship */
  buildingProviders_aggregate: BuildingProviders_Aggregate;
  buildingType?: Maybe<BuildingType_Enum>;
  /** An object relationship */
  buildingTypeByBuildingtype?: Maybe<BuildingType>;
  coordinates: Scalars['geography']['output'];
  createdAt: Scalars['timestamptz']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  excludedCities?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  locationStatus: LocationStatus;
  /** An object relationship */
  locationType: LocationType;
  name: Scalars['String']['output'];
  partnershipDefaultStatus?: Maybe<PartnershipStatus_Enum>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  provider?: Maybe<Providers>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  /** In Kilometers */
  radius?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  schedules: Array<Schedule>;
  /** An aggregate relationship */
  schedules_aggregate: Schedule_Aggregate;
  status: LocationStatus_Enum;
  /** An array relationship */
  timeouts: Array<Timeouts>;
  /** An aggregate relationship */
  timeouts_aggregate: Timeouts_Aggregate;
  transitionStatus?: Maybe<TransitionStatus_Enum>;
  type: LocationType_Enum;
  /** An array relationship */
  unavailableServiceLocations: Array<UnavailableServiceLocations>;
  /** An aggregate relationship */
  unavailableServiceLocations_aggregate: UnavailableServiceLocations_Aggregate;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "locations" */
export type LocationsAppointmentsArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


/** columns and relationships of "locations" */
export type LocationsAppointments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


/** columns and relationships of "locations" */
export type LocationsBuildingProvidersArgs = {
  distinct_on?: InputMaybe<Array<BuildingProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingProviders_Order_By>>;
  where?: InputMaybe<BuildingProviders_Bool_Exp>;
};


/** columns and relationships of "locations" */
export type LocationsBuildingProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuildingProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingProviders_Order_By>>;
  where?: InputMaybe<BuildingProviders_Bool_Exp>;
};


/** columns and relationships of "locations" */
export type LocationsSchedulesArgs = {
  distinct_on?: InputMaybe<Array<Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Schedule_Order_By>>;
  where?: InputMaybe<Schedule_Bool_Exp>;
};


/** columns and relationships of "locations" */
export type LocationsSchedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Schedule_Order_By>>;
  where?: InputMaybe<Schedule_Bool_Exp>;
};


/** columns and relationships of "locations" */
export type LocationsTimeoutsArgs = {
  distinct_on?: InputMaybe<Array<Timeouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Timeouts_Order_By>>;
  where?: InputMaybe<Timeouts_Bool_Exp>;
};


/** columns and relationships of "locations" */
export type LocationsTimeouts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Timeouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Timeouts_Order_By>>;
  where?: InputMaybe<Timeouts_Bool_Exp>;
};


/** columns and relationships of "locations" */
export type LocationsUnavailableServiceLocationsArgs = {
  distinct_on?: InputMaybe<Array<UnavailableServiceLocations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnavailableServiceLocations_Order_By>>;
  where?: InputMaybe<UnavailableServiceLocations_Bool_Exp>;
};


/** columns and relationships of "locations" */
export type LocationsUnavailableServiceLocations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UnavailableServiceLocations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnavailableServiceLocations_Order_By>>;
  where?: InputMaybe<UnavailableServiceLocations_Bool_Exp>;
};

/** aggregated selection of "locations" */
export type Locations_Aggregate = {
  __typename?: 'locations_aggregate';
  aggregate?: Maybe<Locations_Aggregate_Fields>;
  nodes: Array<Locations>;
};

export type Locations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Locations_Aggregate_Bool_Exp_Count>;
};

export type Locations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Locations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Locations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "locations" */
export type Locations_Aggregate_Fields = {
  __typename?: 'locations_aggregate_fields';
  avg?: Maybe<Locations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Locations_Max_Fields>;
  min?: Maybe<Locations_Min_Fields>;
  stddev?: Maybe<Locations_Stddev_Fields>;
  stddev_pop?: Maybe<Locations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Locations_Stddev_Samp_Fields>;
  sum?: Maybe<Locations_Sum_Fields>;
  var_pop?: Maybe<Locations_Var_Pop_Fields>;
  var_samp?: Maybe<Locations_Var_Samp_Fields>;
  variance?: Maybe<Locations_Variance_Fields>;
};


/** aggregate fields of "locations" */
export type Locations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Locations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "locations" */
export type Locations_Aggregate_Order_By = {
  avg?: InputMaybe<Locations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Locations_Max_Order_By>;
  min?: InputMaybe<Locations_Min_Order_By>;
  stddev?: InputMaybe<Locations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Locations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Locations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Locations_Sum_Order_By>;
  var_pop?: InputMaybe<Locations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Locations_Var_Samp_Order_By>;
  variance?: InputMaybe<Locations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "locations" */
export type Locations_Arr_Rel_Insert_Input = {
  data: Array<Locations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Locations_On_Conflict>;
};

/** aggregate avg on columns */
export type Locations_Avg_Fields = {
  __typename?: 'locations_avg_fields';
  /** In Kilometers */
  radius?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "locations" */
export type Locations_Avg_Order_By = {
  /** In Kilometers */
  radius?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "locations". All fields are combined with a logical 'AND'. */
export type Locations_Bool_Exp = {
  _and?: InputMaybe<Array<Locations_Bool_Exp>>;
  _not?: InputMaybe<Locations_Bool_Exp>;
  _or?: InputMaybe<Array<Locations_Bool_Exp>>;
  additionalCities?: InputMaybe<String_Array_Comparison_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  appointments?: InputMaybe<Appointments_Bool_Exp>;
  appointments_aggregate?: InputMaybe<Appointments_Aggregate_Bool_Exp>;
  buildingManager?: InputMaybe<Users_Bool_Exp>;
  buildingManagerId?: InputMaybe<Uuid_Comparison_Exp>;
  buildingProviders?: InputMaybe<BuildingProviders_Bool_Exp>;
  buildingProviders_aggregate?: InputMaybe<BuildingProviders_Aggregate_Bool_Exp>;
  buildingType?: InputMaybe<BuildingType_Enum_Comparison_Exp>;
  buildingTypeByBuildingtype?: InputMaybe<BuildingType_Bool_Exp>;
  coordinates?: InputMaybe<Geography_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  excludedCities?: InputMaybe<String_Array_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  locationStatus?: InputMaybe<LocationStatus_Bool_Exp>;
  locationType?: InputMaybe<LocationType_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  partnershipDefaultStatus?: InputMaybe<PartnershipStatus_Enum_Comparison_Exp>;
  phoneNumber?: InputMaybe<String_Comparison_Exp>;
  provider?: InputMaybe<Providers_Bool_Exp>;
  providerId?: InputMaybe<Uuid_Comparison_Exp>;
  radius?: InputMaybe<Numeric_Comparison_Exp>;
  schedules?: InputMaybe<Schedule_Bool_Exp>;
  schedules_aggregate?: InputMaybe<Schedule_Aggregate_Bool_Exp>;
  status?: InputMaybe<LocationStatus_Enum_Comparison_Exp>;
  timeouts?: InputMaybe<Timeouts_Bool_Exp>;
  timeouts_aggregate?: InputMaybe<Timeouts_Aggregate_Bool_Exp>;
  transitionStatus?: InputMaybe<TransitionStatus_Enum_Comparison_Exp>;
  type?: InputMaybe<LocationType_Enum_Comparison_Exp>;
  unavailableServiceLocations?: InputMaybe<UnavailableServiceLocations_Bool_Exp>;
  unavailableServiceLocations_aggregate?: InputMaybe<UnavailableServiceLocations_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "locations" */
export enum Locations_Constraint {
  /** unique or primary key constraint on columns "buildingManagerId" */
  LocationsBuildingManagerIdKey = 'locations_buildingManagerId_key',
  /** unique or primary key constraint on columns "id" */
  LocationsPkey = 'locations_pkey',
  /** unique or primary key constraint on columns "address" */
  UniqueCommercialActiveAddress = 'unique_commercial_active_address',
  /** unique or primary key constraint on columns "coordinates" */
  UniqueCommercialActiveCoordinates = 'unique_commercial_active_coordinates'
}

/** input type for incrementing numeric columns in table "locations" */
export type Locations_Inc_Input = {
  /** In Kilometers */
  radius?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "locations" */
export type Locations_Insert_Input = {
  additionalCities?: InputMaybe<Array<Scalars['String']['input']>>;
  address?: InputMaybe<Scalars['String']['input']>;
  appointments?: InputMaybe<Appointments_Arr_Rel_Insert_Input>;
  buildingManager?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  buildingManagerId?: InputMaybe<Scalars['uuid']['input']>;
  buildingProviders?: InputMaybe<BuildingProviders_Arr_Rel_Insert_Input>;
  buildingType?: InputMaybe<BuildingType_Enum>;
  buildingTypeByBuildingtype?: InputMaybe<BuildingType_Obj_Rel_Insert_Input>;
  coordinates?: InputMaybe<Scalars['geography']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  excludedCities?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  locationStatus?: InputMaybe<LocationStatus_Obj_Rel_Insert_Input>;
  locationType?: InputMaybe<LocationType_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnershipDefaultStatus?: InputMaybe<PartnershipStatus_Enum>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Providers_Obj_Rel_Insert_Input>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  /** In Kilometers */
  radius?: InputMaybe<Scalars['numeric']['input']>;
  schedules?: InputMaybe<Schedule_Arr_Rel_Insert_Input>;
  status?: InputMaybe<LocationStatus_Enum>;
  timeouts?: InputMaybe<Timeouts_Arr_Rel_Insert_Input>;
  transitionStatus?: InputMaybe<TransitionStatus_Enum>;
  type?: InputMaybe<LocationType_Enum>;
  unavailableServiceLocations?: InputMaybe<UnavailableServiceLocations_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Locations_Max_Fields = {
  __typename?: 'locations_max_fields';
  additionalCities?: Maybe<Array<Scalars['String']['output']>>;
  address?: Maybe<Scalars['String']['output']>;
  buildingManagerId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  excludedCities?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  /** In Kilometers */
  radius?: Maybe<Scalars['numeric']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "locations" */
export type Locations_Max_Order_By = {
  additionalCities?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  buildingManagerId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  excludedCities?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  /** In Kilometers */
  radius?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Locations_Min_Fields = {
  __typename?: 'locations_min_fields';
  additionalCities?: Maybe<Array<Scalars['String']['output']>>;
  address?: Maybe<Scalars['String']['output']>;
  buildingManagerId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  excludedCities?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  /** In Kilometers */
  radius?: Maybe<Scalars['numeric']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "locations" */
export type Locations_Min_Order_By = {
  additionalCities?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  buildingManagerId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  excludedCities?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  /** In Kilometers */
  radius?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "locations" */
export type Locations_Mutation_Response = {
  __typename?: 'locations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Locations>;
};

/** input type for inserting object relation for remote table "locations" */
export type Locations_Obj_Rel_Insert_Input = {
  data: Locations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Locations_On_Conflict>;
};

/** on_conflict condition type for table "locations" */
export type Locations_On_Conflict = {
  constraint: Locations_Constraint;
  update_columns?: Array<Locations_Update_Column>;
  where?: InputMaybe<Locations_Bool_Exp>;
};

/** Ordering options when selecting data from "locations". */
export type Locations_Order_By = {
  additionalCities?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  appointments_aggregate?: InputMaybe<Appointments_Aggregate_Order_By>;
  buildingManager?: InputMaybe<Users_Order_By>;
  buildingManagerId?: InputMaybe<Order_By>;
  buildingProviders_aggregate?: InputMaybe<BuildingProviders_Aggregate_Order_By>;
  buildingType?: InputMaybe<Order_By>;
  buildingTypeByBuildingtype?: InputMaybe<BuildingType_Order_By>;
  coordinates?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  excludedCities?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locationStatus?: InputMaybe<LocationStatus_Order_By>;
  locationType?: InputMaybe<LocationType_Order_By>;
  name?: InputMaybe<Order_By>;
  partnershipDefaultStatus?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  provider?: InputMaybe<Providers_Order_By>;
  providerId?: InputMaybe<Order_By>;
  radius?: InputMaybe<Order_By>;
  schedules_aggregate?: InputMaybe<Schedule_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  timeouts_aggregate?: InputMaybe<Timeouts_Aggregate_Order_By>;
  transitionStatus?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unavailableServiceLocations_aggregate?: InputMaybe<UnavailableServiceLocations_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: locations */
export type Locations_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "locations" */
export enum Locations_Select_Column {
  /** column name */
  AdditionalCities = 'additionalCities',
  /** column name */
  Address = 'address',
  /** column name */
  BuildingManagerId = 'buildingManagerId',
  /** column name */
  BuildingType = 'buildingType',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  ExcludedCities = 'excludedCities',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PartnershipDefaultStatus = 'partnershipDefaultStatus',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  Radius = 'radius',
  /** column name */
  Status = 'status',
  /** column name */
  TransitionStatus = 'transitionStatus',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "locations" */
export type Locations_Set_Input = {
  additionalCities?: InputMaybe<Array<Scalars['String']['input']>>;
  address?: InputMaybe<Scalars['String']['input']>;
  buildingManagerId?: InputMaybe<Scalars['uuid']['input']>;
  buildingType?: InputMaybe<BuildingType_Enum>;
  coordinates?: InputMaybe<Scalars['geography']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  excludedCities?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnershipDefaultStatus?: InputMaybe<PartnershipStatus_Enum>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  /** In Kilometers */
  radius?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<LocationStatus_Enum>;
  transitionStatus?: InputMaybe<TransitionStatus_Enum>;
  type?: InputMaybe<LocationType_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Locations_Stddev_Fields = {
  __typename?: 'locations_stddev_fields';
  /** In Kilometers */
  radius?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "locations" */
export type Locations_Stddev_Order_By = {
  /** In Kilometers */
  radius?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Locations_Stddev_Pop_Fields = {
  __typename?: 'locations_stddev_pop_fields';
  /** In Kilometers */
  radius?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "locations" */
export type Locations_Stddev_Pop_Order_By = {
  /** In Kilometers */
  radius?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Locations_Stddev_Samp_Fields = {
  __typename?: 'locations_stddev_samp_fields';
  /** In Kilometers */
  radius?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "locations" */
export type Locations_Stddev_Samp_Order_By = {
  /** In Kilometers */
  radius?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "locations" */
export type Locations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locations_Stream_Cursor_Value_Input = {
  additionalCities?: InputMaybe<Array<Scalars['String']['input']>>;
  address?: InputMaybe<Scalars['String']['input']>;
  buildingManagerId?: InputMaybe<Scalars['uuid']['input']>;
  buildingType?: InputMaybe<BuildingType_Enum>;
  coordinates?: InputMaybe<Scalars['geography']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  excludedCities?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnershipDefaultStatus?: InputMaybe<PartnershipStatus_Enum>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  /** In Kilometers */
  radius?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<LocationStatus_Enum>;
  transitionStatus?: InputMaybe<TransitionStatus_Enum>;
  type?: InputMaybe<LocationType_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Locations_Sum_Fields = {
  __typename?: 'locations_sum_fields';
  /** In Kilometers */
  radius?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "locations" */
export type Locations_Sum_Order_By = {
  /** In Kilometers */
  radius?: InputMaybe<Order_By>;
};

/** update columns of table "locations" */
export enum Locations_Update_Column {
  /** column name */
  AdditionalCities = 'additionalCities',
  /** column name */
  Address = 'address',
  /** column name */
  BuildingManagerId = 'buildingManagerId',
  /** column name */
  BuildingType = 'buildingType',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  ExcludedCities = 'excludedCities',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PartnershipDefaultStatus = 'partnershipDefaultStatus',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  Radius = 'radius',
  /** column name */
  Status = 'status',
  /** column name */
  TransitionStatus = 'transitionStatus',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Locations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Locations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Locations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Locations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Locations_Var_Pop_Fields = {
  __typename?: 'locations_var_pop_fields';
  /** In Kilometers */
  radius?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "locations" */
export type Locations_Var_Pop_Order_By = {
  /** In Kilometers */
  radius?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Locations_Var_Samp_Fields = {
  __typename?: 'locations_var_samp_fields';
  /** In Kilometers */
  radius?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "locations" */
export type Locations_Var_Samp_Order_By = {
  /** In Kilometers */
  radius?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Locations_Variance_Fields = {
  __typename?: 'locations_variance_fields';
  /** In Kilometers */
  radius?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "locations" */
export type Locations_Variance_Order_By = {
  /** In Kilometers */
  radius?: InputMaybe<Order_By>;
};

/** columns and relationships of "locations_with_distance" */
export type Locations_With_Distance = {
  __typename?: 'locations_with_distance';
  address?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<Scalars['geography']['output']>;
  distance?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  radius?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  schedules: Array<Schedule>;
  /** An aggregate relationship */
  schedules_aggregate: Schedule_Aggregate;
  type?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "locations_with_distance" */
export type Locations_With_DistanceSchedulesArgs = {
  distinct_on?: InputMaybe<Array<Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Schedule_Order_By>>;
  where?: InputMaybe<Schedule_Bool_Exp>;
};


/** columns and relationships of "locations_with_distance" */
export type Locations_With_DistanceSchedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Schedule_Order_By>>;
  where?: InputMaybe<Schedule_Bool_Exp>;
};

export type Locations_With_Distance_Aggregate = {
  __typename?: 'locations_with_distance_aggregate';
  aggregate?: Maybe<Locations_With_Distance_Aggregate_Fields>;
  nodes: Array<Locations_With_Distance>;
};

/** aggregate fields of "locations_with_distance" */
export type Locations_With_Distance_Aggregate_Fields = {
  __typename?: 'locations_with_distance_aggregate_fields';
  avg?: Maybe<Locations_With_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Locations_With_Distance_Max_Fields>;
  min?: Maybe<Locations_With_Distance_Min_Fields>;
  stddev?: Maybe<Locations_With_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<Locations_With_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Locations_With_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<Locations_With_Distance_Sum_Fields>;
  var_pop?: Maybe<Locations_With_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<Locations_With_Distance_Var_Samp_Fields>;
  variance?: Maybe<Locations_With_Distance_Variance_Fields>;
};


/** aggregate fields of "locations_with_distance" */
export type Locations_With_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Locations_With_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Locations_With_Distance_Avg_Fields = {
  __typename?: 'locations_with_distance_avg_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "locations_with_distance". All fields are combined with a logical 'AND'. */
export type Locations_With_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<Locations_With_Distance_Bool_Exp>>;
  _not?: InputMaybe<Locations_With_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<Locations_With_Distance_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  coordinates?: InputMaybe<Geography_Comparison_Exp>;
  distance?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  radius?: InputMaybe<Numeric_Comparison_Exp>;
  schedules?: InputMaybe<Schedule_Bool_Exp>;
  schedules_aggregate?: InputMaybe<Schedule_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "locations_with_distance" */
export type Locations_With_Distance_Inc_Input = {
  distance?: InputMaybe<Scalars['float8']['input']>;
  radius?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "locations_with_distance" */
export type Locations_With_Distance_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<Scalars['geography']['input']>;
  distance?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['numeric']['input']>;
  schedules?: InputMaybe<Schedule_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Locations_With_Distance_Max_Fields = {
  __typename?: 'locations_with_distance_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  radius?: Maybe<Scalars['numeric']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Locations_With_Distance_Min_Fields = {
  __typename?: 'locations_with_distance_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  radius?: Maybe<Scalars['numeric']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "locations_with_distance" */
export type Locations_With_Distance_Mutation_Response = {
  __typename?: 'locations_with_distance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Locations_With_Distance>;
};

/** Ordering options when selecting data from "locations_with_distance". */
export type Locations_With_Distance_Order_By = {
  address?: InputMaybe<Order_By>;
  coordinates?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  radius?: InputMaybe<Order_By>;
  schedules_aggregate?: InputMaybe<Schedule_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "locations_with_distance" */
export enum Locations_With_Distance_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Distance = 'distance',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Radius = 'radius',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "locations_with_distance" */
export type Locations_With_Distance_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<Scalars['geography']['input']>;
  distance?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Locations_With_Distance_Stddev_Fields = {
  __typename?: 'locations_with_distance_stddev_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Locations_With_Distance_Stddev_Pop_Fields = {
  __typename?: 'locations_with_distance_stddev_pop_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Locations_With_Distance_Stddev_Samp_Fields = {
  __typename?: 'locations_with_distance_stddev_samp_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "locations_with_distance" */
export type Locations_With_Distance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locations_With_Distance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locations_With_Distance_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<Scalars['geography']['input']>;
  distance?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Locations_With_Distance_Sum_Fields = {
  __typename?: 'locations_with_distance_sum_fields';
  distance?: Maybe<Scalars['float8']['output']>;
  radius?: Maybe<Scalars['numeric']['output']>;
};

export type Locations_With_Distance_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Locations_With_Distance_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Locations_With_Distance_Set_Input>;
  /** filter the rows which have to be updated */
  where: Locations_With_Distance_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Locations_With_Distance_Var_Pop_Fields = {
  __typename?: 'locations_with_distance_var_pop_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Locations_With_Distance_Var_Samp_Fields = {
  __typename?: 'locations_with_distance_var_samp_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Locations_With_Distance_Variance_Fields = {
  __typename?: 'locations_with_distance_variance_fields';
  distance?: Maybe<Scalars['Float']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  ApproveAppointment: Appointment;
  SPMarkAppointmentCompleted: Appointment;
  SPMarkAppointmentPartial: Appointment;
  SPMarkAppointmentScheduled: Appointment;
  SpRefundPayment: Appointment;
  SpUpdateApptPaymentStatus: Appointment;
  cancelCheckoutSession: Scalars['String']['output'];
  cancelRejectAppointment: Appointment;
  changePassword: Scalars['String']['output'];
  clearEmployeeCalendar: Scalars['Boolean']['output'];
  createAppointmentAnonymous: CreateApptUser;
  createAppointmentBM: CreateApptBm;
  createAppointmentPaymentIntent: CreateAppointmentPaymentIntentDto;
  createAppointmentPaymentIntentAnonymous: CreateAppointmentPaymentIntentDto;
  createAppointmentPaymentIntentUser: CreateAppointmentPaymentIntentDto;
  createAppointmentSP: CreateApptSp;
  createAppointmentUser: CreateApptUser;
  createBookedAppointmentPaymentIntent: CreateBookedAppointmentPaymentIntentDto;
  createConnectedAccount: AccountLinkDto;
  createCustomer: Customer;
  createCustomerSetupIntent: SetupCustomerIntentDto;
  createEmployee: CreateEmployeeDto;
  createMonthlySpPayments: Scalars['Boolean']['output'];
  createPayment: Array<Payment>;
  createProviderSetupIntent: SetupIntentDto;
  createUserSetupIntent: SetupIntentDto;
  deleteCustomerPaymentMethod: DeleteCustomerPaymentMethodDto;
  deleteFile: DeleteFileDto;
  deleteProviderPaymentMethod: DeletePaymentMethodDto;
  deleteUserPaymentMethod: DeletePaymentMethodDto;
  /** delete data from the table: "appointmentPricing" */
  delete_appointmentPricing?: Maybe<AppointmentPricing_Mutation_Response>;
  /** delete single row from the table: "appointmentPricing" */
  delete_appointmentPricing_by_pk?: Maybe<AppointmentPricing>;
  /** delete data from the table: "appointments" */
  delete_appointments?: Maybe<Appointments_Mutation_Response>;
  /** delete single row from the table: "appointments" */
  delete_appointments_by_pk?: Maybe<Appointments>;
  /** delete data from the table: "bookingStatus" */
  delete_bookingStatus?: Maybe<BookingStatus_Mutation_Response>;
  /** delete single row from the table: "bookingStatus" */
  delete_bookingStatus_by_pk?: Maybe<BookingStatus>;
  /** delete data from the table: "buildingProviders" */
  delete_buildingProviders?: Maybe<BuildingProviders_Mutation_Response>;
  /** delete single row from the table: "buildingProviders" */
  delete_buildingProviders_by_pk?: Maybe<BuildingProviders>;
  /** delete data from the table: "buildingType" */
  delete_buildingType?: Maybe<BuildingType_Mutation_Response>;
  /** delete single row from the table: "buildingType" */
  delete_buildingType_by_pk?: Maybe<BuildingType>;
  /** delete data from the table: "checkoutSessions" */
  delete_checkoutSessions?: Maybe<CheckoutSessions_Mutation_Response>;
  /** delete single row from the table: "checkoutSessions" */
  delete_checkoutSessions_by_pk?: Maybe<CheckoutSessions>;
  /** delete data from the table: "currencies" */
  delete_currencies?: Maybe<Currencies_Mutation_Response>;
  /** delete single row from the table: "currencies" */
  delete_currencies_by_pk?: Maybe<Currencies>;
  /** delete data from the table: "customers" */
  delete_customers?: Maybe<Customers_Mutation_Response>;
  /** delete single row from the table: "customers" */
  delete_customers_by_pk?: Maybe<Customers>;
  /** delete data from the table: "entityType" */
  delete_entityType?: Maybe<EntityType_Mutation_Response>;
  /** delete single row from the table: "entityType" */
  delete_entityType_by_pk?: Maybe<EntityType>;
  /** delete data from the table: "files" */
  delete_files?: Maybe<Files_Mutation_Response>;
  /** delete single row from the table: "files" */
  delete_files_by_pk?: Maybe<Files>;
  /** delete data from the table: "form" */
  delete_form?: Maybe<Form_Mutation_Response>;
  /** delete data from the table: "formAnswers" */
  delete_formAnswers?: Maybe<FormAnswers_Mutation_Response>;
  /** delete single row from the table: "formAnswers" */
  delete_formAnswers_by_pk?: Maybe<FormAnswers>;
  /** delete data from the table: "formQuestionOptions" */
  delete_formQuestionOptions?: Maybe<FormQuestionOptions_Mutation_Response>;
  /** delete single row from the table: "formQuestionOptions" */
  delete_formQuestionOptions_by_pk?: Maybe<FormQuestionOptions>;
  /** delete data from the table: "formQuestionType" */
  delete_formQuestionType?: Maybe<FormQuestionType_Mutation_Response>;
  /** delete single row from the table: "formQuestionType" */
  delete_formQuestionType_by_pk?: Maybe<FormQuestionType>;
  /** delete data from the table: "formQuestions" */
  delete_formQuestions?: Maybe<FormQuestions_Mutation_Response>;
  /** delete single row from the table: "formQuestions" */
  delete_formQuestions_by_pk?: Maybe<FormQuestions>;
  /** delete single row from the table: "form" */
  delete_form_by_pk?: Maybe<Form>;
  /** delete data from the table: "jobStatus" */
  delete_jobStatus?: Maybe<JobStatus_Mutation_Response>;
  /** delete single row from the table: "jobStatus" */
  delete_jobStatus_by_pk?: Maybe<JobStatus>;
  /** delete data from the table: "locale" */
  delete_locale?: Maybe<Locale_Mutation_Response>;
  /** delete single row from the table: "locale" */
  delete_locale_by_pk?: Maybe<Locale>;
  /** delete data from the table: "locationStatus" */
  delete_locationStatus?: Maybe<LocationStatus_Mutation_Response>;
  /** delete single row from the table: "locationStatus" */
  delete_locationStatus_by_pk?: Maybe<LocationStatus>;
  /** delete data from the table: "locationType" */
  delete_locationType?: Maybe<LocationType_Mutation_Response>;
  /** delete single row from the table: "locationType" */
  delete_locationType_by_pk?: Maybe<LocationType>;
  /** delete data from the table: "locations" */
  delete_locations?: Maybe<Locations_Mutation_Response>;
  /** delete single row from the table: "locations" */
  delete_locations_by_pk?: Maybe<Locations>;
  /** delete data from the table: "locations_with_distance" */
  delete_locations_with_distance?: Maybe<Locations_With_Distance_Mutation_Response>;
  /** delete data from the table: "notificationType" */
  delete_notificationType?: Maybe<NotificationType_Mutation_Response>;
  /** delete single row from the table: "notificationType" */
  delete_notificationType_by_pk?: Maybe<NotificationType>;
  /** delete data from the table: "notifications" */
  delete_notifications?: Maybe<Notifications_Mutation_Response>;
  /** delete single row from the table: "notifications" */
  delete_notifications_by_pk?: Maybe<Notifications>;
  /** delete data from the table: "partnershipSchedulingType" */
  delete_partnershipSchedulingType?: Maybe<PartnershipSchedulingType_Mutation_Response>;
  /** delete single row from the table: "partnershipSchedulingType" */
  delete_partnershipSchedulingType_by_pk?: Maybe<PartnershipSchedulingType>;
  /** delete data from the table: "partnershipStatus" */
  delete_partnershipStatus?: Maybe<PartnershipStatus_Mutation_Response>;
  /** delete single row from the table: "partnershipStatus" */
  delete_partnershipStatus_by_pk?: Maybe<PartnershipStatus>;
  /** delete data from the table: "paymentFormat" */
  delete_paymentFormat?: Maybe<PaymentFormat_Mutation_Response>;
  /** delete single row from the table: "paymentFormat" */
  delete_paymentFormat_by_pk?: Maybe<PaymentFormat>;
  /** delete data from the table: "paymentStatus" */
  delete_paymentStatus?: Maybe<PaymentStatus_Mutation_Response>;
  /** delete single row from the table: "paymentStatus" */
  delete_paymentStatus_by_pk?: Maybe<PaymentStatus>;
  /** delete data from the table: "payments" */
  delete_payments?: Maybe<Payments_Mutation_Response>;
  /** delete single row from the table: "payments" */
  delete_payments_by_pk?: Maybe<Payments>;
  /** delete data from the table: "providerCategory" */
  delete_providerCategory?: Maybe<ProviderCategory_Mutation_Response>;
  /** delete single row from the table: "providerCategory" */
  delete_providerCategory_by_pk?: Maybe<ProviderCategory>;
  /** delete data from the table: "providerMonthlyPayments" */
  delete_providerMonthlyPayments?: Maybe<ProviderMonthlyPayments_Mutation_Response>;
  /** delete single row from the table: "providerMonthlyPayments" */
  delete_providerMonthlyPayments_by_pk?: Maybe<ProviderMonthlyPayments>;
  /** delete data from the table: "providerPictures" */
  delete_providerPictures?: Maybe<ProviderPictures_Mutation_Response>;
  /** delete single row from the table: "providerPictures" */
  delete_providerPictures_by_pk?: Maybe<ProviderPictures>;
  /** delete data from the table: "providerRole" */
  delete_providerRole?: Maybe<ProviderRole_Mutation_Response>;
  /** delete single row from the table: "providerRole" */
  delete_providerRole_by_pk?: Maybe<ProviderRole>;
  /** delete data from the table: "providerStatus" */
  delete_providerStatus?: Maybe<ProviderStatus_Mutation_Response>;
  /** delete single row from the table: "providerStatus" */
  delete_providerStatus_by_pk?: Maybe<ProviderStatus>;
  /** delete data from the table: "providerType" */
  delete_providerType?: Maybe<ProviderType_Mutation_Response>;
  /** delete single row from the table: "providerType" */
  delete_providerType_by_pk?: Maybe<ProviderType>;
  /** delete data from the table: "providerVisibility" */
  delete_providerVisibility?: Maybe<ProviderVisibility_Mutation_Response>;
  /** delete single row from the table: "providerVisibility" */
  delete_providerVisibility_by_pk?: Maybe<ProviderVisibility>;
  /** delete data from the table: "providers" */
  delete_providers?: Maybe<Providers_Mutation_Response>;
  /** delete single row from the table: "providers" */
  delete_providers_by_pk?: Maybe<Providers>;
  /** delete data from the table: "refunds" */
  delete_refunds?: Maybe<Refunds_Mutation_Response>;
  /** delete single row from the table: "refunds" */
  delete_refunds_by_pk?: Maybe<Refunds>;
  /** delete data from the table: "relationshipStatus" */
  delete_relationshipStatus?: Maybe<RelationshipStatus_Mutation_Response>;
  /** delete single row from the table: "relationshipStatus" */
  delete_relationshipStatus_by_pk?: Maybe<RelationshipStatus>;
  /** delete data from the table: "schedule" */
  delete_schedule?: Maybe<Schedule_Mutation_Response>;
  /** delete single row from the table: "schedule" */
  delete_schedule_by_pk?: Maybe<Schedule>;
  /** delete data from the table: "serviceEmployees" */
  delete_serviceEmployees?: Maybe<ServiceEmployees_Mutation_Response>;
  /** delete single row from the table: "serviceEmployees" */
  delete_serviceEmployees_by_pk?: Maybe<ServiceEmployees>;
  /** delete data from the table: "serviceFormStatus" */
  delete_serviceFormStatus?: Maybe<ServiceFormStatus_Mutation_Response>;
  /** delete single row from the table: "serviceFormStatus" */
  delete_serviceFormStatus_by_pk?: Maybe<ServiceFormStatus>;
  /** delete data from the table: "serviceOptionAnswers" */
  delete_serviceOptionAnswers?: Maybe<ServiceOptionAnswers_Mutation_Response>;
  /** delete single row from the table: "serviceOptionAnswers" */
  delete_serviceOptionAnswers_by_pk?: Maybe<ServiceOptionAnswers>;
  /** delete data from the table: "serviceOptionSection" */
  delete_serviceOptionSection?: Maybe<ServiceOptionSection_Mutation_Response>;
  /** delete data from the table: "serviceOptionSectionOptions" */
  delete_serviceOptionSectionOptions?: Maybe<ServiceOptionSectionOptions_Mutation_Response>;
  /** delete single row from the table: "serviceOptionSectionOptions" */
  delete_serviceOptionSectionOptions_by_pk?: Maybe<ServiceOptionSectionOptions>;
  /** delete single row from the table: "serviceOptionSection" */
  delete_serviceOptionSection_by_pk?: Maybe<ServiceOptionSection>;
  /** delete data from the table: "serviceOptions" */
  delete_serviceOptions?: Maybe<ServiceOptions_Mutation_Response>;
  /** delete data from the table: "serviceOptionsStatus" */
  delete_serviceOptionsStatus?: Maybe<ServiceOptionsStatus_Mutation_Response>;
  /** delete single row from the table: "serviceOptionsStatus" */
  delete_serviceOptionsStatus_by_pk?: Maybe<ServiceOptionsStatus>;
  /** delete single row from the table: "serviceOptions" */
  delete_serviceOptions_by_pk?: Maybe<ServiceOptions>;
  /** delete data from the table: "servicePictures" */
  delete_servicePictures?: Maybe<ServicePictures_Mutation_Response>;
  /** delete single row from the table: "servicePictures" */
  delete_servicePictures_by_pk?: Maybe<ServicePictures>;
  /** delete data from the table: "servicePricings" */
  delete_servicePricings?: Maybe<ServicePricings_Mutation_Response>;
  /** delete single row from the table: "servicePricings" */
  delete_servicePricings_by_pk?: Maybe<ServicePricings>;
  /** delete data from the table: "serviceSectionOptionQuantityType" */
  delete_serviceSectionOptionQuantityType?: Maybe<ServiceSectionOptionQuantityType_Mutation_Response>;
  /** delete single row from the table: "serviceSectionOptionQuantityType" */
  delete_serviceSectionOptionQuantityType_by_pk?: Maybe<ServiceSectionOptionQuantityType>;
  /** delete data from the table: "serviceSectionOptionType" */
  delete_serviceSectionOptionType?: Maybe<ServiceSectionOptionType_Mutation_Response>;
  /** delete single row from the table: "serviceSectionOptionType" */
  delete_serviceSectionOptionType_by_pk?: Maybe<ServiceSectionOptionType>;
  /** delete data from the table: "serviceStatus" */
  delete_serviceStatus?: Maybe<ServiceStatus_Mutation_Response>;
  /** delete single row from the table: "serviceStatus" */
  delete_serviceStatus_by_pk?: Maybe<ServiceStatus>;
  /** delete data from the table: "services" */
  delete_services?: Maybe<Services_Mutation_Response>;
  /** delete data from the table: "servicesForms" */
  delete_servicesForms?: Maybe<ServicesForms_Mutation_Response>;
  /** delete single row from the table: "servicesForms" */
  delete_servicesForms_by_pk?: Maybe<ServicesForms>;
  /** delete single row from the table: "services" */
  delete_services_by_pk?: Maybe<Services>;
  /** delete data from the table: "sessions" */
  delete_sessions?: Maybe<Sessions_Mutation_Response>;
  /** delete single row from the table: "sessions" */
  delete_sessions_by_pk?: Maybe<Sessions>;
  /** delete data from the table: "timeouts" */
  delete_timeouts?: Maybe<Timeouts_Mutation_Response>;
  /** delete single row from the table: "timeouts" */
  delete_timeouts_by_pk?: Maybe<Timeouts>;
  /** delete data from the table: "transitionStatus" */
  delete_transitionStatus?: Maybe<TransitionStatus_Mutation_Response>;
  /** delete single row from the table: "transitionStatus" */
  delete_transitionStatus_by_pk?: Maybe<TransitionStatus>;
  /** delete data from the table: "unavailableServiceLocations" */
  delete_unavailableServiceLocations?: Maybe<UnavailableServiceLocations_Mutation_Response>;
  /** delete single row from the table: "unavailableServiceLocations" */
  delete_unavailableServiceLocations_by_pk?: Maybe<UnavailableServiceLocations>;
  /** delete data from the table: "userRole" */
  delete_userRole?: Maybe<UserRole_Mutation_Response>;
  /** delete single row from the table: "userRole" */
  delete_userRole_by_pk?: Maybe<UserRole>;
  /** delete data from the table: "userRoles" */
  delete_userRoles?: Maybe<UserRoles_Mutation_Response>;
  /** delete single row from the table: "userRoles" */
  delete_userRoles_by_pk?: Maybe<UserRoles>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  exportAppointments: ExportAppointmentBase64;
  forgotPassword: UserSessionDto;
  getCheckoutSession: CheckoutSesssionDto;
  handleGoogleOAuthCallback: Scalars['Boolean']['output'];
  /** insert data into the table: "appointmentPricing" */
  insert_appointmentPricing?: Maybe<AppointmentPricing_Mutation_Response>;
  /** insert a single row into the table: "appointmentPricing" */
  insert_appointmentPricing_one?: Maybe<AppointmentPricing>;
  /** insert data into the table: "appointments" */
  insert_appointments?: Maybe<Appointments_Mutation_Response>;
  /** insert a single row into the table: "appointments" */
  insert_appointments_one?: Maybe<Appointments>;
  /** insert data into the table: "bookingStatus" */
  insert_bookingStatus?: Maybe<BookingStatus_Mutation_Response>;
  /** insert a single row into the table: "bookingStatus" */
  insert_bookingStatus_one?: Maybe<BookingStatus>;
  /** insert data into the table: "buildingProviders" */
  insert_buildingProviders?: Maybe<BuildingProviders_Mutation_Response>;
  /** insert a single row into the table: "buildingProviders" */
  insert_buildingProviders_one?: Maybe<BuildingProviders>;
  /** insert data into the table: "buildingType" */
  insert_buildingType?: Maybe<BuildingType_Mutation_Response>;
  /** insert a single row into the table: "buildingType" */
  insert_buildingType_one?: Maybe<BuildingType>;
  /** insert data into the table: "checkoutSessions" */
  insert_checkoutSessions?: Maybe<CheckoutSessions_Mutation_Response>;
  /** insert a single row into the table: "checkoutSessions" */
  insert_checkoutSessions_one?: Maybe<CheckoutSessions>;
  /** insert data into the table: "currencies" */
  insert_currencies?: Maybe<Currencies_Mutation_Response>;
  /** insert a single row into the table: "currencies" */
  insert_currencies_one?: Maybe<Currencies>;
  /** insert data into the table: "customers" */
  insert_customers?: Maybe<Customers_Mutation_Response>;
  /** insert a single row into the table: "customers" */
  insert_customers_one?: Maybe<Customers>;
  /** insert data into the table: "entityType" */
  insert_entityType?: Maybe<EntityType_Mutation_Response>;
  /** insert a single row into the table: "entityType" */
  insert_entityType_one?: Maybe<EntityType>;
  /** insert data into the table: "files" */
  insert_files?: Maybe<Files_Mutation_Response>;
  /** insert a single row into the table: "files" */
  insert_files_one?: Maybe<Files>;
  /** insert data into the table: "form" */
  insert_form?: Maybe<Form_Mutation_Response>;
  /** insert data into the table: "formAnswers" */
  insert_formAnswers?: Maybe<FormAnswers_Mutation_Response>;
  /** insert a single row into the table: "formAnswers" */
  insert_formAnswers_one?: Maybe<FormAnswers>;
  /** insert data into the table: "formQuestionOptions" */
  insert_formQuestionOptions?: Maybe<FormQuestionOptions_Mutation_Response>;
  /** insert a single row into the table: "formQuestionOptions" */
  insert_formQuestionOptions_one?: Maybe<FormQuestionOptions>;
  /** insert data into the table: "formQuestionType" */
  insert_formQuestionType?: Maybe<FormQuestionType_Mutation_Response>;
  /** insert a single row into the table: "formQuestionType" */
  insert_formQuestionType_one?: Maybe<FormQuestionType>;
  /** insert data into the table: "formQuestions" */
  insert_formQuestions?: Maybe<FormQuestions_Mutation_Response>;
  /** insert a single row into the table: "formQuestions" */
  insert_formQuestions_one?: Maybe<FormQuestions>;
  /** insert a single row into the table: "form" */
  insert_form_one?: Maybe<Form>;
  /** insert data into the table: "jobStatus" */
  insert_jobStatus?: Maybe<JobStatus_Mutation_Response>;
  /** insert a single row into the table: "jobStatus" */
  insert_jobStatus_one?: Maybe<JobStatus>;
  /** insert data into the table: "locale" */
  insert_locale?: Maybe<Locale_Mutation_Response>;
  /** insert a single row into the table: "locale" */
  insert_locale_one?: Maybe<Locale>;
  /** insert data into the table: "locationStatus" */
  insert_locationStatus?: Maybe<LocationStatus_Mutation_Response>;
  /** insert a single row into the table: "locationStatus" */
  insert_locationStatus_one?: Maybe<LocationStatus>;
  /** insert data into the table: "locationType" */
  insert_locationType?: Maybe<LocationType_Mutation_Response>;
  /** insert a single row into the table: "locationType" */
  insert_locationType_one?: Maybe<LocationType>;
  /** insert data into the table: "locations" */
  insert_locations?: Maybe<Locations_Mutation_Response>;
  /** insert a single row into the table: "locations" */
  insert_locations_one?: Maybe<Locations>;
  /** insert data into the table: "locations_with_distance" */
  insert_locations_with_distance?: Maybe<Locations_With_Distance_Mutation_Response>;
  /** insert a single row into the table: "locations_with_distance" */
  insert_locations_with_distance_one?: Maybe<Locations_With_Distance>;
  /** insert data into the table: "notificationType" */
  insert_notificationType?: Maybe<NotificationType_Mutation_Response>;
  /** insert a single row into the table: "notificationType" */
  insert_notificationType_one?: Maybe<NotificationType>;
  /** insert data into the table: "notifications" */
  insert_notifications?: Maybe<Notifications_Mutation_Response>;
  /** insert a single row into the table: "notifications" */
  insert_notifications_one?: Maybe<Notifications>;
  /** insert data into the table: "partnershipSchedulingType" */
  insert_partnershipSchedulingType?: Maybe<PartnershipSchedulingType_Mutation_Response>;
  /** insert a single row into the table: "partnershipSchedulingType" */
  insert_partnershipSchedulingType_one?: Maybe<PartnershipSchedulingType>;
  /** insert data into the table: "partnershipStatus" */
  insert_partnershipStatus?: Maybe<PartnershipStatus_Mutation_Response>;
  /** insert a single row into the table: "partnershipStatus" */
  insert_partnershipStatus_one?: Maybe<PartnershipStatus>;
  /** insert data into the table: "paymentFormat" */
  insert_paymentFormat?: Maybe<PaymentFormat_Mutation_Response>;
  /** insert a single row into the table: "paymentFormat" */
  insert_paymentFormat_one?: Maybe<PaymentFormat>;
  /** insert data into the table: "paymentStatus" */
  insert_paymentStatus?: Maybe<PaymentStatus_Mutation_Response>;
  /** insert a single row into the table: "paymentStatus" */
  insert_paymentStatus_one?: Maybe<PaymentStatus>;
  /** insert data into the table: "payments" */
  insert_payments?: Maybe<Payments_Mutation_Response>;
  /** insert a single row into the table: "payments" */
  insert_payments_one?: Maybe<Payments>;
  /** insert data into the table: "providerCategory" */
  insert_providerCategory?: Maybe<ProviderCategory_Mutation_Response>;
  /** insert a single row into the table: "providerCategory" */
  insert_providerCategory_one?: Maybe<ProviderCategory>;
  /** insert data into the table: "providerMonthlyPayments" */
  insert_providerMonthlyPayments?: Maybe<ProviderMonthlyPayments_Mutation_Response>;
  /** insert a single row into the table: "providerMonthlyPayments" */
  insert_providerMonthlyPayments_one?: Maybe<ProviderMonthlyPayments>;
  /** insert data into the table: "providerPictures" */
  insert_providerPictures?: Maybe<ProviderPictures_Mutation_Response>;
  /** insert a single row into the table: "providerPictures" */
  insert_providerPictures_one?: Maybe<ProviderPictures>;
  /** insert data into the table: "providerRole" */
  insert_providerRole?: Maybe<ProviderRole_Mutation_Response>;
  /** insert a single row into the table: "providerRole" */
  insert_providerRole_one?: Maybe<ProviderRole>;
  /** insert data into the table: "providerStatus" */
  insert_providerStatus?: Maybe<ProviderStatus_Mutation_Response>;
  /** insert a single row into the table: "providerStatus" */
  insert_providerStatus_one?: Maybe<ProviderStatus>;
  /** insert data into the table: "providerType" */
  insert_providerType?: Maybe<ProviderType_Mutation_Response>;
  /** insert a single row into the table: "providerType" */
  insert_providerType_one?: Maybe<ProviderType>;
  /** insert data into the table: "providerVisibility" */
  insert_providerVisibility?: Maybe<ProviderVisibility_Mutation_Response>;
  /** insert a single row into the table: "providerVisibility" */
  insert_providerVisibility_one?: Maybe<ProviderVisibility>;
  /** insert data into the table: "providers" */
  insert_providers?: Maybe<Providers_Mutation_Response>;
  /** insert a single row into the table: "providers" */
  insert_providers_one?: Maybe<Providers>;
  /** insert data into the table: "refunds" */
  insert_refunds?: Maybe<Refunds_Mutation_Response>;
  /** insert a single row into the table: "refunds" */
  insert_refunds_one?: Maybe<Refunds>;
  /** insert data into the table: "relationshipStatus" */
  insert_relationshipStatus?: Maybe<RelationshipStatus_Mutation_Response>;
  /** insert a single row into the table: "relationshipStatus" */
  insert_relationshipStatus_one?: Maybe<RelationshipStatus>;
  /** insert data into the table: "schedule" */
  insert_schedule?: Maybe<Schedule_Mutation_Response>;
  /** insert a single row into the table: "schedule" */
  insert_schedule_one?: Maybe<Schedule>;
  /** insert data into the table: "serviceEmployees" */
  insert_serviceEmployees?: Maybe<ServiceEmployees_Mutation_Response>;
  /** insert a single row into the table: "serviceEmployees" */
  insert_serviceEmployees_one?: Maybe<ServiceEmployees>;
  /** insert data into the table: "serviceFormStatus" */
  insert_serviceFormStatus?: Maybe<ServiceFormStatus_Mutation_Response>;
  /** insert a single row into the table: "serviceFormStatus" */
  insert_serviceFormStatus_one?: Maybe<ServiceFormStatus>;
  /** insert data into the table: "serviceOptionAnswers" */
  insert_serviceOptionAnswers?: Maybe<ServiceOptionAnswers_Mutation_Response>;
  /** insert a single row into the table: "serviceOptionAnswers" */
  insert_serviceOptionAnswers_one?: Maybe<ServiceOptionAnswers>;
  /** insert data into the table: "serviceOptionSection" */
  insert_serviceOptionSection?: Maybe<ServiceOptionSection_Mutation_Response>;
  /** insert data into the table: "serviceOptionSectionOptions" */
  insert_serviceOptionSectionOptions?: Maybe<ServiceOptionSectionOptions_Mutation_Response>;
  /** insert a single row into the table: "serviceOptionSectionOptions" */
  insert_serviceOptionSectionOptions_one?: Maybe<ServiceOptionSectionOptions>;
  /** insert a single row into the table: "serviceOptionSection" */
  insert_serviceOptionSection_one?: Maybe<ServiceOptionSection>;
  /** insert data into the table: "serviceOptions" */
  insert_serviceOptions?: Maybe<ServiceOptions_Mutation_Response>;
  /** insert data into the table: "serviceOptionsStatus" */
  insert_serviceOptionsStatus?: Maybe<ServiceOptionsStatus_Mutation_Response>;
  /** insert a single row into the table: "serviceOptionsStatus" */
  insert_serviceOptionsStatus_one?: Maybe<ServiceOptionsStatus>;
  /** insert a single row into the table: "serviceOptions" */
  insert_serviceOptions_one?: Maybe<ServiceOptions>;
  /** insert data into the table: "servicePictures" */
  insert_servicePictures?: Maybe<ServicePictures_Mutation_Response>;
  /** insert a single row into the table: "servicePictures" */
  insert_servicePictures_one?: Maybe<ServicePictures>;
  /** insert data into the table: "servicePricings" */
  insert_servicePricings?: Maybe<ServicePricings_Mutation_Response>;
  /** insert a single row into the table: "servicePricings" */
  insert_servicePricings_one?: Maybe<ServicePricings>;
  /** insert data into the table: "serviceSectionOptionQuantityType" */
  insert_serviceSectionOptionQuantityType?: Maybe<ServiceSectionOptionQuantityType_Mutation_Response>;
  /** insert a single row into the table: "serviceSectionOptionQuantityType" */
  insert_serviceSectionOptionQuantityType_one?: Maybe<ServiceSectionOptionQuantityType>;
  /** insert data into the table: "serviceSectionOptionType" */
  insert_serviceSectionOptionType?: Maybe<ServiceSectionOptionType_Mutation_Response>;
  /** insert a single row into the table: "serviceSectionOptionType" */
  insert_serviceSectionOptionType_one?: Maybe<ServiceSectionOptionType>;
  /** insert data into the table: "serviceStatus" */
  insert_serviceStatus?: Maybe<ServiceStatus_Mutation_Response>;
  /** insert a single row into the table: "serviceStatus" */
  insert_serviceStatus_one?: Maybe<ServiceStatus>;
  /** insert data into the table: "services" */
  insert_services?: Maybe<Services_Mutation_Response>;
  /** insert data into the table: "servicesForms" */
  insert_servicesForms?: Maybe<ServicesForms_Mutation_Response>;
  /** insert a single row into the table: "servicesForms" */
  insert_servicesForms_one?: Maybe<ServicesForms>;
  /** insert a single row into the table: "services" */
  insert_services_one?: Maybe<Services>;
  /** insert data into the table: "sessions" */
  insert_sessions?: Maybe<Sessions_Mutation_Response>;
  /** insert a single row into the table: "sessions" */
  insert_sessions_one?: Maybe<Sessions>;
  /** insert data into the table: "timeouts" */
  insert_timeouts?: Maybe<Timeouts_Mutation_Response>;
  /** insert a single row into the table: "timeouts" */
  insert_timeouts_one?: Maybe<Timeouts>;
  /** insert data into the table: "transitionStatus" */
  insert_transitionStatus?: Maybe<TransitionStatus_Mutation_Response>;
  /** insert a single row into the table: "transitionStatus" */
  insert_transitionStatus_one?: Maybe<TransitionStatus>;
  /** insert data into the table: "unavailableServiceLocations" */
  insert_unavailableServiceLocations?: Maybe<UnavailableServiceLocations_Mutation_Response>;
  /** insert a single row into the table: "unavailableServiceLocations" */
  insert_unavailableServiceLocations_one?: Maybe<UnavailableServiceLocations>;
  /** insert data into the table: "userRole" */
  insert_userRole?: Maybe<UserRole_Mutation_Response>;
  /** insert a single row into the table: "userRole" */
  insert_userRole_one?: Maybe<UserRole>;
  /** insert data into the table: "userRoles" */
  insert_userRoles?: Maybe<UserRoles_Mutation_Response>;
  /** insert a single row into the table: "userRoles" */
  insert_userRoles_one?: Maybe<UserRoles>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  logout: LogoutDto;
  modifyAppointment: Appointment;
  payBookedAppointment: Scalars['String']['output'];
  refreshTokens: UserSessionDto;
  register: UserSessionDto;
  registerBuildingManager: UserSessionDto;
  registerProvider: UserSessionDto;
  requestForgotPassword: Scalars['String']['output'];
  requestLocationPartnership: PartnershipDto;
  requestVerifyEmail: Scalars['String']['output'];
  requestVerifyPhoneNumber: Scalars['String']['output'];
  setEmployeeCalendar: Scalars['Boolean']['output'];
  unlinkGoogleCalendar: Scalars['Boolean']['output'];
  updateUserPhone: UserWithoutPassword;
  /** update data of the table: "appointmentPricing" */
  update_appointmentPricing?: Maybe<AppointmentPricing_Mutation_Response>;
  /** update single row of the table: "appointmentPricing" */
  update_appointmentPricing_by_pk?: Maybe<AppointmentPricing>;
  /** update multiples rows of table: "appointmentPricing" */
  update_appointmentPricing_many?: Maybe<Array<Maybe<AppointmentPricing_Mutation_Response>>>;
  /** update data of the table: "appointments" */
  update_appointments?: Maybe<Appointments_Mutation_Response>;
  /** update single row of the table: "appointments" */
  update_appointments_by_pk?: Maybe<Appointments>;
  /** update multiples rows of table: "appointments" */
  update_appointments_many?: Maybe<Array<Maybe<Appointments_Mutation_Response>>>;
  /** update data of the table: "bookingStatus" */
  update_bookingStatus?: Maybe<BookingStatus_Mutation_Response>;
  /** update single row of the table: "bookingStatus" */
  update_bookingStatus_by_pk?: Maybe<BookingStatus>;
  /** update multiples rows of table: "bookingStatus" */
  update_bookingStatus_many?: Maybe<Array<Maybe<BookingStatus_Mutation_Response>>>;
  /** update data of the table: "buildingProviders" */
  update_buildingProviders?: Maybe<BuildingProviders_Mutation_Response>;
  /** update single row of the table: "buildingProviders" */
  update_buildingProviders_by_pk?: Maybe<BuildingProviders>;
  /** update multiples rows of table: "buildingProviders" */
  update_buildingProviders_many?: Maybe<Array<Maybe<BuildingProviders_Mutation_Response>>>;
  /** update data of the table: "buildingType" */
  update_buildingType?: Maybe<BuildingType_Mutation_Response>;
  /** update single row of the table: "buildingType" */
  update_buildingType_by_pk?: Maybe<BuildingType>;
  /** update multiples rows of table: "buildingType" */
  update_buildingType_many?: Maybe<Array<Maybe<BuildingType_Mutation_Response>>>;
  /** update data of the table: "checkoutSessions" */
  update_checkoutSessions?: Maybe<CheckoutSessions_Mutation_Response>;
  /** update single row of the table: "checkoutSessions" */
  update_checkoutSessions_by_pk?: Maybe<CheckoutSessions>;
  /** update multiples rows of table: "checkoutSessions" */
  update_checkoutSessions_many?: Maybe<Array<Maybe<CheckoutSessions_Mutation_Response>>>;
  /** update data of the table: "currencies" */
  update_currencies?: Maybe<Currencies_Mutation_Response>;
  /** update single row of the table: "currencies" */
  update_currencies_by_pk?: Maybe<Currencies>;
  /** update multiples rows of table: "currencies" */
  update_currencies_many?: Maybe<Array<Maybe<Currencies_Mutation_Response>>>;
  /** update data of the table: "customers" */
  update_customers?: Maybe<Customers_Mutation_Response>;
  /** update single row of the table: "customers" */
  update_customers_by_pk?: Maybe<Customers>;
  /** update multiples rows of table: "customers" */
  update_customers_many?: Maybe<Array<Maybe<Customers_Mutation_Response>>>;
  /** update data of the table: "entityType" */
  update_entityType?: Maybe<EntityType_Mutation_Response>;
  /** update single row of the table: "entityType" */
  update_entityType_by_pk?: Maybe<EntityType>;
  /** update multiples rows of table: "entityType" */
  update_entityType_many?: Maybe<Array<Maybe<EntityType_Mutation_Response>>>;
  /** update data of the table: "files" */
  update_files?: Maybe<Files_Mutation_Response>;
  /** update single row of the table: "files" */
  update_files_by_pk?: Maybe<Files>;
  /** update multiples rows of table: "files" */
  update_files_many?: Maybe<Array<Maybe<Files_Mutation_Response>>>;
  /** update data of the table: "form" */
  update_form?: Maybe<Form_Mutation_Response>;
  /** update data of the table: "formAnswers" */
  update_formAnswers?: Maybe<FormAnswers_Mutation_Response>;
  /** update single row of the table: "formAnswers" */
  update_formAnswers_by_pk?: Maybe<FormAnswers>;
  /** update multiples rows of table: "formAnswers" */
  update_formAnswers_many?: Maybe<Array<Maybe<FormAnswers_Mutation_Response>>>;
  /** update data of the table: "formQuestionOptions" */
  update_formQuestionOptions?: Maybe<FormQuestionOptions_Mutation_Response>;
  /** update single row of the table: "formQuestionOptions" */
  update_formQuestionOptions_by_pk?: Maybe<FormQuestionOptions>;
  /** update multiples rows of table: "formQuestionOptions" */
  update_formQuestionOptions_many?: Maybe<Array<Maybe<FormQuestionOptions_Mutation_Response>>>;
  /** update data of the table: "formQuestionType" */
  update_formQuestionType?: Maybe<FormQuestionType_Mutation_Response>;
  /** update single row of the table: "formQuestionType" */
  update_formQuestionType_by_pk?: Maybe<FormQuestionType>;
  /** update multiples rows of table: "formQuestionType" */
  update_formQuestionType_many?: Maybe<Array<Maybe<FormQuestionType_Mutation_Response>>>;
  /** update data of the table: "formQuestions" */
  update_formQuestions?: Maybe<FormQuestions_Mutation_Response>;
  /** update single row of the table: "formQuestions" */
  update_formQuestions_by_pk?: Maybe<FormQuestions>;
  /** update multiples rows of table: "formQuestions" */
  update_formQuestions_many?: Maybe<Array<Maybe<FormQuestions_Mutation_Response>>>;
  /** update single row of the table: "form" */
  update_form_by_pk?: Maybe<Form>;
  /** update multiples rows of table: "form" */
  update_form_many?: Maybe<Array<Maybe<Form_Mutation_Response>>>;
  /** update data of the table: "jobStatus" */
  update_jobStatus?: Maybe<JobStatus_Mutation_Response>;
  /** update single row of the table: "jobStatus" */
  update_jobStatus_by_pk?: Maybe<JobStatus>;
  /** update multiples rows of table: "jobStatus" */
  update_jobStatus_many?: Maybe<Array<Maybe<JobStatus_Mutation_Response>>>;
  /** update data of the table: "locale" */
  update_locale?: Maybe<Locale_Mutation_Response>;
  /** update single row of the table: "locale" */
  update_locale_by_pk?: Maybe<Locale>;
  /** update multiples rows of table: "locale" */
  update_locale_many?: Maybe<Array<Maybe<Locale_Mutation_Response>>>;
  /** update data of the table: "locationStatus" */
  update_locationStatus?: Maybe<LocationStatus_Mutation_Response>;
  /** update single row of the table: "locationStatus" */
  update_locationStatus_by_pk?: Maybe<LocationStatus>;
  /** update multiples rows of table: "locationStatus" */
  update_locationStatus_many?: Maybe<Array<Maybe<LocationStatus_Mutation_Response>>>;
  /** update data of the table: "locationType" */
  update_locationType?: Maybe<LocationType_Mutation_Response>;
  /** update single row of the table: "locationType" */
  update_locationType_by_pk?: Maybe<LocationType>;
  /** update multiples rows of table: "locationType" */
  update_locationType_many?: Maybe<Array<Maybe<LocationType_Mutation_Response>>>;
  /** update data of the table: "locations" */
  update_locations?: Maybe<Locations_Mutation_Response>;
  /** update single row of the table: "locations" */
  update_locations_by_pk?: Maybe<Locations>;
  /** update multiples rows of table: "locations" */
  update_locations_many?: Maybe<Array<Maybe<Locations_Mutation_Response>>>;
  /** update data of the table: "locations_with_distance" */
  update_locations_with_distance?: Maybe<Locations_With_Distance_Mutation_Response>;
  /** update multiples rows of table: "locations_with_distance" */
  update_locations_with_distance_many?: Maybe<Array<Maybe<Locations_With_Distance_Mutation_Response>>>;
  /** update data of the table: "notificationType" */
  update_notificationType?: Maybe<NotificationType_Mutation_Response>;
  /** update single row of the table: "notificationType" */
  update_notificationType_by_pk?: Maybe<NotificationType>;
  /** update multiples rows of table: "notificationType" */
  update_notificationType_many?: Maybe<Array<Maybe<NotificationType_Mutation_Response>>>;
  /** update data of the table: "notifications" */
  update_notifications?: Maybe<Notifications_Mutation_Response>;
  /** update single row of the table: "notifications" */
  update_notifications_by_pk?: Maybe<Notifications>;
  /** update multiples rows of table: "notifications" */
  update_notifications_many?: Maybe<Array<Maybe<Notifications_Mutation_Response>>>;
  /** update data of the table: "partnershipSchedulingType" */
  update_partnershipSchedulingType?: Maybe<PartnershipSchedulingType_Mutation_Response>;
  /** update single row of the table: "partnershipSchedulingType" */
  update_partnershipSchedulingType_by_pk?: Maybe<PartnershipSchedulingType>;
  /** update multiples rows of table: "partnershipSchedulingType" */
  update_partnershipSchedulingType_many?: Maybe<Array<Maybe<PartnershipSchedulingType_Mutation_Response>>>;
  /** update data of the table: "partnershipStatus" */
  update_partnershipStatus?: Maybe<PartnershipStatus_Mutation_Response>;
  /** update single row of the table: "partnershipStatus" */
  update_partnershipStatus_by_pk?: Maybe<PartnershipStatus>;
  /** update multiples rows of table: "partnershipStatus" */
  update_partnershipStatus_many?: Maybe<Array<Maybe<PartnershipStatus_Mutation_Response>>>;
  /** update data of the table: "paymentFormat" */
  update_paymentFormat?: Maybe<PaymentFormat_Mutation_Response>;
  /** update single row of the table: "paymentFormat" */
  update_paymentFormat_by_pk?: Maybe<PaymentFormat>;
  /** update multiples rows of table: "paymentFormat" */
  update_paymentFormat_many?: Maybe<Array<Maybe<PaymentFormat_Mutation_Response>>>;
  /** update data of the table: "paymentStatus" */
  update_paymentStatus?: Maybe<PaymentStatus_Mutation_Response>;
  /** update single row of the table: "paymentStatus" */
  update_paymentStatus_by_pk?: Maybe<PaymentStatus>;
  /** update multiples rows of table: "paymentStatus" */
  update_paymentStatus_many?: Maybe<Array<Maybe<PaymentStatus_Mutation_Response>>>;
  /** update data of the table: "payments" */
  update_payments?: Maybe<Payments_Mutation_Response>;
  /** update single row of the table: "payments" */
  update_payments_by_pk?: Maybe<Payments>;
  /** update multiples rows of table: "payments" */
  update_payments_many?: Maybe<Array<Maybe<Payments_Mutation_Response>>>;
  /** update data of the table: "providerCategory" */
  update_providerCategory?: Maybe<ProviderCategory_Mutation_Response>;
  /** update single row of the table: "providerCategory" */
  update_providerCategory_by_pk?: Maybe<ProviderCategory>;
  /** update multiples rows of table: "providerCategory" */
  update_providerCategory_many?: Maybe<Array<Maybe<ProviderCategory_Mutation_Response>>>;
  /** update data of the table: "providerMonthlyPayments" */
  update_providerMonthlyPayments?: Maybe<ProviderMonthlyPayments_Mutation_Response>;
  /** update single row of the table: "providerMonthlyPayments" */
  update_providerMonthlyPayments_by_pk?: Maybe<ProviderMonthlyPayments>;
  /** update multiples rows of table: "providerMonthlyPayments" */
  update_providerMonthlyPayments_many?: Maybe<Array<Maybe<ProviderMonthlyPayments_Mutation_Response>>>;
  /** update data of the table: "providerPictures" */
  update_providerPictures?: Maybe<ProviderPictures_Mutation_Response>;
  /** update single row of the table: "providerPictures" */
  update_providerPictures_by_pk?: Maybe<ProviderPictures>;
  /** update multiples rows of table: "providerPictures" */
  update_providerPictures_many?: Maybe<Array<Maybe<ProviderPictures_Mutation_Response>>>;
  /** update data of the table: "providerRole" */
  update_providerRole?: Maybe<ProviderRole_Mutation_Response>;
  /** update single row of the table: "providerRole" */
  update_providerRole_by_pk?: Maybe<ProviderRole>;
  /** update multiples rows of table: "providerRole" */
  update_providerRole_many?: Maybe<Array<Maybe<ProviderRole_Mutation_Response>>>;
  /** update data of the table: "providerStatus" */
  update_providerStatus?: Maybe<ProviderStatus_Mutation_Response>;
  /** update single row of the table: "providerStatus" */
  update_providerStatus_by_pk?: Maybe<ProviderStatus>;
  /** update multiples rows of table: "providerStatus" */
  update_providerStatus_many?: Maybe<Array<Maybe<ProviderStatus_Mutation_Response>>>;
  /** update data of the table: "providerType" */
  update_providerType?: Maybe<ProviderType_Mutation_Response>;
  /** update single row of the table: "providerType" */
  update_providerType_by_pk?: Maybe<ProviderType>;
  /** update multiples rows of table: "providerType" */
  update_providerType_many?: Maybe<Array<Maybe<ProviderType_Mutation_Response>>>;
  /** update data of the table: "providerVisibility" */
  update_providerVisibility?: Maybe<ProviderVisibility_Mutation_Response>;
  /** update single row of the table: "providerVisibility" */
  update_providerVisibility_by_pk?: Maybe<ProviderVisibility>;
  /** update multiples rows of table: "providerVisibility" */
  update_providerVisibility_many?: Maybe<Array<Maybe<ProviderVisibility_Mutation_Response>>>;
  /** update data of the table: "providers" */
  update_providers?: Maybe<Providers_Mutation_Response>;
  /** update single row of the table: "providers" */
  update_providers_by_pk?: Maybe<Providers>;
  /** update multiples rows of table: "providers" */
  update_providers_many?: Maybe<Array<Maybe<Providers_Mutation_Response>>>;
  /** update data of the table: "refunds" */
  update_refunds?: Maybe<Refunds_Mutation_Response>;
  /** update single row of the table: "refunds" */
  update_refunds_by_pk?: Maybe<Refunds>;
  /** update multiples rows of table: "refunds" */
  update_refunds_many?: Maybe<Array<Maybe<Refunds_Mutation_Response>>>;
  /** update data of the table: "relationshipStatus" */
  update_relationshipStatus?: Maybe<RelationshipStatus_Mutation_Response>;
  /** update single row of the table: "relationshipStatus" */
  update_relationshipStatus_by_pk?: Maybe<RelationshipStatus>;
  /** update multiples rows of table: "relationshipStatus" */
  update_relationshipStatus_many?: Maybe<Array<Maybe<RelationshipStatus_Mutation_Response>>>;
  /** update data of the table: "schedule" */
  update_schedule?: Maybe<Schedule_Mutation_Response>;
  /** update single row of the table: "schedule" */
  update_schedule_by_pk?: Maybe<Schedule>;
  /** update multiples rows of table: "schedule" */
  update_schedule_many?: Maybe<Array<Maybe<Schedule_Mutation_Response>>>;
  /** update data of the table: "serviceEmployees" */
  update_serviceEmployees?: Maybe<ServiceEmployees_Mutation_Response>;
  /** update single row of the table: "serviceEmployees" */
  update_serviceEmployees_by_pk?: Maybe<ServiceEmployees>;
  /** update multiples rows of table: "serviceEmployees" */
  update_serviceEmployees_many?: Maybe<Array<Maybe<ServiceEmployees_Mutation_Response>>>;
  /** update data of the table: "serviceFormStatus" */
  update_serviceFormStatus?: Maybe<ServiceFormStatus_Mutation_Response>;
  /** update single row of the table: "serviceFormStatus" */
  update_serviceFormStatus_by_pk?: Maybe<ServiceFormStatus>;
  /** update multiples rows of table: "serviceFormStatus" */
  update_serviceFormStatus_many?: Maybe<Array<Maybe<ServiceFormStatus_Mutation_Response>>>;
  /** update data of the table: "serviceOptionAnswers" */
  update_serviceOptionAnswers?: Maybe<ServiceOptionAnswers_Mutation_Response>;
  /** update single row of the table: "serviceOptionAnswers" */
  update_serviceOptionAnswers_by_pk?: Maybe<ServiceOptionAnswers>;
  /** update multiples rows of table: "serviceOptionAnswers" */
  update_serviceOptionAnswers_many?: Maybe<Array<Maybe<ServiceOptionAnswers_Mutation_Response>>>;
  /** update data of the table: "serviceOptionSection" */
  update_serviceOptionSection?: Maybe<ServiceOptionSection_Mutation_Response>;
  /** update data of the table: "serviceOptionSectionOptions" */
  update_serviceOptionSectionOptions?: Maybe<ServiceOptionSectionOptions_Mutation_Response>;
  /** update single row of the table: "serviceOptionSectionOptions" */
  update_serviceOptionSectionOptions_by_pk?: Maybe<ServiceOptionSectionOptions>;
  /** update multiples rows of table: "serviceOptionSectionOptions" */
  update_serviceOptionSectionOptions_many?: Maybe<Array<Maybe<ServiceOptionSectionOptions_Mutation_Response>>>;
  /** update single row of the table: "serviceOptionSection" */
  update_serviceOptionSection_by_pk?: Maybe<ServiceOptionSection>;
  /** update multiples rows of table: "serviceOptionSection" */
  update_serviceOptionSection_many?: Maybe<Array<Maybe<ServiceOptionSection_Mutation_Response>>>;
  /** update data of the table: "serviceOptions" */
  update_serviceOptions?: Maybe<ServiceOptions_Mutation_Response>;
  /** update data of the table: "serviceOptionsStatus" */
  update_serviceOptionsStatus?: Maybe<ServiceOptionsStatus_Mutation_Response>;
  /** update single row of the table: "serviceOptionsStatus" */
  update_serviceOptionsStatus_by_pk?: Maybe<ServiceOptionsStatus>;
  /** update multiples rows of table: "serviceOptionsStatus" */
  update_serviceOptionsStatus_many?: Maybe<Array<Maybe<ServiceOptionsStatus_Mutation_Response>>>;
  /** update single row of the table: "serviceOptions" */
  update_serviceOptions_by_pk?: Maybe<ServiceOptions>;
  /** update multiples rows of table: "serviceOptions" */
  update_serviceOptions_many?: Maybe<Array<Maybe<ServiceOptions_Mutation_Response>>>;
  /** update data of the table: "servicePictures" */
  update_servicePictures?: Maybe<ServicePictures_Mutation_Response>;
  /** update single row of the table: "servicePictures" */
  update_servicePictures_by_pk?: Maybe<ServicePictures>;
  /** update multiples rows of table: "servicePictures" */
  update_servicePictures_many?: Maybe<Array<Maybe<ServicePictures_Mutation_Response>>>;
  /** update data of the table: "servicePricings" */
  update_servicePricings?: Maybe<ServicePricings_Mutation_Response>;
  /** update single row of the table: "servicePricings" */
  update_servicePricings_by_pk?: Maybe<ServicePricings>;
  /** update multiples rows of table: "servicePricings" */
  update_servicePricings_many?: Maybe<Array<Maybe<ServicePricings_Mutation_Response>>>;
  /** update data of the table: "serviceSectionOptionQuantityType" */
  update_serviceSectionOptionQuantityType?: Maybe<ServiceSectionOptionQuantityType_Mutation_Response>;
  /** update single row of the table: "serviceSectionOptionQuantityType" */
  update_serviceSectionOptionQuantityType_by_pk?: Maybe<ServiceSectionOptionQuantityType>;
  /** update multiples rows of table: "serviceSectionOptionQuantityType" */
  update_serviceSectionOptionQuantityType_many?: Maybe<Array<Maybe<ServiceSectionOptionQuantityType_Mutation_Response>>>;
  /** update data of the table: "serviceSectionOptionType" */
  update_serviceSectionOptionType?: Maybe<ServiceSectionOptionType_Mutation_Response>;
  /** update single row of the table: "serviceSectionOptionType" */
  update_serviceSectionOptionType_by_pk?: Maybe<ServiceSectionOptionType>;
  /** update multiples rows of table: "serviceSectionOptionType" */
  update_serviceSectionOptionType_many?: Maybe<Array<Maybe<ServiceSectionOptionType_Mutation_Response>>>;
  /** update data of the table: "serviceStatus" */
  update_serviceStatus?: Maybe<ServiceStatus_Mutation_Response>;
  /** update single row of the table: "serviceStatus" */
  update_serviceStatus_by_pk?: Maybe<ServiceStatus>;
  /** update multiples rows of table: "serviceStatus" */
  update_serviceStatus_many?: Maybe<Array<Maybe<ServiceStatus_Mutation_Response>>>;
  /** update data of the table: "services" */
  update_services?: Maybe<Services_Mutation_Response>;
  /** update data of the table: "servicesForms" */
  update_servicesForms?: Maybe<ServicesForms_Mutation_Response>;
  /** update single row of the table: "servicesForms" */
  update_servicesForms_by_pk?: Maybe<ServicesForms>;
  /** update multiples rows of table: "servicesForms" */
  update_servicesForms_many?: Maybe<Array<Maybe<ServicesForms_Mutation_Response>>>;
  /** update single row of the table: "services" */
  update_services_by_pk?: Maybe<Services>;
  /** update multiples rows of table: "services" */
  update_services_many?: Maybe<Array<Maybe<Services_Mutation_Response>>>;
  /** update data of the table: "sessions" */
  update_sessions?: Maybe<Sessions_Mutation_Response>;
  /** update single row of the table: "sessions" */
  update_sessions_by_pk?: Maybe<Sessions>;
  /** update multiples rows of table: "sessions" */
  update_sessions_many?: Maybe<Array<Maybe<Sessions_Mutation_Response>>>;
  /** update data of the table: "timeouts" */
  update_timeouts?: Maybe<Timeouts_Mutation_Response>;
  /** update single row of the table: "timeouts" */
  update_timeouts_by_pk?: Maybe<Timeouts>;
  /** update multiples rows of table: "timeouts" */
  update_timeouts_many?: Maybe<Array<Maybe<Timeouts_Mutation_Response>>>;
  /** update data of the table: "transitionStatus" */
  update_transitionStatus?: Maybe<TransitionStatus_Mutation_Response>;
  /** update single row of the table: "transitionStatus" */
  update_transitionStatus_by_pk?: Maybe<TransitionStatus>;
  /** update multiples rows of table: "transitionStatus" */
  update_transitionStatus_many?: Maybe<Array<Maybe<TransitionStatus_Mutation_Response>>>;
  /** update data of the table: "unavailableServiceLocations" */
  update_unavailableServiceLocations?: Maybe<UnavailableServiceLocations_Mutation_Response>;
  /** update single row of the table: "unavailableServiceLocations" */
  update_unavailableServiceLocations_by_pk?: Maybe<UnavailableServiceLocations>;
  /** update multiples rows of table: "unavailableServiceLocations" */
  update_unavailableServiceLocations_many?: Maybe<Array<Maybe<UnavailableServiceLocations_Mutation_Response>>>;
  /** update data of the table: "userRole" */
  update_userRole?: Maybe<UserRole_Mutation_Response>;
  /** update single row of the table: "userRole" */
  update_userRole_by_pk?: Maybe<UserRole>;
  /** update multiples rows of table: "userRole" */
  update_userRole_many?: Maybe<Array<Maybe<UserRole_Mutation_Response>>>;
  /** update data of the table: "userRoles" */
  update_userRoles?: Maybe<UserRoles_Mutation_Response>;
  /** update single row of the table: "userRoles" */
  update_userRoles_by_pk?: Maybe<UserRoles>;
  /** update multiples rows of table: "userRoles" */
  update_userRoles_many?: Maybe<Array<Maybe<UserRoles_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  verifyEmail: Scalars['String']['output'];
  verifyPhoneNumber: Scalars['String']['output'];
};


/** mutation root */
export type Mutation_RootApproveAppointmentArgs = {
  appointmentId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSpMarkAppointmentCompletedArgs = {
  appointmentId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSpMarkAppointmentPartialArgs = {
  appointmentId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSpMarkAppointmentScheduledArgs = {
  appointmentId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSpRefundPaymentArgs = {
  apptId: Scalars['String']['input'];
  paymentId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSpUpdateApptPaymentStatusArgs = {
  apptId: Scalars['String']['input'];
  status: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCancelCheckoutSessionArgs = {
  token: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCancelRejectAppointmentArgs = {
  id: Scalars['String']['input'];
  keepCancellationFee?: InputMaybe<Scalars['Boolean']['input']>;
};


/** mutation root */
export type Mutation_RootChangePasswordArgs = {
  password: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootClearEmployeeCalendarArgs = {
  employeeId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateAppointmentAnonymousArgs = {
  data: CreateAppointmentAnonymousDtoArgs;
};


/** mutation root */
export type Mutation_RootCreateAppointmentBmArgs = {
  data: CreateAppointmentDtoArgs;
};


/** mutation root */
export type Mutation_RootCreateAppointmentPaymentIntentArgs = {
  data: CreateAppointmentPaymentIntentDtoArgs;
};


/** mutation root */
export type Mutation_RootCreateAppointmentPaymentIntentAnonymousArgs = {
  data: CreateAppointmentPaymentIntentAnonymousDtoArgs;
};


/** mutation root */
export type Mutation_RootCreateAppointmentPaymentIntentUserArgs = {
  data: CreateAppointmentPaymentIntentUserDtoArgs;
};


/** mutation root */
export type Mutation_RootCreateAppointmentSpArgs = {
  data: CreateAppointmentSpDtoArgs;
};


/** mutation root */
export type Mutation_RootCreateAppointmentUserArgs = {
  data: CreateAppointmentUserDtoArgs;
};


/** mutation root */
export type Mutation_RootCreateBookedAppointmentPaymentIntentArgs = {
  appointmentId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateCustomerArgs = {
  input: CustomerDataInputDto;
};


/** mutation root */
export type Mutation_RootCreateCustomerSetupIntentArgs = {
  confirmationTokenId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateEmployeeArgs = {
  employee: CreateEmployeeInputDto;
};


/** mutation root */
export type Mutation_RootCreateMonthlySpPaymentsArgs = {
  monthString?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootCreatePaymentArgs = {
  amount: Scalars['Float']['input'];
};


/** mutation root */
export type Mutation_RootCreateProviderSetupIntentArgs = {
  confirmationTokenId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateUserSetupIntentArgs = {
  confirmationTokenId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteCustomerPaymentMethodArgs = {
  customerId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteFileArgs = {
  fileId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AppointmentPricingArgs = {
  where: AppointmentPricing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AppointmentPricing_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AppointmentsArgs = {
  where: Appointments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Appointments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BookingStatusArgs = {
  where: BookingStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BookingStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BuildingProvidersArgs = {
  where: BuildingProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BuildingProviders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BuildingTypeArgs = {
  where: BuildingType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BuildingType_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CheckoutSessionsArgs = {
  where: CheckoutSessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CheckoutSessions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CurrenciesArgs = {
  where: Currencies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Currencies_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CustomersArgs = {
  where: Customers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EntityTypeArgs = {
  where: EntityType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EntityType_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FilesArgs = {
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Files_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FormArgs = {
  where: Form_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_FormAnswersArgs = {
  where: FormAnswers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_FormAnswers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FormQuestionOptionsArgs = {
  where: FormQuestionOptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_FormQuestionOptions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FormQuestionTypeArgs = {
  where: FormQuestionType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_FormQuestionType_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FormQuestionsArgs = {
  where: FormQuestions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_FormQuestions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Form_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_JobStatusArgs = {
  where: JobStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_JobStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_LocaleArgs = {
  where: Locale_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Locale_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_LocationStatusArgs = {
  where: LocationStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_LocationStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_LocationTypeArgs = {
  where: LocationType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_LocationType_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_LocationsArgs = {
  where: Locations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Locations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Locations_With_DistanceArgs = {
  where: Locations_With_Distance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_NotificationTypeArgs = {
  where: NotificationType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_NotificationType_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_NotificationsArgs = {
  where: Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PartnershipSchedulingTypeArgs = {
  where: PartnershipSchedulingType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PartnershipSchedulingType_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PartnershipStatusArgs = {
  where: PartnershipStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PartnershipStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PaymentFormatArgs = {
  where: PaymentFormat_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PaymentFormat_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PaymentStatusArgs = {
  where: PaymentStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PaymentStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PaymentsArgs = {
  where: Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProviderCategoryArgs = {
  where: ProviderCategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProviderCategory_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProviderMonthlyPaymentsArgs = {
  where: ProviderMonthlyPayments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProviderMonthlyPayments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProviderPicturesArgs = {
  where: ProviderPictures_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProviderPictures_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProviderRoleArgs = {
  where: ProviderRole_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProviderRole_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProviderStatusArgs = {
  where: ProviderStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProviderStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProviderTypeArgs = {
  where: ProviderType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProviderType_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProviderVisibilityArgs = {
  where: ProviderVisibility_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProviderVisibility_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProvidersArgs = {
  where: Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Providers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RefundsArgs = {
  where: Refunds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Refunds_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RelationshipStatusArgs = {
  where: RelationshipStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RelationshipStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ScheduleArgs = {
  where: Schedule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Schedule_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServiceEmployeesArgs = {
  where: ServiceEmployees_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServiceEmployees_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServiceFormStatusArgs = {
  where: ServiceFormStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServiceFormStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServiceOptionAnswersArgs = {
  where: ServiceOptionAnswers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServiceOptionAnswers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServiceOptionSectionArgs = {
  where: ServiceOptionSection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServiceOptionSectionOptionsArgs = {
  where: ServiceOptionSectionOptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServiceOptionSectionOptions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServiceOptionSection_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServiceOptionsArgs = {
  where: ServiceOptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServiceOptionsStatusArgs = {
  where: ServiceOptionsStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServiceOptionsStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServiceOptions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServicePicturesArgs = {
  where: ServicePictures_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServicePictures_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServicePricingsArgs = {
  where: ServicePricings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServicePricings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServiceSectionOptionQuantityTypeArgs = {
  where: ServiceSectionOptionQuantityType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServiceSectionOptionQuantityType_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServiceSectionOptionTypeArgs = {
  where: ServiceSectionOptionType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServiceSectionOptionType_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServiceStatusArgs = {
  where: ServiceStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServiceStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServicesArgs = {
  where: Services_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServicesFormsArgs = {
  where: ServicesForms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServicesForms_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Services_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SessionsArgs = {
  where: Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sessions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TimeoutsArgs = {
  where: Timeouts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Timeouts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TransitionStatusArgs = {
  where: TransitionStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TransitionStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UnavailableServiceLocationsArgs = {
  where: UnavailableServiceLocations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UnavailableServiceLocations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserRoleArgs = {
  where: UserRole_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserRole_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserRolesArgs = {
  where: UserRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserRoles_By_PkArgs = {
  userId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootExportAppointmentsArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


/** mutation root */
export type Mutation_RootForgotPasswordArgs = {
  email: Scalars['String']['input'];
  verificationToken: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootHandleGoogleOAuthCallbackArgs = {
  authTokens?: InputMaybe<Scalars['JSON']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootInsert_AppointmentPricingArgs = {
  objects: Array<AppointmentPricing_Insert_Input>;
  on_conflict?: InputMaybe<AppointmentPricing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AppointmentPricing_OneArgs = {
  object: AppointmentPricing_Insert_Input;
  on_conflict?: InputMaybe<AppointmentPricing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AppointmentsArgs = {
  objects: Array<Appointments_Insert_Input>;
  on_conflict?: InputMaybe<Appointments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Appointments_OneArgs = {
  object: Appointments_Insert_Input;
  on_conflict?: InputMaybe<Appointments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BookingStatusArgs = {
  objects: Array<BookingStatus_Insert_Input>;
  on_conflict?: InputMaybe<BookingStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BookingStatus_OneArgs = {
  object: BookingStatus_Insert_Input;
  on_conflict?: InputMaybe<BookingStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BuildingProvidersArgs = {
  objects: Array<BuildingProviders_Insert_Input>;
  on_conflict?: InputMaybe<BuildingProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BuildingProviders_OneArgs = {
  object: BuildingProviders_Insert_Input;
  on_conflict?: InputMaybe<BuildingProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BuildingTypeArgs = {
  objects: Array<BuildingType_Insert_Input>;
  on_conflict?: InputMaybe<BuildingType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BuildingType_OneArgs = {
  object: BuildingType_Insert_Input;
  on_conflict?: InputMaybe<BuildingType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CheckoutSessionsArgs = {
  objects: Array<CheckoutSessions_Insert_Input>;
  on_conflict?: InputMaybe<CheckoutSessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CheckoutSessions_OneArgs = {
  object: CheckoutSessions_Insert_Input;
  on_conflict?: InputMaybe<CheckoutSessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CurrenciesArgs = {
  objects: Array<Currencies_Insert_Input>;
  on_conflict?: InputMaybe<Currencies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Currencies_OneArgs = {
  object: Currencies_Insert_Input;
  on_conflict?: InputMaybe<Currencies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CustomersArgs = {
  objects: Array<Customers_Insert_Input>;
  on_conflict?: InputMaybe<Customers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customers_OneArgs = {
  object: Customers_Insert_Input;
  on_conflict?: InputMaybe<Customers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EntityTypeArgs = {
  objects: Array<EntityType_Insert_Input>;
  on_conflict?: InputMaybe<EntityType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EntityType_OneArgs = {
  object: EntityType_Insert_Input;
  on_conflict?: InputMaybe<EntityType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FilesArgs = {
  objects: Array<Files_Insert_Input>;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Files_OneArgs = {
  object: Files_Insert_Input;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FormArgs = {
  objects: Array<Form_Insert_Input>;
  on_conflict?: InputMaybe<Form_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FormAnswersArgs = {
  objects: Array<FormAnswers_Insert_Input>;
  on_conflict?: InputMaybe<FormAnswers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FormAnswers_OneArgs = {
  object: FormAnswers_Insert_Input;
  on_conflict?: InputMaybe<FormAnswers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FormQuestionOptionsArgs = {
  objects: Array<FormQuestionOptions_Insert_Input>;
  on_conflict?: InputMaybe<FormQuestionOptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FormQuestionOptions_OneArgs = {
  object: FormQuestionOptions_Insert_Input;
  on_conflict?: InputMaybe<FormQuestionOptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FormQuestionTypeArgs = {
  objects: Array<FormQuestionType_Insert_Input>;
  on_conflict?: InputMaybe<FormQuestionType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FormQuestionType_OneArgs = {
  object: FormQuestionType_Insert_Input;
  on_conflict?: InputMaybe<FormQuestionType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FormQuestionsArgs = {
  objects: Array<FormQuestions_Insert_Input>;
  on_conflict?: InputMaybe<FormQuestions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FormQuestions_OneArgs = {
  object: FormQuestions_Insert_Input;
  on_conflict?: InputMaybe<FormQuestions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Form_OneArgs = {
  object: Form_Insert_Input;
  on_conflict?: InputMaybe<Form_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_JobStatusArgs = {
  objects: Array<JobStatus_Insert_Input>;
  on_conflict?: InputMaybe<JobStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_JobStatus_OneArgs = {
  object: JobStatus_Insert_Input;
  on_conflict?: InputMaybe<JobStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LocaleArgs = {
  objects: Array<Locale_Insert_Input>;
  on_conflict?: InputMaybe<Locale_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Locale_OneArgs = {
  object: Locale_Insert_Input;
  on_conflict?: InputMaybe<Locale_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LocationStatusArgs = {
  objects: Array<LocationStatus_Insert_Input>;
  on_conflict?: InputMaybe<LocationStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LocationStatus_OneArgs = {
  object: LocationStatus_Insert_Input;
  on_conflict?: InputMaybe<LocationStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LocationTypeArgs = {
  objects: Array<LocationType_Insert_Input>;
  on_conflict?: InputMaybe<LocationType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LocationType_OneArgs = {
  object: LocationType_Insert_Input;
  on_conflict?: InputMaybe<LocationType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LocationsArgs = {
  objects: Array<Locations_Insert_Input>;
  on_conflict?: InputMaybe<Locations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Locations_OneArgs = {
  object: Locations_Insert_Input;
  on_conflict?: InputMaybe<Locations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Locations_With_DistanceArgs = {
  objects: Array<Locations_With_Distance_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Locations_With_Distance_OneArgs = {
  object: Locations_With_Distance_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_NotificationTypeArgs = {
  objects: Array<NotificationType_Insert_Input>;
  on_conflict?: InputMaybe<NotificationType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotificationType_OneArgs = {
  object: NotificationType_Insert_Input;
  on_conflict?: InputMaybe<NotificationType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotificationsArgs = {
  objects: Array<Notifications_Insert_Input>;
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notifications_OneArgs = {
  object: Notifications_Insert_Input;
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PartnershipSchedulingTypeArgs = {
  objects: Array<PartnershipSchedulingType_Insert_Input>;
  on_conflict?: InputMaybe<PartnershipSchedulingType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PartnershipSchedulingType_OneArgs = {
  object: PartnershipSchedulingType_Insert_Input;
  on_conflict?: InputMaybe<PartnershipSchedulingType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PartnershipStatusArgs = {
  objects: Array<PartnershipStatus_Insert_Input>;
  on_conflict?: InputMaybe<PartnershipStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PartnershipStatus_OneArgs = {
  object: PartnershipStatus_Insert_Input;
  on_conflict?: InputMaybe<PartnershipStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PaymentFormatArgs = {
  objects: Array<PaymentFormat_Insert_Input>;
  on_conflict?: InputMaybe<PaymentFormat_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PaymentFormat_OneArgs = {
  object: PaymentFormat_Insert_Input;
  on_conflict?: InputMaybe<PaymentFormat_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PaymentStatusArgs = {
  objects: Array<PaymentStatus_Insert_Input>;
  on_conflict?: InputMaybe<PaymentStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PaymentStatus_OneArgs = {
  object: PaymentStatus_Insert_Input;
  on_conflict?: InputMaybe<PaymentStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PaymentsArgs = {
  objects: Array<Payments_Insert_Input>;
  on_conflict?: InputMaybe<Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payments_OneArgs = {
  object: Payments_Insert_Input;
  on_conflict?: InputMaybe<Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProviderCategoryArgs = {
  objects: Array<ProviderCategory_Insert_Input>;
  on_conflict?: InputMaybe<ProviderCategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProviderCategory_OneArgs = {
  object: ProviderCategory_Insert_Input;
  on_conflict?: InputMaybe<ProviderCategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProviderMonthlyPaymentsArgs = {
  objects: Array<ProviderMonthlyPayments_Insert_Input>;
  on_conflict?: InputMaybe<ProviderMonthlyPayments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProviderMonthlyPayments_OneArgs = {
  object: ProviderMonthlyPayments_Insert_Input;
  on_conflict?: InputMaybe<ProviderMonthlyPayments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProviderPicturesArgs = {
  objects: Array<ProviderPictures_Insert_Input>;
  on_conflict?: InputMaybe<ProviderPictures_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProviderPictures_OneArgs = {
  object: ProviderPictures_Insert_Input;
  on_conflict?: InputMaybe<ProviderPictures_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProviderRoleArgs = {
  objects: Array<ProviderRole_Insert_Input>;
  on_conflict?: InputMaybe<ProviderRole_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProviderRole_OneArgs = {
  object: ProviderRole_Insert_Input;
  on_conflict?: InputMaybe<ProviderRole_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProviderStatusArgs = {
  objects: Array<ProviderStatus_Insert_Input>;
  on_conflict?: InputMaybe<ProviderStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProviderStatus_OneArgs = {
  object: ProviderStatus_Insert_Input;
  on_conflict?: InputMaybe<ProviderStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProviderTypeArgs = {
  objects: Array<ProviderType_Insert_Input>;
  on_conflict?: InputMaybe<ProviderType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProviderType_OneArgs = {
  object: ProviderType_Insert_Input;
  on_conflict?: InputMaybe<ProviderType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProviderVisibilityArgs = {
  objects: Array<ProviderVisibility_Insert_Input>;
  on_conflict?: InputMaybe<ProviderVisibility_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProviderVisibility_OneArgs = {
  object: ProviderVisibility_Insert_Input;
  on_conflict?: InputMaybe<ProviderVisibility_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProvidersArgs = {
  objects: Array<Providers_Insert_Input>;
  on_conflict?: InputMaybe<Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Providers_OneArgs = {
  object: Providers_Insert_Input;
  on_conflict?: InputMaybe<Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RefundsArgs = {
  objects: Array<Refunds_Insert_Input>;
  on_conflict?: InputMaybe<Refunds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refunds_OneArgs = {
  object: Refunds_Insert_Input;
  on_conflict?: InputMaybe<Refunds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RelationshipStatusArgs = {
  objects: Array<RelationshipStatus_Insert_Input>;
  on_conflict?: InputMaybe<RelationshipStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RelationshipStatus_OneArgs = {
  object: RelationshipStatus_Insert_Input;
  on_conflict?: InputMaybe<RelationshipStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ScheduleArgs = {
  objects: Array<Schedule_Insert_Input>;
  on_conflict?: InputMaybe<Schedule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Schedule_OneArgs = {
  object: Schedule_Insert_Input;
  on_conflict?: InputMaybe<Schedule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceEmployeesArgs = {
  objects: Array<ServiceEmployees_Insert_Input>;
  on_conflict?: InputMaybe<ServiceEmployees_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceEmployees_OneArgs = {
  object: ServiceEmployees_Insert_Input;
  on_conflict?: InputMaybe<ServiceEmployees_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceFormStatusArgs = {
  objects: Array<ServiceFormStatus_Insert_Input>;
  on_conflict?: InputMaybe<ServiceFormStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceFormStatus_OneArgs = {
  object: ServiceFormStatus_Insert_Input;
  on_conflict?: InputMaybe<ServiceFormStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceOptionAnswersArgs = {
  objects: Array<ServiceOptionAnswers_Insert_Input>;
  on_conflict?: InputMaybe<ServiceOptionAnswers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceOptionAnswers_OneArgs = {
  object: ServiceOptionAnswers_Insert_Input;
  on_conflict?: InputMaybe<ServiceOptionAnswers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceOptionSectionArgs = {
  objects: Array<ServiceOptionSection_Insert_Input>;
  on_conflict?: InputMaybe<ServiceOptionSection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceOptionSectionOptionsArgs = {
  objects: Array<ServiceOptionSectionOptions_Insert_Input>;
  on_conflict?: InputMaybe<ServiceOptionSectionOptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceOptionSectionOptions_OneArgs = {
  object: ServiceOptionSectionOptions_Insert_Input;
  on_conflict?: InputMaybe<ServiceOptionSectionOptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceOptionSection_OneArgs = {
  object: ServiceOptionSection_Insert_Input;
  on_conflict?: InputMaybe<ServiceOptionSection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceOptionsArgs = {
  objects: Array<ServiceOptions_Insert_Input>;
  on_conflict?: InputMaybe<ServiceOptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceOptionsStatusArgs = {
  objects: Array<ServiceOptionsStatus_Insert_Input>;
  on_conflict?: InputMaybe<ServiceOptionsStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceOptionsStatus_OneArgs = {
  object: ServiceOptionsStatus_Insert_Input;
  on_conflict?: InputMaybe<ServiceOptionsStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceOptions_OneArgs = {
  object: ServiceOptions_Insert_Input;
  on_conflict?: InputMaybe<ServiceOptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServicePicturesArgs = {
  objects: Array<ServicePictures_Insert_Input>;
  on_conflict?: InputMaybe<ServicePictures_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServicePictures_OneArgs = {
  object: ServicePictures_Insert_Input;
  on_conflict?: InputMaybe<ServicePictures_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServicePricingsArgs = {
  objects: Array<ServicePricings_Insert_Input>;
  on_conflict?: InputMaybe<ServicePricings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServicePricings_OneArgs = {
  object: ServicePricings_Insert_Input;
  on_conflict?: InputMaybe<ServicePricings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceSectionOptionQuantityTypeArgs = {
  objects: Array<ServiceSectionOptionQuantityType_Insert_Input>;
  on_conflict?: InputMaybe<ServiceSectionOptionQuantityType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceSectionOptionQuantityType_OneArgs = {
  object: ServiceSectionOptionQuantityType_Insert_Input;
  on_conflict?: InputMaybe<ServiceSectionOptionQuantityType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceSectionOptionTypeArgs = {
  objects: Array<ServiceSectionOptionType_Insert_Input>;
  on_conflict?: InputMaybe<ServiceSectionOptionType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceSectionOptionType_OneArgs = {
  object: ServiceSectionOptionType_Insert_Input;
  on_conflict?: InputMaybe<ServiceSectionOptionType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceStatusArgs = {
  objects: Array<ServiceStatus_Insert_Input>;
  on_conflict?: InputMaybe<ServiceStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceStatus_OneArgs = {
  object: ServiceStatus_Insert_Input;
  on_conflict?: InputMaybe<ServiceStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServicesArgs = {
  objects: Array<Services_Insert_Input>;
  on_conflict?: InputMaybe<Services_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServicesFormsArgs = {
  objects: Array<ServicesForms_Insert_Input>;
  on_conflict?: InputMaybe<ServicesForms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServicesForms_OneArgs = {
  object: ServicesForms_Insert_Input;
  on_conflict?: InputMaybe<ServicesForms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Services_OneArgs = {
  object: Services_Insert_Input;
  on_conflict?: InputMaybe<Services_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SessionsArgs = {
  objects: Array<Sessions_Insert_Input>;
  on_conflict?: InputMaybe<Sessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sessions_OneArgs = {
  object: Sessions_Insert_Input;
  on_conflict?: InputMaybe<Sessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TimeoutsArgs = {
  objects: Array<Timeouts_Insert_Input>;
  on_conflict?: InputMaybe<Timeouts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Timeouts_OneArgs = {
  object: Timeouts_Insert_Input;
  on_conflict?: InputMaybe<Timeouts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TransitionStatusArgs = {
  objects: Array<TransitionStatus_Insert_Input>;
  on_conflict?: InputMaybe<TransitionStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TransitionStatus_OneArgs = {
  object: TransitionStatus_Insert_Input;
  on_conflict?: InputMaybe<TransitionStatus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UnavailableServiceLocationsArgs = {
  objects: Array<UnavailableServiceLocations_Insert_Input>;
  on_conflict?: InputMaybe<UnavailableServiceLocations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UnavailableServiceLocations_OneArgs = {
  object: UnavailableServiceLocations_Insert_Input;
  on_conflict?: InputMaybe<UnavailableServiceLocations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserRoleArgs = {
  objects: Array<UserRole_Insert_Input>;
  on_conflict?: InputMaybe<UserRole_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserRole_OneArgs = {
  object: UserRole_Insert_Input;
  on_conflict?: InputMaybe<UserRole_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserRolesArgs = {
  objects: Array<UserRoles_Insert_Input>;
  on_conflict?: InputMaybe<UserRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserRoles_OneArgs = {
  object: UserRoles_Insert_Input;
  on_conflict?: InputMaybe<UserRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootModifyAppointmentArgs = {
  id: Scalars['String']['input'];
  input: ModifyAppointmentDtoArgs;
};


/** mutation root */
export type Mutation_RootPayBookedAppointmentArgs = {
  appointmentId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootRefreshTokensArgs = {
  refreshToken: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootRegisterArgs = {
  user: UserRegisterInputDto;
};


/** mutation root */
export type Mutation_RootRegisterBuildingManagerArgs = {
  buildingManager: BuildingManagerRegisterInputDto;
};


/** mutation root */
export type Mutation_RootRegisterProviderArgs = {
  provider: ProviderRegisterInputDto;
  user: UserRegisterInputDto;
};


/** mutation root */
export type Mutation_RootRequestForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootRequestLocationPartnershipArgs = {
  locationId: Scalars['String']['input'];
  partnershipSchedulingType: Scalars['String']['input'];
  scheduleLocationId?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootSetEmployeeCalendarArgs = {
  calendarId: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootUpdateUserPhoneArgs = {
  phoneNumber: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootUpdate_AppointmentPricingArgs = {
  _append?: InputMaybe<AppointmentPricing_Append_Input>;
  _delete_at_path?: InputMaybe<AppointmentPricing_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AppointmentPricing_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AppointmentPricing_Delete_Key_Input>;
  _inc?: InputMaybe<AppointmentPricing_Inc_Input>;
  _prepend?: InputMaybe<AppointmentPricing_Prepend_Input>;
  _set?: InputMaybe<AppointmentPricing_Set_Input>;
  where: AppointmentPricing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AppointmentPricing_By_PkArgs = {
  _append?: InputMaybe<AppointmentPricing_Append_Input>;
  _delete_at_path?: InputMaybe<AppointmentPricing_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AppointmentPricing_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AppointmentPricing_Delete_Key_Input>;
  _inc?: InputMaybe<AppointmentPricing_Inc_Input>;
  _prepend?: InputMaybe<AppointmentPricing_Prepend_Input>;
  _set?: InputMaybe<AppointmentPricing_Set_Input>;
  pk_columns: AppointmentPricing_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_AppointmentPricing_ManyArgs = {
  updates: Array<AppointmentPricing_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AppointmentsArgs = {
  _set?: InputMaybe<Appointments_Set_Input>;
  where: Appointments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Appointments_By_PkArgs = {
  _set?: InputMaybe<Appointments_Set_Input>;
  pk_columns: Appointments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Appointments_ManyArgs = {
  updates: Array<Appointments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BookingStatusArgs = {
  _set?: InputMaybe<BookingStatus_Set_Input>;
  where: BookingStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_BookingStatus_By_PkArgs = {
  _set?: InputMaybe<BookingStatus_Set_Input>;
  pk_columns: BookingStatus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BookingStatus_ManyArgs = {
  updates: Array<BookingStatus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingProvidersArgs = {
  _set?: InputMaybe<BuildingProviders_Set_Input>;
  where: BuildingProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingProviders_By_PkArgs = {
  _set?: InputMaybe<BuildingProviders_Set_Input>;
  pk_columns: BuildingProviders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingProviders_ManyArgs = {
  updates: Array<BuildingProviders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingTypeArgs = {
  _set?: InputMaybe<BuildingType_Set_Input>;
  where: BuildingType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingType_By_PkArgs = {
  _set?: InputMaybe<BuildingType_Set_Input>;
  pk_columns: BuildingType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BuildingType_ManyArgs = {
  updates: Array<BuildingType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CheckoutSessionsArgs = {
  _set?: InputMaybe<CheckoutSessions_Set_Input>;
  where: CheckoutSessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_CheckoutSessions_By_PkArgs = {
  _set?: InputMaybe<CheckoutSessions_Set_Input>;
  pk_columns: CheckoutSessions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CheckoutSessions_ManyArgs = {
  updates: Array<CheckoutSessions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CurrenciesArgs = {
  _set?: InputMaybe<Currencies_Set_Input>;
  where: Currencies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Currencies_By_PkArgs = {
  _set?: InputMaybe<Currencies_Set_Input>;
  pk_columns: Currencies_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Currencies_ManyArgs = {
  updates: Array<Currencies_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CustomersArgs = {
  _set?: InputMaybe<Customers_Set_Input>;
  where: Customers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customers_By_PkArgs = {
  _set?: InputMaybe<Customers_Set_Input>;
  pk_columns: Customers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customers_ManyArgs = {
  updates: Array<Customers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EntityTypeArgs = {
  _set?: InputMaybe<EntityType_Set_Input>;
  where: EntityType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EntityType_By_PkArgs = {
  _set?: InputMaybe<EntityType_Set_Input>;
  pk_columns: EntityType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EntityType_ManyArgs = {
  updates: Array<EntityType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FilesArgs = {
  _set?: InputMaybe<Files_Set_Input>;
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Files_By_PkArgs = {
  _set?: InputMaybe<Files_Set_Input>;
  pk_columns: Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Files_ManyArgs = {
  updates: Array<Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FormArgs = {
  _set?: InputMaybe<Form_Set_Input>;
  where: Form_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_FormAnswersArgs = {
  _set?: InputMaybe<FormAnswers_Set_Input>;
  where: FormAnswers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_FormAnswers_By_PkArgs = {
  _set?: InputMaybe<FormAnswers_Set_Input>;
  pk_columns: FormAnswers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_FormAnswers_ManyArgs = {
  updates: Array<FormAnswers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FormQuestionOptionsArgs = {
  _set?: InputMaybe<FormQuestionOptions_Set_Input>;
  where: FormQuestionOptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_FormQuestionOptions_By_PkArgs = {
  _set?: InputMaybe<FormQuestionOptions_Set_Input>;
  pk_columns: FormQuestionOptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_FormQuestionOptions_ManyArgs = {
  updates: Array<FormQuestionOptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FormQuestionTypeArgs = {
  _set?: InputMaybe<FormQuestionType_Set_Input>;
  where: FormQuestionType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_FormQuestionType_By_PkArgs = {
  _set?: InputMaybe<FormQuestionType_Set_Input>;
  pk_columns: FormQuestionType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_FormQuestionType_ManyArgs = {
  updates: Array<FormQuestionType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FormQuestionsArgs = {
  _inc?: InputMaybe<FormQuestions_Inc_Input>;
  _set?: InputMaybe<FormQuestions_Set_Input>;
  where: FormQuestions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_FormQuestions_By_PkArgs = {
  _inc?: InputMaybe<FormQuestions_Inc_Input>;
  _set?: InputMaybe<FormQuestions_Set_Input>;
  pk_columns: FormQuestions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_FormQuestions_ManyArgs = {
  updates: Array<FormQuestions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Form_By_PkArgs = {
  _set?: InputMaybe<Form_Set_Input>;
  pk_columns: Form_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Form_ManyArgs = {
  updates: Array<Form_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_JobStatusArgs = {
  _set?: InputMaybe<JobStatus_Set_Input>;
  where: JobStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_JobStatus_By_PkArgs = {
  _set?: InputMaybe<JobStatus_Set_Input>;
  pk_columns: JobStatus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_JobStatus_ManyArgs = {
  updates: Array<JobStatus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LocaleArgs = {
  _set?: InputMaybe<Locale_Set_Input>;
  where: Locale_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Locale_By_PkArgs = {
  _set?: InputMaybe<Locale_Set_Input>;
  pk_columns: Locale_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Locale_ManyArgs = {
  updates: Array<Locale_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LocationStatusArgs = {
  _set?: InputMaybe<LocationStatus_Set_Input>;
  where: LocationStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_LocationStatus_By_PkArgs = {
  _set?: InputMaybe<LocationStatus_Set_Input>;
  pk_columns: LocationStatus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_LocationStatus_ManyArgs = {
  updates: Array<LocationStatus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LocationTypeArgs = {
  _set?: InputMaybe<LocationType_Set_Input>;
  where: LocationType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_LocationType_By_PkArgs = {
  _set?: InputMaybe<LocationType_Set_Input>;
  pk_columns: LocationType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_LocationType_ManyArgs = {
  updates: Array<LocationType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LocationsArgs = {
  _inc?: InputMaybe<Locations_Inc_Input>;
  _set?: InputMaybe<Locations_Set_Input>;
  where: Locations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Locations_By_PkArgs = {
  _inc?: InputMaybe<Locations_Inc_Input>;
  _set?: InputMaybe<Locations_Set_Input>;
  pk_columns: Locations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Locations_ManyArgs = {
  updates: Array<Locations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Locations_With_DistanceArgs = {
  _inc?: InputMaybe<Locations_With_Distance_Inc_Input>;
  _set?: InputMaybe<Locations_With_Distance_Set_Input>;
  where: Locations_With_Distance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Locations_With_Distance_ManyArgs = {
  updates: Array<Locations_With_Distance_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationTypeArgs = {
  _set?: InputMaybe<NotificationType_Set_Input>;
  where: NotificationType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationType_By_PkArgs = {
  _set?: InputMaybe<NotificationType_Set_Input>;
  pk_columns: NotificationType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationType_ManyArgs = {
  updates: Array<NotificationType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationsArgs = {
  _set?: InputMaybe<Notifications_Set_Input>;
  where: Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notifications_By_PkArgs = {
  _set?: InputMaybe<Notifications_Set_Input>;
  pk_columns: Notifications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notifications_ManyArgs = {
  updates: Array<Notifications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PartnershipSchedulingTypeArgs = {
  _set?: InputMaybe<PartnershipSchedulingType_Set_Input>;
  where: PartnershipSchedulingType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PartnershipSchedulingType_By_PkArgs = {
  _set?: InputMaybe<PartnershipSchedulingType_Set_Input>;
  pk_columns: PartnershipSchedulingType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PartnershipSchedulingType_ManyArgs = {
  updates: Array<PartnershipSchedulingType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PartnershipStatusArgs = {
  _set?: InputMaybe<PartnershipStatus_Set_Input>;
  where: PartnershipStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PartnershipStatus_By_PkArgs = {
  _set?: InputMaybe<PartnershipStatus_Set_Input>;
  pk_columns: PartnershipStatus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PartnershipStatus_ManyArgs = {
  updates: Array<PartnershipStatus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PaymentFormatArgs = {
  _set?: InputMaybe<PaymentFormat_Set_Input>;
  where: PaymentFormat_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PaymentFormat_By_PkArgs = {
  _set?: InputMaybe<PaymentFormat_Set_Input>;
  pk_columns: PaymentFormat_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PaymentFormat_ManyArgs = {
  updates: Array<PaymentFormat_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PaymentStatusArgs = {
  _set?: InputMaybe<PaymentStatus_Set_Input>;
  where: PaymentStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PaymentStatus_By_PkArgs = {
  _set?: InputMaybe<PaymentStatus_Set_Input>;
  pk_columns: PaymentStatus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PaymentStatus_ManyArgs = {
  updates: Array<PaymentStatus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PaymentsArgs = {
  _append?: InputMaybe<Payments_Append_Input>;
  _delete_at_path?: InputMaybe<Payments_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Payments_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Payments_Delete_Key_Input>;
  _inc?: InputMaybe<Payments_Inc_Input>;
  _prepend?: InputMaybe<Payments_Prepend_Input>;
  _set?: InputMaybe<Payments_Set_Input>;
  where: Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payments_By_PkArgs = {
  _append?: InputMaybe<Payments_Append_Input>;
  _delete_at_path?: InputMaybe<Payments_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Payments_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Payments_Delete_Key_Input>;
  _inc?: InputMaybe<Payments_Inc_Input>;
  _prepend?: InputMaybe<Payments_Prepend_Input>;
  _set?: InputMaybe<Payments_Set_Input>;
  pk_columns: Payments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payments_ManyArgs = {
  updates: Array<Payments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderCategoryArgs = {
  _set?: InputMaybe<ProviderCategory_Set_Input>;
  where: ProviderCategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderCategory_By_PkArgs = {
  _set?: InputMaybe<ProviderCategory_Set_Input>;
  pk_columns: ProviderCategory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderCategory_ManyArgs = {
  updates: Array<ProviderCategory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderMonthlyPaymentsArgs = {
  _inc?: InputMaybe<ProviderMonthlyPayments_Inc_Input>;
  _set?: InputMaybe<ProviderMonthlyPayments_Set_Input>;
  where: ProviderMonthlyPayments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderMonthlyPayments_By_PkArgs = {
  _inc?: InputMaybe<ProviderMonthlyPayments_Inc_Input>;
  _set?: InputMaybe<ProviderMonthlyPayments_Set_Input>;
  pk_columns: ProviderMonthlyPayments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderMonthlyPayments_ManyArgs = {
  updates: Array<ProviderMonthlyPayments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderPicturesArgs = {
  _set?: InputMaybe<ProviderPictures_Set_Input>;
  where: ProviderPictures_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderPictures_By_PkArgs = {
  _set?: InputMaybe<ProviderPictures_Set_Input>;
  pk_columns: ProviderPictures_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderPictures_ManyArgs = {
  updates: Array<ProviderPictures_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderRoleArgs = {
  _set?: InputMaybe<ProviderRole_Set_Input>;
  where: ProviderRole_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderRole_By_PkArgs = {
  _set?: InputMaybe<ProviderRole_Set_Input>;
  pk_columns: ProviderRole_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderRole_ManyArgs = {
  updates: Array<ProviderRole_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderStatusArgs = {
  _set?: InputMaybe<ProviderStatus_Set_Input>;
  where: ProviderStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderStatus_By_PkArgs = {
  _set?: InputMaybe<ProviderStatus_Set_Input>;
  pk_columns: ProviderStatus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderStatus_ManyArgs = {
  updates: Array<ProviderStatus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderTypeArgs = {
  _set?: InputMaybe<ProviderType_Set_Input>;
  where: ProviderType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderType_By_PkArgs = {
  _set?: InputMaybe<ProviderType_Set_Input>;
  pk_columns: ProviderType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderType_ManyArgs = {
  updates: Array<ProviderType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderVisibilityArgs = {
  _set?: InputMaybe<ProviderVisibility_Set_Input>;
  where: ProviderVisibility_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderVisibility_By_PkArgs = {
  _set?: InputMaybe<ProviderVisibility_Set_Input>;
  pk_columns: ProviderVisibility_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProviderVisibility_ManyArgs = {
  updates: Array<ProviderVisibility_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProvidersArgs = {
  _append?: InputMaybe<Providers_Append_Input>;
  _delete_at_path?: InputMaybe<Providers_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Providers_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Providers_Delete_Key_Input>;
  _inc?: InputMaybe<Providers_Inc_Input>;
  _prepend?: InputMaybe<Providers_Prepend_Input>;
  _set?: InputMaybe<Providers_Set_Input>;
  where: Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Providers_By_PkArgs = {
  _append?: InputMaybe<Providers_Append_Input>;
  _delete_at_path?: InputMaybe<Providers_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Providers_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Providers_Delete_Key_Input>;
  _inc?: InputMaybe<Providers_Inc_Input>;
  _prepend?: InputMaybe<Providers_Prepend_Input>;
  _set?: InputMaybe<Providers_Set_Input>;
  pk_columns: Providers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Providers_ManyArgs = {
  updates: Array<Providers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RefundsArgs = {
  _append?: InputMaybe<Refunds_Append_Input>;
  _delete_at_path?: InputMaybe<Refunds_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Refunds_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Refunds_Delete_Key_Input>;
  _inc?: InputMaybe<Refunds_Inc_Input>;
  _prepend?: InputMaybe<Refunds_Prepend_Input>;
  _set?: InputMaybe<Refunds_Set_Input>;
  where: Refunds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Refunds_By_PkArgs = {
  _append?: InputMaybe<Refunds_Append_Input>;
  _delete_at_path?: InputMaybe<Refunds_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Refunds_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Refunds_Delete_Key_Input>;
  _inc?: InputMaybe<Refunds_Inc_Input>;
  _prepend?: InputMaybe<Refunds_Prepend_Input>;
  _set?: InputMaybe<Refunds_Set_Input>;
  pk_columns: Refunds_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Refunds_ManyArgs = {
  updates: Array<Refunds_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RelationshipStatusArgs = {
  _set?: InputMaybe<RelationshipStatus_Set_Input>;
  where: RelationshipStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_RelationshipStatus_By_PkArgs = {
  _set?: InputMaybe<RelationshipStatus_Set_Input>;
  pk_columns: RelationshipStatus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RelationshipStatus_ManyArgs = {
  updates: Array<RelationshipStatus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ScheduleArgs = {
  _set?: InputMaybe<Schedule_Set_Input>;
  where: Schedule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Schedule_By_PkArgs = {
  _set?: InputMaybe<Schedule_Set_Input>;
  pk_columns: Schedule_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Schedule_ManyArgs = {
  updates: Array<Schedule_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceEmployeesArgs = {
  _set?: InputMaybe<ServiceEmployees_Set_Input>;
  where: ServiceEmployees_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceEmployees_By_PkArgs = {
  _set?: InputMaybe<ServiceEmployees_Set_Input>;
  pk_columns: ServiceEmployees_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceEmployees_ManyArgs = {
  updates: Array<ServiceEmployees_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceFormStatusArgs = {
  _set?: InputMaybe<ServiceFormStatus_Set_Input>;
  where: ServiceFormStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceFormStatus_By_PkArgs = {
  _set?: InputMaybe<ServiceFormStatus_Set_Input>;
  pk_columns: ServiceFormStatus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceFormStatus_ManyArgs = {
  updates: Array<ServiceFormStatus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceOptionAnswersArgs = {
  _inc?: InputMaybe<ServiceOptionAnswers_Inc_Input>;
  _set?: InputMaybe<ServiceOptionAnswers_Set_Input>;
  where: ServiceOptionAnswers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceOptionAnswers_By_PkArgs = {
  _inc?: InputMaybe<ServiceOptionAnswers_Inc_Input>;
  _set?: InputMaybe<ServiceOptionAnswers_Set_Input>;
  pk_columns: ServiceOptionAnswers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceOptionAnswers_ManyArgs = {
  updates: Array<ServiceOptionAnswers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceOptionSectionArgs = {
  _inc?: InputMaybe<ServiceOptionSection_Inc_Input>;
  _set?: InputMaybe<ServiceOptionSection_Set_Input>;
  where: ServiceOptionSection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceOptionSectionOptionsArgs = {
  _inc?: InputMaybe<ServiceOptionSectionOptions_Inc_Input>;
  _set?: InputMaybe<ServiceOptionSectionOptions_Set_Input>;
  where: ServiceOptionSectionOptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceOptionSectionOptions_By_PkArgs = {
  _inc?: InputMaybe<ServiceOptionSectionOptions_Inc_Input>;
  _set?: InputMaybe<ServiceOptionSectionOptions_Set_Input>;
  pk_columns: ServiceOptionSectionOptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceOptionSectionOptions_ManyArgs = {
  updates: Array<ServiceOptionSectionOptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceOptionSection_By_PkArgs = {
  _inc?: InputMaybe<ServiceOptionSection_Inc_Input>;
  _set?: InputMaybe<ServiceOptionSection_Set_Input>;
  pk_columns: ServiceOptionSection_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceOptionSection_ManyArgs = {
  updates: Array<ServiceOptionSection_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceOptionsArgs = {
  _set?: InputMaybe<ServiceOptions_Set_Input>;
  where: ServiceOptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceOptionsStatusArgs = {
  _set?: InputMaybe<ServiceOptionsStatus_Set_Input>;
  where: ServiceOptionsStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceOptionsStatus_By_PkArgs = {
  _set?: InputMaybe<ServiceOptionsStatus_Set_Input>;
  pk_columns: ServiceOptionsStatus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceOptionsStatus_ManyArgs = {
  updates: Array<ServiceOptionsStatus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceOptions_By_PkArgs = {
  _set?: InputMaybe<ServiceOptions_Set_Input>;
  pk_columns: ServiceOptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceOptions_ManyArgs = {
  updates: Array<ServiceOptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServicePicturesArgs = {
  _set?: InputMaybe<ServicePictures_Set_Input>;
  where: ServicePictures_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServicePictures_By_PkArgs = {
  _set?: InputMaybe<ServicePictures_Set_Input>;
  pk_columns: ServicePictures_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ServicePictures_ManyArgs = {
  updates: Array<ServicePictures_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServicePricingsArgs = {
  _append?: InputMaybe<ServicePricings_Append_Input>;
  _delete_at_path?: InputMaybe<ServicePricings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<ServicePricings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<ServicePricings_Delete_Key_Input>;
  _inc?: InputMaybe<ServicePricings_Inc_Input>;
  _prepend?: InputMaybe<ServicePricings_Prepend_Input>;
  _set?: InputMaybe<ServicePricings_Set_Input>;
  where: ServicePricings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServicePricings_By_PkArgs = {
  _append?: InputMaybe<ServicePricings_Append_Input>;
  _delete_at_path?: InputMaybe<ServicePricings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<ServicePricings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<ServicePricings_Delete_Key_Input>;
  _inc?: InputMaybe<ServicePricings_Inc_Input>;
  _prepend?: InputMaybe<ServicePricings_Prepend_Input>;
  _set?: InputMaybe<ServicePricings_Set_Input>;
  pk_columns: ServicePricings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ServicePricings_ManyArgs = {
  updates: Array<ServicePricings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceSectionOptionQuantityTypeArgs = {
  _set?: InputMaybe<ServiceSectionOptionQuantityType_Set_Input>;
  where: ServiceSectionOptionQuantityType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceSectionOptionQuantityType_By_PkArgs = {
  _set?: InputMaybe<ServiceSectionOptionQuantityType_Set_Input>;
  pk_columns: ServiceSectionOptionQuantityType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceSectionOptionQuantityType_ManyArgs = {
  updates: Array<ServiceSectionOptionQuantityType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceSectionOptionTypeArgs = {
  _set?: InputMaybe<ServiceSectionOptionType_Set_Input>;
  where: ServiceSectionOptionType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceSectionOptionType_By_PkArgs = {
  _set?: InputMaybe<ServiceSectionOptionType_Set_Input>;
  pk_columns: ServiceSectionOptionType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceSectionOptionType_ManyArgs = {
  updates: Array<ServiceSectionOptionType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceStatusArgs = {
  _set?: InputMaybe<ServiceStatus_Set_Input>;
  where: ServiceStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceStatus_By_PkArgs = {
  _set?: InputMaybe<ServiceStatus_Set_Input>;
  pk_columns: ServiceStatus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceStatus_ManyArgs = {
  updates: Array<ServiceStatus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServicesArgs = {
  _inc?: InputMaybe<Services_Inc_Input>;
  _set?: InputMaybe<Services_Set_Input>;
  where: Services_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServicesFormsArgs = {
  _set?: InputMaybe<ServicesForms_Set_Input>;
  where: ServicesForms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServicesForms_By_PkArgs = {
  _set?: InputMaybe<ServicesForms_Set_Input>;
  pk_columns: ServicesForms_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ServicesForms_ManyArgs = {
  updates: Array<ServicesForms_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Services_By_PkArgs = {
  _inc?: InputMaybe<Services_Inc_Input>;
  _set?: InputMaybe<Services_Set_Input>;
  pk_columns: Services_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Services_ManyArgs = {
  updates: Array<Services_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SessionsArgs = {
  _set?: InputMaybe<Sessions_Set_Input>;
  where: Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sessions_By_PkArgs = {
  _set?: InputMaybe<Sessions_Set_Input>;
  pk_columns: Sessions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sessions_ManyArgs = {
  updates: Array<Sessions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TimeoutsArgs = {
  _set?: InputMaybe<Timeouts_Set_Input>;
  where: Timeouts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Timeouts_By_PkArgs = {
  _set?: InputMaybe<Timeouts_Set_Input>;
  pk_columns: Timeouts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Timeouts_ManyArgs = {
  updates: Array<Timeouts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TransitionStatusArgs = {
  _set?: InputMaybe<TransitionStatus_Set_Input>;
  where: TransitionStatus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TransitionStatus_By_PkArgs = {
  _set?: InputMaybe<TransitionStatus_Set_Input>;
  pk_columns: TransitionStatus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TransitionStatus_ManyArgs = {
  updates: Array<TransitionStatus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UnavailableServiceLocationsArgs = {
  _set?: InputMaybe<UnavailableServiceLocations_Set_Input>;
  where: UnavailableServiceLocations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UnavailableServiceLocations_By_PkArgs = {
  _set?: InputMaybe<UnavailableServiceLocations_Set_Input>;
  pk_columns: UnavailableServiceLocations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UnavailableServiceLocations_ManyArgs = {
  updates: Array<UnavailableServiceLocations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserRoleArgs = {
  _set?: InputMaybe<UserRole_Set_Input>;
  where: UserRole_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserRole_By_PkArgs = {
  _set?: InputMaybe<UserRole_Set_Input>;
  pk_columns: UserRole_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserRole_ManyArgs = {
  updates: Array<UserRole_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserRolesArgs = {
  _set?: InputMaybe<UserRoles_Set_Input>;
  where: UserRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserRoles_By_PkArgs = {
  _set?: InputMaybe<UserRoles_Set_Input>;
  pk_columns: UserRoles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserRoles_ManyArgs = {
  updates: Array<UserRoles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootVerifyEmailArgs = {
  token: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootVerifyPhoneNumberArgs = {
  token: Scalars['String']['input'];
};

export type Nest_BuildingProviders = {
  __typename?: 'nest_buildingProviders';
  id: Scalars['String']['output'];
  partnershipSchedulingType: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "notificationType" */
export type NotificationType = {
  __typename?: 'notificationType';
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "notificationType" */
export type NotificationTypeNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "notificationType" */
export type NotificationTypeNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** aggregated selection of "notificationType" */
export type NotificationType_Aggregate = {
  __typename?: 'notificationType_aggregate';
  aggregate?: Maybe<NotificationType_Aggregate_Fields>;
  nodes: Array<NotificationType>;
};

/** aggregate fields of "notificationType" */
export type NotificationType_Aggregate_Fields = {
  __typename?: 'notificationType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<NotificationType_Max_Fields>;
  min?: Maybe<NotificationType_Min_Fields>;
};


/** aggregate fields of "notificationType" */
export type NotificationType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "notificationType". All fields are combined with a logical 'AND'. */
export type NotificationType_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationType_Bool_Exp>>;
  _not?: InputMaybe<NotificationType_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationType_Bool_Exp>>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notificationType" */
export enum NotificationType_Constraint {
  /** unique or primary key constraint on columns "value" */
  NotificationTypePkey = 'notificationType_pkey'
}

export enum NotificationType_Enum {
  AppointmentCancelled = 'appointment_cancelled',
  AppointmentUpdate = 'appointment_update',
  ApprovedPendingPartnership = 'approved_pending_partnership',
  ApprovedPendingService = 'approved_pending_service',
  AutomaticApproval = 'automatic_approval',
  NewApprovedPartnership = 'new_approved_partnership',
  NewPartnershipRequest = 'new_partnership_request',
  PaymentReceived = 'payment_received',
  RefundReceived = 'refund_received',
  RejectedPendingPartnership = 'rejected_pending_partnership',
  WaitForApproval = 'wait_for_approval'
}

/** Boolean expression to compare columns of type "notificationType_enum". All fields are combined with logical 'AND'. */
export type NotificationType_Enum_Comparison_Exp = {
  _eq?: InputMaybe<NotificationType_Enum>;
  _in?: InputMaybe<Array<NotificationType_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<NotificationType_Enum>;
  _nin?: InputMaybe<Array<NotificationType_Enum>>;
};

/** input type for inserting data into table "notificationType" */
export type NotificationType_Insert_Input = {
  notifications?: InputMaybe<Notifications_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type NotificationType_Max_Fields = {
  __typename?: 'notificationType_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type NotificationType_Min_Fields = {
  __typename?: 'notificationType_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "notificationType" */
export type NotificationType_Mutation_Response = {
  __typename?: 'notificationType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationType>;
};

/** input type for inserting object relation for remote table "notificationType" */
export type NotificationType_Obj_Rel_Insert_Input = {
  data: NotificationType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationType_On_Conflict>;
};

/** on_conflict condition type for table "notificationType" */
export type NotificationType_On_Conflict = {
  constraint: NotificationType_Constraint;
  update_columns?: Array<NotificationType_Update_Column>;
  where?: InputMaybe<NotificationType_Bool_Exp>;
};

/** Ordering options when selecting data from "notificationType". */
export type NotificationType_Order_By = {
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notificationType */
export type NotificationType_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "notificationType" */
export enum NotificationType_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "notificationType" */
export type NotificationType_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "notificationType" */
export type NotificationType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationType_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "notificationType" */
export enum NotificationType_Update_Column {
  /** column name */
  Value = 'value'
}

export type NotificationType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationType_Set_Input>;
  /** filter the rows which have to be updated */
  where: NotificationType_Bool_Exp;
};

/** columns and relationships of "notifications" */
export type Notifications = {
  __typename?: 'notifications';
  createdAt: Scalars['timestamptz']['output'];
  entityId?: Maybe<Scalars['uuid']['output']>;
  entityType?: Maybe<EntityType_Enum>;
  /** An object relationship */
  fromUser?: Maybe<Users>;
  fromUserId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  notificationType: NotificationType;
  readAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  toUser: Users;
  toUserId: Scalars['uuid']['output'];
  type: NotificationType_Enum;
  updatedAt: Scalars['timestamptz']['output'];
  viewedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "notifications" */
export type Notifications_Aggregate = {
  __typename?: 'notifications_aggregate';
  aggregate?: Maybe<Notifications_Aggregate_Fields>;
  nodes: Array<Notifications>;
};

export type Notifications_Aggregate_Bool_Exp = {
  count?: InputMaybe<Notifications_Aggregate_Bool_Exp_Count>;
};

export type Notifications_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notifications_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "notifications" */
export type Notifications_Aggregate_Fields = {
  __typename?: 'notifications_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Notifications_Max_Fields>;
  min?: Maybe<Notifications_Min_Fields>;
};


/** aggregate fields of "notifications" */
export type Notifications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "notifications" */
export type Notifications_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notifications_Max_Order_By>;
  min?: InputMaybe<Notifications_Min_Order_By>;
};

/** input type for inserting array relation for remote table "notifications" */
export type Notifications_Arr_Rel_Insert_Input = {
  data: Array<Notifications_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};

/** Boolean expression to filter rows from the table "notifications". All fields are combined with a logical 'AND'. */
export type Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Notifications_Bool_Exp>>;
  _not?: InputMaybe<Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Notifications_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  entityId?: InputMaybe<Uuid_Comparison_Exp>;
  entityType?: InputMaybe<EntityType_Enum_Comparison_Exp>;
  fromUser?: InputMaybe<Users_Bool_Exp>;
  fromUserId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notificationType?: InputMaybe<NotificationType_Bool_Exp>;
  readAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  toUser?: InputMaybe<Users_Bool_Exp>;
  toUserId?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<NotificationType_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  viewedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "notifications" */
export enum Notifications_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationsPkey = 'notifications_pkey'
}

/** input type for inserting data into table "notifications" */
export type Notifications_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['uuid']['input']>;
  entityType?: InputMaybe<EntityType_Enum>;
  fromUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  fromUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notificationType?: InputMaybe<NotificationType_Obj_Rel_Insert_Input>;
  readAt?: InputMaybe<Scalars['timestamptz']['input']>;
  toUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  toUserId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<NotificationType_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Notifications_Max_Fields = {
  __typename?: 'notifications_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  entityId?: Maybe<Scalars['uuid']['output']>;
  fromUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  readAt?: Maybe<Scalars['timestamptz']['output']>;
  toUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  viewedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "notifications" */
export type Notifications_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  fromUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  readAt?: InputMaybe<Order_By>;
  toUserId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  viewedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Notifications_Min_Fields = {
  __typename?: 'notifications_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  entityId?: Maybe<Scalars['uuid']['output']>;
  fromUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  readAt?: Maybe<Scalars['timestamptz']['output']>;
  toUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  viewedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "notifications" */
export type Notifications_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  fromUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  readAt?: InputMaybe<Order_By>;
  toUserId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  viewedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notifications" */
export type Notifications_Mutation_Response = {
  __typename?: 'notifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Notifications>;
};

/** input type for inserting object relation for remote table "notifications" */
export type Notifications_Obj_Rel_Insert_Input = {
  data: Notifications_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};

/** on_conflict condition type for table "notifications" */
export type Notifications_On_Conflict = {
  constraint: Notifications_Constraint;
  update_columns?: Array<Notifications_Update_Column>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** Ordering options when selecting data from "notifications". */
export type Notifications_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  entityId?: InputMaybe<Order_By>;
  entityType?: InputMaybe<Order_By>;
  fromUser?: InputMaybe<Users_Order_By>;
  fromUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationType?: InputMaybe<NotificationType_Order_By>;
  readAt?: InputMaybe<Order_By>;
  toUser?: InputMaybe<Users_Order_By>;
  toUserId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  viewedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notifications */
export type Notifications_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "notifications" */
export enum Notifications_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  EntityType = 'entityType',
  /** column name */
  FromUserId = 'fromUserId',
  /** column name */
  Id = 'id',
  /** column name */
  ReadAt = 'readAt',
  /** column name */
  ToUserId = 'toUserId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ViewedAt = 'viewedAt'
}

/** input type for updating data in table "notifications" */
export type Notifications_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['uuid']['input']>;
  entityType?: InputMaybe<EntityType_Enum>;
  fromUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  readAt?: InputMaybe<Scalars['timestamptz']['input']>;
  toUserId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<NotificationType_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "notifications" */
export type Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notifications_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['uuid']['input']>;
  entityType?: InputMaybe<EntityType_Enum>;
  fromUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  readAt?: InputMaybe<Scalars['timestamptz']['input']>;
  toUserId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<NotificationType_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "notifications" */
export enum Notifications_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EntityId = 'entityId',
  /** column name */
  EntityType = 'entityType',
  /** column name */
  FromUserId = 'fromUserId',
  /** column name */
  Id = 'id',
  /** column name */
  ReadAt = 'readAt',
  /** column name */
  ToUserId = 'toUserId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ViewedAt = 'viewedAt'
}

export type Notifications_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notifications_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notifications_Bool_Exp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "partnershipSchedulingType" */
export type PartnershipSchedulingType = {
  __typename?: 'partnershipSchedulingType';
  value: Scalars['String']['output'];
};

/** aggregated selection of "partnershipSchedulingType" */
export type PartnershipSchedulingType_Aggregate = {
  __typename?: 'partnershipSchedulingType_aggregate';
  aggregate?: Maybe<PartnershipSchedulingType_Aggregate_Fields>;
  nodes: Array<PartnershipSchedulingType>;
};

/** aggregate fields of "partnershipSchedulingType" */
export type PartnershipSchedulingType_Aggregate_Fields = {
  __typename?: 'partnershipSchedulingType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<PartnershipSchedulingType_Max_Fields>;
  min?: Maybe<PartnershipSchedulingType_Min_Fields>;
};


/** aggregate fields of "partnershipSchedulingType" */
export type PartnershipSchedulingType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PartnershipSchedulingType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "partnershipSchedulingType". All fields are combined with a logical 'AND'. */
export type PartnershipSchedulingType_Bool_Exp = {
  _and?: InputMaybe<Array<PartnershipSchedulingType_Bool_Exp>>;
  _not?: InputMaybe<PartnershipSchedulingType_Bool_Exp>;
  _or?: InputMaybe<Array<PartnershipSchedulingType_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "partnershipSchedulingType" */
export enum PartnershipSchedulingType_Constraint {
  /** unique or primary key constraint on columns "value" */
  PartnershipSchedulingTypePkey = 'partnershipSchedulingType_pkey'
}

export enum PartnershipSchedulingType_Enum {
  Custom = 'custom',
  OtherSchedules = 'other_schedules'
}

/** Boolean expression to compare columns of type "partnershipSchedulingType_enum". All fields are combined with logical 'AND'. */
export type PartnershipSchedulingType_Enum_Comparison_Exp = {
  _eq?: InputMaybe<PartnershipSchedulingType_Enum>;
  _in?: InputMaybe<Array<PartnershipSchedulingType_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<PartnershipSchedulingType_Enum>;
  _nin?: InputMaybe<Array<PartnershipSchedulingType_Enum>>;
};

/** input type for inserting data into table "partnershipSchedulingType" */
export type PartnershipSchedulingType_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type PartnershipSchedulingType_Max_Fields = {
  __typename?: 'partnershipSchedulingType_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type PartnershipSchedulingType_Min_Fields = {
  __typename?: 'partnershipSchedulingType_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "partnershipSchedulingType" */
export type PartnershipSchedulingType_Mutation_Response = {
  __typename?: 'partnershipSchedulingType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PartnershipSchedulingType>;
};

/** on_conflict condition type for table "partnershipSchedulingType" */
export type PartnershipSchedulingType_On_Conflict = {
  constraint: PartnershipSchedulingType_Constraint;
  update_columns?: Array<PartnershipSchedulingType_Update_Column>;
  where?: InputMaybe<PartnershipSchedulingType_Bool_Exp>;
};

/** Ordering options when selecting data from "partnershipSchedulingType". */
export type PartnershipSchedulingType_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partnershipSchedulingType */
export type PartnershipSchedulingType_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "partnershipSchedulingType" */
export enum PartnershipSchedulingType_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "partnershipSchedulingType" */
export type PartnershipSchedulingType_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "partnershipSchedulingType" */
export type PartnershipSchedulingType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PartnershipSchedulingType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PartnershipSchedulingType_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "partnershipSchedulingType" */
export enum PartnershipSchedulingType_Update_Column {
  /** column name */
  Value = 'value'
}

export type PartnershipSchedulingType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PartnershipSchedulingType_Set_Input>;
  /** filter the rows which have to be updated */
  where: PartnershipSchedulingType_Bool_Exp;
};

/** columns and relationships of "partnershipStatus" */
export type PartnershipStatus = {
  __typename?: 'partnershipStatus';
  value: Scalars['String']['output'];
};

/** aggregated selection of "partnershipStatus" */
export type PartnershipStatus_Aggregate = {
  __typename?: 'partnershipStatus_aggregate';
  aggregate?: Maybe<PartnershipStatus_Aggregate_Fields>;
  nodes: Array<PartnershipStatus>;
};

/** aggregate fields of "partnershipStatus" */
export type PartnershipStatus_Aggregate_Fields = {
  __typename?: 'partnershipStatus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<PartnershipStatus_Max_Fields>;
  min?: Maybe<PartnershipStatus_Min_Fields>;
};


/** aggregate fields of "partnershipStatus" */
export type PartnershipStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PartnershipStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "partnershipStatus". All fields are combined with a logical 'AND'. */
export type PartnershipStatus_Bool_Exp = {
  _and?: InputMaybe<Array<PartnershipStatus_Bool_Exp>>;
  _not?: InputMaybe<PartnershipStatus_Bool_Exp>;
  _or?: InputMaybe<Array<PartnershipStatus_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "partnershipStatus" */
export enum PartnershipStatus_Constraint {
  /** unique or primary key constraint on columns "value" */
  PartnershipStatusPkey = 'partnershipStatus_pkey'
}

export enum PartnershipStatus_Enum {
  AutomaticApproval = 'automatic_approval',
  WaitForApproval = 'wait_for_approval'
}

/** Boolean expression to compare columns of type "partnershipStatus_enum". All fields are combined with logical 'AND'. */
export type PartnershipStatus_Enum_Comparison_Exp = {
  _eq?: InputMaybe<PartnershipStatus_Enum>;
  _in?: InputMaybe<Array<PartnershipStatus_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<PartnershipStatus_Enum>;
  _nin?: InputMaybe<Array<PartnershipStatus_Enum>>;
};

/** input type for inserting data into table "partnershipStatus" */
export type PartnershipStatus_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type PartnershipStatus_Max_Fields = {
  __typename?: 'partnershipStatus_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type PartnershipStatus_Min_Fields = {
  __typename?: 'partnershipStatus_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "partnershipStatus" */
export type PartnershipStatus_Mutation_Response = {
  __typename?: 'partnershipStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PartnershipStatus>;
};

/** on_conflict condition type for table "partnershipStatus" */
export type PartnershipStatus_On_Conflict = {
  constraint: PartnershipStatus_Constraint;
  update_columns?: Array<PartnershipStatus_Update_Column>;
  where?: InputMaybe<PartnershipStatus_Bool_Exp>;
};

/** Ordering options when selecting data from "partnershipStatus". */
export type PartnershipStatus_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: partnershipStatus */
export type PartnershipStatus_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "partnershipStatus" */
export enum PartnershipStatus_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "partnershipStatus" */
export type PartnershipStatus_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "partnershipStatus" */
export type PartnershipStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PartnershipStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PartnershipStatus_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "partnershipStatus" */
export enum PartnershipStatus_Update_Column {
  /** column name */
  Value = 'value'
}

export type PartnershipStatus_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PartnershipStatus_Set_Input>;
  /** filter the rows which have to be updated */
  where: PartnershipStatus_Bool_Exp;
};

/** columns and relationships of "paymentFormat" */
export type PaymentFormat = {
  __typename?: 'paymentFormat';
  /** An array relationship */
  servicePricings: Array<ServicePricings>;
  /** An aggregate relationship */
  servicePricings_aggregate: ServicePricings_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "paymentFormat" */
export type PaymentFormatServicePricingsArgs = {
  distinct_on?: InputMaybe<Array<ServicePricings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicePricings_Order_By>>;
  where?: InputMaybe<ServicePricings_Bool_Exp>;
};


/** columns and relationships of "paymentFormat" */
export type PaymentFormatServicePricings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServicePricings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicePricings_Order_By>>;
  where?: InputMaybe<ServicePricings_Bool_Exp>;
};

/** aggregated selection of "paymentFormat" */
export type PaymentFormat_Aggregate = {
  __typename?: 'paymentFormat_aggregate';
  aggregate?: Maybe<PaymentFormat_Aggregate_Fields>;
  nodes: Array<PaymentFormat>;
};

/** aggregate fields of "paymentFormat" */
export type PaymentFormat_Aggregate_Fields = {
  __typename?: 'paymentFormat_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<PaymentFormat_Max_Fields>;
  min?: Maybe<PaymentFormat_Min_Fields>;
};


/** aggregate fields of "paymentFormat" */
export type PaymentFormat_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentFormat_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "paymentFormat". All fields are combined with a logical 'AND'. */
export type PaymentFormat_Bool_Exp = {
  _and?: InputMaybe<Array<PaymentFormat_Bool_Exp>>;
  _not?: InputMaybe<PaymentFormat_Bool_Exp>;
  _or?: InputMaybe<Array<PaymentFormat_Bool_Exp>>;
  servicePricings?: InputMaybe<ServicePricings_Bool_Exp>;
  servicePricings_aggregate?: InputMaybe<ServicePricings_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "paymentFormat" */
export enum PaymentFormat_Constraint {
  /** unique or primary key constraint on columns "value" */
  PaymentFormatPkey = 'paymentFormat_pkey'
}

export enum PaymentFormat_Enum {
  CustomerSpecific = 'customer_specific',
  Fixed = 'fixed'
}

/** Boolean expression to compare columns of type "paymentFormat_enum". All fields are combined with logical 'AND'. */
export type PaymentFormat_Enum_Comparison_Exp = {
  _eq?: InputMaybe<PaymentFormat_Enum>;
  _in?: InputMaybe<Array<PaymentFormat_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<PaymentFormat_Enum>;
  _nin?: InputMaybe<Array<PaymentFormat_Enum>>;
};

/** input type for inserting data into table "paymentFormat" */
export type PaymentFormat_Insert_Input = {
  servicePricings?: InputMaybe<ServicePricings_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type PaymentFormat_Max_Fields = {
  __typename?: 'paymentFormat_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type PaymentFormat_Min_Fields = {
  __typename?: 'paymentFormat_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "paymentFormat" */
export type PaymentFormat_Mutation_Response = {
  __typename?: 'paymentFormat_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentFormat>;
};

/** input type for inserting object relation for remote table "paymentFormat" */
export type PaymentFormat_Obj_Rel_Insert_Input = {
  data: PaymentFormat_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PaymentFormat_On_Conflict>;
};

/** on_conflict condition type for table "paymentFormat" */
export type PaymentFormat_On_Conflict = {
  constraint: PaymentFormat_Constraint;
  update_columns?: Array<PaymentFormat_Update_Column>;
  where?: InputMaybe<PaymentFormat_Bool_Exp>;
};

/** Ordering options when selecting data from "paymentFormat". */
export type PaymentFormat_Order_By = {
  servicePricings_aggregate?: InputMaybe<ServicePricings_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: paymentFormat */
export type PaymentFormat_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "paymentFormat" */
export enum PaymentFormat_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "paymentFormat" */
export type PaymentFormat_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "paymentFormat" */
export type PaymentFormat_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PaymentFormat_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentFormat_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "paymentFormat" */
export enum PaymentFormat_Update_Column {
  /** column name */
  Value = 'value'
}

export type PaymentFormat_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentFormat_Set_Input>;
  /** filter the rows which have to be updated */
  where: PaymentFormat_Bool_Exp;
};

/** columns and relationships of "paymentStatus" */
export type PaymentStatus = {
  __typename?: 'paymentStatus';
  /** An array relationship */
  appointments: Array<Appointments>;
  /** An aggregate relationship */
  appointments_aggregate: Appointments_Aggregate;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "paymentStatus" */
export type PaymentStatusAppointmentsArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


/** columns and relationships of "paymentStatus" */
export type PaymentStatusAppointments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


/** columns and relationships of "paymentStatus" */
export type PaymentStatusPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "paymentStatus" */
export type PaymentStatusPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};

/** aggregated selection of "paymentStatus" */
export type PaymentStatus_Aggregate = {
  __typename?: 'paymentStatus_aggregate';
  aggregate?: Maybe<PaymentStatus_Aggregate_Fields>;
  nodes: Array<PaymentStatus>;
};

/** aggregate fields of "paymentStatus" */
export type PaymentStatus_Aggregate_Fields = {
  __typename?: 'paymentStatus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<PaymentStatus_Max_Fields>;
  min?: Maybe<PaymentStatus_Min_Fields>;
};


/** aggregate fields of "paymentStatus" */
export type PaymentStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "paymentStatus". All fields are combined with a logical 'AND'. */
export type PaymentStatus_Bool_Exp = {
  _and?: InputMaybe<Array<PaymentStatus_Bool_Exp>>;
  _not?: InputMaybe<PaymentStatus_Bool_Exp>;
  _or?: InputMaybe<Array<PaymentStatus_Bool_Exp>>;
  appointments?: InputMaybe<Appointments_Bool_Exp>;
  appointments_aggregate?: InputMaybe<Appointments_Aggregate_Bool_Exp>;
  payments?: InputMaybe<Payments_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "paymentStatus" */
export enum PaymentStatus_Constraint {
  /** unique or primary key constraint on columns "value" */
  PaymentStatusPkey = 'paymentStatus_pkey'
}

export enum PaymentStatus_Enum {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Partial = 'partial',
  PartiallyRefunded = 'partially_refunded',
  Pending = 'pending',
  Refunded = 'refunded'
}

/** Boolean expression to compare columns of type "paymentStatus_enum". All fields are combined with logical 'AND'. */
export type PaymentStatus_Enum_Comparison_Exp = {
  _eq?: InputMaybe<PaymentStatus_Enum>;
  _in?: InputMaybe<Array<PaymentStatus_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<PaymentStatus_Enum>;
  _nin?: InputMaybe<Array<PaymentStatus_Enum>>;
};

/** input type for inserting data into table "paymentStatus" */
export type PaymentStatus_Insert_Input = {
  appointments?: InputMaybe<Appointments_Arr_Rel_Insert_Input>;
  payments?: InputMaybe<Payments_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type PaymentStatus_Max_Fields = {
  __typename?: 'paymentStatus_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type PaymentStatus_Min_Fields = {
  __typename?: 'paymentStatus_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "paymentStatus" */
export type PaymentStatus_Mutation_Response = {
  __typename?: 'paymentStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentStatus>;
};

/** input type for inserting object relation for remote table "paymentStatus" */
export type PaymentStatus_Obj_Rel_Insert_Input = {
  data: PaymentStatus_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PaymentStatus_On_Conflict>;
};

/** on_conflict condition type for table "paymentStatus" */
export type PaymentStatus_On_Conflict = {
  constraint: PaymentStatus_Constraint;
  update_columns?: Array<PaymentStatus_Update_Column>;
  where?: InputMaybe<PaymentStatus_Bool_Exp>;
};

/** Ordering options when selecting data from "paymentStatus". */
export type PaymentStatus_Order_By = {
  appointments_aggregate?: InputMaybe<Appointments_Aggregate_Order_By>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: paymentStatus */
export type PaymentStatus_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "paymentStatus" */
export enum PaymentStatus_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "paymentStatus" */
export type PaymentStatus_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "paymentStatus" */
export type PaymentStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PaymentStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentStatus_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "paymentStatus" */
export enum PaymentStatus_Update_Column {
  /** column name */
  Value = 'value'
}

export type PaymentStatus_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentStatus_Set_Input>;
  /** filter the rows which have to be updated */
  where: PaymentStatus_Bool_Exp;
};

/** columns and relationships of "payments" */
export type Payments = {
  __typename?: 'payments';
  /** In whole units (USD, CAD) */
  amount: Scalars['numeric']['output'];
  /** An object relationship */
  appointment: Appointments;
  appointmentId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  currency: Currencies_Enum;
  /** An object relationship */
  currencyByCurrency: Currencies;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  paymentStatus: PaymentStatus;
  /** An array relationship */
  refund: Array<Refunds>;
  /** An aggregate relationship */
  refund_aggregate: Refunds_Aggregate;
  sources: Scalars['jsonb']['output'];
  status: PaymentStatus_Enum;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "payments" */
export type PaymentsRefundArgs = {
  distinct_on?: InputMaybe<Array<Refunds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refunds_Order_By>>;
  where?: InputMaybe<Refunds_Bool_Exp>;
};


/** columns and relationships of "payments" */
export type PaymentsRefund_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refunds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refunds_Order_By>>;
  where?: InputMaybe<Refunds_Bool_Exp>;
};


/** columns and relationships of "payments" */
export type PaymentsSourcesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "payments" */
export type Payments_Aggregate = {
  __typename?: 'payments_aggregate';
  aggregate?: Maybe<Payments_Aggregate_Fields>;
  nodes: Array<Payments>;
};

export type Payments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Payments_Aggregate_Bool_Exp_Count>;
};

export type Payments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Payments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Payments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "payments" */
export type Payments_Aggregate_Fields = {
  __typename?: 'payments_aggregate_fields';
  avg?: Maybe<Payments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Payments_Max_Fields>;
  min?: Maybe<Payments_Min_Fields>;
  stddev?: Maybe<Payments_Stddev_Fields>;
  stddev_pop?: Maybe<Payments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payments_Stddev_Samp_Fields>;
  sum?: Maybe<Payments_Sum_Fields>;
  var_pop?: Maybe<Payments_Var_Pop_Fields>;
  var_samp?: Maybe<Payments_Var_Samp_Fields>;
  variance?: Maybe<Payments_Variance_Fields>;
};


/** aggregate fields of "payments" */
export type Payments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "payments" */
export type Payments_Aggregate_Order_By = {
  avg?: InputMaybe<Payments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payments_Max_Order_By>;
  min?: InputMaybe<Payments_Min_Order_By>;
  stddev?: InputMaybe<Payments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payments_Sum_Order_By>;
  var_pop?: InputMaybe<Payments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payments_Var_Samp_Order_By>;
  variance?: InputMaybe<Payments_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Payments_Append_Input = {
  sources?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "payments" */
export type Payments_Arr_Rel_Insert_Input = {
  data: Array<Payments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Payments_On_Conflict>;
};

/** aggregate avg on columns */
export type Payments_Avg_Fields = {
  __typename?: 'payments_avg_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "payments" */
export type Payments_Avg_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payments". All fields are combined with a logical 'AND'. */
export type Payments_Bool_Exp = {
  _and?: InputMaybe<Array<Payments_Bool_Exp>>;
  _not?: InputMaybe<Payments_Bool_Exp>;
  _or?: InputMaybe<Array<Payments_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  appointment?: InputMaybe<Appointments_Bool_Exp>;
  appointmentId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<Currencies_Enum_Comparison_Exp>;
  currencyByCurrency?: InputMaybe<Currencies_Bool_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  paymentStatus?: InputMaybe<PaymentStatus_Bool_Exp>;
  refund?: InputMaybe<Refunds_Bool_Exp>;
  refund_aggregate?: InputMaybe<Refunds_Aggregate_Bool_Exp>;
  sources?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<PaymentStatus_Enum_Comparison_Exp>;
  stripePaymentIntentId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "payments" */
export enum Payments_Constraint {
  /** unique or primary key constraint on columns "id" */
  PaymentsPkey = 'payments_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Payments_Delete_At_Path_Input = {
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Payments_Delete_Elem_Input = {
  sources?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Payments_Delete_Key_Input = {
  sources?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "payments" */
export type Payments_Inc_Input = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "payments" */
export type Payments_Insert_Input = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Scalars['numeric']['input']>;
  appointment?: InputMaybe<Appointments_Obj_Rel_Insert_Input>;
  appointmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Currencies_Enum>;
  currencyByCurrency?: InputMaybe<Currencies_Obj_Rel_Insert_Input>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus_Obj_Rel_Insert_Input>;
  refund?: InputMaybe<Refunds_Arr_Rel_Insert_Input>;
  sources?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<PaymentStatus_Enum>;
  stripePaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Payments_Max_Fields = {
  __typename?: 'payments_max_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['numeric']['output']>;
  appointmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "payments" */
export type Payments_Max_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
  appointmentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stripePaymentIntentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Payments_Min_Fields = {
  __typename?: 'payments_min_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['numeric']['output']>;
  appointmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "payments" */
export type Payments_Min_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
  appointmentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stripePaymentIntentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "payments" */
export type Payments_Mutation_Response = {
  __typename?: 'payments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Payments>;
};

/** input type for inserting object relation for remote table "payments" */
export type Payments_Obj_Rel_Insert_Input = {
  data: Payments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Payments_On_Conflict>;
};

/** on_conflict condition type for table "payments" */
export type Payments_On_Conflict = {
  constraint: Payments_Constraint;
  update_columns?: Array<Payments_Update_Column>;
  where?: InputMaybe<Payments_Bool_Exp>;
};

/** Ordering options when selecting data from "payments". */
export type Payments_Order_By = {
  amount?: InputMaybe<Order_By>;
  appointment?: InputMaybe<Appointments_Order_By>;
  appointmentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  currencyByCurrency?: InputMaybe<Currencies_Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  paymentStatus?: InputMaybe<PaymentStatus_Order_By>;
  refund_aggregate?: InputMaybe<Refunds_Aggregate_Order_By>;
  sources?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripePaymentIntentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payments */
export type Payments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Payments_Prepend_Input = {
  sources?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "payments" */
export enum Payments_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AppointmentId = 'appointmentId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Sources = 'sources',
  /** column name */
  Status = 'status',
  /** column name */
  StripePaymentIntentId = 'stripePaymentIntentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "payments" */
export type Payments_Set_Input = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Scalars['numeric']['input']>;
  appointmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Currencies_Enum>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sources?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<PaymentStatus_Enum>;
  stripePaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Payments_Stddev_Fields = {
  __typename?: 'payments_stddev_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "payments" */
export type Payments_Stddev_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Payments_Stddev_Pop_Fields = {
  __typename?: 'payments_stddev_pop_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "payments" */
export type Payments_Stddev_Pop_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Payments_Stddev_Samp_Fields = {
  __typename?: 'payments_stddev_samp_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "payments" */
export type Payments_Stddev_Samp_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "payments" */
export type Payments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payments_Stream_Cursor_Value_Input = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Scalars['numeric']['input']>;
  appointmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Currencies_Enum>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sources?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<PaymentStatus_Enum>;
  stripePaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Payments_Sum_Fields = {
  __typename?: 'payments_sum_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "payments" */
export type Payments_Sum_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "payments" */
export enum Payments_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AppointmentId = 'appointmentId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Sources = 'sources',
  /** column name */
  Status = 'status',
  /** column name */
  StripePaymentIntentId = 'stripePaymentIntentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Payments_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Payments_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Payments_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Payments_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Payments_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payments_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Payments_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Payments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Payments_Var_Pop_Fields = {
  __typename?: 'payments_var_pop_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "payments" */
export type Payments_Var_Pop_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Payments_Var_Samp_Fields = {
  __typename?: 'payments_var_samp_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "payments" */
export type Payments_Var_Samp_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Payments_Variance_Fields = {
  __typename?: 'payments_variance_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "payments" */
export type Payments_Variance_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "providerCategory" */
export type ProviderCategory = {
  __typename?: 'providerCategory';
  /** An array relationship */
  providers: Array<Providers>;
  /** An aggregate relationship */
  providers_aggregate: Providers_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "providerCategory" */
export type ProviderCategoryProvidersArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};


/** columns and relationships of "providerCategory" */
export type ProviderCategoryProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};

/** aggregated selection of "providerCategory" */
export type ProviderCategory_Aggregate = {
  __typename?: 'providerCategory_aggregate';
  aggregate?: Maybe<ProviderCategory_Aggregate_Fields>;
  nodes: Array<ProviderCategory>;
};

/** aggregate fields of "providerCategory" */
export type ProviderCategory_Aggregate_Fields = {
  __typename?: 'providerCategory_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProviderCategory_Max_Fields>;
  min?: Maybe<ProviderCategory_Min_Fields>;
};


/** aggregate fields of "providerCategory" */
export type ProviderCategory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProviderCategory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "providerCategory". All fields are combined with a logical 'AND'. */
export type ProviderCategory_Bool_Exp = {
  _and?: InputMaybe<Array<ProviderCategory_Bool_Exp>>;
  _not?: InputMaybe<ProviderCategory_Bool_Exp>;
  _or?: InputMaybe<Array<ProviderCategory_Bool_Exp>>;
  providers?: InputMaybe<Providers_Bool_Exp>;
  providers_aggregate?: InputMaybe<Providers_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "providerCategory" */
export enum ProviderCategory_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProviderCategoryPkey = 'providerCategory_pkey'
}

export enum ProviderCategory_Enum {
  ArtsActivities = 'arts_activities',
  CarCare = 'car_care',
  HealthCare = 'health_care',
  HouseCare = 'house_care',
  PetCare = 'pet_care',
  SelfCare = 'self_care'
}

/** Boolean expression to compare columns of type "providerCategory_enum". All fields are combined with logical 'AND'. */
export type ProviderCategory_Enum_Comparison_Exp = {
  _eq?: InputMaybe<ProviderCategory_Enum>;
  _in?: InputMaybe<Array<ProviderCategory_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<ProviderCategory_Enum>;
  _nin?: InputMaybe<Array<ProviderCategory_Enum>>;
};

/** input type for inserting data into table "providerCategory" */
export type ProviderCategory_Insert_Input = {
  providers?: InputMaybe<Providers_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ProviderCategory_Max_Fields = {
  __typename?: 'providerCategory_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ProviderCategory_Min_Fields = {
  __typename?: 'providerCategory_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "providerCategory" */
export type ProviderCategory_Mutation_Response = {
  __typename?: 'providerCategory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProviderCategory>;
};

/** input type for inserting object relation for remote table "providerCategory" */
export type ProviderCategory_Obj_Rel_Insert_Input = {
  data: ProviderCategory_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProviderCategory_On_Conflict>;
};

/** on_conflict condition type for table "providerCategory" */
export type ProviderCategory_On_Conflict = {
  constraint: ProviderCategory_Constraint;
  update_columns?: Array<ProviderCategory_Update_Column>;
  where?: InputMaybe<ProviderCategory_Bool_Exp>;
};

/** Ordering options when selecting data from "providerCategory". */
export type ProviderCategory_Order_By = {
  providers_aggregate?: InputMaybe<Providers_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: providerCategory */
export type ProviderCategory_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "providerCategory" */
export enum ProviderCategory_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "providerCategory" */
export type ProviderCategory_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "providerCategory" */
export type ProviderCategory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProviderCategory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProviderCategory_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "providerCategory" */
export enum ProviderCategory_Update_Column {
  /** column name */
  Value = 'value'
}

export type ProviderCategory_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProviderCategory_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProviderCategory_Bool_Exp;
};

/** provider payments towards the platform */
export type ProviderMonthlyPayments = {
  __typename?: 'providerMonthlyPayments';
  amount: Scalars['numeric']['output'];
  /** An array relationship */
  appointments: Array<Appointments>;
  /** An aggregate relationship */
  appointments_aggregate: Appointments_Aggregate;
  createdAt: Scalars['date']['output'];
  deletedAt?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  month?: Maybe<Scalars['String']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  provider: Providers;
  providerId: Scalars['uuid']['output'];
  status: PaymentStatus_Enum;
  updatedAt?: Maybe<Scalars['date']['output']>;
};


/** provider payments towards the platform */
export type ProviderMonthlyPaymentsAppointmentsArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


/** provider payments towards the platform */
export type ProviderMonthlyPaymentsAppointments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};

/** aggregated selection of "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Aggregate = {
  __typename?: 'providerMonthlyPayments_aggregate';
  aggregate?: Maybe<ProviderMonthlyPayments_Aggregate_Fields>;
  nodes: Array<ProviderMonthlyPayments>;
};

export type ProviderMonthlyPayments_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProviderMonthlyPayments_Aggregate_Bool_Exp_Count>;
};

export type ProviderMonthlyPayments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProviderMonthlyPayments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProviderMonthlyPayments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Aggregate_Fields = {
  __typename?: 'providerMonthlyPayments_aggregate_fields';
  avg?: Maybe<ProviderMonthlyPayments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ProviderMonthlyPayments_Max_Fields>;
  min?: Maybe<ProviderMonthlyPayments_Min_Fields>;
  stddev?: Maybe<ProviderMonthlyPayments_Stddev_Fields>;
  stddev_pop?: Maybe<ProviderMonthlyPayments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProviderMonthlyPayments_Stddev_Samp_Fields>;
  sum?: Maybe<ProviderMonthlyPayments_Sum_Fields>;
  var_pop?: Maybe<ProviderMonthlyPayments_Var_Pop_Fields>;
  var_samp?: Maybe<ProviderMonthlyPayments_Var_Samp_Fields>;
  variance?: Maybe<ProviderMonthlyPayments_Variance_Fields>;
};


/** aggregate fields of "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProviderMonthlyPayments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Aggregate_Order_By = {
  avg?: InputMaybe<ProviderMonthlyPayments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProviderMonthlyPayments_Max_Order_By>;
  min?: InputMaybe<ProviderMonthlyPayments_Min_Order_By>;
  stddev?: InputMaybe<ProviderMonthlyPayments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ProviderMonthlyPayments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ProviderMonthlyPayments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ProviderMonthlyPayments_Sum_Order_By>;
  var_pop?: InputMaybe<ProviderMonthlyPayments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ProviderMonthlyPayments_Var_Samp_Order_By>;
  variance?: InputMaybe<ProviderMonthlyPayments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Arr_Rel_Insert_Input = {
  data: Array<ProviderMonthlyPayments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProviderMonthlyPayments_On_Conflict>;
};

/** aggregate avg on columns */
export type ProviderMonthlyPayments_Avg_Fields = {
  __typename?: 'providerMonthlyPayments_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "providerMonthlyPayments". All fields are combined with a logical 'AND'. */
export type ProviderMonthlyPayments_Bool_Exp = {
  _and?: InputMaybe<Array<ProviderMonthlyPayments_Bool_Exp>>;
  _not?: InputMaybe<ProviderMonthlyPayments_Bool_Exp>;
  _or?: InputMaybe<Array<ProviderMonthlyPayments_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  appointments?: InputMaybe<Appointments_Bool_Exp>;
  appointments_aggregate?: InputMaybe<Appointments_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Date_Comparison_Exp>;
  deletedAt?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  month?: InputMaybe<String_Comparison_Exp>;
  paymentId?: InputMaybe<String_Comparison_Exp>;
  provider?: InputMaybe<Providers_Bool_Exp>;
  providerId?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<PaymentStatus_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "providerMonthlyPayments" */
export enum ProviderMonthlyPayments_Constraint {
  /** unique or primary key constraint on columns "paymentId" */
  ProviderPaymentsPaymentIdKey = 'providerPayments_paymentId_key',
  /** unique or primary key constraint on columns "id" */
  ProviderPaymentsPkey = 'providerPayments_pkey'
}

/** input type for incrementing numeric columns in table "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  appointments?: InputMaybe<Appointments_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['date']['input']>;
  deletedAt?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Providers_Obj_Rel_Insert_Input>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<PaymentStatus_Enum>;
  updatedAt?: InputMaybe<Scalars['date']['input']>;
};

/** aggregate max on columns */
export type ProviderMonthlyPayments_Max_Fields = {
  __typename?: 'providerMonthlyPayments_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  createdAt?: Maybe<Scalars['date']['output']>;
  deletedAt?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['date']['output']>;
};

/** order by max() on columns of table "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  paymentId?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProviderMonthlyPayments_Min_Fields = {
  __typename?: 'providerMonthlyPayments_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  createdAt?: Maybe<Scalars['date']['output']>;
  deletedAt?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['date']['output']>;
};

/** order by min() on columns of table "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  paymentId?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Mutation_Response = {
  __typename?: 'providerMonthlyPayments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProviderMonthlyPayments>;
};

/** on_conflict condition type for table "providerMonthlyPayments" */
export type ProviderMonthlyPayments_On_Conflict = {
  constraint: ProviderMonthlyPayments_Constraint;
  update_columns?: Array<ProviderMonthlyPayments_Update_Column>;
  where?: InputMaybe<ProviderMonthlyPayments_Bool_Exp>;
};

/** Ordering options when selecting data from "providerMonthlyPayments". */
export type ProviderMonthlyPayments_Order_By = {
  amount?: InputMaybe<Order_By>;
  appointments_aggregate?: InputMaybe<Appointments_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  paymentId?: InputMaybe<Order_By>;
  provider?: InputMaybe<Providers_Order_By>;
  providerId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: providerMonthlyPayments */
export type ProviderMonthlyPayments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "providerMonthlyPayments" */
export enum ProviderMonthlyPayments_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Month = 'month',
  /** column name */
  PaymentId = 'paymentId',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  createdAt?: InputMaybe<Scalars['date']['input']>;
  deletedAt?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<PaymentStatus_Enum>;
  updatedAt?: InputMaybe<Scalars['date']['input']>;
};

/** aggregate stddev on columns */
export type ProviderMonthlyPayments_Stddev_Fields = {
  __typename?: 'providerMonthlyPayments_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ProviderMonthlyPayments_Stddev_Pop_Fields = {
  __typename?: 'providerMonthlyPayments_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ProviderMonthlyPayments_Stddev_Samp_Fields = {
  __typename?: 'providerMonthlyPayments_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProviderMonthlyPayments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProviderMonthlyPayments_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  createdAt?: InputMaybe<Scalars['date']['input']>;
  deletedAt?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<PaymentStatus_Enum>;
  updatedAt?: InputMaybe<Scalars['date']['input']>;
};

/** aggregate sum on columns */
export type ProviderMonthlyPayments_Sum_Fields = {
  __typename?: 'providerMonthlyPayments_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "providerMonthlyPayments" */
export enum ProviderMonthlyPayments_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Month = 'month',
  /** column name */
  PaymentId = 'paymentId',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ProviderMonthlyPayments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProviderMonthlyPayments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProviderMonthlyPayments_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProviderMonthlyPayments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProviderMonthlyPayments_Var_Pop_Fields = {
  __typename?: 'providerMonthlyPayments_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ProviderMonthlyPayments_Var_Samp_Fields = {
  __typename?: 'providerMonthlyPayments_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ProviderMonthlyPayments_Variance_Fields = {
  __typename?: 'providerMonthlyPayments_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "providerMonthlyPayments" */
export type ProviderMonthlyPayments_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "providerPictures" */
export type ProviderPictures = {
  __typename?: 'providerPictures';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: Files;
  fileId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  provider: Providers;
  providerId: Scalars['uuid']['output'];
  /** An array relationship */
  providers: Array<Providers>;
  /** An array relationship */
  providersByProfilepic: Array<Providers>;
  /** An aggregate relationship */
  providersByProfilepic_aggregate: Providers_Aggregate;
  /** An aggregate relationship */
  providers_aggregate: Providers_Aggregate;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "providerPictures" */
export type ProviderPicturesProvidersArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};


/** columns and relationships of "providerPictures" */
export type ProviderPicturesProvidersByProfilepicArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};


/** columns and relationships of "providerPictures" */
export type ProviderPicturesProvidersByProfilepic_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};


/** columns and relationships of "providerPictures" */
export type ProviderPicturesProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};

/** aggregated selection of "providerPictures" */
export type ProviderPictures_Aggregate = {
  __typename?: 'providerPictures_aggregate';
  aggregate?: Maybe<ProviderPictures_Aggregate_Fields>;
  nodes: Array<ProviderPictures>;
};

export type ProviderPictures_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProviderPictures_Aggregate_Bool_Exp_Count>;
};

export type ProviderPictures_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProviderPictures_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProviderPictures_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "providerPictures" */
export type ProviderPictures_Aggregate_Fields = {
  __typename?: 'providerPictures_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProviderPictures_Max_Fields>;
  min?: Maybe<ProviderPictures_Min_Fields>;
};


/** aggregate fields of "providerPictures" */
export type ProviderPictures_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProviderPictures_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "providerPictures" */
export type ProviderPictures_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProviderPictures_Max_Order_By>;
  min?: InputMaybe<ProviderPictures_Min_Order_By>;
};

/** input type for inserting array relation for remote table "providerPictures" */
export type ProviderPictures_Arr_Rel_Insert_Input = {
  data: Array<ProviderPictures_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProviderPictures_On_Conflict>;
};

/** Boolean expression to filter rows from the table "providerPictures". All fields are combined with a logical 'AND'. */
export type ProviderPictures_Bool_Exp = {
  _and?: InputMaybe<Array<ProviderPictures_Bool_Exp>>;
  _not?: InputMaybe<ProviderPictures_Bool_Exp>;
  _or?: InputMaybe<Array<ProviderPictures_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  provider?: InputMaybe<Providers_Bool_Exp>;
  providerId?: InputMaybe<Uuid_Comparison_Exp>;
  providers?: InputMaybe<Providers_Bool_Exp>;
  providersByProfilepic?: InputMaybe<Providers_Bool_Exp>;
  providersByProfilepic_aggregate?: InputMaybe<Providers_Aggregate_Bool_Exp>;
  providers_aggregate?: InputMaybe<Providers_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "providerPictures" */
export enum ProviderPictures_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProviderPicturesPkey = 'providerPictures_pkey'
}

/** input type for inserting data into table "providerPictures" */
export type ProviderPictures_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Providers_Obj_Rel_Insert_Input>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  providers?: InputMaybe<Providers_Arr_Rel_Insert_Input>;
  providersByProfilepic?: InputMaybe<Providers_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ProviderPictures_Max_Fields = {
  __typename?: 'providerPictures_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "providerPictures" */
export type ProviderPictures_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProviderPictures_Min_Fields = {
  __typename?: 'providerPictures_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "providerPictures" */
export type ProviderPictures_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "providerPictures" */
export type ProviderPictures_Mutation_Response = {
  __typename?: 'providerPictures_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProviderPictures>;
};

/** input type for inserting object relation for remote table "providerPictures" */
export type ProviderPictures_Obj_Rel_Insert_Input = {
  data: ProviderPictures_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProviderPictures_On_Conflict>;
};

/** on_conflict condition type for table "providerPictures" */
export type ProviderPictures_On_Conflict = {
  constraint: ProviderPictures_Constraint;
  update_columns?: Array<ProviderPictures_Update_Column>;
  where?: InputMaybe<ProviderPictures_Bool_Exp>;
};

/** Ordering options when selecting data from "providerPictures". */
export type ProviderPictures_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  provider?: InputMaybe<Providers_Order_By>;
  providerId?: InputMaybe<Order_By>;
  providersByProfilepic_aggregate?: InputMaybe<Providers_Aggregate_Order_By>;
  providers_aggregate?: InputMaybe<Providers_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: providerPictures */
export type ProviderPictures_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "providerPictures" */
export enum ProviderPictures_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "providerPictures" */
export type ProviderPictures_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "providerPictures" */
export type ProviderPictures_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProviderPictures_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProviderPictures_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "providerPictures" */
export enum ProviderPictures_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ProviderPictures_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProviderPictures_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProviderPictures_Bool_Exp;
};

/** columns and relationships of "providerRole" */
export type ProviderRole = {
  __typename?: 'providerRole';
  value: Scalars['String']['output'];
};

/** aggregated selection of "providerRole" */
export type ProviderRole_Aggregate = {
  __typename?: 'providerRole_aggregate';
  aggregate?: Maybe<ProviderRole_Aggregate_Fields>;
  nodes: Array<ProviderRole>;
};

/** aggregate fields of "providerRole" */
export type ProviderRole_Aggregate_Fields = {
  __typename?: 'providerRole_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProviderRole_Max_Fields>;
  min?: Maybe<ProviderRole_Min_Fields>;
};


/** aggregate fields of "providerRole" */
export type ProviderRole_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProviderRole_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "providerRole". All fields are combined with a logical 'AND'. */
export type ProviderRole_Bool_Exp = {
  _and?: InputMaybe<Array<ProviderRole_Bool_Exp>>;
  _not?: InputMaybe<ProviderRole_Bool_Exp>;
  _or?: InputMaybe<Array<ProviderRole_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "providerRole" */
export enum ProviderRole_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProviderRolePkey = 'providerRole_pkey'
}

/** input type for inserting data into table "providerRole" */
export type ProviderRole_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ProviderRole_Max_Fields = {
  __typename?: 'providerRole_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ProviderRole_Min_Fields = {
  __typename?: 'providerRole_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "providerRole" */
export type ProviderRole_Mutation_Response = {
  __typename?: 'providerRole_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProviderRole>;
};

/** on_conflict condition type for table "providerRole" */
export type ProviderRole_On_Conflict = {
  constraint: ProviderRole_Constraint;
  update_columns?: Array<ProviderRole_Update_Column>;
  where?: InputMaybe<ProviderRole_Bool_Exp>;
};

/** Ordering options when selecting data from "providerRole". */
export type ProviderRole_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: providerRole */
export type ProviderRole_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "providerRole" */
export enum ProviderRole_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "providerRole" */
export type ProviderRole_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "providerRole" */
export type ProviderRole_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProviderRole_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProviderRole_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "providerRole" */
export enum ProviderRole_Update_Column {
  /** column name */
  Value = 'value'
}

export type ProviderRole_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProviderRole_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProviderRole_Bool_Exp;
};

/** columns and relationships of "providerStatus" */
export type ProviderStatus = {
  __typename?: 'providerStatus';
  /** An array relationship */
  providers: Array<Providers>;
  /** An aggregate relationship */
  providers_aggregate: Providers_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "providerStatus" */
export type ProviderStatusProvidersArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};


/** columns and relationships of "providerStatus" */
export type ProviderStatusProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};

/** aggregated selection of "providerStatus" */
export type ProviderStatus_Aggregate = {
  __typename?: 'providerStatus_aggregate';
  aggregate?: Maybe<ProviderStatus_Aggregate_Fields>;
  nodes: Array<ProviderStatus>;
};

/** aggregate fields of "providerStatus" */
export type ProviderStatus_Aggregate_Fields = {
  __typename?: 'providerStatus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProviderStatus_Max_Fields>;
  min?: Maybe<ProviderStatus_Min_Fields>;
};


/** aggregate fields of "providerStatus" */
export type ProviderStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProviderStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "providerStatus". All fields are combined with a logical 'AND'. */
export type ProviderStatus_Bool_Exp = {
  _and?: InputMaybe<Array<ProviderStatus_Bool_Exp>>;
  _not?: InputMaybe<ProviderStatus_Bool_Exp>;
  _or?: InputMaybe<Array<ProviderStatus_Bool_Exp>>;
  providers?: InputMaybe<Providers_Bool_Exp>;
  providers_aggregate?: InputMaybe<Providers_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "providerStatus" */
export enum ProviderStatus_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProviderStatusPkey = 'providerStatus_pkey'
}

export enum ProviderStatus_Enum {
  Approved = 'approved',
  Cancelled = 'cancelled',
  Pending = 'pending',
  Rejected = 'rejected'
}

/** Boolean expression to compare columns of type "providerStatus_enum". All fields are combined with logical 'AND'. */
export type ProviderStatus_Enum_Comparison_Exp = {
  _eq?: InputMaybe<ProviderStatus_Enum>;
  _in?: InputMaybe<Array<ProviderStatus_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<ProviderStatus_Enum>;
  _nin?: InputMaybe<Array<ProviderStatus_Enum>>;
};

/** input type for inserting data into table "providerStatus" */
export type ProviderStatus_Insert_Input = {
  providers?: InputMaybe<Providers_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ProviderStatus_Max_Fields = {
  __typename?: 'providerStatus_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ProviderStatus_Min_Fields = {
  __typename?: 'providerStatus_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "providerStatus" */
export type ProviderStatus_Mutation_Response = {
  __typename?: 'providerStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProviderStatus>;
};

/** input type for inserting object relation for remote table "providerStatus" */
export type ProviderStatus_Obj_Rel_Insert_Input = {
  data: ProviderStatus_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProviderStatus_On_Conflict>;
};

/** on_conflict condition type for table "providerStatus" */
export type ProviderStatus_On_Conflict = {
  constraint: ProviderStatus_Constraint;
  update_columns?: Array<ProviderStatus_Update_Column>;
  where?: InputMaybe<ProviderStatus_Bool_Exp>;
};

/** Ordering options when selecting data from "providerStatus". */
export type ProviderStatus_Order_By = {
  providers_aggregate?: InputMaybe<Providers_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: providerStatus */
export type ProviderStatus_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "providerStatus" */
export enum ProviderStatus_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "providerStatus" */
export type ProviderStatus_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "providerStatus" */
export type ProviderStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProviderStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProviderStatus_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "providerStatus" */
export enum ProviderStatus_Update_Column {
  /** column name */
  Value = 'value'
}

export type ProviderStatus_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProviderStatus_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProviderStatus_Bool_Exp;
};

/** columns and relationships of "providerType" */
export type ProviderType = {
  __typename?: 'providerType';
  /** An array relationship */
  providers: Array<Providers>;
  /** An aggregate relationship */
  providers_aggregate: Providers_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "providerType" */
export type ProviderTypeProvidersArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};


/** columns and relationships of "providerType" */
export type ProviderTypeProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};

/** aggregated selection of "providerType" */
export type ProviderType_Aggregate = {
  __typename?: 'providerType_aggregate';
  aggregate?: Maybe<ProviderType_Aggregate_Fields>;
  nodes: Array<ProviderType>;
};

/** aggregate fields of "providerType" */
export type ProviderType_Aggregate_Fields = {
  __typename?: 'providerType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProviderType_Max_Fields>;
  min?: Maybe<ProviderType_Min_Fields>;
};


/** aggregate fields of "providerType" */
export type ProviderType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProviderType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "providerType". All fields are combined with a logical 'AND'. */
export type ProviderType_Bool_Exp = {
  _and?: InputMaybe<Array<ProviderType_Bool_Exp>>;
  _not?: InputMaybe<ProviderType_Bool_Exp>;
  _or?: InputMaybe<Array<ProviderType_Bool_Exp>>;
  providers?: InputMaybe<Providers_Bool_Exp>;
  providers_aggregate?: InputMaybe<Providers_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "providerType" */
export enum ProviderType_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProviderTypePkey = 'providerType_pkey'
}

export enum ProviderType_Enum {
  Services = 'services'
}

/** Boolean expression to compare columns of type "providerType_enum". All fields are combined with logical 'AND'. */
export type ProviderType_Enum_Comparison_Exp = {
  _eq?: InputMaybe<ProviderType_Enum>;
  _in?: InputMaybe<Array<ProviderType_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<ProviderType_Enum>;
  _nin?: InputMaybe<Array<ProviderType_Enum>>;
};

/** input type for inserting data into table "providerType" */
export type ProviderType_Insert_Input = {
  providers?: InputMaybe<Providers_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ProviderType_Max_Fields = {
  __typename?: 'providerType_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ProviderType_Min_Fields = {
  __typename?: 'providerType_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "providerType" */
export type ProviderType_Mutation_Response = {
  __typename?: 'providerType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProviderType>;
};

/** input type for inserting object relation for remote table "providerType" */
export type ProviderType_Obj_Rel_Insert_Input = {
  data: ProviderType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProviderType_On_Conflict>;
};

/** on_conflict condition type for table "providerType" */
export type ProviderType_On_Conflict = {
  constraint: ProviderType_Constraint;
  update_columns?: Array<ProviderType_Update_Column>;
  where?: InputMaybe<ProviderType_Bool_Exp>;
};

/** Ordering options when selecting data from "providerType". */
export type ProviderType_Order_By = {
  providers_aggregate?: InputMaybe<Providers_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: providerType */
export type ProviderType_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "providerType" */
export enum ProviderType_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "providerType" */
export type ProviderType_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "providerType" */
export type ProviderType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProviderType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProviderType_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "providerType" */
export enum ProviderType_Update_Column {
  /** column name */
  Value = 'value'
}

export type ProviderType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProviderType_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProviderType_Bool_Exp;
};

/** columns and relationships of "providerVisibility" */
export type ProviderVisibility = {
  __typename?: 'providerVisibility';
  /** An array relationship */
  providers: Array<Providers>;
  /** An aggregate relationship */
  providers_aggregate: Providers_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "providerVisibility" */
export type ProviderVisibilityProvidersArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};


/** columns and relationships of "providerVisibility" */
export type ProviderVisibilityProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};

/** aggregated selection of "providerVisibility" */
export type ProviderVisibility_Aggregate = {
  __typename?: 'providerVisibility_aggregate';
  aggregate?: Maybe<ProviderVisibility_Aggregate_Fields>;
  nodes: Array<ProviderVisibility>;
};

/** aggregate fields of "providerVisibility" */
export type ProviderVisibility_Aggregate_Fields = {
  __typename?: 'providerVisibility_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProviderVisibility_Max_Fields>;
  min?: Maybe<ProviderVisibility_Min_Fields>;
};


/** aggregate fields of "providerVisibility" */
export type ProviderVisibility_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProviderVisibility_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "providerVisibility". All fields are combined with a logical 'AND'. */
export type ProviderVisibility_Bool_Exp = {
  _and?: InputMaybe<Array<ProviderVisibility_Bool_Exp>>;
  _not?: InputMaybe<ProviderVisibility_Bool_Exp>;
  _or?: InputMaybe<Array<ProviderVisibility_Bool_Exp>>;
  providers?: InputMaybe<Providers_Bool_Exp>;
  providers_aggregate?: InputMaybe<Providers_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "providerVisibility" */
export enum ProviderVisibility_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProviderVisibilityPkey = 'providerVisibility_pkey'
}

export enum ProviderVisibility_Enum {
  Private = 'private',
  Public = 'public'
}

/** Boolean expression to compare columns of type "providerVisibility_enum". All fields are combined with logical 'AND'. */
export type ProviderVisibility_Enum_Comparison_Exp = {
  _eq?: InputMaybe<ProviderVisibility_Enum>;
  _in?: InputMaybe<Array<ProviderVisibility_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<ProviderVisibility_Enum>;
  _nin?: InputMaybe<Array<ProviderVisibility_Enum>>;
};

/** input type for inserting data into table "providerVisibility" */
export type ProviderVisibility_Insert_Input = {
  providers?: InputMaybe<Providers_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ProviderVisibility_Max_Fields = {
  __typename?: 'providerVisibility_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ProviderVisibility_Min_Fields = {
  __typename?: 'providerVisibility_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "providerVisibility" */
export type ProviderVisibility_Mutation_Response = {
  __typename?: 'providerVisibility_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProviderVisibility>;
};

/** input type for inserting object relation for remote table "providerVisibility" */
export type ProviderVisibility_Obj_Rel_Insert_Input = {
  data: ProviderVisibility_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProviderVisibility_On_Conflict>;
};

/** on_conflict condition type for table "providerVisibility" */
export type ProviderVisibility_On_Conflict = {
  constraint: ProviderVisibility_Constraint;
  update_columns?: Array<ProviderVisibility_Update_Column>;
  where?: InputMaybe<ProviderVisibility_Bool_Exp>;
};

/** Ordering options when selecting data from "providerVisibility". */
export type ProviderVisibility_Order_By = {
  providers_aggregate?: InputMaybe<Providers_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: providerVisibility */
export type ProviderVisibility_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "providerVisibility" */
export enum ProviderVisibility_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "providerVisibility" */
export type ProviderVisibility_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "providerVisibility" */
export type ProviderVisibility_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProviderVisibility_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProviderVisibility_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "providerVisibility" */
export enum ProviderVisibility_Update_Column {
  /** column name */
  Value = 'value'
}

export type ProviderVisibility_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProviderVisibility_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProviderVisibility_Bool_Exp;
};

/** columns and relationships of "providers" */
export type Providers = {
  __typename?: 'providers';
  address: Scalars['String']['output'];
  authTokens?: Maybe<Scalars['jsonb']['output']>;
  bookingCancelationWarningPeriod?: Maybe<Scalars['Int']['output']>;
  bookingDefaultStatus: BookingStatus_Enum;
  /** An object relationship */
  bookingStatus: BookingStatus;
  /** An array relationship */
  buildingProviders: Array<BuildingProviders>;
  /** An aggregate relationship */
  buildingProviders_aggregate: BuildingProviders_Aggregate;
  category: ProviderCategory_Enum;
  coverPic?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  customers: Array<Customers>;
  /** An aggregate relationship */
  customers_aggregate: Customers_Aggregate;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  /** An array relationship */
  forms: Array<Form>;
  /** An aggregate relationship */
  forms_aggregate: Form_Aggregate;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  locations: Array<Locations>;
  /** An aggregate relationship */
  locations_aggregate: Locations_Aggregate;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  profilePic?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  providerCategory: ProviderCategory;
  /** An array relationship */
  providerPayments: Array<ProviderMonthlyPayments>;
  /** An aggregate relationship */
  providerPayments_aggregate: ProviderMonthlyPayments_Aggregate;
  /** An object relationship */
  providerPictureByCoverPic?: Maybe<ProviderPictures>;
  /** An object relationship */
  providerPictureByProfilePic?: Maybe<ProviderPictures>;
  /** An array relationship */
  providerPictures: Array<ProviderPictures>;
  /** An aggregate relationship */
  providerPictures_aggregate: ProviderPictures_Aggregate;
  /** An object relationship */
  providerStatus: ProviderStatus;
  /** An object relationship */
  providerType: ProviderType;
  /** An object relationship */
  providerVisibility: ProviderVisibility;
  /** An array relationship */
  services: Array<Services>;
  /** An aggregate relationship */
  services_aggregate: Services_Aggregate;
  slug: Scalars['String']['output'];
  status: ProviderStatus_Enum;
  stripeClientSecret?: Maybe<Scalars['String']['output']>;
  stripeConnectAccId?: Maybe<Scalars['String']['output']>;
  /** stripe customer id on the platform account */
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** stripe payment method id on the platform account */
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  type: ProviderType_Enum;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  userRoles: Array<UserRoles>;
  /** An aggregate relationship */
  userRoles_aggregate: UserRoles_Aggregate;
  visibility: ProviderVisibility_Enum;
};


/** columns and relationships of "providers" */
export type ProvidersAuthTokensArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "providers" */
export type ProvidersBuildingProvidersArgs = {
  distinct_on?: InputMaybe<Array<BuildingProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingProviders_Order_By>>;
  where?: InputMaybe<BuildingProviders_Bool_Exp>;
};


/** columns and relationships of "providers" */
export type ProvidersBuildingProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuildingProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingProviders_Order_By>>;
  where?: InputMaybe<BuildingProviders_Bool_Exp>;
};


/** columns and relationships of "providers" */
export type ProvidersCustomersArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


/** columns and relationships of "providers" */
export type ProvidersCustomers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


/** columns and relationships of "providers" */
export type ProvidersFormsArgs = {
  distinct_on?: InputMaybe<Array<Form_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Order_By>>;
  where?: InputMaybe<Form_Bool_Exp>;
};


/** columns and relationships of "providers" */
export type ProvidersForms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Form_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Order_By>>;
  where?: InputMaybe<Form_Bool_Exp>;
};


/** columns and relationships of "providers" */
export type ProvidersLocationsArgs = {
  distinct_on?: InputMaybe<Array<Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locations_Order_By>>;
  where?: InputMaybe<Locations_Bool_Exp>;
};


/** columns and relationships of "providers" */
export type ProvidersLocations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locations_Order_By>>;
  where?: InputMaybe<Locations_Bool_Exp>;
};


/** columns and relationships of "providers" */
export type ProvidersProviderPaymentsArgs = {
  distinct_on?: InputMaybe<Array<ProviderMonthlyPayments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderMonthlyPayments_Order_By>>;
  where?: InputMaybe<ProviderMonthlyPayments_Bool_Exp>;
};


/** columns and relationships of "providers" */
export type ProvidersProviderPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderMonthlyPayments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderMonthlyPayments_Order_By>>;
  where?: InputMaybe<ProviderMonthlyPayments_Bool_Exp>;
};


/** columns and relationships of "providers" */
export type ProvidersProviderPicturesArgs = {
  distinct_on?: InputMaybe<Array<ProviderPictures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderPictures_Order_By>>;
  where?: InputMaybe<ProviderPictures_Bool_Exp>;
};


/** columns and relationships of "providers" */
export type ProvidersProviderPictures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderPictures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderPictures_Order_By>>;
  where?: InputMaybe<ProviderPictures_Bool_Exp>;
};


/** columns and relationships of "providers" */
export type ProvidersServicesArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


/** columns and relationships of "providers" */
export type ProvidersServices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


/** columns and relationships of "providers" */
export type ProvidersUserRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoles_Order_By>>;
  where?: InputMaybe<UserRoles_Bool_Exp>;
};


/** columns and relationships of "providers" */
export type ProvidersUserRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoles_Order_By>>;
  where?: InputMaybe<UserRoles_Bool_Exp>;
};

/** aggregated selection of "providers" */
export type Providers_Aggregate = {
  __typename?: 'providers_aggregate';
  aggregate?: Maybe<Providers_Aggregate_Fields>;
  nodes: Array<Providers>;
};

export type Providers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Providers_Aggregate_Bool_Exp_Count>;
};

export type Providers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Providers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "providers" */
export type Providers_Aggregate_Fields = {
  __typename?: 'providers_aggregate_fields';
  avg?: Maybe<Providers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Providers_Max_Fields>;
  min?: Maybe<Providers_Min_Fields>;
  stddev?: Maybe<Providers_Stddev_Fields>;
  stddev_pop?: Maybe<Providers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Providers_Stddev_Samp_Fields>;
  sum?: Maybe<Providers_Sum_Fields>;
  var_pop?: Maybe<Providers_Var_Pop_Fields>;
  var_samp?: Maybe<Providers_Var_Samp_Fields>;
  variance?: Maybe<Providers_Variance_Fields>;
};


/** aggregate fields of "providers" */
export type Providers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "providers" */
export type Providers_Aggregate_Order_By = {
  avg?: InputMaybe<Providers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Providers_Max_Order_By>;
  min?: InputMaybe<Providers_Min_Order_By>;
  stddev?: InputMaybe<Providers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Providers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Providers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Providers_Sum_Order_By>;
  var_pop?: InputMaybe<Providers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Providers_Var_Samp_Order_By>;
  variance?: InputMaybe<Providers_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Providers_Append_Input = {
  authTokens?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "providers" */
export type Providers_Arr_Rel_Insert_Input = {
  data: Array<Providers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Providers_On_Conflict>;
};

/** aggregate avg on columns */
export type Providers_Avg_Fields = {
  __typename?: 'providers_avg_fields';
  bookingCancelationWarningPeriod?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "providers" */
export type Providers_Avg_Order_By = {
  bookingCancelationWarningPeriod?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "providers". All fields are combined with a logical 'AND'. */
export type Providers_Bool_Exp = {
  _and?: InputMaybe<Array<Providers_Bool_Exp>>;
  _not?: InputMaybe<Providers_Bool_Exp>;
  _or?: InputMaybe<Array<Providers_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  authTokens?: InputMaybe<Jsonb_Comparison_Exp>;
  bookingCancelationWarningPeriod?: InputMaybe<Int_Comparison_Exp>;
  bookingDefaultStatus?: InputMaybe<BookingStatus_Enum_Comparison_Exp>;
  bookingStatus?: InputMaybe<BookingStatus_Bool_Exp>;
  buildingProviders?: InputMaybe<BuildingProviders_Bool_Exp>;
  buildingProviders_aggregate?: InputMaybe<BuildingProviders_Aggregate_Bool_Exp>;
  category?: InputMaybe<ProviderCategory_Enum_Comparison_Exp>;
  coverPic?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  customers?: InputMaybe<Customers_Bool_Exp>;
  customers_aggregate?: InputMaybe<Customers_Aggregate_Bool_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  forms?: InputMaybe<Form_Bool_Exp>;
  forms_aggregate?: InputMaybe<Form_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  locations?: InputMaybe<Locations_Bool_Exp>;
  locations_aggregate?: InputMaybe<Locations_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phoneNumber?: InputMaybe<String_Comparison_Exp>;
  profilePic?: InputMaybe<Uuid_Comparison_Exp>;
  providerCategory?: InputMaybe<ProviderCategory_Bool_Exp>;
  providerPayments?: InputMaybe<ProviderMonthlyPayments_Bool_Exp>;
  providerPayments_aggregate?: InputMaybe<ProviderMonthlyPayments_Aggregate_Bool_Exp>;
  providerPictureByCoverPic?: InputMaybe<ProviderPictures_Bool_Exp>;
  providerPictureByProfilePic?: InputMaybe<ProviderPictures_Bool_Exp>;
  providerPictures?: InputMaybe<ProviderPictures_Bool_Exp>;
  providerPictures_aggregate?: InputMaybe<ProviderPictures_Aggregate_Bool_Exp>;
  providerStatus?: InputMaybe<ProviderStatus_Bool_Exp>;
  providerType?: InputMaybe<ProviderType_Bool_Exp>;
  providerVisibility?: InputMaybe<ProviderVisibility_Bool_Exp>;
  services?: InputMaybe<Services_Bool_Exp>;
  services_aggregate?: InputMaybe<Services_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<ProviderStatus_Enum_Comparison_Exp>;
  stripeClientSecret?: InputMaybe<String_Comparison_Exp>;
  stripeConnectAccId?: InputMaybe<String_Comparison_Exp>;
  stripeCustomerId?: InputMaybe<String_Comparison_Exp>;
  stripePaymentMethodId?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<ProviderType_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userRoles?: InputMaybe<UserRoles_Bool_Exp>;
  userRoles_aggregate?: InputMaybe<UserRoles_Aggregate_Bool_Exp>;
  visibility?: InputMaybe<ProviderVisibility_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "providers" */
export enum Providers_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProvidersIdKey = 'providers_id_key',
  /** unique or primary key constraint on columns "name" */
  ProvidersNameKey = 'providers_name_key',
  /** unique or primary key constraint on columns "id" */
  ProvidersPkey = 'providers_pkey',
  /** unique or primary key constraint on columns "slug" */
  ProvidersSlugKey = 'providers_slug_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Providers_Delete_At_Path_Input = {
  authTokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Providers_Delete_Elem_Input = {
  authTokens?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Providers_Delete_Key_Input = {
  authTokens?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "providers" */
export type Providers_Inc_Input = {
  bookingCancelationWarningPeriod?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "providers" */
export type Providers_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  authTokens?: InputMaybe<Scalars['jsonb']['input']>;
  bookingCancelationWarningPeriod?: InputMaybe<Scalars['Int']['input']>;
  bookingDefaultStatus?: InputMaybe<BookingStatus_Enum>;
  bookingStatus?: InputMaybe<BookingStatus_Obj_Rel_Insert_Input>;
  buildingProviders?: InputMaybe<BuildingProviders_Arr_Rel_Insert_Input>;
  category?: InputMaybe<ProviderCategory_Enum>;
  coverPic?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customers?: InputMaybe<Customers_Arr_Rel_Insert_Input>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<Form_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  locations?: InputMaybe<Locations_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePic?: InputMaybe<Scalars['uuid']['input']>;
  providerCategory?: InputMaybe<ProviderCategory_Obj_Rel_Insert_Input>;
  providerPayments?: InputMaybe<ProviderMonthlyPayments_Arr_Rel_Insert_Input>;
  providerPictureByCoverPic?: InputMaybe<ProviderPictures_Obj_Rel_Insert_Input>;
  providerPictureByProfilePic?: InputMaybe<ProviderPictures_Obj_Rel_Insert_Input>;
  providerPictures?: InputMaybe<ProviderPictures_Arr_Rel_Insert_Input>;
  providerStatus?: InputMaybe<ProviderStatus_Obj_Rel_Insert_Input>;
  providerType?: InputMaybe<ProviderType_Obj_Rel_Insert_Input>;
  providerVisibility?: InputMaybe<ProviderVisibility_Obj_Rel_Insert_Input>;
  services?: InputMaybe<Services_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProviderStatus_Enum>;
  stripeClientSecret?: InputMaybe<Scalars['String']['input']>;
  stripeConnectAccId?: InputMaybe<Scalars['String']['input']>;
  /** stripe customer id on the platform account */
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  /** stripe payment method id on the platform account */
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProviderType_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userRoles?: InputMaybe<UserRoles_Arr_Rel_Insert_Input>;
  visibility?: InputMaybe<ProviderVisibility_Enum>;
};

/** aggregate max on columns */
export type Providers_Max_Fields = {
  __typename?: 'providers_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  bookingCancelationWarningPeriod?: Maybe<Scalars['Int']['output']>;
  coverPic?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePic?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stripeClientSecret?: Maybe<Scalars['String']['output']>;
  stripeConnectAccId?: Maybe<Scalars['String']['output']>;
  /** stripe customer id on the platform account */
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** stripe payment method id on the platform account */
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "providers" */
export type Providers_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  bookingCancelationWarningPeriod?: InputMaybe<Order_By>;
  coverPic?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  profilePic?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  stripeClientSecret?: InputMaybe<Order_By>;
  stripeConnectAccId?: InputMaybe<Order_By>;
  /** stripe customer id on the platform account */
  stripeCustomerId?: InputMaybe<Order_By>;
  /** stripe payment method id on the platform account */
  stripePaymentMethodId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Providers_Min_Fields = {
  __typename?: 'providers_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  bookingCancelationWarningPeriod?: Maybe<Scalars['Int']['output']>;
  coverPic?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePic?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stripeClientSecret?: Maybe<Scalars['String']['output']>;
  stripeConnectAccId?: Maybe<Scalars['String']['output']>;
  /** stripe customer id on the platform account */
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** stripe payment method id on the platform account */
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "providers" */
export type Providers_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  bookingCancelationWarningPeriod?: InputMaybe<Order_By>;
  coverPic?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  profilePic?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  stripeClientSecret?: InputMaybe<Order_By>;
  stripeConnectAccId?: InputMaybe<Order_By>;
  /** stripe customer id on the platform account */
  stripeCustomerId?: InputMaybe<Order_By>;
  /** stripe payment method id on the platform account */
  stripePaymentMethodId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "providers" */
export type Providers_Mutation_Response = {
  __typename?: 'providers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Providers>;
};

/** input type for inserting object relation for remote table "providers" */
export type Providers_Obj_Rel_Insert_Input = {
  data: Providers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Providers_On_Conflict>;
};

/** on_conflict condition type for table "providers" */
export type Providers_On_Conflict = {
  constraint: Providers_Constraint;
  update_columns?: Array<Providers_Update_Column>;
  where?: InputMaybe<Providers_Bool_Exp>;
};

/** Ordering options when selecting data from "providers". */
export type Providers_Order_By = {
  address?: InputMaybe<Order_By>;
  authTokens?: InputMaybe<Order_By>;
  bookingCancelationWarningPeriod?: InputMaybe<Order_By>;
  bookingDefaultStatus?: InputMaybe<Order_By>;
  bookingStatus?: InputMaybe<BookingStatus_Order_By>;
  buildingProviders_aggregate?: InputMaybe<BuildingProviders_Aggregate_Order_By>;
  category?: InputMaybe<Order_By>;
  coverPic?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  customers_aggregate?: InputMaybe<Customers_Aggregate_Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  forms_aggregate?: InputMaybe<Form_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  locations_aggregate?: InputMaybe<Locations_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  profilePic?: InputMaybe<Order_By>;
  providerCategory?: InputMaybe<ProviderCategory_Order_By>;
  providerPayments_aggregate?: InputMaybe<ProviderMonthlyPayments_Aggregate_Order_By>;
  providerPictureByCoverPic?: InputMaybe<ProviderPictures_Order_By>;
  providerPictureByProfilePic?: InputMaybe<ProviderPictures_Order_By>;
  providerPictures_aggregate?: InputMaybe<ProviderPictures_Aggregate_Order_By>;
  providerStatus?: InputMaybe<ProviderStatus_Order_By>;
  providerType?: InputMaybe<ProviderType_Order_By>;
  providerVisibility?: InputMaybe<ProviderVisibility_Order_By>;
  services_aggregate?: InputMaybe<Services_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripeClientSecret?: InputMaybe<Order_By>;
  stripeConnectAccId?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  stripePaymentMethodId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userRoles_aggregate?: InputMaybe<UserRoles_Aggregate_Order_By>;
  visibility?: InputMaybe<Order_By>;
};

/** primary key columns input for table: providers */
export type Providers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Providers_Prepend_Input = {
  authTokens?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "providers" */
export enum Providers_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AuthTokens = 'authTokens',
  /** column name */
  BookingCancelationWarningPeriod = 'bookingCancelationWarningPeriod',
  /** column name */
  BookingDefaultStatus = 'bookingDefaultStatus',
  /** column name */
  Category = 'category',
  /** column name */
  CoverPic = 'coverPic',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  ProfilePic = 'profilePic',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  StripeClientSecret = 'stripeClientSecret',
  /** column name */
  StripeConnectAccId = 'stripeConnectAccId',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripePaymentMethodId = 'stripePaymentMethodId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Visibility = 'visibility'
}

/** input type for updating data in table "providers" */
export type Providers_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  authTokens?: InputMaybe<Scalars['jsonb']['input']>;
  bookingCancelationWarningPeriod?: InputMaybe<Scalars['Int']['input']>;
  bookingDefaultStatus?: InputMaybe<BookingStatus_Enum>;
  category?: InputMaybe<ProviderCategory_Enum>;
  coverPic?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePic?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProviderStatus_Enum>;
  stripeClientSecret?: InputMaybe<Scalars['String']['input']>;
  stripeConnectAccId?: InputMaybe<Scalars['String']['input']>;
  /** stripe customer id on the platform account */
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  /** stripe payment method id on the platform account */
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProviderType_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  visibility?: InputMaybe<ProviderVisibility_Enum>;
};

/** aggregate stddev on columns */
export type Providers_Stddev_Fields = {
  __typename?: 'providers_stddev_fields';
  bookingCancelationWarningPeriod?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "providers" */
export type Providers_Stddev_Order_By = {
  bookingCancelationWarningPeriod?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Providers_Stddev_Pop_Fields = {
  __typename?: 'providers_stddev_pop_fields';
  bookingCancelationWarningPeriod?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "providers" */
export type Providers_Stddev_Pop_Order_By = {
  bookingCancelationWarningPeriod?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Providers_Stddev_Samp_Fields = {
  __typename?: 'providers_stddev_samp_fields';
  bookingCancelationWarningPeriod?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "providers" */
export type Providers_Stddev_Samp_Order_By = {
  bookingCancelationWarningPeriod?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "providers" */
export type Providers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Providers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Providers_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  authTokens?: InputMaybe<Scalars['jsonb']['input']>;
  bookingCancelationWarningPeriod?: InputMaybe<Scalars['Int']['input']>;
  bookingDefaultStatus?: InputMaybe<BookingStatus_Enum>;
  category?: InputMaybe<ProviderCategory_Enum>;
  coverPic?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePic?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProviderStatus_Enum>;
  stripeClientSecret?: InputMaybe<Scalars['String']['input']>;
  stripeConnectAccId?: InputMaybe<Scalars['String']['input']>;
  /** stripe customer id on the platform account */
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  /** stripe payment method id on the platform account */
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProviderType_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  visibility?: InputMaybe<ProviderVisibility_Enum>;
};

/** aggregate sum on columns */
export type Providers_Sum_Fields = {
  __typename?: 'providers_sum_fields';
  bookingCancelationWarningPeriod?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "providers" */
export type Providers_Sum_Order_By = {
  bookingCancelationWarningPeriod?: InputMaybe<Order_By>;
};

/** update columns of table "providers" */
export enum Providers_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AuthTokens = 'authTokens',
  /** column name */
  BookingCancelationWarningPeriod = 'bookingCancelationWarningPeriod',
  /** column name */
  BookingDefaultStatus = 'bookingDefaultStatus',
  /** column name */
  Category = 'category',
  /** column name */
  CoverPic = 'coverPic',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  ProfilePic = 'profilePic',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  StripeClientSecret = 'stripeClientSecret',
  /** column name */
  StripeConnectAccId = 'stripeConnectAccId',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripePaymentMethodId = 'stripePaymentMethodId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Visibility = 'visibility'
}

export type Providers_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Providers_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Providers_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Providers_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Providers_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Providers_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Providers_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Providers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Providers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Providers_Var_Pop_Fields = {
  __typename?: 'providers_var_pop_fields';
  bookingCancelationWarningPeriod?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "providers" */
export type Providers_Var_Pop_Order_By = {
  bookingCancelationWarningPeriod?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Providers_Var_Samp_Fields = {
  __typename?: 'providers_var_samp_fields';
  bookingCancelationWarningPeriod?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "providers" */
export type Providers_Var_Samp_Order_By = {
  bookingCancelationWarningPeriod?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Providers_Variance_Fields = {
  __typename?: 'providers_variance_fields';
  bookingCancelationWarningPeriod?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "providers" */
export type Providers_Variance_Order_By = {
  bookingCancelationWarningPeriod?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  CustomerCard?: Maybe<CustomerCardDto>;
  /** fetch data from the table: "appointmentPricing" */
  appointmentPricing: Array<AppointmentPricing>;
  /** fetch aggregated fields from the table: "appointmentPricing" */
  appointmentPricing_aggregate: AppointmentPricing_Aggregate;
  /** fetch data from the table: "appointmentPricing" using primary key columns */
  appointmentPricing_by_pk?: Maybe<AppointmentPricing>;
  /** An array relationship */
  appointments: Array<Appointments>;
  /** An aggregate relationship */
  appointments_aggregate: Appointments_Aggregate;
  /** fetch data from the table: "appointments" using primary key columns */
  appointments_by_pk?: Maybe<Appointments>;
  availableAppointmentDateTimeSlots: AvailableAppointmentDateTimeSlotsDto;
  /** fetch data from the table: "bookingStatus" */
  bookingStatus: Array<BookingStatus>;
  /** fetch aggregated fields from the table: "bookingStatus" */
  bookingStatus_aggregate: BookingStatus_Aggregate;
  /** fetch data from the table: "bookingStatus" using primary key columns */
  bookingStatus_by_pk?: Maybe<BookingStatus>;
  /** An array relationship */
  buildingProviders: Array<BuildingProviders>;
  /** An aggregate relationship */
  buildingProviders_aggregate: BuildingProviders_Aggregate;
  /** fetch data from the table: "buildingProviders" using primary key columns */
  buildingProviders_by_pk?: Maybe<BuildingProviders>;
  /** fetch data from the table: "buildingType" */
  buildingType: Array<BuildingType>;
  /** fetch aggregated fields from the table: "buildingType" */
  buildingType_aggregate: BuildingType_Aggregate;
  /** fetch data from the table: "buildingType" using primary key columns */
  buildingType_by_pk?: Maybe<BuildingType>;
  canProviderReceivePayments: Scalars['Boolean']['output'];
  /** fetch data from the table: "checkoutSessions" */
  checkoutSessions: Array<CheckoutSessions>;
  /** fetch aggregated fields from the table: "checkoutSessions" */
  checkoutSessions_aggregate: CheckoutSessions_Aggregate;
  /** fetch data from the table: "checkoutSessions" using primary key columns */
  checkoutSessions_by_pk?: Maybe<CheckoutSessions>;
  /** fetch data from the table: "currencies" */
  currencies: Array<Currencies>;
  /** fetch aggregated fields from the table: "currencies" */
  currencies_aggregate: Currencies_Aggregate;
  /** fetch data from the table: "currencies" using primary key columns */
  currencies_by_pk?: Maybe<Currencies>;
  /** fetch data from the table: "customerAmountSpent" */
  customerAmountSpent: Array<CustomerAmountSpent>;
  /** fetch aggregated fields from the table: "customerAmountSpent" */
  customerAmountSpent_aggregate: CustomerAmountSpent_Aggregate;
  /** An array relationship */
  customers: Array<Customers>;
  /** An aggregate relationship */
  customers_aggregate: Customers_Aggregate;
  /** fetch data from the table: "customers" using primary key columns */
  customers_by_pk?: Maybe<Customers>;
  /** fetch data from the table: "entityType" */
  entityType: Array<EntityType>;
  /** fetch aggregated fields from the table: "entityType" */
  entityType_aggregate: EntityType_Aggregate;
  /** fetch data from the table: "entityType" using primary key columns */
  entityType_by_pk?: Maybe<EntityType>;
  /** fetch data from the table: "files" */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "files" */
  files_aggregate: Files_Aggregate;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: Maybe<Files>;
  findLocationsByServiceId: Array<LocationWithDistance>;
  /** fetch data from the table: "form" */
  form: Array<Form>;
  /** An array relationship */
  formAnswers: Array<FormAnswers>;
  /** An aggregate relationship */
  formAnswers_aggregate: FormAnswers_Aggregate;
  /** fetch data from the table: "formAnswers" using primary key columns */
  formAnswers_by_pk?: Maybe<FormAnswers>;
  /** An array relationship */
  formQuestionOptions: Array<FormQuestionOptions>;
  /** An aggregate relationship */
  formQuestionOptions_aggregate: FormQuestionOptions_Aggregate;
  /** fetch data from the table: "formQuestionOptions" using primary key columns */
  formQuestionOptions_by_pk?: Maybe<FormQuestionOptions>;
  /** fetch data from the table: "formQuestionType" */
  formQuestionType: Array<FormQuestionType>;
  /** fetch aggregated fields from the table: "formQuestionType" */
  formQuestionType_aggregate: FormQuestionType_Aggregate;
  /** fetch data from the table: "formQuestionType" using primary key columns */
  formQuestionType_by_pk?: Maybe<FormQuestionType>;
  /** An array relationship */
  formQuestions: Array<FormQuestions>;
  /** An aggregate relationship */
  formQuestions_aggregate: FormQuestions_Aggregate;
  /** fetch data from the table: "formQuestions" using primary key columns */
  formQuestions_by_pk?: Maybe<FormQuestions>;
  /** fetch aggregated fields from the table: "form" */
  form_aggregate: Form_Aggregate;
  /** fetch data from the table: "form" using primary key columns */
  form_by_pk?: Maybe<Form>;
  getAdminCustomerDetails: CustomerEntryDto;
  getAdminCustomerList: AdminCustomerListDto;
  getAllUsers: Array<UserWithoutPassword>;
  getAppointmentPaymentDetails: GetAppointmentPaymentDetails;
  getBMCustomerDetails?: Maybe<BuildingManagerCustomerWithAppointmentsDto>;
  getBMCustomerList: BuildingManagerCustomerListDto;
  getCalendar: CalendarListEntryDto;
  getCheckoutPrivateFile: Scalars['String']['output'];
  getCurrentProvider: Provider;
  getCurrentUser: UserWithoutPassword;
  getCustomerServices: Array<CustomerServices>;
  getEmployeesByServiceIdAndLocationId: Array<Employee>;
  getGoogleOAuthUrl: Scalars['String']['output'];
  getLocationByAddress: LocationDto;
  getPrivateFile: Scalars['String']['output'];
  getProviderCard?: Maybe<Card>;
  getProviderVisibility: ProviderVisibilityDto;
  getPublicUploadFileUrl: UploadFileUrlDto;
  getUpfrontAppointmentDetails: GetUpfrontAppointmentDetails;
  getUploadFileUrl: UploadFileUrlDto;
  getUserCard?: Maybe<Card>;
  /** execute function "get_nearby_locations" which returns "locations_with_distance" */
  get_nearby_locations: Array<Locations_With_Distance>;
  /** execute function "get_nearby_locations" and query aggregates on result of table type "locations_with_distance" */
  get_nearby_locations_aggregate: Locations_With_Distance_Aggregate;
  haversine: HaversineDto;
  isGoogleCalendarLinked: Scalars['Boolean']['output'];
  isOnboardingCompleted: OnboardingCompletedDto;
  /** fetch data from the table: "jobStatus" */
  jobStatus: Array<JobStatus>;
  /** fetch aggregated fields from the table: "jobStatus" */
  jobStatus_aggregate: JobStatus_Aggregate;
  /** fetch data from the table: "jobStatus" using primary key columns */
  jobStatus_by_pk?: Maybe<JobStatus>;
  listCalendars: Array<CalendarListEntryDto>;
  /** fetch data from the table: "locale" */
  locale: Array<Locale>;
  /** fetch aggregated fields from the table: "locale" */
  locale_aggregate: Locale_Aggregate;
  /** fetch data from the table: "locale" using primary key columns */
  locale_by_pk?: Maybe<Locale>;
  locationHaversine: HaversineDto;
  /** fetch data from the table: "locationStatus" */
  locationStatus: Array<LocationStatus>;
  /** fetch aggregated fields from the table: "locationStatus" */
  locationStatus_aggregate: LocationStatus_Aggregate;
  /** fetch data from the table: "locationStatus" using primary key columns */
  locationStatus_by_pk?: Maybe<LocationStatus>;
  /** fetch data from the table: "locationType" */
  locationType: Array<LocationType>;
  /** fetch aggregated fields from the table: "locationType" */
  locationType_aggregate: LocationType_Aggregate;
  /** fetch data from the table: "locationType" using primary key columns */
  locationType_by_pk?: Maybe<LocationType>;
  /** An array relationship */
  locations: Array<Locations>;
  /** An aggregate relationship */
  locations_aggregate: Locations_Aggregate;
  /** fetch data from the table: "locations" using primary key columns */
  locations_by_pk?: Maybe<Locations>;
  /** fetch data from the table: "locations_with_distance" */
  locations_with_distance: Array<Locations_With_Distance>;
  /** fetch aggregated fields from the table: "locations_with_distance" */
  locations_with_distance_aggregate: Locations_With_Distance_Aggregate;
  login: UserSessionDto;
  /** fetch data from the table: "notificationType" */
  notificationType: Array<NotificationType>;
  /** fetch aggregated fields from the table: "notificationType" */
  notificationType_aggregate: NotificationType_Aggregate;
  /** fetch data from the table: "notificationType" using primary key columns */
  notificationType_by_pk?: Maybe<NotificationType>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** fetch data from the table: "partnershipSchedulingType" */
  partnershipSchedulingType: Array<PartnershipSchedulingType>;
  /** fetch aggregated fields from the table: "partnershipSchedulingType" */
  partnershipSchedulingType_aggregate: PartnershipSchedulingType_Aggregate;
  /** fetch data from the table: "partnershipSchedulingType" using primary key columns */
  partnershipSchedulingType_by_pk?: Maybe<PartnershipSchedulingType>;
  /** fetch data from the table: "partnershipStatus" */
  partnershipStatus: Array<PartnershipStatus>;
  /** fetch aggregated fields from the table: "partnershipStatus" */
  partnershipStatus_aggregate: PartnershipStatus_Aggregate;
  /** fetch data from the table: "partnershipStatus" using primary key columns */
  partnershipStatus_by_pk?: Maybe<PartnershipStatus>;
  /** fetch data from the table: "paymentFormat" */
  paymentFormat: Array<PaymentFormat>;
  /** fetch aggregated fields from the table: "paymentFormat" */
  paymentFormat_aggregate: PaymentFormat_Aggregate;
  /** fetch data from the table: "paymentFormat" using primary key columns */
  paymentFormat_by_pk?: Maybe<PaymentFormat>;
  /** fetch data from the table: "paymentStatus" */
  paymentStatus: Array<PaymentStatus>;
  /** fetch aggregated fields from the table: "paymentStatus" */
  paymentStatus_aggregate: PaymentStatus_Aggregate;
  /** fetch data from the table: "paymentStatus" using primary key columns */
  paymentStatus_by_pk?: Maybe<PaymentStatus>;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  /** fetch data from the table: "payments" using primary key columns */
  payments_by_pk?: Maybe<Payments>;
  payouts: PayoutsDto;
  /** fetch data from the table: "providerCategory" */
  providerCategory: Array<ProviderCategory>;
  /** fetch aggregated fields from the table: "providerCategory" */
  providerCategory_aggregate: ProviderCategory_Aggregate;
  /** fetch data from the table: "providerCategory" using primary key columns */
  providerCategory_by_pk?: Maybe<ProviderCategory>;
  /** fetch data from the table: "providerMonthlyPayments" */
  providerMonthlyPayments: Array<ProviderMonthlyPayments>;
  /** fetch aggregated fields from the table: "providerMonthlyPayments" */
  providerMonthlyPayments_aggregate: ProviderMonthlyPayments_Aggregate;
  /** fetch data from the table: "providerMonthlyPayments" using primary key columns */
  providerMonthlyPayments_by_pk?: Maybe<ProviderMonthlyPayments>;
  providerPayments: ProviderPaymentsDto;
  /** An array relationship */
  providerPictures: Array<ProviderPictures>;
  /** An aggregate relationship */
  providerPictures_aggregate: ProviderPictures_Aggregate;
  /** fetch data from the table: "providerPictures" using primary key columns */
  providerPictures_by_pk?: Maybe<ProviderPictures>;
  /** fetch data from the table: "providerRole" */
  providerRole: Array<ProviderRole>;
  /** fetch aggregated fields from the table: "providerRole" */
  providerRole_aggregate: ProviderRole_Aggregate;
  /** fetch data from the table: "providerRole" using primary key columns */
  providerRole_by_pk?: Maybe<ProviderRole>;
  /** fetch data from the table: "providerStatus" */
  providerStatus: Array<ProviderStatus>;
  /** fetch aggregated fields from the table: "providerStatus" */
  providerStatus_aggregate: ProviderStatus_Aggregate;
  /** fetch data from the table: "providerStatus" using primary key columns */
  providerStatus_by_pk?: Maybe<ProviderStatus>;
  /** fetch data from the table: "providerType" */
  providerType: Array<ProviderType>;
  /** fetch aggregated fields from the table: "providerType" */
  providerType_aggregate: ProviderType_Aggregate;
  /** fetch data from the table: "providerType" using primary key columns */
  providerType_by_pk?: Maybe<ProviderType>;
  /** fetch data from the table: "providerVisibility" */
  providerVisibility: Array<ProviderVisibility>;
  /** fetch aggregated fields from the table: "providerVisibility" */
  providerVisibility_aggregate: ProviderVisibility_Aggregate;
  /** fetch data from the table: "providerVisibility" using primary key columns */
  providerVisibility_by_pk?: Maybe<ProviderVisibility>;
  /** An array relationship */
  providers: Array<Providers>;
  /** An aggregate relationship */
  providers_aggregate: Providers_Aggregate;
  /** fetch data from the table: "providers" using primary key columns */
  providers_by_pk?: Maybe<Providers>;
  /** An array relationship */
  refunds: Array<Refunds>;
  /** An aggregate relationship */
  refunds_aggregate: Refunds_Aggregate;
  /** fetch data from the table: "refunds" using primary key columns */
  refunds_by_pk?: Maybe<Refunds>;
  /** fetch data from the table: "relationshipStatus" */
  relationshipStatus: Array<RelationshipStatus>;
  /** fetch aggregated fields from the table: "relationshipStatus" */
  relationshipStatus_aggregate: RelationshipStatus_Aggregate;
  /** fetch data from the table: "relationshipStatus" using primary key columns */
  relationshipStatus_by_pk?: Maybe<RelationshipStatus>;
  /** fetch data from the table: "schedule" */
  schedule: Array<Schedule>;
  /** fetch aggregated fields from the table: "schedule" */
  schedule_aggregate: Schedule_Aggregate;
  /** fetch data from the table: "schedule" using primary key columns */
  schedule_by_pk?: Maybe<Schedule>;
  /** An array relationship */
  serviceEmployees: Array<ServiceEmployees>;
  /** An aggregate relationship */
  serviceEmployees_aggregate: ServiceEmployees_Aggregate;
  /** fetch data from the table: "serviceEmployees" using primary key columns */
  serviceEmployees_by_pk?: Maybe<ServiceEmployees>;
  /** fetch data from the table: "serviceFormStatus" */
  serviceFormStatus: Array<ServiceFormStatus>;
  /** fetch aggregated fields from the table: "serviceFormStatus" */
  serviceFormStatus_aggregate: ServiceFormStatus_Aggregate;
  /** fetch data from the table: "serviceFormStatus" using primary key columns */
  serviceFormStatus_by_pk?: Maybe<ServiceFormStatus>;
  /** An array relationship */
  serviceOptionAnswers: Array<ServiceOptionAnswers>;
  /** An aggregate relationship */
  serviceOptionAnswers_aggregate: ServiceOptionAnswers_Aggregate;
  /** fetch data from the table: "serviceOptionAnswers" using primary key columns */
  serviceOptionAnswers_by_pk?: Maybe<ServiceOptionAnswers>;
  /** fetch data from the table: "serviceOptionSection" */
  serviceOptionSection: Array<ServiceOptionSection>;
  /** An array relationship */
  serviceOptionSectionOptions: Array<ServiceOptionSectionOptions>;
  /** An aggregate relationship */
  serviceOptionSectionOptions_aggregate: ServiceOptionSectionOptions_Aggregate;
  /** fetch data from the table: "serviceOptionSectionOptions" using primary key columns */
  serviceOptionSectionOptions_by_pk?: Maybe<ServiceOptionSectionOptions>;
  /** fetch aggregated fields from the table: "serviceOptionSection" */
  serviceOptionSection_aggregate: ServiceOptionSection_Aggregate;
  /** fetch data from the table: "serviceOptionSection" using primary key columns */
  serviceOptionSection_by_pk?: Maybe<ServiceOptionSection>;
  /** An array relationship */
  serviceOptions: Array<ServiceOptions>;
  /** fetch data from the table: "serviceOptionsStatus" */
  serviceOptionsStatus: Array<ServiceOptionsStatus>;
  /** fetch aggregated fields from the table: "serviceOptionsStatus" */
  serviceOptionsStatus_aggregate: ServiceOptionsStatus_Aggregate;
  /** fetch data from the table: "serviceOptionsStatus" using primary key columns */
  serviceOptionsStatus_by_pk?: Maybe<ServiceOptionsStatus>;
  /** An aggregate relationship */
  serviceOptions_aggregate: ServiceOptions_Aggregate;
  /** fetch data from the table: "serviceOptions" using primary key columns */
  serviceOptions_by_pk?: Maybe<ServiceOptions>;
  /** An array relationship */
  servicePictures: Array<ServicePictures>;
  /** An aggregate relationship */
  servicePictures_aggregate: ServicePictures_Aggregate;
  /** fetch data from the table: "servicePictures" using primary key columns */
  servicePictures_by_pk?: Maybe<ServicePictures>;
  /** An array relationship */
  servicePricings: Array<ServicePricings>;
  /** An aggregate relationship */
  servicePricings_aggregate: ServicePricings_Aggregate;
  /** fetch data from the table: "servicePricings" using primary key columns */
  servicePricings_by_pk?: Maybe<ServicePricings>;
  /** fetch data from the table: "serviceSectionOptionQuantityType" */
  serviceSectionOptionQuantityType: Array<ServiceSectionOptionQuantityType>;
  /** fetch aggregated fields from the table: "serviceSectionOptionQuantityType" */
  serviceSectionOptionQuantityType_aggregate: ServiceSectionOptionQuantityType_Aggregate;
  /** fetch data from the table: "serviceSectionOptionQuantityType" using primary key columns */
  serviceSectionOptionQuantityType_by_pk?: Maybe<ServiceSectionOptionQuantityType>;
  /** fetch data from the table: "serviceSectionOptionType" */
  serviceSectionOptionType: Array<ServiceSectionOptionType>;
  /** fetch aggregated fields from the table: "serviceSectionOptionType" */
  serviceSectionOptionType_aggregate: ServiceSectionOptionType_Aggregate;
  /** fetch data from the table: "serviceSectionOptionType" using primary key columns */
  serviceSectionOptionType_by_pk?: Maybe<ServiceSectionOptionType>;
  /** fetch data from the table: "serviceStatus" */
  serviceStatus: Array<ServiceStatus>;
  /** fetch aggregated fields from the table: "serviceStatus" */
  serviceStatus_aggregate: ServiceStatus_Aggregate;
  /** fetch data from the table: "serviceStatus" using primary key columns */
  serviceStatus_by_pk?: Maybe<ServiceStatus>;
  /** An array relationship */
  services: Array<Services>;
  /** An array relationship */
  servicesForms: Array<ServicesForms>;
  /** An aggregate relationship */
  servicesForms_aggregate: ServicesForms_Aggregate;
  /** fetch data from the table: "servicesForms" using primary key columns */
  servicesForms_by_pk?: Maybe<ServicesForms>;
  /** An aggregate relationship */
  services_aggregate: Services_Aggregate;
  /** fetch data from the table: "services" using primary key columns */
  services_by_pk?: Maybe<Services>;
  /** fetch data from the table: "sessions" */
  sessions: Array<Sessions>;
  /** fetch aggregated fields from the table: "sessions" */
  sessions_aggregate: Sessions_Aggregate;
  /** fetch data from the table: "sessions" using primary key columns */
  sessions_by_pk?: Maybe<Sessions>;
  /** An array relationship */
  timeouts: Array<Timeouts>;
  /** An aggregate relationship */
  timeouts_aggregate: Timeouts_Aggregate;
  /** fetch data from the table: "timeouts" using primary key columns */
  timeouts_by_pk?: Maybe<Timeouts>;
  /** fetch data from the table: "transitionStatus" */
  transitionStatus: Array<TransitionStatus>;
  /** fetch aggregated fields from the table: "transitionStatus" */
  transitionStatus_aggregate: TransitionStatus_Aggregate;
  /** fetch data from the table: "transitionStatus" using primary key columns */
  transitionStatus_by_pk?: Maybe<TransitionStatus>;
  /** An array relationship */
  unavailableServiceLocations: Array<UnavailableServiceLocations>;
  /** An aggregate relationship */
  unavailableServiceLocations_aggregate: UnavailableServiceLocations_Aggregate;
  /** fetch data from the table: "unavailableServiceLocations" using primary key columns */
  unavailableServiceLocations_by_pk?: Maybe<UnavailableServiceLocations>;
  /** fetch data from the table: "userRole" */
  userRole: Array<UserRole>;
  /** fetch aggregated fields from the table: "userRole" */
  userRole_aggregate: UserRole_Aggregate;
  /** fetch data from the table: "userRole" using primary key columns */
  userRole_by_pk?: Maybe<UserRole>;
  /** An array relationship */
  userRoles: Array<UserRoles>;
  /** An aggregate relationship */
  userRoles_aggregate: UserRoles_Aggregate;
  /** fetch data from the table: "userRoles" using primary key columns */
  userRoles_by_pk?: Maybe<UserRoles>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  validateServiceById: ValidateService;
};


export type Query_RootCustomerCardArgs = {
  customerId: Scalars['String']['input'];
};


export type Query_RootAppointmentPricingArgs = {
  distinct_on?: InputMaybe<Array<AppointmentPricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AppointmentPricing_Order_By>>;
  where?: InputMaybe<AppointmentPricing_Bool_Exp>;
};


export type Query_RootAppointmentPricing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AppointmentPricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AppointmentPricing_Order_By>>;
  where?: InputMaybe<AppointmentPricing_Bool_Exp>;
};


export type Query_RootAppointmentPricing_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAppointmentsArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


export type Query_RootAppointments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


export type Query_RootAppointments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAvailableAppointmentDateTimeSlotsArgs = {
  inputs: TimeSlotsDto;
};


export type Query_RootBookingStatusArgs = {
  distinct_on?: InputMaybe<Array<BookingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BookingStatus_Order_By>>;
  where?: InputMaybe<BookingStatus_Bool_Exp>;
};


export type Query_RootBookingStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BookingStatus_Order_By>>;
  where?: InputMaybe<BookingStatus_Bool_Exp>;
};


export type Query_RootBookingStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootBuildingProvidersArgs = {
  distinct_on?: InputMaybe<Array<BuildingProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingProviders_Order_By>>;
  where?: InputMaybe<BuildingProviders_Bool_Exp>;
};


export type Query_RootBuildingProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuildingProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingProviders_Order_By>>;
  where?: InputMaybe<BuildingProviders_Bool_Exp>;
};


export type Query_RootBuildingProviders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBuildingTypeArgs = {
  distinct_on?: InputMaybe<Array<BuildingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingType_Order_By>>;
  where?: InputMaybe<BuildingType_Bool_Exp>;
};


export type Query_RootBuildingType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuildingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingType_Order_By>>;
  where?: InputMaybe<BuildingType_Bool_Exp>;
};


export type Query_RootBuildingType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootCanProviderReceivePaymentsArgs = {
  providerId: Scalars['String']['input'];
};


export type Query_RootCheckoutSessionsArgs = {
  distinct_on?: InputMaybe<Array<CheckoutSessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CheckoutSessions_Order_By>>;
  where?: InputMaybe<CheckoutSessions_Bool_Exp>;
};


export type Query_RootCheckoutSessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CheckoutSessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CheckoutSessions_Order_By>>;
  where?: InputMaybe<CheckoutSessions_Bool_Exp>;
};


export type Query_RootCheckoutSessions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCurrenciesArgs = {
  distinct_on?: InputMaybe<Array<Currencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currencies_Order_By>>;
  where?: InputMaybe<Currencies_Bool_Exp>;
};


export type Query_RootCurrencies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Currencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currencies_Order_By>>;
  where?: InputMaybe<Currencies_Bool_Exp>;
};


export type Query_RootCurrencies_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootCustomerAmountSpentArgs = {
  distinct_on?: InputMaybe<Array<CustomerAmountSpent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CustomerAmountSpent_Order_By>>;
  where?: InputMaybe<CustomerAmountSpent_Bool_Exp>;
};


export type Query_RootCustomerAmountSpent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CustomerAmountSpent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CustomerAmountSpent_Order_By>>;
  where?: InputMaybe<CustomerAmountSpent_Bool_Exp>;
};


export type Query_RootCustomersArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Query_RootCustomers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Query_RootCustomers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEntityTypeArgs = {
  distinct_on?: InputMaybe<Array<EntityType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EntityType_Order_By>>;
  where?: InputMaybe<EntityType_Bool_Exp>;
};


export type Query_RootEntityType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EntityType_Order_By>>;
  where?: InputMaybe<EntityType_Bool_Exp>;
};


export type Query_RootEntityType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFiles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFindLocationsByServiceIdArgs = {
  coordinates?: InputMaybe<GeographyCoordinatesInput>;
  serviceId: Scalars['String']['input'];
};


export type Query_RootFormArgs = {
  distinct_on?: InputMaybe<Array<Form_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Order_By>>;
  where?: InputMaybe<Form_Bool_Exp>;
};


export type Query_RootFormAnswersArgs = {
  distinct_on?: InputMaybe<Array<FormAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormAnswers_Order_By>>;
  where?: InputMaybe<FormAnswers_Bool_Exp>;
};


export type Query_RootFormAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FormAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormAnswers_Order_By>>;
  where?: InputMaybe<FormAnswers_Bool_Exp>;
};


export type Query_RootFormAnswers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFormQuestionOptionsArgs = {
  distinct_on?: InputMaybe<Array<FormQuestionOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormQuestionOptions_Order_By>>;
  where?: InputMaybe<FormQuestionOptions_Bool_Exp>;
};


export type Query_RootFormQuestionOptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FormQuestionOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormQuestionOptions_Order_By>>;
  where?: InputMaybe<FormQuestionOptions_Bool_Exp>;
};


export type Query_RootFormQuestionOptions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFormQuestionTypeArgs = {
  distinct_on?: InputMaybe<Array<FormQuestionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormQuestionType_Order_By>>;
  where?: InputMaybe<FormQuestionType_Bool_Exp>;
};


export type Query_RootFormQuestionType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FormQuestionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormQuestionType_Order_By>>;
  where?: InputMaybe<FormQuestionType_Bool_Exp>;
};


export type Query_RootFormQuestionType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootFormQuestionsArgs = {
  distinct_on?: InputMaybe<Array<FormQuestions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormQuestions_Order_By>>;
  where?: InputMaybe<FormQuestions_Bool_Exp>;
};


export type Query_RootFormQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FormQuestions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormQuestions_Order_By>>;
  where?: InputMaybe<FormQuestions_Bool_Exp>;
};


export type Query_RootFormQuestions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootForm_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Form_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Order_By>>;
  where?: InputMaybe<Form_Bool_Exp>;
};


export type Query_RootForm_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootGetAdminCustomerDetailsArgs = {
  customerId: Scalars['String']['input'];
};


export type Query_RootGetAdminCustomerListArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
};


export type Query_RootGetAppointmentPaymentDetailsArgs = {
  appointmentId: Scalars['String']['input'];
};


export type Query_RootGetBmCustomerDetailsArgs = {
  appointmentsLimit?: InputMaybe<Scalars['Float']['input']>;
  appointmentsOffset?: InputMaybe<Scalars['Float']['input']>;
  customerId: Scalars['String']['input'];
};


export type Query_RootGetBmCustomerListArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  searchByName: Scalars['String']['input'];
};


export type Query_RootGetCalendarArgs = {
  calendarId: Scalars['String']['input'];
};


export type Query_RootGetCheckoutPrivateFileArgs = {
  fileName: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type Query_RootGetEmployeesByServiceIdAndLocationIdArgs = {
  locationId: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};


export type Query_RootGetLocationByAddressArgs = {
  address: Scalars['String']['input'];
};


export type Query_RootGetPrivateFileArgs = {
  fileName: Scalars['String']['input'];
};


export type Query_RootGetPublicUploadFileUrlArgs = {
  file: UploadFileDto;
  token: Scalars['String']['input'];
};


export type Query_RootGetUpfrontAppointmentDetailsArgs = {
  data: GetUpfrontAppointmentDetailsDtoArgs;
};


export type Query_RootGetUploadFileUrlArgs = {
  file: UploadFileDto;
};


export type Query_RootGet_Nearby_LocationsArgs = {
  args: Get_Nearby_Locations_Args;
  distinct_on?: InputMaybe<Array<Locations_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locations_With_Distance_Order_By>>;
  where?: InputMaybe<Locations_With_Distance_Bool_Exp>;
};


export type Query_RootGet_Nearby_Locations_AggregateArgs = {
  args: Get_Nearby_Locations_Args;
  distinct_on?: InputMaybe<Array<Locations_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locations_With_Distance_Order_By>>;
  where?: InputMaybe<Locations_With_Distance_Bool_Exp>;
};


export type Query_RootHaversineArgs = {
  input: HaversineInputDto;
};


export type Query_RootJobStatusArgs = {
  distinct_on?: InputMaybe<Array<JobStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<JobStatus_Order_By>>;
  where?: InputMaybe<JobStatus_Bool_Exp>;
};


export type Query_RootJobStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<JobStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<JobStatus_Order_By>>;
  where?: InputMaybe<JobStatus_Bool_Exp>;
};


export type Query_RootJobStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootLocaleArgs = {
  distinct_on?: InputMaybe<Array<Locale_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locale_Order_By>>;
  where?: InputMaybe<Locale_Bool_Exp>;
};


export type Query_RootLocale_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Locale_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locale_Order_By>>;
  where?: InputMaybe<Locale_Bool_Exp>;
};


export type Query_RootLocale_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootLocationHaversineArgs = {
  input: LocationHaversineInputDto;
};


export type Query_RootLocationStatusArgs = {
  distinct_on?: InputMaybe<Array<LocationStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<LocationStatus_Order_By>>;
  where?: InputMaybe<LocationStatus_Bool_Exp>;
};


export type Query_RootLocationStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LocationStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<LocationStatus_Order_By>>;
  where?: InputMaybe<LocationStatus_Bool_Exp>;
};


export type Query_RootLocationStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootLocationTypeArgs = {
  distinct_on?: InputMaybe<Array<LocationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<LocationType_Order_By>>;
  where?: InputMaybe<LocationType_Bool_Exp>;
};


export type Query_RootLocationType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LocationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<LocationType_Order_By>>;
  where?: InputMaybe<LocationType_Bool_Exp>;
};


export type Query_RootLocationType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootLocationsArgs = {
  distinct_on?: InputMaybe<Array<Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locations_Order_By>>;
  where?: InputMaybe<Locations_Bool_Exp>;
};


export type Query_RootLocations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locations_Order_By>>;
  where?: InputMaybe<Locations_Bool_Exp>;
};


export type Query_RootLocations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLocations_With_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Locations_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locations_With_Distance_Order_By>>;
  where?: InputMaybe<Locations_With_Distance_Bool_Exp>;
};


export type Query_RootLocations_With_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Locations_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locations_With_Distance_Order_By>>;
  where?: InputMaybe<Locations_With_Distance_Bool_Exp>;
};


export type Query_RootLoginArgs = {
  user: UserLoginInputDto;
};


export type Query_RootNotificationTypeArgs = {
  distinct_on?: InputMaybe<Array<NotificationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationType_Order_By>>;
  where?: InputMaybe<NotificationType_Bool_Exp>;
};


export type Query_RootNotificationType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationType_Order_By>>;
  where?: InputMaybe<NotificationType_Bool_Exp>;
};


export type Query_RootNotificationType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootNotifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPartnershipSchedulingTypeArgs = {
  distinct_on?: InputMaybe<Array<PartnershipSchedulingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PartnershipSchedulingType_Order_By>>;
  where?: InputMaybe<PartnershipSchedulingType_Bool_Exp>;
};


export type Query_RootPartnershipSchedulingType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PartnershipSchedulingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PartnershipSchedulingType_Order_By>>;
  where?: InputMaybe<PartnershipSchedulingType_Bool_Exp>;
};


export type Query_RootPartnershipSchedulingType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPartnershipStatusArgs = {
  distinct_on?: InputMaybe<Array<PartnershipStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PartnershipStatus_Order_By>>;
  where?: InputMaybe<PartnershipStatus_Bool_Exp>;
};


export type Query_RootPartnershipStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PartnershipStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PartnershipStatus_Order_By>>;
  where?: InputMaybe<PartnershipStatus_Bool_Exp>;
};


export type Query_RootPartnershipStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPaymentFormatArgs = {
  distinct_on?: InputMaybe<Array<PaymentFormat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaymentFormat_Order_By>>;
  where?: InputMaybe<PaymentFormat_Bool_Exp>;
};


export type Query_RootPaymentFormat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PaymentFormat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaymentFormat_Order_By>>;
  where?: InputMaybe<PaymentFormat_Bool_Exp>;
};


export type Query_RootPaymentFormat_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPaymentStatusArgs = {
  distinct_on?: InputMaybe<Array<PaymentStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaymentStatus_Order_By>>;
  where?: InputMaybe<PaymentStatus_Bool_Exp>;
};


export type Query_RootPaymentStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PaymentStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaymentStatus_Order_By>>;
  where?: InputMaybe<PaymentStatus_Bool_Exp>;
};


export type Query_RootPaymentStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Query_RootPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Query_RootPayments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPayoutsArgs = {
  limit: Scalars['Float']['input'];
  startingAfter?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootProviderCategoryArgs = {
  distinct_on?: InputMaybe<Array<ProviderCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderCategory_Order_By>>;
  where?: InputMaybe<ProviderCategory_Bool_Exp>;
};


export type Query_RootProviderCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderCategory_Order_By>>;
  where?: InputMaybe<ProviderCategory_Bool_Exp>;
};


export type Query_RootProviderCategory_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProviderMonthlyPaymentsArgs = {
  distinct_on?: InputMaybe<Array<ProviderMonthlyPayments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderMonthlyPayments_Order_By>>;
  where?: InputMaybe<ProviderMonthlyPayments_Bool_Exp>;
};


export type Query_RootProviderMonthlyPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderMonthlyPayments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderMonthlyPayments_Order_By>>;
  where?: InputMaybe<ProviderMonthlyPayments_Bool_Exp>;
};


export type Query_RootProviderMonthlyPayments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProviderPaymentsArgs = {
  limit: Scalars['Float']['input'];
  startingAfter?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootProviderPicturesArgs = {
  distinct_on?: InputMaybe<Array<ProviderPictures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderPictures_Order_By>>;
  where?: InputMaybe<ProviderPictures_Bool_Exp>;
};


export type Query_RootProviderPictures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderPictures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderPictures_Order_By>>;
  where?: InputMaybe<ProviderPictures_Bool_Exp>;
};


export type Query_RootProviderPictures_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProviderRoleArgs = {
  distinct_on?: InputMaybe<Array<ProviderRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderRole_Order_By>>;
  where?: InputMaybe<ProviderRole_Bool_Exp>;
};


export type Query_RootProviderRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderRole_Order_By>>;
  where?: InputMaybe<ProviderRole_Bool_Exp>;
};


export type Query_RootProviderRole_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProviderStatusArgs = {
  distinct_on?: InputMaybe<Array<ProviderStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderStatus_Order_By>>;
  where?: InputMaybe<ProviderStatus_Bool_Exp>;
};


export type Query_RootProviderStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderStatus_Order_By>>;
  where?: InputMaybe<ProviderStatus_Bool_Exp>;
};


export type Query_RootProviderStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProviderTypeArgs = {
  distinct_on?: InputMaybe<Array<ProviderType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderType_Order_By>>;
  where?: InputMaybe<ProviderType_Bool_Exp>;
};


export type Query_RootProviderType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderType_Order_By>>;
  where?: InputMaybe<ProviderType_Bool_Exp>;
};


export type Query_RootProviderType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProviderVisibilityArgs = {
  distinct_on?: InputMaybe<Array<ProviderVisibility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderVisibility_Order_By>>;
  where?: InputMaybe<ProviderVisibility_Bool_Exp>;
};


export type Query_RootProviderVisibility_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderVisibility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderVisibility_Order_By>>;
  where?: InputMaybe<ProviderVisibility_Bool_Exp>;
};


export type Query_RootProviderVisibility_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProvidersArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};


export type Query_RootProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};


export type Query_RootProviders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRefundsArgs = {
  distinct_on?: InputMaybe<Array<Refunds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refunds_Order_By>>;
  where?: InputMaybe<Refunds_Bool_Exp>;
};


export type Query_RootRefunds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refunds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refunds_Order_By>>;
  where?: InputMaybe<Refunds_Bool_Exp>;
};


export type Query_RootRefunds_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRelationshipStatusArgs = {
  distinct_on?: InputMaybe<Array<RelationshipStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelationshipStatus_Order_By>>;
  where?: InputMaybe<RelationshipStatus_Bool_Exp>;
};


export type Query_RootRelationshipStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RelationshipStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelationshipStatus_Order_By>>;
  where?: InputMaybe<RelationshipStatus_Bool_Exp>;
};


export type Query_RootRelationshipStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootScheduleArgs = {
  distinct_on?: InputMaybe<Array<Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Schedule_Order_By>>;
  where?: InputMaybe<Schedule_Bool_Exp>;
};


export type Query_RootSchedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Schedule_Order_By>>;
  where?: InputMaybe<Schedule_Bool_Exp>;
};


export type Query_RootSchedule_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootServiceEmployeesArgs = {
  distinct_on?: InputMaybe<Array<ServiceEmployees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceEmployees_Order_By>>;
  where?: InputMaybe<ServiceEmployees_Bool_Exp>;
};


export type Query_RootServiceEmployees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceEmployees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceEmployees_Order_By>>;
  where?: InputMaybe<ServiceEmployees_Bool_Exp>;
};


export type Query_RootServiceEmployees_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootServiceFormStatusArgs = {
  distinct_on?: InputMaybe<Array<ServiceFormStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceFormStatus_Order_By>>;
  where?: InputMaybe<ServiceFormStatus_Bool_Exp>;
};


export type Query_RootServiceFormStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceFormStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceFormStatus_Order_By>>;
  where?: InputMaybe<ServiceFormStatus_Bool_Exp>;
};


export type Query_RootServiceFormStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootServiceOptionAnswersArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionAnswers_Order_By>>;
  where?: InputMaybe<ServiceOptionAnswers_Bool_Exp>;
};


export type Query_RootServiceOptionAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionAnswers_Order_By>>;
  where?: InputMaybe<ServiceOptionAnswers_Bool_Exp>;
};


export type Query_RootServiceOptionAnswers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootServiceOptionSectionArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionSection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionSection_Order_By>>;
  where?: InputMaybe<ServiceOptionSection_Bool_Exp>;
};


export type Query_RootServiceOptionSectionOptionsArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionSectionOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionSectionOptions_Order_By>>;
  where?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
};


export type Query_RootServiceOptionSectionOptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionSectionOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionSectionOptions_Order_By>>;
  where?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
};


export type Query_RootServiceOptionSectionOptions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootServiceOptionSection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionSection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionSection_Order_By>>;
  where?: InputMaybe<ServiceOptionSection_Bool_Exp>;
};


export type Query_RootServiceOptionSection_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootServiceOptionsArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptions_Order_By>>;
  where?: InputMaybe<ServiceOptions_Bool_Exp>;
};


export type Query_RootServiceOptionsStatusArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionsStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionsStatus_Order_By>>;
  where?: InputMaybe<ServiceOptionsStatus_Bool_Exp>;
};


export type Query_RootServiceOptionsStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionsStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionsStatus_Order_By>>;
  where?: InputMaybe<ServiceOptionsStatus_Bool_Exp>;
};


export type Query_RootServiceOptionsStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootServiceOptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptions_Order_By>>;
  where?: InputMaybe<ServiceOptions_Bool_Exp>;
};


export type Query_RootServiceOptions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootServicePicturesArgs = {
  distinct_on?: InputMaybe<Array<ServicePictures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicePictures_Order_By>>;
  where?: InputMaybe<ServicePictures_Bool_Exp>;
};


export type Query_RootServicePictures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServicePictures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicePictures_Order_By>>;
  where?: InputMaybe<ServicePictures_Bool_Exp>;
};


export type Query_RootServicePictures_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootServicePricingsArgs = {
  distinct_on?: InputMaybe<Array<ServicePricings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicePricings_Order_By>>;
  where?: InputMaybe<ServicePricings_Bool_Exp>;
};


export type Query_RootServicePricings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServicePricings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicePricings_Order_By>>;
  where?: InputMaybe<ServicePricings_Bool_Exp>;
};


export type Query_RootServicePricings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootServiceSectionOptionQuantityTypeArgs = {
  distinct_on?: InputMaybe<Array<ServiceSectionOptionQuantityType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceSectionOptionQuantityType_Order_By>>;
  where?: InputMaybe<ServiceSectionOptionQuantityType_Bool_Exp>;
};


export type Query_RootServiceSectionOptionQuantityType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceSectionOptionQuantityType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceSectionOptionQuantityType_Order_By>>;
  where?: InputMaybe<ServiceSectionOptionQuantityType_Bool_Exp>;
};


export type Query_RootServiceSectionOptionQuantityType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootServiceSectionOptionTypeArgs = {
  distinct_on?: InputMaybe<Array<ServiceSectionOptionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceSectionOptionType_Order_By>>;
  where?: InputMaybe<ServiceSectionOptionType_Bool_Exp>;
};


export type Query_RootServiceSectionOptionType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceSectionOptionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceSectionOptionType_Order_By>>;
  where?: InputMaybe<ServiceSectionOptionType_Bool_Exp>;
};


export type Query_RootServiceSectionOptionType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootServiceStatusArgs = {
  distinct_on?: InputMaybe<Array<ServiceStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceStatus_Order_By>>;
  where?: InputMaybe<ServiceStatus_Bool_Exp>;
};


export type Query_RootServiceStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceStatus_Order_By>>;
  where?: InputMaybe<ServiceStatus_Bool_Exp>;
};


export type Query_RootServiceStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootServicesArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Query_RootServicesFormsArgs = {
  distinct_on?: InputMaybe<Array<ServicesForms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicesForms_Order_By>>;
  where?: InputMaybe<ServicesForms_Bool_Exp>;
};


export type Query_RootServicesForms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServicesForms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicesForms_Order_By>>;
  where?: InputMaybe<ServicesForms_Bool_Exp>;
};


export type Query_RootServicesForms_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootServices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Query_RootServices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSessionsArgs = {
  distinct_on?: InputMaybe<Array<Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sessions_Order_By>>;
  where?: InputMaybe<Sessions_Bool_Exp>;
};


export type Query_RootSessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sessions_Order_By>>;
  where?: InputMaybe<Sessions_Bool_Exp>;
};


export type Query_RootSessions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTimeoutsArgs = {
  distinct_on?: InputMaybe<Array<Timeouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Timeouts_Order_By>>;
  where?: InputMaybe<Timeouts_Bool_Exp>;
};


export type Query_RootTimeouts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Timeouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Timeouts_Order_By>>;
  where?: InputMaybe<Timeouts_Bool_Exp>;
};


export type Query_RootTimeouts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTransitionStatusArgs = {
  distinct_on?: InputMaybe<Array<TransitionStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransitionStatus_Order_By>>;
  where?: InputMaybe<TransitionStatus_Bool_Exp>;
};


export type Query_RootTransitionStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TransitionStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransitionStatus_Order_By>>;
  where?: InputMaybe<TransitionStatus_Bool_Exp>;
};


export type Query_RootTransitionStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUnavailableServiceLocationsArgs = {
  distinct_on?: InputMaybe<Array<UnavailableServiceLocations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnavailableServiceLocations_Order_By>>;
  where?: InputMaybe<UnavailableServiceLocations_Bool_Exp>;
};


export type Query_RootUnavailableServiceLocations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UnavailableServiceLocations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnavailableServiceLocations_Order_By>>;
  where?: InputMaybe<UnavailableServiceLocations_Bool_Exp>;
};


export type Query_RootUnavailableServiceLocations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUserRoleArgs = {
  distinct_on?: InputMaybe<Array<UserRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_Order_By>>;
  where?: InputMaybe<UserRole_Bool_Exp>;
};


export type Query_RootUserRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_Order_By>>;
  where?: InputMaybe<UserRole_Bool_Exp>;
};


export type Query_RootUserRole_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUserRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoles_Order_By>>;
  where?: InputMaybe<UserRoles_Bool_Exp>;
};


export type Query_RootUserRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoles_Order_By>>;
  where?: InputMaybe<UserRoles_Bool_Exp>;
};


export type Query_RootUserRoles_By_PkArgs = {
  userId: Scalars['uuid']['input'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootValidateServiceByIdArgs = {
  id: Scalars['String']['input'];
};

/** columns and relationships of "refunds" */
export type Refunds = {
  __typename?: 'refunds';
  /** In whole units (USD, CAD) */
  amount: Scalars['numeric']['output'];
  /** An object relationship */
  appointment: Appointments;
  appointmentId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  currency: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  payment: Payments;
  paymentId: Scalars['uuid']['output'];
  sources: Scalars['jsonb']['output'];
  status: PaymentStatus_Enum;
  stripeRefundId: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "refunds" */
export type RefundsSourcesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "refunds" */
export type Refunds_Aggregate = {
  __typename?: 'refunds_aggregate';
  aggregate?: Maybe<Refunds_Aggregate_Fields>;
  nodes: Array<Refunds>;
};

export type Refunds_Aggregate_Bool_Exp = {
  count?: InputMaybe<Refunds_Aggregate_Bool_Exp_Count>;
};

export type Refunds_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Refunds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Refunds_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "refunds" */
export type Refunds_Aggregate_Fields = {
  __typename?: 'refunds_aggregate_fields';
  avg?: Maybe<Refunds_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Refunds_Max_Fields>;
  min?: Maybe<Refunds_Min_Fields>;
  stddev?: Maybe<Refunds_Stddev_Fields>;
  stddev_pop?: Maybe<Refunds_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Refunds_Stddev_Samp_Fields>;
  sum?: Maybe<Refunds_Sum_Fields>;
  var_pop?: Maybe<Refunds_Var_Pop_Fields>;
  var_samp?: Maybe<Refunds_Var_Samp_Fields>;
  variance?: Maybe<Refunds_Variance_Fields>;
};


/** aggregate fields of "refunds" */
export type Refunds_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Refunds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "refunds" */
export type Refunds_Aggregate_Order_By = {
  avg?: InputMaybe<Refunds_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Refunds_Max_Order_By>;
  min?: InputMaybe<Refunds_Min_Order_By>;
  stddev?: InputMaybe<Refunds_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Refunds_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Refunds_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Refunds_Sum_Order_By>;
  var_pop?: InputMaybe<Refunds_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Refunds_Var_Samp_Order_By>;
  variance?: InputMaybe<Refunds_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Refunds_Append_Input = {
  sources?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "refunds" */
export type Refunds_Arr_Rel_Insert_Input = {
  data: Array<Refunds_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Refunds_On_Conflict>;
};

/** aggregate avg on columns */
export type Refunds_Avg_Fields = {
  __typename?: 'refunds_avg_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "refunds" */
export type Refunds_Avg_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "refunds". All fields are combined with a logical 'AND'. */
export type Refunds_Bool_Exp = {
  _and?: InputMaybe<Array<Refunds_Bool_Exp>>;
  _not?: InputMaybe<Refunds_Bool_Exp>;
  _or?: InputMaybe<Array<Refunds_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  appointment?: InputMaybe<Appointments_Bool_Exp>;
  appointmentId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  payment?: InputMaybe<Payments_Bool_Exp>;
  paymentId?: InputMaybe<Uuid_Comparison_Exp>;
  sources?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<PaymentStatus_Enum_Comparison_Exp>;
  stripeRefundId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "refunds" */
export enum Refunds_Constraint {
  /** unique or primary key constraint on columns "id" */
  RefundsPkey = 'refunds_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Refunds_Delete_At_Path_Input = {
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Refunds_Delete_Elem_Input = {
  sources?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Refunds_Delete_Key_Input = {
  sources?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "refunds" */
export type Refunds_Inc_Input = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "refunds" */
export type Refunds_Insert_Input = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Scalars['numeric']['input']>;
  appointment?: InputMaybe<Appointments_Obj_Rel_Insert_Input>;
  appointmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  payment?: InputMaybe<Payments_Obj_Rel_Insert_Input>;
  paymentId?: InputMaybe<Scalars['uuid']['input']>;
  sources?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<PaymentStatus_Enum>;
  stripeRefundId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Refunds_Max_Fields = {
  __typename?: 'refunds_max_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['numeric']['output']>;
  appointmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  paymentId?: Maybe<Scalars['uuid']['output']>;
  stripeRefundId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "refunds" */
export type Refunds_Max_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
  appointmentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  paymentId?: InputMaybe<Order_By>;
  stripeRefundId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Refunds_Min_Fields = {
  __typename?: 'refunds_min_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['numeric']['output']>;
  appointmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  paymentId?: Maybe<Scalars['uuid']['output']>;
  stripeRefundId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "refunds" */
export type Refunds_Min_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
  appointmentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  paymentId?: InputMaybe<Order_By>;
  stripeRefundId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "refunds" */
export type Refunds_Mutation_Response = {
  __typename?: 'refunds_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Refunds>;
};

/** on_conflict condition type for table "refunds" */
export type Refunds_On_Conflict = {
  constraint: Refunds_Constraint;
  update_columns?: Array<Refunds_Update_Column>;
  where?: InputMaybe<Refunds_Bool_Exp>;
};

/** Ordering options when selecting data from "refunds". */
export type Refunds_Order_By = {
  amount?: InputMaybe<Order_By>;
  appointment?: InputMaybe<Appointments_Order_By>;
  appointmentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment?: InputMaybe<Payments_Order_By>;
  paymentId?: InputMaybe<Order_By>;
  sources?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripeRefundId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: refunds */
export type Refunds_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Refunds_Prepend_Input = {
  sources?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "refunds" */
export enum Refunds_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AppointmentId = 'appointmentId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentId = 'paymentId',
  /** column name */
  Sources = 'sources',
  /** column name */
  Status = 'status',
  /** column name */
  StripeRefundId = 'stripeRefundId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "refunds" */
export type Refunds_Set_Input = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Scalars['numeric']['input']>;
  appointmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  paymentId?: InputMaybe<Scalars['uuid']['input']>;
  sources?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<PaymentStatus_Enum>;
  stripeRefundId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Refunds_Stddev_Fields = {
  __typename?: 'refunds_stddev_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "refunds" */
export type Refunds_Stddev_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Refunds_Stddev_Pop_Fields = {
  __typename?: 'refunds_stddev_pop_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "refunds" */
export type Refunds_Stddev_Pop_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Refunds_Stddev_Samp_Fields = {
  __typename?: 'refunds_stddev_samp_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "refunds" */
export type Refunds_Stddev_Samp_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "refunds" */
export type Refunds_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Refunds_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Refunds_Stream_Cursor_Value_Input = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Scalars['numeric']['input']>;
  appointmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  paymentId?: InputMaybe<Scalars['uuid']['input']>;
  sources?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<PaymentStatus_Enum>;
  stripeRefundId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Refunds_Sum_Fields = {
  __typename?: 'refunds_sum_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "refunds" */
export type Refunds_Sum_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "refunds" */
export enum Refunds_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AppointmentId = 'appointmentId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentId = 'paymentId',
  /** column name */
  Sources = 'sources',
  /** column name */
  Status = 'status',
  /** column name */
  StripeRefundId = 'stripeRefundId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Refunds_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Refunds_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Refunds_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Refunds_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Refunds_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Refunds_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Refunds_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Refunds_Set_Input>;
  /** filter the rows which have to be updated */
  where: Refunds_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Refunds_Var_Pop_Fields = {
  __typename?: 'refunds_var_pop_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "refunds" */
export type Refunds_Var_Pop_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Refunds_Var_Samp_Fields = {
  __typename?: 'refunds_var_samp_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "refunds" */
export type Refunds_Var_Samp_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Refunds_Variance_Fields = {
  __typename?: 'refunds_variance_fields';
  /** In whole units (USD, CAD) */
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "refunds" */
export type Refunds_Variance_Order_By = {
  /** In whole units (USD, CAD) */
  amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "relationshipStatus" */
export type RelationshipStatus = {
  __typename?: 'relationshipStatus';
  value: Scalars['String']['output'];
};

/** aggregated selection of "relationshipStatus" */
export type RelationshipStatus_Aggregate = {
  __typename?: 'relationshipStatus_aggregate';
  aggregate?: Maybe<RelationshipStatus_Aggregate_Fields>;
  nodes: Array<RelationshipStatus>;
};

/** aggregate fields of "relationshipStatus" */
export type RelationshipStatus_Aggregate_Fields = {
  __typename?: 'relationshipStatus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<RelationshipStatus_Max_Fields>;
  min?: Maybe<RelationshipStatus_Min_Fields>;
};


/** aggregate fields of "relationshipStatus" */
export type RelationshipStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RelationshipStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "relationshipStatus". All fields are combined with a logical 'AND'. */
export type RelationshipStatus_Bool_Exp = {
  _and?: InputMaybe<Array<RelationshipStatus_Bool_Exp>>;
  _not?: InputMaybe<RelationshipStatus_Bool_Exp>;
  _or?: InputMaybe<Array<RelationshipStatus_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "relationshipStatus" */
export enum RelationshipStatus_Constraint {
  /** unique or primary key constraint on columns "value" */
  RelationshipStatusPkey = 'relationshipStatus_pkey'
}

export enum RelationshipStatus_Enum {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected',
  Restricted = 'restricted'
}

/** Boolean expression to compare columns of type "relationshipStatus_enum". All fields are combined with logical 'AND'. */
export type RelationshipStatus_Enum_Comparison_Exp = {
  _eq?: InputMaybe<RelationshipStatus_Enum>;
  _in?: InputMaybe<Array<RelationshipStatus_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RelationshipStatus_Enum>;
  _nin?: InputMaybe<Array<RelationshipStatus_Enum>>;
};

/** input type for inserting data into table "relationshipStatus" */
export type RelationshipStatus_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type RelationshipStatus_Max_Fields = {
  __typename?: 'relationshipStatus_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type RelationshipStatus_Min_Fields = {
  __typename?: 'relationshipStatus_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "relationshipStatus" */
export type RelationshipStatus_Mutation_Response = {
  __typename?: 'relationshipStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RelationshipStatus>;
};

/** on_conflict condition type for table "relationshipStatus" */
export type RelationshipStatus_On_Conflict = {
  constraint: RelationshipStatus_Constraint;
  update_columns?: Array<RelationshipStatus_Update_Column>;
  where?: InputMaybe<RelationshipStatus_Bool_Exp>;
};

/** Ordering options when selecting data from "relationshipStatus". */
export type RelationshipStatus_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: relationshipStatus */
export type RelationshipStatus_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "relationshipStatus" */
export enum RelationshipStatus_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "relationshipStatus" */
export type RelationshipStatus_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "relationshipStatus" */
export type RelationshipStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RelationshipStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RelationshipStatus_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "relationshipStatus" */
export enum RelationshipStatus_Update_Column {
  /** column name */
  Value = 'value'
}

export type RelationshipStatus_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RelationshipStatus_Set_Input>;
  /** filter the rows which have to be updated */
  where: RelationshipStatus_Bool_Exp;
};

/** columns and relationships of "schedule" */
export type Schedule = {
  __typename?: 'schedule';
  createdAt: Scalars['timestamp']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  employeeId: Scalars['uuid']['output'];
  endTime: Scalars['timetz']['output'];
  endingAt?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  location: Locations;
  locationId: Scalars['uuid']['output'];
  repeatableDayOfWeek?: Maybe<Array<Scalars['String']['output']>>;
  startTime: Scalars['timetz']['output'];
  startingAt: Scalars['date']['output'];
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};

/** aggregated selection of "schedule" */
export type Schedule_Aggregate = {
  __typename?: 'schedule_aggregate';
  aggregate?: Maybe<Schedule_Aggregate_Fields>;
  nodes: Array<Schedule>;
};

export type Schedule_Aggregate_Bool_Exp = {
  count?: InputMaybe<Schedule_Aggregate_Bool_Exp_Count>;
};

export type Schedule_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Schedule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Schedule_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "schedule" */
export type Schedule_Aggregate_Fields = {
  __typename?: 'schedule_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Schedule_Max_Fields>;
  min?: Maybe<Schedule_Min_Fields>;
};


/** aggregate fields of "schedule" */
export type Schedule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Schedule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "schedule" */
export type Schedule_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Schedule_Max_Order_By>;
  min?: InputMaybe<Schedule_Min_Order_By>;
};

/** input type for inserting array relation for remote table "schedule" */
export type Schedule_Arr_Rel_Insert_Input = {
  data: Array<Schedule_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Schedule_On_Conflict>;
};

/** Boolean expression to filter rows from the table "schedule". All fields are combined with a logical 'AND'. */
export type Schedule_Bool_Exp = {
  _and?: InputMaybe<Array<Schedule_Bool_Exp>>;
  _not?: InputMaybe<Schedule_Bool_Exp>;
  _or?: InputMaybe<Array<Schedule_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  employeeId?: InputMaybe<Uuid_Comparison_Exp>;
  endTime?: InputMaybe<Timetz_Comparison_Exp>;
  endingAt?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Locations_Bool_Exp>;
  locationId?: InputMaybe<Uuid_Comparison_Exp>;
  repeatableDayOfWeek?: InputMaybe<String_Array_Comparison_Exp>;
  startTime?: InputMaybe<Timetz_Comparison_Exp>;
  startingAt?: InputMaybe<Date_Comparison_Exp>;
  timezone?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "schedule" */
export enum Schedule_Constraint {
  /** unique or primary key constraint on columns "id" */
  SchedulePkey = 'schedule_pkey'
}

/** input type for inserting data into table "schedule" */
export type Schedule_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  employeeId?: InputMaybe<Scalars['uuid']['input']>;
  endTime?: InputMaybe<Scalars['timetz']['input']>;
  endingAt?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Locations_Obj_Rel_Insert_Input>;
  locationId?: InputMaybe<Scalars['uuid']['input']>;
  repeatableDayOfWeek?: InputMaybe<Array<Scalars['String']['input']>>;
  startTime?: InputMaybe<Scalars['timetz']['input']>;
  startingAt?: InputMaybe<Scalars['date']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Schedule_Max_Fields = {
  __typename?: 'schedule_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  employeeId?: Maybe<Scalars['uuid']['output']>;
  endTime?: Maybe<Scalars['timetz']['output']>;
  endingAt?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  locationId?: Maybe<Scalars['uuid']['output']>;
  repeatableDayOfWeek?: Maybe<Array<Scalars['String']['output']>>;
  startTime?: Maybe<Scalars['timetz']['output']>;
  startingAt?: Maybe<Scalars['date']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "schedule" */
export type Schedule_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  employeeId?: InputMaybe<Order_By>;
  endTime?: InputMaybe<Order_By>;
  endingAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locationId?: InputMaybe<Order_By>;
  repeatableDayOfWeek?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
  startingAt?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Schedule_Min_Fields = {
  __typename?: 'schedule_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  employeeId?: Maybe<Scalars['uuid']['output']>;
  endTime?: Maybe<Scalars['timetz']['output']>;
  endingAt?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  locationId?: Maybe<Scalars['uuid']['output']>;
  repeatableDayOfWeek?: Maybe<Array<Scalars['String']['output']>>;
  startTime?: Maybe<Scalars['timetz']['output']>;
  startingAt?: Maybe<Scalars['date']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "schedule" */
export type Schedule_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  employeeId?: InputMaybe<Order_By>;
  endTime?: InputMaybe<Order_By>;
  endingAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locationId?: InputMaybe<Order_By>;
  repeatableDayOfWeek?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
  startingAt?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "schedule" */
export type Schedule_Mutation_Response = {
  __typename?: 'schedule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Schedule>;
};

/** input type for inserting object relation for remote table "schedule" */
export type Schedule_Obj_Rel_Insert_Input = {
  data: Schedule_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Schedule_On_Conflict>;
};

/** on_conflict condition type for table "schedule" */
export type Schedule_On_Conflict = {
  constraint: Schedule_Constraint;
  update_columns?: Array<Schedule_Update_Column>;
  where?: InputMaybe<Schedule_Bool_Exp>;
};

/** Ordering options when selecting data from "schedule". */
export type Schedule_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  employeeId?: InputMaybe<Order_By>;
  endTime?: InputMaybe<Order_By>;
  endingAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Locations_Order_By>;
  locationId?: InputMaybe<Order_By>;
  repeatableDayOfWeek?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
  startingAt?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: schedule */
export type Schedule_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "schedule" */
export enum Schedule_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EmployeeId = 'employeeId',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  EndingAt = 'endingAt',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'locationId',
  /** column name */
  RepeatableDayOfWeek = 'repeatableDayOfWeek',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  StartingAt = 'startingAt',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "schedule" */
export type Schedule_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  employeeId?: InputMaybe<Scalars['uuid']['input']>;
  endTime?: InputMaybe<Scalars['timetz']['input']>;
  endingAt?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  locationId?: InputMaybe<Scalars['uuid']['input']>;
  repeatableDayOfWeek?: InputMaybe<Array<Scalars['String']['input']>>;
  startTime?: InputMaybe<Scalars['timetz']['input']>;
  startingAt?: InputMaybe<Scalars['date']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "schedule" */
export type Schedule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Schedule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Schedule_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  employeeId?: InputMaybe<Scalars['uuid']['input']>;
  endTime?: InputMaybe<Scalars['timetz']['input']>;
  endingAt?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  locationId?: InputMaybe<Scalars['uuid']['input']>;
  repeatableDayOfWeek?: InputMaybe<Array<Scalars['String']['input']>>;
  startTime?: InputMaybe<Scalars['timetz']['input']>;
  startingAt?: InputMaybe<Scalars['date']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "schedule" */
export enum Schedule_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EmployeeId = 'employeeId',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  EndingAt = 'endingAt',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'locationId',
  /** column name */
  RepeatableDayOfWeek = 'repeatableDayOfWeek',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  StartingAt = 'startingAt',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Schedule_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Schedule_Set_Input>;
  /** filter the rows which have to be updated */
  where: Schedule_Bool_Exp;
};

/** columns and relationships of "serviceEmployees" */
export type ServiceEmployees = {
  __typename?: 'serviceEmployees';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  service: Services;
  serviceId: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "serviceEmployees" */
export type ServiceEmployees_Aggregate = {
  __typename?: 'serviceEmployees_aggregate';
  aggregate?: Maybe<ServiceEmployees_Aggregate_Fields>;
  nodes: Array<ServiceEmployees>;
};

export type ServiceEmployees_Aggregate_Bool_Exp = {
  count?: InputMaybe<ServiceEmployees_Aggregate_Bool_Exp_Count>;
};

export type ServiceEmployees_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ServiceEmployees_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceEmployees_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "serviceEmployees" */
export type ServiceEmployees_Aggregate_Fields = {
  __typename?: 'serviceEmployees_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ServiceEmployees_Max_Fields>;
  min?: Maybe<ServiceEmployees_Min_Fields>;
};


/** aggregate fields of "serviceEmployees" */
export type ServiceEmployees_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceEmployees_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "serviceEmployees" */
export type ServiceEmployees_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ServiceEmployees_Max_Order_By>;
  min?: InputMaybe<ServiceEmployees_Min_Order_By>;
};

/** input type for inserting array relation for remote table "serviceEmployees" */
export type ServiceEmployees_Arr_Rel_Insert_Input = {
  data: Array<ServiceEmployees_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceEmployees_On_Conflict>;
};

/** Boolean expression to filter rows from the table "serviceEmployees". All fields are combined with a logical 'AND'. */
export type ServiceEmployees_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceEmployees_Bool_Exp>>;
  _not?: InputMaybe<ServiceEmployees_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceEmployees_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  service?: InputMaybe<Services_Bool_Exp>;
  serviceId?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "serviceEmployees" */
export enum ServiceEmployees_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServiceEmployeesPkey = 'serviceEmployees_pkey',
  /** unique or primary key constraint on columns "serviceId", "userId" */
  ServiceEmployeesUserIdServiceIdKey = 'serviceEmployees_userId_serviceId_key'
}

/** input type for inserting data into table "serviceEmployees" */
export type ServiceEmployees_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  service?: InputMaybe<Services_Obj_Rel_Insert_Input>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ServiceEmployees_Max_Fields = {
  __typename?: 'serviceEmployees_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  serviceId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "serviceEmployees" */
export type ServiceEmployees_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ServiceEmployees_Min_Fields = {
  __typename?: 'serviceEmployees_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  serviceId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "serviceEmployees" */
export type ServiceEmployees_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "serviceEmployees" */
export type ServiceEmployees_Mutation_Response = {
  __typename?: 'serviceEmployees_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ServiceEmployees>;
};

/** input type for inserting object relation for remote table "serviceEmployees" */
export type ServiceEmployees_Obj_Rel_Insert_Input = {
  data: ServiceEmployees_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceEmployees_On_Conflict>;
};

/** on_conflict condition type for table "serviceEmployees" */
export type ServiceEmployees_On_Conflict = {
  constraint: ServiceEmployees_Constraint;
  update_columns?: Array<ServiceEmployees_Update_Column>;
  where?: InputMaybe<ServiceEmployees_Bool_Exp>;
};

/** Ordering options when selecting data from "serviceEmployees". */
export type ServiceEmployees_Order_By = {
  id?: InputMaybe<Order_By>;
  service?: InputMaybe<Services_Order_By>;
  serviceId?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: serviceEmployees */
export type ServiceEmployees_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "serviceEmployees" */
export enum ServiceEmployees_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "serviceEmployees" */
export type ServiceEmployees_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "serviceEmployees" */
export type ServiceEmployees_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceEmployees_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceEmployees_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "serviceEmployees" */
export enum ServiceEmployees_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  UserId = 'userId'
}

export type ServiceEmployees_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ServiceEmployees_Set_Input>;
  /** filter the rows which have to be updated */
  where: ServiceEmployees_Bool_Exp;
};

/** columns and relationships of "serviceFormStatus" */
export type ServiceFormStatus = {
  __typename?: 'serviceFormStatus';
  /** An array relationship */
  servicesForms: Array<ServicesForms>;
  /** An aggregate relationship */
  servicesForms_aggregate: ServicesForms_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "serviceFormStatus" */
export type ServiceFormStatusServicesFormsArgs = {
  distinct_on?: InputMaybe<Array<ServicesForms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicesForms_Order_By>>;
  where?: InputMaybe<ServicesForms_Bool_Exp>;
};


/** columns and relationships of "serviceFormStatus" */
export type ServiceFormStatusServicesForms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServicesForms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicesForms_Order_By>>;
  where?: InputMaybe<ServicesForms_Bool_Exp>;
};

/** aggregated selection of "serviceFormStatus" */
export type ServiceFormStatus_Aggregate = {
  __typename?: 'serviceFormStatus_aggregate';
  aggregate?: Maybe<ServiceFormStatus_Aggregate_Fields>;
  nodes: Array<ServiceFormStatus>;
};

/** aggregate fields of "serviceFormStatus" */
export type ServiceFormStatus_Aggregate_Fields = {
  __typename?: 'serviceFormStatus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ServiceFormStatus_Max_Fields>;
  min?: Maybe<ServiceFormStatus_Min_Fields>;
};


/** aggregate fields of "serviceFormStatus" */
export type ServiceFormStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceFormStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "serviceFormStatus". All fields are combined with a logical 'AND'. */
export type ServiceFormStatus_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceFormStatus_Bool_Exp>>;
  _not?: InputMaybe<ServiceFormStatus_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceFormStatus_Bool_Exp>>;
  servicesForms?: InputMaybe<ServicesForms_Bool_Exp>;
  servicesForms_aggregate?: InputMaybe<ServicesForms_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "serviceFormStatus" */
export enum ServiceFormStatus_Constraint {
  /** unique or primary key constraint on columns "value" */
  ServiceFormStatusPkey = 'serviceFormStatus_pkey'
}

export enum ServiceFormStatus_Enum {
  Active = 'active',
  Inactive = 'inactive'
}

/** Boolean expression to compare columns of type "serviceFormStatus_enum". All fields are combined with logical 'AND'. */
export type ServiceFormStatus_Enum_Comparison_Exp = {
  _eq?: InputMaybe<ServiceFormStatus_Enum>;
  _in?: InputMaybe<Array<ServiceFormStatus_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<ServiceFormStatus_Enum>;
  _nin?: InputMaybe<Array<ServiceFormStatus_Enum>>;
};

/** input type for inserting data into table "serviceFormStatus" */
export type ServiceFormStatus_Insert_Input = {
  servicesForms?: InputMaybe<ServicesForms_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ServiceFormStatus_Max_Fields = {
  __typename?: 'serviceFormStatus_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ServiceFormStatus_Min_Fields = {
  __typename?: 'serviceFormStatus_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "serviceFormStatus" */
export type ServiceFormStatus_Mutation_Response = {
  __typename?: 'serviceFormStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ServiceFormStatus>;
};

/** input type for inserting object relation for remote table "serviceFormStatus" */
export type ServiceFormStatus_Obj_Rel_Insert_Input = {
  data: ServiceFormStatus_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceFormStatus_On_Conflict>;
};

/** on_conflict condition type for table "serviceFormStatus" */
export type ServiceFormStatus_On_Conflict = {
  constraint: ServiceFormStatus_Constraint;
  update_columns?: Array<ServiceFormStatus_Update_Column>;
  where?: InputMaybe<ServiceFormStatus_Bool_Exp>;
};

/** Ordering options when selecting data from "serviceFormStatus". */
export type ServiceFormStatus_Order_By = {
  servicesForms_aggregate?: InputMaybe<ServicesForms_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: serviceFormStatus */
export type ServiceFormStatus_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "serviceFormStatus" */
export enum ServiceFormStatus_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "serviceFormStatus" */
export type ServiceFormStatus_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "serviceFormStatus" */
export type ServiceFormStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceFormStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceFormStatus_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "serviceFormStatus" */
export enum ServiceFormStatus_Update_Column {
  /** column name */
  Value = 'value'
}

export type ServiceFormStatus_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ServiceFormStatus_Set_Input>;
  /** filter the rows which have to be updated */
  where: ServiceFormStatus_Bool_Exp;
};

/** columns and relationships of "serviceOptionAnswers" */
export type ServiceOptionAnswers = {
  __typename?: 'serviceOptionAnswers';
  /** An object relationship */
  appointment: Appointments;
  appointmentId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  quantity?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  serviceOptionSectionOption: ServiceOptionSectionOptions;
  serviceOptionSectionOptionsId: Scalars['uuid']['output'];
};

/** aggregated selection of "serviceOptionAnswers" */
export type ServiceOptionAnswers_Aggregate = {
  __typename?: 'serviceOptionAnswers_aggregate';
  aggregate?: Maybe<ServiceOptionAnswers_Aggregate_Fields>;
  nodes: Array<ServiceOptionAnswers>;
};

export type ServiceOptionAnswers_Aggregate_Bool_Exp = {
  count?: InputMaybe<ServiceOptionAnswers_Aggregate_Bool_Exp_Count>;
};

export type ServiceOptionAnswers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ServiceOptionAnswers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceOptionAnswers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "serviceOptionAnswers" */
export type ServiceOptionAnswers_Aggregate_Fields = {
  __typename?: 'serviceOptionAnswers_aggregate_fields';
  avg?: Maybe<ServiceOptionAnswers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ServiceOptionAnswers_Max_Fields>;
  min?: Maybe<ServiceOptionAnswers_Min_Fields>;
  stddev?: Maybe<ServiceOptionAnswers_Stddev_Fields>;
  stddev_pop?: Maybe<ServiceOptionAnswers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ServiceOptionAnswers_Stddev_Samp_Fields>;
  sum?: Maybe<ServiceOptionAnswers_Sum_Fields>;
  var_pop?: Maybe<ServiceOptionAnswers_Var_Pop_Fields>;
  var_samp?: Maybe<ServiceOptionAnswers_Var_Samp_Fields>;
  variance?: Maybe<ServiceOptionAnswers_Variance_Fields>;
};


/** aggregate fields of "serviceOptionAnswers" */
export type ServiceOptionAnswers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceOptionAnswers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "serviceOptionAnswers" */
export type ServiceOptionAnswers_Aggregate_Order_By = {
  avg?: InputMaybe<ServiceOptionAnswers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ServiceOptionAnswers_Max_Order_By>;
  min?: InputMaybe<ServiceOptionAnswers_Min_Order_By>;
  stddev?: InputMaybe<ServiceOptionAnswers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ServiceOptionAnswers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ServiceOptionAnswers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ServiceOptionAnswers_Sum_Order_By>;
  var_pop?: InputMaybe<ServiceOptionAnswers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ServiceOptionAnswers_Var_Samp_Order_By>;
  variance?: InputMaybe<ServiceOptionAnswers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "serviceOptionAnswers" */
export type ServiceOptionAnswers_Arr_Rel_Insert_Input = {
  data: Array<ServiceOptionAnswers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceOptionAnswers_On_Conflict>;
};

/** aggregate avg on columns */
export type ServiceOptionAnswers_Avg_Fields = {
  __typename?: 'serviceOptionAnswers_avg_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "serviceOptionAnswers" */
export type ServiceOptionAnswers_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "serviceOptionAnswers". All fields are combined with a logical 'AND'. */
export type ServiceOptionAnswers_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceOptionAnswers_Bool_Exp>>;
  _not?: InputMaybe<ServiceOptionAnswers_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceOptionAnswers_Bool_Exp>>;
  appointment?: InputMaybe<Appointments_Bool_Exp>;
  appointmentId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  serviceOptionSectionOption?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
  serviceOptionSectionOptionsId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "serviceOptionAnswers" */
export enum ServiceOptionAnswers_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServiceOptionAnswersPkey = 'serviceOptionAnswers_pkey'
}

/** input type for incrementing numeric columns in table "serviceOptionAnswers" */
export type ServiceOptionAnswers_Inc_Input = {
  quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "serviceOptionAnswers" */
export type ServiceOptionAnswers_Insert_Input = {
  appointment?: InputMaybe<Appointments_Obj_Rel_Insert_Input>;
  appointmentId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  serviceOptionSectionOption?: InputMaybe<ServiceOptionSectionOptions_Obj_Rel_Insert_Input>;
  serviceOptionSectionOptionsId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ServiceOptionAnswers_Max_Fields = {
  __typename?: 'serviceOptionAnswers_max_fields';
  appointmentId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  serviceOptionSectionOptionsId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "serviceOptionAnswers" */
export type ServiceOptionAnswers_Max_Order_By = {
  appointmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  serviceOptionSectionOptionsId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ServiceOptionAnswers_Min_Fields = {
  __typename?: 'serviceOptionAnswers_min_fields';
  appointmentId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  serviceOptionSectionOptionsId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "serviceOptionAnswers" */
export type ServiceOptionAnswers_Min_Order_By = {
  appointmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  serviceOptionSectionOptionsId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "serviceOptionAnswers" */
export type ServiceOptionAnswers_Mutation_Response = {
  __typename?: 'serviceOptionAnswers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ServiceOptionAnswers>;
};

/** on_conflict condition type for table "serviceOptionAnswers" */
export type ServiceOptionAnswers_On_Conflict = {
  constraint: ServiceOptionAnswers_Constraint;
  update_columns?: Array<ServiceOptionAnswers_Update_Column>;
  where?: InputMaybe<ServiceOptionAnswers_Bool_Exp>;
};

/** Ordering options when selecting data from "serviceOptionAnswers". */
export type ServiceOptionAnswers_Order_By = {
  appointment?: InputMaybe<Appointments_Order_By>;
  appointmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  serviceOptionSectionOption?: InputMaybe<ServiceOptionSectionOptions_Order_By>;
  serviceOptionSectionOptionsId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: serviceOptionAnswers */
export type ServiceOptionAnswers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "serviceOptionAnswers" */
export enum ServiceOptionAnswers_Select_Column {
  /** column name */
  AppointmentId = 'appointmentId',
  /** column name */
  Id = 'id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  ServiceOptionSectionOptionsId = 'serviceOptionSectionOptionsId'
}

/** input type for updating data in table "serviceOptionAnswers" */
export type ServiceOptionAnswers_Set_Input = {
  appointmentId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  serviceOptionSectionOptionsId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type ServiceOptionAnswers_Stddev_Fields = {
  __typename?: 'serviceOptionAnswers_stddev_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "serviceOptionAnswers" */
export type ServiceOptionAnswers_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ServiceOptionAnswers_Stddev_Pop_Fields = {
  __typename?: 'serviceOptionAnswers_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "serviceOptionAnswers" */
export type ServiceOptionAnswers_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ServiceOptionAnswers_Stddev_Samp_Fields = {
  __typename?: 'serviceOptionAnswers_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "serviceOptionAnswers" */
export type ServiceOptionAnswers_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "serviceOptionAnswers" */
export type ServiceOptionAnswers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceOptionAnswers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceOptionAnswers_Stream_Cursor_Value_Input = {
  appointmentId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  serviceOptionSectionOptionsId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type ServiceOptionAnswers_Sum_Fields = {
  __typename?: 'serviceOptionAnswers_sum_fields';
  quantity?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "serviceOptionAnswers" */
export type ServiceOptionAnswers_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "serviceOptionAnswers" */
export enum ServiceOptionAnswers_Update_Column {
  /** column name */
  AppointmentId = 'appointmentId',
  /** column name */
  Id = 'id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  ServiceOptionSectionOptionsId = 'serviceOptionSectionOptionsId'
}

export type ServiceOptionAnswers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ServiceOptionAnswers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ServiceOptionAnswers_Set_Input>;
  /** filter the rows which have to be updated */
  where: ServiceOptionAnswers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ServiceOptionAnswers_Var_Pop_Fields = {
  __typename?: 'serviceOptionAnswers_var_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "serviceOptionAnswers" */
export type ServiceOptionAnswers_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ServiceOptionAnswers_Var_Samp_Fields = {
  __typename?: 'serviceOptionAnswers_var_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "serviceOptionAnswers" */
export type ServiceOptionAnswers_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ServiceOptionAnswers_Variance_Fields = {
  __typename?: 'serviceOptionAnswers_variance_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "serviceOptionAnswers" */
export type ServiceOptionAnswers_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "serviceOptionSection" */
export type ServiceOptionSection = {
  __typename?: 'serviceOptionSection';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  mandatory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['bigint']['output'];
  /** An object relationship */
  serviceOption: ServiceOptions;
  serviceOptionId: Scalars['uuid']['output'];
  /** An array relationship */
  serviceOptionSectionOptions: Array<ServiceOptionSectionOptions>;
  /** An aggregate relationship */
  serviceOptionSectionOptions_aggregate: ServiceOptionSectionOptions_Aggregate;
  /** An object relationship */
  serviceSectionOptionType: ServiceSectionOptionType;
  type: ServiceSectionOptionType_Enum;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "serviceOptionSection" */
export type ServiceOptionSectionServiceOptionSectionOptionsArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionSectionOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionSectionOptions_Order_By>>;
  where?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
};


/** columns and relationships of "serviceOptionSection" */
export type ServiceOptionSectionServiceOptionSectionOptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionSectionOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionSectionOptions_Order_By>>;
  where?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
};

/** columns and relationships of "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions = {
  __typename?: 'serviceOptionSectionOptions';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  order: Scalars['bigint']['output'];
  price: Scalars['float8']['output'];
  quantity: ServiceSectionOptionQuantityType_Enum;
  /** An array relationship */
  serviceOptionAnswers: Array<ServiceOptionAnswers>;
  /** An aggregate relationship */
  serviceOptionAnswers_aggregate: ServiceOptionAnswers_Aggregate;
  /** An object relationship */
  serviceOptionSection: ServiceOptionSection;
  serviceOptionSectionId: Scalars['uuid']['output'];
  /** An object relationship */
  serviceSectionOptionQuantityType: ServiceSectionOptionQuantityType;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptionsServiceOptionAnswersArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionAnswers_Order_By>>;
  where?: InputMaybe<ServiceOptionAnswers_Bool_Exp>;
};


/** columns and relationships of "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptionsServiceOptionAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionAnswers_Order_By>>;
  where?: InputMaybe<ServiceOptionAnswers_Bool_Exp>;
};

/** aggregated selection of "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Aggregate = {
  __typename?: 'serviceOptionSectionOptions_aggregate';
  aggregate?: Maybe<ServiceOptionSectionOptions_Aggregate_Fields>;
  nodes: Array<ServiceOptionSectionOptions>;
};

export type ServiceOptionSectionOptions_Aggregate_Bool_Exp = {
  avg?: InputMaybe<ServiceOptionSectionOptions_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<ServiceOptionSectionOptions_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<ServiceOptionSectionOptions_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<ServiceOptionSectionOptions_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<ServiceOptionSectionOptions_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<ServiceOptionSectionOptions_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<ServiceOptionSectionOptions_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<ServiceOptionSectionOptions_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<ServiceOptionSectionOptions_Aggregate_Bool_Exp_Var_Samp>;
};

export type ServiceOptionSectionOptions_Aggregate_Bool_Exp_Avg = {
  arguments: ServiceOptionSectionOptions_Select_Column_ServiceOptionSectionOptions_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ServiceOptionSectionOptions_Aggregate_Bool_Exp_Corr = {
  arguments: ServiceOptionSectionOptions_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ServiceOptionSectionOptions_Aggregate_Bool_Exp_Corr_Arguments = {
  X: ServiceOptionSectionOptions_Select_Column_ServiceOptionSectionOptions_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: ServiceOptionSectionOptions_Select_Column_ServiceOptionSectionOptions_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type ServiceOptionSectionOptions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ServiceOptionSectionOptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type ServiceOptionSectionOptions_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: ServiceOptionSectionOptions_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ServiceOptionSectionOptions_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: ServiceOptionSectionOptions_Select_Column_ServiceOptionSectionOptions_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: ServiceOptionSectionOptions_Select_Column_ServiceOptionSectionOptions_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type ServiceOptionSectionOptions_Aggregate_Bool_Exp_Max = {
  arguments: ServiceOptionSectionOptions_Select_Column_ServiceOptionSectionOptions_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ServiceOptionSectionOptions_Aggregate_Bool_Exp_Min = {
  arguments: ServiceOptionSectionOptions_Select_Column_ServiceOptionSectionOptions_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ServiceOptionSectionOptions_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: ServiceOptionSectionOptions_Select_Column_ServiceOptionSectionOptions_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ServiceOptionSectionOptions_Aggregate_Bool_Exp_Sum = {
  arguments: ServiceOptionSectionOptions_Select_Column_ServiceOptionSectionOptions_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ServiceOptionSectionOptions_Aggregate_Bool_Exp_Var_Samp = {
  arguments: ServiceOptionSectionOptions_Select_Column_ServiceOptionSectionOptions_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Aggregate_Fields = {
  __typename?: 'serviceOptionSectionOptions_aggregate_fields';
  avg?: Maybe<ServiceOptionSectionOptions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ServiceOptionSectionOptions_Max_Fields>;
  min?: Maybe<ServiceOptionSectionOptions_Min_Fields>;
  stddev?: Maybe<ServiceOptionSectionOptions_Stddev_Fields>;
  stddev_pop?: Maybe<ServiceOptionSectionOptions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ServiceOptionSectionOptions_Stddev_Samp_Fields>;
  sum?: Maybe<ServiceOptionSectionOptions_Sum_Fields>;
  var_pop?: Maybe<ServiceOptionSectionOptions_Var_Pop_Fields>;
  var_samp?: Maybe<ServiceOptionSectionOptions_Var_Samp_Fields>;
  variance?: Maybe<ServiceOptionSectionOptions_Variance_Fields>;
};


/** aggregate fields of "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceOptionSectionOptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Aggregate_Order_By = {
  avg?: InputMaybe<ServiceOptionSectionOptions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ServiceOptionSectionOptions_Max_Order_By>;
  min?: InputMaybe<ServiceOptionSectionOptions_Min_Order_By>;
  stddev?: InputMaybe<ServiceOptionSectionOptions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ServiceOptionSectionOptions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ServiceOptionSectionOptions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ServiceOptionSectionOptions_Sum_Order_By>;
  var_pop?: InputMaybe<ServiceOptionSectionOptions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ServiceOptionSectionOptions_Var_Samp_Order_By>;
  variance?: InputMaybe<ServiceOptionSectionOptions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Arr_Rel_Insert_Input = {
  data: Array<ServiceOptionSectionOptions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceOptionSectionOptions_On_Conflict>;
};

/** aggregate avg on columns */
export type ServiceOptionSectionOptions_Avg_Fields = {
  __typename?: 'serviceOptionSectionOptions_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "serviceOptionSectionOptions". All fields are combined with a logical 'AND'. */
export type ServiceOptionSectionOptions_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceOptionSectionOptions_Bool_Exp>>;
  _not?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceOptionSectionOptions_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Bigint_Comparison_Exp>;
  price?: InputMaybe<Float8_Comparison_Exp>;
  quantity?: InputMaybe<ServiceSectionOptionQuantityType_Enum_Comparison_Exp>;
  serviceOptionAnswers?: InputMaybe<ServiceOptionAnswers_Bool_Exp>;
  serviceOptionAnswers_aggregate?: InputMaybe<ServiceOptionAnswers_Aggregate_Bool_Exp>;
  serviceOptionSection?: InputMaybe<ServiceOptionSection_Bool_Exp>;
  serviceOptionSectionId?: InputMaybe<Uuid_Comparison_Exp>;
  serviceSectionOptionQuantityType?: InputMaybe<ServiceSectionOptionQuantityType_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "serviceOptionSectionOptions" */
export enum ServiceOptionSectionOptions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServiceOptionSectionOptionsPkey = 'serviceOptionSectionOptions_pkey'
}

/** input type for incrementing numeric columns in table "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Inc_Input = {
  order?: InputMaybe<Scalars['bigint']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['bigint']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
  quantity?: InputMaybe<ServiceSectionOptionQuantityType_Enum>;
  serviceOptionAnswers?: InputMaybe<ServiceOptionAnswers_Arr_Rel_Insert_Input>;
  serviceOptionSection?: InputMaybe<ServiceOptionSection_Obj_Rel_Insert_Input>;
  serviceOptionSectionId?: InputMaybe<Scalars['uuid']['input']>;
  serviceSectionOptionQuantityType?: InputMaybe<ServiceSectionOptionQuantityType_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ServiceOptionSectionOptions_Max_Fields = {
  __typename?: 'serviceOptionSectionOptions_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['bigint']['output']>;
  price?: Maybe<Scalars['float8']['output']>;
  serviceOptionSectionId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  serviceOptionSectionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ServiceOptionSectionOptions_Min_Fields = {
  __typename?: 'serviceOptionSectionOptions_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['bigint']['output']>;
  price?: Maybe<Scalars['float8']['output']>;
  serviceOptionSectionId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  serviceOptionSectionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Mutation_Response = {
  __typename?: 'serviceOptionSectionOptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ServiceOptionSectionOptions>;
};

/** input type for inserting object relation for remote table "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Obj_Rel_Insert_Input = {
  data: ServiceOptionSectionOptions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceOptionSectionOptions_On_Conflict>;
};

/** on_conflict condition type for table "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_On_Conflict = {
  constraint: ServiceOptionSectionOptions_Constraint;
  update_columns?: Array<ServiceOptionSectionOptions_Update_Column>;
  where?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
};

/** Ordering options when selecting data from "serviceOptionSectionOptions". */
export type ServiceOptionSectionOptions_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  serviceOptionAnswers_aggregate?: InputMaybe<ServiceOptionAnswers_Aggregate_Order_By>;
  serviceOptionSection?: InputMaybe<ServiceOptionSection_Order_By>;
  serviceOptionSectionId?: InputMaybe<Order_By>;
  serviceSectionOptionQuantityType?: InputMaybe<ServiceSectionOptionQuantityType_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: serviceOptionSectionOptions */
export type ServiceOptionSectionOptions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "serviceOptionSectionOptions" */
export enum ServiceOptionSectionOptions_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  Price = 'price',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  ServiceOptionSectionId = 'serviceOptionSectionId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "serviceOptionSectionOptions_aggregate_bool_exp_avg_arguments_columns" columns of table "serviceOptionSectionOptions" */
export enum ServiceOptionSectionOptions_Select_Column_ServiceOptionSectionOptions_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Price = 'price'
}

/** select "serviceOptionSectionOptions_aggregate_bool_exp_corr_arguments_columns" columns of table "serviceOptionSectionOptions" */
export enum ServiceOptionSectionOptions_Select_Column_ServiceOptionSectionOptions_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Price = 'price'
}

/** select "serviceOptionSectionOptions_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "serviceOptionSectionOptions" */
export enum ServiceOptionSectionOptions_Select_Column_ServiceOptionSectionOptions_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Price = 'price'
}

/** select "serviceOptionSectionOptions_aggregate_bool_exp_max_arguments_columns" columns of table "serviceOptionSectionOptions" */
export enum ServiceOptionSectionOptions_Select_Column_ServiceOptionSectionOptions_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Price = 'price'
}

/** select "serviceOptionSectionOptions_aggregate_bool_exp_min_arguments_columns" columns of table "serviceOptionSectionOptions" */
export enum ServiceOptionSectionOptions_Select_Column_ServiceOptionSectionOptions_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Price = 'price'
}

/** select "serviceOptionSectionOptions_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "serviceOptionSectionOptions" */
export enum ServiceOptionSectionOptions_Select_Column_ServiceOptionSectionOptions_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Price = 'price'
}

/** select "serviceOptionSectionOptions_aggregate_bool_exp_sum_arguments_columns" columns of table "serviceOptionSectionOptions" */
export enum ServiceOptionSectionOptions_Select_Column_ServiceOptionSectionOptions_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Price = 'price'
}

/** select "serviceOptionSectionOptions_aggregate_bool_exp_var_samp_arguments_columns" columns of table "serviceOptionSectionOptions" */
export enum ServiceOptionSectionOptions_Select_Column_ServiceOptionSectionOptions_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Price = 'price'
}

/** input type for updating data in table "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['bigint']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
  quantity?: InputMaybe<ServiceSectionOptionQuantityType_Enum>;
  serviceOptionSectionId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type ServiceOptionSectionOptions_Stddev_Fields = {
  __typename?: 'serviceOptionSectionOptions_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ServiceOptionSectionOptions_Stddev_Pop_Fields = {
  __typename?: 'serviceOptionSectionOptions_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ServiceOptionSectionOptions_Stddev_Samp_Fields = {
  __typename?: 'serviceOptionSectionOptions_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceOptionSectionOptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceOptionSectionOptions_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['bigint']['input']>;
  price?: InputMaybe<Scalars['float8']['input']>;
  quantity?: InputMaybe<ServiceSectionOptionQuantityType_Enum>;
  serviceOptionSectionId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type ServiceOptionSectionOptions_Sum_Fields = {
  __typename?: 'serviceOptionSectionOptions_sum_fields';
  order?: Maybe<Scalars['bigint']['output']>;
  price?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** update columns of table "serviceOptionSectionOptions" */
export enum ServiceOptionSectionOptions_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  Price = 'price',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  ServiceOptionSectionId = 'serviceOptionSectionId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ServiceOptionSectionOptions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ServiceOptionSectionOptions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ServiceOptionSectionOptions_Set_Input>;
  /** filter the rows which have to be updated */
  where: ServiceOptionSectionOptions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ServiceOptionSectionOptions_Var_Pop_Fields = {
  __typename?: 'serviceOptionSectionOptions_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ServiceOptionSectionOptions_Var_Samp_Fields = {
  __typename?: 'serviceOptionSectionOptions_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ServiceOptionSectionOptions_Variance_Fields = {
  __typename?: 'serviceOptionSectionOptions_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "serviceOptionSectionOptions" */
export type ServiceOptionSectionOptions_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregated selection of "serviceOptionSection" */
export type ServiceOptionSection_Aggregate = {
  __typename?: 'serviceOptionSection_aggregate';
  aggregate?: Maybe<ServiceOptionSection_Aggregate_Fields>;
  nodes: Array<ServiceOptionSection>;
};

export type ServiceOptionSection_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<ServiceOptionSection_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ServiceOptionSection_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<ServiceOptionSection_Aggregate_Bool_Exp_Count>;
};

export type ServiceOptionSection_Aggregate_Bool_Exp_Bool_And = {
  arguments: ServiceOptionSection_Select_Column_ServiceOptionSection_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceOptionSection_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ServiceOptionSection_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ServiceOptionSection_Select_Column_ServiceOptionSection_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceOptionSection_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ServiceOptionSection_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ServiceOptionSection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceOptionSection_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "serviceOptionSection" */
export type ServiceOptionSection_Aggregate_Fields = {
  __typename?: 'serviceOptionSection_aggregate_fields';
  avg?: Maybe<ServiceOptionSection_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ServiceOptionSection_Max_Fields>;
  min?: Maybe<ServiceOptionSection_Min_Fields>;
  stddev?: Maybe<ServiceOptionSection_Stddev_Fields>;
  stddev_pop?: Maybe<ServiceOptionSection_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ServiceOptionSection_Stddev_Samp_Fields>;
  sum?: Maybe<ServiceOptionSection_Sum_Fields>;
  var_pop?: Maybe<ServiceOptionSection_Var_Pop_Fields>;
  var_samp?: Maybe<ServiceOptionSection_Var_Samp_Fields>;
  variance?: Maybe<ServiceOptionSection_Variance_Fields>;
};


/** aggregate fields of "serviceOptionSection" */
export type ServiceOptionSection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceOptionSection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "serviceOptionSection" */
export type ServiceOptionSection_Aggregate_Order_By = {
  avg?: InputMaybe<ServiceOptionSection_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ServiceOptionSection_Max_Order_By>;
  min?: InputMaybe<ServiceOptionSection_Min_Order_By>;
  stddev?: InputMaybe<ServiceOptionSection_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ServiceOptionSection_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ServiceOptionSection_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ServiceOptionSection_Sum_Order_By>;
  var_pop?: InputMaybe<ServiceOptionSection_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ServiceOptionSection_Var_Samp_Order_By>;
  variance?: InputMaybe<ServiceOptionSection_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "serviceOptionSection" */
export type ServiceOptionSection_Arr_Rel_Insert_Input = {
  data: Array<ServiceOptionSection_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceOptionSection_On_Conflict>;
};

/** aggregate avg on columns */
export type ServiceOptionSection_Avg_Fields = {
  __typename?: 'serviceOptionSection_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "serviceOptionSection" */
export type ServiceOptionSection_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "serviceOptionSection". All fields are combined with a logical 'AND'. */
export type ServiceOptionSection_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceOptionSection_Bool_Exp>>;
  _not?: InputMaybe<ServiceOptionSection_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceOptionSection_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mandatory?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Bigint_Comparison_Exp>;
  serviceOption?: InputMaybe<ServiceOptions_Bool_Exp>;
  serviceOptionId?: InputMaybe<Uuid_Comparison_Exp>;
  serviceOptionSectionOptions?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
  serviceOptionSectionOptions_aggregate?: InputMaybe<ServiceOptionSectionOptions_Aggregate_Bool_Exp>;
  serviceSectionOptionType?: InputMaybe<ServiceSectionOptionType_Bool_Exp>;
  type?: InputMaybe<ServiceSectionOptionType_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "serviceOptionSection" */
export enum ServiceOptionSection_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServiceOptionSectionPkey = 'serviceOptionSection_pkey'
}

/** input type for incrementing numeric columns in table "serviceOptionSection" */
export type ServiceOptionSection_Inc_Input = {
  order?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "serviceOptionSection" */
export type ServiceOptionSection_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['bigint']['input']>;
  serviceOption?: InputMaybe<ServiceOptions_Obj_Rel_Insert_Input>;
  serviceOptionId?: InputMaybe<Scalars['uuid']['input']>;
  serviceOptionSectionOptions?: InputMaybe<ServiceOptionSectionOptions_Arr_Rel_Insert_Input>;
  serviceSectionOptionType?: InputMaybe<ServiceSectionOptionType_Obj_Rel_Insert_Input>;
  type?: InputMaybe<ServiceSectionOptionType_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ServiceOptionSection_Max_Fields = {
  __typename?: 'serviceOptionSection_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['bigint']['output']>;
  serviceOptionId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "serviceOptionSection" */
export type ServiceOptionSection_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceOptionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ServiceOptionSection_Min_Fields = {
  __typename?: 'serviceOptionSection_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['bigint']['output']>;
  serviceOptionId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "serviceOptionSection" */
export type ServiceOptionSection_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceOptionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "serviceOptionSection" */
export type ServiceOptionSection_Mutation_Response = {
  __typename?: 'serviceOptionSection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ServiceOptionSection>;
};

/** input type for inserting object relation for remote table "serviceOptionSection" */
export type ServiceOptionSection_Obj_Rel_Insert_Input = {
  data: ServiceOptionSection_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceOptionSection_On_Conflict>;
};

/** on_conflict condition type for table "serviceOptionSection" */
export type ServiceOptionSection_On_Conflict = {
  constraint: ServiceOptionSection_Constraint;
  update_columns?: Array<ServiceOptionSection_Update_Column>;
  where?: InputMaybe<ServiceOptionSection_Bool_Exp>;
};

/** Ordering options when selecting data from "serviceOptionSection". */
export type ServiceOptionSection_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mandatory?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceOption?: InputMaybe<ServiceOptions_Order_By>;
  serviceOptionId?: InputMaybe<Order_By>;
  serviceOptionSectionOptions_aggregate?: InputMaybe<ServiceOptionSectionOptions_Aggregate_Order_By>;
  serviceSectionOptionType?: InputMaybe<ServiceSectionOptionType_Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: serviceOptionSection */
export type ServiceOptionSection_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "serviceOptionSection" */
export enum ServiceOptionSection_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Mandatory = 'mandatory',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ServiceOptionId = 'serviceOptionId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "serviceOptionSection_aggregate_bool_exp_bool_and_arguments_columns" columns of table "serviceOptionSection" */
export enum ServiceOptionSection_Select_Column_ServiceOptionSection_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Mandatory = 'mandatory'
}

/** select "serviceOptionSection_aggregate_bool_exp_bool_or_arguments_columns" columns of table "serviceOptionSection" */
export enum ServiceOptionSection_Select_Column_ServiceOptionSection_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Mandatory = 'mandatory'
}

/** input type for updating data in table "serviceOptionSection" */
export type ServiceOptionSection_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['bigint']['input']>;
  serviceOptionId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<ServiceSectionOptionType_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type ServiceOptionSection_Stddev_Fields = {
  __typename?: 'serviceOptionSection_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "serviceOptionSection" */
export type ServiceOptionSection_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ServiceOptionSection_Stddev_Pop_Fields = {
  __typename?: 'serviceOptionSection_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "serviceOptionSection" */
export type ServiceOptionSection_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ServiceOptionSection_Stddev_Samp_Fields = {
  __typename?: 'serviceOptionSection_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "serviceOptionSection" */
export type ServiceOptionSection_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "serviceOptionSection" */
export type ServiceOptionSection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceOptionSection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceOptionSection_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['bigint']['input']>;
  serviceOptionId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<ServiceSectionOptionType_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type ServiceOptionSection_Sum_Fields = {
  __typename?: 'serviceOptionSection_sum_fields';
  order?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "serviceOptionSection" */
export type ServiceOptionSection_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "serviceOptionSection" */
export enum ServiceOptionSection_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Mandatory = 'mandatory',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ServiceOptionId = 'serviceOptionId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ServiceOptionSection_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ServiceOptionSection_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ServiceOptionSection_Set_Input>;
  /** filter the rows which have to be updated */
  where: ServiceOptionSection_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ServiceOptionSection_Var_Pop_Fields = {
  __typename?: 'serviceOptionSection_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "serviceOptionSection" */
export type ServiceOptionSection_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ServiceOptionSection_Var_Samp_Fields = {
  __typename?: 'serviceOptionSection_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "serviceOptionSection" */
export type ServiceOptionSection_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ServiceOptionSection_Variance_Fields = {
  __typename?: 'serviceOptionSection_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "serviceOptionSection" */
export type ServiceOptionSection_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "serviceOptions" */
export type ServiceOptions = {
  __typename?: 'serviceOptions';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  service: Services;
  serviceId: Scalars['uuid']['output'];
  /** An array relationship */
  serviceOptionSections: Array<ServiceOptionSection>;
  /** An aggregate relationship */
  serviceOptionSections_aggregate: ServiceOptionSection_Aggregate;
  /** An object relationship */
  serviceOptionsStatus: ServiceOptionsStatus;
  status: ServiceOptionsStatus_Enum;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "serviceOptions" */
export type ServiceOptionsServiceOptionSectionsArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionSection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionSection_Order_By>>;
  where?: InputMaybe<ServiceOptionSection_Bool_Exp>;
};


/** columns and relationships of "serviceOptions" */
export type ServiceOptionsServiceOptionSections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionSection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionSection_Order_By>>;
  where?: InputMaybe<ServiceOptionSection_Bool_Exp>;
};

/** columns and relationships of "serviceOptionsStatus" */
export type ServiceOptionsStatus = {
  __typename?: 'serviceOptionsStatus';
  /** An array relationship */
  serviceOptions: Array<ServiceOptions>;
  /** An aggregate relationship */
  serviceOptions_aggregate: ServiceOptions_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "serviceOptionsStatus" */
export type ServiceOptionsStatusServiceOptionsArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptions_Order_By>>;
  where?: InputMaybe<ServiceOptions_Bool_Exp>;
};


/** columns and relationships of "serviceOptionsStatus" */
export type ServiceOptionsStatusServiceOptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptions_Order_By>>;
  where?: InputMaybe<ServiceOptions_Bool_Exp>;
};

/** aggregated selection of "serviceOptionsStatus" */
export type ServiceOptionsStatus_Aggregate = {
  __typename?: 'serviceOptionsStatus_aggregate';
  aggregate?: Maybe<ServiceOptionsStatus_Aggregate_Fields>;
  nodes: Array<ServiceOptionsStatus>;
};

/** aggregate fields of "serviceOptionsStatus" */
export type ServiceOptionsStatus_Aggregate_Fields = {
  __typename?: 'serviceOptionsStatus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ServiceOptionsStatus_Max_Fields>;
  min?: Maybe<ServiceOptionsStatus_Min_Fields>;
};


/** aggregate fields of "serviceOptionsStatus" */
export type ServiceOptionsStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceOptionsStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "serviceOptionsStatus". All fields are combined with a logical 'AND'. */
export type ServiceOptionsStatus_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceOptionsStatus_Bool_Exp>>;
  _not?: InputMaybe<ServiceOptionsStatus_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceOptionsStatus_Bool_Exp>>;
  serviceOptions?: InputMaybe<ServiceOptions_Bool_Exp>;
  serviceOptions_aggregate?: InputMaybe<ServiceOptions_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "serviceOptionsStatus" */
export enum ServiceOptionsStatus_Constraint {
  /** unique or primary key constraint on columns "value" */
  ServiceOptionsStatusPkey = 'serviceOptionsStatus_pkey'
}

export enum ServiceOptionsStatus_Enum {
  Active = 'active',
  Inactive = 'inactive'
}

/** Boolean expression to compare columns of type "serviceOptionsStatus_enum". All fields are combined with logical 'AND'. */
export type ServiceOptionsStatus_Enum_Comparison_Exp = {
  _eq?: InputMaybe<ServiceOptionsStatus_Enum>;
  _in?: InputMaybe<Array<ServiceOptionsStatus_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<ServiceOptionsStatus_Enum>;
  _nin?: InputMaybe<Array<ServiceOptionsStatus_Enum>>;
};

/** input type for inserting data into table "serviceOptionsStatus" */
export type ServiceOptionsStatus_Insert_Input = {
  serviceOptions?: InputMaybe<ServiceOptions_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ServiceOptionsStatus_Max_Fields = {
  __typename?: 'serviceOptionsStatus_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ServiceOptionsStatus_Min_Fields = {
  __typename?: 'serviceOptionsStatus_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "serviceOptionsStatus" */
export type ServiceOptionsStatus_Mutation_Response = {
  __typename?: 'serviceOptionsStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ServiceOptionsStatus>;
};

/** input type for inserting object relation for remote table "serviceOptionsStatus" */
export type ServiceOptionsStatus_Obj_Rel_Insert_Input = {
  data: ServiceOptionsStatus_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceOptionsStatus_On_Conflict>;
};

/** on_conflict condition type for table "serviceOptionsStatus" */
export type ServiceOptionsStatus_On_Conflict = {
  constraint: ServiceOptionsStatus_Constraint;
  update_columns?: Array<ServiceOptionsStatus_Update_Column>;
  where?: InputMaybe<ServiceOptionsStatus_Bool_Exp>;
};

/** Ordering options when selecting data from "serviceOptionsStatus". */
export type ServiceOptionsStatus_Order_By = {
  serviceOptions_aggregate?: InputMaybe<ServiceOptions_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: serviceOptionsStatus */
export type ServiceOptionsStatus_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "serviceOptionsStatus" */
export enum ServiceOptionsStatus_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "serviceOptionsStatus" */
export type ServiceOptionsStatus_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "serviceOptionsStatus" */
export type ServiceOptionsStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceOptionsStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceOptionsStatus_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "serviceOptionsStatus" */
export enum ServiceOptionsStatus_Update_Column {
  /** column name */
  Value = 'value'
}

export type ServiceOptionsStatus_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ServiceOptionsStatus_Set_Input>;
  /** filter the rows which have to be updated */
  where: ServiceOptionsStatus_Bool_Exp;
};

/** aggregated selection of "serviceOptions" */
export type ServiceOptions_Aggregate = {
  __typename?: 'serviceOptions_aggregate';
  aggregate?: Maybe<ServiceOptions_Aggregate_Fields>;
  nodes: Array<ServiceOptions>;
};

export type ServiceOptions_Aggregate_Bool_Exp = {
  count?: InputMaybe<ServiceOptions_Aggregate_Bool_Exp_Count>;
};

export type ServiceOptions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ServiceOptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceOptions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "serviceOptions" */
export type ServiceOptions_Aggregate_Fields = {
  __typename?: 'serviceOptions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ServiceOptions_Max_Fields>;
  min?: Maybe<ServiceOptions_Min_Fields>;
};


/** aggregate fields of "serviceOptions" */
export type ServiceOptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceOptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "serviceOptions" */
export type ServiceOptions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ServiceOptions_Max_Order_By>;
  min?: InputMaybe<ServiceOptions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "serviceOptions" */
export type ServiceOptions_Arr_Rel_Insert_Input = {
  data: Array<ServiceOptions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceOptions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "serviceOptions". All fields are combined with a logical 'AND'. */
export type ServiceOptions_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceOptions_Bool_Exp>>;
  _not?: InputMaybe<ServiceOptions_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceOptions_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  service?: InputMaybe<Services_Bool_Exp>;
  serviceId?: InputMaybe<Uuid_Comparison_Exp>;
  serviceOptionSections?: InputMaybe<ServiceOptionSection_Bool_Exp>;
  serviceOptionSections_aggregate?: InputMaybe<ServiceOptionSection_Aggregate_Bool_Exp>;
  serviceOptionsStatus?: InputMaybe<ServiceOptionsStatus_Bool_Exp>;
  status?: InputMaybe<ServiceOptionsStatus_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "serviceOptions" */
export enum ServiceOptions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServiceOptionsPkey = 'serviceOptions_pkey'
}

/** input type for inserting data into table "serviceOptions" */
export type ServiceOptions_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Services_Obj_Rel_Insert_Input>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  serviceOptionSections?: InputMaybe<ServiceOptionSection_Arr_Rel_Insert_Input>;
  serviceOptionsStatus?: InputMaybe<ServiceOptionsStatus_Obj_Rel_Insert_Input>;
  status?: InputMaybe<ServiceOptionsStatus_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ServiceOptions_Max_Fields = {
  __typename?: 'serviceOptions_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serviceId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "serviceOptions" */
export type ServiceOptions_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ServiceOptions_Min_Fields = {
  __typename?: 'serviceOptions_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serviceId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "serviceOptions" */
export type ServiceOptions_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "serviceOptions" */
export type ServiceOptions_Mutation_Response = {
  __typename?: 'serviceOptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ServiceOptions>;
};

/** input type for inserting object relation for remote table "serviceOptions" */
export type ServiceOptions_Obj_Rel_Insert_Input = {
  data: ServiceOptions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceOptions_On_Conflict>;
};

/** on_conflict condition type for table "serviceOptions" */
export type ServiceOptions_On_Conflict = {
  constraint: ServiceOptions_Constraint;
  update_columns?: Array<ServiceOptions_Update_Column>;
  where?: InputMaybe<ServiceOptions_Bool_Exp>;
};

/** Ordering options when selecting data from "serviceOptions". */
export type ServiceOptions_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  service?: InputMaybe<Services_Order_By>;
  serviceId?: InputMaybe<Order_By>;
  serviceOptionSections_aggregate?: InputMaybe<ServiceOptionSection_Aggregate_Order_By>;
  serviceOptionsStatus?: InputMaybe<ServiceOptionsStatus_Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: serviceOptions */
export type ServiceOptions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "serviceOptions" */
export enum ServiceOptions_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "serviceOptions" */
export type ServiceOptions_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<ServiceOptionsStatus_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "serviceOptions" */
export type ServiceOptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceOptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceOptions_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<ServiceOptionsStatus_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "serviceOptions" */
export enum ServiceOptions_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ServiceOptions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ServiceOptions_Set_Input>;
  /** filter the rows which have to be updated */
  where: ServiceOptions_Bool_Exp;
};

/** columns and relationships of "servicePictures" */
export type ServicePictures = {
  __typename?: 'servicePictures';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: Files;
  fileId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  service: Services;
  serviceId: Scalars['uuid']['output'];
  /** An array relationship */
  services: Array<Services>;
  /** An aggregate relationship */
  services_aggregate: Services_Aggregate;
  size: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "servicePictures" */
export type ServicePicturesServicesArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


/** columns and relationships of "servicePictures" */
export type ServicePicturesServices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};

/** aggregated selection of "servicePictures" */
export type ServicePictures_Aggregate = {
  __typename?: 'servicePictures_aggregate';
  aggregate?: Maybe<ServicePictures_Aggregate_Fields>;
  nodes: Array<ServicePictures>;
};

export type ServicePictures_Aggregate_Bool_Exp = {
  count?: InputMaybe<ServicePictures_Aggregate_Bool_Exp_Count>;
};

export type ServicePictures_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ServicePictures_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServicePictures_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "servicePictures" */
export type ServicePictures_Aggregate_Fields = {
  __typename?: 'servicePictures_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ServicePictures_Max_Fields>;
  min?: Maybe<ServicePictures_Min_Fields>;
};


/** aggregate fields of "servicePictures" */
export type ServicePictures_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServicePictures_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "servicePictures" */
export type ServicePictures_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ServicePictures_Max_Order_By>;
  min?: InputMaybe<ServicePictures_Min_Order_By>;
};

/** input type for inserting array relation for remote table "servicePictures" */
export type ServicePictures_Arr_Rel_Insert_Input = {
  data: Array<ServicePictures_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ServicePictures_On_Conflict>;
};

/** Boolean expression to filter rows from the table "servicePictures". All fields are combined with a logical 'AND'. */
export type ServicePictures_Bool_Exp = {
  _and?: InputMaybe<Array<ServicePictures_Bool_Exp>>;
  _not?: InputMaybe<ServicePictures_Bool_Exp>;
  _or?: InputMaybe<Array<ServicePictures_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  service?: InputMaybe<Services_Bool_Exp>;
  serviceId?: InputMaybe<Uuid_Comparison_Exp>;
  services?: InputMaybe<Services_Bool_Exp>;
  services_aggregate?: InputMaybe<Services_Aggregate_Bool_Exp>;
  size?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "servicePictures" */
export enum ServicePictures_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServicePicturesPkey = 'servicePictures_pkey'
}

/** input type for inserting data into table "servicePictures" */
export type ServicePictures_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Services_Obj_Rel_Insert_Input>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  services?: InputMaybe<Services_Arr_Rel_Insert_Input>;
  size?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ServicePictures_Max_Fields = {
  __typename?: 'servicePictures_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serviceId?: Maybe<Scalars['uuid']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "servicePictures" */
export type ServicePictures_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ServicePictures_Min_Fields = {
  __typename?: 'servicePictures_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serviceId?: Maybe<Scalars['uuid']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "servicePictures" */
export type ServicePictures_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "servicePictures" */
export type ServicePictures_Mutation_Response = {
  __typename?: 'servicePictures_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ServicePictures>;
};

/** input type for inserting object relation for remote table "servicePictures" */
export type ServicePictures_Obj_Rel_Insert_Input = {
  data: ServicePictures_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ServicePictures_On_Conflict>;
};

/** on_conflict condition type for table "servicePictures" */
export type ServicePictures_On_Conflict = {
  constraint: ServicePictures_Constraint;
  update_columns?: Array<ServicePictures_Update_Column>;
  where?: InputMaybe<ServicePictures_Bool_Exp>;
};

/** Ordering options when selecting data from "servicePictures". */
export type ServicePictures_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  service?: InputMaybe<Services_Order_By>;
  serviceId?: InputMaybe<Order_By>;
  services_aggregate?: InputMaybe<Services_Aggregate_Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: servicePictures */
export type ServicePictures_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "servicePictures" */
export enum ServicePictures_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "servicePictures" */
export type ServicePictures_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "servicePictures" */
export type ServicePictures_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServicePictures_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServicePictures_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "servicePictures" */
export enum ServicePictures_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ServicePictures_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ServicePictures_Set_Input>;
  /** filter the rows which have to be updated */
  where: ServicePictures_Bool_Exp;
};

/** columns and relationships of "servicePricings" */
export type ServicePricings = {
  __typename?: 'servicePricings';
  basePrice?: Maybe<Scalars['float8']['output']>;
  checkoutPayment?: Maybe<Scalars['jsonb']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  currency: Currencies_Enum;
  /** An object relationship */
  currencyByCurrency: Currencies;
  fees?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  minimumDeposit?: Maybe<Scalars['float8']['output']>;
  paymentFormat: PaymentFormat_Enum;
  /** An object relationship */
  paymentFormatByPaymentformat: PaymentFormat;
  /** An object relationship */
  service: Services;
  serviceId: Scalars['uuid']['output'];
  taxes?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "servicePricings" */
export type ServicePricingsCheckoutPaymentArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "servicePricings" */
export type ServicePricingsFeesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "servicePricings" */
export type ServicePricings_Aggregate = {
  __typename?: 'servicePricings_aggregate';
  aggregate?: Maybe<ServicePricings_Aggregate_Fields>;
  nodes: Array<ServicePricings>;
};

export type ServicePricings_Aggregate_Bool_Exp = {
  avg?: InputMaybe<ServicePricings_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<ServicePricings_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ServicePricings_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<ServicePricings_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<ServicePricings_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<ServicePricings_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<ServicePricings_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<ServicePricings_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<ServicePricings_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<ServicePricings_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<ServicePricings_Aggregate_Bool_Exp_Var_Samp>;
};

export type ServicePricings_Aggregate_Bool_Exp_Avg = {
  arguments: ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServicePricings_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ServicePricings_Aggregate_Bool_Exp_Bool_And = {
  arguments: ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServicePricings_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ServicePricings_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServicePricings_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ServicePricings_Aggregate_Bool_Exp_Corr = {
  arguments: ServicePricings_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServicePricings_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ServicePricings_Aggregate_Bool_Exp_Corr_Arguments = {
  X: ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type ServicePricings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ServicePricings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServicePricings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type ServicePricings_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: ServicePricings_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServicePricings_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ServicePricings_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type ServicePricings_Aggregate_Bool_Exp_Max = {
  arguments: ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServicePricings_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ServicePricings_Aggregate_Bool_Exp_Min = {
  arguments: ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServicePricings_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ServicePricings_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServicePricings_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ServicePricings_Aggregate_Bool_Exp_Sum = {
  arguments: ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServicePricings_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type ServicePricings_Aggregate_Bool_Exp_Var_Samp = {
  arguments: ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServicePricings_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "servicePricings" */
export type ServicePricings_Aggregate_Fields = {
  __typename?: 'servicePricings_aggregate_fields';
  avg?: Maybe<ServicePricings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ServicePricings_Max_Fields>;
  min?: Maybe<ServicePricings_Min_Fields>;
  stddev?: Maybe<ServicePricings_Stddev_Fields>;
  stddev_pop?: Maybe<ServicePricings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ServicePricings_Stddev_Samp_Fields>;
  sum?: Maybe<ServicePricings_Sum_Fields>;
  var_pop?: Maybe<ServicePricings_Var_Pop_Fields>;
  var_samp?: Maybe<ServicePricings_Var_Samp_Fields>;
  variance?: Maybe<ServicePricings_Variance_Fields>;
};


/** aggregate fields of "servicePricings" */
export type ServicePricings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServicePricings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "servicePricings" */
export type ServicePricings_Aggregate_Order_By = {
  avg?: InputMaybe<ServicePricings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ServicePricings_Max_Order_By>;
  min?: InputMaybe<ServicePricings_Min_Order_By>;
  stddev?: InputMaybe<ServicePricings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ServicePricings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ServicePricings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ServicePricings_Sum_Order_By>;
  var_pop?: InputMaybe<ServicePricings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ServicePricings_Var_Samp_Order_By>;
  variance?: InputMaybe<ServicePricings_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ServicePricings_Append_Input = {
  checkoutPayment?: InputMaybe<Scalars['jsonb']['input']>;
  fees?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "servicePricings" */
export type ServicePricings_Arr_Rel_Insert_Input = {
  data: Array<ServicePricings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ServicePricings_On_Conflict>;
};

/** aggregate avg on columns */
export type ServicePricings_Avg_Fields = {
  __typename?: 'servicePricings_avg_fields';
  basePrice?: Maybe<Scalars['Float']['output']>;
  minimumDeposit?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "servicePricings" */
export type ServicePricings_Avg_Order_By = {
  basePrice?: InputMaybe<Order_By>;
  minimumDeposit?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "servicePricings". All fields are combined with a logical 'AND'. */
export type ServicePricings_Bool_Exp = {
  _and?: InputMaybe<Array<ServicePricings_Bool_Exp>>;
  _not?: InputMaybe<ServicePricings_Bool_Exp>;
  _or?: InputMaybe<Array<ServicePricings_Bool_Exp>>;
  basePrice?: InputMaybe<Float8_Comparison_Exp>;
  checkoutPayment?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<Currencies_Enum_Comparison_Exp>;
  currencyByCurrency?: InputMaybe<Currencies_Bool_Exp>;
  fees?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  minimumDeposit?: InputMaybe<Float8_Comparison_Exp>;
  paymentFormat?: InputMaybe<PaymentFormat_Enum_Comparison_Exp>;
  paymentFormatByPaymentformat?: InputMaybe<PaymentFormat_Bool_Exp>;
  service?: InputMaybe<Services_Bool_Exp>;
  serviceId?: InputMaybe<Uuid_Comparison_Exp>;
  taxes?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "servicePricings" */
export enum ServicePricings_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServicePricingsPkey = 'servicePricings_pkey',
  /** unique or primary key constraint on columns "serviceId" */
  ServicePricingsServiceIdKey = 'servicePricings_serviceId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ServicePricings_Delete_At_Path_Input = {
  checkoutPayment?: InputMaybe<Array<Scalars['String']['input']>>;
  fees?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ServicePricings_Delete_Elem_Input = {
  checkoutPayment?: InputMaybe<Scalars['Int']['input']>;
  fees?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ServicePricings_Delete_Key_Input = {
  checkoutPayment?: InputMaybe<Scalars['String']['input']>;
  fees?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "servicePricings" */
export type ServicePricings_Inc_Input = {
  basePrice?: InputMaybe<Scalars['float8']['input']>;
  minimumDeposit?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "servicePricings" */
export type ServicePricings_Insert_Input = {
  basePrice?: InputMaybe<Scalars['float8']['input']>;
  checkoutPayment?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Currencies_Enum>;
  currencyByCurrency?: InputMaybe<Currencies_Obj_Rel_Insert_Input>;
  fees?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  minimumDeposit?: InputMaybe<Scalars['float8']['input']>;
  paymentFormat?: InputMaybe<PaymentFormat_Enum>;
  paymentFormatByPaymentformat?: InputMaybe<PaymentFormat_Obj_Rel_Insert_Input>;
  service?: InputMaybe<Services_Obj_Rel_Insert_Input>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  taxes?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ServicePricings_Max_Fields = {
  __typename?: 'servicePricings_max_fields';
  basePrice?: Maybe<Scalars['float8']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  minimumDeposit?: Maybe<Scalars['float8']['output']>;
  serviceId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "servicePricings" */
export type ServicePricings_Max_Order_By = {
  basePrice?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  minimumDeposit?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ServicePricings_Min_Fields = {
  __typename?: 'servicePricings_min_fields';
  basePrice?: Maybe<Scalars['float8']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  minimumDeposit?: Maybe<Scalars['float8']['output']>;
  serviceId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "servicePricings" */
export type ServicePricings_Min_Order_By = {
  basePrice?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  minimumDeposit?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "servicePricings" */
export type ServicePricings_Mutation_Response = {
  __typename?: 'servicePricings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ServicePricings>;
};

/** input type for inserting object relation for remote table "servicePricings" */
export type ServicePricings_Obj_Rel_Insert_Input = {
  data: ServicePricings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ServicePricings_On_Conflict>;
};

/** on_conflict condition type for table "servicePricings" */
export type ServicePricings_On_Conflict = {
  constraint: ServicePricings_Constraint;
  update_columns?: Array<ServicePricings_Update_Column>;
  where?: InputMaybe<ServicePricings_Bool_Exp>;
};

/** Ordering options when selecting data from "servicePricings". */
export type ServicePricings_Order_By = {
  basePrice?: InputMaybe<Order_By>;
  checkoutPayment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  currencyByCurrency?: InputMaybe<Currencies_Order_By>;
  fees?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  minimumDeposit?: InputMaybe<Order_By>;
  paymentFormat?: InputMaybe<Order_By>;
  paymentFormatByPaymentformat?: InputMaybe<PaymentFormat_Order_By>;
  service?: InputMaybe<Services_Order_By>;
  serviceId?: InputMaybe<Order_By>;
  taxes?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: servicePricings */
export type ServicePricings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ServicePricings_Prepend_Input = {
  checkoutPayment?: InputMaybe<Scalars['jsonb']['input']>;
  fees?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "servicePricings" */
export enum ServicePricings_Select_Column {
  /** column name */
  BasePrice = 'basePrice',
  /** column name */
  CheckoutPayment = 'checkoutPayment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  Fees = 'fees',
  /** column name */
  Id = 'id',
  /** column name */
  MinimumDeposit = 'minimumDeposit',
  /** column name */
  PaymentFormat = 'paymentFormat',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  Taxes = 'taxes',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "servicePricings_aggregate_bool_exp_avg_arguments_columns" columns of table "servicePricings" */
export enum ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  BasePrice = 'basePrice',
  /** column name */
  MinimumDeposit = 'minimumDeposit'
}

/** select "servicePricings_aggregate_bool_exp_bool_and_arguments_columns" columns of table "servicePricings" */
export enum ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Taxes = 'taxes'
}

/** select "servicePricings_aggregate_bool_exp_bool_or_arguments_columns" columns of table "servicePricings" */
export enum ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Taxes = 'taxes'
}

/** select "servicePricings_aggregate_bool_exp_corr_arguments_columns" columns of table "servicePricings" */
export enum ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  BasePrice = 'basePrice',
  /** column name */
  MinimumDeposit = 'minimumDeposit'
}

/** select "servicePricings_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "servicePricings" */
export enum ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  BasePrice = 'basePrice',
  /** column name */
  MinimumDeposit = 'minimumDeposit'
}

/** select "servicePricings_aggregate_bool_exp_max_arguments_columns" columns of table "servicePricings" */
export enum ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  BasePrice = 'basePrice',
  /** column name */
  MinimumDeposit = 'minimumDeposit'
}

/** select "servicePricings_aggregate_bool_exp_min_arguments_columns" columns of table "servicePricings" */
export enum ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  BasePrice = 'basePrice',
  /** column name */
  MinimumDeposit = 'minimumDeposit'
}

/** select "servicePricings_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "servicePricings" */
export enum ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  BasePrice = 'basePrice',
  /** column name */
  MinimumDeposit = 'minimumDeposit'
}

/** select "servicePricings_aggregate_bool_exp_sum_arguments_columns" columns of table "servicePricings" */
export enum ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  BasePrice = 'basePrice',
  /** column name */
  MinimumDeposit = 'minimumDeposit'
}

/** select "servicePricings_aggregate_bool_exp_var_samp_arguments_columns" columns of table "servicePricings" */
export enum ServicePricings_Select_Column_ServicePricings_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  BasePrice = 'basePrice',
  /** column name */
  MinimumDeposit = 'minimumDeposit'
}

/** input type for updating data in table "servicePricings" */
export type ServicePricings_Set_Input = {
  basePrice?: InputMaybe<Scalars['float8']['input']>;
  checkoutPayment?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Currencies_Enum>;
  fees?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  minimumDeposit?: InputMaybe<Scalars['float8']['input']>;
  paymentFormat?: InputMaybe<PaymentFormat_Enum>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  taxes?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type ServicePricings_Stddev_Fields = {
  __typename?: 'servicePricings_stddev_fields';
  basePrice?: Maybe<Scalars['Float']['output']>;
  minimumDeposit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "servicePricings" */
export type ServicePricings_Stddev_Order_By = {
  basePrice?: InputMaybe<Order_By>;
  minimumDeposit?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ServicePricings_Stddev_Pop_Fields = {
  __typename?: 'servicePricings_stddev_pop_fields';
  basePrice?: Maybe<Scalars['Float']['output']>;
  minimumDeposit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "servicePricings" */
export type ServicePricings_Stddev_Pop_Order_By = {
  basePrice?: InputMaybe<Order_By>;
  minimumDeposit?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ServicePricings_Stddev_Samp_Fields = {
  __typename?: 'servicePricings_stddev_samp_fields';
  basePrice?: Maybe<Scalars['Float']['output']>;
  minimumDeposit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "servicePricings" */
export type ServicePricings_Stddev_Samp_Order_By = {
  basePrice?: InputMaybe<Order_By>;
  minimumDeposit?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "servicePricings" */
export type ServicePricings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServicePricings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServicePricings_Stream_Cursor_Value_Input = {
  basePrice?: InputMaybe<Scalars['float8']['input']>;
  checkoutPayment?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Currencies_Enum>;
  fees?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  minimumDeposit?: InputMaybe<Scalars['float8']['input']>;
  paymentFormat?: InputMaybe<PaymentFormat_Enum>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  taxes?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type ServicePricings_Sum_Fields = {
  __typename?: 'servicePricings_sum_fields';
  basePrice?: Maybe<Scalars['float8']['output']>;
  minimumDeposit?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "servicePricings" */
export type ServicePricings_Sum_Order_By = {
  basePrice?: InputMaybe<Order_By>;
  minimumDeposit?: InputMaybe<Order_By>;
};

/** update columns of table "servicePricings" */
export enum ServicePricings_Update_Column {
  /** column name */
  BasePrice = 'basePrice',
  /** column name */
  CheckoutPayment = 'checkoutPayment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  Fees = 'fees',
  /** column name */
  Id = 'id',
  /** column name */
  MinimumDeposit = 'minimumDeposit',
  /** column name */
  PaymentFormat = 'paymentFormat',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  Taxes = 'taxes',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ServicePricings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ServicePricings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ServicePricings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ServicePricings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ServicePricings_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ServicePricings_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ServicePricings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ServicePricings_Set_Input>;
  /** filter the rows which have to be updated */
  where: ServicePricings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ServicePricings_Var_Pop_Fields = {
  __typename?: 'servicePricings_var_pop_fields';
  basePrice?: Maybe<Scalars['Float']['output']>;
  minimumDeposit?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "servicePricings" */
export type ServicePricings_Var_Pop_Order_By = {
  basePrice?: InputMaybe<Order_By>;
  minimumDeposit?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ServicePricings_Var_Samp_Fields = {
  __typename?: 'servicePricings_var_samp_fields';
  basePrice?: Maybe<Scalars['Float']['output']>;
  minimumDeposit?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "servicePricings" */
export type ServicePricings_Var_Samp_Order_By = {
  basePrice?: InputMaybe<Order_By>;
  minimumDeposit?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ServicePricings_Variance_Fields = {
  __typename?: 'servicePricings_variance_fields';
  basePrice?: Maybe<Scalars['Float']['output']>;
  minimumDeposit?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "servicePricings" */
export type ServicePricings_Variance_Order_By = {
  basePrice?: InputMaybe<Order_By>;
  minimumDeposit?: InputMaybe<Order_By>;
};

/** columns and relationships of "serviceSectionOptionQuantityType" */
export type ServiceSectionOptionQuantityType = {
  __typename?: 'serviceSectionOptionQuantityType';
  /** An array relationship */
  serviceOptionSectionOptions: Array<ServiceOptionSectionOptions>;
  /** An aggregate relationship */
  serviceOptionSectionOptions_aggregate: ServiceOptionSectionOptions_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "serviceSectionOptionQuantityType" */
export type ServiceSectionOptionQuantityTypeServiceOptionSectionOptionsArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionSectionOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionSectionOptions_Order_By>>;
  where?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
};


/** columns and relationships of "serviceSectionOptionQuantityType" */
export type ServiceSectionOptionQuantityTypeServiceOptionSectionOptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionSectionOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionSectionOptions_Order_By>>;
  where?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
};

/** aggregated selection of "serviceSectionOptionQuantityType" */
export type ServiceSectionOptionQuantityType_Aggregate = {
  __typename?: 'serviceSectionOptionQuantityType_aggregate';
  aggregate?: Maybe<ServiceSectionOptionQuantityType_Aggregate_Fields>;
  nodes: Array<ServiceSectionOptionQuantityType>;
};

/** aggregate fields of "serviceSectionOptionQuantityType" */
export type ServiceSectionOptionQuantityType_Aggregate_Fields = {
  __typename?: 'serviceSectionOptionQuantityType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ServiceSectionOptionQuantityType_Max_Fields>;
  min?: Maybe<ServiceSectionOptionQuantityType_Min_Fields>;
};


/** aggregate fields of "serviceSectionOptionQuantityType" */
export type ServiceSectionOptionQuantityType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceSectionOptionQuantityType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "serviceSectionOptionQuantityType". All fields are combined with a logical 'AND'. */
export type ServiceSectionOptionQuantityType_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceSectionOptionQuantityType_Bool_Exp>>;
  _not?: InputMaybe<ServiceSectionOptionQuantityType_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceSectionOptionQuantityType_Bool_Exp>>;
  serviceOptionSectionOptions?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
  serviceOptionSectionOptions_aggregate?: InputMaybe<ServiceOptionSectionOptions_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "serviceSectionOptionQuantityType" */
export enum ServiceSectionOptionQuantityType_Constraint {
  /** unique or primary key constraint on columns "value" */
  ServiceSectionOptionQuantityTypePkey = 'serviceSectionOptionQuantityType_pkey'
}

export enum ServiceSectionOptionQuantityType_Enum {
  DefinedByUser = 'defined_by_user',
  NotDefined = 'not_defined'
}

/** Boolean expression to compare columns of type "serviceSectionOptionQuantityType_enum". All fields are combined with logical 'AND'. */
export type ServiceSectionOptionQuantityType_Enum_Comparison_Exp = {
  _eq?: InputMaybe<ServiceSectionOptionQuantityType_Enum>;
  _in?: InputMaybe<Array<ServiceSectionOptionQuantityType_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<ServiceSectionOptionQuantityType_Enum>;
  _nin?: InputMaybe<Array<ServiceSectionOptionQuantityType_Enum>>;
};

/** input type for inserting data into table "serviceSectionOptionQuantityType" */
export type ServiceSectionOptionQuantityType_Insert_Input = {
  serviceOptionSectionOptions?: InputMaybe<ServiceOptionSectionOptions_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ServiceSectionOptionQuantityType_Max_Fields = {
  __typename?: 'serviceSectionOptionQuantityType_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ServiceSectionOptionQuantityType_Min_Fields = {
  __typename?: 'serviceSectionOptionQuantityType_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "serviceSectionOptionQuantityType" */
export type ServiceSectionOptionQuantityType_Mutation_Response = {
  __typename?: 'serviceSectionOptionQuantityType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ServiceSectionOptionQuantityType>;
};

/** input type for inserting object relation for remote table "serviceSectionOptionQuantityType" */
export type ServiceSectionOptionQuantityType_Obj_Rel_Insert_Input = {
  data: ServiceSectionOptionQuantityType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceSectionOptionQuantityType_On_Conflict>;
};

/** on_conflict condition type for table "serviceSectionOptionQuantityType" */
export type ServiceSectionOptionQuantityType_On_Conflict = {
  constraint: ServiceSectionOptionQuantityType_Constraint;
  update_columns?: Array<ServiceSectionOptionQuantityType_Update_Column>;
  where?: InputMaybe<ServiceSectionOptionQuantityType_Bool_Exp>;
};

/** Ordering options when selecting data from "serviceSectionOptionQuantityType". */
export type ServiceSectionOptionQuantityType_Order_By = {
  serviceOptionSectionOptions_aggregate?: InputMaybe<ServiceOptionSectionOptions_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: serviceSectionOptionQuantityType */
export type ServiceSectionOptionQuantityType_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "serviceSectionOptionQuantityType" */
export enum ServiceSectionOptionQuantityType_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "serviceSectionOptionQuantityType" */
export type ServiceSectionOptionQuantityType_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "serviceSectionOptionQuantityType" */
export type ServiceSectionOptionQuantityType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceSectionOptionQuantityType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceSectionOptionQuantityType_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "serviceSectionOptionQuantityType" */
export enum ServiceSectionOptionQuantityType_Update_Column {
  /** column name */
  Value = 'value'
}

export type ServiceSectionOptionQuantityType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ServiceSectionOptionQuantityType_Set_Input>;
  /** filter the rows which have to be updated */
  where: ServiceSectionOptionQuantityType_Bool_Exp;
};

/** columns and relationships of "serviceSectionOptionType" */
export type ServiceSectionOptionType = {
  __typename?: 'serviceSectionOptionType';
  /** An array relationship */
  serviceOptionSections: Array<ServiceOptionSection>;
  /** An aggregate relationship */
  serviceOptionSections_aggregate: ServiceOptionSection_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "serviceSectionOptionType" */
export type ServiceSectionOptionTypeServiceOptionSectionsArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionSection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionSection_Order_By>>;
  where?: InputMaybe<ServiceOptionSection_Bool_Exp>;
};


/** columns and relationships of "serviceSectionOptionType" */
export type ServiceSectionOptionTypeServiceOptionSections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionSection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionSection_Order_By>>;
  where?: InputMaybe<ServiceOptionSection_Bool_Exp>;
};

/** aggregated selection of "serviceSectionOptionType" */
export type ServiceSectionOptionType_Aggregate = {
  __typename?: 'serviceSectionOptionType_aggregate';
  aggregate?: Maybe<ServiceSectionOptionType_Aggregate_Fields>;
  nodes: Array<ServiceSectionOptionType>;
};

/** aggregate fields of "serviceSectionOptionType" */
export type ServiceSectionOptionType_Aggregate_Fields = {
  __typename?: 'serviceSectionOptionType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ServiceSectionOptionType_Max_Fields>;
  min?: Maybe<ServiceSectionOptionType_Min_Fields>;
};


/** aggregate fields of "serviceSectionOptionType" */
export type ServiceSectionOptionType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceSectionOptionType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "serviceSectionOptionType". All fields are combined with a logical 'AND'. */
export type ServiceSectionOptionType_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceSectionOptionType_Bool_Exp>>;
  _not?: InputMaybe<ServiceSectionOptionType_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceSectionOptionType_Bool_Exp>>;
  serviceOptionSections?: InputMaybe<ServiceOptionSection_Bool_Exp>;
  serviceOptionSections_aggregate?: InputMaybe<ServiceOptionSection_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "serviceSectionOptionType" */
export enum ServiceSectionOptionType_Constraint {
  /** unique or primary key constraint on columns "value" */
  ServiceSectionOptionTypePkey = 'serviceSectionOptionType_pkey'
}

export enum ServiceSectionOptionType_Enum {
  MultipleChoice = 'multiple_choice',
  SingleChoice = 'single_choice'
}

/** Boolean expression to compare columns of type "serviceSectionOptionType_enum". All fields are combined with logical 'AND'. */
export type ServiceSectionOptionType_Enum_Comparison_Exp = {
  _eq?: InputMaybe<ServiceSectionOptionType_Enum>;
  _in?: InputMaybe<Array<ServiceSectionOptionType_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<ServiceSectionOptionType_Enum>;
  _nin?: InputMaybe<Array<ServiceSectionOptionType_Enum>>;
};

/** input type for inserting data into table "serviceSectionOptionType" */
export type ServiceSectionOptionType_Insert_Input = {
  serviceOptionSections?: InputMaybe<ServiceOptionSection_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ServiceSectionOptionType_Max_Fields = {
  __typename?: 'serviceSectionOptionType_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ServiceSectionOptionType_Min_Fields = {
  __typename?: 'serviceSectionOptionType_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "serviceSectionOptionType" */
export type ServiceSectionOptionType_Mutation_Response = {
  __typename?: 'serviceSectionOptionType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ServiceSectionOptionType>;
};

/** input type for inserting object relation for remote table "serviceSectionOptionType" */
export type ServiceSectionOptionType_Obj_Rel_Insert_Input = {
  data: ServiceSectionOptionType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceSectionOptionType_On_Conflict>;
};

/** on_conflict condition type for table "serviceSectionOptionType" */
export type ServiceSectionOptionType_On_Conflict = {
  constraint: ServiceSectionOptionType_Constraint;
  update_columns?: Array<ServiceSectionOptionType_Update_Column>;
  where?: InputMaybe<ServiceSectionOptionType_Bool_Exp>;
};

/** Ordering options when selecting data from "serviceSectionOptionType". */
export type ServiceSectionOptionType_Order_By = {
  serviceOptionSections_aggregate?: InputMaybe<ServiceOptionSection_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: serviceSectionOptionType */
export type ServiceSectionOptionType_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "serviceSectionOptionType" */
export enum ServiceSectionOptionType_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "serviceSectionOptionType" */
export type ServiceSectionOptionType_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "serviceSectionOptionType" */
export type ServiceSectionOptionType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceSectionOptionType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceSectionOptionType_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "serviceSectionOptionType" */
export enum ServiceSectionOptionType_Update_Column {
  /** column name */
  Value = 'value'
}

export type ServiceSectionOptionType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ServiceSectionOptionType_Set_Input>;
  /** filter the rows which have to be updated */
  where: ServiceSectionOptionType_Bool_Exp;
};

/** columns and relationships of "serviceStatus" */
export type ServiceStatus = {
  __typename?: 'serviceStatus';
  /** An array relationship */
  services: Array<Services>;
  /** An aggregate relationship */
  services_aggregate: Services_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "serviceStatus" */
export type ServiceStatusServicesArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


/** columns and relationships of "serviceStatus" */
export type ServiceStatusServices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};

/** aggregated selection of "serviceStatus" */
export type ServiceStatus_Aggregate = {
  __typename?: 'serviceStatus_aggregate';
  aggregate?: Maybe<ServiceStatus_Aggregate_Fields>;
  nodes: Array<ServiceStatus>;
};

/** aggregate fields of "serviceStatus" */
export type ServiceStatus_Aggregate_Fields = {
  __typename?: 'serviceStatus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ServiceStatus_Max_Fields>;
  min?: Maybe<ServiceStatus_Min_Fields>;
};


/** aggregate fields of "serviceStatus" */
export type ServiceStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "serviceStatus". All fields are combined with a logical 'AND'. */
export type ServiceStatus_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceStatus_Bool_Exp>>;
  _not?: InputMaybe<ServiceStatus_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceStatus_Bool_Exp>>;
  services?: InputMaybe<Services_Bool_Exp>;
  services_aggregate?: InputMaybe<Services_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "serviceStatus" */
export enum ServiceStatus_Constraint {
  /** unique or primary key constraint on columns "value" */
  ServiceStatusPkey = 'serviceStatus_pkey'
}

export enum ServiceStatus_Enum {
  Active = 'active',
  Draft = 'draft',
  Inactive = 'inactive',
  Pending = 'pending',
  Rejected = 'rejected'
}

/** Boolean expression to compare columns of type "serviceStatus_enum". All fields are combined with logical 'AND'. */
export type ServiceStatus_Enum_Comparison_Exp = {
  _eq?: InputMaybe<ServiceStatus_Enum>;
  _in?: InputMaybe<Array<ServiceStatus_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<ServiceStatus_Enum>;
  _nin?: InputMaybe<Array<ServiceStatus_Enum>>;
};

/** input type for inserting data into table "serviceStatus" */
export type ServiceStatus_Insert_Input = {
  services?: InputMaybe<Services_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ServiceStatus_Max_Fields = {
  __typename?: 'serviceStatus_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ServiceStatus_Min_Fields = {
  __typename?: 'serviceStatus_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "serviceStatus" */
export type ServiceStatus_Mutation_Response = {
  __typename?: 'serviceStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ServiceStatus>;
};

/** input type for inserting object relation for remote table "serviceStatus" */
export type ServiceStatus_Obj_Rel_Insert_Input = {
  data: ServiceStatus_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceStatus_On_Conflict>;
};

/** on_conflict condition type for table "serviceStatus" */
export type ServiceStatus_On_Conflict = {
  constraint: ServiceStatus_Constraint;
  update_columns?: Array<ServiceStatus_Update_Column>;
  where?: InputMaybe<ServiceStatus_Bool_Exp>;
};

/** Ordering options when selecting data from "serviceStatus". */
export type ServiceStatus_Order_By = {
  services_aggregate?: InputMaybe<Services_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: serviceStatus */
export type ServiceStatus_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "serviceStatus" */
export enum ServiceStatus_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "serviceStatus" */
export type ServiceStatus_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "serviceStatus" */
export type ServiceStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceStatus_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "serviceStatus" */
export enum ServiceStatus_Update_Column {
  /** column name */
  Value = 'value'
}

export type ServiceStatus_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ServiceStatus_Set_Input>;
  /** filter the rows which have to be updated */
  where: ServiceStatus_Bool_Exp;
};

/** columns and relationships of "services" */
export type Services = {
  __typename?: 'services';
  /** An array relationship */
  appointments: Array<Appointments>;
  /** An aggregate relationship */
  appointments_aggregate: Appointments_Aggregate;
  color: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  customerCanPickEmployee?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  duration?: Maybe<Scalars['numeric']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  maxBookings?: Maybe<Scalars['numeric']['output']>;
  name: Scalars['String']['output'];
  offTime?: Maybe<Scalars['numeric']['output']>;
  pictures?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  provider: Providers;
  providerId: Scalars['uuid']['output'];
  /** An array relationship */
  serviceEmployees: Array<ServiceEmployees>;
  /** An aggregate relationship */
  serviceEmployees_aggregate: ServiceEmployees_Aggregate;
  /** An array relationship */
  serviceOptions: Array<ServiceOptions>;
  /** An aggregate relationship */
  serviceOptions_aggregate: ServiceOptions_Aggregate;
  /** An object relationship */
  servicePicture?: Maybe<ServicePictures>;
  /** An array relationship */
  servicePictures: Array<ServicePictures>;
  /** An aggregate relationship */
  servicePictures_aggregate: ServicePictures_Aggregate;
  /** An object relationship */
  servicePricing?: Maybe<ServicePricings>;
  /** An array relationship */
  servicePricings: Array<ServicePricings>;
  /** An aggregate relationship */
  servicePricings_aggregate: ServicePricings_Aggregate;
  /** An object relationship */
  serviceStatus: ServiceStatus;
  /** An array relationship */
  servicesForms: Array<ServicesForms>;
  /** An aggregate relationship */
  servicesForms_aggregate: ServicesForms_Aggregate;
  sku: Scalars['String']['output'];
  status: ServiceStatus_Enum;
  /** An array relationship */
  timeouts: Array<Timeouts>;
  /** An aggregate relationship */
  timeouts_aggregate: Timeouts_Aggregate;
  /** An array relationship */
  unavailableServiceLocations: Array<UnavailableServiceLocations>;
  /** An aggregate relationship */
  unavailableServiceLocations_aggregate: UnavailableServiceLocations_Aggregate;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "services" */
export type ServicesAppointmentsArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesAppointments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesServiceEmployeesArgs = {
  distinct_on?: InputMaybe<Array<ServiceEmployees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceEmployees_Order_By>>;
  where?: InputMaybe<ServiceEmployees_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesServiceEmployees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceEmployees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceEmployees_Order_By>>;
  where?: InputMaybe<ServiceEmployees_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesServiceOptionsArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptions_Order_By>>;
  where?: InputMaybe<ServiceOptions_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesServiceOptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptions_Order_By>>;
  where?: InputMaybe<ServiceOptions_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesServicePicturesArgs = {
  distinct_on?: InputMaybe<Array<ServicePictures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicePictures_Order_By>>;
  where?: InputMaybe<ServicePictures_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesServicePictures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServicePictures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicePictures_Order_By>>;
  where?: InputMaybe<ServicePictures_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesServicePricingsArgs = {
  distinct_on?: InputMaybe<Array<ServicePricings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicePricings_Order_By>>;
  where?: InputMaybe<ServicePricings_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesServicePricings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServicePricings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicePricings_Order_By>>;
  where?: InputMaybe<ServicePricings_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesServicesFormsArgs = {
  distinct_on?: InputMaybe<Array<ServicesForms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicesForms_Order_By>>;
  where?: InputMaybe<ServicesForms_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesServicesForms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServicesForms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicesForms_Order_By>>;
  where?: InputMaybe<ServicesForms_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesTimeoutsArgs = {
  distinct_on?: InputMaybe<Array<Timeouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Timeouts_Order_By>>;
  where?: InputMaybe<Timeouts_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesTimeouts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Timeouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Timeouts_Order_By>>;
  where?: InputMaybe<Timeouts_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesUnavailableServiceLocationsArgs = {
  distinct_on?: InputMaybe<Array<UnavailableServiceLocations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnavailableServiceLocations_Order_By>>;
  where?: InputMaybe<UnavailableServiceLocations_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesUnavailableServiceLocations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UnavailableServiceLocations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnavailableServiceLocations_Order_By>>;
  where?: InputMaybe<UnavailableServiceLocations_Bool_Exp>;
};

/** columns and relationships of "servicesForms" */
export type ServicesForms = {
  __typename?: 'servicesForms';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  form: Form;
  formId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  service: Services;
  /** An object relationship */
  serviceFormStatus: ServiceFormStatus;
  serviceId: Scalars['uuid']['output'];
  status: ServiceFormStatus_Enum;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "servicesForms" */
export type ServicesForms_Aggregate = {
  __typename?: 'servicesForms_aggregate';
  aggregate?: Maybe<ServicesForms_Aggregate_Fields>;
  nodes: Array<ServicesForms>;
};

export type ServicesForms_Aggregate_Bool_Exp = {
  count?: InputMaybe<ServicesForms_Aggregate_Bool_Exp_Count>;
};

export type ServicesForms_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ServicesForms_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServicesForms_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "servicesForms" */
export type ServicesForms_Aggregate_Fields = {
  __typename?: 'servicesForms_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ServicesForms_Max_Fields>;
  min?: Maybe<ServicesForms_Min_Fields>;
};


/** aggregate fields of "servicesForms" */
export type ServicesForms_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServicesForms_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "servicesForms" */
export type ServicesForms_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ServicesForms_Max_Order_By>;
  min?: InputMaybe<ServicesForms_Min_Order_By>;
};

/** input type for inserting array relation for remote table "servicesForms" */
export type ServicesForms_Arr_Rel_Insert_Input = {
  data: Array<ServicesForms_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ServicesForms_On_Conflict>;
};

/** Boolean expression to filter rows from the table "servicesForms". All fields are combined with a logical 'AND'. */
export type ServicesForms_Bool_Exp = {
  _and?: InputMaybe<Array<ServicesForms_Bool_Exp>>;
  _not?: InputMaybe<ServicesForms_Bool_Exp>;
  _or?: InputMaybe<Array<ServicesForms_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  form?: InputMaybe<Form_Bool_Exp>;
  formId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  service?: InputMaybe<Services_Bool_Exp>;
  serviceFormStatus?: InputMaybe<ServiceFormStatus_Bool_Exp>;
  serviceId?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<ServiceFormStatus_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "servicesForms" */
export enum ServicesForms_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServicesFormsPkey = 'servicesForms_pkey'
}

/** input type for inserting data into table "servicesForms" */
export type ServicesForms_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  form?: InputMaybe<Form_Obj_Rel_Insert_Input>;
  formId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  service?: InputMaybe<Services_Obj_Rel_Insert_Input>;
  serviceFormStatus?: InputMaybe<ServiceFormStatus_Obj_Rel_Insert_Input>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<ServiceFormStatus_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ServicesForms_Max_Fields = {
  __typename?: 'servicesForms_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  formId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  serviceId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "servicesForms" */
export type ServicesForms_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  formId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ServicesForms_Min_Fields = {
  __typename?: 'servicesForms_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  formId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  serviceId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "servicesForms" */
export type ServicesForms_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  formId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "servicesForms" */
export type ServicesForms_Mutation_Response = {
  __typename?: 'servicesForms_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ServicesForms>;
};

/** on_conflict condition type for table "servicesForms" */
export type ServicesForms_On_Conflict = {
  constraint: ServicesForms_Constraint;
  update_columns?: Array<ServicesForms_Update_Column>;
  where?: InputMaybe<ServicesForms_Bool_Exp>;
};

/** Ordering options when selecting data from "servicesForms". */
export type ServicesForms_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  form?: InputMaybe<Form_Order_By>;
  formId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  service?: InputMaybe<Services_Order_By>;
  serviceFormStatus?: InputMaybe<ServiceFormStatus_Order_By>;
  serviceId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: servicesForms */
export type ServicesForms_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "servicesForms" */
export enum ServicesForms_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FormId = 'formId',
  /** column name */
  Id = 'id',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "servicesForms" */
export type ServicesForms_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  formId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<ServiceFormStatus_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "servicesForms" */
export type ServicesForms_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServicesForms_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServicesForms_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  formId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<ServiceFormStatus_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "servicesForms" */
export enum ServicesForms_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FormId = 'formId',
  /** column name */
  Id = 'id',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ServicesForms_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ServicesForms_Set_Input>;
  /** filter the rows which have to be updated */
  where: ServicesForms_Bool_Exp;
};

/** aggregated selection of "services" */
export type Services_Aggregate = {
  __typename?: 'services_aggregate';
  aggregate?: Maybe<Services_Aggregate_Fields>;
  nodes: Array<Services>;
};

export type Services_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Services_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Services_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Services_Aggregate_Bool_Exp_Count>;
};

export type Services_Aggregate_Bool_Exp_Bool_And = {
  arguments: Services_Select_Column_Services_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Services_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Services_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Services_Select_Column_Services_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Services_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Services_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Services_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Services_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "services" */
export type Services_Aggregate_Fields = {
  __typename?: 'services_aggregate_fields';
  avg?: Maybe<Services_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Services_Max_Fields>;
  min?: Maybe<Services_Min_Fields>;
  stddev?: Maybe<Services_Stddev_Fields>;
  stddev_pop?: Maybe<Services_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Services_Stddev_Samp_Fields>;
  sum?: Maybe<Services_Sum_Fields>;
  var_pop?: Maybe<Services_Var_Pop_Fields>;
  var_samp?: Maybe<Services_Var_Samp_Fields>;
  variance?: Maybe<Services_Variance_Fields>;
};


/** aggregate fields of "services" */
export type Services_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Services_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "services" */
export type Services_Aggregate_Order_By = {
  avg?: InputMaybe<Services_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Services_Max_Order_By>;
  min?: InputMaybe<Services_Min_Order_By>;
  stddev?: InputMaybe<Services_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Services_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Services_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Services_Sum_Order_By>;
  var_pop?: InputMaybe<Services_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Services_Var_Samp_Order_By>;
  variance?: InputMaybe<Services_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "services" */
export type Services_Arr_Rel_Insert_Input = {
  data: Array<Services_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Services_On_Conflict>;
};

/** aggregate avg on columns */
export type Services_Avg_Fields = {
  __typename?: 'services_avg_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  maxBookings?: Maybe<Scalars['Float']['output']>;
  offTime?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "services" */
export type Services_Avg_Order_By = {
  duration?: InputMaybe<Order_By>;
  maxBookings?: InputMaybe<Order_By>;
  offTime?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "services". All fields are combined with a logical 'AND'. */
export type Services_Bool_Exp = {
  _and?: InputMaybe<Array<Services_Bool_Exp>>;
  _not?: InputMaybe<Services_Bool_Exp>;
  _or?: InputMaybe<Array<Services_Bool_Exp>>;
  appointments?: InputMaybe<Appointments_Bool_Exp>;
  appointments_aggregate?: InputMaybe<Appointments_Aggregate_Bool_Exp>;
  color?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  customerCanPickEmployee?: InputMaybe<Boolean_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  duration?: InputMaybe<Numeric_Comparison_Exp>;
  featured?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  maxBookings?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  offTime?: InputMaybe<Numeric_Comparison_Exp>;
  pictures?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<Providers_Bool_Exp>;
  providerId?: InputMaybe<Uuid_Comparison_Exp>;
  serviceEmployees?: InputMaybe<ServiceEmployees_Bool_Exp>;
  serviceEmployees_aggregate?: InputMaybe<ServiceEmployees_Aggregate_Bool_Exp>;
  serviceOptions?: InputMaybe<ServiceOptions_Bool_Exp>;
  serviceOptions_aggregate?: InputMaybe<ServiceOptions_Aggregate_Bool_Exp>;
  servicePicture?: InputMaybe<ServicePictures_Bool_Exp>;
  servicePictures?: InputMaybe<ServicePictures_Bool_Exp>;
  servicePictures_aggregate?: InputMaybe<ServicePictures_Aggregate_Bool_Exp>;
  servicePricing?: InputMaybe<ServicePricings_Bool_Exp>;
  servicePricings?: InputMaybe<ServicePricings_Bool_Exp>;
  servicePricings_aggregate?: InputMaybe<ServicePricings_Aggregate_Bool_Exp>;
  serviceStatus?: InputMaybe<ServiceStatus_Bool_Exp>;
  servicesForms?: InputMaybe<ServicesForms_Bool_Exp>;
  servicesForms_aggregate?: InputMaybe<ServicesForms_Aggregate_Bool_Exp>;
  sku?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<ServiceStatus_Enum_Comparison_Exp>;
  timeouts?: InputMaybe<Timeouts_Bool_Exp>;
  timeouts_aggregate?: InputMaybe<Timeouts_Aggregate_Bool_Exp>;
  unavailableServiceLocations?: InputMaybe<UnavailableServiceLocations_Bool_Exp>;
  unavailableServiceLocations_aggregate?: InputMaybe<UnavailableServiceLocations_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "services" */
export enum Services_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServicesPkey = 'services_pkey',
  /** unique or primary key constraint on columns "providerId", "sku" */
  ServicesUniqueSkuProvideridDeletedat = 'services_unique_sku_providerid_deletedat'
}

/** input type for incrementing numeric columns in table "services" */
export type Services_Inc_Input = {
  duration?: InputMaybe<Scalars['numeric']['input']>;
  maxBookings?: InputMaybe<Scalars['numeric']['input']>;
  offTime?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "services" */
export type Services_Insert_Input = {
  appointments?: InputMaybe<Appointments_Arr_Rel_Insert_Input>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customerCanPickEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['numeric']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  maxBookings?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offTime?: InputMaybe<Scalars['numeric']['input']>;
  pictures?: InputMaybe<Scalars['uuid']['input']>;
  provider?: InputMaybe<Providers_Obj_Rel_Insert_Input>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  serviceEmployees?: InputMaybe<ServiceEmployees_Arr_Rel_Insert_Input>;
  serviceOptions?: InputMaybe<ServiceOptions_Arr_Rel_Insert_Input>;
  servicePicture?: InputMaybe<ServicePictures_Obj_Rel_Insert_Input>;
  servicePictures?: InputMaybe<ServicePictures_Arr_Rel_Insert_Input>;
  servicePricing?: InputMaybe<ServicePricings_Obj_Rel_Insert_Input>;
  servicePricings?: InputMaybe<ServicePricings_Arr_Rel_Insert_Input>;
  serviceStatus?: InputMaybe<ServiceStatus_Obj_Rel_Insert_Input>;
  servicesForms?: InputMaybe<ServicesForms_Arr_Rel_Insert_Input>;
  sku?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ServiceStatus_Enum>;
  timeouts?: InputMaybe<Timeouts_Arr_Rel_Insert_Input>;
  unavailableServiceLocations?: InputMaybe<UnavailableServiceLocations_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Services_Max_Fields = {
  __typename?: 'services_max_fields';
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  maxBookings?: Maybe<Scalars['numeric']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offTime?: Maybe<Scalars['numeric']['output']>;
  pictures?: Maybe<Scalars['uuid']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "services" */
export type Services_Max_Order_By = {
  color?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  maxBookings?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  offTime?: InputMaybe<Order_By>;
  pictures?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Services_Min_Fields = {
  __typename?: 'services_min_fields';
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  maxBookings?: Maybe<Scalars['numeric']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offTime?: Maybe<Scalars['numeric']['output']>;
  pictures?: Maybe<Scalars['uuid']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "services" */
export type Services_Min_Order_By = {
  color?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  maxBookings?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  offTime?: InputMaybe<Order_By>;
  pictures?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "services" */
export type Services_Mutation_Response = {
  __typename?: 'services_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Services>;
};

/** input type for inserting object relation for remote table "services" */
export type Services_Obj_Rel_Insert_Input = {
  data: Services_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Services_On_Conflict>;
};

/** on_conflict condition type for table "services" */
export type Services_On_Conflict = {
  constraint: Services_Constraint;
  update_columns?: Array<Services_Update_Column>;
  where?: InputMaybe<Services_Bool_Exp>;
};

/** Ordering options when selecting data from "services". */
export type Services_Order_By = {
  appointments_aggregate?: InputMaybe<Appointments_Aggregate_Order_By>;
  color?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  customerCanPickEmployee?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  featured?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  maxBookings?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  offTime?: InputMaybe<Order_By>;
  pictures?: InputMaybe<Order_By>;
  provider?: InputMaybe<Providers_Order_By>;
  providerId?: InputMaybe<Order_By>;
  serviceEmployees_aggregate?: InputMaybe<ServiceEmployees_Aggregate_Order_By>;
  serviceOptions_aggregate?: InputMaybe<ServiceOptions_Aggregate_Order_By>;
  servicePicture?: InputMaybe<ServicePictures_Order_By>;
  servicePictures_aggregate?: InputMaybe<ServicePictures_Aggregate_Order_By>;
  servicePricing?: InputMaybe<ServicePricings_Order_By>;
  servicePricings_aggregate?: InputMaybe<ServicePricings_Aggregate_Order_By>;
  serviceStatus?: InputMaybe<ServiceStatus_Order_By>;
  servicesForms_aggregate?: InputMaybe<ServicesForms_Aggregate_Order_By>;
  sku?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  timeouts_aggregate?: InputMaybe<Timeouts_Aggregate_Order_By>;
  unavailableServiceLocations_aggregate?: InputMaybe<UnavailableServiceLocations_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: services */
export type Services_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "services" */
export enum Services_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerCanPickEmployee = 'customerCanPickEmployee',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Duration = 'duration',
  /** column name */
  Featured = 'featured',
  /** column name */
  Id = 'id',
  /** column name */
  MaxBookings = 'maxBookings',
  /** column name */
  Name = 'name',
  /** column name */
  OffTime = 'offTime',
  /** column name */
  Pictures = 'pictures',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  Sku = 'sku',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "services_aggregate_bool_exp_bool_and_arguments_columns" columns of table "services" */
export enum Services_Select_Column_Services_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CustomerCanPickEmployee = 'customerCanPickEmployee',
  /** column name */
  Featured = 'featured'
}

/** select "services_aggregate_bool_exp_bool_or_arguments_columns" columns of table "services" */
export enum Services_Select_Column_Services_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CustomerCanPickEmployee = 'customerCanPickEmployee',
  /** column name */
  Featured = 'featured'
}

/** input type for updating data in table "services" */
export type Services_Set_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customerCanPickEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['numeric']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  maxBookings?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offTime?: InputMaybe<Scalars['numeric']['input']>;
  pictures?: InputMaybe<Scalars['uuid']['input']>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ServiceStatus_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Services_Stddev_Fields = {
  __typename?: 'services_stddev_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  maxBookings?: Maybe<Scalars['Float']['output']>;
  offTime?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "services" */
export type Services_Stddev_Order_By = {
  duration?: InputMaybe<Order_By>;
  maxBookings?: InputMaybe<Order_By>;
  offTime?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Services_Stddev_Pop_Fields = {
  __typename?: 'services_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  maxBookings?: Maybe<Scalars['Float']['output']>;
  offTime?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "services" */
export type Services_Stddev_Pop_Order_By = {
  duration?: InputMaybe<Order_By>;
  maxBookings?: InputMaybe<Order_By>;
  offTime?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Services_Stddev_Samp_Fields = {
  __typename?: 'services_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  maxBookings?: Maybe<Scalars['Float']['output']>;
  offTime?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "services" */
export type Services_Stddev_Samp_Order_By = {
  duration?: InputMaybe<Order_By>;
  maxBookings?: InputMaybe<Order_By>;
  offTime?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "services" */
export type Services_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Services_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Services_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customerCanPickEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['numeric']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  maxBookings?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offTime?: InputMaybe<Scalars['numeric']['input']>;
  pictures?: InputMaybe<Scalars['uuid']['input']>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ServiceStatus_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Services_Sum_Fields = {
  __typename?: 'services_sum_fields';
  duration?: Maybe<Scalars['numeric']['output']>;
  maxBookings?: Maybe<Scalars['numeric']['output']>;
  offTime?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "services" */
export type Services_Sum_Order_By = {
  duration?: InputMaybe<Order_By>;
  maxBookings?: InputMaybe<Order_By>;
  offTime?: InputMaybe<Order_By>;
};

/** update columns of table "services" */
export enum Services_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerCanPickEmployee = 'customerCanPickEmployee',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Duration = 'duration',
  /** column name */
  Featured = 'featured',
  /** column name */
  Id = 'id',
  /** column name */
  MaxBookings = 'maxBookings',
  /** column name */
  Name = 'name',
  /** column name */
  OffTime = 'offTime',
  /** column name */
  Pictures = 'pictures',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  Sku = 'sku',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Services_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Services_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Services_Set_Input>;
  /** filter the rows which have to be updated */
  where: Services_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Services_Var_Pop_Fields = {
  __typename?: 'services_var_pop_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  maxBookings?: Maybe<Scalars['Float']['output']>;
  offTime?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "services" */
export type Services_Var_Pop_Order_By = {
  duration?: InputMaybe<Order_By>;
  maxBookings?: InputMaybe<Order_By>;
  offTime?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Services_Var_Samp_Fields = {
  __typename?: 'services_var_samp_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  maxBookings?: Maybe<Scalars['Float']['output']>;
  offTime?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "services" */
export type Services_Var_Samp_Order_By = {
  duration?: InputMaybe<Order_By>;
  maxBookings?: InputMaybe<Order_By>;
  offTime?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Services_Variance_Fields = {
  __typename?: 'services_variance_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  maxBookings?: Maybe<Scalars['Float']['output']>;
  offTime?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "services" */
export type Services_Variance_Order_By = {
  duration?: InputMaybe<Order_By>;
  maxBookings?: InputMaybe<Order_By>;
  offTime?: InputMaybe<Order_By>;
};

/** columns and relationships of "sessions" */
export type Sessions = {
  __typename?: 'sessions';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "sessions" */
export type Sessions_Aggregate = {
  __typename?: 'sessions_aggregate';
  aggregate?: Maybe<Sessions_Aggregate_Fields>;
  nodes: Array<Sessions>;
};

export type Sessions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Sessions_Aggregate_Bool_Exp_Count>;
};

export type Sessions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sessions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sessions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sessions" */
export type Sessions_Aggregate_Fields = {
  __typename?: 'sessions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Sessions_Max_Fields>;
  min?: Maybe<Sessions_Min_Fields>;
};


/** aggregate fields of "sessions" */
export type Sessions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sessions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sessions" */
export type Sessions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sessions_Max_Order_By>;
  min?: InputMaybe<Sessions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "sessions" */
export type Sessions_Arr_Rel_Insert_Input = {
  data: Array<Sessions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sessions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "sessions". All fields are combined with a logical 'AND'. */
export type Sessions_Bool_Exp = {
  _and?: InputMaybe<Array<Sessions_Bool_Exp>>;
  _not?: InputMaybe<Sessions_Bool_Exp>;
  _or?: InputMaybe<Array<Sessions_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  refreshToken?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "sessions" */
export enum Sessions_Constraint {
  /** unique or primary key constraint on columns "id" */
  SessionsPkey = 'sessions_pkey'
}

/** input type for inserting data into table "sessions" */
export type Sessions_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Sessions_Max_Fields = {
  __typename?: 'sessions_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "sessions" */
export type Sessions_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sessions_Min_Fields = {
  __typename?: 'sessions_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "sessions" */
export type Sessions_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sessions" */
export type Sessions_Mutation_Response = {
  __typename?: 'sessions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sessions>;
};

/** input type for inserting object relation for remote table "sessions" */
export type Sessions_Obj_Rel_Insert_Input = {
  data: Sessions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sessions_On_Conflict>;
};

/** on_conflict condition type for table "sessions" */
export type Sessions_On_Conflict = {
  constraint: Sessions_Constraint;
  update_columns?: Array<Sessions_Update_Column>;
  where?: InputMaybe<Sessions_Bool_Exp>;
};

/** Ordering options when selecting data from "sessions". */
export type Sessions_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sessions */
export type Sessions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "sessions" */
export enum Sessions_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "sessions" */
export type Sessions_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "sessions" */
export type Sessions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sessions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sessions_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "sessions" */
export enum Sessions_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UserId = 'userId'
}

export type Sessions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sessions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sessions_Bool_Exp;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geography']['input'];
  use_spheroid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geometry']['input'];
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "appointmentPricing" */
  appointmentPricing: Array<AppointmentPricing>;
  /** fetch aggregated fields from the table: "appointmentPricing" */
  appointmentPricing_aggregate: AppointmentPricing_Aggregate;
  /** fetch data from the table: "appointmentPricing" using primary key columns */
  appointmentPricing_by_pk?: Maybe<AppointmentPricing>;
  /** fetch data from the table in a streaming manner: "appointmentPricing" */
  appointmentPricing_stream: Array<AppointmentPricing>;
  /** An array relationship */
  appointments: Array<Appointments>;
  /** An aggregate relationship */
  appointments_aggregate: Appointments_Aggregate;
  /** fetch data from the table: "appointments" using primary key columns */
  appointments_by_pk?: Maybe<Appointments>;
  /** fetch data from the table in a streaming manner: "appointments" */
  appointments_stream: Array<Appointments>;
  /** fetch data from the table: "bookingStatus" */
  bookingStatus: Array<BookingStatus>;
  /** fetch aggregated fields from the table: "bookingStatus" */
  bookingStatus_aggregate: BookingStatus_Aggregate;
  /** fetch data from the table: "bookingStatus" using primary key columns */
  bookingStatus_by_pk?: Maybe<BookingStatus>;
  /** fetch data from the table in a streaming manner: "bookingStatus" */
  bookingStatus_stream: Array<BookingStatus>;
  /** An array relationship */
  buildingProviders: Array<BuildingProviders>;
  /** An aggregate relationship */
  buildingProviders_aggregate: BuildingProviders_Aggregate;
  /** fetch data from the table: "buildingProviders" using primary key columns */
  buildingProviders_by_pk?: Maybe<BuildingProviders>;
  /** fetch data from the table in a streaming manner: "buildingProviders" */
  buildingProviders_stream: Array<BuildingProviders>;
  /** fetch data from the table: "buildingType" */
  buildingType: Array<BuildingType>;
  /** fetch aggregated fields from the table: "buildingType" */
  buildingType_aggregate: BuildingType_Aggregate;
  /** fetch data from the table: "buildingType" using primary key columns */
  buildingType_by_pk?: Maybe<BuildingType>;
  /** fetch data from the table in a streaming manner: "buildingType" */
  buildingType_stream: Array<BuildingType>;
  /** fetch data from the table: "checkoutSessions" */
  checkoutSessions: Array<CheckoutSessions>;
  /** fetch aggregated fields from the table: "checkoutSessions" */
  checkoutSessions_aggregate: CheckoutSessions_Aggregate;
  /** fetch data from the table: "checkoutSessions" using primary key columns */
  checkoutSessions_by_pk?: Maybe<CheckoutSessions>;
  /** fetch data from the table in a streaming manner: "checkoutSessions" */
  checkoutSessions_stream: Array<CheckoutSessions>;
  /** fetch data from the table: "currencies" */
  currencies: Array<Currencies>;
  /** fetch aggregated fields from the table: "currencies" */
  currencies_aggregate: Currencies_Aggregate;
  /** fetch data from the table: "currencies" using primary key columns */
  currencies_by_pk?: Maybe<Currencies>;
  /** fetch data from the table in a streaming manner: "currencies" */
  currencies_stream: Array<Currencies>;
  /** fetch data from the table: "customerAmountSpent" */
  customerAmountSpent: Array<CustomerAmountSpent>;
  /** fetch aggregated fields from the table: "customerAmountSpent" */
  customerAmountSpent_aggregate: CustomerAmountSpent_Aggregate;
  /** fetch data from the table in a streaming manner: "customerAmountSpent" */
  customerAmountSpent_stream: Array<CustomerAmountSpent>;
  /** An array relationship */
  customers: Array<Customers>;
  /** An aggregate relationship */
  customers_aggregate: Customers_Aggregate;
  /** fetch data from the table: "customers" using primary key columns */
  customers_by_pk?: Maybe<Customers>;
  /** fetch data from the table in a streaming manner: "customers" */
  customers_stream: Array<Customers>;
  /** fetch data from the table: "entityType" */
  entityType: Array<EntityType>;
  /** fetch aggregated fields from the table: "entityType" */
  entityType_aggregate: EntityType_Aggregate;
  /** fetch data from the table: "entityType" using primary key columns */
  entityType_by_pk?: Maybe<EntityType>;
  /** fetch data from the table in a streaming manner: "entityType" */
  entityType_stream: Array<EntityType>;
  /** fetch data from the table: "files" */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "files" */
  files_aggregate: Files_Aggregate;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: Maybe<Files>;
  /** fetch data from the table in a streaming manner: "files" */
  files_stream: Array<Files>;
  /** fetch data from the table: "form" */
  form: Array<Form>;
  /** An array relationship */
  formAnswers: Array<FormAnswers>;
  /** An aggregate relationship */
  formAnswers_aggregate: FormAnswers_Aggregate;
  /** fetch data from the table: "formAnswers" using primary key columns */
  formAnswers_by_pk?: Maybe<FormAnswers>;
  /** fetch data from the table in a streaming manner: "formAnswers" */
  formAnswers_stream: Array<FormAnswers>;
  /** An array relationship */
  formQuestionOptions: Array<FormQuestionOptions>;
  /** An aggregate relationship */
  formQuestionOptions_aggregate: FormQuestionOptions_Aggregate;
  /** fetch data from the table: "formQuestionOptions" using primary key columns */
  formQuestionOptions_by_pk?: Maybe<FormQuestionOptions>;
  /** fetch data from the table in a streaming manner: "formQuestionOptions" */
  formQuestionOptions_stream: Array<FormQuestionOptions>;
  /** fetch data from the table: "formQuestionType" */
  formQuestionType: Array<FormQuestionType>;
  /** fetch aggregated fields from the table: "formQuestionType" */
  formQuestionType_aggregate: FormQuestionType_Aggregate;
  /** fetch data from the table: "formQuestionType" using primary key columns */
  formQuestionType_by_pk?: Maybe<FormQuestionType>;
  /** fetch data from the table in a streaming manner: "formQuestionType" */
  formQuestionType_stream: Array<FormQuestionType>;
  /** An array relationship */
  formQuestions: Array<FormQuestions>;
  /** An aggregate relationship */
  formQuestions_aggregate: FormQuestions_Aggregate;
  /** fetch data from the table: "formQuestions" using primary key columns */
  formQuestions_by_pk?: Maybe<FormQuestions>;
  /** fetch data from the table in a streaming manner: "formQuestions" */
  formQuestions_stream: Array<FormQuestions>;
  /** fetch aggregated fields from the table: "form" */
  form_aggregate: Form_Aggregate;
  /** fetch data from the table: "form" using primary key columns */
  form_by_pk?: Maybe<Form>;
  /** fetch data from the table in a streaming manner: "form" */
  form_stream: Array<Form>;
  /** execute function "get_nearby_locations" which returns "locations_with_distance" */
  get_nearby_locations: Array<Locations_With_Distance>;
  /** execute function "get_nearby_locations" and query aggregates on result of table type "locations_with_distance" */
  get_nearby_locations_aggregate: Locations_With_Distance_Aggregate;
  /** fetch data from the table: "jobStatus" */
  jobStatus: Array<JobStatus>;
  /** fetch aggregated fields from the table: "jobStatus" */
  jobStatus_aggregate: JobStatus_Aggregate;
  /** fetch data from the table: "jobStatus" using primary key columns */
  jobStatus_by_pk?: Maybe<JobStatus>;
  /** fetch data from the table in a streaming manner: "jobStatus" */
  jobStatus_stream: Array<JobStatus>;
  /** fetch data from the table: "locale" */
  locale: Array<Locale>;
  /** fetch aggregated fields from the table: "locale" */
  locale_aggregate: Locale_Aggregate;
  /** fetch data from the table: "locale" using primary key columns */
  locale_by_pk?: Maybe<Locale>;
  /** fetch data from the table in a streaming manner: "locale" */
  locale_stream: Array<Locale>;
  /** fetch data from the table: "locationStatus" */
  locationStatus: Array<LocationStatus>;
  /** fetch aggregated fields from the table: "locationStatus" */
  locationStatus_aggregate: LocationStatus_Aggregate;
  /** fetch data from the table: "locationStatus" using primary key columns */
  locationStatus_by_pk?: Maybe<LocationStatus>;
  /** fetch data from the table in a streaming manner: "locationStatus" */
  locationStatus_stream: Array<LocationStatus>;
  /** fetch data from the table: "locationType" */
  locationType: Array<LocationType>;
  /** fetch aggregated fields from the table: "locationType" */
  locationType_aggregate: LocationType_Aggregate;
  /** fetch data from the table: "locationType" using primary key columns */
  locationType_by_pk?: Maybe<LocationType>;
  /** fetch data from the table in a streaming manner: "locationType" */
  locationType_stream: Array<LocationType>;
  /** An array relationship */
  locations: Array<Locations>;
  /** An aggregate relationship */
  locations_aggregate: Locations_Aggregate;
  /** fetch data from the table: "locations" using primary key columns */
  locations_by_pk?: Maybe<Locations>;
  /** fetch data from the table in a streaming manner: "locations" */
  locations_stream: Array<Locations>;
  /** fetch data from the table: "locations_with_distance" */
  locations_with_distance: Array<Locations_With_Distance>;
  /** fetch aggregated fields from the table: "locations_with_distance" */
  locations_with_distance_aggregate: Locations_With_Distance_Aggregate;
  /** fetch data from the table in a streaming manner: "locations_with_distance" */
  locations_with_distance_stream: Array<Locations_With_Distance>;
  /** fetch data from the table: "notificationType" */
  notificationType: Array<NotificationType>;
  /** fetch aggregated fields from the table: "notificationType" */
  notificationType_aggregate: NotificationType_Aggregate;
  /** fetch data from the table: "notificationType" using primary key columns */
  notificationType_by_pk?: Maybe<NotificationType>;
  /** fetch data from the table in a streaming manner: "notificationType" */
  notificationType_stream: Array<NotificationType>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** fetch data from the table in a streaming manner: "notifications" */
  notifications_stream: Array<Notifications>;
  /** fetch data from the table: "partnershipSchedulingType" */
  partnershipSchedulingType: Array<PartnershipSchedulingType>;
  /** fetch aggregated fields from the table: "partnershipSchedulingType" */
  partnershipSchedulingType_aggregate: PartnershipSchedulingType_Aggregate;
  /** fetch data from the table: "partnershipSchedulingType" using primary key columns */
  partnershipSchedulingType_by_pk?: Maybe<PartnershipSchedulingType>;
  /** fetch data from the table in a streaming manner: "partnershipSchedulingType" */
  partnershipSchedulingType_stream: Array<PartnershipSchedulingType>;
  /** fetch data from the table: "partnershipStatus" */
  partnershipStatus: Array<PartnershipStatus>;
  /** fetch aggregated fields from the table: "partnershipStatus" */
  partnershipStatus_aggregate: PartnershipStatus_Aggregate;
  /** fetch data from the table: "partnershipStatus" using primary key columns */
  partnershipStatus_by_pk?: Maybe<PartnershipStatus>;
  /** fetch data from the table in a streaming manner: "partnershipStatus" */
  partnershipStatus_stream: Array<PartnershipStatus>;
  /** fetch data from the table: "paymentFormat" */
  paymentFormat: Array<PaymentFormat>;
  /** fetch aggregated fields from the table: "paymentFormat" */
  paymentFormat_aggregate: PaymentFormat_Aggregate;
  /** fetch data from the table: "paymentFormat" using primary key columns */
  paymentFormat_by_pk?: Maybe<PaymentFormat>;
  /** fetch data from the table in a streaming manner: "paymentFormat" */
  paymentFormat_stream: Array<PaymentFormat>;
  /** fetch data from the table: "paymentStatus" */
  paymentStatus: Array<PaymentStatus>;
  /** fetch aggregated fields from the table: "paymentStatus" */
  paymentStatus_aggregate: PaymentStatus_Aggregate;
  /** fetch data from the table: "paymentStatus" using primary key columns */
  paymentStatus_by_pk?: Maybe<PaymentStatus>;
  /** fetch data from the table in a streaming manner: "paymentStatus" */
  paymentStatus_stream: Array<PaymentStatus>;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  /** fetch data from the table: "payments" using primary key columns */
  payments_by_pk?: Maybe<Payments>;
  /** fetch data from the table in a streaming manner: "payments" */
  payments_stream: Array<Payments>;
  /** fetch data from the table: "providerCategory" */
  providerCategory: Array<ProviderCategory>;
  /** fetch aggregated fields from the table: "providerCategory" */
  providerCategory_aggregate: ProviderCategory_Aggregate;
  /** fetch data from the table: "providerCategory" using primary key columns */
  providerCategory_by_pk?: Maybe<ProviderCategory>;
  /** fetch data from the table in a streaming manner: "providerCategory" */
  providerCategory_stream: Array<ProviderCategory>;
  /** fetch data from the table: "providerMonthlyPayments" */
  providerMonthlyPayments: Array<ProviderMonthlyPayments>;
  /** fetch aggregated fields from the table: "providerMonthlyPayments" */
  providerMonthlyPayments_aggregate: ProviderMonthlyPayments_Aggregate;
  /** fetch data from the table: "providerMonthlyPayments" using primary key columns */
  providerMonthlyPayments_by_pk?: Maybe<ProviderMonthlyPayments>;
  /** fetch data from the table in a streaming manner: "providerMonthlyPayments" */
  providerMonthlyPayments_stream: Array<ProviderMonthlyPayments>;
  /** An array relationship */
  providerPictures: Array<ProviderPictures>;
  /** An aggregate relationship */
  providerPictures_aggregate: ProviderPictures_Aggregate;
  /** fetch data from the table: "providerPictures" using primary key columns */
  providerPictures_by_pk?: Maybe<ProviderPictures>;
  /** fetch data from the table in a streaming manner: "providerPictures" */
  providerPictures_stream: Array<ProviderPictures>;
  /** fetch data from the table: "providerRole" */
  providerRole: Array<ProviderRole>;
  /** fetch aggregated fields from the table: "providerRole" */
  providerRole_aggregate: ProviderRole_Aggregate;
  /** fetch data from the table: "providerRole" using primary key columns */
  providerRole_by_pk?: Maybe<ProviderRole>;
  /** fetch data from the table in a streaming manner: "providerRole" */
  providerRole_stream: Array<ProviderRole>;
  /** fetch data from the table: "providerStatus" */
  providerStatus: Array<ProviderStatus>;
  /** fetch aggregated fields from the table: "providerStatus" */
  providerStatus_aggregate: ProviderStatus_Aggregate;
  /** fetch data from the table: "providerStatus" using primary key columns */
  providerStatus_by_pk?: Maybe<ProviderStatus>;
  /** fetch data from the table in a streaming manner: "providerStatus" */
  providerStatus_stream: Array<ProviderStatus>;
  /** fetch data from the table: "providerType" */
  providerType: Array<ProviderType>;
  /** fetch aggregated fields from the table: "providerType" */
  providerType_aggregate: ProviderType_Aggregate;
  /** fetch data from the table: "providerType" using primary key columns */
  providerType_by_pk?: Maybe<ProviderType>;
  /** fetch data from the table in a streaming manner: "providerType" */
  providerType_stream: Array<ProviderType>;
  /** fetch data from the table: "providerVisibility" */
  providerVisibility: Array<ProviderVisibility>;
  /** fetch aggregated fields from the table: "providerVisibility" */
  providerVisibility_aggregate: ProviderVisibility_Aggregate;
  /** fetch data from the table: "providerVisibility" using primary key columns */
  providerVisibility_by_pk?: Maybe<ProviderVisibility>;
  /** fetch data from the table in a streaming manner: "providerVisibility" */
  providerVisibility_stream: Array<ProviderVisibility>;
  /** An array relationship */
  providers: Array<Providers>;
  /** An aggregate relationship */
  providers_aggregate: Providers_Aggregate;
  /** fetch data from the table: "providers" using primary key columns */
  providers_by_pk?: Maybe<Providers>;
  /** fetch data from the table in a streaming manner: "providers" */
  providers_stream: Array<Providers>;
  /** An array relationship */
  refunds: Array<Refunds>;
  /** An aggregate relationship */
  refunds_aggregate: Refunds_Aggregate;
  /** fetch data from the table: "refunds" using primary key columns */
  refunds_by_pk?: Maybe<Refunds>;
  /** fetch data from the table in a streaming manner: "refunds" */
  refunds_stream: Array<Refunds>;
  /** fetch data from the table: "relationshipStatus" */
  relationshipStatus: Array<RelationshipStatus>;
  /** fetch aggregated fields from the table: "relationshipStatus" */
  relationshipStatus_aggregate: RelationshipStatus_Aggregate;
  /** fetch data from the table: "relationshipStatus" using primary key columns */
  relationshipStatus_by_pk?: Maybe<RelationshipStatus>;
  /** fetch data from the table in a streaming manner: "relationshipStatus" */
  relationshipStatus_stream: Array<RelationshipStatus>;
  /** fetch data from the table: "schedule" */
  schedule: Array<Schedule>;
  /** fetch aggregated fields from the table: "schedule" */
  schedule_aggregate: Schedule_Aggregate;
  /** fetch data from the table: "schedule" using primary key columns */
  schedule_by_pk?: Maybe<Schedule>;
  /** fetch data from the table in a streaming manner: "schedule" */
  schedule_stream: Array<Schedule>;
  /** An array relationship */
  serviceEmployees: Array<ServiceEmployees>;
  /** An aggregate relationship */
  serviceEmployees_aggregate: ServiceEmployees_Aggregate;
  /** fetch data from the table: "serviceEmployees" using primary key columns */
  serviceEmployees_by_pk?: Maybe<ServiceEmployees>;
  /** fetch data from the table in a streaming manner: "serviceEmployees" */
  serviceEmployees_stream: Array<ServiceEmployees>;
  /** fetch data from the table: "serviceFormStatus" */
  serviceFormStatus: Array<ServiceFormStatus>;
  /** fetch aggregated fields from the table: "serviceFormStatus" */
  serviceFormStatus_aggregate: ServiceFormStatus_Aggregate;
  /** fetch data from the table: "serviceFormStatus" using primary key columns */
  serviceFormStatus_by_pk?: Maybe<ServiceFormStatus>;
  /** fetch data from the table in a streaming manner: "serviceFormStatus" */
  serviceFormStatus_stream: Array<ServiceFormStatus>;
  /** An array relationship */
  serviceOptionAnswers: Array<ServiceOptionAnswers>;
  /** An aggregate relationship */
  serviceOptionAnswers_aggregate: ServiceOptionAnswers_Aggregate;
  /** fetch data from the table: "serviceOptionAnswers" using primary key columns */
  serviceOptionAnswers_by_pk?: Maybe<ServiceOptionAnswers>;
  /** fetch data from the table in a streaming manner: "serviceOptionAnswers" */
  serviceOptionAnswers_stream: Array<ServiceOptionAnswers>;
  /** fetch data from the table: "serviceOptionSection" */
  serviceOptionSection: Array<ServiceOptionSection>;
  /** An array relationship */
  serviceOptionSectionOptions: Array<ServiceOptionSectionOptions>;
  /** An aggregate relationship */
  serviceOptionSectionOptions_aggregate: ServiceOptionSectionOptions_Aggregate;
  /** fetch data from the table: "serviceOptionSectionOptions" using primary key columns */
  serviceOptionSectionOptions_by_pk?: Maybe<ServiceOptionSectionOptions>;
  /** fetch data from the table in a streaming manner: "serviceOptionSectionOptions" */
  serviceOptionSectionOptions_stream: Array<ServiceOptionSectionOptions>;
  /** fetch aggregated fields from the table: "serviceOptionSection" */
  serviceOptionSection_aggregate: ServiceOptionSection_Aggregate;
  /** fetch data from the table: "serviceOptionSection" using primary key columns */
  serviceOptionSection_by_pk?: Maybe<ServiceOptionSection>;
  /** fetch data from the table in a streaming manner: "serviceOptionSection" */
  serviceOptionSection_stream: Array<ServiceOptionSection>;
  /** An array relationship */
  serviceOptions: Array<ServiceOptions>;
  /** fetch data from the table: "serviceOptionsStatus" */
  serviceOptionsStatus: Array<ServiceOptionsStatus>;
  /** fetch aggregated fields from the table: "serviceOptionsStatus" */
  serviceOptionsStatus_aggregate: ServiceOptionsStatus_Aggregate;
  /** fetch data from the table: "serviceOptionsStatus" using primary key columns */
  serviceOptionsStatus_by_pk?: Maybe<ServiceOptionsStatus>;
  /** fetch data from the table in a streaming manner: "serviceOptionsStatus" */
  serviceOptionsStatus_stream: Array<ServiceOptionsStatus>;
  /** An aggregate relationship */
  serviceOptions_aggregate: ServiceOptions_Aggregate;
  /** fetch data from the table: "serviceOptions" using primary key columns */
  serviceOptions_by_pk?: Maybe<ServiceOptions>;
  /** fetch data from the table in a streaming manner: "serviceOptions" */
  serviceOptions_stream: Array<ServiceOptions>;
  /** An array relationship */
  servicePictures: Array<ServicePictures>;
  /** An aggregate relationship */
  servicePictures_aggregate: ServicePictures_Aggregate;
  /** fetch data from the table: "servicePictures" using primary key columns */
  servicePictures_by_pk?: Maybe<ServicePictures>;
  /** fetch data from the table in a streaming manner: "servicePictures" */
  servicePictures_stream: Array<ServicePictures>;
  /** An array relationship */
  servicePricings: Array<ServicePricings>;
  /** An aggregate relationship */
  servicePricings_aggregate: ServicePricings_Aggregate;
  /** fetch data from the table: "servicePricings" using primary key columns */
  servicePricings_by_pk?: Maybe<ServicePricings>;
  /** fetch data from the table in a streaming manner: "servicePricings" */
  servicePricings_stream: Array<ServicePricings>;
  /** fetch data from the table: "serviceSectionOptionQuantityType" */
  serviceSectionOptionQuantityType: Array<ServiceSectionOptionQuantityType>;
  /** fetch aggregated fields from the table: "serviceSectionOptionQuantityType" */
  serviceSectionOptionQuantityType_aggregate: ServiceSectionOptionQuantityType_Aggregate;
  /** fetch data from the table: "serviceSectionOptionQuantityType" using primary key columns */
  serviceSectionOptionQuantityType_by_pk?: Maybe<ServiceSectionOptionQuantityType>;
  /** fetch data from the table in a streaming manner: "serviceSectionOptionQuantityType" */
  serviceSectionOptionQuantityType_stream: Array<ServiceSectionOptionQuantityType>;
  /** fetch data from the table: "serviceSectionOptionType" */
  serviceSectionOptionType: Array<ServiceSectionOptionType>;
  /** fetch aggregated fields from the table: "serviceSectionOptionType" */
  serviceSectionOptionType_aggregate: ServiceSectionOptionType_Aggregate;
  /** fetch data from the table: "serviceSectionOptionType" using primary key columns */
  serviceSectionOptionType_by_pk?: Maybe<ServiceSectionOptionType>;
  /** fetch data from the table in a streaming manner: "serviceSectionOptionType" */
  serviceSectionOptionType_stream: Array<ServiceSectionOptionType>;
  /** fetch data from the table: "serviceStatus" */
  serviceStatus: Array<ServiceStatus>;
  /** fetch aggregated fields from the table: "serviceStatus" */
  serviceStatus_aggregate: ServiceStatus_Aggregate;
  /** fetch data from the table: "serviceStatus" using primary key columns */
  serviceStatus_by_pk?: Maybe<ServiceStatus>;
  /** fetch data from the table in a streaming manner: "serviceStatus" */
  serviceStatus_stream: Array<ServiceStatus>;
  /** An array relationship */
  services: Array<Services>;
  /** An array relationship */
  servicesForms: Array<ServicesForms>;
  /** An aggregate relationship */
  servicesForms_aggregate: ServicesForms_Aggregate;
  /** fetch data from the table: "servicesForms" using primary key columns */
  servicesForms_by_pk?: Maybe<ServicesForms>;
  /** fetch data from the table in a streaming manner: "servicesForms" */
  servicesForms_stream: Array<ServicesForms>;
  /** An aggregate relationship */
  services_aggregate: Services_Aggregate;
  /** fetch data from the table: "services" using primary key columns */
  services_by_pk?: Maybe<Services>;
  /** fetch data from the table in a streaming manner: "services" */
  services_stream: Array<Services>;
  /** fetch data from the table: "sessions" */
  sessions: Array<Sessions>;
  /** fetch aggregated fields from the table: "sessions" */
  sessions_aggregate: Sessions_Aggregate;
  /** fetch data from the table: "sessions" using primary key columns */
  sessions_by_pk?: Maybe<Sessions>;
  /** fetch data from the table in a streaming manner: "sessions" */
  sessions_stream: Array<Sessions>;
  /** An array relationship */
  timeouts: Array<Timeouts>;
  /** An aggregate relationship */
  timeouts_aggregate: Timeouts_Aggregate;
  /** fetch data from the table: "timeouts" using primary key columns */
  timeouts_by_pk?: Maybe<Timeouts>;
  /** fetch data from the table in a streaming manner: "timeouts" */
  timeouts_stream: Array<Timeouts>;
  /** fetch data from the table: "transitionStatus" */
  transitionStatus: Array<TransitionStatus>;
  /** fetch aggregated fields from the table: "transitionStatus" */
  transitionStatus_aggregate: TransitionStatus_Aggregate;
  /** fetch data from the table: "transitionStatus" using primary key columns */
  transitionStatus_by_pk?: Maybe<TransitionStatus>;
  /** fetch data from the table in a streaming manner: "transitionStatus" */
  transitionStatus_stream: Array<TransitionStatus>;
  /** An array relationship */
  unavailableServiceLocations: Array<UnavailableServiceLocations>;
  /** An aggregate relationship */
  unavailableServiceLocations_aggregate: UnavailableServiceLocations_Aggregate;
  /** fetch data from the table: "unavailableServiceLocations" using primary key columns */
  unavailableServiceLocations_by_pk?: Maybe<UnavailableServiceLocations>;
  /** fetch data from the table in a streaming manner: "unavailableServiceLocations" */
  unavailableServiceLocations_stream: Array<UnavailableServiceLocations>;
  /** fetch data from the table: "userRole" */
  userRole: Array<UserRole>;
  /** fetch aggregated fields from the table: "userRole" */
  userRole_aggregate: UserRole_Aggregate;
  /** fetch data from the table: "userRole" using primary key columns */
  userRole_by_pk?: Maybe<UserRole>;
  /** fetch data from the table in a streaming manner: "userRole" */
  userRole_stream: Array<UserRole>;
  /** An array relationship */
  userRoles: Array<UserRoles>;
  /** An aggregate relationship */
  userRoles_aggregate: UserRoles_Aggregate;
  /** fetch data from the table: "userRoles" using primary key columns */
  userRoles_by_pk?: Maybe<UserRoles>;
  /** fetch data from the table in a streaming manner: "userRoles" */
  userRoles_stream: Array<UserRoles>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
};


export type Subscription_RootAppointmentPricingArgs = {
  distinct_on?: InputMaybe<Array<AppointmentPricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AppointmentPricing_Order_By>>;
  where?: InputMaybe<AppointmentPricing_Bool_Exp>;
};


export type Subscription_RootAppointmentPricing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AppointmentPricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AppointmentPricing_Order_By>>;
  where?: InputMaybe<AppointmentPricing_Bool_Exp>;
};


export type Subscription_RootAppointmentPricing_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAppointmentPricing_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AppointmentPricing_Stream_Cursor_Input>>;
  where?: InputMaybe<AppointmentPricing_Bool_Exp>;
};


export type Subscription_RootAppointmentsArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


export type Subscription_RootAppointments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


export type Subscription_RootAppointments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAppointments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Appointments_Stream_Cursor_Input>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


export type Subscription_RootBookingStatusArgs = {
  distinct_on?: InputMaybe<Array<BookingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BookingStatus_Order_By>>;
  where?: InputMaybe<BookingStatus_Bool_Exp>;
};


export type Subscription_RootBookingStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BookingStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BookingStatus_Order_By>>;
  where?: InputMaybe<BookingStatus_Bool_Exp>;
};


export type Subscription_RootBookingStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootBookingStatus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BookingStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<BookingStatus_Bool_Exp>;
};


export type Subscription_RootBuildingProvidersArgs = {
  distinct_on?: InputMaybe<Array<BuildingProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingProviders_Order_By>>;
  where?: InputMaybe<BuildingProviders_Bool_Exp>;
};


export type Subscription_RootBuildingProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuildingProviders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingProviders_Order_By>>;
  where?: InputMaybe<BuildingProviders_Bool_Exp>;
};


export type Subscription_RootBuildingProviders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBuildingProviders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BuildingProviders_Stream_Cursor_Input>>;
  where?: InputMaybe<BuildingProviders_Bool_Exp>;
};


export type Subscription_RootBuildingTypeArgs = {
  distinct_on?: InputMaybe<Array<BuildingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingType_Order_By>>;
  where?: InputMaybe<BuildingType_Bool_Exp>;
};


export type Subscription_RootBuildingType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuildingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BuildingType_Order_By>>;
  where?: InputMaybe<BuildingType_Bool_Exp>;
};


export type Subscription_RootBuildingType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootBuildingType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BuildingType_Stream_Cursor_Input>>;
  where?: InputMaybe<BuildingType_Bool_Exp>;
};


export type Subscription_RootCheckoutSessionsArgs = {
  distinct_on?: InputMaybe<Array<CheckoutSessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CheckoutSessions_Order_By>>;
  where?: InputMaybe<CheckoutSessions_Bool_Exp>;
};


export type Subscription_RootCheckoutSessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CheckoutSessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CheckoutSessions_Order_By>>;
  where?: InputMaybe<CheckoutSessions_Bool_Exp>;
};


export type Subscription_RootCheckoutSessions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCheckoutSessions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CheckoutSessions_Stream_Cursor_Input>>;
  where?: InputMaybe<CheckoutSessions_Bool_Exp>;
};


export type Subscription_RootCurrenciesArgs = {
  distinct_on?: InputMaybe<Array<Currencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currencies_Order_By>>;
  where?: InputMaybe<Currencies_Bool_Exp>;
};


export type Subscription_RootCurrencies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Currencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Currencies_Order_By>>;
  where?: InputMaybe<Currencies_Bool_Exp>;
};


export type Subscription_RootCurrencies_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootCurrencies_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Currencies_Stream_Cursor_Input>>;
  where?: InputMaybe<Currencies_Bool_Exp>;
};


export type Subscription_RootCustomerAmountSpentArgs = {
  distinct_on?: InputMaybe<Array<CustomerAmountSpent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CustomerAmountSpent_Order_By>>;
  where?: InputMaybe<CustomerAmountSpent_Bool_Exp>;
};


export type Subscription_RootCustomerAmountSpent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CustomerAmountSpent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CustomerAmountSpent_Order_By>>;
  where?: InputMaybe<CustomerAmountSpent_Bool_Exp>;
};


export type Subscription_RootCustomerAmountSpent_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CustomerAmountSpent_Stream_Cursor_Input>>;
  where?: InputMaybe<CustomerAmountSpent_Bool_Exp>;
};


export type Subscription_RootCustomersArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Subscription_RootCustomers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Subscription_RootCustomers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customers_Stream_Cursor_Input>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Subscription_RootEntityTypeArgs = {
  distinct_on?: InputMaybe<Array<EntityType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EntityType_Order_By>>;
  where?: InputMaybe<EntityType_Bool_Exp>;
};


export type Subscription_RootEntityType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EntityType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EntityType_Order_By>>;
  where?: InputMaybe<EntityType_Bool_Exp>;
};


export type Subscription_RootEntityType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEntityType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EntityType_Stream_Cursor_Input>>;
  where?: InputMaybe<EntityType_Bool_Exp>;
};


export type Subscription_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFiles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFormArgs = {
  distinct_on?: InputMaybe<Array<Form_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Order_By>>;
  where?: InputMaybe<Form_Bool_Exp>;
};


export type Subscription_RootFormAnswersArgs = {
  distinct_on?: InputMaybe<Array<FormAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormAnswers_Order_By>>;
  where?: InputMaybe<FormAnswers_Bool_Exp>;
};


export type Subscription_RootFormAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FormAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormAnswers_Order_By>>;
  where?: InputMaybe<FormAnswers_Bool_Exp>;
};


export type Subscription_RootFormAnswers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFormAnswers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<FormAnswers_Stream_Cursor_Input>>;
  where?: InputMaybe<FormAnswers_Bool_Exp>;
};


export type Subscription_RootFormQuestionOptionsArgs = {
  distinct_on?: InputMaybe<Array<FormQuestionOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormQuestionOptions_Order_By>>;
  where?: InputMaybe<FormQuestionOptions_Bool_Exp>;
};


export type Subscription_RootFormQuestionOptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FormQuestionOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormQuestionOptions_Order_By>>;
  where?: InputMaybe<FormQuestionOptions_Bool_Exp>;
};


export type Subscription_RootFormQuestionOptions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFormQuestionOptions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<FormQuestionOptions_Stream_Cursor_Input>>;
  where?: InputMaybe<FormQuestionOptions_Bool_Exp>;
};


export type Subscription_RootFormQuestionTypeArgs = {
  distinct_on?: InputMaybe<Array<FormQuestionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormQuestionType_Order_By>>;
  where?: InputMaybe<FormQuestionType_Bool_Exp>;
};


export type Subscription_RootFormQuestionType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FormQuestionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormQuestionType_Order_By>>;
  where?: InputMaybe<FormQuestionType_Bool_Exp>;
};


export type Subscription_RootFormQuestionType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootFormQuestionType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<FormQuestionType_Stream_Cursor_Input>>;
  where?: InputMaybe<FormQuestionType_Bool_Exp>;
};


export type Subscription_RootFormQuestionsArgs = {
  distinct_on?: InputMaybe<Array<FormQuestions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormQuestions_Order_By>>;
  where?: InputMaybe<FormQuestions_Bool_Exp>;
};


export type Subscription_RootFormQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FormQuestions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FormQuestions_Order_By>>;
  where?: InputMaybe<FormQuestions_Bool_Exp>;
};


export type Subscription_RootFormQuestions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFormQuestions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<FormQuestions_Stream_Cursor_Input>>;
  where?: InputMaybe<FormQuestions_Bool_Exp>;
};


export type Subscription_RootForm_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Form_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Order_By>>;
  where?: InputMaybe<Form_Bool_Exp>;
};


export type Subscription_RootForm_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootForm_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Form_Stream_Cursor_Input>>;
  where?: InputMaybe<Form_Bool_Exp>;
};


export type Subscription_RootGet_Nearby_LocationsArgs = {
  args: Get_Nearby_Locations_Args;
  distinct_on?: InputMaybe<Array<Locations_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locations_With_Distance_Order_By>>;
  where?: InputMaybe<Locations_With_Distance_Bool_Exp>;
};


export type Subscription_RootGet_Nearby_Locations_AggregateArgs = {
  args: Get_Nearby_Locations_Args;
  distinct_on?: InputMaybe<Array<Locations_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locations_With_Distance_Order_By>>;
  where?: InputMaybe<Locations_With_Distance_Bool_Exp>;
};


export type Subscription_RootJobStatusArgs = {
  distinct_on?: InputMaybe<Array<JobStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<JobStatus_Order_By>>;
  where?: InputMaybe<JobStatus_Bool_Exp>;
};


export type Subscription_RootJobStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<JobStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<JobStatus_Order_By>>;
  where?: InputMaybe<JobStatus_Bool_Exp>;
};


export type Subscription_RootJobStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootJobStatus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<JobStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<JobStatus_Bool_Exp>;
};


export type Subscription_RootLocaleArgs = {
  distinct_on?: InputMaybe<Array<Locale_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locale_Order_By>>;
  where?: InputMaybe<Locale_Bool_Exp>;
};


export type Subscription_RootLocale_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Locale_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locale_Order_By>>;
  where?: InputMaybe<Locale_Bool_Exp>;
};


export type Subscription_RootLocale_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootLocale_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locale_Stream_Cursor_Input>>;
  where?: InputMaybe<Locale_Bool_Exp>;
};


export type Subscription_RootLocationStatusArgs = {
  distinct_on?: InputMaybe<Array<LocationStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<LocationStatus_Order_By>>;
  where?: InputMaybe<LocationStatus_Bool_Exp>;
};


export type Subscription_RootLocationStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LocationStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<LocationStatus_Order_By>>;
  where?: InputMaybe<LocationStatus_Bool_Exp>;
};


export type Subscription_RootLocationStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootLocationStatus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<LocationStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<LocationStatus_Bool_Exp>;
};


export type Subscription_RootLocationTypeArgs = {
  distinct_on?: InputMaybe<Array<LocationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<LocationType_Order_By>>;
  where?: InputMaybe<LocationType_Bool_Exp>;
};


export type Subscription_RootLocationType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LocationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<LocationType_Order_By>>;
  where?: InputMaybe<LocationType_Bool_Exp>;
};


export type Subscription_RootLocationType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootLocationType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<LocationType_Stream_Cursor_Input>>;
  where?: InputMaybe<LocationType_Bool_Exp>;
};


export type Subscription_RootLocationsArgs = {
  distinct_on?: InputMaybe<Array<Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locations_Order_By>>;
  where?: InputMaybe<Locations_Bool_Exp>;
};


export type Subscription_RootLocations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locations_Order_By>>;
  where?: InputMaybe<Locations_Bool_Exp>;
};


export type Subscription_RootLocations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLocations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locations_Stream_Cursor_Input>>;
  where?: InputMaybe<Locations_Bool_Exp>;
};


export type Subscription_RootLocations_With_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Locations_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locations_With_Distance_Order_By>>;
  where?: InputMaybe<Locations_With_Distance_Bool_Exp>;
};


export type Subscription_RootLocations_With_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Locations_With_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locations_With_Distance_Order_By>>;
  where?: InputMaybe<Locations_With_Distance_Bool_Exp>;
};


export type Subscription_RootLocations_With_Distance_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locations_With_Distance_Stream_Cursor_Input>>;
  where?: InputMaybe<Locations_With_Distance_Bool_Exp>;
};


export type Subscription_RootNotificationTypeArgs = {
  distinct_on?: InputMaybe<Array<NotificationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationType_Order_By>>;
  where?: InputMaybe<NotificationType_Bool_Exp>;
};


export type Subscription_RootNotificationType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationType_Order_By>>;
  where?: InputMaybe<NotificationType_Bool_Exp>;
};


export type Subscription_RootNotificationType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootNotificationType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<NotificationType_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationType_Bool_Exp>;
};


export type Subscription_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootNotifications_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootPartnershipSchedulingTypeArgs = {
  distinct_on?: InputMaybe<Array<PartnershipSchedulingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PartnershipSchedulingType_Order_By>>;
  where?: InputMaybe<PartnershipSchedulingType_Bool_Exp>;
};


export type Subscription_RootPartnershipSchedulingType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PartnershipSchedulingType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PartnershipSchedulingType_Order_By>>;
  where?: InputMaybe<PartnershipSchedulingType_Bool_Exp>;
};


export type Subscription_RootPartnershipSchedulingType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPartnershipSchedulingType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PartnershipSchedulingType_Stream_Cursor_Input>>;
  where?: InputMaybe<PartnershipSchedulingType_Bool_Exp>;
};


export type Subscription_RootPartnershipStatusArgs = {
  distinct_on?: InputMaybe<Array<PartnershipStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PartnershipStatus_Order_By>>;
  where?: InputMaybe<PartnershipStatus_Bool_Exp>;
};


export type Subscription_RootPartnershipStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PartnershipStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PartnershipStatus_Order_By>>;
  where?: InputMaybe<PartnershipStatus_Bool_Exp>;
};


export type Subscription_RootPartnershipStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPartnershipStatus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PartnershipStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<PartnershipStatus_Bool_Exp>;
};


export type Subscription_RootPaymentFormatArgs = {
  distinct_on?: InputMaybe<Array<PaymentFormat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaymentFormat_Order_By>>;
  where?: InputMaybe<PaymentFormat_Bool_Exp>;
};


export type Subscription_RootPaymentFormat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PaymentFormat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaymentFormat_Order_By>>;
  where?: InputMaybe<PaymentFormat_Bool_Exp>;
};


export type Subscription_RootPaymentFormat_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPaymentFormat_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PaymentFormat_Stream_Cursor_Input>>;
  where?: InputMaybe<PaymentFormat_Bool_Exp>;
};


export type Subscription_RootPaymentStatusArgs = {
  distinct_on?: InputMaybe<Array<PaymentStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaymentStatus_Order_By>>;
  where?: InputMaybe<PaymentStatus_Bool_Exp>;
};


export type Subscription_RootPaymentStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PaymentStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaymentStatus_Order_By>>;
  where?: InputMaybe<PaymentStatus_Bool_Exp>;
};


export type Subscription_RootPaymentStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPaymentStatus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PaymentStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<PaymentStatus_Bool_Exp>;
};


export type Subscription_RootPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Subscription_RootPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Subscription_RootPayments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPayments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Payments_Stream_Cursor_Input>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Subscription_RootProviderCategoryArgs = {
  distinct_on?: InputMaybe<Array<ProviderCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderCategory_Order_By>>;
  where?: InputMaybe<ProviderCategory_Bool_Exp>;
};


export type Subscription_RootProviderCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderCategory_Order_By>>;
  where?: InputMaybe<ProviderCategory_Bool_Exp>;
};


export type Subscription_RootProviderCategory_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProviderCategory_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProviderCategory_Stream_Cursor_Input>>;
  where?: InputMaybe<ProviderCategory_Bool_Exp>;
};


export type Subscription_RootProviderMonthlyPaymentsArgs = {
  distinct_on?: InputMaybe<Array<ProviderMonthlyPayments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderMonthlyPayments_Order_By>>;
  where?: InputMaybe<ProviderMonthlyPayments_Bool_Exp>;
};


export type Subscription_RootProviderMonthlyPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderMonthlyPayments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderMonthlyPayments_Order_By>>;
  where?: InputMaybe<ProviderMonthlyPayments_Bool_Exp>;
};


export type Subscription_RootProviderMonthlyPayments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProviderMonthlyPayments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProviderMonthlyPayments_Stream_Cursor_Input>>;
  where?: InputMaybe<ProviderMonthlyPayments_Bool_Exp>;
};


export type Subscription_RootProviderPicturesArgs = {
  distinct_on?: InputMaybe<Array<ProviderPictures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderPictures_Order_By>>;
  where?: InputMaybe<ProviderPictures_Bool_Exp>;
};


export type Subscription_RootProviderPictures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderPictures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderPictures_Order_By>>;
  where?: InputMaybe<ProviderPictures_Bool_Exp>;
};


export type Subscription_RootProviderPictures_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProviderPictures_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProviderPictures_Stream_Cursor_Input>>;
  where?: InputMaybe<ProviderPictures_Bool_Exp>;
};


export type Subscription_RootProviderRoleArgs = {
  distinct_on?: InputMaybe<Array<ProviderRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderRole_Order_By>>;
  where?: InputMaybe<ProviderRole_Bool_Exp>;
};


export type Subscription_RootProviderRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderRole_Order_By>>;
  where?: InputMaybe<ProviderRole_Bool_Exp>;
};


export type Subscription_RootProviderRole_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProviderRole_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProviderRole_Stream_Cursor_Input>>;
  where?: InputMaybe<ProviderRole_Bool_Exp>;
};


export type Subscription_RootProviderStatusArgs = {
  distinct_on?: InputMaybe<Array<ProviderStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderStatus_Order_By>>;
  where?: InputMaybe<ProviderStatus_Bool_Exp>;
};


export type Subscription_RootProviderStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderStatus_Order_By>>;
  where?: InputMaybe<ProviderStatus_Bool_Exp>;
};


export type Subscription_RootProviderStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProviderStatus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProviderStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<ProviderStatus_Bool_Exp>;
};


export type Subscription_RootProviderTypeArgs = {
  distinct_on?: InputMaybe<Array<ProviderType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderType_Order_By>>;
  where?: InputMaybe<ProviderType_Bool_Exp>;
};


export type Subscription_RootProviderType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderType_Order_By>>;
  where?: InputMaybe<ProviderType_Bool_Exp>;
};


export type Subscription_RootProviderType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProviderType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProviderType_Stream_Cursor_Input>>;
  where?: InputMaybe<ProviderType_Bool_Exp>;
};


export type Subscription_RootProviderVisibilityArgs = {
  distinct_on?: InputMaybe<Array<ProviderVisibility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderVisibility_Order_By>>;
  where?: InputMaybe<ProviderVisibility_Bool_Exp>;
};


export type Subscription_RootProviderVisibility_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProviderVisibility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ProviderVisibility_Order_By>>;
  where?: InputMaybe<ProviderVisibility_Bool_Exp>;
};


export type Subscription_RootProviderVisibility_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProviderVisibility_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProviderVisibility_Stream_Cursor_Input>>;
  where?: InputMaybe<ProviderVisibility_Bool_Exp>;
};


export type Subscription_RootProvidersArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};


export type Subscription_RootProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};


export type Subscription_RootProviders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProviders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Providers_Stream_Cursor_Input>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};


export type Subscription_RootRefundsArgs = {
  distinct_on?: InputMaybe<Array<Refunds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refunds_Order_By>>;
  where?: InputMaybe<Refunds_Bool_Exp>;
};


export type Subscription_RootRefunds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refunds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refunds_Order_By>>;
  where?: InputMaybe<Refunds_Bool_Exp>;
};


export type Subscription_RootRefunds_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRefunds_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Refunds_Stream_Cursor_Input>>;
  where?: InputMaybe<Refunds_Bool_Exp>;
};


export type Subscription_RootRelationshipStatusArgs = {
  distinct_on?: InputMaybe<Array<RelationshipStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelationshipStatus_Order_By>>;
  where?: InputMaybe<RelationshipStatus_Bool_Exp>;
};


export type Subscription_RootRelationshipStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RelationshipStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RelationshipStatus_Order_By>>;
  where?: InputMaybe<RelationshipStatus_Bool_Exp>;
};


export type Subscription_RootRelationshipStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootRelationshipStatus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RelationshipStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<RelationshipStatus_Bool_Exp>;
};


export type Subscription_RootScheduleArgs = {
  distinct_on?: InputMaybe<Array<Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Schedule_Order_By>>;
  where?: InputMaybe<Schedule_Bool_Exp>;
};


export type Subscription_RootSchedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Schedule_Order_By>>;
  where?: InputMaybe<Schedule_Bool_Exp>;
};


export type Subscription_RootSchedule_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSchedule_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Schedule_Stream_Cursor_Input>>;
  where?: InputMaybe<Schedule_Bool_Exp>;
};


export type Subscription_RootServiceEmployeesArgs = {
  distinct_on?: InputMaybe<Array<ServiceEmployees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceEmployees_Order_By>>;
  where?: InputMaybe<ServiceEmployees_Bool_Exp>;
};


export type Subscription_RootServiceEmployees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceEmployees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceEmployees_Order_By>>;
  where?: InputMaybe<ServiceEmployees_Bool_Exp>;
};


export type Subscription_RootServiceEmployees_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootServiceEmployees_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceEmployees_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceEmployees_Bool_Exp>;
};


export type Subscription_RootServiceFormStatusArgs = {
  distinct_on?: InputMaybe<Array<ServiceFormStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceFormStatus_Order_By>>;
  where?: InputMaybe<ServiceFormStatus_Bool_Exp>;
};


export type Subscription_RootServiceFormStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceFormStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceFormStatus_Order_By>>;
  where?: InputMaybe<ServiceFormStatus_Bool_Exp>;
};


export type Subscription_RootServiceFormStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootServiceFormStatus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceFormStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceFormStatus_Bool_Exp>;
};


export type Subscription_RootServiceOptionAnswersArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionAnswers_Order_By>>;
  where?: InputMaybe<ServiceOptionAnswers_Bool_Exp>;
};


export type Subscription_RootServiceOptionAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionAnswers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionAnswers_Order_By>>;
  where?: InputMaybe<ServiceOptionAnswers_Bool_Exp>;
};


export type Subscription_RootServiceOptionAnswers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootServiceOptionAnswers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceOptionAnswers_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceOptionAnswers_Bool_Exp>;
};


export type Subscription_RootServiceOptionSectionArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionSection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionSection_Order_By>>;
  where?: InputMaybe<ServiceOptionSection_Bool_Exp>;
};


export type Subscription_RootServiceOptionSectionOptionsArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionSectionOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionSectionOptions_Order_By>>;
  where?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
};


export type Subscription_RootServiceOptionSectionOptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionSectionOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionSectionOptions_Order_By>>;
  where?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
};


export type Subscription_RootServiceOptionSectionOptions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootServiceOptionSectionOptions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceOptionSectionOptions_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceOptionSectionOptions_Bool_Exp>;
};


export type Subscription_RootServiceOptionSection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionSection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionSection_Order_By>>;
  where?: InputMaybe<ServiceOptionSection_Bool_Exp>;
};


export type Subscription_RootServiceOptionSection_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootServiceOptionSection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceOptionSection_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceOptionSection_Bool_Exp>;
};


export type Subscription_RootServiceOptionsArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptions_Order_By>>;
  where?: InputMaybe<ServiceOptions_Bool_Exp>;
};


export type Subscription_RootServiceOptionsStatusArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionsStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionsStatus_Order_By>>;
  where?: InputMaybe<ServiceOptionsStatus_Bool_Exp>;
};


export type Subscription_RootServiceOptionsStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptionsStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptionsStatus_Order_By>>;
  where?: InputMaybe<ServiceOptionsStatus_Bool_Exp>;
};


export type Subscription_RootServiceOptionsStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootServiceOptionsStatus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceOptionsStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceOptionsStatus_Bool_Exp>;
};


export type Subscription_RootServiceOptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOptions_Order_By>>;
  where?: InputMaybe<ServiceOptions_Bool_Exp>;
};


export type Subscription_RootServiceOptions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootServiceOptions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceOptions_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceOptions_Bool_Exp>;
};


export type Subscription_RootServicePicturesArgs = {
  distinct_on?: InputMaybe<Array<ServicePictures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicePictures_Order_By>>;
  where?: InputMaybe<ServicePictures_Bool_Exp>;
};


export type Subscription_RootServicePictures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServicePictures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicePictures_Order_By>>;
  where?: InputMaybe<ServicePictures_Bool_Exp>;
};


export type Subscription_RootServicePictures_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootServicePictures_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServicePictures_Stream_Cursor_Input>>;
  where?: InputMaybe<ServicePictures_Bool_Exp>;
};


export type Subscription_RootServicePricingsArgs = {
  distinct_on?: InputMaybe<Array<ServicePricings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicePricings_Order_By>>;
  where?: InputMaybe<ServicePricings_Bool_Exp>;
};


export type Subscription_RootServicePricings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServicePricings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicePricings_Order_By>>;
  where?: InputMaybe<ServicePricings_Bool_Exp>;
};


export type Subscription_RootServicePricings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootServicePricings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServicePricings_Stream_Cursor_Input>>;
  where?: InputMaybe<ServicePricings_Bool_Exp>;
};


export type Subscription_RootServiceSectionOptionQuantityTypeArgs = {
  distinct_on?: InputMaybe<Array<ServiceSectionOptionQuantityType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceSectionOptionQuantityType_Order_By>>;
  where?: InputMaybe<ServiceSectionOptionQuantityType_Bool_Exp>;
};


export type Subscription_RootServiceSectionOptionQuantityType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceSectionOptionQuantityType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceSectionOptionQuantityType_Order_By>>;
  where?: InputMaybe<ServiceSectionOptionQuantityType_Bool_Exp>;
};


export type Subscription_RootServiceSectionOptionQuantityType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootServiceSectionOptionQuantityType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceSectionOptionQuantityType_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceSectionOptionQuantityType_Bool_Exp>;
};


export type Subscription_RootServiceSectionOptionTypeArgs = {
  distinct_on?: InputMaybe<Array<ServiceSectionOptionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceSectionOptionType_Order_By>>;
  where?: InputMaybe<ServiceSectionOptionType_Bool_Exp>;
};


export type Subscription_RootServiceSectionOptionType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceSectionOptionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceSectionOptionType_Order_By>>;
  where?: InputMaybe<ServiceSectionOptionType_Bool_Exp>;
};


export type Subscription_RootServiceSectionOptionType_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootServiceSectionOptionType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceSectionOptionType_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceSectionOptionType_Bool_Exp>;
};


export type Subscription_RootServiceStatusArgs = {
  distinct_on?: InputMaybe<Array<ServiceStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceStatus_Order_By>>;
  where?: InputMaybe<ServiceStatus_Bool_Exp>;
};


export type Subscription_RootServiceStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceStatus_Order_By>>;
  where?: InputMaybe<ServiceStatus_Bool_Exp>;
};


export type Subscription_RootServiceStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootServiceStatus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceStatus_Bool_Exp>;
};


export type Subscription_RootServicesArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Subscription_RootServicesFormsArgs = {
  distinct_on?: InputMaybe<Array<ServicesForms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicesForms_Order_By>>;
  where?: InputMaybe<ServicesForms_Bool_Exp>;
};


export type Subscription_RootServicesForms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServicesForms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServicesForms_Order_By>>;
  where?: InputMaybe<ServicesForms_Bool_Exp>;
};


export type Subscription_RootServicesForms_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootServicesForms_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServicesForms_Stream_Cursor_Input>>;
  where?: InputMaybe<ServicesForms_Bool_Exp>;
};


export type Subscription_RootServices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Subscription_RootServices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootServices_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Services_Stream_Cursor_Input>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Subscription_RootSessionsArgs = {
  distinct_on?: InputMaybe<Array<Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sessions_Order_By>>;
  where?: InputMaybe<Sessions_Bool_Exp>;
};


export type Subscription_RootSessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sessions_Order_By>>;
  where?: InputMaybe<Sessions_Bool_Exp>;
};


export type Subscription_RootSessions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSessions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sessions_Stream_Cursor_Input>>;
  where?: InputMaybe<Sessions_Bool_Exp>;
};


export type Subscription_RootTimeoutsArgs = {
  distinct_on?: InputMaybe<Array<Timeouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Timeouts_Order_By>>;
  where?: InputMaybe<Timeouts_Bool_Exp>;
};


export type Subscription_RootTimeouts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Timeouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Timeouts_Order_By>>;
  where?: InputMaybe<Timeouts_Bool_Exp>;
};


export type Subscription_RootTimeouts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTimeouts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Timeouts_Stream_Cursor_Input>>;
  where?: InputMaybe<Timeouts_Bool_Exp>;
};


export type Subscription_RootTransitionStatusArgs = {
  distinct_on?: InputMaybe<Array<TransitionStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransitionStatus_Order_By>>;
  where?: InputMaybe<TransitionStatus_Bool_Exp>;
};


export type Subscription_RootTransitionStatus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TransitionStatus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TransitionStatus_Order_By>>;
  where?: InputMaybe<TransitionStatus_Bool_Exp>;
};


export type Subscription_RootTransitionStatus_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTransitionStatus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TransitionStatus_Stream_Cursor_Input>>;
  where?: InputMaybe<TransitionStatus_Bool_Exp>;
};


export type Subscription_RootUnavailableServiceLocationsArgs = {
  distinct_on?: InputMaybe<Array<UnavailableServiceLocations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnavailableServiceLocations_Order_By>>;
  where?: InputMaybe<UnavailableServiceLocations_Bool_Exp>;
};


export type Subscription_RootUnavailableServiceLocations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UnavailableServiceLocations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnavailableServiceLocations_Order_By>>;
  where?: InputMaybe<UnavailableServiceLocations_Bool_Exp>;
};


export type Subscription_RootUnavailableServiceLocations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUnavailableServiceLocations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UnavailableServiceLocations_Stream_Cursor_Input>>;
  where?: InputMaybe<UnavailableServiceLocations_Bool_Exp>;
};


export type Subscription_RootUserRoleArgs = {
  distinct_on?: InputMaybe<Array<UserRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_Order_By>>;
  where?: InputMaybe<UserRole_Bool_Exp>;
};


export type Subscription_RootUserRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_Order_By>>;
  where?: InputMaybe<UserRole_Bool_Exp>;
};


export type Subscription_RootUserRole_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootUserRole_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserRole_Stream_Cursor_Input>>;
  where?: InputMaybe<UserRole_Bool_Exp>;
};


export type Subscription_RootUserRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoles_Order_By>>;
  where?: InputMaybe<UserRoles_Bool_Exp>;
};


export type Subscription_RootUserRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoles_Order_By>>;
  where?: InputMaybe<UserRoles_Bool_Exp>;
};


export type Subscription_RootUserRoles_By_PkArgs = {
  userId: Scalars['uuid']['input'];
};


export type Subscription_RootUserRoles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserRoles_Stream_Cursor_Input>>;
  where?: InputMaybe<UserRoles_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']['input']>;
  _gt?: InputMaybe<Scalars['time']['input']>;
  _gte?: InputMaybe<Scalars['time']['input']>;
  _in?: InputMaybe<Array<Scalars['time']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['time']['input']>;
  _lte?: InputMaybe<Scalars['time']['input']>;
  _neq?: InputMaybe<Scalars['time']['input']>;
  _nin?: InputMaybe<Array<Scalars['time']['input']>>;
};

/** columns and relationships of "timeouts" */
export type Timeouts = {
  __typename?: 'timeouts';
  createdAt: Scalars['timestamptz']['output'];
  endDate?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  location?: Maybe<Locations>;
  locationId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  service?: Maybe<Services>;
  serviceId?: Maybe<Scalars['uuid']['output']>;
  startDate: Scalars['timestamptz']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "timeouts" */
export type Timeouts_Aggregate = {
  __typename?: 'timeouts_aggregate';
  aggregate?: Maybe<Timeouts_Aggregate_Fields>;
  nodes: Array<Timeouts>;
};

export type Timeouts_Aggregate_Bool_Exp = {
  count?: InputMaybe<Timeouts_Aggregate_Bool_Exp_Count>;
};

export type Timeouts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Timeouts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Timeouts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "timeouts" */
export type Timeouts_Aggregate_Fields = {
  __typename?: 'timeouts_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Timeouts_Max_Fields>;
  min?: Maybe<Timeouts_Min_Fields>;
};


/** aggregate fields of "timeouts" */
export type Timeouts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Timeouts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "timeouts" */
export type Timeouts_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Timeouts_Max_Order_By>;
  min?: InputMaybe<Timeouts_Min_Order_By>;
};

/** input type for inserting array relation for remote table "timeouts" */
export type Timeouts_Arr_Rel_Insert_Input = {
  data: Array<Timeouts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Timeouts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "timeouts". All fields are combined with a logical 'AND'. */
export type Timeouts_Bool_Exp = {
  _and?: InputMaybe<Array<Timeouts_Bool_Exp>>;
  _not?: InputMaybe<Timeouts_Bool_Exp>;
  _or?: InputMaybe<Array<Timeouts_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  endDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Locations_Bool_Exp>;
  locationId?: InputMaybe<Uuid_Comparison_Exp>;
  service?: InputMaybe<Services_Bool_Exp>;
  serviceId?: InputMaybe<Uuid_Comparison_Exp>;
  startDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "timeouts" */
export enum Timeouts_Constraint {
  /** unique or primary key constraint on columns "id" */
  TimeoutsPkey = 'timeouts_pkey'
}

/** input type for inserting data into table "timeouts" */
export type Timeouts_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Locations_Obj_Rel_Insert_Input>;
  locationId?: InputMaybe<Scalars['uuid']['input']>;
  service?: InputMaybe<Services_Obj_Rel_Insert_Input>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Timeouts_Max_Fields = {
  __typename?: 'timeouts_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  endDate?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  locationId?: Maybe<Scalars['uuid']['output']>;
  serviceId?: Maybe<Scalars['uuid']['output']>;
  startDate?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "timeouts" */
export type Timeouts_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locationId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Timeouts_Min_Fields = {
  __typename?: 'timeouts_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  endDate?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  locationId?: Maybe<Scalars['uuid']['output']>;
  serviceId?: Maybe<Scalars['uuid']['output']>;
  startDate?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "timeouts" */
export type Timeouts_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locationId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "timeouts" */
export type Timeouts_Mutation_Response = {
  __typename?: 'timeouts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Timeouts>;
};

/** input type for inserting object relation for remote table "timeouts" */
export type Timeouts_Obj_Rel_Insert_Input = {
  data: Timeouts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Timeouts_On_Conflict>;
};

/** on_conflict condition type for table "timeouts" */
export type Timeouts_On_Conflict = {
  constraint: Timeouts_Constraint;
  update_columns?: Array<Timeouts_Update_Column>;
  where?: InputMaybe<Timeouts_Bool_Exp>;
};

/** Ordering options when selecting data from "timeouts". */
export type Timeouts_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Locations_Order_By>;
  locationId?: InputMaybe<Order_By>;
  service?: InputMaybe<Services_Order_By>;
  serviceId?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: timeouts */
export type Timeouts_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "timeouts" */
export enum Timeouts_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'locationId',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "timeouts" */
export type Timeouts_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  locationId?: InputMaybe<Scalars['uuid']['input']>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "timeouts" */
export type Timeouts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Timeouts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Timeouts_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  locationId?: InputMaybe<Scalars['uuid']['input']>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "timeouts" */
export enum Timeouts_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'locationId',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Timeouts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Timeouts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Timeouts_Bool_Exp;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** Boolean expression to compare columns of type "timetz". All fields are combined with logical 'AND'. */
export type Timetz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timetz']['input']>;
  _gt?: InputMaybe<Scalars['timetz']['input']>;
  _gte?: InputMaybe<Scalars['timetz']['input']>;
  _in?: InputMaybe<Array<Scalars['timetz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timetz']['input']>;
  _lte?: InputMaybe<Scalars['timetz']['input']>;
  _neq?: InputMaybe<Scalars['timetz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timetz']['input']>>;
};

/** columns and relationships of "transitionStatus" */
export type TransitionStatus = {
  __typename?: 'transitionStatus';
  value: Scalars['String']['output'];
};

/** aggregated selection of "transitionStatus" */
export type TransitionStatus_Aggregate = {
  __typename?: 'transitionStatus_aggregate';
  aggregate?: Maybe<TransitionStatus_Aggregate_Fields>;
  nodes: Array<TransitionStatus>;
};

/** aggregate fields of "transitionStatus" */
export type TransitionStatus_Aggregate_Fields = {
  __typename?: 'transitionStatus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<TransitionStatus_Max_Fields>;
  min?: Maybe<TransitionStatus_Min_Fields>;
};


/** aggregate fields of "transitionStatus" */
export type TransitionStatus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TransitionStatus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "transitionStatus". All fields are combined with a logical 'AND'. */
export type TransitionStatus_Bool_Exp = {
  _and?: InputMaybe<Array<TransitionStatus_Bool_Exp>>;
  _not?: InputMaybe<TransitionStatus_Bool_Exp>;
  _or?: InputMaybe<Array<TransitionStatus_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "transitionStatus" */
export enum TransitionStatus_Constraint {
  /** unique or primary key constraint on columns "value" */
  TransitionStatusPkey = 'transitionStatus_pkey'
}

export enum TransitionStatus_Enum {
  Accepted = 'accepted',
  Pending = 'pending'
}

/** Boolean expression to compare columns of type "transitionStatus_enum". All fields are combined with logical 'AND'. */
export type TransitionStatus_Enum_Comparison_Exp = {
  _eq?: InputMaybe<TransitionStatus_Enum>;
  _in?: InputMaybe<Array<TransitionStatus_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<TransitionStatus_Enum>;
  _nin?: InputMaybe<Array<TransitionStatus_Enum>>;
};

/** input type for inserting data into table "transitionStatus" */
export type TransitionStatus_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TransitionStatus_Max_Fields = {
  __typename?: 'transitionStatus_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TransitionStatus_Min_Fields = {
  __typename?: 'transitionStatus_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "transitionStatus" */
export type TransitionStatus_Mutation_Response = {
  __typename?: 'transitionStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TransitionStatus>;
};

/** on_conflict condition type for table "transitionStatus" */
export type TransitionStatus_On_Conflict = {
  constraint: TransitionStatus_Constraint;
  update_columns?: Array<TransitionStatus_Update_Column>;
  where?: InputMaybe<TransitionStatus_Bool_Exp>;
};

/** Ordering options when selecting data from "transitionStatus". */
export type TransitionStatus_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transitionStatus */
export type TransitionStatus_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "transitionStatus" */
export enum TransitionStatus_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "transitionStatus" */
export type TransitionStatus_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "transitionStatus" */
export type TransitionStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TransitionStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TransitionStatus_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "transitionStatus" */
export enum TransitionStatus_Update_Column {
  /** column name */
  Value = 'value'
}

export type TransitionStatus_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TransitionStatus_Set_Input>;
  /** filter the rows which have to be updated */
  where: TransitionStatus_Bool_Exp;
};

/** columns and relationships of "unavailableServiceLocations" */
export type UnavailableServiceLocations = {
  __typename?: 'unavailableServiceLocations';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  location: Locations;
  locationId: Scalars['uuid']['output'];
  /** An object relationship */
  service: Services;
  serviceId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "unavailableServiceLocations" */
export type UnavailableServiceLocations_Aggregate = {
  __typename?: 'unavailableServiceLocations_aggregate';
  aggregate?: Maybe<UnavailableServiceLocations_Aggregate_Fields>;
  nodes: Array<UnavailableServiceLocations>;
};

export type UnavailableServiceLocations_Aggregate_Bool_Exp = {
  count?: InputMaybe<UnavailableServiceLocations_Aggregate_Bool_Exp_Count>;
};

export type UnavailableServiceLocations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<UnavailableServiceLocations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UnavailableServiceLocations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "unavailableServiceLocations" */
export type UnavailableServiceLocations_Aggregate_Fields = {
  __typename?: 'unavailableServiceLocations_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<UnavailableServiceLocations_Max_Fields>;
  min?: Maybe<UnavailableServiceLocations_Min_Fields>;
};


/** aggregate fields of "unavailableServiceLocations" */
export type UnavailableServiceLocations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UnavailableServiceLocations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "unavailableServiceLocations" */
export type UnavailableServiceLocations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UnavailableServiceLocations_Max_Order_By>;
  min?: InputMaybe<UnavailableServiceLocations_Min_Order_By>;
};

/** input type for inserting array relation for remote table "unavailableServiceLocations" */
export type UnavailableServiceLocations_Arr_Rel_Insert_Input = {
  data: Array<UnavailableServiceLocations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UnavailableServiceLocations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "unavailableServiceLocations". All fields are combined with a logical 'AND'. */
export type UnavailableServiceLocations_Bool_Exp = {
  _and?: InputMaybe<Array<UnavailableServiceLocations_Bool_Exp>>;
  _not?: InputMaybe<UnavailableServiceLocations_Bool_Exp>;
  _or?: InputMaybe<Array<UnavailableServiceLocations_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Locations_Bool_Exp>;
  locationId?: InputMaybe<Uuid_Comparison_Exp>;
  service?: InputMaybe<Services_Bool_Exp>;
  serviceId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "unavailableServiceLocations" */
export enum UnavailableServiceLocations_Constraint {
  /** unique or primary key constraint on columns "id" */
  UnavailableServiceLocationsPkey = 'unavailableServiceLocations_pkey'
}

/** input type for inserting data into table "unavailableServiceLocations" */
export type UnavailableServiceLocations_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Locations_Obj_Rel_Insert_Input>;
  locationId?: InputMaybe<Scalars['uuid']['input']>;
  service?: InputMaybe<Services_Obj_Rel_Insert_Input>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type UnavailableServiceLocations_Max_Fields = {
  __typename?: 'unavailableServiceLocations_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  locationId?: Maybe<Scalars['uuid']['output']>;
  serviceId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "unavailableServiceLocations" */
export type UnavailableServiceLocations_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locationId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UnavailableServiceLocations_Min_Fields = {
  __typename?: 'unavailableServiceLocations_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  locationId?: Maybe<Scalars['uuid']['output']>;
  serviceId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "unavailableServiceLocations" */
export type UnavailableServiceLocations_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locationId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "unavailableServiceLocations" */
export type UnavailableServiceLocations_Mutation_Response = {
  __typename?: 'unavailableServiceLocations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UnavailableServiceLocations>;
};

/** on_conflict condition type for table "unavailableServiceLocations" */
export type UnavailableServiceLocations_On_Conflict = {
  constraint: UnavailableServiceLocations_Constraint;
  update_columns?: Array<UnavailableServiceLocations_Update_Column>;
  where?: InputMaybe<UnavailableServiceLocations_Bool_Exp>;
};

/** Ordering options when selecting data from "unavailableServiceLocations". */
export type UnavailableServiceLocations_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Locations_Order_By>;
  locationId?: InputMaybe<Order_By>;
  service?: InputMaybe<Services_Order_By>;
  serviceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: unavailableServiceLocations */
export type UnavailableServiceLocations_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "unavailableServiceLocations" */
export enum UnavailableServiceLocations_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'locationId',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "unavailableServiceLocations" */
export type UnavailableServiceLocations_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  locationId?: InputMaybe<Scalars['uuid']['input']>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "unavailableServiceLocations" */
export type UnavailableServiceLocations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UnavailableServiceLocations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UnavailableServiceLocations_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  locationId?: InputMaybe<Scalars['uuid']['input']>;
  serviceId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "unavailableServiceLocations" */
export enum UnavailableServiceLocations_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'locationId',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type UnavailableServiceLocations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UnavailableServiceLocations_Set_Input>;
  /** filter the rows which have to be updated */
  where: UnavailableServiceLocations_Bool_Exp;
};

/** columns and relationships of "userRole" */
export type UserRole = {
  __typename?: 'userRole';
  /** An array relationship */
  userRoles: Array<UserRoles>;
  /** An aggregate relationship */
  userRoles_aggregate: UserRoles_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "userRole" */
export type UserRoleUserRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoles_Order_By>>;
  where?: InputMaybe<UserRoles_Bool_Exp>;
};


/** columns and relationships of "userRole" */
export type UserRoleUserRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRoles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoles_Order_By>>;
  where?: InputMaybe<UserRoles_Bool_Exp>;
};

/** aggregated selection of "userRole" */
export type UserRole_Aggregate = {
  __typename?: 'userRole_aggregate';
  aggregate?: Maybe<UserRole_Aggregate_Fields>;
  nodes: Array<UserRole>;
};

/** aggregate fields of "userRole" */
export type UserRole_Aggregate_Fields = {
  __typename?: 'userRole_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<UserRole_Max_Fields>;
  min?: Maybe<UserRole_Min_Fields>;
};


/** aggregate fields of "userRole" */
export type UserRole_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserRole_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "userRole". All fields are combined with a logical 'AND'. */
export type UserRole_Bool_Exp = {
  _and?: InputMaybe<Array<UserRole_Bool_Exp>>;
  _not?: InputMaybe<UserRole_Bool_Exp>;
  _or?: InputMaybe<Array<UserRole_Bool_Exp>>;
  userRoles?: InputMaybe<UserRoles_Bool_Exp>;
  userRoles_aggregate?: InputMaybe<UserRoles_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "userRole" */
export enum UserRole_Constraint {
  /** unique or primary key constraint on columns "value" */
  UserRolePkey = 'userRole_pkey'
}

export enum UserRole_Enum {
  Admin = 'admin',
  Anonymous = 'anonymous',
  BuildingManager = 'buildingManager',
  Employee = 'employee',
  Provider = 'provider',
  User = 'user'
}

/** Boolean expression to compare columns of type "userRole_enum". All fields are combined with logical 'AND'. */
export type UserRole_Enum_Comparison_Exp = {
  _eq?: InputMaybe<UserRole_Enum>;
  _in?: InputMaybe<Array<UserRole_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<UserRole_Enum>;
  _nin?: InputMaybe<Array<UserRole_Enum>>;
};

/** input type for inserting data into table "userRole" */
export type UserRole_Insert_Input = {
  userRoles?: InputMaybe<UserRoles_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type UserRole_Max_Fields = {
  __typename?: 'userRole_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type UserRole_Min_Fields = {
  __typename?: 'userRole_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "userRole" */
export type UserRole_Mutation_Response = {
  __typename?: 'userRole_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserRole>;
};

/** input type for inserting object relation for remote table "userRole" */
export type UserRole_Obj_Rel_Insert_Input = {
  data: UserRole_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<UserRole_On_Conflict>;
};

/** on_conflict condition type for table "userRole" */
export type UserRole_On_Conflict = {
  constraint: UserRole_Constraint;
  update_columns?: Array<UserRole_Update_Column>;
  where?: InputMaybe<UserRole_Bool_Exp>;
};

/** Ordering options when selecting data from "userRole". */
export type UserRole_Order_By = {
  userRoles_aggregate?: InputMaybe<UserRoles_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: userRole */
export type UserRole_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "userRole" */
export enum UserRole_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "userRole" */
export type UserRole_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "userRole" */
export type UserRole_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserRole_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserRole_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "userRole" */
export enum UserRole_Update_Column {
  /** column name */
  Value = 'value'
}

export type UserRole_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserRole_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserRole_Bool_Exp;
};

/** columns and relationships of "userRoles" */
export type UserRoles = {
  __typename?: 'userRoles';
  calendarId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  provider?: Maybe<Providers>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  role: UserRole_Enum;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
  /** An object relationship */
  userRole: UserRole;
};

/** aggregated selection of "userRoles" */
export type UserRoles_Aggregate = {
  __typename?: 'userRoles_aggregate';
  aggregate?: Maybe<UserRoles_Aggregate_Fields>;
  nodes: Array<UserRoles>;
};

export type UserRoles_Aggregate_Bool_Exp = {
  count?: InputMaybe<UserRoles_Aggregate_Bool_Exp_Count>;
};

export type UserRoles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<UserRoles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserRoles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "userRoles" */
export type UserRoles_Aggregate_Fields = {
  __typename?: 'userRoles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<UserRoles_Max_Fields>;
  min?: Maybe<UserRoles_Min_Fields>;
};


/** aggregate fields of "userRoles" */
export type UserRoles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserRoles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "userRoles" */
export type UserRoles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserRoles_Max_Order_By>;
  min?: InputMaybe<UserRoles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "userRoles" */
export type UserRoles_Arr_Rel_Insert_Input = {
  data: Array<UserRoles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserRoles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "userRoles". All fields are combined with a logical 'AND'. */
export type UserRoles_Bool_Exp = {
  _and?: InputMaybe<Array<UserRoles_Bool_Exp>>;
  _not?: InputMaybe<UserRoles_Bool_Exp>;
  _or?: InputMaybe<Array<UserRoles_Bool_Exp>>;
  calendarId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  provider?: InputMaybe<Providers_Bool_Exp>;
  providerId?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<UserRole_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
  userRole?: InputMaybe<UserRole_Bool_Exp>;
};

/** unique or primary key constraints on table "userRoles" */
export enum UserRoles_Constraint {
  /** unique or primary key constraint on columns "userId" */
  UserRolesPkey = 'userRoles_pkey'
}

/** input type for inserting data into table "userRoles" */
export type UserRoles_Insert_Input = {
  calendarId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  provider?: InputMaybe<Providers_Obj_Rel_Insert_Input>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<UserRole_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  userRole?: InputMaybe<UserRole_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type UserRoles_Max_Fields = {
  __typename?: 'userRoles_max_fields';
  calendarId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "userRoles" */
export type UserRoles_Max_Order_By = {
  calendarId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserRoles_Min_Fields = {
  __typename?: 'userRoles_min_fields';
  calendarId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "userRoles" */
export type UserRoles_Min_Order_By = {
  calendarId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "userRoles" */
export type UserRoles_Mutation_Response = {
  __typename?: 'userRoles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserRoles>;
};

/** input type for inserting object relation for remote table "userRoles" */
export type UserRoles_Obj_Rel_Insert_Input = {
  data: UserRoles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<UserRoles_On_Conflict>;
};

/** on_conflict condition type for table "userRoles" */
export type UserRoles_On_Conflict = {
  constraint: UserRoles_Constraint;
  update_columns?: Array<UserRoles_Update_Column>;
  where?: InputMaybe<UserRoles_Bool_Exp>;
};

/** Ordering options when selecting data from "userRoles". */
export type UserRoles_Order_By = {
  calendarId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  provider?: InputMaybe<Providers_Order_By>;
  providerId?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
  userRole?: InputMaybe<UserRole_Order_By>;
};

/** primary key columns input for table: userRoles */
export type UserRoles_Pk_Columns_Input = {
  userId: Scalars['uuid']['input'];
};

/** select columns of table "userRoles" */
export enum UserRoles_Select_Column {
  /** column name */
  CalendarId = 'calendarId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "userRoles" */
export type UserRoles_Set_Input = {
  calendarId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<UserRole_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "userRoles" */
export type UserRoles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserRoles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserRoles_Stream_Cursor_Value_Input = {
  calendarId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<UserRole_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "userRoles" */
export enum UserRoles_Update_Column {
  /** column name */
  CalendarId = 'calendarId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UserRoles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserRoles_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserRoles_Bool_Exp;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  address?: Maybe<Scalars['String']['output']>;
  apartmentNumber?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  appointmentsByEmployeeid: Array<Appointments>;
  /** An aggregate relationship */
  appointmentsByEmployeeid_aggregate: Appointments_Aggregate;
  coordinates?: Maybe<Scalars['geography']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  customers: Array<Customers>;
  /** An aggregate relationship */
  customers_aggregate: Customers_Aggregate;
  email: Scalars['String']['output'];
  /** An object relationship */
  file?: Maybe<Files>;
  id: Scalars['uuid']['output'];
  isEmailVerified: Scalars['Boolean']['output'];
  isPhoneNumberVerified: Scalars['Boolean']['output'];
  locale?: Maybe<Locale_Enum>;
  /** An object relationship */
  location?: Maybe<Locations>;
  name: Scalars['String']['output'];
  /** An object relationship */
  notifications?: Maybe<Notifications>;
  /** An array relationship */
  notificationsByUserid: Array<Notifications>;
  /** An aggregate relationship */
  notificationsByUserid_aggregate: Notifications_Aggregate;
  password: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  profilePicture?: Maybe<Files>;
  profilePictureFileId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  schedules?: Maybe<Schedule>;
  /** An array relationship */
  schedulesByEmployeeid: Array<Schedule>;
  /** An aggregate relationship */
  schedulesByEmployeeid_aggregate: Schedule_Aggregate;
  /** An array relationship */
  sentNotifications: Array<Notifications>;
  /** An aggregate relationship */
  sentNotifications_aggregate: Notifications_Aggregate;
  /** An object relationship */
  serviceEmployees?: Maybe<ServiceEmployees>;
  /** An array relationship */
  serviceEmployeesByUserid: Array<ServiceEmployees>;
  /** An aggregate relationship */
  serviceEmployeesByUserid_aggregate: ServiceEmployees_Aggregate;
  /** An object relationship */
  sessions?: Maybe<Sessions>;
  /** An array relationship */
  sessionsByUserid: Array<Sessions>;
  /** An aggregate relationship */
  sessionsByUserid_aggregate: Sessions_Aggregate;
  /** Stripe Customer Id on the platform account */
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** Stripe Payment Method Id on the platform account */
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  timeouts?: Maybe<Timeouts>;
  /** An array relationship */
  timeoutsByUserid: Array<Timeouts>;
  /** An aggregate relationship */
  timeoutsByUserid_aggregate: Timeouts_Aggregate;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  userRole?: Maybe<UserRoles>;
};


/** columns and relationships of "users" */
export type UsersAppointmentsByEmployeeidArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAppointmentsByEmployeeid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCustomersArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCustomers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNotificationsByUseridArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNotificationsByUserid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSchedulesByEmployeeidArgs = {
  distinct_on?: InputMaybe<Array<Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Schedule_Order_By>>;
  where?: InputMaybe<Schedule_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSchedulesByEmployeeid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Schedule_Order_By>>;
  where?: InputMaybe<Schedule_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSentNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSentNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersServiceEmployeesByUseridArgs = {
  distinct_on?: InputMaybe<Array<ServiceEmployees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceEmployees_Order_By>>;
  where?: InputMaybe<ServiceEmployees_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersServiceEmployeesByUserid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceEmployees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceEmployees_Order_By>>;
  where?: InputMaybe<ServiceEmployees_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSessionsByUseridArgs = {
  distinct_on?: InputMaybe<Array<Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sessions_Order_By>>;
  where?: InputMaybe<Sessions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSessionsByUserid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sessions_Order_By>>;
  where?: InputMaybe<Sessions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTimeoutsByUseridArgs = {
  distinct_on?: InputMaybe<Array<Timeouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Timeouts_Order_By>>;
  where?: InputMaybe<Timeouts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTimeoutsByUserid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Timeouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Timeouts_Order_By>>;
  where?: InputMaybe<Timeouts_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  apartmentNumber?: InputMaybe<String_Comparison_Exp>;
  appointmentsByEmployeeid?: InputMaybe<Appointments_Bool_Exp>;
  appointmentsByEmployeeid_aggregate?: InputMaybe<Appointments_Aggregate_Bool_Exp>;
  coordinates?: InputMaybe<Geography_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  customers?: InputMaybe<Customers_Bool_Exp>;
  customers_aggregate?: InputMaybe<Customers_Aggregate_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isEmailVerified?: InputMaybe<Boolean_Comparison_Exp>;
  isPhoneNumberVerified?: InputMaybe<Boolean_Comparison_Exp>;
  locale?: InputMaybe<Locale_Enum_Comparison_Exp>;
  location?: InputMaybe<Locations_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  notificationsByUserid?: InputMaybe<Notifications_Bool_Exp>;
  notificationsByUserid_aggregate?: InputMaybe<Notifications_Aggregate_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  phoneNumber?: InputMaybe<String_Comparison_Exp>;
  profilePicture?: InputMaybe<Files_Bool_Exp>;
  profilePictureFileId?: InputMaybe<Uuid_Comparison_Exp>;
  schedules?: InputMaybe<Schedule_Bool_Exp>;
  schedulesByEmployeeid?: InputMaybe<Schedule_Bool_Exp>;
  schedulesByEmployeeid_aggregate?: InputMaybe<Schedule_Aggregate_Bool_Exp>;
  sentNotifications?: InputMaybe<Notifications_Bool_Exp>;
  sentNotifications_aggregate?: InputMaybe<Notifications_Aggregate_Bool_Exp>;
  serviceEmployees?: InputMaybe<ServiceEmployees_Bool_Exp>;
  serviceEmployeesByUserid?: InputMaybe<ServiceEmployees_Bool_Exp>;
  serviceEmployeesByUserid_aggregate?: InputMaybe<ServiceEmployees_Aggregate_Bool_Exp>;
  sessions?: InputMaybe<Sessions_Bool_Exp>;
  sessionsByUserid?: InputMaybe<Sessions_Bool_Exp>;
  sessionsByUserid_aggregate?: InputMaybe<Sessions_Aggregate_Bool_Exp>;
  stripeCustomerId?: InputMaybe<String_Comparison_Exp>;
  stripePaymentMethodId?: InputMaybe<String_Comparison_Exp>;
  timeouts?: InputMaybe<Timeouts_Bool_Exp>;
  timeoutsByUserid?: InputMaybe<Timeouts_Bool_Exp>;
  timeoutsByUserid_aggregate?: InputMaybe<Timeouts_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userRole?: InputMaybe<UserRoles_Bool_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey',
  /** unique or primary key constraint on columns "profilePictureFileId" */
  UsersProfilePictureKey = 'users_profilePicture_key',
  /** unique or primary key constraint on columns "stripeCustomerId" */
  UsersStripeCustomerIdKey = 'users_stripeCustomerId_key',
  /** unique or primary key constraint on columns "stripePaymentMethodId" */
  UsersStripePaymentMethodIdKey = 'users_stripePaymentMethodId_key'
}

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  appointmentsByEmployeeid?: InputMaybe<Appointments_Arr_Rel_Insert_Input>;
  coordinates?: InputMaybe<Scalars['geography']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customers?: InputMaybe<Customers_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isPhoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Locale_Enum>;
  location?: InputMaybe<Locations_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<Notifications_Obj_Rel_Insert_Input>;
  notificationsByUserid?: InputMaybe<Notifications_Arr_Rel_Insert_Input>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  profilePictureFileId?: InputMaybe<Scalars['uuid']['input']>;
  schedules?: InputMaybe<Schedule_Obj_Rel_Insert_Input>;
  schedulesByEmployeeid?: InputMaybe<Schedule_Arr_Rel_Insert_Input>;
  sentNotifications?: InputMaybe<Notifications_Arr_Rel_Insert_Input>;
  serviceEmployees?: InputMaybe<ServiceEmployees_Obj_Rel_Insert_Input>;
  serviceEmployeesByUserid?: InputMaybe<ServiceEmployees_Arr_Rel_Insert_Input>;
  sessions?: InputMaybe<Sessions_Obj_Rel_Insert_Input>;
  sessionsByUserid?: InputMaybe<Sessions_Arr_Rel_Insert_Input>;
  /** Stripe Customer Id on the platform account */
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  /** Stripe Payment Method Id on the platform account */
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  timeouts?: InputMaybe<Timeouts_Obj_Rel_Insert_Input>;
  timeoutsByUserid?: InputMaybe<Timeouts_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userRole?: InputMaybe<UserRoles_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  apartmentNumber?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePictureFileId?: Maybe<Scalars['uuid']['output']>;
  /** Stripe Customer Id on the platform account */
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** Stripe Payment Method Id on the platform account */
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  apartmentNumber?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePictureFileId?: Maybe<Scalars['uuid']['output']>;
  /** Stripe Customer Id on the platform account */
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** Stripe Payment Method Id on the platform account */
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  address?: InputMaybe<Order_By>;
  apartmentNumber?: InputMaybe<Order_By>;
  appointmentsByEmployeeid_aggregate?: InputMaybe<Appointments_Aggregate_Order_By>;
  coordinates?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  customers_aggregate?: InputMaybe<Customers_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  id?: InputMaybe<Order_By>;
  isEmailVerified?: InputMaybe<Order_By>;
  isPhoneNumberVerified?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  location?: InputMaybe<Locations_Order_By>;
  name?: InputMaybe<Order_By>;
  notifications?: InputMaybe<Notifications_Order_By>;
  notificationsByUserid_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  password?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  profilePicture?: InputMaybe<Files_Order_By>;
  profilePictureFileId?: InputMaybe<Order_By>;
  schedules?: InputMaybe<Schedule_Order_By>;
  schedulesByEmployeeid_aggregate?: InputMaybe<Schedule_Aggregate_Order_By>;
  sentNotifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  serviceEmployees?: InputMaybe<ServiceEmployees_Order_By>;
  serviceEmployeesByUserid_aggregate?: InputMaybe<ServiceEmployees_Aggregate_Order_By>;
  sessions?: InputMaybe<Sessions_Order_By>;
  sessionsByUserid_aggregate?: InputMaybe<Sessions_Aggregate_Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  stripePaymentMethodId?: InputMaybe<Order_By>;
  timeouts?: InputMaybe<Timeouts_Order_By>;
  timeoutsByUserid_aggregate?: InputMaybe<Timeouts_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userRole?: InputMaybe<UserRoles_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  ApartmentNumber = 'apartmentNumber',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IsEmailVerified = 'isEmailVerified',
  /** column name */
  IsPhoneNumberVerified = 'isPhoneNumberVerified',
  /** column name */
  Locale = 'locale',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  ProfilePictureFileId = 'profilePictureFileId',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripePaymentMethodId = 'stripePaymentMethodId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<Scalars['geography']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isPhoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Locale_Enum>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePictureFileId?: InputMaybe<Scalars['uuid']['input']>;
  /** Stripe Customer Id on the platform account */
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  /** Stripe Payment Method Id on the platform account */
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<Scalars['geography']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isPhoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Locale_Enum>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePictureFileId?: InputMaybe<Scalars['uuid']['input']>;
  /** Stripe Customer Id on the platform account */
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  /** Stripe Payment Method Id on the platform account */
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  ApartmentNumber = 'apartmentNumber',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IsEmailVerified = 'isEmailVerified',
  /** column name */
  IsPhoneNumberVerified = 'isPhoneNumberVerified',
  /** column name */
  Locale = 'locale',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  ProfilePictureFileId = 'profilePictureFileId',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  StripePaymentMethodId = 'stripePaymentMethodId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type ExportAppointmentsByDateRangeMutationVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type ExportAppointmentsByDateRangeMutation = { __typename?: 'mutation_root', exportAppointments: { __typename?: 'ExportAppointmentBase64', base64?: string | null } };

export type CancelRejectAppointmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  keepCancellationFee?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CancelRejectAppointmentMutation = { __typename?: 'mutation_root', cancelRejectAppointment: { __typename?: 'Appointment', id: string, jobStatus: string } };

export type DeleteDraftAppointmentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteDraftAppointmentMutation = { __typename?: 'mutation_root', delete_payments?: { __typename?: 'payments_mutation_response', returning: Array<{ __typename?: 'payments', id: any }> } | null, delete_appointmentPricing?: { __typename?: 'appointmentPricing_mutation_response', returning: Array<{ __typename?: 'appointmentPricing', id: any }> } | null, delete_serviceOptionAnswers?: { __typename?: 'serviceOptionAnswers_mutation_response', returning: Array<{ __typename?: 'serviceOptionAnswers', id: any }> } | null, delete_formAnswers?: { __typename?: 'formAnswers_mutation_response', returning: Array<{ __typename?: 'formAnswers', id: any }> } | null, delete_appointments?: { __typename?: 'appointments_mutation_response', returning: Array<{ __typename?: 'appointments', id: any }> } | null };

export type CreateAppointmentUserMutationVariables = Exact<{
  input: CreateAppointmentUserDtoArgs;
}>;


export type CreateAppointmentUserMutation = { __typename?: 'mutation_root', createAppointmentUser: { __typename?: 'CreateApptUser', id: string } };

export type ModifyAppointmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: ModifyAppointmentDtoArgs;
}>;


export type ModifyAppointmentMutation = { __typename?: 'mutation_root', modifyAppointment: { __typename?: 'Appointment', id: string, employeeId: string, serviceId: string, locationId: string, address?: string | null, startDate: string, endDate: string, jobStatus: string, coordinates?: { __typename?: 'GeographyCoordinates', type: string, coordinates: Array<number> } | null } };

export type CreateAppointmentAnonymousMutationVariables = Exact<{
  input: CreateAppointmentAnonymousDtoArgs;
}>;


export type CreateAppointmentAnonymousMutation = { __typename?: 'mutation_root', createAppointmentAnonymous: { __typename?: 'CreateApptUser', id: string } };

export type AppointmentPaymentDetailsQueryVariables = Exact<{
  appointmentId: Scalars['String']['input'];
}>;


export type AppointmentPaymentDetailsQuery = { __typename?: 'query_root', getAppointmentPaymentDetails: { __typename?: 'GetAppointmentPaymentDetails', options: number, serviceFee: number, taxes: number, travelFees: number } };

export type PayBookedAppointmentMutationVariables = Exact<{
  appointmentId: Scalars['String']['input'];
}>;


export type PayBookedAppointmentMutation = { __typename?: 'mutation_root', payBookedAppointment: string };

export type CanProviderReceivePaymentsQueryVariables = Exact<{
  providerId: Scalars['String']['input'];
}>;


export type CanProviderReceivePaymentsQuery = { __typename?: 'query_root', canProviderReceivePayments: boolean };

export type RenewTokensMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type RenewTokensMutation = { __typename?: 'mutation_root', refreshTokens: { __typename?: 'UserSessionDto', accessToken: string, refreshToken: string } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'mutation_root', logout: { __typename?: 'LogoutDto', deletedSessions: Array<{ __typename?: 'SessionUserId', id: string }> } };

export type RegisterProviderMutationVariables = Exact<{
  providerAddress: Scalars['String']['input'];
  providerCategory: Scalars['String']['input'];
  providerEmail: Scalars['String']['input'];
  providerName: Scalars['String']['input'];
  providerPhone: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
  userName: Scalars['String']['input'];
  userPassword: Scalars['String']['input'];
  userPhone: Scalars['String']['input'];
}>;


export type RegisterProviderMutation = { __typename?: 'mutation_root', registerProvider: { __typename?: 'UserSessionDto', accessToken: string, refreshToken: string } };

export type RequestVerifyPhoneNumberMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestVerifyPhoneNumberMutation = { __typename?: 'mutation_root', requestVerifyPhoneNumber: string };

export type VerifyPhoneNumberTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type VerifyPhoneNumberTokenMutation = { __typename?: 'mutation_root', verifyPhoneNumber: string };

export type RequestVerifyEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestVerifyEmailMutation = { __typename?: 'mutation_root', requestVerifyEmail: string };

export type VerifyEmailTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type VerifyEmailTokenMutation = { __typename?: 'mutation_root', verifyEmail: string };

export type GetCheckoutSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type GetCheckoutSessionMutation = { __typename?: 'mutation_root', getCheckoutSession: { __typename?: 'CheckoutSesssionDto', id: string, token: string } };

export type DeleteCheckoutSessionMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type DeleteCheckoutSessionMutation = { __typename?: 'mutation_root', cancelCheckoutSession: string };

export type CreateBuildingManagerMutationVariables = Exact<{
  input: BuildingManagerRegisterInputDto;
}>;


export type CreateBuildingManagerMutation = { __typename?: 'mutation_root', registerBuildingManager: { __typename?: 'UserSessionDto', accessToken: string, refreshToken: string } };

export type UpdateBuildingManagerMutationVariables = Exact<{
  buildingManagerId: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
}>;


export type UpdateBuildingManagerMutation = { __typename?: 'mutation_root', buildingManager?: { __typename?: 'users', id: any, name: string, phoneNumber?: string | null } | null };

export type GetBuildingManagerSettingsQueryVariables = Exact<{
  buildingManagerId: Scalars['uuid']['input'];
}>;


export type GetBuildingManagerSettingsQuery = { __typename?: 'query_root', building: Array<{ __typename?: 'locations', id: any, name: string, address: string, coordinates: any, partnershipDefaultStatus?: PartnershipStatus_Enum | null }>, buildingManager?: { __typename?: 'users', id: any, name: string, email: string, phoneNumber?: string | null } | null };

export type UpdatePartnershipDefaultStatusMutationVariables = Exact<{
  buildingId: Scalars['uuid']['input'];
  partnershipDefaultStatus?: InputMaybe<PartnershipStatus_Enum>;
}>;


export type UpdatePartnershipDefaultStatusMutation = { __typename?: 'mutation_root', update_locations_by_pk?: { __typename?: 'locations', id: any, partnershipDefaultStatus?: PartnershipStatus_Enum | null } | null };

export type GetBuildingByBuildingManagerIdQueryVariables = Exact<{
  buildingManagerId: Scalars['uuid']['input'];
}>;


export type GetBuildingByBuildingManagerIdQuery = { __typename?: 'query_root', buildingManager: Array<{ __typename?: 'users', id: any, building?: { __typename?: 'locations', id: any, name: string, address: string, coordinates: any } | null }> };

export type GetCustomerCardQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GetCustomerCardQuery = { __typename?: 'query_root', CustomerCard?: { __typename?: 'CustomerCardDto', id: string, brand: string, expMonth: number, expYear: number, last4: string, name?: string | null } | null };

export type CreateCustomerSetupIntentMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  confirmationTokenId: Scalars['String']['input'];
}>;


export type CreateCustomerSetupIntentMutation = { __typename?: 'mutation_root', createCustomerSetupIntent: { __typename?: 'SetupCustomerIntentDto', clientSecret: string, status: string } };

export type DeleteCustomerPaymentMethodMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type DeleteCustomerPaymentMethodMutation = { __typename?: 'mutation_root', deleteCustomerPaymentMethod: { __typename?: 'DeleteCustomerPaymentMethodDto', id: string } };

export type GetBuildingCustomersQueryVariables = Exact<{
  searchByName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetBuildingCustomersQuery = { __typename?: 'query_root', getBMCustomerList: { __typename?: 'BuildingManagerCustomerListDto', filteredCustomers: Array<{ __typename?: 'BuildingManagerCustomerListEntryDto', id: string, name?: string | null, email?: string | null, isBlocked: boolean, locationId?: string | null, address?: string | null, apartmentNumber?: string | null, phoneNumber?: string | null, stripePaymentMethodId?: string | null, bmStripePaymentMethodId?: string | null, coordinates?: { __typename?: 'GeographyCoordinates', coordinates: Array<number> } | null, user?: { __typename?: 'CustomerUserDto', id: string, name: string, email: string, phoneNumber?: string | null, address?: string | null, profilePicture?: { __typename?: 'ProfilePictureDto', id: string, name: string } | null, coordinates?: { __typename?: 'GeographyCoordinates', coordinates: Array<number> } | null } | null, bookings?: { __typename?: 'Aggregate', aggregate: { __typename?: 'Count', count: number } } | null, amountSpent?: { __typename?: 'Amount', amount?: number | null } | null }>, filteredCustomersAggregate: { __typename?: 'Aggregate', aggregate: { __typename?: 'Count', count: number } }, allAppointmentsAggregate: { __typename?: 'Aggregate', aggregate: { __typename?: 'Count', count: number } }, allCustomersAggregate: { __typename?: 'Aggregate', aggregate: { __typename?: 'Count', count: number } } } };

export type GetBasicCustomerDetailsByIdQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GetBasicCustomerDetailsByIdQuery = { __typename?: 'query_root', getBMCustomerDetails?: { __typename?: 'BuildingManagerCustomerWithAppointmentsDto', id: string, name?: string | null, email?: string | null, phoneNumber?: string | null, address?: string | null, apartmentNumber?: string | null, bmStripePaymentMethodId?: string | null, coordinates?: { __typename?: 'GeographyCoordinates', coordinates: Array<number> } | null, user?: { __typename?: 'CustomerUserDto', id: string, name: string, email: string, phoneNumber?: string | null, address?: string | null, coordinates?: { __typename?: 'GeographyCoordinates', coordinates: Array<number> } | null } | null } | null };

export type GetCustomerDetailsByIdQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
  buildingManagerId: Scalars['uuid']['input'];
}>;


export type GetCustomerDetailsByIdQuery = { __typename?: 'query_root', getBMCustomerDetails?: { __typename?: 'BuildingManagerCustomerWithAppointmentsDto', id: string, address?: string | null, apartmentNumber?: string | null, createdAt: string, deletedAt?: string | null, email?: string | null, locationId?: string | null, name?: string | null, phoneNumber?: string | null, bmStripePaymentMethodId?: string | null, bmStripeCustomerId?: string | null, coordinates?: { __typename?: 'GeographyCoordinates', coordinates: Array<number> } | null, user?: { __typename?: 'CustomerUserDto', id: string, email: string, name: string, phoneNumber?: string | null, createdAt: string, address?: string | null, apartmentNumber?: string | null, profilePicture?: { __typename?: 'ProfilePictureDto', id: string, name: string } | null, coordinates?: { __typename?: 'GeographyCoordinates', coordinates: Array<number> } | null } | null } | null, buildingManager: Array<{ __typename?: 'users', building?: { __typename?: 'locations', id: any, name: string, address: string, type: LocationType_Enum } | null }> };

export type GetCustomerAppointmentsByIdQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
  appointmentsLimit: Scalars['Float']['input'];
  appointmentsOffset: Scalars['Float']['input'];
}>;


export type GetCustomerAppointmentsByIdQuery = { __typename?: 'query_root', getBMCustomerDetails?: { __typename?: 'BuildingManagerCustomerWithAppointmentsDto', appointments: Array<{ __typename?: 'CustomerAppointmentData', id: string, createdAt: string, endDate: string, startDate: string, updatedAt: string, jobStatus: string, paymentStatus: string, service: { __typename?: 'AppointmentServiceDto', sku: string, provider: { __typename?: 'ServiceProviderDto', id: string, name: string } }, location: { __typename?: 'AppointmentLocationDto', id: string, address: string, radius?: number | null }, payments_aggregate?: { __typename?: 'AggregateSum', aggregate: { __typename?: 'Sum', sum: { __typename?: 'Amount', amount?: number | null } } } | null }>, appointmentsAggregate: { __typename?: 'Aggregate', aggregate: { __typename?: 'Count', count: number } } } | null };

export type FindCustomerByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type FindCustomerByIdQuery = { __typename?: 'query_root', providers_by_pk?: { __typename?: 'providers', phoneNumber: string, name: string, id: any, email: string, address: string, stripeCustomerId?: string | null, stripePaymentMethodId?: string | null } | null };

export type UpdateBuildingRelationshipStatusMutationVariables = Exact<{
  providerId: Scalars['uuid']['input'];
  relationshipStatus: RelationshipStatus_Enum;
}>;


export type UpdateBuildingRelationshipStatusMutation = { __typename?: 'mutation_root', update_buildingProviders?: { __typename?: 'buildingProviders_mutation_response', returning: Array<{ __typename?: 'buildingProviders', id: any, locationId: any, providerId: any, status: RelationshipStatus_Enum }> } | null };

export type UpdateBuildingRelationshipStatusByPkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  relationshipStatus: RelationshipStatus_Enum;
}>;


export type UpdateBuildingRelationshipStatusByPkMutation = { __typename?: 'mutation_root', update_buildingProviders_by_pk?: { __typename?: 'buildingProviders', id: any, locationId: any, providerId: any, status: RelationshipStatus_Enum } | null };

export type GetBuildingServicesQueryVariables = Exact<{
  searchByName: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetBuildingServicesQuery = { __typename?: 'query_root', services: Array<{ __typename?: 'services', id: any, name: string, sku: string, duration?: any | null, servicePricing?: { __typename?: 'servicePricings', id: any, basePrice?: any | null } | null, serviceOptions: Array<{ __typename?: 'serviceOptions', name: string, id: any, status: ServiceOptionsStatus_Enum, question: Array<{ __typename?: 'serviceOptionSection', name: string, order: any, id: any, mandatory: boolean, type: ServiceSectionOptionType_Enum, answers: Array<{ __typename?: 'serviceOptionSectionOptions', id: any, name: string, order: any, price: any, quantity: ServiceSectionOptionQuantityType_Enum, serviceOptionAnswers: Array<{ __typename?: 'serviceOptionAnswers', id: any, serviceOptionSectionOptionsId: any }> }> }> }> }> };

export type EmployeesByServiceQueryVariables = Exact<{
  serviceId: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  searchByName: Scalars['String']['input'];
}>;


export type EmployeesByServiceQuery = { __typename?: 'query_root', serviceEmployees: Array<{ __typename?: 'serviceEmployees', user: { __typename?: 'users', id: any, name: string, profilePicture?: { __typename?: 'files', id: any, name: string } | null, completedAppointments: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null } } }>, serviceEmployees_aggregate: { __typename?: 'serviceEmployees_aggregate', aggregate?: { __typename?: 'serviceEmployees_aggregate_fields', count: number } | null } };

export type GetManagerProvidersQueryVariables = Exact<{
  searchByName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetManagerProvidersQuery = { __typename?: 'query_root', buildingProviders: Array<{ __typename?: 'buildingProviders', id: any, provider: { __typename?: 'providers', id: any, name: string } }> };

export type GetBuildingProvidersByRelationshipStatusQueryVariables = Exact<{
  relationshipStatus?: InputMaybe<Array<RelationshipStatus_Enum> | RelationshipStatus_Enum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetBuildingProvidersByRelationshipStatusQuery = { __typename?: 'query_root', buildingProviders: Array<{ __typename?: 'buildingProviders', id: any, status: RelationshipStatus_Enum, provider: { __typename?: 'providers', id: any, name: string, category: ProviderCategory_Enum, email: string, phoneNumber: string, type: ProviderType_Enum, slug: string, profilePic?: any | null } }>, buildingProviders_aggregate: { __typename?: 'buildingProviders_aggregate', aggregate?: { __typename?: 'buildingProviders_aggregate_fields', count: number } | null } };

export type GetBuildingManagerRestrictedProvidersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetBuildingManagerRestrictedProvidersQuery = { __typename?: 'query_root', buildingProviders: Array<{ __typename?: 'buildingProviders', id: any, status: RelationshipStatus_Enum, provider: { __typename?: 'providers', id: any, name: string, email: string, phoneNumber: string, type: ProviderType_Enum, slug: string, profilePic?: any | null } }>, buildingProviders_aggregate: { __typename?: 'buildingProviders_aggregate', aggregate?: { __typename?: 'buildingProviders_aggregate_fields', count: number } | null } };

export type RemoveProviderRestrictionMutationVariables = Exact<{
  providerId: Scalars['uuid']['input'];
}>;


export type RemoveProviderRestrictionMutation = { __typename?: 'mutation_root', delete_buildingProviders?: { __typename?: 'buildingProviders_mutation_response', returning: Array<{ __typename?: 'buildingProviders', id: any, providerId: any, locationId: any }> } | null };

export type GetBuildingManagerDashboardQueryVariables = Exact<{
  buildingManagerId: Scalars['uuid']['input'];
  startOfToday: Scalars['timestamptz']['input'];
  endOfToday: Scalars['timestamptz']['input'];
}>;


export type GetBuildingManagerDashboardQuery = { __typename?: 'query_root', pendingServiceProviders: { __typename?: 'buildingProviders_aggregate', aggregate?: { __typename?: 'buildingProviders_aggregate_fields', count: number } | null }, todaysAppointments: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null }, nextAppointments: Array<{ __typename?: 'appointments', id: any, startDate: any, createdByUserId?: any | null, customer: { __typename?: 'customers', id: any, name?: string | null, user?: { __typename?: 'users', id: any, name: string, profilePicture?: { __typename?: 'files', id: any, name: string } | null } | null } }> };

export type BmLocationQueryVariables = Exact<{
  buildingManagerId: Scalars['uuid']['input'];
}>;


export type BmLocationQuery = { __typename?: 'query_root', buildingManager?: { __typename?: 'users', id: any, building?: { __typename?: 'locations', id: any, name: string, address: string, type: LocationType_Enum, coordinates: any } | null } | null };

export type CreateApptProvidersListQueryVariables = Exact<{
  searchByName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateApptProvidersListQuery = { __typename?: 'query_root', providers: Array<{ __typename?: 'providers', id: any, category: ProviderCategory_Enum, name: string, email: string, phoneNumber: string, address: string, createdAt?: any | null, providerPictureByProfilePic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string } } | null }>, providers_aggregate: { __typename?: 'providers_aggregate', aggregate?: { __typename?: 'providers_aggregate_fields', count: number } | null } };

export type UpdateAppointmentStatusByPkMutationVariables = Exact<{
  appointmentId: Scalars['uuid']['input'];
  jobStatus: JobStatus_Enum;
}>;


export type UpdateAppointmentStatusByPkMutation = { __typename?: 'mutation_root', update_appointments_by_pk?: { __typename?: 'appointments', id: any, jobStatus: JobStatus_Enum } | null };

export type CreateAppointmentBmMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  serviceId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
  address: Scalars['String']['input'];
  optionAnswers: Array<CreateApptServiceOptionAnswers> | CreateApptServiceOptionAnswers;
  paidBy?: InputMaybe<ApptPaidBy>;
  coordinates: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  formAnswers: Array<CreateApptServiceFormAnswers> | CreateApptServiceFormAnswers;
  existingPaymentIntentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAppointmentBmMutation = { __typename?: 'mutation_root', createAppointmentBM: { __typename?: 'CreateApptBM', id: string } };

export type CreateAppointmentPaymentIntentMutationVariables = Exact<{
  serviceId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  optionAnswers: Array<CreateApptServiceOptionAnswers> | CreateApptServiceOptionAnswers;
}>;


export type CreateAppointmentPaymentIntentMutation = { __typename?: 'mutation_root', createAppointmentPaymentIntent: { __typename?: 'CreateAppointmentPaymentIntentDto', clientSecret: string, generatedAppointmentId: string, paymentIntentId: string, connectedAccountId: string } };

export type ServicesByCategoryQueryVariables = Exact<{ [key: string]: never; }>;


export type ServicesByCategoryQuery = { __typename?: 'query_root', getCustomerServices: Array<{ __typename?: 'CustomerServices', category: string, providers: Array<{ __typename?: 'CustomerServicesProvider', id: string, name: string, email: string, phoneNumber: string, address: string, services: Array<{ __typename?: 'CustomerServicesService', id: string, name: string, description: string, color: string, duration: number, nextAvailableDate?: string | null }> }> }> };

export type GetCustomerByIdQueryVariables = Exact<{
  customerId: Scalars['uuid']['input'];
}>;


export type GetCustomerByIdQuery = { __typename?: 'query_root', customers_by_pk?: { __typename?: 'customers', id: any, address?: string | null, apartmentNumber?: string | null, createdAt: any, deletedAt?: any | null, email?: string | null, name?: string | null, phoneNumber?: string | null, user?: { __typename?: 'users', id: any, email: string, name: string, phoneNumber?: string | null, createdAt: any, address?: string | null, apartmentNumber?: string | null, profilePicture?: { __typename?: 'files', id: any, name: string } | null } | null } | null };

export type GetCustomerAppointmentsQueryVariables = Exact<{
  customerId: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCustomerAppointmentsQuery = { __typename?: 'query_root', appointments: Array<{ __typename?: 'appointments', id: any, createdAt: any, endDate: any, startDate: any, updatedAt: any, jobStatus: JobStatus_Enum, paymentStatus: PaymentStatus_Enum, appointmentPricing?: { __typename?: 'appointmentPricing', basePrice: any, fees: any, taxes: boolean, taxRate?: any | null } | null, serviceOptionAnswers: Array<{ __typename?: 'serviceOptionAnswers', id: any, quantity?: any | null, serviceOptionSectionOption: { __typename?: 'serviceOptionSectionOptions', id: any, price: any, serviceOptionSection: { __typename?: 'serviceOptionSection', id: any, mandatory: boolean, name: string, serviceOption: { __typename?: 'serviceOptions', id: any, name: string } } } }>, service: { __typename?: 'services', id: any, sku: string, provider: { __typename?: 'providers', id: any, name: string } }, location: { __typename?: 'locations', id: any, address: string, radius?: any | null } }>, appointments_aggregate: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null } };

export type GetCustomerAppointmentsAggregateQueryVariables = Exact<{
  customerId: Scalars['uuid']['input'];
}>;


export type GetCustomerAppointmentsAggregateQuery = { __typename?: 'query_root', appointments_aggregate: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null } };

export type GetAppointmentsAggregateQueryVariables = Exact<{
  jobStatus: Array<JobStatus_Enum> | JobStatus_Enum;
}>;


export type GetAppointmentsAggregateQuery = { __typename?: 'query_root', appointments_aggregate: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null } };

export type GetAppointmentsBetweenDatesAggregateQueryVariables = Exact<{
  jobStatus: Array<JobStatus_Enum> | JobStatus_Enum;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type GetAppointmentsBetweenDatesAggregateQuery = { __typename?: 'query_root', appointments_aggregate: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null } };

export type CreateBuildingCustomerFromCreateAppointmentScreenMutationVariables = Exact<{
  input: CustomerDataInputDto;
}>;


export type CreateBuildingCustomerFromCreateAppointmentScreenMutation = { __typename?: 'mutation_root', createCustomer: { __typename?: 'Customer', id: string, name?: string | null, address?: string | null, apartmentNumber?: string | null, phoneNumber?: string | null, providerId?: string | null, locationId?: string | null, userId?: string | null, updatedAt: string, stripeCustomerId?: string | null, isBlocked: boolean, email?: string | null, deletedAt?: string | null, createdAt: string, coordinates?: { __typename?: 'GeographyCoordinates', type: string, coordinates: Array<number> } | null, user?: { __typename?: 'User', id: string, name: string, email: string, phoneNumber?: string | null, apartmentNumber?: string | null, address?: string | null, coordinates?: { __typename?: 'GeographyCoordinates', type: string, coordinates: Array<number> } | null } | null } };

export type CreateProviderCustomerFromCreateAppointmentScreenMutationVariables = Exact<{
  input: CustomerDataInputDto;
}>;


export type CreateProviderCustomerFromCreateAppointmentScreenMutation = { __typename?: 'mutation_root', createCustomer: { __typename?: 'Customer', id: string, name?: string | null, address?: string | null, apartmentNumber?: string | null, phoneNumber?: string | null, providerId?: string | null, locationId?: string | null, userId?: string | null, updatedAt: string, stripeCustomerId?: string | null, isBlocked: boolean, email?: string | null, deletedAt?: string | null, createdAt: string, coordinates?: { __typename?: 'GeographyCoordinates', type: string, coordinates: Array<number> } | null, user?: { __typename?: 'User', id: string, name: string, email: string, phoneNumber?: string | null, apartmentNumber?: string | null, address?: string | null, coordinates?: { __typename?: 'GeographyCoordinates', type: string, coordinates: Array<number> } | null } | null } };

export type CreateCustomerMutationVariables = Exact<{
  input: CustomerDataInputDto;
}>;


export type CreateCustomerMutation = { __typename?: 'mutation_root', createCustomer: { __typename?: 'Customer', address?: string | null, createdAt: string, deletedAt?: string | null, email?: string | null, id: string, name?: string | null, phoneNumber?: string | null, apartmentNumber?: string | null, providerId?: string | null, locationId?: string | null, coordinates?: { __typename?: 'GeographyCoordinates', type: string, coordinates: Array<number> } | null } };

export type UpdateCustomerByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Customers_Set_Input;
}>;


export type UpdateCustomerByIdMutation = { __typename?: 'mutation_root', update_customers_by_pk?: { __typename?: 'customers', address?: string | null, createdAt: any, deletedAt?: any | null, email?: string | null, id: any, name?: string | null, phoneNumber?: string | null } | null };

export type FindEmployeesByServiceIdAndLocationIdQueryVariables = Exact<{
  serviceId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
}>;


export type FindEmployeesByServiceIdAndLocationIdQuery = { __typename?: 'query_root', getEmployeesByServiceIdAndLocationId: Array<{ __typename?: 'Employee', id: string, name: string, profilePicture?: { __typename?: 'ProfilePicture', name: string } | null }> };

export type PublicUploadFileUrlQueryVariables = Exact<{
  file: UploadFileDto;
  token: Scalars['String']['input'];
}>;


export type PublicUploadFileUrlQuery = { __typename?: 'query_root', getPublicUploadFileUrl: { __typename?: 'UploadFileUrlDto', id: string, name: string, uploadName: string, entityType: string, signedUrl: string } };

export type UploadFileUrlQueryVariables = Exact<{
  file: UploadFileDto;
}>;


export type UploadFileUrlQuery = { __typename?: 'query_root', getUploadFileUrl: { __typename?: 'UploadFileUrlDto', id: string, name: string, uploadName: string, entityType: string, signedUrl: string } };

export type PrivateFileQueryVariables = Exact<{
  fileName: Scalars['String']['input'];
}>;


export type PrivateFileQuery = { __typename?: 'query_root', getPrivateFile: string };

export type CheckoutPrivateFileQueryVariables = Exact<{
  fileName: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type CheckoutPrivateFileQuery = { __typename?: 'query_root', getCheckoutPrivateFile: string };

export type DeleteFileMutationVariables = Exact<{
  fileId: Scalars['String']['input'];
}>;


export type DeleteFileMutation = { __typename?: 'mutation_root', deleteFile: { __typename?: 'DeleteFileDto', deletedFile: string } };

export type FileByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type FileByIdQuery = { __typename?: 'query_root', files_by_pk?: { __typename?: 'files', id: any, name: string, uploadName: string } | null };

export type CheckProviderGoogleCalendarLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckProviderGoogleCalendarLinkQuery = { __typename?: 'query_root', linked: boolean };

export type GetGoogleAuthUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGoogleAuthUrlQuery = { __typename?: 'query_root', url: string };

export type SetGoogleAuthTokensMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type SetGoogleAuthTokensMutation = { __typename?: 'mutation_root', success: boolean };

export type UnlinkGoogleCalendarMutationVariables = Exact<{ [key: string]: never; }>;


export type UnlinkGoogleCalendarMutation = { __typename?: 'mutation_root', success: boolean };

export type GetGoogleCalendarQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetGoogleCalendarQuery = { __typename?: 'query_root', calendar: { __typename?: 'CalendarListEntryDto', id?: string | null, primary?: boolean | null, summary?: string | null, description?: string | null } };

export type ListGoogleCalendarsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListGoogleCalendarsQuery = { __typename?: 'query_root', calendars: Array<{ __typename?: 'CalendarListEntryDto', id?: string | null, primary?: boolean | null, summary?: string | null, description?: string | null }> };

export type LinkCalendarMutationVariables = Exact<{
  employeeId: Scalars['String']['input'];
  calendarId: Scalars['String']['input'];
}>;


export type LinkCalendarMutation = { __typename?: 'mutation_root', success: boolean };

export type UnlinkCalendarMutationVariables = Exact<{
  employeeId: Scalars['String']['input'];
}>;


export type UnlinkCalendarMutation = { __typename?: 'mutation_root', success: boolean };

export type LocationsQueryVariables = Exact<{
  value: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LocationsQuery = { __typename?: 'query_root', locations: Array<{ __typename?: 'locations', address: string, coordinates: any, id: any, name: string, phoneNumber?: string | null, email?: string | null, radius?: any | null, status: LocationStatus_Enum, type: LocationType_Enum, additionalCities?: Array<string> | null, excludedCities?: Array<string> | null, schedules: Array<{ __typename?: 'schedule', user: { __typename?: 'users', serviceEmployeesByUserid_aggregate: { __typename?: 'serviceEmployees_aggregate', aggregate?: { __typename?: 'serviceEmployees_aggregate_fields', count: number } | null } } }>, schedules_aggregate: { __typename?: 'schedule_aggregate', aggregate?: { __typename?: 'schedule_aggregate_fields', count: number } | null } }> };

export type LocationByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type LocationByIdQuery = { __typename?: 'query_root', locations_by_pk?: { __typename?: 'locations', address: string, coordinates: any, id: any, providerId?: any | null, name: string, phoneNumber?: string | null, email?: string | null, radius?: any | null, status: LocationStatus_Enum, type: LocationType_Enum, additionalCities?: Array<string> | null, excludedCities?: Array<string> | null, schedules: Array<{ __typename?: 'schedule', user: { __typename?: 'users', serviceEmployeesByUserid_aggregate: { __typename?: 'serviceEmployees_aggregate', nodes: Array<{ __typename?: 'serviceEmployees', service: { __typename?: 'services', name: string, status: ServiceStatus_Enum, deletedAt?: any | null } }>, aggregate?: { __typename?: 'serviceEmployees_aggregate_fields', count: number } | null } } }>, schedules_aggregate: { __typename?: 'schedule_aggregate', nodes: Array<{ __typename?: 'schedule', user: { __typename?: 'users', name: string, email: string, phoneNumber?: string | null } }>, aggregate?: { __typename?: 'schedule_aggregate_fields', count: number } | null } } | null };

export type LocationsAggregateQueryVariables = Exact<{
  value: Scalars['String']['input'];
}>;


export type LocationsAggregateQuery = { __typename?: 'query_root', locations_aggregate: { __typename?: 'locations_aggregate', aggregate?: { __typename?: 'locations_aggregate_fields', count: number } | null } };

export type ProviderAtHomeLocationsListQueryVariables = Exact<{
  providerId: Scalars['uuid']['input'];
  value: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProviderAtHomeLocationsListQuery = { __typename?: 'query_root', providers_by_pk?: { __typename?: 'providers', id: any, locations: Array<{ __typename?: 'locations', id: any, address: string, coordinates: any, name: string, phoneNumber?: string | null, email?: string | null, radius?: any | null, status: LocationStatus_Enum, type: LocationType_Enum, additionalCities?: Array<string> | null, excludedCities?: Array<string> | null }>, locations_aggregate: { __typename?: 'locations_aggregate', aggregate?: { __typename?: 'locations_aggregate_fields', count: number } | null } } | null };

export type ProviderLocationsQueryVariables = Exact<{
  providerId: Scalars['uuid']['input'];
  value: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProviderLocationsQuery = { __typename?: 'query_root', buildingProviders: Array<{ __typename?: 'buildingProviders', id: any, status: RelationshipStatus_Enum, scheduleLocationId?: any | null, partnershipSchedulingType: PartnershipSchedulingType_Enum, scheduleLocation?: { __typename?: 'locations', id: any, name: string, address: string, type: LocationType_Enum } | null, location: { __typename?: 'locations', address: string, coordinates: any, id: any, name: string, phoneNumber?: string | null, email?: string | null, status: LocationStatus_Enum, type: LocationType_Enum, buildingProviders: Array<{ __typename?: 'buildingProviders', id: any, status: RelationshipStatus_Enum }>, buildingManager?: { __typename?: 'users', id: any, name: string, email: string, address?: string | null, phoneNumber?: string | null } | null } }>, providers_by_pk?: { __typename?: 'providers', id: any, locations: Array<{ __typename?: 'locations', address: string, coordinates: any, id: any, name: string, phoneNumber?: string | null, email?: string | null, radius?: any | null, status: LocationStatus_Enum, type: LocationType_Enum, additionalCities?: Array<string> | null, excludedCities?: Array<string> | null, schedules: Array<{ __typename?: 'schedule', user: { __typename?: 'users', serviceEmployeesByUserid_aggregate: { __typename?: 'serviceEmployees_aggregate', aggregate?: { __typename?: 'serviceEmployees_aggregate_fields', count: number } | null } } }>, schedules_aggregate: { __typename?: 'schedule_aggregate', aggregate?: { __typename?: 'schedule_aggregate_fields', count: number } | null } }>, locations_aggregate: { __typename?: 'locations_aggregate', aggregate?: { __typename?: 'locations_aggregate_fields', count: number } | null } } | null };

export type LocationEmployeesQueryVariables = Exact<{
  locationId: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LocationEmployeesQuery = { __typename?: 'query_root', locations_by_pk?: { __typename?: 'locations', schedules: Array<{ __typename?: 'schedule', user: { __typename?: 'users', id: any, name: string, email: string, phoneNumber?: string | null, profilePicture?: { __typename?: 'files', id: any, name: string } | null } }>, schedules_aggregate: { __typename?: 'schedule_aggregate', aggregate?: { __typename?: 'schedule_aggregate_fields', count: number } | null } } | null };

export type DeletePartnershipMutationVariables = Exact<{
  partnershipId: Scalars['uuid']['input'];
}>;


export type DeletePartnershipMutation = { __typename?: 'mutation_root', update_buildingProviders_by_pk?: { __typename?: 'buildingProviders', id: any } | null };

export type CreateLocationMutationVariables = Exact<{
  address: Scalars['String']['input'];
  coordinates: Scalars['geography']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['uuid']['input'];
  radius?: InputMaybe<Scalars['numeric']['input']>;
  status: LocationStatus_Enum;
  type: LocationType_Enum;
  additionalCities?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  excludedCities?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreateLocationMutation = { __typename?: 'mutation_root', insert_locations_one?: { __typename?: 'locations', address: string, coordinates: any, id: any, name: string, phoneNumber?: string | null, email?: string | null, providerId?: any | null, radius?: any | null, status: LocationStatus_Enum, type: LocationType_Enum, additionalCities?: Array<string> | null, excludedCities?: Array<string> | null } | null };

export type LocationServicesQueryVariables = Exact<{
  locationId: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LocationServicesQuery = { __typename?: 'query_root', locations: Array<{ __typename?: 'locations', schedules: Array<{ __typename?: 'schedule', user: { __typename?: 'users', serviceEmployeesByUserid: Array<{ __typename?: 'serviceEmployees', service: { __typename?: 'services', id: any, name: string } }>, serviceEmployeesByUserid_aggregate: { __typename?: 'serviceEmployees_aggregate', aggregate?: { __typename?: 'serviceEmployees_aggregate_fields', count: number } | null } } }> }> };

export type SearchLocationServicesQueryVariables = Exact<{
  locationId: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchByName: Scalars['String']['input'];
}>;


export type SearchLocationServicesQuery = { __typename?: 'query_root', locations: Array<{ __typename?: 'locations', schedules: Array<{ __typename?: 'schedule', user: { __typename?: 'users', serviceEmployeesByUserid: Array<{ __typename?: 'serviceEmployees', service: { __typename?: 'services', id: any, name: string } }>, serviceEmployeesByUserid_aggregate: { __typename?: 'serviceEmployees_aggregate', aggregate?: { __typename?: 'serviceEmployees_aggregate_fields', count: number } | null } } }> }> };

export type UnavailableServiceLocationsQueryVariables = Exact<{
  locationId: Scalars['uuid']['input'];
}>;


export type UnavailableServiceLocationsQuery = { __typename?: 'query_root', unavailableServiceLocations: Array<{ __typename?: 'unavailableServiceLocations', serviceId: any }> };

export type SetUnavailableServiceLocationMutationVariables = Exact<{
  locationId: Scalars['uuid']['input'];
  serviceId: Scalars['uuid']['input'];
}>;


export type SetUnavailableServiceLocationMutation = { __typename?: 'mutation_root', insert_unavailableServiceLocations_one?: { __typename?: 'unavailableServiceLocations', id: any, locationId: any, serviceId: any } | null };

export type UnsetUnavailableServiceLocationMutationVariables = Exact<{
  locationId: Scalars['uuid']['input'];
  serviceId: Scalars['uuid']['input'];
}>;


export type UnsetUnavailableServiceLocationMutation = { __typename?: 'mutation_root', delete_unavailableServiceLocations?: { __typename?: 'unavailableServiceLocations_mutation_response', affected_rows: number } | null };

export type GetLocationByAddressQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type GetLocationByAddressQuery = { __typename?: 'query_root', getLocationByAddress: { __typename?: 'LocationDto', location?: { __typename?: 'Location', id: string, address: string, buildingManagerId?: string | null, radius?: number | null, createdAt: string, deletedAt?: string | null, email?: string | null, phoneNumber?: string | null, partnershipDefaultStatus?: string | null, status: string, buildingManager?: { __typename?: 'LocationBuildingManager', id: string, name: string, email: string, phoneNumber?: string | null, profilePictureFileId?: string | null, isEmailVerified: boolean, isPhoneNumberVerified: boolean } | null, buildingProviders?: Array<{ __typename?: 'LocationBuildingProvider', id: string, providerId: string, locationId: string, partnershipSchedulingType: string }> | null, coordinates?: { __typename?: 'GeographyCoordinates', coordinates: Array<number> } | null } | null } };

export type CreateLocationPartnershipMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  partnershipSchedulingType: Scalars['String']['input'];
  scheduleLocationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateLocationPartnershipMutation = { __typename?: 'mutation_root', requestLocationPartnership: { __typename?: 'PartnershipDto', partnership: { __typename?: 'nest_buildingProviders', id: string, status?: string | null, partnershipSchedulingType: string } } };

export type UpdateBuildingMutationVariables = Exact<{
  buildingId: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateBuildingMutation = { __typename?: 'mutation_root', update_locations_by_pk?: { __typename?: 'locations', id: any, name: string } | null };

export type UpdateLocationDetailsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['numeric']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateLocationDetailsMutation = { __typename?: 'mutation_root', update_locations_by_pk?: { __typename?: 'locations', id: any } | null };

export type RestoreDeletedLocationMutationVariables = Exact<{
  locationId: Scalars['uuid']['input'];
  input: Locations_Set_Input;
}>;


export type RestoreDeletedLocationMutation = { __typename?: 'mutation_root', update_locations?: { __typename?: 'locations_mutation_response', returning: Array<{ __typename?: 'locations', id: any }> } | null };

export type FindLocationsByServiceIdQueryVariables = Exact<{
  serviceId: Scalars['String']['input'];
  coordinates?: InputMaybe<GeographyCoordinatesInput>;
}>;


export type FindLocationsByServiceIdQuery = { __typename?: 'query_root', findLocationsByServiceId: Array<{ __typename?: 'LocationWithDistance', id: string, name: string, distance?: number | null, type: string, address: string, radius?: number | null, coordinates: { __typename?: 'GeographyCoordinates', type: string, coordinates: Array<number> } }> };

export type LocationHaversineQueryVariables = Exact<{
  input: LocationHaversineInputDto;
}>;


export type LocationHaversineQuery = { __typename?: 'query_root', locationHaversine: { __typename?: 'HaversineDto', distance: number, inside?: boolean | null } };

export type GetSpLocationsListQueryVariables = Exact<{
  searchByName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  providerId: Scalars['uuid']['input'];
}>;


export type GetSpLocationsListQuery = { __typename?: 'query_root', locations: Array<{ __typename?: 'locations', id: any, name: string, address: string, type: LocationType_Enum, coordinates: any, radius?: any | null, additionalCities?: Array<string> | null, excludedCities?: Array<string> | null }> };

export type AppointmentServiceNotificationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AppointmentServiceNotificationQuery = { __typename?: 'query_root', appointments_by_pk?: { __typename?: 'appointments', service: { __typename?: 'services', id: any, color: string, name: string }, customer: { __typename?: 'customers', name?: string | null } } | null };

export type PartnershipNotificationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type PartnershipNotificationQuery = { __typename?: 'query_root', buildingProviders_by_pk?: { __typename?: 'buildingProviders', id: any, status: RelationshipStatus_Enum, provider: { __typename?: 'providers', id: any, name: string }, location: { __typename?: 'locations', address: string, name: string, buildingManager?: { __typename?: 'users', name: string } | null } } | null };

export type PaymentServiceNotificationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type PaymentServiceNotificationQuery = { __typename?: 'query_root', payments_by_pk?: { __typename?: 'payments', appointment: { __typename?: 'appointments', service: { __typename?: 'services', id: any, color: string, name: string }, customer: { __typename?: 'customers', name?: string | null } } } | null };

export type ServicesServiceNotificationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ServicesServiceNotificationQuery = { __typename?: 'query_root', services_by_pk?: { __typename?: 'services', id: any, color: string, name: string } | null };

export type NotificationsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  beforeCreatedAt: Scalars['timestamptz']['input'];
}>;


export type NotificationsQuery = { __typename?: 'query_root', notifications: Array<{ __typename?: 'notifications', id: any, entityId?: any | null, entityType?: EntityType_Enum | null, fromUserId?: any | null, toUserId: any, type: NotificationType_Enum, readAt?: any | null, viewedAt?: any | null, createdAt: any, updatedAt: any, fromUser?: { __typename?: 'users', id: any, name: string, profilePicture?: { __typename?: 'files', id: any, name: string } | null, location?: { __typename?: 'locations', name: string } | null, userRole?: { __typename?: 'userRoles', provider?: { __typename?: 'providers', id: any, name: string } | null } | null } | null }>, notifications_aggregate: { __typename?: 'notifications_aggregate', aggregate?: { __typename?: 'notifications_aggregate_fields', count: number } | null }, unreadNotificationsCount: { __typename?: 'notifications_aggregate', aggregate?: { __typename?: 'notifications_aggregate_fields', count: number } | null } };

export type NewNotificationsSubscriptionVariables = Exact<{
  afterCreatedAt: Scalars['timestamptz']['input'];
}>;


export type NewNotificationsSubscription = { __typename?: 'subscription_root', notifications_stream: Array<{ __typename?: 'notifications', id: any, entityId?: any | null, entityType?: EntityType_Enum | null, fromUserId?: any | null, toUserId: any, type: NotificationType_Enum, readAt?: any | null, viewedAt?: any | null, createdAt: any, updatedAt: any, fromUser?: { __typename?: 'users', id: any, name: string, profilePicture?: { __typename?: 'files', id: any, name: string } | null } | null }> };

export type ReadNotificationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  readAt: Scalars['timestamptz']['input'];
}>;


export type ReadNotificationMutation = { __typename?: 'mutation_root', update_notifications_by_pk?: { __typename?: 'notifications', id: any, readAt?: any | null } | null };

export type ReadAllNotificationsMutationVariables = Exact<{
  readAt: Scalars['timestamptz']['input'];
}>;


export type ReadAllNotificationsMutation = { __typename?: 'mutation_root', update_notifications?: { __typename?: 'notifications_mutation_response', returning: Array<{ __typename?: 'notifications', id: any, readAt?: any | null }> } | null };

export type ViewAllNotificationsMutationVariables = Exact<{
  viewedAt: Scalars['timestamptz']['input'];
}>;


export type ViewAllNotificationsMutation = { __typename?: 'mutation_root', update_notifications?: { __typename?: 'notifications_mutation_response', returning: Array<{ __typename?: 'notifications', id: any, viewedAt?: any | null }> } | null };

export type ProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type ProvidersQuery = { __typename?: 'query_root', providers: Array<{ __typename?: 'providers', id: any, category: ProviderCategory_Enum, name: string, email: string, phoneNumber: string, address: string, createdAt?: any | null }> };

export type GetCurrentProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentProviderQuery = { __typename?: 'query_root', getCurrentProvider: { __typename?: 'Provider', id: string, category: string, name: string, email: string, phoneNumber: string, address: string, slug: string, stripeConnectAccId?: string | null, visibility: string } };

export type ProviderByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ProviderByIdQuery = { __typename?: 'query_root', providers_by_pk?: { __typename?: 'providers', id: any, category: ProviderCategory_Enum, name: string, email: string, phoneNumber: string, bookingCancelationWarningPeriod?: number | null, address: string, createdAt?: any | null } | null };

export type FormsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FormsQuery = { __typename?: 'query_root', form: Array<{ __typename?: 'form', id: any, name: string, servicesForms: Array<{ __typename?: 'servicesForms', service: { __typename?: 'services', id: any, name: string } }>, formQuestions_aggregate: { __typename?: 'formQuestions_aggregate', aggregate?: { __typename?: 'formQuestions_aggregate_fields', count: number } | null }, formQuestions: Array<{ __typename?: 'formQuestions', id: any, description?: string | null, label: string, mandatory: boolean, name?: string | null, order: any, questionType: FormQuestionType_Enum, formQuestionOptions: Array<{ __typename?: 'formQuestionOptions', id: any, value: string }> }> }>, form_aggregate: { __typename?: 'form_aggregate', aggregate?: { __typename?: 'form_aggregate_fields', count: number } | null } };

export type GetFormListByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetFormListByIdQuery = { __typename?: 'query_root', form_by_pk?: { __typename?: 'form', id: any, createdAt: any, deletedAt?: any | null, name: string, updatedAt: any, providerId: any } | null, formQuestions: Array<{ __typename?: 'formQuestions', description?: string | null, formId: any, id: any, label: string, mandatory: boolean, name?: string | null, order: any, questionType: FormQuestionType_Enum, deletedAt?: any | null }> };

export type GetFormQuestionsQueryVariables = Exact<{
  formId: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFormQuestionsQuery = { __typename?: 'query_root', formQuestions: Array<{ __typename?: 'formQuestions', id: any, name?: string | null }>, formQuestions_aggregate: { __typename?: 'formQuestions_aggregate', aggregate?: { __typename?: 'formQuestions_aggregate_fields', count: number } | null } };

export type CreateFormMutationVariables = Exact<{
  name: Scalars['String']['input'];
  questions: Array<FormQuestions_Insert_Input> | FormQuestions_Insert_Input;
}>;


export type CreateFormMutation = { __typename?: 'mutation_root', insert_form_one?: { __typename?: 'form', id: any, name: string, formQuestions: Array<{ __typename?: 'formQuestions', id: any, description?: string | null, formId: any, label: string, mandatory: boolean, name?: string | null, order: any, questionType: FormQuestionType_Enum, formQuestionOptions: Array<{ __typename?: 'formQuestionOptions', id: any, value: string }> }> } | null };

export type UpdateFormNameMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateFormNameMutation = { __typename?: 'mutation_root', update_form_by_pk?: { __typename?: 'form', id: any, name: string } | null };

export type UpdateFormMutationVariables = Exact<{
  deletedFormQuestionsIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  input: Array<FormQuestions_Insert_Input> | FormQuestions_Insert_Input;
}>;


export type UpdateFormMutation = { __typename?: 'mutation_root', deletedFormQuestions?: { __typename?: 'formQuestions_mutation_response', returning: Array<{ __typename?: 'formQuestions', id: any, deletedAt?: any | null }> } | null, createdFormQuestions?: { __typename?: 'formQuestions_mutation_response', returning: Array<{ __typename?: 'formQuestions', id: any, formId: any, description?: string | null, label: string, mandatory: boolean, name?: string | null, order: any, questionType: FormQuestionType_Enum, formQuestionOptions: Array<{ __typename?: 'formQuestionOptions', id: any, formQuestionId: any, value: string }> }> } | null };

export type GetFormActiveServicesQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetFormActiveServicesQuery = { __typename?: 'query_root', form_by_pk?: { __typename?: 'form', id: any, name: string, servicesForms: Array<{ __typename?: 'servicesForms', id: any, status: ServiceFormStatus_Enum }> } | null };

export type DeleteFormMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteFormMutation = { __typename?: 'mutation_root', deletedForm?: { __typename?: 'form', id: any, deletedAt?: any | null } | null, deletedServiceForms?: { __typename?: 'servicesForms_mutation_response', returning: Array<{ __typename?: 'servicesForms', id: any }> } | null };

export type CreateServiceFormsMutationVariables = Exact<{
  name: Scalars['String']['input'];
  providerId: Scalars['uuid']['input'];
  questions: Array<FormQuestions_Insert_Input> | FormQuestions_Insert_Input;
}>;


export type CreateServiceFormsMutation = { __typename?: 'mutation_root', insert_form_one?: { __typename?: 'form', id: any, name: string, formQuestions: Array<{ __typename?: 'formQuestions', description?: string | null, label: string, mandatory: boolean, name?: string | null, order: any, questionType: FormQuestionType_Enum }> } | null };

export type UpdateFormListByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  questions: Array<FormQuestions_Insert_Input> | FormQuestions_Insert_Input;
}>;


export type UpdateFormListByIdMutation = { __typename?: 'mutation_root', update_form_by_pk?: { __typename?: 'form', id: any, name: string, updatedAt: any, deletedAt?: any | null, createdAt: any } | null, insert_formQuestions?: { __typename?: 'formQuestions_mutation_response', affected_rows: number } | null };

export type CreateStripeConnectedAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateStripeConnectedAccountMutation = { __typename?: 'mutation_root', createConnectedAccount: { __typename?: 'AccountLinkDto', created: number, expires_at: number, object: string, url: string } };

export type IsStripeOnboardingCompletedQueryVariables = Exact<{ [key: string]: never; }>;


export type IsStripeOnboardingCompletedQuery = { __typename?: 'query_root', isOnboardingCompleted: { __typename?: 'OnboardingCompletedDto', onboardingCompleted: boolean, businessAcc?: string | null, payoutsSchedule?: { __typename?: 'PayoutsScheduleDto', delayDays: number, interval: string } | null, companyAddress?: { __typename?: 'CompanyAddressDto', country: string, state: string, city: string, address: string } | null } };

export type ProviderEmployeesQueryVariables = Exact<{
  searchByName: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type ProviderEmployeesQuery = { __typename?: 'query_root', userRoles_aggregate: { __typename?: 'userRoles_aggregate', aggregate?: { __typename?: 'userRoles_aggregate_fields', count: number } | null }, userRoles: Array<{ __typename?: 'userRoles', user: { __typename?: 'users', id: any, name: string, email: string, phoneNumber?: string | null, profilePicture?: { __typename?: 'files', id: any, name: string } | null, serviceEmployeesByUserid: Array<{ __typename?: 'serviceEmployees', serviceId: any }> } }> };

export type ServicePicturesQueryVariables = Exact<{
  serviceId: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type ServicePicturesQuery = { __typename?: 'query_root', servicePictures: Array<{ __typename?: 'servicePictures', id: any, name: string, size: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } }>, servicePictures_aggregate: { __typename?: 'servicePictures_aggregate', aggregate?: { __typename?: 'servicePictures_aggregate_fields', count: number } | null } };

export type AddServicePicturesMutationVariables = Exact<{
  servicePictures: Array<ServicePictures_Insert_Input> | ServicePictures_Insert_Input;
}>;


export type AddServicePicturesMutation = { __typename?: 'mutation_root', insert_servicePictures?: { __typename?: 'servicePictures_mutation_response', returning: Array<{ __typename?: 'servicePictures', id: any, name: string, size: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } }> } | null };

export type DeleteServicePicturesMutationVariables = Exact<{
  servicePicturesIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteServicePicturesMutation = { __typename?: 'mutation_root', delete_servicePictures?: { __typename?: 'servicePictures_mutation_response', returning: Array<{ __typename?: 'servicePictures', id: any, name: string, size: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } }> } | null };

export type GetCustomersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchByName: Scalars['String']['input'];
  providerId: Scalars['uuid']['input'];
}>;


export type GetCustomersQuery = { __typename?: 'query_root', customers: Array<{ __typename?: 'customers', id: any, name?: string | null, email?: string | null, isBlocked: boolean, address?: string | null, phoneNumber?: string | null, providerId?: any | null, user?: { __typename?: 'users', id: any, name: string, email: string, phoneNumber?: string | null, address?: string | null, profilePicture?: { __typename?: 'files', id: any, name: string } | null } | null, bookings: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null }, amountSpent?: { __typename?: 'customerAmountSpent', amount?: any | null } | null }>, customers_aggregate: { __typename?: 'customers_aggregate', aggregate?: { __typename?: 'customers_aggregate_fields', count: number } | null } };

export type GetProviderAndPartneredBmCustomersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchByName: Scalars['String']['input'];
}>;


export type GetProviderAndPartneredBmCustomersQuery = { __typename?: 'query_root', customers: Array<{ __typename?: 'customers', id: any, name?: string | null, email?: string | null, isBlocked: boolean, address?: string | null, coordinates?: any | null, apartmentNumber?: string | null, userId?: any | null, phoneNumber?: string | null, location?: { __typename?: 'locations', id: any, name: string, address: string } | null, user?: { __typename?: 'users', id: any, name: string, email: string, phoneNumber?: string | null, address?: string | null, coordinates?: any | null, apartmentNumber?: string | null, profilePicture?: { __typename?: 'files', id: any, name: string } | null } | null, bookings: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null }, amountSpent?: { __typename?: 'customerAmountSpent', amount?: any | null } | null }>, customers_aggregate: { __typename?: 'customers_aggregate', aggregate?: { __typename?: 'customers_aggregate_fields', count: number } | null } };

export type GetCustomersStatsQueryVariables = Exact<{
  paymentStartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  paymentEndDate?: InputMaybe<Scalars['timestamptz']['input']>;
  providerId: Scalars['uuid']['input'];
}>;


export type GetCustomersStatsQuery = { __typename?: 'query_root', payments_aggregate: { __typename?: 'payments_aggregate', aggregate?: { __typename?: 'payments_aggregate_fields', sum?: { __typename?: 'payments_sum_fields', amount?: any | null } | null } | null }, appointments_aggregate: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null }, customers_aggregate: { __typename?: 'customers_aggregate', aggregate?: { __typename?: 'customers_aggregate_fields', count: number } | null } };

export type ProviderDataQueryVariables = Exact<{
  providerId: Scalars['uuid']['input'];
  picturesLimit: Scalars['Int']['input'];
  picturesOffset: Scalars['Int']['input'];
  blockedCustomersLimit: Scalars['Int']['input'];
  blockedCustomersOffset: Scalars['Int']['input'];
}>;


export type ProviderDataQuery = { __typename?: 'query_root', providers_by_pk?: { __typename?: 'providers', id: any, slug: string, address: string, email: string, name: string, description?: string | null, phoneNumber: string, stripeConnectAccId?: string | null, stripeClientSecret?: string | null, stripePaymentMethodId?: string | null, bookingDefaultStatus: BookingStatus_Enum, bookingCancelationWarningPeriod?: number | null, providerPictureByProfilePic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null, providerPictureByCoverPic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null, providerPictures: Array<{ __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } }>, providerPictures_aggregate: { __typename?: 'providerPictures_aggregate', aggregate?: { __typename?: 'providerPictures_aggregate_fields', count: number } | null }, blockedCustomers: Array<{ __typename?: 'customers', id: any, name?: string | null, address?: string | null, user?: { __typename?: 'users', name: string, email: string, profilePicture?: { __typename?: 'files', id: any, name: string } | null } | null, bookings: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null }, amountSpent?: { __typename?: 'customerAmountSpent', amount?: any | null } | null }>, blockedCustomersAggregate: { __typename?: 'customers_aggregate', aggregate?: { __typename?: 'customers_aggregate_fields', count: number } | null } } | null };

export type AddProviderPictureMutationVariables = Exact<{
  providerId: Scalars['uuid']['input'];
  fileId: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
}>;


export type AddProviderPictureMutation = { __typename?: 'mutation_root', insert_providerPictures_one?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string } } | null };

export type AddProviderProfilePicMutationVariables = Exact<{
  providerId: Scalars['uuid']['input'];
  providerPictureId: Scalars['uuid']['input'];
}>;


export type AddProviderProfilePicMutation = { __typename?: 'mutation_root', update_providers_by_pk?: { __typename?: 'providers', id: any, address: string, email: string, name: string, phoneNumber: string, providerPictureByProfilePic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null, providerPictureByCoverPic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null, providerPictures_aggregate: { __typename?: 'providerPictures_aggregate', aggregate?: { __typename?: 'providerPictures_aggregate_fields', count: number } | null } } | null };

export type AddProviderCoverPicMutationVariables = Exact<{
  providerId: Scalars['uuid']['input'];
  providerPictureId: Scalars['uuid']['input'];
}>;


export type AddProviderCoverPicMutation = { __typename?: 'mutation_root', update_providers_by_pk?: { __typename?: 'providers', id: any, address: string, email: string, name: string, phoneNumber: string, providerPictureByProfilePic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null, providerPictureByCoverPic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null, providerPictures_aggregate: { __typename?: 'providerPictures_aggregate', aggregate?: { __typename?: 'providerPictures_aggregate_fields', count: number } | null } } | null };

export type DeleteProviderProfilePicMutationVariables = Exact<{
  providerId: Scalars['uuid']['input'];
  providerPictureId: Scalars['uuid']['input'];
}>;


export type DeleteProviderProfilePicMutation = { __typename?: 'mutation_root', update_providers_by_pk?: { __typename?: 'providers', id: any, address: string, email: string, name: string, phoneNumber: string, providerPictureByProfilePic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null, providerPictureByCoverPic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null, providerPictures_aggregate: { __typename?: 'providerPictures_aggregate', aggregate?: { __typename?: 'providerPictures_aggregate_fields', count: number } | null } } | null, delete_providerPictures_by_pk?: { __typename?: 'providerPictures', id: any } | null };

export type DeleteProviderCoverPicMutationVariables = Exact<{
  providerId: Scalars['uuid']['input'];
  providerPictureId: Scalars['uuid']['input'];
}>;


export type DeleteProviderCoverPicMutation = { __typename?: 'mutation_root', update_providers_by_pk?: { __typename?: 'providers', id: any, address: string, email: string, name: string, phoneNumber: string, providerPictureByProfilePic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null, providerPictureByCoverPic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null, providerPictures_aggregate: { __typename?: 'providerPictures_aggregate', aggregate?: { __typename?: 'providerPictures_aggregate_fields', count: number } | null } } | null, delete_providerPictures_by_pk?: { __typename?: 'providerPictures', id: any } | null };

export type DeleteProviderPicturesMutationVariables = Exact<{
  providerPicturesIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteProviderPicturesMutation = { __typename?: 'mutation_root', delete_providerPictures?: { __typename?: 'providerPictures_mutation_response', returning: Array<{ __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } }> } | null };

export type AddProviderPicturesMutationVariables = Exact<{
  providerPictures: Array<ProviderPictures_Insert_Input> | ProviderPictures_Insert_Input;
}>;


export type AddProviderPicturesMutation = { __typename?: 'mutation_root', insert_providerPictures?: { __typename?: 'providerPictures_mutation_response', returning: Array<{ __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } }> } | null };

export type PayoutsQueryVariables = Exact<{
  limit: Scalars['Float']['input'];
  startingAfter?: InputMaybe<Scalars['String']['input']>;
}>;


export type PayoutsQuery = { __typename?: 'query_root', payouts: { __typename?: 'PayoutsDto', totalCount: number, data: Array<{ __typename?: 'PayoutDto', id: string, date: any, amountCaptured: number, fees: number, status: string }> } };

export type AppointmentPricingFragment = { __typename?: 'appointments', appointmentPricing?: { __typename?: 'appointmentPricing', id: any, basePrice: any, taxes: boolean, taxRate?: any | null, checkoutPayment: any, fees: any, minimumDeposit?: any | null } | null };

export type AppointmentPaymentsFragment = { __typename?: 'appointments', payments: Array<{ __typename?: 'payments', id: any, amount: any, currency: Currencies_Enum, description?: string | null, status: PaymentStatus_Enum, sources: any, refund: Array<{ __typename?: 'refunds', id: any, amount: any, currency: string, status: PaymentStatus_Enum }> }> };

export type AppointmentFormAnswersFragment = { __typename?: 'appointments', formAnswers: Array<{ __typename?: 'formAnswers', id: any, answer?: string | null, formId: any, formQuestionId: any, optionId?: any | null, fileId?: any | null, form: { __typename?: 'form', id: any, name: string }, formQuestion: { __typename?: 'formQuestions', id: any, label: string, questionType: FormQuestionType_Enum }, file?: { __typename?: 'files', id: any, name: string, uploadName: string } | null, option?: { __typename?: 'formQuestionOptions', id: any, value: string } | null }> };

export type AppointmentServiceOptionAnswersFragment = { __typename?: 'appointments', serviceOptionAnswers: Array<{ __typename?: 'serviceOptionAnswers', id: any, quantity?: any | null, serviceOptionSectionOption: { __typename?: 'serviceOptionSectionOptions', id: any, price: any, name: string, serviceOptionSection: { __typename?: 'serviceOptionSection', id: any, name: string, serviceOption: { __typename?: 'serviceOptions', id: any, name: string, status: ServiceOptionsStatus_Enum } } } }> };

export type AppointmentsSubscriptionVariables = Exact<{
  employeeIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  providerIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  afterStartDate: Scalars['timestamptz']['input'];
  beforeStartDate: Scalars['timestamptz']['input'];
}>;


export type AppointmentsSubscription = { __typename?: 'subscription_root', appointments: Array<{ __typename?: 'appointments', id: any, customerId: any, employeeId: any, startDate: any, endDate: any, jobStatus: JobStatus_Enum, customer: { __typename?: 'customers', id: any, name?: string | null, user?: { __typename?: 'users', id: any, name: string } | null }, service: { __typename?: 'services', id: any, name: string, color: string } }> };

export type GetAppointmentsKpisQueryVariables = Exact<{
  startDate: Scalars['timestamptz']['input'];
  endDate: Scalars['timestamptz']['input'];
}>;


export type GetAppointmentsKpisQuery = { __typename?: 'query_root', pendingAppointments: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null }, processedAppointments: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null }, todayAppointments: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null } };

export type GetProviderEmployeesQueryVariables = Exact<{
  searchByName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProviderEmployeesQuery = { __typename?: 'query_root', userRoles: Array<{ __typename?: 'userRoles', user: { __typename?: 'users', id: any, name: string } }> };

export type TeamQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TeamQuery = { __typename?: 'query_root', userRoles: Array<{ __typename?: 'userRoles', role: UserRole_Enum, user: { __typename?: 'users', id: any, name: string, email: string, phoneNumber?: string | null, profilePicture?: { __typename?: 'files', id: any, name: string } | null } }>, userRoles_aggregate: { __typename?: 'userRoles_aggregate', aggregate?: { __typename?: 'userRoles_aggregate_fields', count: number } | null } };

export type UpdateBlockedCustomersMutationVariables = Exact<{
  customersIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  isBlocked: Scalars['Boolean']['input'];
}>;


export type UpdateBlockedCustomersMutation = { __typename?: 'mutation_root', update_customers?: { __typename?: 'customers_mutation_response', returning: Array<{ __typename?: 'customers', id: any, isBlocked: boolean, name?: string | null, address?: string | null, user?: { __typename?: 'users', name: string, email: string, profilePicture?: { __typename?: 'files', id: any, name: string } | null } | null, bookings: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null }, amountSpent?: { __typename?: 'customerAmountSpent', amount?: any | null } | null }> } | null };

export type ProviderBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type ProviderBySlugQuery = { __typename?: 'query_root', providers: Array<{ __typename?: 'providers', name: string, description?: string | null, category: ProviderCategory_Enum, slug: string, providerPictureByProfilePic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null, providerPictureByCoverPic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null, providerPictures: Array<{ __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } }>, providerPictures_aggregate: { __typename?: 'providerPictures_aggregate', aggregate?: { __typename?: 'providerPictures_aggregate_fields', count: number } | null }, services: Array<{ __typename?: 'services', id: any, name: string, description: string, duration?: any | null, customerCanPickEmployee?: boolean | null, sku: string, providerId: any, servicePictures: Array<{ __typename?: 'servicePictures', id: any, name: string, size: string, file: { __typename?: 'files', id: any, name: string } }>, servicePricings: Array<{ __typename?: 'servicePricings', id: any, basePrice?: any | null, currency: Currencies_Enum }>, serviceEmployees_aggregate: { __typename?: 'serviceEmployees_aggregate', aggregate?: { __typename?: 'serviceEmployees_aggregate_fields', count: number } | null }, serviceOptions: Array<{ __typename?: 'serviceOptions', name: string, id: any, status: ServiceOptionsStatus_Enum, serviceOptionSections: Array<{ __typename?: 'serviceOptionSection', name: string, order: any, id: any, mandatory: boolean, type: ServiceSectionOptionType_Enum, serviceOptionSectionOptions: Array<{ __typename?: 'serviceOptionSectionOptions', id: any, name: string, order: any, price: any, quantity: ServiceSectionOptionQuantityType_Enum }> }> }>, servicesForms: Array<{ __typename?: 'servicesForms', id: any, formId: any, status: ServiceFormStatus_Enum, form: { __typename?: 'form', id: any, name: string, formQuestions: Array<{ __typename?: 'formQuestions', id: any, label: string, mandatory: boolean, name?: string | null, order: any, questionType: FormQuestionType_Enum, options: Array<{ __typename?: 'formQuestionOptions', id: any, value: string }> }> } }>, servicePricing?: { __typename?: 'servicePricings', basePrice?: any | null, checkoutPayment?: any | null, fees?: any | null, taxes?: boolean | null, minimumDeposit?: any | null, paymentFormat: PaymentFormat_Enum, currency: Currencies_Enum } | null }>, services_aggregate: { __typename?: 'services_aggregate', aggregate?: { __typename?: 'services_aggregate_fields', count: number } | null } }> };

export type AvailableLocationsByTypeQueryVariables = Exact<{
  locationName: Scalars['String']['input'];
  locationType: LocationType_Enum;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  providerId: Scalars['uuid']['input'];
  serviceId: Scalars['uuid']['input'];
}>;


export type AvailableLocationsByTypeQuery = { __typename?: 'query_root', locations: Array<{ __typename?: 'locations', id: any, name: string, address: string, radius?: any | null, buildingManagerId?: any | null, coordinates: any, buildingManager?: { __typename?: 'users', id: any, name: string, address?: string | null } | null }>, locations_aggregate: { __typename?: 'locations_aggregate', aggregate?: { __typename?: 'locations_aggregate_fields', count: number } | null } };

export type GetAppointmentsQueryVariables = Exact<{
  jobStatus: Array<JobStatus_Enum> | JobStatus_Enum;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetAppointmentsQuery = { __typename?: 'query_root', appointments: Array<{ __typename?: 'appointments', id: any, customerId: any, employeeId: any, startDate: any, endDate: any, paymentStatus: PaymentStatus_Enum, jobStatus: JobStatus_Enum, createdByUserId?: any | null, customer: { __typename?: 'customers', id: any, name?: string | null, phoneNumber?: string | null, email?: string | null, address?: string | null, user?: { __typename?: 'users', id: any, name: string, phoneNumber?: string | null, email: string, address?: string | null, profilePicture?: { __typename?: 'files', id: any, name: string } | null } | null }, payments_aggregate: { __typename?: 'payments_aggregate', aggregate?: { __typename?: 'payments_aggregate_fields', sum?: { __typename?: 'payments_sum_fields', amount?: any | null } | null } | null }, service: { __typename?: 'services', id: any, name: string, color: string, sku: string }, serviceOptionAnswers: Array<{ __typename?: 'serviceOptionAnswers', id: any, quantity?: any | null, serviceOptionSectionOption: { __typename?: 'serviceOptionSectionOptions', id: any, price: any, name: string, serviceOptionSection: { __typename?: 'serviceOptionSection', id: any, name: string, serviceOption: { __typename?: 'serviceOptions', id: any, name: string, status: ServiceOptionsStatus_Enum } } } }>, appointmentPricing?: { __typename?: 'appointmentPricing', id: any, basePrice: any, taxes: boolean, taxRate?: any | null, checkoutPayment: any, fees: any, minimumDeposit?: any | null } | null }>, appointments_aggregate: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null } };

export type GetAppointmentByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetAppointmentByIdQuery = { __typename?: 'query_root', appointments_by_pk?: { __typename?: 'appointments', id: any, customerId: any, employeeId: any, serviceId: any, startDate: any, endDate: any, paymentStatus: PaymentStatus_Enum, createdByUserId?: any | null, address?: string | null, coordinates?: any | null, jobStatus: JobStatus_Enum, notes?: string | null, apartmentNumber?: string | null, userByAbortedId?: { __typename?: 'users', id: any, name: string, email: string, phoneNumber?: string | null } | null, userByEmployeeid: { __typename?: 'users', id: any, name: string, email: string, phoneNumber?: string | null, profilePicture?: { __typename?: 'files', id: any, name: string } | null }, customer: { __typename?: 'customers', id: any, name?: string | null, phoneNumber?: string | null, email?: string | null, address?: string | null, coordinates?: any | null, stripeCustomerId?: string | null, bmStripePaymentMethodId?: string | null, user?: { __typename?: 'users', id: any, name: string, phoneNumber?: string | null, email: string, address?: string | null, coordinates?: any | null, stripePaymentMethodId?: string | null, profilePicture?: { __typename?: 'files', id: any, name: string } | null } | null }, payments_aggregate: { __typename?: 'payments_aggregate', aggregate?: { __typename?: 'payments_aggregate_fields', sum?: { __typename?: 'payments_sum_fields', amount?: any | null } | null } | null }, service: { __typename?: 'services', id: any, name: string, color: string, sku: string, duration?: any | null, customerCanPickEmployee?: boolean | null, serviceOptions: Array<{ __typename?: 'serviceOptions', id: any, name: string, serviceOptionSections: Array<{ __typename?: 'serviceOptionSection', id: any, name: string, type: ServiceSectionOptionType_Enum, serviceOptionSectionOptions: Array<{ __typename?: 'serviceOptionSectionOptions', id: any, name: string, price: any, quantity: ServiceSectionOptionQuantityType_Enum, serviceOptionAnswers: Array<{ __typename?: 'serviceOptionAnswers', id: any, quantity?: any | null, serviceOptionSectionOption: { __typename?: 'serviceOptionSectionOptions', serviceOptionSection: { __typename?: 'serviceOptionSection', name: string } } }> }> }> }>, provider: { __typename?: 'providers', id: any, slug: string, name: string, email: string, phoneNumber: string, bookingCancelationWarningPeriod?: number | null, forms: Array<{ __typename?: 'form', id: any, name: string, formQuestions: Array<{ __typename?: 'formQuestions', id: any, questionType: FormQuestionType_Enum, name?: string | null, label: string, description?: string | null }>, formAnswers: Array<{ __typename?: 'formAnswers', id: any, answer?: string | null, formQuestionId: any }> }> }, servicePricing?: { __typename?: 'servicePricings', minimumDeposit?: any | null, paymentFormat: PaymentFormat_Enum, taxes?: boolean | null } | null, serviceEmployees_aggregate: { __typename?: 'serviceEmployees_aggregate', aggregate?: { __typename?: 'serviceEmployees_aggregate_fields', count: number } | null } }, location: { __typename?: 'locations', id: any, name: string, address: string, coordinates: any, type: LocationType_Enum }, appointmentPricing?: { __typename?: 'appointmentPricing', id: any, basePrice: any, taxes: boolean, taxRate?: any | null, checkoutPayment: any, fees: any, minimumDeposit?: any | null } | null, payments: Array<{ __typename?: 'payments', id: any, amount: any, currency: Currencies_Enum, description?: string | null, status: PaymentStatus_Enum, sources: any, refund: Array<{ __typename?: 'refunds', id: any, amount: any, currency: string, status: PaymentStatus_Enum }> }>, formAnswers: Array<{ __typename?: 'formAnswers', id: any, answer?: string | null, formId: any, formQuestionId: any, optionId?: any | null, fileId?: any | null, form: { __typename?: 'form', id: any, name: string }, formQuestion: { __typename?: 'formQuestions', id: any, label: string, questionType: FormQuestionType_Enum }, file?: { __typename?: 'files', id: any, name: string, uploadName: string } | null, option?: { __typename?: 'formQuestionOptions', id: any, value: string } | null }>, serviceOptionAnswers: Array<{ __typename?: 'serviceOptionAnswers', id: any, quantity?: any | null, serviceOptionSectionOption: { __typename?: 'serviceOptionSectionOptions', id: any, price: any, name: string, serviceOptionSection: { __typename?: 'serviceOptionSection', id: any, name: string, serviceOption: { __typename?: 'serviceOptions', id: any, name: string, status: ServiceOptionsStatus_Enum } } } }> } | null };

export type GetDashboardTimeoutsQueryVariables = Exact<{
  startDate: Scalars['timestamptz']['input'];
}>;


export type GetDashboardTimeoutsQuery = { __typename?: 'query_root', timeouts: Array<{ __typename?: 'timeouts', id: any, startDate: any, endDate?: any | null, user?: { __typename?: 'users', id: any, name: string } | null, location?: { __typename?: 'locations', id: any, name: string } | null, service?: { __typename?: 'services', id: any, name: string } | null }> };

export type GetDashboardAppointmentsQueryVariables = Exact<{
  jobStatus: Array<JobStatus_Enum> | JobStatus_Enum;
}>;


export type GetDashboardAppointmentsQuery = { __typename?: 'query_root', appointments: Array<{ __typename?: 'appointments', id: any, startDate: any, customer: { __typename?: 'customers', id: any, name?: string | null, user?: { __typename?: 'users', id: any, name: string, profilePicture?: { __typename?: 'files', id: any, name: string } | null } | null } }> };

export type UpdateAppointmentNotesMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  notes: Scalars['String']['input'];
}>;


export type UpdateAppointmentNotesMutation = { __typename?: 'mutation_root', update_appointments_by_pk?: { __typename?: 'appointments', notes?: string | null } | null };

export type SpRefundSinglePaymentMutationVariables = Exact<{
  appointmentId: Scalars['String']['input'];
  paymentId: Scalars['String']['input'];
}>;


export type SpRefundSinglePaymentMutation = { __typename?: 'mutation_root', SpRefundPayment: { __typename?: 'Appointment', id: string } };

export type SpUpdateAppointmentPaymentStatusMutationVariables = Exact<{
  appointmentId: Scalars['String']['input'];
  status: Scalars['String']['input'];
}>;


export type SpUpdateAppointmentPaymentStatusMutation = { __typename?: 'mutation_root', SpUpdateApptPaymentStatus: { __typename?: 'Appointment', id: string } };

export type ApproveAppointmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ApproveAppointmentMutation = { __typename?: 'mutation_root', ApproveAppointment: { __typename?: 'Appointment', id: string, jobStatus: string } };

export type CompleteAppointmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CompleteAppointmentMutation = { __typename?: 'mutation_root', SPMarkAppointmentCompleted: { __typename?: 'Appointment', id: string, jobStatus: string } };

export type SetAppointmentPartialMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SetAppointmentPartialMutation = { __typename?: 'mutation_root', SPMarkAppointmentPartial: { __typename?: 'Appointment', id: string, jobStatus: string } };

export type SetAppointmentScheduledMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SetAppointmentScheduledMutation = { __typename?: 'mutation_root', SPMarkAppointmentScheduled: { __typename?: 'Appointment', id: string, jobStatus: string } };

export type GetEmployeesListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchByName: Scalars['String']['input'];
  serviceId: Scalars['uuid']['input'];
}>;


export type GetEmployeesListQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, name: string, completedAppointments: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null }, profilePicture?: { __typename?: 'files', id: any, name: string } | null }>, users_aggregate: { __typename?: 'users_aggregate', aggregate?: { __typename?: 'users_aggregate_fields', count: number } | null } };

export type UpdateServiceOptionsStatusMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  status?: InputMaybe<ServiceOptionsStatus_Enum>;
}>;


export type UpdateServiceOptionsStatusMutation = { __typename?: 'mutation_root', update_serviceOptions_by_pk?: { __typename?: 'serviceOptions', id: any, name: string, status: ServiceOptionsStatus_Enum } | null };

export type UpdateServicePricingPaymentFormatByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  paymentFormat?: InputMaybe<PaymentFormat_Enum>;
}>;


export type UpdateServicePricingPaymentFormatByIdMutation = { __typename?: 'mutation_root', update_servicePricings?: { __typename?: 'servicePricings_mutation_response', returning: Array<{ __typename?: 'servicePricings', id: any, basePrice?: any | null, minimumDeposit?: any | null, taxes?: boolean | null, fees?: any | null, paymentFormat: PaymentFormat_Enum, checkoutPayment?: any | null, currency: Currencies_Enum }> } | null };

export type DeleteLocationsByIdMutationVariables = Exact<{
  locationIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteLocationsByIdMutation = { __typename?: 'mutation_root', update_locations?: { __typename?: 'locations_mutation_response', returning: Array<{ __typename?: 'locations', id: any, deletedAt?: any | null }> } | null, delete_schedule?: { __typename?: 'schedule_mutation_response', returning: Array<{ __typename?: 'schedule', id: any }> } | null, delete_timeouts?: { __typename?: 'timeouts_mutation_response', returning: Array<{ __typename?: 'timeouts', id: any }> } | null };

export type GetFutureAppointmentsByLocationIdsQueryVariables = Exact<{
  locationIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetFutureAppointmentsByLocationIdsQuery = { __typename?: 'query_root', appointments: Array<{ __typename?: 'appointments', id: any, startDate: any }> };

export type CreateEmployeeMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  profilePictureFileId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateEmployeeMutation = { __typename?: 'mutation_root', createEmployee: { __typename?: 'CreateEmployeeDto', id: string, name: string, phoneNumber: string, email: string, profilePictureFileId?: string | null, createdAt: string, profilePicture?: { __typename?: 'ProfilePicture', id: string, name: string } | null } };

export type EditEmployeeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  profilePictureFileId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type EditEmployeeMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any, name: string, phoneNumber?: string | null, email: string, profilePictureFileId?: any | null, profilePicture?: { __typename?: 'files', id: any, name: string } | null } | null };

export type ServicesByEmployeeIdQueryVariables = Exact<{
  employeeId: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ServicesByEmployeeIdQuery = { __typename?: 'query_root', services: Array<{ __typename?: 'services', id: any, name: string, status: ServiceStatus_Enum, serviceEmployees: Array<{ __typename?: 'serviceEmployees', id: any, userId: any, serviceId: any }> }> };

export type AvailabilitiesByEmployeeIdQueryVariables = Exact<{
  employeeId: Scalars['uuid']['input'];
  afterStartDate: Scalars['date']['input'];
  afterStartTimestamp: Scalars['timestamptz']['input'];
  beforeStartDate: Scalars['date']['input'];
  beforeStartTimestamp: Scalars['timestamptz']['input'];
}>;


export type AvailabilitiesByEmployeeIdQuery = { __typename?: 'query_root', schedule: Array<{ __typename?: 'schedule', id: any, startTime: any, endTime: any, repeatableDayOfWeek?: Array<string> | null, startingAt: any, endingAt?: any | null, locationId: any, employeeId: any }>, timeouts: Array<{ __typename?: 'timeouts', id: any, userId?: any | null, locationId?: any | null, serviceId?: any | null, startDate: any, endDate?: any | null, createdAt: any, updatedAt: any }> };

export type AddEmployeeScheduleMutationVariables = Exact<{
  input: Array<Schedule_Insert_Input> | Schedule_Insert_Input;
}>;


export type AddEmployeeScheduleMutation = { __typename?: 'mutation_root', insert_schedule?: { __typename?: 'schedule_mutation_response', returning: Array<{ __typename?: 'schedule', createdAt: any, employeeId: any, endTime: any, id: any, locationId: any, repeatableDayOfWeek?: Array<string> | null, startTime: any, startingAt: any, endingAt?: any | null, updatedAt: any }> } | null };

export type GetServiceOptionAnswersQueryVariables = Exact<{
  serviceOptionId: Scalars['uuid']['input'];
}>;


export type GetServiceOptionAnswersQuery = { __typename?: 'query_root', serviceOptionAnswers: Array<{ __typename?: 'serviceOptionAnswers', id: any, serviceOptionSectionOptionsId: any }> };

export type RemoveEmployeeScheduleByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RemoveEmployeeScheduleByIdMutation = { __typename?: 'mutation_root', delete_schedule_by_pk?: { __typename?: 'schedule', id: any } | null };

export type AddEmployeeTimeoutMutationVariables = Exact<{
  input: Array<Timeouts_Insert_Input> | Timeouts_Insert_Input;
}>;


export type AddEmployeeTimeoutMutation = { __typename?: 'mutation_root', insert_timeouts?: { __typename?: 'timeouts_mutation_response', returning: Array<{ __typename?: 'timeouts', id: any, userId?: any | null, locationId?: any | null, serviceId?: any | null, startDate: any, endDate?: any | null, createdAt: any, updatedAt: any }> } | null };

export type RemoveEmployeeTimeoutByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RemoveEmployeeTimeoutByIdMutation = { __typename?: 'mutation_root', delete_timeouts_by_pk?: { __typename?: 'timeouts', id: any, userId?: any | null, locationId?: any | null, serviceId?: any | null, startDate: any, endDate?: any | null, createdAt: any, updatedAt: any } | null };

export type SchedulesConflictsQueryVariables = Exact<{
  employeeId: Scalars['uuid']['input'];
  startingAt: Scalars['timestamptz']['input'];
  endingAt: Scalars['timestamptz']['input'];
  locationId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type SchedulesConflictsQuery = { __typename?: 'query_root', timeouts: Array<{ __typename?: 'timeouts', id: any, userId?: any | null, locationId?: any | null, serviceId?: any | null, startDate: any, endDate?: any | null, createdAt: any, updatedAt: any }> };

export type SchedulesWithoutEndDateConflictsQueryVariables = Exact<{
  employeeId: Scalars['uuid']['input'];
  startingAt: Scalars['timestamptz']['input'];
  locationId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type SchedulesWithoutEndDateConflictsQuery = { __typename?: 'query_root', timeouts: Array<{ __typename?: 'timeouts', id: any, userId?: any | null, locationId?: any | null, serviceId?: any | null, startDate: any, endDate?: any | null, createdAt: any, updatedAt: any }> };

export type AppointmentConflictsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  locationIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  serviceIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  employeeIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type AppointmentConflictsQuery = { __typename?: 'query_root', appointments: Array<{ __typename?: 'appointments', id: any }> };

export type UpcomingEmployeesAppointmentsQueryVariables = Exact<{
  userIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UpcomingEmployeesAppointmentsQuery = { __typename?: 'query_root', appointments_aggregate: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null, nodes: Array<{ __typename?: 'appointments', userByEmployeeid: { __typename?: 'users', name: string } }> } };

export type DeleteEmployeesMutationVariables = Exact<{
  usersIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteEmployeesMutation = { __typename?: 'mutation_root', update_userRoles?: { __typename?: 'userRoles_mutation_response', returning: Array<{ __typename?: 'userRoles', userId: any }> } | null, delete_schedule?: { __typename?: 'schedule_mutation_response', affected_rows: number } | null, delete_timeouts?: { __typename?: 'timeouts_mutation_response', affected_rows: number } | null };

export type ProviderCardQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderCardQuery = { __typename?: 'query_root', getProviderCard?: { __typename?: 'card', id: string, brand: string, expMonth: number, expYear: number, last4: string, name?: string | null } | null };

export type CreateProviderSetupIntentMutationVariables = Exact<{
  confirmationTokenId: Scalars['String']['input'];
}>;


export type CreateProviderSetupIntentMutation = { __typename?: 'mutation_root', createProviderSetupIntent: { __typename?: 'SetupIntentDto', clientSecret: string, status: string } };

export type DeleteProviderPaymentMethodMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteProviderPaymentMethodMutation = { __typename?: 'mutation_root', deleteProviderPaymentMethod: { __typename?: 'DeletePaymentMethodDto', id: string } };

export type CountUnpaidAppointmentsQueryVariables = Exact<{
  providerId: Scalars['uuid']['input'];
}>;


export type CountUnpaidAppointmentsQuery = { __typename?: 'query_root', appointments_aggregate: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null } };

export type ProviderPaymentsQueryVariables = Exact<{
  limit: Scalars['Float']['input'];
  startingAfter?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProviderPaymentsQuery = { __typename?: 'query_root', providerPayments: { __typename?: 'ProviderPaymentsDto', totalCount: number, data: Array<{ __typename?: 'ProviderPaymentDto', id: string, date: any, amount: number, status: string, currency: string }> } };

export type EditProviderBookingSettingsMutationVariables = Exact<{
  providerId: Scalars['uuid']['input'];
  bookingStatus: BookingStatus_Enum;
  bookingCancelationWarningPeriod?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EditProviderBookingSettingsMutation = { __typename?: 'mutation_root', update_providers_by_pk?: { __typename?: 'providers', id: any, bookingDefaultStatus: BookingStatus_Enum, bookingCancelationWarningPeriod?: number | null } | null };

export type EditProviderBusinessDetailsMutationVariables = Exact<{
  providerId: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  address: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
}>;


export type EditProviderBusinessDetailsMutation = { __typename?: 'mutation_root', update_providers_by_pk?: { __typename?: 'providers', id: any, name: string, address: string, phoneNumber: string } | null };

export type EditProviderBusinessDescriptionMutationVariables = Exact<{
  providerId: Scalars['uuid']['input'];
  description: Scalars['String']['input'];
}>;


export type EditProviderBusinessDescriptionMutation = { __typename?: 'mutation_root', update_providers_by_pk?: { __typename?: 'providers', id: any, description?: string | null } | null };

export type GetFutureAppointmentsByServiceIdsQueryVariables = Exact<{
  serviceIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetFutureAppointmentsByServiceIdsQuery = { __typename?: 'query_root', appointments: Array<{ __typename?: 'appointments', id: any, startDate: any }> };

export type UpdateServiceByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Services_Set_Input;
}>;


export type UpdateServiceByIdMutation = { __typename?: 'mutation_root', update_services_by_pk?: { __typename?: 'services', id: any, name: string, sku: string, featured?: boolean | null, status: ServiceStatus_Enum, description: string } | null };

export type DeleteServiceByIdMutationVariables = Exact<{
  serviceIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteServiceByIdMutation = { __typename?: 'mutation_root', update_services?: { __typename?: 'services_mutation_response', returning: Array<{ __typename?: 'services', id: any }> } | null, delete_timeouts?: { __typename?: 'timeouts_mutation_response', returning: Array<{ __typename?: 'timeouts', id: any }> } | null };

export type AvailableAppointmentDateTimeSlotsQueryVariables = Exact<{
  inputs: TimeSlotsDto;
}>;


export type AvailableAppointmentDateTimeSlotsQuery = { __typename?: 'query_root', availableAppointmentDateTimeSlots: { __typename?: 'AvailableAppointmentDateTimeSlotsDto', availableSlots: Array<{ __typename?: 'TimeSlotDto', date: any, employeeId: string }> } };

export type CreateAppointmentSpMutationVariables = Exact<{
  serviceId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
  address: Scalars['String']['input'];
  optionAnswers: Array<CreateApptServiceOptionAnswers> | CreateApptServiceOptionAnswers;
  coordinates: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  formAnswers: Array<CreateApptServiceFormAnswers> | CreateApptServiceFormAnswers;
}>;


export type CreateAppointmentSpMutation = { __typename?: 'mutation_root', createAppointmentSP: { __typename?: 'CreateApptSP', id: string, customerId: string, employeeId: string, startDate: string, endDate: string, jobStatus: string, address: string, apartmentNumber?: string | null, coordinates: { __typename?: 'GeographyCoordinates', coordinates: Array<number> }, service: { __typename?: 'CreateApptSPService', name: string, color: string } } };

export type ProviderBookingDefaultStatusQueryVariables = Exact<{
  providerId: Scalars['uuid']['input'];
}>;


export type ProviderBookingDefaultStatusQuery = { __typename?: 'query_root', providers_by_pk?: { __typename?: 'providers', bookingDefaultStatus: BookingStatus_Enum } | null };

export type NewFormFragmentFragment = { __typename?: 'form', id: any, name: string, formQuestions: Array<{ __typename?: 'formQuestions', id: any, label: string, order: any, mandatory: boolean, questionType: FormQuestionType_Enum, formQuestionOptions: Array<{ __typename?: 'formQuestionOptions', id: any, value: string }> }> };

export type SearchProvidersAndServicesNearbyQueryVariables = Exact<{
  location: Scalars['geography']['input'];
  distanceInMeters: Scalars['Float']['input'];
}>;


export type SearchProvidersAndServicesNearbyQuery = { __typename?: 'query_root', providers: Array<{ __typename?: 'providers', id: any, name: string, slug: string, category: ProviderCategory_Enum, status: ProviderStatus_Enum, providerPictureByProfilePic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null, providerPictureByCoverPic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null, buildingProviders: Array<{ __typename?: 'buildingProviders', id: any, location: { __typename?: 'locations', address: string } }>, locations: Array<{ __typename?: 'locations', id: any, name: string, address: string, type: LocationType_Enum }>, services: Array<{ __typename?: 'services', id: any, sku: string, name: string, featured?: boolean | null, description: string, servicePricing?: { __typename?: 'servicePricings', id: any, basePrice?: any | null } | null }> }> };

export type ProviderVisibilityQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderVisibilityQuery = { __typename?: 'query_root', getProviderVisibility: { __typename?: 'ProviderVisibilityDto', visibility: string, status: { __typename?: 'ProviderVisibilityStatusDto', hasActiveLocations: boolean, hasEmployeesWithSchedules: boolean, hasActiveServices: boolean, hasPaymentMethod: boolean, hasGeneralSettings: boolean, hasPublicProfileSettings: boolean, isApprovedByAdmin: boolean } } };

export type ProvidersInBuildingFragment = { __typename?: 'providers', id: any, name: string, slug: string, category: ProviderCategory_Enum, status: ProviderStatus_Enum, locations: Array<{ __typename?: 'locations', id: any, name: string, type: LocationType_Enum, address: string }>, services: Array<{ __typename?: 'services', id: any, sku: string, name: string, featured?: boolean | null, description: string, servicePricing?: { __typename?: 'servicePricings', id: any, basePrice?: any | null } | null }>, buildingProviders: Array<{ __typename?: 'buildingProviders', id: any, location: { __typename?: 'locations', id: any, name: string, address: string, coordinates: any } }>, providerPictureByProfilePic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null, providerPictureByCoverPic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null };

export type ProvidersInBuildingByAddressQueryVariables = Exact<{
  address?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProvidersInBuildingByAddressQuery = { __typename?: 'query_root', providers: Array<{ __typename?: 'providers', id: any, name: string, slug: string, category: ProviderCategory_Enum, status: ProviderStatus_Enum, locations: Array<{ __typename?: 'locations', id: any, name: string, type: LocationType_Enum, address: string }>, services: Array<{ __typename?: 'services', id: any, sku: string, name: string, featured?: boolean | null, description: string, servicePricing?: { __typename?: 'servicePricings', id: any, basePrice?: any | null } | null }>, buildingProviders: Array<{ __typename?: 'buildingProviders', id: any, location: { __typename?: 'locations', id: any, name: string, address: string, coordinates: any } }>, providerPictureByProfilePic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null, providerPictureByCoverPic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null }> };

export type ProvidersInBuildingByCoordinatesQueryVariables = Exact<{
  coordinates?: InputMaybe<Scalars['geography']['input']>;
}>;


export type ProvidersInBuildingByCoordinatesQuery = { __typename?: 'query_root', providers: Array<{ __typename?: 'providers', id: any, name: string, slug: string, category: ProviderCategory_Enum, status: ProviderStatus_Enum, locations: Array<{ __typename?: 'locations', id: any, name: string, type: LocationType_Enum, address: string }>, services: Array<{ __typename?: 'services', id: any, sku: string, name: string, featured?: boolean | null, description: string, servicePricing?: { __typename?: 'servicePricings', id: any, basePrice?: any | null } | null }>, buildingProviders: Array<{ __typename?: 'buildingProviders', id: any, location: { __typename?: 'locations', id: any, name: string, address: string, coordinates: any } }>, providerPictureByProfilePic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null, providerPictureByCoverPic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null }> };

export type ServicesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchByName: Scalars['String']['input'];
}>;


export type ServicesQuery = { __typename?: 'query_root', services: Array<{ __typename?: 'services', id: any, name: string, sku: string, offTime?: any | null, pictures?: any | null, maxBookings?: any | null, duration?: any | null, description: string, status: ServiceStatus_Enum, featured?: boolean | null, serviceEmployees: Array<{ __typename?: 'serviceEmployees', id: any, userId: any, serviceId: any }> }>, services_aggregate: { __typename?: 'services_aggregate', aggregate?: { __typename?: 'services_aggregate_fields', count: number } | null } };

export type CreateServiceMutationVariables = Exact<{
  providerId: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  sku: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type CreateServiceMutation = { __typename?: 'mutation_root', insert_services_one?: { __typename?: 'services', id: any, name: string, sku: string, description: string, status: ServiceStatus_Enum } | null };

export type EditServiceByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  sku: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type EditServiceByIdMutation = { __typename?: 'mutation_root', update_services_by_pk?: { __typename?: 'services', id: any, name: string, sku: string, description: string } | null };

export type GetServiceByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetServiceByIdQuery = { __typename?: 'query_root', services_by_pk?: { __typename?: 'services', id: any, name: string, sku: string, description: string, status: ServiceStatus_Enum, offTime?: any | null, duration?: any | null, color: string, customerCanPickEmployee?: boolean | null, maxBookings?: any | null, featured?: boolean | null, providerId: any, provider: { __typename?: 'providers', id: any, name: string, visibility: ProviderVisibility_Enum }, servicePricings: Array<{ __typename?: 'servicePricings', id: any, basePrice?: any | null, minimumDeposit?: any | null, taxes?: boolean | null, fees?: any | null, paymentFormat: PaymentFormat_Enum, checkoutPayment?: any | null, currency: Currencies_Enum }>, servicePricing?: { __typename?: 'servicePricings', id: any, basePrice?: any | null, minimumDeposit?: any | null, taxes?: boolean | null, fees?: any | null, paymentFormat: PaymentFormat_Enum, checkoutPayment?: any | null, currency: Currencies_Enum } | null, serviceEmployees: Array<{ __typename?: 'serviceEmployees', user: { __typename?: 'users', id: any, name: string } }>, serviceEmployees_aggregate: { __typename?: 'serviceEmployees_aggregate', aggregate?: { __typename?: 'serviceEmployees_aggregate_fields', count: number } | null }, serviceOptions: Array<{ __typename?: 'serviceOptions', id: any, name: string, status: ServiceOptionsStatus_Enum, serviceOptionSections: Array<{ __typename?: 'serviceOptionSection', id: any, mandatory: boolean, name: string, type: ServiceSectionOptionType_Enum, order: any, serviceOptionSectionOptions: Array<{ __typename?: 'serviceOptionSectionOptions', id: any, name: string, price: any, order: any, quantity: ServiceSectionOptionQuantityType_Enum }> }> }>, servicesForms: Array<{ __typename?: 'servicesForms', id: any, formId: any, status: ServiceFormStatus_Enum, form: { __typename?: 'form', id: any, name: string, formQuestions: Array<{ __typename?: 'formQuestions', id: any, label: string, mandatory: boolean, name?: string | null, order: any, questionType: FormQuestionType_Enum, options: Array<{ __typename?: 'formQuestionOptions', id: any, value: string }>, formAnswers: Array<{ __typename?: 'formAnswers', formId: any, formQuestionId: any, answer?: string | null, optionId?: any | null, fileId?: any | null }> }> } }> } | null };

export type GetPublicServiceQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  serviceId: Scalars['uuid']['input'];
}>;


export type GetPublicServiceQuery = { __typename?: 'query_root', providers: Array<{ __typename?: 'providers', slug: string, services: Array<{ __typename?: 'services', id: any, name: string, sku: string, description: string, duration?: any | null, providerId: any, servicePricing?: { __typename?: 'servicePricings', id: any, basePrice?: any | null, fees?: any | null, minimumDeposit?: any | null, currency: Currencies_Enum, taxes?: boolean | null, checkoutPayment?: any | null, paymentFormat: PaymentFormat_Enum } | null, servicePictures: Array<{ __typename?: 'servicePictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } }>, serviceOptions: Array<{ __typename?: 'serviceOptions', id: any, name: string, status: ServiceOptionsStatus_Enum, serviceOptionSections: Array<{ __typename?: 'serviceOptionSection', id: any, mandatory: boolean, name: string, type: ServiceSectionOptionType_Enum, order: any, serviceOptionSectionOptions: Array<{ __typename?: 'serviceOptionSectionOptions', id: any, name: string, price: any, order: any, quantity: ServiceSectionOptionQuantityType_Enum }> }> }>, servicesForms: Array<{ __typename?: 'servicesForms', id: any, formId: any, status: ServiceFormStatus_Enum, form: { __typename?: 'form', id: any, name: string, formQuestions: Array<{ __typename?: 'formQuestions', id: any, label: string, mandatory: boolean, name?: string | null, order: any, questionType: FormQuestionType_Enum, options: Array<{ __typename?: 'formQuestionOptions', id: any, value: string }> }> } }>, servicePictures_aggregate: { __typename?: 'servicePictures_aggregate', aggregate?: { __typename?: 'servicePictures_aggregate_fields', count: number } | null }, serviceEmployees_aggregate: { __typename?: 'serviceEmployees_aggregate', aggregate?: { __typename?: 'serviceEmployees_aggregate_fields', count: number } | null } }> }> };

export type GetServiceFormsQueryVariables = Exact<{
  serviceId: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetServiceFormsQuery = { __typename?: 'query_root', servicesForms: Array<{ __typename?: 'servicesForms', id: any, status: ServiceFormStatus_Enum, form: { __typename?: 'form', id: any, name: string } }>, servicesForms_aggregate: { __typename?: 'servicesForms_aggregate', aggregate?: { __typename?: 'servicesForms_aggregate_fields', count: number } | null } };

export type GetServiceDetailsByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetServiceDetailsByIdQuery = { __typename?: 'query_root', services_by_pk?: { __typename?: 'services', id: any, name: string, sku: string, description: string, status: ServiceStatus_Enum, offTime?: any | null, duration?: any | null, color: string, customerCanPickEmployee?: boolean | null, maxBookings?: any | null, featured?: boolean | null } | null };

export type GetServiceProviderQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetServiceProviderQuery = { __typename?: 'query_root', services_by_pk?: { __typename?: 'services', servicePictures: Array<{ __typename?: 'servicePictures', id: any, file: { __typename?: 'files', id: any, name: string } }>, provider: { __typename?: 'providers', id: any, name: string, category: ProviderCategory_Enum, providerPictureByProfilePic?: { __typename?: 'providerPictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } } | null } } | null };

export type UpdateServiceStatusMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  status?: InputMaybe<ServiceStatus_Enum>;
}>;


export type UpdateServiceStatusMutation = { __typename?: 'mutation_root', update_services_by_pk?: { __typename?: 'services', id: any } | null };

export type UpdateServiceFormStatusMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  status?: InputMaybe<ServiceFormStatus_Enum>;
}>;


export type UpdateServiceFormStatusMutation = { __typename?: 'mutation_root', update_servicesForms_by_pk?: { __typename?: 'servicesForms', id: any, status: ServiceFormStatus_Enum } | null };

export type GetFormsQueryVariables = Exact<{
  searchByName: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetFormsQuery = { __typename?: 'query_root', form_aggregate: { __typename?: 'form_aggregate', aggregate?: { __typename?: 'form_aggregate_fields', count: number } | null }, form: Array<{ __typename?: 'form', id: any, name: string, servicesForms: Array<{ __typename?: 'servicesForms', id: any, serviceId: any }> }> };

export type DeleteServiceFormMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteServiceFormMutation = { __typename?: 'mutation_root', delete_servicesForms_by_pk?: { __typename?: 'servicesForms', id: any } | null };

export type InsertServiceFormMutationVariables = Exact<{
  input: ServicesForms_Insert_Input;
}>;


export type InsertServiceFormMutation = { __typename?: 'mutation_root', insert_servicesForms_one?: { __typename?: 'servicesForms', id: any, status: ServiceFormStatus_Enum, form: { __typename?: 'form', id: any, name: string } } | null };

export type ImportFormsToServiceMutationVariables = Exact<{
  serviceFormIds: Array<ServicesForms_Insert_Input> | ServicesForms_Insert_Input;
}>;


export type ImportFormsToServiceMutation = { __typename?: 'mutation_root', insert_servicesForms?: { __typename?: 'servicesForms_mutation_response', returning: Array<{ __typename?: 'servicesForms', id: any, serviceId: any, status: ServiceFormStatus_Enum, formId: any }> } | null };

export type UpdateServiceOffTimeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  offTime?: InputMaybe<Scalars['numeric']['input']>;
}>;


export type UpdateServiceOffTimeMutation = { __typename?: 'mutation_root', update_services_by_pk?: { __typename?: 'services', id: any, name: string, sku: string, description: string, status: ServiceStatus_Enum, offTime?: any | null, duration?: any | null, color: string, featured?: boolean | null } | null };

export type UpdateServiceDurationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  duration?: InputMaybe<Scalars['numeric']['input']>;
}>;


export type UpdateServiceDurationMutation = { __typename?: 'mutation_root', update_services_by_pk?: { __typename?: 'services', id: any, name: string, sku: string, description: string, status: ServiceStatus_Enum, offTime?: any | null, duration?: any | null, color: string, featured?: boolean | null } | null };

export type UpdateServiceColorMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateServiceColorMutation = { __typename?: 'mutation_root', update_services_by_pk?: { __typename?: 'services', id: any, name: string, sku: string, description: string, status: ServiceStatus_Enum, offTime?: any | null, duration?: any | null, color: string, featured?: boolean | null } | null };

export type ServicesTableQueryVariables = Exact<{
  value: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  status?: InputMaybe<Array<ServiceStatus_Enum> | ServiceStatus_Enum>;
}>;


export type ServicesTableQuery = { __typename?: 'query_root', filteredServices: Array<{ __typename?: 'services', color: string, customerCanPickEmployee?: boolean | null, description: string, duration?: any | null, id: any, name: string, sku: string, maxBookings?: any | null, status: ServiceStatus_Enum, featured?: boolean | null }>, filteredServicesAggregate: { __typename?: 'services_aggregate', aggregate?: { __typename?: 'services_aggregate_fields', count: number } | null }, allServicesAggregate: { __typename?: 'services_aggregate', nodes: Array<{ __typename?: 'services', id: any, status: ServiceStatus_Enum }>, aggregate?: { __typename?: 'services_aggregate_fields', count: number } | null } };

export type ServiceEmployeesQueryVariables = Exact<{
  serviceId: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type ServiceEmployeesQuery = { __typename?: 'query_root', services: Array<{ __typename?: 'services', id: any, serviceEmployees: Array<{ __typename?: 'serviceEmployees', id: any, user: { __typename?: 'users', id: any, name: string, email: string, phoneNumber?: string | null, profilePicture?: { __typename?: 'files', id: any, name: string } | null } }>, serviceEmployees_aggregate: { __typename?: 'serviceEmployees_aggregate', aggregate?: { __typename?: 'serviceEmployees_aggregate_fields', count: number } | null } }> };

export type AddServiceEmployeesMutationVariables = Exact<{
  serviceEmployeesIds: Array<ServiceEmployees_Insert_Input> | ServiceEmployees_Insert_Input;
}>;


export type AddServiceEmployeesMutation = { __typename?: 'mutation_root', insert_serviceEmployees?: { __typename?: 'serviceEmployees_mutation_response', returning: Array<{ __typename?: 'serviceEmployees', service: { __typename?: 'services', id: any, serviceEmployees: Array<{ __typename?: 'serviceEmployees', id: any, user: { __typename?: 'users', id: any, name: string, email: string, phoneNumber?: string | null, profilePicture?: { __typename?: 'files', id: any, name: string } | null } }> } }> } | null };

export type DeleteServiceEmployeeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteServiceEmployeeMutation = { __typename?: 'mutation_root', delete_serviceEmployees_by_pk?: { __typename?: 'serviceEmployees', id: any } | null };

export type InsertServicePricingMutationVariables = Exact<{
  serviceId: Scalars['uuid']['input'];
  checkoutPayment?: InputMaybe<Scalars['jsonb']['input']>;
  fees?: InputMaybe<Scalars['jsonb']['input']>;
  paymentFormat?: InputMaybe<PaymentFormat_Enum>;
  taxes?: InputMaybe<Scalars['Boolean']['input']>;
  basePrice: Scalars['float8']['input'];
  minimumDeposit?: InputMaybe<Scalars['float8']['input']>;
  currency?: InputMaybe<Currencies_Enum>;
}>;


export type InsertServicePricingMutation = { __typename?: 'mutation_root', insert_servicePricings_one?: { __typename?: 'servicePricings', id: any, basePrice?: any | null, minimumDeposit?: any | null, taxes?: boolean | null, fees?: any | null, paymentFormat: PaymentFormat_Enum, checkoutPayment?: any | null, currency: Currencies_Enum } | null };

export type UpdateServicePricingByIdMutationVariables = Exact<{
  serviceId: Scalars['uuid']['input'];
  checkoutPayment?: InputMaybe<Scalars['jsonb']['input']>;
  fees?: InputMaybe<Scalars['jsonb']['input']>;
  paymentFormat?: InputMaybe<PaymentFormat_Enum>;
  taxes?: InputMaybe<Scalars['Boolean']['input']>;
  basePrice: Scalars['float8']['input'];
  minimumDeposit?: InputMaybe<Scalars['float8']['input']>;
  currency?: InputMaybe<Currencies_Enum>;
}>;


export type UpdateServicePricingByIdMutation = { __typename?: 'mutation_root', update_servicePricings?: { __typename?: 'servicePricings_mutation_response', returning: Array<{ __typename?: 'servicePricings', id: any, basePrice?: any | null, minimumDeposit?: any | null, taxes?: boolean | null, fees?: any | null, paymentFormat: PaymentFormat_Enum, checkoutPayment?: any | null, currency: Currencies_Enum }> } | null };

export type UpdateServiceRestrictionsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  customerCanPickEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  maxBookings?: InputMaybe<Scalars['numeric']['input']>;
  checkoutPayment?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateServiceRestrictionsMutation = { __typename?: 'mutation_root', update_services_by_pk?: { __typename?: 'services', id: any, color: string, customerCanPickEmployee?: boolean | null, description: string, duration?: any | null, maxBookings?: any | null, name: string, offTime?: any | null, pictures?: any | null } | null, update_servicePricings?: { __typename?: 'servicePricings_mutation_response', returning: Array<{ __typename?: 'servicePricings', id: any, basePrice?: any | null, checkoutPayment?: any | null, currency: Currencies_Enum, fees?: any | null, minimumDeposit?: any | null, paymentFormat: PaymentFormat_Enum, taxes?: boolean | null }> } | null };

export type GetEmployeesQueryVariables = Exact<{
  searchValue: Scalars['String']['input'];
}>;


export type GetEmployeesQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, name: string }> };

export type GetLocationsQueryVariables = Exact<{
  searchValue: Scalars['String']['input'];
  providerId: Scalars['uuid']['input'];
}>;


export type GetLocationsQuery = { __typename?: 'query_root', locations: Array<{ __typename?: 'locations', id: any, name: string }> };

export type GetServicesQueryVariables = Exact<{
  searchValue: Scalars['String']['input'];
}>;


export type GetServicesQuery = { __typename?: 'query_root', services: Array<{ __typename?: 'services', id: any, name: string }> };

export type CreateTimeoutMutationVariables = Exact<{
  timeouts: Array<Timeouts_Insert_Input> | Timeouts_Insert_Input;
}>;


export type CreateTimeoutMutation = { __typename?: 'mutation_root', insert_timeouts?: { __typename?: 'timeouts_mutation_response', returning: Array<{ __typename?: 'timeouts', id: any, startDate: any, endDate?: any | null, userId?: any | null, serviceId?: any | null, locationId?: any | null }> } | null };

export type GetServicesOptionsByServiceIdQueryVariables = Exact<{
  serviceId: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetServicesOptionsByServiceIdQuery = { __typename?: 'query_root', serviceOptions_aggregate: { __typename?: 'serviceOptions_aggregate', aggregate?: { __typename?: 'serviceOptions_aggregate_fields', count: number } | null }, serviceOptions: Array<{ __typename?: 'serviceOptions', id: any, name: string, status: ServiceOptionsStatus_Enum, serviceId: any, serviceOptionSections: Array<{ __typename?: 'serviceOptionSection', id: any, name: string, order: any, mandatory: boolean, type: ServiceSectionOptionType_Enum, serviceOptionSectionOptions: Array<{ __typename?: 'serviceOptionSectionOptions', id: any, name: string, order: any, price: any, quantity: ServiceSectionOptionQuantityType_Enum }> }> }> };

export type InsertServiceOptionsMutationVariables = Exact<{
  name: Scalars['String']['input'];
  serviceOptionSections: ServiceOptionSection_Arr_Rel_Insert_Input;
  serviceId: Scalars['uuid']['input'];
  status?: InputMaybe<ServiceOptionsStatus_Enum>;
}>;


export type InsertServiceOptionsMutation = { __typename?: 'mutation_root', insert_serviceOptions_one?: { __typename?: 'serviceOptions', id: any, name: string, status: ServiceOptionsStatus_Enum, serviceId: any, serviceOptionSections: Array<{ __typename?: 'serviceOptionSection', id: any, name: string, order: any, mandatory: boolean, type: ServiceSectionOptionType_Enum, serviceOptionSectionOptions: Array<{ __typename?: 'serviceOptionSectionOptions', id: any, name: string, order: any, price: any, quantity: ServiceSectionOptionQuantityType_Enum }> }> } | null };

export type UpdateServiceOptionNameMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateServiceOptionNameMutation = { __typename?: 'mutation_root', update_serviceOptions?: { __typename?: 'serviceOptions_mutation_response', returning: Array<{ __typename?: 'serviceOptions', id: any, name: string }> } | null };

export type UpdateServiceOptionsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: ServiceOptions_Insert_Input;
}>;


export type UpdateServiceOptionsMutation = { __typename?: 'mutation_root', serviceOptionsDeleted?: { __typename?: 'serviceOptions_mutation_response', returning: Array<{ __typename?: 'serviceOptions', id: any, deletedAt?: any | null }> } | null, serviceOptionsCreated?: { __typename?: 'serviceOptions', id: any, name: string, status: ServiceOptionsStatus_Enum, serviceId: any, serviceOptionSections: Array<{ __typename?: 'serviceOptionSection', id: any, name: string, order: any, mandatory: boolean, type: ServiceSectionOptionType_Enum, serviceOptionSectionOptions: Array<{ __typename?: 'serviceOptionSectionOptions', id: any, name: string, order: any, price: any, quantity: ServiceSectionOptionQuantityType_Enum }> }> } | null };

export type DeleteServiceOptionsMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteServiceOptionsMutation = { __typename?: 'mutation_root', update_serviceOptions?: { __typename?: 'serviceOptions_mutation_response', returning: Array<{ __typename?: 'serviceOptions', id: any, deletedAt?: any | null }> } | null };

export type ValidateServiceDetailSubmissionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ValidateServiceDetailSubmissionQuery = { __typename?: 'query_root', validateServiceById: { __typename?: 'ValidateService', canSubmit: boolean, isOverviewValid: boolean, paymentCheckoutValid: boolean, hasEmployees: boolean, hasPrice: boolean } };

export type GetSpServicesListQueryVariables = Exact<{
  searchByName: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  providerId: Scalars['uuid']['input'];
}>;


export type GetSpServicesListQuery = { __typename?: 'query_root', services: Array<{ __typename?: 'services', id: any, providerId: any, name: string, sku: string, duration?: any | null, customerCanPickEmployee?: boolean | null, featured?: boolean | null, serviceEmployees: Array<{ __typename?: 'serviceEmployees', user: { __typename?: 'users', id: any, name: string } }>, servicePricing?: { __typename?: 'servicePricings', basePrice?: any | null, minimumDeposit?: any | null, fees?: any | null, checkoutPayment?: any | null, paymentFormat: PaymentFormat_Enum, taxes?: boolean | null } | null, serviceOptions: Array<{ __typename?: 'serviceOptions', name: string, id: any, status: ServiceOptionsStatus_Enum, serviceOptionSections: Array<{ __typename?: 'serviceOptionSection', name: string, order: any, id: any, mandatory: boolean, type: ServiceSectionOptionType_Enum, serviceOptionSectionOptions: Array<{ __typename?: 'serviceOptionSectionOptions', id: any, name: string, order: any, price: any, quantity: ServiceSectionOptionQuantityType_Enum }> }> }>, servicesForms: Array<{ __typename?: 'servicesForms', id: any, formId: any, status: ServiceFormStatus_Enum, form: { __typename?: 'form', id: any, name: string, formQuestions: Array<{ __typename?: 'formQuestions', id: any, label: string, mandatory: boolean, name?: string | null, order: any, questionType: FormQuestionType_Enum, options: Array<{ __typename?: 'formQuestionOptions', id: any, value: string }> }> } }> }>, services_aggregate: { __typename?: 'services_aggregate', aggregate?: { __typename?: 'services_aggregate_fields', count: number } | null } };

export type GetSpServicesListbyLocationQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  providerId: Scalars['uuid']['input'];
  locationId: Scalars['uuid']['input'];
  searchByName: Scalars['String']['input'];
}>;


export type GetSpServicesListbyLocationQuery = { __typename?: 'query_root', services: Array<{ __typename?: 'services', id: any, providerId: any, name: string, description: string, sku: string, duration?: any | null, customerCanPickEmployee?: boolean | null, featured?: boolean | null, serviceEmployees: Array<{ __typename?: 'serviceEmployees', user: { __typename?: 'users', id: any, name: string } }>, servicePricing?: { __typename?: 'servicePricings', basePrice?: any | null, minimumDeposit?: any | null, fees?: any | null, checkoutPayment?: any | null, paymentFormat: PaymentFormat_Enum, taxes?: boolean | null } | null, serviceOptions: Array<{ __typename?: 'serviceOptions', name: string, id: any, status: ServiceOptionsStatus_Enum, serviceOptionSections: Array<{ __typename?: 'serviceOptionSection', name: string, order: any, id: any, mandatory: boolean, type: ServiceSectionOptionType_Enum, serviceOptionSectionOptions: Array<{ __typename?: 'serviceOptionSectionOptions', id: any, name: string, order: any, price: any, quantity: ServiceSectionOptionQuantityType_Enum }> }> }>, servicesForms: Array<{ __typename?: 'servicesForms', id: any, formId: any, status: ServiceFormStatus_Enum, form: { __typename?: 'form', id: any, name: string, formQuestions: Array<{ __typename?: 'formQuestions', id: any, label: string, mandatory: boolean, name?: string | null, order: any, questionType: FormQuestionType_Enum, options: Array<{ __typename?: 'formQuestionOptions', id: any, value: string }> }> } }> }>, services_aggregate: { __typename?: 'services_aggregate', aggregate?: { __typename?: 'services_aggregate_fields', count: number } | null } };

export type GetBmServicesListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  providerId: Scalars['uuid']['input'];
  locationId: Scalars['uuid']['input'];
  searchByName: Scalars['String']['input'];
}>;


export type GetBmServicesListQuery = { __typename?: 'query_root', services: Array<{ __typename?: 'services', id: any, providerId: any, name: string, sku: string, duration?: any | null, description: string, customerCanPickEmployee?: boolean | null, featured?: boolean | null, serviceEmployees: Array<{ __typename?: 'serviceEmployees', user: { __typename?: 'users', id: any, name: string } }>, servicePricing?: { __typename?: 'servicePricings', basePrice?: any | null, minimumDeposit?: any | null, fees?: any | null, checkoutPayment?: any | null, paymentFormat: PaymentFormat_Enum, taxes?: boolean | null } | null, serviceOptions: Array<{ __typename?: 'serviceOptions', name: string, id: any, status: ServiceOptionsStatus_Enum, serviceOptionSections: Array<{ __typename?: 'serviceOptionSection', name: string, order: any, id: any, mandatory: boolean, type: ServiceSectionOptionType_Enum, serviceOptionSectionOptions: Array<{ __typename?: 'serviceOptionSectionOptions', id: any, name: string, order: any, price: any, quantity: ServiceSectionOptionQuantityType_Enum }> }> }>, servicesForms: Array<{ __typename?: 'servicesForms', id: any, formId: any, status: ServiceFormStatus_Enum, form: { __typename?: 'form', id: any, name: string, formQuestions: Array<{ __typename?: 'formQuestions', id: any, label: string, mandatory: boolean, name?: string | null, order: any, questionType: FormQuestionType_Enum, options: Array<{ __typename?: 'formQuestionOptions', id: any, value: string }> }> } }> }>, services_aggregate: { __typename?: 'services_aggregate', aggregate?: { __typename?: 'services_aggregate_fields', count: number } | null } };

export type LoginQueryVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginQuery = { __typename?: 'query_root', login: { __typename?: 'UserSessionDto', accessToken: string, refreshToken: string } };

export type RegisterMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
}>;


export type RegisterMutation = { __typename?: 'mutation_root', register: { __typename?: 'UserSessionDto', accessToken: string, refreshToken: string } };

export type RequestForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestForgotPasswordMutation = { __typename?: 'mutation_root', requestForgotPassword: string };

export type CodeValidationMutationVariables = Exact<{
  email: Scalars['String']['input'];
  verificationToken: Scalars['String']['input'];
}>;


export type CodeValidationMutation = { __typename?: 'mutation_root', forgotPassword: { __typename?: 'UserSessionDto', accessToken: string, refreshToken: string } };

export type ChangePasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename?: 'mutation_root', changePassword: string };

export type GetAllUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUsersQuery = { __typename?: 'query_root', getAllUsers: Array<{ __typename?: 'UserWithoutPassword', id: string, email: string, phoneNumber?: string | null }> };

export type UserByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UserByIdQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: any, name: string, email: string, phoneNumber?: string | null, isEmailVerified: boolean, isPhoneNumberVerified: boolean, profilePicture?: { __typename?: 'files', id: any, name: string } | null, userRole?: { __typename?: 'userRoles', role: UserRole_Enum, calendarId?: string | null } | null, completedAppointments: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null } } | null };

export type UserKpiByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  startDate: Scalars['timestamptz']['input'];
  endDate: Scalars['timestamptz']['input'];
}>;


export type UserKpiByIdQuery = { __typename?: 'query_root', appointments: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null }, timeouts: { __typename?: 'timeouts_aggregate', aggregate?: { __typename?: 'timeouts_aggregate_fields', count: number } | null } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'query_root', getCurrentUser: { __typename?: 'UserWithoutPassword', id: string, name: string, email: string, phoneNumber?: string | null, profilePictureFileId?: string | null, isEmailVerified: boolean, isPhoneNumberVerified: boolean, address?: string | null, apartmentNumber?: string | null, userRole?: { __typename?: 'UserRolesEntity', role: string } | null, coordinates?: { __typename?: 'GeographyCoordinates', type: string, coordinates: Array<number> } | null, location?: { __typename?: 'Location', id: string, name: string, status: string, transitionStatus?: string | null } | null } };

export type UserDataQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UserDataQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: any, name: string, phoneNumber?: string | null, address?: string | null, coordinates?: any | null, email: string, profilePicture?: { __typename?: 'files', id: any, name: string, uploadName: string } | null } | null };

export type AddUserProfilePicMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  fileId: Scalars['uuid']['input'];
}>;


export type AddUserProfilePicMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any, name: string, phoneNumber?: string | null, address?: string | null, email: string, profilePicture?: { __typename?: 'files', id: any, name: string, uploadName: string } | null } | null };

export type DeleteUserProfilePicMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type DeleteUserProfilePicMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any, name: string, phoneNumber?: string | null, address?: string | null, email: string, profilePicture?: { __typename?: 'files', id: any, name: string, uploadName: string } | null } | null };

export type EditUserDetailsMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
}>;


export type EditUserDetailsMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any, name: string, address?: string | null, email: string, profilePicture?: { __typename?: 'files', id: any, name: string, uploadName: string } | null } | null };

export type EditUserPhoneNumberMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type EditUserPhoneNumberMutation = { __typename?: 'mutation_root', updateUserPhone: { __typename?: 'UserWithoutPassword', id: string, phoneNumber?: string | null, isPhoneNumberVerified: boolean } };

export type UpdateUserAddressMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  address: Scalars['String']['input'];
  coordinates: Scalars['geography']['input'];
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserAddressMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any, name: string, phoneNumber?: string | null, address?: string | null, coordinates?: any | null, email: string, profilePicture?: { __typename?: 'files', id: any, name: string, uploadName: string } | null } | null };

export type BuildingManagerLocationsByAddressQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type BuildingManagerLocationsByAddressQuery = { __typename?: 'query_root', locations: Array<{ __typename?: 'locations', id: any, address: string, buildingManager?: { __typename?: 'users', id: any, name: string, email: string, phoneNumber?: string | null } | null }> };

export type GetUserFutureAppointmentsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  jobStatus: Array<JobStatus_Enum> | JobStatus_Enum;
}>;


export type GetUserFutureAppointmentsQuery = { __typename?: 'query_root', appointments: Array<{ __typename?: 'appointments', id: any, startDate: any, jobStatus: JobStatus_Enum, paymentStatus: PaymentStatus_Enum, createdByUserId?: any | null, service: { __typename?: 'services', id: any, name: string, description: string, servicePictures: Array<{ __typename?: 'servicePictures', id: any, name: string }> } }>, appointments_aggregate: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null } };

export type GetUserPastAppointmentsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  jobStatus: Array<JobStatus_Enum> | JobStatus_Enum;
}>;


export type GetUserPastAppointmentsQuery = { __typename?: 'query_root', appointments: Array<{ __typename?: 'appointments', id: any, startDate: any, jobStatus: JobStatus_Enum, paymentStatus: PaymentStatus_Enum, createdByUserId?: any | null, service: { __typename?: 'services', id: any, name: string, sku: string, description: string, duration?: any | null, providerId: any, provider: { __typename?: 'providers', id: any, visibility: ProviderVisibility_Enum }, servicePricing?: { __typename?: 'servicePricings', id: any, basePrice?: any | null, fees?: any | null, minimumDeposit?: any | null, currency: Currencies_Enum, taxes?: boolean | null, checkoutPayment?: any | null, paymentFormat: PaymentFormat_Enum } | null, servicePictures: Array<{ __typename?: 'servicePictures', id: any, name: string, file: { __typename?: 'files', id: any, name: string, uploadName: string } }>, serviceOptions: Array<{ __typename?: 'serviceOptions', id: any, name: string, status: ServiceOptionsStatus_Enum, serviceOptionSections: Array<{ __typename?: 'serviceOptionSection', id: any, mandatory: boolean, name: string, type: ServiceSectionOptionType_Enum, order: any, serviceOptionSectionOptions: Array<{ __typename?: 'serviceOptionSectionOptions', id: any, name: string, price: any, order: any, quantity: ServiceSectionOptionQuantityType_Enum }> }> }>, servicesForms: Array<{ __typename?: 'servicesForms', id: any, formId: any, status: ServiceFormStatus_Enum, form: { __typename?: 'form', id: any, name: string, formQuestions: Array<{ __typename?: 'formQuestions', id: any, label: string, mandatory: boolean, name?: string | null, order: any, questionType: FormQuestionType_Enum, options: Array<{ __typename?: 'formQuestionOptions', id: any, value: string }>, formAnswers: Array<{ __typename?: 'formAnswers', formId: any, formQuestionId: any, answer?: string | null, optionId?: any | null, fileId?: any | null }> }> } }> } }>, appointments_aggregate: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null } };

export type GetUserDraftAppointmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserDraftAppointmentsQuery = { __typename?: 'query_root', appointments: Array<{ __typename?: 'appointments', id: any, startDate: any, jobStatus: JobStatus_Enum, paymentStatus: PaymentStatus_Enum, service: { __typename?: 'services', id: any, name: string, description: string, servicePictures: Array<{ __typename?: 'servicePictures', id: any, name: string }> } }> };

export type GetUpfrontAppointmentDetailsQueryVariables = Exact<{
  serviceId: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
  address: Scalars['String']['input'];
  optionAnswers: Array<CreateApptServiceOptionAnswers> | CreateApptServiceOptionAnswers;
  coordinates: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  formAnswers: Array<CreateApptServiceFormAnswers> | CreateApptServiceFormAnswers;
}>;


export type GetUpfrontAppointmentDetailsQuery = { __typename?: 'query_root', getUpfrontAppointmentDetails: { __typename?: 'GetUpfrontAppointmentDetails', data: { __typename?: 'GetUpfrontAppointmentDetailsData', formsNames: Array<string>, details: { __typename?: 'GetUpfrontAppointmentDetailsDataDetails', date: any, employeeName: string, locationName: string }, payPrice?: { __typename?: 'GetUpfrontAppointmentDetailsDataPayPrice', deposit?: number | null, fees?: number | null, serviceFee?: number | null, taxes?: number | null, options?: number | null, total: number } | null, price: { __typename?: 'GetUpfrontAppointmentDetailsDataPrice', deposit?: number | null, fees?: number | null, subtotal: number, taxes?: number | null, total: number, options: Array<{ __typename?: 'GetUpfrontAppointmentDetailsDataPriceOptions', name: string, price: number, quantity: number }>, service: { __typename?: 'GetUpfrontAppointmentDetailsDataPriceService', duration: number, name: string, price: number } } }, errors: { __typename?: 'GetUpfrontAppointmentDetailsErrors', details?: boolean | null, forms?: boolean | null, payPrice?: boolean | null, price?: boolean | null } } };

export type UserCardQueryVariables = Exact<{ [key: string]: never; }>;


export type UserCardQuery = { __typename?: 'query_root', getUserCard?: { __typename?: 'card', id: string, brand: string, expMonth: number, expYear: number, last4: string, name?: string | null } | null };

export type CreateUserSetupIntentMutationVariables = Exact<{
  confirmationTokenId: Scalars['String']['input'];
}>;


export type CreateUserSetupIntentMutation = { __typename?: 'mutation_root', createUserSetupIntent: { __typename?: 'SetupIntentDto', clientSecret: string, status: string } };

export type DeleteUserPaymentMethodMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUserPaymentMethodMutation = { __typename?: 'mutation_root', deleteUserPaymentMethod: { __typename?: 'DeletePaymentMethodDto', id: string } };

export type CreateAppointmentPaymentIntentUserMutationVariables = Exact<{
  serviceId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  optionAnswers: Array<CreateApptServiceOptionAnswers> | CreateApptServiceOptionAnswers;
}>;


export type CreateAppointmentPaymentIntentUserMutation = { __typename?: 'mutation_root', createAppointmentPaymentIntentUser: { __typename?: 'CreateAppointmentPaymentIntentDto', clientSecret: string, generatedAppointmentId: string, paymentIntentId: string, connectedAccountId: string } };

export type CreateAppointmentPaymentIntentAnonymousMutationVariables = Exact<{
  serviceId: Scalars['String']['input'];
  optionAnswers: Array<CreateApptServiceOptionAnswers> | CreateApptServiceOptionAnswers;
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAppointmentPaymentIntentAnonymousMutation = { __typename?: 'mutation_root', createAppointmentPaymentIntentAnonymous: { __typename?: 'CreateAppointmentPaymentIntentDto', clientSecret: string, generatedAppointmentId: string, paymentIntentId: string, connectedAccountId: string } };

export type CreateBookedAppointmentPaymentIntentMutationVariables = Exact<{
  appointmentId: Scalars['String']['input'];
}>;


export type CreateBookedAppointmentPaymentIntentMutation = { __typename?: 'mutation_root', createBookedAppointmentPaymentIntent: { __typename?: 'CreateBookedAppointmentPaymentIntentDto', clientSecret: string, connectedAccountId: string, paymentIntentId: string } };

export const AppointmentPricingFragmentDoc = gql`
    fragment AppointmentPricing on appointments {
  appointmentPricing {
    id
    basePrice
    taxes
    taxRate
    checkoutPayment
    fees
    minimumDeposit
  }
}
    `;
export const AppointmentPaymentsFragmentDoc = gql`
    fragment AppointmentPayments on appointments {
  payments {
    id
    amount
    currency
    description
    status
    sources
    refund {
      id
      amount
      currency
      status
    }
  }
}
    `;
export const AppointmentFormAnswersFragmentDoc = gql`
    fragment AppointmentFormAnswers on appointments {
  formAnswers {
    id
    answer
    formId
    formQuestionId
    optionId
    fileId
    form {
      id
      name
    }
    formQuestion {
      id
      label
      questionType
    }
    file {
      id
      name
      uploadName
    }
    option {
      id
      value
    }
  }
}
    `;
export const AppointmentServiceOptionAnswersFragmentDoc = gql`
    fragment AppointmentServiceOptionAnswers on appointments {
  serviceOptionAnswers {
    id
    quantity
    serviceOptionSectionOption {
      id
      price
      name
      serviceOptionSection {
        id
        name
        serviceOption {
          id
          name
          status
        }
      }
    }
  }
}
    `;
export const NewFormFragmentFragmentDoc = gql`
    fragment NewFormFragment on form {
  id
  name
  formQuestions {
    id
    label
    order
    mandatory
    questionType
    formQuestionOptions {
      id
      value
    }
  }
}
    `;
export const ProvidersInBuildingFragmentDoc = gql`
    fragment ProvidersInBuilding on providers {
  id
  name
  slug
  category
  status
  locations {
    id
    name
    type
    address
  }
  services {
    id
    sku
    name
    featured
    description
    servicePricing {
      id
      basePrice
    }
  }
  buildingProviders {
    id
    location {
      id
      name
      address
      coordinates
    }
  }
  providerPictureByProfilePic {
    id
    name
    file {
      id
      name
      uploadName
    }
  }
  providerPictureByCoverPic {
    id
    name
    file {
      id
      name
      uploadName
    }
  }
}
    `;
export const ExportAppointmentsByDateRangeDocument = gql`
    mutation ExportAppointmentsByDateRange($startDate: DateTime!, $endDate: DateTime!) {
  exportAppointments(startDate: $startDate, endDate: $endDate) {
    base64
  }
}
    `;
export type ExportAppointmentsByDateRangeMutationFn = Apollo.MutationFunction<ExportAppointmentsByDateRangeMutation, ExportAppointmentsByDateRangeMutationVariables>;

/**
 * __useExportAppointmentsByDateRangeMutation__
 *
 * To run a mutation, you first call `useExportAppointmentsByDateRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportAppointmentsByDateRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportAppointmentsByDateRangeMutation, { data, loading, error }] = useExportAppointmentsByDateRangeMutation({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportAppointmentsByDateRangeMutation(baseOptions?: Apollo.MutationHookOptions<ExportAppointmentsByDateRangeMutation, ExportAppointmentsByDateRangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportAppointmentsByDateRangeMutation, ExportAppointmentsByDateRangeMutationVariables>(ExportAppointmentsByDateRangeDocument, options);
      }
export type ExportAppointmentsByDateRangeMutationHookResult = ReturnType<typeof useExportAppointmentsByDateRangeMutation>;
export type ExportAppointmentsByDateRangeMutationResult = Apollo.MutationResult<ExportAppointmentsByDateRangeMutation>;
export type ExportAppointmentsByDateRangeMutationOptions = Apollo.BaseMutationOptions<ExportAppointmentsByDateRangeMutation, ExportAppointmentsByDateRangeMutationVariables>;
export const CancelRejectAppointmentDocument = gql`
    mutation CancelRejectAppointment($id: String!, $keepCancellationFee: Boolean) {
  cancelRejectAppointment(id: $id, keepCancellationFee: $keepCancellationFee) {
    id
    jobStatus
  }
}
    `;
export type CancelRejectAppointmentMutationFn = Apollo.MutationFunction<CancelRejectAppointmentMutation, CancelRejectAppointmentMutationVariables>;

/**
 * __useCancelRejectAppointmentMutation__
 *
 * To run a mutation, you first call `useCancelRejectAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRejectAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRejectAppointmentMutation, { data, loading, error }] = useCancelRejectAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      keepCancellationFee: // value for 'keepCancellationFee'
 *   },
 * });
 */
export function useCancelRejectAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CancelRejectAppointmentMutation, CancelRejectAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelRejectAppointmentMutation, CancelRejectAppointmentMutationVariables>(CancelRejectAppointmentDocument, options);
      }
export type CancelRejectAppointmentMutationHookResult = ReturnType<typeof useCancelRejectAppointmentMutation>;
export type CancelRejectAppointmentMutationResult = Apollo.MutationResult<CancelRejectAppointmentMutation>;
export type CancelRejectAppointmentMutationOptions = Apollo.BaseMutationOptions<CancelRejectAppointmentMutation, CancelRejectAppointmentMutationVariables>;
export const DeleteDraftAppointmentDocument = gql`
    mutation DeleteDraftAppointment($id: uuid!) {
  delete_payments(where: {appointment: {id: {_eq: $id}, jobStatus: {_eq: draft}}}) {
    returning {
      id
    }
  }
  delete_appointmentPricing(
    where: {appointment: {id: {_eq: $id}, jobStatus: {_eq: draft}}}
  ) {
    returning {
      id
    }
  }
  delete_serviceOptionAnswers(
    where: {appointment: {id: {_eq: $id}, jobStatus: {_eq: draft}}}
  ) {
    returning {
      id
    }
  }
  delete_formAnswers(
    where: {appointment: {id: {_eq: $id}, jobStatus: {_eq: draft}}}
  ) {
    returning {
      id
    }
  }
  delete_appointments(where: {id: {_eq: $id}, jobStatus: {_eq: draft}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteDraftAppointmentMutationFn = Apollo.MutationFunction<DeleteDraftAppointmentMutation, DeleteDraftAppointmentMutationVariables>;

/**
 * __useDeleteDraftAppointmentMutation__
 *
 * To run a mutation, you first call `useDeleteDraftAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDraftAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDraftAppointmentMutation, { data, loading, error }] = useDeleteDraftAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDraftAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDraftAppointmentMutation, DeleteDraftAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDraftAppointmentMutation, DeleteDraftAppointmentMutationVariables>(DeleteDraftAppointmentDocument, options);
      }
export type DeleteDraftAppointmentMutationHookResult = ReturnType<typeof useDeleteDraftAppointmentMutation>;
export type DeleteDraftAppointmentMutationResult = Apollo.MutationResult<DeleteDraftAppointmentMutation>;
export type DeleteDraftAppointmentMutationOptions = Apollo.BaseMutationOptions<DeleteDraftAppointmentMutation, DeleteDraftAppointmentMutationVariables>;
export const CreateAppointmentUserDocument = gql`
    mutation CreateAppointmentUser($input: CreateAppointmentUserDtoArgs!) {
  createAppointmentUser(data: $input) {
    id
  }
}
    `;
export type CreateAppointmentUserMutationFn = Apollo.MutationFunction<CreateAppointmentUserMutation, CreateAppointmentUserMutationVariables>;

/**
 * __useCreateAppointmentUserMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentUserMutation, { data, loading, error }] = useCreateAppointmentUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppointmentUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentUserMutation, CreateAppointmentUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentUserMutation, CreateAppointmentUserMutationVariables>(CreateAppointmentUserDocument, options);
      }
export type CreateAppointmentUserMutationHookResult = ReturnType<typeof useCreateAppointmentUserMutation>;
export type CreateAppointmentUserMutationResult = Apollo.MutationResult<CreateAppointmentUserMutation>;
export type CreateAppointmentUserMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentUserMutation, CreateAppointmentUserMutationVariables>;
export const ModifyAppointmentDocument = gql`
    mutation ModifyAppointment($id: String!, $input: ModifyAppointmentDtoArgs!) {
  modifyAppointment(id: $id, input: $input) {
    id
    employeeId
    serviceId
    locationId
    address
    coordinates {
      type
      coordinates
    }
    startDate
    endDate
    jobStatus
  }
}
    `;
export type ModifyAppointmentMutationFn = Apollo.MutationFunction<ModifyAppointmentMutation, ModifyAppointmentMutationVariables>;

/**
 * __useModifyAppointmentMutation__
 *
 * To run a mutation, you first call `useModifyAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyAppointmentMutation, { data, loading, error }] = useModifyAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifyAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<ModifyAppointmentMutation, ModifyAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyAppointmentMutation, ModifyAppointmentMutationVariables>(ModifyAppointmentDocument, options);
      }
export type ModifyAppointmentMutationHookResult = ReturnType<typeof useModifyAppointmentMutation>;
export type ModifyAppointmentMutationResult = Apollo.MutationResult<ModifyAppointmentMutation>;
export type ModifyAppointmentMutationOptions = Apollo.BaseMutationOptions<ModifyAppointmentMutation, ModifyAppointmentMutationVariables>;
export const CreateAppointmentAnonymousDocument = gql`
    mutation CreateAppointmentAnonymous($input: CreateAppointmentAnonymousDtoArgs!) {
  createAppointmentAnonymous(data: $input) {
    id
  }
}
    `;
export type CreateAppointmentAnonymousMutationFn = Apollo.MutationFunction<CreateAppointmentAnonymousMutation, CreateAppointmentAnonymousMutationVariables>;

/**
 * __useCreateAppointmentAnonymousMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentAnonymousMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentAnonymousMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentAnonymousMutation, { data, loading, error }] = useCreateAppointmentAnonymousMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppointmentAnonymousMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentAnonymousMutation, CreateAppointmentAnonymousMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentAnonymousMutation, CreateAppointmentAnonymousMutationVariables>(CreateAppointmentAnonymousDocument, options);
      }
export type CreateAppointmentAnonymousMutationHookResult = ReturnType<typeof useCreateAppointmentAnonymousMutation>;
export type CreateAppointmentAnonymousMutationResult = Apollo.MutationResult<CreateAppointmentAnonymousMutation>;
export type CreateAppointmentAnonymousMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentAnonymousMutation, CreateAppointmentAnonymousMutationVariables>;
export const AppointmentPaymentDetailsDocument = gql`
    query AppointmentPaymentDetails($appointmentId: String!) {
  getAppointmentPaymentDetails(appointmentId: $appointmentId) {
    options
    serviceFee
    taxes
    travelFees
  }
}
    `;

/**
 * __useAppointmentPaymentDetailsQuery__
 *
 * To run a query within a React component, call `useAppointmentPaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentPaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentPaymentDetailsQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useAppointmentPaymentDetailsQuery(baseOptions: Apollo.QueryHookOptions<AppointmentPaymentDetailsQuery, AppointmentPaymentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentPaymentDetailsQuery, AppointmentPaymentDetailsQueryVariables>(AppointmentPaymentDetailsDocument, options);
      }
export function useAppointmentPaymentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentPaymentDetailsQuery, AppointmentPaymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentPaymentDetailsQuery, AppointmentPaymentDetailsQueryVariables>(AppointmentPaymentDetailsDocument, options);
        }
export function useAppointmentPaymentDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AppointmentPaymentDetailsQuery, AppointmentPaymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppointmentPaymentDetailsQuery, AppointmentPaymentDetailsQueryVariables>(AppointmentPaymentDetailsDocument, options);
        }
export type AppointmentPaymentDetailsQueryHookResult = ReturnType<typeof useAppointmentPaymentDetailsQuery>;
export type AppointmentPaymentDetailsLazyQueryHookResult = ReturnType<typeof useAppointmentPaymentDetailsLazyQuery>;
export type AppointmentPaymentDetailsSuspenseQueryHookResult = ReturnType<typeof useAppointmentPaymentDetailsSuspenseQuery>;
export type AppointmentPaymentDetailsQueryResult = Apollo.QueryResult<AppointmentPaymentDetailsQuery, AppointmentPaymentDetailsQueryVariables>;
export const PayBookedAppointmentDocument = gql`
    mutation PayBookedAppointment($appointmentId: String!) {
  payBookedAppointment(appointmentId: $appointmentId)
}
    `;
export type PayBookedAppointmentMutationFn = Apollo.MutationFunction<PayBookedAppointmentMutation, PayBookedAppointmentMutationVariables>;

/**
 * __usePayBookedAppointmentMutation__
 *
 * To run a mutation, you first call `usePayBookedAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayBookedAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payBookedAppointmentMutation, { data, loading, error }] = usePayBookedAppointmentMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function usePayBookedAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<PayBookedAppointmentMutation, PayBookedAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayBookedAppointmentMutation, PayBookedAppointmentMutationVariables>(PayBookedAppointmentDocument, options);
      }
export type PayBookedAppointmentMutationHookResult = ReturnType<typeof usePayBookedAppointmentMutation>;
export type PayBookedAppointmentMutationResult = Apollo.MutationResult<PayBookedAppointmentMutation>;
export type PayBookedAppointmentMutationOptions = Apollo.BaseMutationOptions<PayBookedAppointmentMutation, PayBookedAppointmentMutationVariables>;
export const CanProviderReceivePaymentsDocument = gql`
    query CanProviderReceivePayments($providerId: String!) {
  canProviderReceivePayments(providerId: $providerId)
}
    `;

/**
 * __useCanProviderReceivePaymentsQuery__
 *
 * To run a query within a React component, call `useCanProviderReceivePaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanProviderReceivePaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanProviderReceivePaymentsQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useCanProviderReceivePaymentsQuery(baseOptions: Apollo.QueryHookOptions<CanProviderReceivePaymentsQuery, CanProviderReceivePaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanProviderReceivePaymentsQuery, CanProviderReceivePaymentsQueryVariables>(CanProviderReceivePaymentsDocument, options);
      }
export function useCanProviderReceivePaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanProviderReceivePaymentsQuery, CanProviderReceivePaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanProviderReceivePaymentsQuery, CanProviderReceivePaymentsQueryVariables>(CanProviderReceivePaymentsDocument, options);
        }
export function useCanProviderReceivePaymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CanProviderReceivePaymentsQuery, CanProviderReceivePaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CanProviderReceivePaymentsQuery, CanProviderReceivePaymentsQueryVariables>(CanProviderReceivePaymentsDocument, options);
        }
export type CanProviderReceivePaymentsQueryHookResult = ReturnType<typeof useCanProviderReceivePaymentsQuery>;
export type CanProviderReceivePaymentsLazyQueryHookResult = ReturnType<typeof useCanProviderReceivePaymentsLazyQuery>;
export type CanProviderReceivePaymentsSuspenseQueryHookResult = ReturnType<typeof useCanProviderReceivePaymentsSuspenseQuery>;
export type CanProviderReceivePaymentsQueryResult = Apollo.QueryResult<CanProviderReceivePaymentsQuery, CanProviderReceivePaymentsQueryVariables>;
export const RenewTokensDocument = gql`
    mutation RenewTokens($refreshToken: String!) {
  refreshTokens(refreshToken: $refreshToken) {
    accessToken
    refreshToken
  }
}
    `;
export type RenewTokensMutationFn = Apollo.MutationFunction<RenewTokensMutation, RenewTokensMutationVariables>;

/**
 * __useRenewTokensMutation__
 *
 * To run a mutation, you first call `useRenewTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewTokensMutation, { data, loading, error }] = useRenewTokensMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRenewTokensMutation(baseOptions?: Apollo.MutationHookOptions<RenewTokensMutation, RenewTokensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewTokensMutation, RenewTokensMutationVariables>(RenewTokensDocument, options);
      }
export type RenewTokensMutationHookResult = ReturnType<typeof useRenewTokensMutation>;
export type RenewTokensMutationResult = Apollo.MutationResult<RenewTokensMutation>;
export type RenewTokensMutationOptions = Apollo.BaseMutationOptions<RenewTokensMutation, RenewTokensMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    deletedSessions {
      id
    }
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const RegisterProviderDocument = gql`
    mutation RegisterProvider($providerAddress: String!, $providerCategory: String!, $providerEmail: String!, $providerName: String!, $providerPhone: String!, $userEmail: String!, $userName: String!, $userPassword: String!, $userPhone: String!) {
  registerProvider(
    provider: {address: $providerAddress, category: $providerCategory, email: $providerEmail, name: $providerName, phoneNumber: $providerPhone}
    user: {email: $userEmail, name: $userName, password: $userPassword, phoneNumber: $userPhone}
  ) {
    accessToken
    refreshToken
  }
}
    `;
export type RegisterProviderMutationFn = Apollo.MutationFunction<RegisterProviderMutation, RegisterProviderMutationVariables>;

/**
 * __useRegisterProviderMutation__
 *
 * To run a mutation, you first call `useRegisterProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerProviderMutation, { data, loading, error }] = useRegisterProviderMutation({
 *   variables: {
 *      providerAddress: // value for 'providerAddress'
 *      providerCategory: // value for 'providerCategory'
 *      providerEmail: // value for 'providerEmail'
 *      providerName: // value for 'providerName'
 *      providerPhone: // value for 'providerPhone'
 *      userEmail: // value for 'userEmail'
 *      userName: // value for 'userName'
 *      userPassword: // value for 'userPassword'
 *      userPhone: // value for 'userPhone'
 *   },
 * });
 */
export function useRegisterProviderMutation(baseOptions?: Apollo.MutationHookOptions<RegisterProviderMutation, RegisterProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterProviderMutation, RegisterProviderMutationVariables>(RegisterProviderDocument, options);
      }
export type RegisterProviderMutationHookResult = ReturnType<typeof useRegisterProviderMutation>;
export type RegisterProviderMutationResult = Apollo.MutationResult<RegisterProviderMutation>;
export type RegisterProviderMutationOptions = Apollo.BaseMutationOptions<RegisterProviderMutation, RegisterProviderMutationVariables>;
export const RequestVerifyPhoneNumberDocument = gql`
    mutation RequestVerifyPhoneNumber {
  requestVerifyPhoneNumber
}
    `;
export type RequestVerifyPhoneNumberMutationFn = Apollo.MutationFunction<RequestVerifyPhoneNumberMutation, RequestVerifyPhoneNumberMutationVariables>;

/**
 * __useRequestVerifyPhoneNumberMutation__
 *
 * To run a mutation, you first call `useRequestVerifyPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestVerifyPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestVerifyPhoneNumberMutation, { data, loading, error }] = useRequestVerifyPhoneNumberMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestVerifyPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<RequestVerifyPhoneNumberMutation, RequestVerifyPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestVerifyPhoneNumberMutation, RequestVerifyPhoneNumberMutationVariables>(RequestVerifyPhoneNumberDocument, options);
      }
export type RequestVerifyPhoneNumberMutationHookResult = ReturnType<typeof useRequestVerifyPhoneNumberMutation>;
export type RequestVerifyPhoneNumberMutationResult = Apollo.MutationResult<RequestVerifyPhoneNumberMutation>;
export type RequestVerifyPhoneNumberMutationOptions = Apollo.BaseMutationOptions<RequestVerifyPhoneNumberMutation, RequestVerifyPhoneNumberMutationVariables>;
export const VerifyPhoneNumberTokenDocument = gql`
    mutation VerifyPhoneNumberToken($token: String!) {
  verifyPhoneNumber(token: $token)
}
    `;
export type VerifyPhoneNumberTokenMutationFn = Apollo.MutationFunction<VerifyPhoneNumberTokenMutation, VerifyPhoneNumberTokenMutationVariables>;

/**
 * __useVerifyPhoneNumberTokenMutation__
 *
 * To run a mutation, you first call `useVerifyPhoneNumberTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPhoneNumberTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPhoneNumberTokenMutation, { data, loading, error }] = useVerifyPhoneNumberTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyPhoneNumberTokenMutation(baseOptions?: Apollo.MutationHookOptions<VerifyPhoneNumberTokenMutation, VerifyPhoneNumberTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyPhoneNumberTokenMutation, VerifyPhoneNumberTokenMutationVariables>(VerifyPhoneNumberTokenDocument, options);
      }
export type VerifyPhoneNumberTokenMutationHookResult = ReturnType<typeof useVerifyPhoneNumberTokenMutation>;
export type VerifyPhoneNumberTokenMutationResult = Apollo.MutationResult<VerifyPhoneNumberTokenMutation>;
export type VerifyPhoneNumberTokenMutationOptions = Apollo.BaseMutationOptions<VerifyPhoneNumberTokenMutation, VerifyPhoneNumberTokenMutationVariables>;
export const RequestVerifyEmailDocument = gql`
    mutation RequestVerifyEmail {
  requestVerifyEmail
}
    `;
export type RequestVerifyEmailMutationFn = Apollo.MutationFunction<RequestVerifyEmailMutation, RequestVerifyEmailMutationVariables>;

/**
 * __useRequestVerifyEmailMutation__
 *
 * To run a mutation, you first call `useRequestVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestVerifyEmailMutation, { data, loading, error }] = useRequestVerifyEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<RequestVerifyEmailMutation, RequestVerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestVerifyEmailMutation, RequestVerifyEmailMutationVariables>(RequestVerifyEmailDocument, options);
      }
export type RequestVerifyEmailMutationHookResult = ReturnType<typeof useRequestVerifyEmailMutation>;
export type RequestVerifyEmailMutationResult = Apollo.MutationResult<RequestVerifyEmailMutation>;
export type RequestVerifyEmailMutationOptions = Apollo.BaseMutationOptions<RequestVerifyEmailMutation, RequestVerifyEmailMutationVariables>;
export const VerifyEmailTokenDocument = gql`
    mutation VerifyEmailToken($token: String!) {
  verifyEmail(token: $token)
}
    `;
export type VerifyEmailTokenMutationFn = Apollo.MutationFunction<VerifyEmailTokenMutation, VerifyEmailTokenMutationVariables>;

/**
 * __useVerifyEmailTokenMutation__
 *
 * To run a mutation, you first call `useVerifyEmailTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailTokenMutation, { data, loading, error }] = useVerifyEmailTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyEmailTokenMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailTokenMutation, VerifyEmailTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailTokenMutation, VerifyEmailTokenMutationVariables>(VerifyEmailTokenDocument, options);
      }
export type VerifyEmailTokenMutationHookResult = ReturnType<typeof useVerifyEmailTokenMutation>;
export type VerifyEmailTokenMutationResult = Apollo.MutationResult<VerifyEmailTokenMutation>;
export type VerifyEmailTokenMutationOptions = Apollo.BaseMutationOptions<VerifyEmailTokenMutation, VerifyEmailTokenMutationVariables>;
export const GetCheckoutSessionDocument = gql`
    mutation GetCheckoutSession {
  getCheckoutSession {
    id
    token
  }
}
    `;
export type GetCheckoutSessionMutationFn = Apollo.MutationFunction<GetCheckoutSessionMutation, GetCheckoutSessionMutationVariables>;

/**
 * __useGetCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useGetCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getCheckoutSessionMutation, { data, loading, error }] = useGetCheckoutSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetCheckoutSessionMutation(baseOptions?: Apollo.MutationHookOptions<GetCheckoutSessionMutation, GetCheckoutSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetCheckoutSessionMutation, GetCheckoutSessionMutationVariables>(GetCheckoutSessionDocument, options);
      }
export type GetCheckoutSessionMutationHookResult = ReturnType<typeof useGetCheckoutSessionMutation>;
export type GetCheckoutSessionMutationResult = Apollo.MutationResult<GetCheckoutSessionMutation>;
export type GetCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<GetCheckoutSessionMutation, GetCheckoutSessionMutationVariables>;
export const DeleteCheckoutSessionDocument = gql`
    mutation DeleteCheckoutSession($token: String!) {
  cancelCheckoutSession(token: $token)
}
    `;
export type DeleteCheckoutSessionMutationFn = Apollo.MutationFunction<DeleteCheckoutSessionMutation, DeleteCheckoutSessionMutationVariables>;

/**
 * __useDeleteCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useDeleteCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCheckoutSessionMutation, { data, loading, error }] = useDeleteCheckoutSessionMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useDeleteCheckoutSessionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCheckoutSessionMutation, DeleteCheckoutSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCheckoutSessionMutation, DeleteCheckoutSessionMutationVariables>(DeleteCheckoutSessionDocument, options);
      }
export type DeleteCheckoutSessionMutationHookResult = ReturnType<typeof useDeleteCheckoutSessionMutation>;
export type DeleteCheckoutSessionMutationResult = Apollo.MutationResult<DeleteCheckoutSessionMutation>;
export type DeleteCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<DeleteCheckoutSessionMutation, DeleteCheckoutSessionMutationVariables>;
export const CreateBuildingManagerDocument = gql`
    mutation CreateBuildingManager($input: BuildingManagerRegisterInputDto!) {
  registerBuildingManager(buildingManager: $input) {
    accessToken
    refreshToken
  }
}
    `;
export type CreateBuildingManagerMutationFn = Apollo.MutationFunction<CreateBuildingManagerMutation, CreateBuildingManagerMutationVariables>;

/**
 * __useCreateBuildingManagerMutation__
 *
 * To run a mutation, you first call `useCreateBuildingManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuildingManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuildingManagerMutation, { data, loading, error }] = useCreateBuildingManagerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBuildingManagerMutation(baseOptions?: Apollo.MutationHookOptions<CreateBuildingManagerMutation, CreateBuildingManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBuildingManagerMutation, CreateBuildingManagerMutationVariables>(CreateBuildingManagerDocument, options);
      }
export type CreateBuildingManagerMutationHookResult = ReturnType<typeof useCreateBuildingManagerMutation>;
export type CreateBuildingManagerMutationResult = Apollo.MutationResult<CreateBuildingManagerMutation>;
export type CreateBuildingManagerMutationOptions = Apollo.BaseMutationOptions<CreateBuildingManagerMutation, CreateBuildingManagerMutationVariables>;
export const UpdateBuildingManagerDocument = gql`
    mutation UpdateBuildingManager($buildingManagerId: uuid!, $name: String!, $phoneNumber: String!) {
  buildingManager: update_users_by_pk(
    pk_columns: {id: $buildingManagerId}
    _set: {name: $name, phoneNumber: $phoneNumber}
  ) {
    id
    name
    phoneNumber
  }
}
    `;
export type UpdateBuildingManagerMutationFn = Apollo.MutationFunction<UpdateBuildingManagerMutation, UpdateBuildingManagerMutationVariables>;

/**
 * __useUpdateBuildingManagerMutation__
 *
 * To run a mutation, you first call `useUpdateBuildingManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBuildingManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBuildingManagerMutation, { data, loading, error }] = useUpdateBuildingManagerMutation({
 *   variables: {
 *      buildingManagerId: // value for 'buildingManagerId'
 *      name: // value for 'name'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdateBuildingManagerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBuildingManagerMutation, UpdateBuildingManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBuildingManagerMutation, UpdateBuildingManagerMutationVariables>(UpdateBuildingManagerDocument, options);
      }
export type UpdateBuildingManagerMutationHookResult = ReturnType<typeof useUpdateBuildingManagerMutation>;
export type UpdateBuildingManagerMutationResult = Apollo.MutationResult<UpdateBuildingManagerMutation>;
export type UpdateBuildingManagerMutationOptions = Apollo.BaseMutationOptions<UpdateBuildingManagerMutation, UpdateBuildingManagerMutationVariables>;
export const GetBuildingManagerSettingsDocument = gql`
    query GetBuildingManagerSettings($buildingManagerId: uuid!) {
  building: locations(where: {buildingManagerId: {_eq: $buildingManagerId}}) {
    id
    name
    address
    coordinates
    partnershipDefaultStatus
  }
  buildingManager: users_by_pk(id: $buildingManagerId) {
    id
    name
    email
    phoneNumber
  }
}
    `;

/**
 * __useGetBuildingManagerSettingsQuery__
 *
 * To run a query within a React component, call `useGetBuildingManagerSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuildingManagerSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuildingManagerSettingsQuery({
 *   variables: {
 *      buildingManagerId: // value for 'buildingManagerId'
 *   },
 * });
 */
export function useGetBuildingManagerSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetBuildingManagerSettingsQuery, GetBuildingManagerSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuildingManagerSettingsQuery, GetBuildingManagerSettingsQueryVariables>(GetBuildingManagerSettingsDocument, options);
      }
export function useGetBuildingManagerSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuildingManagerSettingsQuery, GetBuildingManagerSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuildingManagerSettingsQuery, GetBuildingManagerSettingsQueryVariables>(GetBuildingManagerSettingsDocument, options);
        }
export function useGetBuildingManagerSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBuildingManagerSettingsQuery, GetBuildingManagerSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBuildingManagerSettingsQuery, GetBuildingManagerSettingsQueryVariables>(GetBuildingManagerSettingsDocument, options);
        }
export type GetBuildingManagerSettingsQueryHookResult = ReturnType<typeof useGetBuildingManagerSettingsQuery>;
export type GetBuildingManagerSettingsLazyQueryHookResult = ReturnType<typeof useGetBuildingManagerSettingsLazyQuery>;
export type GetBuildingManagerSettingsSuspenseQueryHookResult = ReturnType<typeof useGetBuildingManagerSettingsSuspenseQuery>;
export type GetBuildingManagerSettingsQueryResult = Apollo.QueryResult<GetBuildingManagerSettingsQuery, GetBuildingManagerSettingsQueryVariables>;
export const UpdatePartnershipDefaultStatusDocument = gql`
    mutation UpdatePartnershipDefaultStatus($buildingId: uuid!, $partnershipDefaultStatus: partnershipStatus_enum) {
  update_locations_by_pk(
    pk_columns: {id: $buildingId}
    _set: {partnershipDefaultStatus: $partnershipDefaultStatus}
  ) {
    id
    partnershipDefaultStatus
  }
}
    `;
export type UpdatePartnershipDefaultStatusMutationFn = Apollo.MutationFunction<UpdatePartnershipDefaultStatusMutation, UpdatePartnershipDefaultStatusMutationVariables>;

/**
 * __useUpdatePartnershipDefaultStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePartnershipDefaultStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnershipDefaultStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnershipDefaultStatusMutation, { data, loading, error }] = useUpdatePartnershipDefaultStatusMutation({
 *   variables: {
 *      buildingId: // value for 'buildingId'
 *      partnershipDefaultStatus: // value for 'partnershipDefaultStatus'
 *   },
 * });
 */
export function useUpdatePartnershipDefaultStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnershipDefaultStatusMutation, UpdatePartnershipDefaultStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnershipDefaultStatusMutation, UpdatePartnershipDefaultStatusMutationVariables>(UpdatePartnershipDefaultStatusDocument, options);
      }
export type UpdatePartnershipDefaultStatusMutationHookResult = ReturnType<typeof useUpdatePartnershipDefaultStatusMutation>;
export type UpdatePartnershipDefaultStatusMutationResult = Apollo.MutationResult<UpdatePartnershipDefaultStatusMutation>;
export type UpdatePartnershipDefaultStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePartnershipDefaultStatusMutation, UpdatePartnershipDefaultStatusMutationVariables>;
export const GetBuildingByBuildingManagerIdDocument = gql`
    query GetBuildingByBuildingManagerId($buildingManagerId: uuid!) {
  buildingManager: users(where: {id: {_eq: $buildingManagerId}}) {
    id
    building: location {
      id
      name
      address
      coordinates
    }
  }
}
    `;

/**
 * __useGetBuildingByBuildingManagerIdQuery__
 *
 * To run a query within a React component, call `useGetBuildingByBuildingManagerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuildingByBuildingManagerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuildingByBuildingManagerIdQuery({
 *   variables: {
 *      buildingManagerId: // value for 'buildingManagerId'
 *   },
 * });
 */
export function useGetBuildingByBuildingManagerIdQuery(baseOptions: Apollo.QueryHookOptions<GetBuildingByBuildingManagerIdQuery, GetBuildingByBuildingManagerIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuildingByBuildingManagerIdQuery, GetBuildingByBuildingManagerIdQueryVariables>(GetBuildingByBuildingManagerIdDocument, options);
      }
export function useGetBuildingByBuildingManagerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuildingByBuildingManagerIdQuery, GetBuildingByBuildingManagerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuildingByBuildingManagerIdQuery, GetBuildingByBuildingManagerIdQueryVariables>(GetBuildingByBuildingManagerIdDocument, options);
        }
export function useGetBuildingByBuildingManagerIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBuildingByBuildingManagerIdQuery, GetBuildingByBuildingManagerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBuildingByBuildingManagerIdQuery, GetBuildingByBuildingManagerIdQueryVariables>(GetBuildingByBuildingManagerIdDocument, options);
        }
export type GetBuildingByBuildingManagerIdQueryHookResult = ReturnType<typeof useGetBuildingByBuildingManagerIdQuery>;
export type GetBuildingByBuildingManagerIdLazyQueryHookResult = ReturnType<typeof useGetBuildingByBuildingManagerIdLazyQuery>;
export type GetBuildingByBuildingManagerIdSuspenseQueryHookResult = ReturnType<typeof useGetBuildingByBuildingManagerIdSuspenseQuery>;
export type GetBuildingByBuildingManagerIdQueryResult = Apollo.QueryResult<GetBuildingByBuildingManagerIdQuery, GetBuildingByBuildingManagerIdQueryVariables>;
export const GetCustomerCardDocument = gql`
    query GetCustomerCard($customerId: String!) {
  CustomerCard(customerId: $customerId) {
    id
    brand
    expMonth
    expYear
    last4
    name
  }
}
    `;

/**
 * __useGetCustomerCardQuery__
 *
 * To run a query within a React component, call `useGetCustomerCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerCardQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerCardQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerCardQuery, GetCustomerCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerCardQuery, GetCustomerCardQueryVariables>(GetCustomerCardDocument, options);
      }
export function useGetCustomerCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerCardQuery, GetCustomerCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerCardQuery, GetCustomerCardQueryVariables>(GetCustomerCardDocument, options);
        }
export function useGetCustomerCardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerCardQuery, GetCustomerCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerCardQuery, GetCustomerCardQueryVariables>(GetCustomerCardDocument, options);
        }
export type GetCustomerCardQueryHookResult = ReturnType<typeof useGetCustomerCardQuery>;
export type GetCustomerCardLazyQueryHookResult = ReturnType<typeof useGetCustomerCardLazyQuery>;
export type GetCustomerCardSuspenseQueryHookResult = ReturnType<typeof useGetCustomerCardSuspenseQuery>;
export type GetCustomerCardQueryResult = Apollo.QueryResult<GetCustomerCardQuery, GetCustomerCardQueryVariables>;
export const CreateCustomerSetupIntentDocument = gql`
    mutation createCustomerSetupIntent($customerId: String!, $confirmationTokenId: String!) {
  createCustomerSetupIntent(
    customerId: $customerId
    confirmationTokenId: $confirmationTokenId
  ) {
    clientSecret
    status
  }
}
    `;
export type CreateCustomerSetupIntentMutationFn = Apollo.MutationFunction<CreateCustomerSetupIntentMutation, CreateCustomerSetupIntentMutationVariables>;

/**
 * __useCreateCustomerSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateCustomerSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerSetupIntentMutation, { data, loading, error }] = useCreateCustomerSetupIntentMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      confirmationTokenId: // value for 'confirmationTokenId'
 *   },
 * });
 */
export function useCreateCustomerSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerSetupIntentMutation, CreateCustomerSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerSetupIntentMutation, CreateCustomerSetupIntentMutationVariables>(CreateCustomerSetupIntentDocument, options);
      }
export type CreateCustomerSetupIntentMutationHookResult = ReturnType<typeof useCreateCustomerSetupIntentMutation>;
export type CreateCustomerSetupIntentMutationResult = Apollo.MutationResult<CreateCustomerSetupIntentMutation>;
export type CreateCustomerSetupIntentMutationOptions = Apollo.BaseMutationOptions<CreateCustomerSetupIntentMutation, CreateCustomerSetupIntentMutationVariables>;
export const DeleteCustomerPaymentMethodDocument = gql`
    mutation DeleteCustomerPaymentMethod($customerId: String!) {
  deleteCustomerPaymentMethod(customerId: $customerId) {
    id
  }
}
    `;
export type DeleteCustomerPaymentMethodMutationFn = Apollo.MutationFunction<DeleteCustomerPaymentMethodMutation, DeleteCustomerPaymentMethodMutationVariables>;

/**
 * __useDeleteCustomerPaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerPaymentMethodMutation, { data, loading, error }] = useDeleteCustomerPaymentMethodMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useDeleteCustomerPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerPaymentMethodMutation, DeleteCustomerPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerPaymentMethodMutation, DeleteCustomerPaymentMethodMutationVariables>(DeleteCustomerPaymentMethodDocument, options);
      }
export type DeleteCustomerPaymentMethodMutationHookResult = ReturnType<typeof useDeleteCustomerPaymentMethodMutation>;
export type DeleteCustomerPaymentMethodMutationResult = Apollo.MutationResult<DeleteCustomerPaymentMethodMutation>;
export type DeleteCustomerPaymentMethodMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerPaymentMethodMutation, DeleteCustomerPaymentMethodMutationVariables>;
export const GetBuildingCustomersDocument = gql`
    query GetBuildingCustomers($searchByName: String!, $limit: Float, $offset: Float) {
  getBMCustomerList(searchByName: $searchByName, limit: $limit, offset: $offset) {
    filteredCustomers {
      id
      name
      email
      isBlocked
      locationId
      address
      coordinates {
        coordinates
      }
      apartmentNumber
      phoneNumber
      stripePaymentMethodId
      bmStripePaymentMethodId
      user {
        id
        name
        email
        profilePicture {
          id
          name
        }
        phoneNumber
        address
        coordinates {
          coordinates
        }
      }
      bookings {
        aggregate {
          count
        }
      }
      amountSpent {
        amount
      }
    }
    filteredCustomersAggregate {
      aggregate {
        count
      }
    }
    allAppointmentsAggregate {
      aggregate {
        count
      }
    }
    allCustomersAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetBuildingCustomersQuery__
 *
 * To run a query within a React component, call `useGetBuildingCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuildingCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuildingCustomersQuery({
 *   variables: {
 *      searchByName: // value for 'searchByName'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetBuildingCustomersQuery(baseOptions: Apollo.QueryHookOptions<GetBuildingCustomersQuery, GetBuildingCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuildingCustomersQuery, GetBuildingCustomersQueryVariables>(GetBuildingCustomersDocument, options);
      }
export function useGetBuildingCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuildingCustomersQuery, GetBuildingCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuildingCustomersQuery, GetBuildingCustomersQueryVariables>(GetBuildingCustomersDocument, options);
        }
export function useGetBuildingCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBuildingCustomersQuery, GetBuildingCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBuildingCustomersQuery, GetBuildingCustomersQueryVariables>(GetBuildingCustomersDocument, options);
        }
export type GetBuildingCustomersQueryHookResult = ReturnType<typeof useGetBuildingCustomersQuery>;
export type GetBuildingCustomersLazyQueryHookResult = ReturnType<typeof useGetBuildingCustomersLazyQuery>;
export type GetBuildingCustomersSuspenseQueryHookResult = ReturnType<typeof useGetBuildingCustomersSuspenseQuery>;
export type GetBuildingCustomersQueryResult = Apollo.QueryResult<GetBuildingCustomersQuery, GetBuildingCustomersQueryVariables>;
export const GetBasicCustomerDetailsByIdDocument = gql`
    query GetBasicCustomerDetailsById($customerId: String!) {
  getBMCustomerDetails(customerId: $customerId) {
    id
    name
    email
    phoneNumber
    address
    coordinates {
      coordinates
    }
    apartmentNumber
    bmStripePaymentMethodId
    user {
      id
      name
      email
      phoneNumber
      address
      coordinates {
        coordinates
      }
    }
  }
}
    `;

/**
 * __useGetBasicCustomerDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetBasicCustomerDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicCustomerDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasicCustomerDetailsByIdQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetBasicCustomerDetailsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetBasicCustomerDetailsByIdQuery, GetBasicCustomerDetailsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBasicCustomerDetailsByIdQuery, GetBasicCustomerDetailsByIdQueryVariables>(GetBasicCustomerDetailsByIdDocument, options);
      }
export function useGetBasicCustomerDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasicCustomerDetailsByIdQuery, GetBasicCustomerDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBasicCustomerDetailsByIdQuery, GetBasicCustomerDetailsByIdQueryVariables>(GetBasicCustomerDetailsByIdDocument, options);
        }
export function useGetBasicCustomerDetailsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBasicCustomerDetailsByIdQuery, GetBasicCustomerDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBasicCustomerDetailsByIdQuery, GetBasicCustomerDetailsByIdQueryVariables>(GetBasicCustomerDetailsByIdDocument, options);
        }
export type GetBasicCustomerDetailsByIdQueryHookResult = ReturnType<typeof useGetBasicCustomerDetailsByIdQuery>;
export type GetBasicCustomerDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetBasicCustomerDetailsByIdLazyQuery>;
export type GetBasicCustomerDetailsByIdSuspenseQueryHookResult = ReturnType<typeof useGetBasicCustomerDetailsByIdSuspenseQuery>;
export type GetBasicCustomerDetailsByIdQueryResult = Apollo.QueryResult<GetBasicCustomerDetailsByIdQuery, GetBasicCustomerDetailsByIdQueryVariables>;
export const GetCustomerDetailsByIdDocument = gql`
    query GetCustomerDetailsById($customerId: String!, $buildingManagerId: uuid!) {
  getBMCustomerDetails(customerId: $customerId) {
    id
    address
    coordinates {
      coordinates
    }
    apartmentNumber
    createdAt
    deletedAt
    email
    locationId
    name
    phoneNumber
    bmStripePaymentMethodId
    bmStripeCustomerId
    user {
      id
      email
      name
      profilePicture {
        id
        name
      }
      phoneNumber
      createdAt
      address
      coordinates {
        coordinates
      }
      apartmentNumber
    }
  }
  buildingManager: users(where: {id: {_eq: $buildingManagerId}}) {
    building: location {
      id
      name
      address
      type
    }
  }
}
    `;

/**
 * __useGetCustomerDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetCustomerDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerDetailsByIdQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      buildingManagerId: // value for 'buildingManagerId'
 *   },
 * });
 */
export function useGetCustomerDetailsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerDetailsByIdQuery, GetCustomerDetailsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerDetailsByIdQuery, GetCustomerDetailsByIdQueryVariables>(GetCustomerDetailsByIdDocument, options);
      }
export function useGetCustomerDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerDetailsByIdQuery, GetCustomerDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerDetailsByIdQuery, GetCustomerDetailsByIdQueryVariables>(GetCustomerDetailsByIdDocument, options);
        }
export function useGetCustomerDetailsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerDetailsByIdQuery, GetCustomerDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerDetailsByIdQuery, GetCustomerDetailsByIdQueryVariables>(GetCustomerDetailsByIdDocument, options);
        }
export type GetCustomerDetailsByIdQueryHookResult = ReturnType<typeof useGetCustomerDetailsByIdQuery>;
export type GetCustomerDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetCustomerDetailsByIdLazyQuery>;
export type GetCustomerDetailsByIdSuspenseQueryHookResult = ReturnType<typeof useGetCustomerDetailsByIdSuspenseQuery>;
export type GetCustomerDetailsByIdQueryResult = Apollo.QueryResult<GetCustomerDetailsByIdQuery, GetCustomerDetailsByIdQueryVariables>;
export const GetCustomerAppointmentsByIdDocument = gql`
    query GetCustomerAppointmentsById($customerId: String!, $appointmentsLimit: Float!, $appointmentsOffset: Float!) {
  getBMCustomerDetails(
    customerId: $customerId
    appointmentsOffset: $appointmentsOffset
    appointmentsLimit: $appointmentsLimit
  ) {
    appointments {
      id
      createdAt
      endDate
      startDate
      updatedAt
      jobStatus
      paymentStatus
      service {
        sku
        provider {
          id
          name
        }
      }
      location {
        id
        address
        radius
      }
      payments_aggregate {
        aggregate {
          sum {
            amount
          }
        }
      }
    }
    appointmentsAggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetCustomerAppointmentsByIdQuery__
 *
 * To run a query within a React component, call `useGetCustomerAppointmentsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerAppointmentsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerAppointmentsByIdQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      appointmentsLimit: // value for 'appointmentsLimit'
 *      appointmentsOffset: // value for 'appointmentsOffset'
 *   },
 * });
 */
export function useGetCustomerAppointmentsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerAppointmentsByIdQuery, GetCustomerAppointmentsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerAppointmentsByIdQuery, GetCustomerAppointmentsByIdQueryVariables>(GetCustomerAppointmentsByIdDocument, options);
      }
export function useGetCustomerAppointmentsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerAppointmentsByIdQuery, GetCustomerAppointmentsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerAppointmentsByIdQuery, GetCustomerAppointmentsByIdQueryVariables>(GetCustomerAppointmentsByIdDocument, options);
        }
export function useGetCustomerAppointmentsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerAppointmentsByIdQuery, GetCustomerAppointmentsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerAppointmentsByIdQuery, GetCustomerAppointmentsByIdQueryVariables>(GetCustomerAppointmentsByIdDocument, options);
        }
export type GetCustomerAppointmentsByIdQueryHookResult = ReturnType<typeof useGetCustomerAppointmentsByIdQuery>;
export type GetCustomerAppointmentsByIdLazyQueryHookResult = ReturnType<typeof useGetCustomerAppointmentsByIdLazyQuery>;
export type GetCustomerAppointmentsByIdSuspenseQueryHookResult = ReturnType<typeof useGetCustomerAppointmentsByIdSuspenseQuery>;
export type GetCustomerAppointmentsByIdQueryResult = Apollo.QueryResult<GetCustomerAppointmentsByIdQuery, GetCustomerAppointmentsByIdQueryVariables>;
export const FindCustomerByIdDocument = gql`
    query FindCustomerById($id: uuid!) {
  providers_by_pk(id: $id) {
    phoneNumber
    name
    id
    email
    address
    stripeCustomerId
    stripePaymentMethodId
  }
}
    `;

/**
 * __useFindCustomerByIdQuery__
 *
 * To run a query within a React component, call `useFindCustomerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCustomerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCustomerByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindCustomerByIdQuery(baseOptions: Apollo.QueryHookOptions<FindCustomerByIdQuery, FindCustomerByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCustomerByIdQuery, FindCustomerByIdQueryVariables>(FindCustomerByIdDocument, options);
      }
export function useFindCustomerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCustomerByIdQuery, FindCustomerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCustomerByIdQuery, FindCustomerByIdQueryVariables>(FindCustomerByIdDocument, options);
        }
export function useFindCustomerByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindCustomerByIdQuery, FindCustomerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindCustomerByIdQuery, FindCustomerByIdQueryVariables>(FindCustomerByIdDocument, options);
        }
export type FindCustomerByIdQueryHookResult = ReturnType<typeof useFindCustomerByIdQuery>;
export type FindCustomerByIdLazyQueryHookResult = ReturnType<typeof useFindCustomerByIdLazyQuery>;
export type FindCustomerByIdSuspenseQueryHookResult = ReturnType<typeof useFindCustomerByIdSuspenseQuery>;
export type FindCustomerByIdQueryResult = Apollo.QueryResult<FindCustomerByIdQuery, FindCustomerByIdQueryVariables>;
export const UpdateBuildingRelationshipStatusDocument = gql`
    mutation UpdateBuildingRelationshipStatus($providerId: uuid!, $relationshipStatus: relationshipStatus_enum!) {
  update_buildingProviders(
    where: {providerId: {_eq: $providerId}}
    _set: {status: $relationshipStatus}
  ) {
    returning {
      id
      locationId
      providerId
      status
    }
  }
}
    `;
export type UpdateBuildingRelationshipStatusMutationFn = Apollo.MutationFunction<UpdateBuildingRelationshipStatusMutation, UpdateBuildingRelationshipStatusMutationVariables>;

/**
 * __useUpdateBuildingRelationshipStatusMutation__
 *
 * To run a mutation, you first call `useUpdateBuildingRelationshipStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBuildingRelationshipStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBuildingRelationshipStatusMutation, { data, loading, error }] = useUpdateBuildingRelationshipStatusMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      relationshipStatus: // value for 'relationshipStatus'
 *   },
 * });
 */
export function useUpdateBuildingRelationshipStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBuildingRelationshipStatusMutation, UpdateBuildingRelationshipStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBuildingRelationshipStatusMutation, UpdateBuildingRelationshipStatusMutationVariables>(UpdateBuildingRelationshipStatusDocument, options);
      }
export type UpdateBuildingRelationshipStatusMutationHookResult = ReturnType<typeof useUpdateBuildingRelationshipStatusMutation>;
export type UpdateBuildingRelationshipStatusMutationResult = Apollo.MutationResult<UpdateBuildingRelationshipStatusMutation>;
export type UpdateBuildingRelationshipStatusMutationOptions = Apollo.BaseMutationOptions<UpdateBuildingRelationshipStatusMutation, UpdateBuildingRelationshipStatusMutationVariables>;
export const UpdateBuildingRelationshipStatusByPkDocument = gql`
    mutation UpdateBuildingRelationshipStatusByPk($id: uuid!, $relationshipStatus: relationshipStatus_enum!) {
  update_buildingProviders_by_pk(
    pk_columns: {id: $id}
    _set: {status: $relationshipStatus}
  ) {
    id
    locationId
    providerId
    status
  }
}
    `;
export type UpdateBuildingRelationshipStatusByPkMutationFn = Apollo.MutationFunction<UpdateBuildingRelationshipStatusByPkMutation, UpdateBuildingRelationshipStatusByPkMutationVariables>;

/**
 * __useUpdateBuildingRelationshipStatusByPkMutation__
 *
 * To run a mutation, you first call `useUpdateBuildingRelationshipStatusByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBuildingRelationshipStatusByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBuildingRelationshipStatusByPkMutation, { data, loading, error }] = useUpdateBuildingRelationshipStatusByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      relationshipStatus: // value for 'relationshipStatus'
 *   },
 * });
 */
export function useUpdateBuildingRelationshipStatusByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBuildingRelationshipStatusByPkMutation, UpdateBuildingRelationshipStatusByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBuildingRelationshipStatusByPkMutation, UpdateBuildingRelationshipStatusByPkMutationVariables>(UpdateBuildingRelationshipStatusByPkDocument, options);
      }
export type UpdateBuildingRelationshipStatusByPkMutationHookResult = ReturnType<typeof useUpdateBuildingRelationshipStatusByPkMutation>;
export type UpdateBuildingRelationshipStatusByPkMutationResult = Apollo.MutationResult<UpdateBuildingRelationshipStatusByPkMutation>;
export type UpdateBuildingRelationshipStatusByPkMutationOptions = Apollo.BaseMutationOptions<UpdateBuildingRelationshipStatusByPkMutation, UpdateBuildingRelationshipStatusByPkMutationVariables>;
export const GetBuildingServicesDocument = gql`
    query GetBuildingServices($searchByName: String!, $limit: Int!, $offset: Int!) {
  services(
    where: {serviceEmployees: {user: {schedules: {location: {buildingManagerId: {_eq: "0ba490c2-2a7c-4b70-be8b-a11fd4e7028e"}}}}}}
  ) {
    id
    name
    sku
    duration
    servicePricing {
      id
      basePrice
    }
    serviceOptions {
      name
      id
      status
      question: serviceOptionSections {
        name
        order
        id
        mandatory
        type
        answers: serviceOptionSectionOptions {
          id
          name
          order
          price
          quantity
          serviceOptionAnswers {
            id
            serviceOptionSectionOptionsId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBuildingServicesQuery__
 *
 * To run a query within a React component, call `useGetBuildingServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuildingServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuildingServicesQuery({
 *   variables: {
 *      searchByName: // value for 'searchByName'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetBuildingServicesQuery(baseOptions: Apollo.QueryHookOptions<GetBuildingServicesQuery, GetBuildingServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuildingServicesQuery, GetBuildingServicesQueryVariables>(GetBuildingServicesDocument, options);
      }
export function useGetBuildingServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuildingServicesQuery, GetBuildingServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuildingServicesQuery, GetBuildingServicesQueryVariables>(GetBuildingServicesDocument, options);
        }
export function useGetBuildingServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBuildingServicesQuery, GetBuildingServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBuildingServicesQuery, GetBuildingServicesQueryVariables>(GetBuildingServicesDocument, options);
        }
export type GetBuildingServicesQueryHookResult = ReturnType<typeof useGetBuildingServicesQuery>;
export type GetBuildingServicesLazyQueryHookResult = ReturnType<typeof useGetBuildingServicesLazyQuery>;
export type GetBuildingServicesSuspenseQueryHookResult = ReturnType<typeof useGetBuildingServicesSuspenseQuery>;
export type GetBuildingServicesQueryResult = Apollo.QueryResult<GetBuildingServicesQuery, GetBuildingServicesQueryVariables>;
export const EmployeesByServiceDocument = gql`
    query EmployeesByService($serviceId: uuid!, $limit: Int!, $offset: Int!, $searchByName: String!) {
  serviceEmployees(
    where: {serviceId: {_eq: $serviceId}, user: {name: {_ilike: $searchByName}, userRole: {deletedAt: {_is_null: true}}}}
    limit: $limit
    offset: $offset
  ) {
    user {
      id
      name
      profilePicture {
        id
        name
      }
      completedAppointments: appointmentsByEmployeeid_aggregate(
        where: {jobStatus: {_eq: completed}}
      ) {
        aggregate {
          count
        }
      }
    }
  }
  serviceEmployees_aggregate(
    where: {serviceId: {_eq: $serviceId}, user: {userRole: {deletedAt: {_is_null: true}}, name: {_ilike: $searchByName}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useEmployeesByServiceQuery__
 *
 * To run a query within a React component, call `useEmployeesByServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeesByServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeesByServiceQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchByName: // value for 'searchByName'
 *   },
 * });
 */
export function useEmployeesByServiceQuery(baseOptions: Apollo.QueryHookOptions<EmployeesByServiceQuery, EmployeesByServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeesByServiceQuery, EmployeesByServiceQueryVariables>(EmployeesByServiceDocument, options);
      }
export function useEmployeesByServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeesByServiceQuery, EmployeesByServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeesByServiceQuery, EmployeesByServiceQueryVariables>(EmployeesByServiceDocument, options);
        }
export function useEmployeesByServiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeesByServiceQuery, EmployeesByServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeesByServiceQuery, EmployeesByServiceQueryVariables>(EmployeesByServiceDocument, options);
        }
export type EmployeesByServiceQueryHookResult = ReturnType<typeof useEmployeesByServiceQuery>;
export type EmployeesByServiceLazyQueryHookResult = ReturnType<typeof useEmployeesByServiceLazyQuery>;
export type EmployeesByServiceSuspenseQueryHookResult = ReturnType<typeof useEmployeesByServiceSuspenseQuery>;
export type EmployeesByServiceQueryResult = Apollo.QueryResult<EmployeesByServiceQuery, EmployeesByServiceQueryVariables>;
export const GetManagerProvidersDocument = gql`
    query GetManagerProviders($searchByName: String) {
  buildingProviders(
    where: {status: {_eq: approved}, deletedAt: {_is_null: true}, provider: {name: {_ilike: $searchByName}}}
    order_by: {provider: {name: asc_nulls_last}}
  ) {
    id
    provider {
      id
      name
    }
  }
}
    `;

/**
 * __useGetManagerProvidersQuery__
 *
 * To run a query within a React component, call `useGetManagerProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerProvidersQuery({
 *   variables: {
 *      searchByName: // value for 'searchByName'
 *   },
 * });
 */
export function useGetManagerProvidersQuery(baseOptions?: Apollo.QueryHookOptions<GetManagerProvidersQuery, GetManagerProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagerProvidersQuery, GetManagerProvidersQueryVariables>(GetManagerProvidersDocument, options);
      }
export function useGetManagerProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagerProvidersQuery, GetManagerProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagerProvidersQuery, GetManagerProvidersQueryVariables>(GetManagerProvidersDocument, options);
        }
export function useGetManagerProvidersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetManagerProvidersQuery, GetManagerProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManagerProvidersQuery, GetManagerProvidersQueryVariables>(GetManagerProvidersDocument, options);
        }
export type GetManagerProvidersQueryHookResult = ReturnType<typeof useGetManagerProvidersQuery>;
export type GetManagerProvidersLazyQueryHookResult = ReturnType<typeof useGetManagerProvidersLazyQuery>;
export type GetManagerProvidersSuspenseQueryHookResult = ReturnType<typeof useGetManagerProvidersSuspenseQuery>;
export type GetManagerProvidersQueryResult = Apollo.QueryResult<GetManagerProvidersQuery, GetManagerProvidersQueryVariables>;
export const GetBuildingProvidersByRelationshipStatusDocument = gql`
    query GetBuildingProvidersByRelationshipStatus($relationshipStatus: [relationshipStatus_enum!], $limit: Int, $offset: Int) {
  buildingProviders(
    limit: $limit
    offset: $offset
    where: {status: {_in: $relationshipStatus}, deletedAt: {_is_null: true}}
    order_by: {provider: {name: asc_nulls_last}}
  ) {
    id
    provider {
      id
      name
      category
      email
      phoneNumber
      type
      slug
      profilePic
    }
    status
  }
  buildingProviders_aggregate(where: {status: {_in: $relationshipStatus}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetBuildingProvidersByRelationshipStatusQuery__
 *
 * To run a query within a React component, call `useGetBuildingProvidersByRelationshipStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuildingProvidersByRelationshipStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuildingProvidersByRelationshipStatusQuery({
 *   variables: {
 *      relationshipStatus: // value for 'relationshipStatus'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetBuildingProvidersByRelationshipStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetBuildingProvidersByRelationshipStatusQuery, GetBuildingProvidersByRelationshipStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuildingProvidersByRelationshipStatusQuery, GetBuildingProvidersByRelationshipStatusQueryVariables>(GetBuildingProvidersByRelationshipStatusDocument, options);
      }
export function useGetBuildingProvidersByRelationshipStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuildingProvidersByRelationshipStatusQuery, GetBuildingProvidersByRelationshipStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuildingProvidersByRelationshipStatusQuery, GetBuildingProvidersByRelationshipStatusQueryVariables>(GetBuildingProvidersByRelationshipStatusDocument, options);
        }
export function useGetBuildingProvidersByRelationshipStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBuildingProvidersByRelationshipStatusQuery, GetBuildingProvidersByRelationshipStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBuildingProvidersByRelationshipStatusQuery, GetBuildingProvidersByRelationshipStatusQueryVariables>(GetBuildingProvidersByRelationshipStatusDocument, options);
        }
export type GetBuildingProvidersByRelationshipStatusQueryHookResult = ReturnType<typeof useGetBuildingProvidersByRelationshipStatusQuery>;
export type GetBuildingProvidersByRelationshipStatusLazyQueryHookResult = ReturnType<typeof useGetBuildingProvidersByRelationshipStatusLazyQuery>;
export type GetBuildingProvidersByRelationshipStatusSuspenseQueryHookResult = ReturnType<typeof useGetBuildingProvidersByRelationshipStatusSuspenseQuery>;
export type GetBuildingProvidersByRelationshipStatusQueryResult = Apollo.QueryResult<GetBuildingProvidersByRelationshipStatusQuery, GetBuildingProvidersByRelationshipStatusQueryVariables>;
export const GetBuildingManagerRestrictedProvidersDocument = gql`
    query GetBuildingManagerRestrictedProviders($limit: Int, $offset: Int) {
  buildingProviders(
    limit: $limit
    offset: $offset
    where: {status: {_eq: restricted}}
  ) {
    id
    provider {
      id
      name
      email
      phoneNumber
      type
      slug
      profilePic
    }
    status
  }
  buildingProviders_aggregate(where: {status: {_eq: restricted}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetBuildingManagerRestrictedProvidersQuery__
 *
 * To run a query within a React component, call `useGetBuildingManagerRestrictedProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuildingManagerRestrictedProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuildingManagerRestrictedProvidersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetBuildingManagerRestrictedProvidersQuery(baseOptions?: Apollo.QueryHookOptions<GetBuildingManagerRestrictedProvidersQuery, GetBuildingManagerRestrictedProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuildingManagerRestrictedProvidersQuery, GetBuildingManagerRestrictedProvidersQueryVariables>(GetBuildingManagerRestrictedProvidersDocument, options);
      }
export function useGetBuildingManagerRestrictedProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuildingManagerRestrictedProvidersQuery, GetBuildingManagerRestrictedProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuildingManagerRestrictedProvidersQuery, GetBuildingManagerRestrictedProvidersQueryVariables>(GetBuildingManagerRestrictedProvidersDocument, options);
        }
export function useGetBuildingManagerRestrictedProvidersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBuildingManagerRestrictedProvidersQuery, GetBuildingManagerRestrictedProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBuildingManagerRestrictedProvidersQuery, GetBuildingManagerRestrictedProvidersQueryVariables>(GetBuildingManagerRestrictedProvidersDocument, options);
        }
export type GetBuildingManagerRestrictedProvidersQueryHookResult = ReturnType<typeof useGetBuildingManagerRestrictedProvidersQuery>;
export type GetBuildingManagerRestrictedProvidersLazyQueryHookResult = ReturnType<typeof useGetBuildingManagerRestrictedProvidersLazyQuery>;
export type GetBuildingManagerRestrictedProvidersSuspenseQueryHookResult = ReturnType<typeof useGetBuildingManagerRestrictedProvidersSuspenseQuery>;
export type GetBuildingManagerRestrictedProvidersQueryResult = Apollo.QueryResult<GetBuildingManagerRestrictedProvidersQuery, GetBuildingManagerRestrictedProvidersQueryVariables>;
export const RemoveProviderRestrictionDocument = gql`
    mutation RemoveProviderRestriction($providerId: uuid!) {
  delete_buildingProviders(where: {providerId: {_eq: $providerId}}) {
    returning {
      id
      providerId
      locationId
    }
  }
}
    `;
export type RemoveProviderRestrictionMutationFn = Apollo.MutationFunction<RemoveProviderRestrictionMutation, RemoveProviderRestrictionMutationVariables>;

/**
 * __useRemoveProviderRestrictionMutation__
 *
 * To run a mutation, you first call `useRemoveProviderRestrictionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProviderRestrictionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProviderRestrictionMutation, { data, loading, error }] = useRemoveProviderRestrictionMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useRemoveProviderRestrictionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProviderRestrictionMutation, RemoveProviderRestrictionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProviderRestrictionMutation, RemoveProviderRestrictionMutationVariables>(RemoveProviderRestrictionDocument, options);
      }
export type RemoveProviderRestrictionMutationHookResult = ReturnType<typeof useRemoveProviderRestrictionMutation>;
export type RemoveProviderRestrictionMutationResult = Apollo.MutationResult<RemoveProviderRestrictionMutation>;
export type RemoveProviderRestrictionMutationOptions = Apollo.BaseMutationOptions<RemoveProviderRestrictionMutation, RemoveProviderRestrictionMutationVariables>;
export const GetBuildingManagerDashboardDocument = gql`
    query GetBuildingManagerDashboard($buildingManagerId: uuid!, $startOfToday: timestamptz!, $endOfToday: timestamptz!) {
  pendingServiceProviders: buildingProviders_aggregate(
    where: {status: {_eq: pending}}
  ) {
    aggregate {
      count
    }
  }
  todaysAppointments: appointments_aggregate(
    where: {location: {buildingManagerId: {_eq: $buildingManagerId}}, _or: [{startDate: {_gte: $startOfToday}, endDate: {_lte: $endOfToday}}, {startDate: {_gte: $startOfToday, _lte: $endOfToday}}, {endDate: {_gte: $startOfToday, _lte: $endOfToday}}], jobStatus: {_in: [completed, pending, scheduled, partial]}}
  ) {
    aggregate {
      count
    }
  }
  nextAppointments: appointments(
    limit: 5
    offset: 0
    order_by: [{startDate: asc, id: desc}]
    where: {location: {buildingManagerId: {_eq: $buildingManagerId}}, startDate: {_gte: "now()"}, jobStatus: {_in: [scheduled, pending]}}
  ) {
    id
    startDate
    customer {
      id
      name
      user {
        id
        name
        profilePicture {
          id
          name
        }
      }
    }
    createdByUserId
  }
}
    `;

/**
 * __useGetBuildingManagerDashboardQuery__
 *
 * To run a query within a React component, call `useGetBuildingManagerDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuildingManagerDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuildingManagerDashboardQuery({
 *   variables: {
 *      buildingManagerId: // value for 'buildingManagerId'
 *      startOfToday: // value for 'startOfToday'
 *      endOfToday: // value for 'endOfToday'
 *   },
 * });
 */
export function useGetBuildingManagerDashboardQuery(baseOptions: Apollo.QueryHookOptions<GetBuildingManagerDashboardQuery, GetBuildingManagerDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuildingManagerDashboardQuery, GetBuildingManagerDashboardQueryVariables>(GetBuildingManagerDashboardDocument, options);
      }
export function useGetBuildingManagerDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuildingManagerDashboardQuery, GetBuildingManagerDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuildingManagerDashboardQuery, GetBuildingManagerDashboardQueryVariables>(GetBuildingManagerDashboardDocument, options);
        }
export function useGetBuildingManagerDashboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBuildingManagerDashboardQuery, GetBuildingManagerDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBuildingManagerDashboardQuery, GetBuildingManagerDashboardQueryVariables>(GetBuildingManagerDashboardDocument, options);
        }
export type GetBuildingManagerDashboardQueryHookResult = ReturnType<typeof useGetBuildingManagerDashboardQuery>;
export type GetBuildingManagerDashboardLazyQueryHookResult = ReturnType<typeof useGetBuildingManagerDashboardLazyQuery>;
export type GetBuildingManagerDashboardSuspenseQueryHookResult = ReturnType<typeof useGetBuildingManagerDashboardSuspenseQuery>;
export type GetBuildingManagerDashboardQueryResult = Apollo.QueryResult<GetBuildingManagerDashboardQuery, GetBuildingManagerDashboardQueryVariables>;
export const BmLocationDocument = gql`
    query BMLocation($buildingManagerId: uuid!) {
  buildingManager: users_by_pk(id: $buildingManagerId) {
    id
    building: location {
      id
      name
      address
      type
      coordinates
    }
  }
}
    `;

/**
 * __useBmLocationQuery__
 *
 * To run a query within a React component, call `useBmLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBmLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBmLocationQuery({
 *   variables: {
 *      buildingManagerId: // value for 'buildingManagerId'
 *   },
 * });
 */
export function useBmLocationQuery(baseOptions: Apollo.QueryHookOptions<BmLocationQuery, BmLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BmLocationQuery, BmLocationQueryVariables>(BmLocationDocument, options);
      }
export function useBmLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BmLocationQuery, BmLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BmLocationQuery, BmLocationQueryVariables>(BmLocationDocument, options);
        }
export function useBmLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BmLocationQuery, BmLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BmLocationQuery, BmLocationQueryVariables>(BmLocationDocument, options);
        }
export type BmLocationQueryHookResult = ReturnType<typeof useBmLocationQuery>;
export type BmLocationLazyQueryHookResult = ReturnType<typeof useBmLocationLazyQuery>;
export type BmLocationSuspenseQueryHookResult = ReturnType<typeof useBmLocationSuspenseQuery>;
export type BmLocationQueryResult = Apollo.QueryResult<BmLocationQuery, BmLocationQueryVariables>;
export const CreateApptProvidersListDocument = gql`
    query CreateApptProvidersList($searchByName: String!, $limit: Int, $offset: Int) {
  providers(
    where: {status: {_eq: approved}, deletedAt: {_is_null: true}, name: {_ilike: $searchByName}, buildingProviders: {status: {_eq: approved}, deletedAt: {_is_null: true}}, stripePaymentMethodId: {_is_null: false}}
    limit: $limit
    offset: $offset
  ) {
    id
    category
    name
    email
    providerPictureByProfilePic {
      id
      name
      file {
        id
        name
      }
    }
    phoneNumber
    address
    createdAt
  }
  providers_aggregate(
    where: {status: {_eq: approved}, deletedAt: {_is_null: true}, name: {_ilike: $searchByName}, buildingProviders: {status: {_eq: approved}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useCreateApptProvidersListQuery__
 *
 * To run a query within a React component, call `useCreateApptProvidersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateApptProvidersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateApptProvidersListQuery({
 *   variables: {
 *      searchByName: // value for 'searchByName'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useCreateApptProvidersListQuery(baseOptions: Apollo.QueryHookOptions<CreateApptProvidersListQuery, CreateApptProvidersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateApptProvidersListQuery, CreateApptProvidersListQueryVariables>(CreateApptProvidersListDocument, options);
      }
export function useCreateApptProvidersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateApptProvidersListQuery, CreateApptProvidersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateApptProvidersListQuery, CreateApptProvidersListQueryVariables>(CreateApptProvidersListDocument, options);
        }
export function useCreateApptProvidersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CreateApptProvidersListQuery, CreateApptProvidersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateApptProvidersListQuery, CreateApptProvidersListQueryVariables>(CreateApptProvidersListDocument, options);
        }
export type CreateApptProvidersListQueryHookResult = ReturnType<typeof useCreateApptProvidersListQuery>;
export type CreateApptProvidersListLazyQueryHookResult = ReturnType<typeof useCreateApptProvidersListLazyQuery>;
export type CreateApptProvidersListSuspenseQueryHookResult = ReturnType<typeof useCreateApptProvidersListSuspenseQuery>;
export type CreateApptProvidersListQueryResult = Apollo.QueryResult<CreateApptProvidersListQuery, CreateApptProvidersListQueryVariables>;
export const UpdateAppointmentStatusByPkDocument = gql`
    mutation UpdateAppointmentStatusByPk($appointmentId: uuid!, $jobStatus: jobStatus_enum!) {
  update_appointments_by_pk(
    pk_columns: {id: $appointmentId}
    _set: {jobStatus: $jobStatus}
  ) {
    id
    jobStatus
  }
}
    `;
export type UpdateAppointmentStatusByPkMutationFn = Apollo.MutationFunction<UpdateAppointmentStatusByPkMutation, UpdateAppointmentStatusByPkMutationVariables>;

/**
 * __useUpdateAppointmentStatusByPkMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentStatusByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentStatusByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentStatusByPkMutation, { data, loading, error }] = useUpdateAppointmentStatusByPkMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      jobStatus: // value for 'jobStatus'
 *   },
 * });
 */
export function useUpdateAppointmentStatusByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentStatusByPkMutation, UpdateAppointmentStatusByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentStatusByPkMutation, UpdateAppointmentStatusByPkMutationVariables>(UpdateAppointmentStatusByPkDocument, options);
      }
export type UpdateAppointmentStatusByPkMutationHookResult = ReturnType<typeof useUpdateAppointmentStatusByPkMutation>;
export type UpdateAppointmentStatusByPkMutationResult = Apollo.MutationResult<UpdateAppointmentStatusByPkMutation>;
export type UpdateAppointmentStatusByPkMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentStatusByPkMutation, UpdateAppointmentStatusByPkMutationVariables>;
export const CreateAppointmentBmDocument = gql`
    mutation CreateAppointmentBM($id: String, $serviceId: String!, $customerId: String!, $employeeId: String!, $locationId: String!, $date: DateTime!, $address: String!, $optionAnswers: [CreateApptServiceOptionAnswers!]!, $paidBy: ApptPaidBy, $coordinates: [Float!]!, $apartmentNumber: String, $formAnswers: [CreateApptServiceFormAnswers!]!, $existingPaymentIntentId: String) {
  createAppointmentBM(
    data: {id: $id, serviceId: $serviceId, customerId: $customerId, employeeId: $employeeId, locationId: $locationId, address: $address, date: $date, createApptServiceOptionAnswers: $optionAnswers, paidBy: $paidBy, coordinates: $coordinates, apartmentNumber: $apartmentNumber, createApptServiceFormAnswers: $formAnswers, existingPaymentIntentId: $existingPaymentIntentId}
  ) {
    id
  }
}
    `;
export type CreateAppointmentBmMutationFn = Apollo.MutationFunction<CreateAppointmentBmMutation, CreateAppointmentBmMutationVariables>;

/**
 * __useCreateAppointmentBmMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentBmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentBmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentBmMutation, { data, loading, error }] = useCreateAppointmentBmMutation({
 *   variables: {
 *      id: // value for 'id'
 *      serviceId: // value for 'serviceId'
 *      customerId: // value for 'customerId'
 *      employeeId: // value for 'employeeId'
 *      locationId: // value for 'locationId'
 *      date: // value for 'date'
 *      address: // value for 'address'
 *      optionAnswers: // value for 'optionAnswers'
 *      paidBy: // value for 'paidBy'
 *      coordinates: // value for 'coordinates'
 *      apartmentNumber: // value for 'apartmentNumber'
 *      formAnswers: // value for 'formAnswers'
 *      existingPaymentIntentId: // value for 'existingPaymentIntentId'
 *   },
 * });
 */
export function useCreateAppointmentBmMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentBmMutation, CreateAppointmentBmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentBmMutation, CreateAppointmentBmMutationVariables>(CreateAppointmentBmDocument, options);
      }
export type CreateAppointmentBmMutationHookResult = ReturnType<typeof useCreateAppointmentBmMutation>;
export type CreateAppointmentBmMutationResult = Apollo.MutationResult<CreateAppointmentBmMutation>;
export type CreateAppointmentBmMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentBmMutation, CreateAppointmentBmMutationVariables>;
export const CreateAppointmentPaymentIntentDocument = gql`
    mutation CreateAppointmentPaymentIntent($serviceId: String!, $customerId: String!, $locationId: String!, $optionAnswers: [CreateApptServiceOptionAnswers!]!) {
  createAppointmentPaymentIntent(
    data: {serviceId: $serviceId, customerId: $customerId, locationId: $locationId, createApptServiceOptionAnswers: $optionAnswers}
  ) {
    clientSecret
    generatedAppointmentId
    paymentIntentId
    connectedAccountId
  }
}
    `;
export type CreateAppointmentPaymentIntentMutationFn = Apollo.MutationFunction<CreateAppointmentPaymentIntentMutation, CreateAppointmentPaymentIntentMutationVariables>;

/**
 * __useCreateAppointmentPaymentIntentMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentPaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentPaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentPaymentIntentMutation, { data, loading, error }] = useCreateAppointmentPaymentIntentMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      customerId: // value for 'customerId'
 *      locationId: // value for 'locationId'
 *      optionAnswers: // value for 'optionAnswers'
 *   },
 * });
 */
export function useCreateAppointmentPaymentIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentPaymentIntentMutation, CreateAppointmentPaymentIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentPaymentIntentMutation, CreateAppointmentPaymentIntentMutationVariables>(CreateAppointmentPaymentIntentDocument, options);
      }
export type CreateAppointmentPaymentIntentMutationHookResult = ReturnType<typeof useCreateAppointmentPaymentIntentMutation>;
export type CreateAppointmentPaymentIntentMutationResult = Apollo.MutationResult<CreateAppointmentPaymentIntentMutation>;
export type CreateAppointmentPaymentIntentMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentPaymentIntentMutation, CreateAppointmentPaymentIntentMutationVariables>;
export const ServicesByCategoryDocument = gql`
    query ServicesByCategory {
  getCustomerServices {
    category
    providers {
      id
      name
      email
      phoneNumber
      address
      services {
        id
        name
        description
        color
        duration
        nextAvailableDate
      }
    }
  }
}
    `;

/**
 * __useServicesByCategoryQuery__
 *
 * To run a query within a React component, call `useServicesByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicesByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicesByCategoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useServicesByCategoryQuery(baseOptions?: Apollo.QueryHookOptions<ServicesByCategoryQuery, ServicesByCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServicesByCategoryQuery, ServicesByCategoryQueryVariables>(ServicesByCategoryDocument, options);
      }
export function useServicesByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServicesByCategoryQuery, ServicesByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServicesByCategoryQuery, ServicesByCategoryQueryVariables>(ServicesByCategoryDocument, options);
        }
export function useServicesByCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServicesByCategoryQuery, ServicesByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServicesByCategoryQuery, ServicesByCategoryQueryVariables>(ServicesByCategoryDocument, options);
        }
export type ServicesByCategoryQueryHookResult = ReturnType<typeof useServicesByCategoryQuery>;
export type ServicesByCategoryLazyQueryHookResult = ReturnType<typeof useServicesByCategoryLazyQuery>;
export type ServicesByCategorySuspenseQueryHookResult = ReturnType<typeof useServicesByCategorySuspenseQuery>;
export type ServicesByCategoryQueryResult = Apollo.QueryResult<ServicesByCategoryQuery, ServicesByCategoryQueryVariables>;
export const GetCustomerByIdDocument = gql`
    query GetCustomerById($customerId: uuid!) {
  customers_by_pk(id: $customerId) {
    id
    address
    apartmentNumber
    createdAt
    deletedAt
    email
    name
    phoneNumber
    user {
      id
      email
      name
      profilePicture {
        id
        name
      }
      phoneNumber
      createdAt
      address
      apartmentNumber
    }
  }
}
    `;

/**
 * __useGetCustomerByIdQuery__
 *
 * To run a query within a React component, call `useGetCustomerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerByIdQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>(GetCustomerByIdDocument, options);
      }
export function useGetCustomerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>(GetCustomerByIdDocument, options);
        }
export function useGetCustomerByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>(GetCustomerByIdDocument, options);
        }
export type GetCustomerByIdQueryHookResult = ReturnType<typeof useGetCustomerByIdQuery>;
export type GetCustomerByIdLazyQueryHookResult = ReturnType<typeof useGetCustomerByIdLazyQuery>;
export type GetCustomerByIdSuspenseQueryHookResult = ReturnType<typeof useGetCustomerByIdSuspenseQuery>;
export type GetCustomerByIdQueryResult = Apollo.QueryResult<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>;
export const GetCustomerAppointmentsDocument = gql`
    query GetCustomerAppointments($customerId: uuid!, $limit: Int = 5, $offset: Int = 0) {
  appointments(
    limit: $limit
    offset: $offset
    order_by: {startDate: asc, id: desc}
    where: {customerId: {_eq: $customerId}}
  ) {
    id
    createdAt
    endDate
    startDate
    updatedAt
    jobStatus
    paymentStatus
    appointmentPricing {
      basePrice
      fees
      taxes
      taxRate
    }
    serviceOptionAnswers {
      id
      quantity
      serviceOptionSectionOption {
        id
        price
        serviceOptionSection {
          id
          mandatory
          name
          serviceOption {
            id
            name
          }
        }
      }
    }
    service {
      id
      sku
      provider {
        id
        name
      }
    }
    location {
      id
      address
      radius
    }
  }
  appointments_aggregate(where: {customerId: {_eq: $customerId}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetCustomerAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetCustomerAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerAppointmentsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetCustomerAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerAppointmentsQuery, GetCustomerAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerAppointmentsQuery, GetCustomerAppointmentsQueryVariables>(GetCustomerAppointmentsDocument, options);
      }
export function useGetCustomerAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerAppointmentsQuery, GetCustomerAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerAppointmentsQuery, GetCustomerAppointmentsQueryVariables>(GetCustomerAppointmentsDocument, options);
        }
export function useGetCustomerAppointmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerAppointmentsQuery, GetCustomerAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerAppointmentsQuery, GetCustomerAppointmentsQueryVariables>(GetCustomerAppointmentsDocument, options);
        }
export type GetCustomerAppointmentsQueryHookResult = ReturnType<typeof useGetCustomerAppointmentsQuery>;
export type GetCustomerAppointmentsLazyQueryHookResult = ReturnType<typeof useGetCustomerAppointmentsLazyQuery>;
export type GetCustomerAppointmentsSuspenseQueryHookResult = ReturnType<typeof useGetCustomerAppointmentsSuspenseQuery>;
export type GetCustomerAppointmentsQueryResult = Apollo.QueryResult<GetCustomerAppointmentsQuery, GetCustomerAppointmentsQueryVariables>;
export const GetCustomerAppointmentsAggregateDocument = gql`
    query GetCustomerAppointmentsAggregate($customerId: uuid!) {
  appointments_aggregate(where: {customerId: {_eq: $customerId}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetCustomerAppointmentsAggregateQuery__
 *
 * To run a query within a React component, call `useGetCustomerAppointmentsAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerAppointmentsAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerAppointmentsAggregateQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerAppointmentsAggregateQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerAppointmentsAggregateQuery, GetCustomerAppointmentsAggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerAppointmentsAggregateQuery, GetCustomerAppointmentsAggregateQueryVariables>(GetCustomerAppointmentsAggregateDocument, options);
      }
export function useGetCustomerAppointmentsAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerAppointmentsAggregateQuery, GetCustomerAppointmentsAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerAppointmentsAggregateQuery, GetCustomerAppointmentsAggregateQueryVariables>(GetCustomerAppointmentsAggregateDocument, options);
        }
export function useGetCustomerAppointmentsAggregateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerAppointmentsAggregateQuery, GetCustomerAppointmentsAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerAppointmentsAggregateQuery, GetCustomerAppointmentsAggregateQueryVariables>(GetCustomerAppointmentsAggregateDocument, options);
        }
export type GetCustomerAppointmentsAggregateQueryHookResult = ReturnType<typeof useGetCustomerAppointmentsAggregateQuery>;
export type GetCustomerAppointmentsAggregateLazyQueryHookResult = ReturnType<typeof useGetCustomerAppointmentsAggregateLazyQuery>;
export type GetCustomerAppointmentsAggregateSuspenseQueryHookResult = ReturnType<typeof useGetCustomerAppointmentsAggregateSuspenseQuery>;
export type GetCustomerAppointmentsAggregateQueryResult = Apollo.QueryResult<GetCustomerAppointmentsAggregateQuery, GetCustomerAppointmentsAggregateQueryVariables>;
export const GetAppointmentsAggregateDocument = gql`
    query GetAppointmentsAggregate($jobStatus: [jobStatus_enum!]!) {
  appointments_aggregate(where: {jobStatus: {_in: $jobStatus}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetAppointmentsAggregateQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsAggregateQuery({
 *   variables: {
 *      jobStatus: // value for 'jobStatus'
 *   },
 * });
 */
export function useGetAppointmentsAggregateQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentsAggregateQuery, GetAppointmentsAggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsAggregateQuery, GetAppointmentsAggregateQueryVariables>(GetAppointmentsAggregateDocument, options);
      }
export function useGetAppointmentsAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsAggregateQuery, GetAppointmentsAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsAggregateQuery, GetAppointmentsAggregateQueryVariables>(GetAppointmentsAggregateDocument, options);
        }
export function useGetAppointmentsAggregateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppointmentsAggregateQuery, GetAppointmentsAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentsAggregateQuery, GetAppointmentsAggregateQueryVariables>(GetAppointmentsAggregateDocument, options);
        }
export type GetAppointmentsAggregateQueryHookResult = ReturnType<typeof useGetAppointmentsAggregateQuery>;
export type GetAppointmentsAggregateLazyQueryHookResult = ReturnType<typeof useGetAppointmentsAggregateLazyQuery>;
export type GetAppointmentsAggregateSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentsAggregateSuspenseQuery>;
export type GetAppointmentsAggregateQueryResult = Apollo.QueryResult<GetAppointmentsAggregateQuery, GetAppointmentsAggregateQueryVariables>;
export const GetAppointmentsBetweenDatesAggregateDocument = gql`
    query GetAppointmentsBetweenDatesAggregate($jobStatus: [jobStatus_enum!]!, $startDate: timestamptz, $endDate: timestamptz) {
  appointments_aggregate(
    where: {jobStatus: {_in: $jobStatus}, startDate: {_gte: $startDate}, endDate: {_lte: $endDate}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetAppointmentsBetweenDatesAggregateQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsBetweenDatesAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsBetweenDatesAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsBetweenDatesAggregateQuery({
 *   variables: {
 *      jobStatus: // value for 'jobStatus'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetAppointmentsBetweenDatesAggregateQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentsBetweenDatesAggregateQuery, GetAppointmentsBetweenDatesAggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsBetweenDatesAggregateQuery, GetAppointmentsBetweenDatesAggregateQueryVariables>(GetAppointmentsBetweenDatesAggregateDocument, options);
      }
export function useGetAppointmentsBetweenDatesAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsBetweenDatesAggregateQuery, GetAppointmentsBetweenDatesAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsBetweenDatesAggregateQuery, GetAppointmentsBetweenDatesAggregateQueryVariables>(GetAppointmentsBetweenDatesAggregateDocument, options);
        }
export function useGetAppointmentsBetweenDatesAggregateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppointmentsBetweenDatesAggregateQuery, GetAppointmentsBetweenDatesAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentsBetweenDatesAggregateQuery, GetAppointmentsBetweenDatesAggregateQueryVariables>(GetAppointmentsBetweenDatesAggregateDocument, options);
        }
export type GetAppointmentsBetweenDatesAggregateQueryHookResult = ReturnType<typeof useGetAppointmentsBetweenDatesAggregateQuery>;
export type GetAppointmentsBetweenDatesAggregateLazyQueryHookResult = ReturnType<typeof useGetAppointmentsBetweenDatesAggregateLazyQuery>;
export type GetAppointmentsBetweenDatesAggregateSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentsBetweenDatesAggregateSuspenseQuery>;
export type GetAppointmentsBetweenDatesAggregateQueryResult = Apollo.QueryResult<GetAppointmentsBetweenDatesAggregateQuery, GetAppointmentsBetweenDatesAggregateQueryVariables>;
export const CreateBuildingCustomerFromCreateAppointmentScreenDocument = gql`
    mutation CreateBuildingCustomerFromCreateAppointmentScreen($input: CustomerDataInputDto!) {
  createCustomer(input: $input) {
    id
    name
    address
    coordinates {
      type
      coordinates
    }
    apartmentNumber
    phoneNumber
    providerId
    locationId
    userId
    user {
      id
      name
      email
      phoneNumber
      apartmentNumber
      address
      coordinates {
        type
        coordinates
      }
    }
    updatedAt
    stripeCustomerId
    isBlocked
    email
    deletedAt
    createdAt
  }
}
    `;
export type CreateBuildingCustomerFromCreateAppointmentScreenMutationFn = Apollo.MutationFunction<CreateBuildingCustomerFromCreateAppointmentScreenMutation, CreateBuildingCustomerFromCreateAppointmentScreenMutationVariables>;

/**
 * __useCreateBuildingCustomerFromCreateAppointmentScreenMutation__
 *
 * To run a mutation, you first call `useCreateBuildingCustomerFromCreateAppointmentScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuildingCustomerFromCreateAppointmentScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuildingCustomerFromCreateAppointmentScreenMutation, { data, loading, error }] = useCreateBuildingCustomerFromCreateAppointmentScreenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBuildingCustomerFromCreateAppointmentScreenMutation(baseOptions?: Apollo.MutationHookOptions<CreateBuildingCustomerFromCreateAppointmentScreenMutation, CreateBuildingCustomerFromCreateAppointmentScreenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBuildingCustomerFromCreateAppointmentScreenMutation, CreateBuildingCustomerFromCreateAppointmentScreenMutationVariables>(CreateBuildingCustomerFromCreateAppointmentScreenDocument, options);
      }
export type CreateBuildingCustomerFromCreateAppointmentScreenMutationHookResult = ReturnType<typeof useCreateBuildingCustomerFromCreateAppointmentScreenMutation>;
export type CreateBuildingCustomerFromCreateAppointmentScreenMutationResult = Apollo.MutationResult<CreateBuildingCustomerFromCreateAppointmentScreenMutation>;
export type CreateBuildingCustomerFromCreateAppointmentScreenMutationOptions = Apollo.BaseMutationOptions<CreateBuildingCustomerFromCreateAppointmentScreenMutation, CreateBuildingCustomerFromCreateAppointmentScreenMutationVariables>;
export const CreateProviderCustomerFromCreateAppointmentScreenDocument = gql`
    mutation CreateProviderCustomerFromCreateAppointmentScreen($input: CustomerDataInputDto!) {
  createCustomer(input: $input) {
    id
    name
    address
    coordinates {
      type
      coordinates
    }
    apartmentNumber
    phoneNumber
    providerId
    locationId
    userId
    user {
      id
      name
      email
      phoneNumber
      apartmentNumber
      address
      coordinates {
        type
        coordinates
      }
    }
    updatedAt
    stripeCustomerId
    isBlocked
    email
    deletedAt
    createdAt
  }
}
    `;
export type CreateProviderCustomerFromCreateAppointmentScreenMutationFn = Apollo.MutationFunction<CreateProviderCustomerFromCreateAppointmentScreenMutation, CreateProviderCustomerFromCreateAppointmentScreenMutationVariables>;

/**
 * __useCreateProviderCustomerFromCreateAppointmentScreenMutation__
 *
 * To run a mutation, you first call `useCreateProviderCustomerFromCreateAppointmentScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProviderCustomerFromCreateAppointmentScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProviderCustomerFromCreateAppointmentScreenMutation, { data, loading, error }] = useCreateProviderCustomerFromCreateAppointmentScreenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProviderCustomerFromCreateAppointmentScreenMutation(baseOptions?: Apollo.MutationHookOptions<CreateProviderCustomerFromCreateAppointmentScreenMutation, CreateProviderCustomerFromCreateAppointmentScreenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProviderCustomerFromCreateAppointmentScreenMutation, CreateProviderCustomerFromCreateAppointmentScreenMutationVariables>(CreateProviderCustomerFromCreateAppointmentScreenDocument, options);
      }
export type CreateProviderCustomerFromCreateAppointmentScreenMutationHookResult = ReturnType<typeof useCreateProviderCustomerFromCreateAppointmentScreenMutation>;
export type CreateProviderCustomerFromCreateAppointmentScreenMutationResult = Apollo.MutationResult<CreateProviderCustomerFromCreateAppointmentScreenMutation>;
export type CreateProviderCustomerFromCreateAppointmentScreenMutationOptions = Apollo.BaseMutationOptions<CreateProviderCustomerFromCreateAppointmentScreenMutation, CreateProviderCustomerFromCreateAppointmentScreenMutationVariables>;
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($input: CustomerDataInputDto!) {
  createCustomer(input: $input) {
    address
    createdAt
    deletedAt
    email
    id
    name
    phoneNumber
    apartmentNumber
    providerId
    locationId
    coordinates {
      type
      coordinates
    }
  }
}
    `;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const UpdateCustomerByIdDocument = gql`
    mutation UpdateCustomerById($id: uuid!, $input: customers_set_input!) {
  update_customers_by_pk(pk_columns: {id: $id}, _set: $input) {
    address
    createdAt
    deletedAt
    email
    id
    name
    phoneNumber
  }
}
    `;
export type UpdateCustomerByIdMutationFn = Apollo.MutationFunction<UpdateCustomerByIdMutation, UpdateCustomerByIdMutationVariables>;

/**
 * __useUpdateCustomerByIdMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerByIdMutation, { data, loading, error }] = useUpdateCustomerByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerByIdMutation, UpdateCustomerByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerByIdMutation, UpdateCustomerByIdMutationVariables>(UpdateCustomerByIdDocument, options);
      }
export type UpdateCustomerByIdMutationHookResult = ReturnType<typeof useUpdateCustomerByIdMutation>;
export type UpdateCustomerByIdMutationResult = Apollo.MutationResult<UpdateCustomerByIdMutation>;
export type UpdateCustomerByIdMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerByIdMutation, UpdateCustomerByIdMutationVariables>;
export const FindEmployeesByServiceIdAndLocationIdDocument = gql`
    query findEmployeesByServiceIdAndLocationId($serviceId: String!, $locationId: String!) {
  getEmployeesByServiceIdAndLocationId(
    serviceId: $serviceId
    locationId: $locationId
  ) {
    id
    name
    profilePicture {
      name
    }
  }
}
    `;

/**
 * __useFindEmployeesByServiceIdAndLocationIdQuery__
 *
 * To run a query within a React component, call `useFindEmployeesByServiceIdAndLocationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindEmployeesByServiceIdAndLocationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindEmployeesByServiceIdAndLocationIdQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useFindEmployeesByServiceIdAndLocationIdQuery(baseOptions: Apollo.QueryHookOptions<FindEmployeesByServiceIdAndLocationIdQuery, FindEmployeesByServiceIdAndLocationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindEmployeesByServiceIdAndLocationIdQuery, FindEmployeesByServiceIdAndLocationIdQueryVariables>(FindEmployeesByServiceIdAndLocationIdDocument, options);
      }
export function useFindEmployeesByServiceIdAndLocationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindEmployeesByServiceIdAndLocationIdQuery, FindEmployeesByServiceIdAndLocationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindEmployeesByServiceIdAndLocationIdQuery, FindEmployeesByServiceIdAndLocationIdQueryVariables>(FindEmployeesByServiceIdAndLocationIdDocument, options);
        }
export function useFindEmployeesByServiceIdAndLocationIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindEmployeesByServiceIdAndLocationIdQuery, FindEmployeesByServiceIdAndLocationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindEmployeesByServiceIdAndLocationIdQuery, FindEmployeesByServiceIdAndLocationIdQueryVariables>(FindEmployeesByServiceIdAndLocationIdDocument, options);
        }
export type FindEmployeesByServiceIdAndLocationIdQueryHookResult = ReturnType<typeof useFindEmployeesByServiceIdAndLocationIdQuery>;
export type FindEmployeesByServiceIdAndLocationIdLazyQueryHookResult = ReturnType<typeof useFindEmployeesByServiceIdAndLocationIdLazyQuery>;
export type FindEmployeesByServiceIdAndLocationIdSuspenseQueryHookResult = ReturnType<typeof useFindEmployeesByServiceIdAndLocationIdSuspenseQuery>;
export type FindEmployeesByServiceIdAndLocationIdQueryResult = Apollo.QueryResult<FindEmployeesByServiceIdAndLocationIdQuery, FindEmployeesByServiceIdAndLocationIdQueryVariables>;
export const PublicUploadFileUrlDocument = gql`
    query PublicUploadFileUrl($file: UploadFileDto!, $token: String!) {
  getPublicUploadFileUrl(file: $file, token: $token) {
    id
    name
    uploadName
    entityType
    signedUrl
  }
}
    `;

/**
 * __usePublicUploadFileUrlQuery__
 *
 * To run a query within a React component, call `usePublicUploadFileUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicUploadFileUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicUploadFileUrlQuery({
 *   variables: {
 *      file: // value for 'file'
 *      token: // value for 'token'
 *   },
 * });
 */
export function usePublicUploadFileUrlQuery(baseOptions: Apollo.QueryHookOptions<PublicUploadFileUrlQuery, PublicUploadFileUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicUploadFileUrlQuery, PublicUploadFileUrlQueryVariables>(PublicUploadFileUrlDocument, options);
      }
export function usePublicUploadFileUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicUploadFileUrlQuery, PublicUploadFileUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicUploadFileUrlQuery, PublicUploadFileUrlQueryVariables>(PublicUploadFileUrlDocument, options);
        }
export function usePublicUploadFileUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublicUploadFileUrlQuery, PublicUploadFileUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicUploadFileUrlQuery, PublicUploadFileUrlQueryVariables>(PublicUploadFileUrlDocument, options);
        }
export type PublicUploadFileUrlQueryHookResult = ReturnType<typeof usePublicUploadFileUrlQuery>;
export type PublicUploadFileUrlLazyQueryHookResult = ReturnType<typeof usePublicUploadFileUrlLazyQuery>;
export type PublicUploadFileUrlSuspenseQueryHookResult = ReturnType<typeof usePublicUploadFileUrlSuspenseQuery>;
export type PublicUploadFileUrlQueryResult = Apollo.QueryResult<PublicUploadFileUrlQuery, PublicUploadFileUrlQueryVariables>;
export const UploadFileUrlDocument = gql`
    query UploadFileUrl($file: UploadFileDto!) {
  getUploadFileUrl(file: $file) {
    id
    name
    uploadName
    entityType
    signedUrl
  }
}
    `;

/**
 * __useUploadFileUrlQuery__
 *
 * To run a query within a React component, call `useUploadFileUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useUploadFileUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUploadFileUrlQuery({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadFileUrlQuery(baseOptions: Apollo.QueryHookOptions<UploadFileUrlQuery, UploadFileUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UploadFileUrlQuery, UploadFileUrlQueryVariables>(UploadFileUrlDocument, options);
      }
export function useUploadFileUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UploadFileUrlQuery, UploadFileUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UploadFileUrlQuery, UploadFileUrlQueryVariables>(UploadFileUrlDocument, options);
        }
export function useUploadFileUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UploadFileUrlQuery, UploadFileUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UploadFileUrlQuery, UploadFileUrlQueryVariables>(UploadFileUrlDocument, options);
        }
export type UploadFileUrlQueryHookResult = ReturnType<typeof useUploadFileUrlQuery>;
export type UploadFileUrlLazyQueryHookResult = ReturnType<typeof useUploadFileUrlLazyQuery>;
export type UploadFileUrlSuspenseQueryHookResult = ReturnType<typeof useUploadFileUrlSuspenseQuery>;
export type UploadFileUrlQueryResult = Apollo.QueryResult<UploadFileUrlQuery, UploadFileUrlQueryVariables>;
export const PrivateFileDocument = gql`
    query PrivateFile($fileName: String!) {
  getPrivateFile(fileName: $fileName)
}
    `;

/**
 * __usePrivateFileQuery__
 *
 * To run a query within a React component, call `usePrivateFileQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivateFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivateFileQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function usePrivateFileQuery(baseOptions: Apollo.QueryHookOptions<PrivateFileQuery, PrivateFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrivateFileQuery, PrivateFileQueryVariables>(PrivateFileDocument, options);
      }
export function usePrivateFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrivateFileQuery, PrivateFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrivateFileQuery, PrivateFileQueryVariables>(PrivateFileDocument, options);
        }
export function usePrivateFileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PrivateFileQuery, PrivateFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PrivateFileQuery, PrivateFileQueryVariables>(PrivateFileDocument, options);
        }
export type PrivateFileQueryHookResult = ReturnType<typeof usePrivateFileQuery>;
export type PrivateFileLazyQueryHookResult = ReturnType<typeof usePrivateFileLazyQuery>;
export type PrivateFileSuspenseQueryHookResult = ReturnType<typeof usePrivateFileSuspenseQuery>;
export type PrivateFileQueryResult = Apollo.QueryResult<PrivateFileQuery, PrivateFileQueryVariables>;
export const CheckoutPrivateFileDocument = gql`
    query CheckoutPrivateFile($fileName: String!, $token: String!) {
  getCheckoutPrivateFile(fileName: $fileName, token: $token)
}
    `;

/**
 * __useCheckoutPrivateFileQuery__
 *
 * To run a query within a React component, call `useCheckoutPrivateFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutPrivateFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutPrivateFileQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCheckoutPrivateFileQuery(baseOptions: Apollo.QueryHookOptions<CheckoutPrivateFileQuery, CheckoutPrivateFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutPrivateFileQuery, CheckoutPrivateFileQueryVariables>(CheckoutPrivateFileDocument, options);
      }
export function useCheckoutPrivateFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutPrivateFileQuery, CheckoutPrivateFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutPrivateFileQuery, CheckoutPrivateFileQueryVariables>(CheckoutPrivateFileDocument, options);
        }
export function useCheckoutPrivateFileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckoutPrivateFileQuery, CheckoutPrivateFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckoutPrivateFileQuery, CheckoutPrivateFileQueryVariables>(CheckoutPrivateFileDocument, options);
        }
export type CheckoutPrivateFileQueryHookResult = ReturnType<typeof useCheckoutPrivateFileQuery>;
export type CheckoutPrivateFileLazyQueryHookResult = ReturnType<typeof useCheckoutPrivateFileLazyQuery>;
export type CheckoutPrivateFileSuspenseQueryHookResult = ReturnType<typeof useCheckoutPrivateFileSuspenseQuery>;
export type CheckoutPrivateFileQueryResult = Apollo.QueryResult<CheckoutPrivateFileQuery, CheckoutPrivateFileQueryVariables>;
export const DeleteFileDocument = gql`
    mutation DeleteFile($fileId: String!) {
  deleteFile(fileId: $fileId) {
    deletedFile
  }
}
    `;
export type DeleteFileMutationFn = Apollo.MutationFunction<DeleteFileMutation, DeleteFileMutationVariables>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, options);
      }
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = Apollo.MutationResult<DeleteFileMutation>;
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<DeleteFileMutation, DeleteFileMutationVariables>;
export const FileByIdDocument = gql`
    query FileById($id: uuid!) {
  files_by_pk(id: $id) {
    id
    name
    uploadName
  }
}
    `;

/**
 * __useFileByIdQuery__
 *
 * To run a query within a React component, call `useFileByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFileByIdQuery(baseOptions: Apollo.QueryHookOptions<FileByIdQuery, FileByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FileByIdQuery, FileByIdQueryVariables>(FileByIdDocument, options);
      }
export function useFileByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FileByIdQuery, FileByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FileByIdQuery, FileByIdQueryVariables>(FileByIdDocument, options);
        }
export function useFileByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FileByIdQuery, FileByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FileByIdQuery, FileByIdQueryVariables>(FileByIdDocument, options);
        }
export type FileByIdQueryHookResult = ReturnType<typeof useFileByIdQuery>;
export type FileByIdLazyQueryHookResult = ReturnType<typeof useFileByIdLazyQuery>;
export type FileByIdSuspenseQueryHookResult = ReturnType<typeof useFileByIdSuspenseQuery>;
export type FileByIdQueryResult = Apollo.QueryResult<FileByIdQuery, FileByIdQueryVariables>;
export const CheckProviderGoogleCalendarLinkDocument = gql`
    query CheckProviderGoogleCalendarLink {
  linked: isGoogleCalendarLinked
}
    `;

/**
 * __useCheckProviderGoogleCalendarLinkQuery__
 *
 * To run a query within a React component, call `useCheckProviderGoogleCalendarLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckProviderGoogleCalendarLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckProviderGoogleCalendarLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckProviderGoogleCalendarLinkQuery(baseOptions?: Apollo.QueryHookOptions<CheckProviderGoogleCalendarLinkQuery, CheckProviderGoogleCalendarLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckProviderGoogleCalendarLinkQuery, CheckProviderGoogleCalendarLinkQueryVariables>(CheckProviderGoogleCalendarLinkDocument, options);
      }
export function useCheckProviderGoogleCalendarLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckProviderGoogleCalendarLinkQuery, CheckProviderGoogleCalendarLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckProviderGoogleCalendarLinkQuery, CheckProviderGoogleCalendarLinkQueryVariables>(CheckProviderGoogleCalendarLinkDocument, options);
        }
export function useCheckProviderGoogleCalendarLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckProviderGoogleCalendarLinkQuery, CheckProviderGoogleCalendarLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckProviderGoogleCalendarLinkQuery, CheckProviderGoogleCalendarLinkQueryVariables>(CheckProviderGoogleCalendarLinkDocument, options);
        }
export type CheckProviderGoogleCalendarLinkQueryHookResult = ReturnType<typeof useCheckProviderGoogleCalendarLinkQuery>;
export type CheckProviderGoogleCalendarLinkLazyQueryHookResult = ReturnType<typeof useCheckProviderGoogleCalendarLinkLazyQuery>;
export type CheckProviderGoogleCalendarLinkSuspenseQueryHookResult = ReturnType<typeof useCheckProviderGoogleCalendarLinkSuspenseQuery>;
export type CheckProviderGoogleCalendarLinkQueryResult = Apollo.QueryResult<CheckProviderGoogleCalendarLinkQuery, CheckProviderGoogleCalendarLinkQueryVariables>;
export const GetGoogleAuthUrlDocument = gql`
    query GetGoogleAuthUrl {
  url: getGoogleOAuthUrl
}
    `;

/**
 * __useGetGoogleAuthUrlQuery__
 *
 * To run a query within a React component, call `useGetGoogleAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoogleAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoogleAuthUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGoogleAuthUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetGoogleAuthUrlQuery, GetGoogleAuthUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGoogleAuthUrlQuery, GetGoogleAuthUrlQueryVariables>(GetGoogleAuthUrlDocument, options);
      }
export function useGetGoogleAuthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGoogleAuthUrlQuery, GetGoogleAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGoogleAuthUrlQuery, GetGoogleAuthUrlQueryVariables>(GetGoogleAuthUrlDocument, options);
        }
export function useGetGoogleAuthUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGoogleAuthUrlQuery, GetGoogleAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGoogleAuthUrlQuery, GetGoogleAuthUrlQueryVariables>(GetGoogleAuthUrlDocument, options);
        }
export type GetGoogleAuthUrlQueryHookResult = ReturnType<typeof useGetGoogleAuthUrlQuery>;
export type GetGoogleAuthUrlLazyQueryHookResult = ReturnType<typeof useGetGoogleAuthUrlLazyQuery>;
export type GetGoogleAuthUrlSuspenseQueryHookResult = ReturnType<typeof useGetGoogleAuthUrlSuspenseQuery>;
export type GetGoogleAuthUrlQueryResult = Apollo.QueryResult<GetGoogleAuthUrlQuery, GetGoogleAuthUrlQueryVariables>;
export const SetGoogleAuthTokensDocument = gql`
    mutation SetGoogleAuthTokens($code: String!) {
  success: handleGoogleOAuthCallback(code: $code)
}
    `;
export type SetGoogleAuthTokensMutationFn = Apollo.MutationFunction<SetGoogleAuthTokensMutation, SetGoogleAuthTokensMutationVariables>;

/**
 * __useSetGoogleAuthTokensMutation__
 *
 * To run a mutation, you first call `useSetGoogleAuthTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGoogleAuthTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGoogleAuthTokensMutation, { data, loading, error }] = useSetGoogleAuthTokensMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSetGoogleAuthTokensMutation(baseOptions?: Apollo.MutationHookOptions<SetGoogleAuthTokensMutation, SetGoogleAuthTokensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetGoogleAuthTokensMutation, SetGoogleAuthTokensMutationVariables>(SetGoogleAuthTokensDocument, options);
      }
export type SetGoogleAuthTokensMutationHookResult = ReturnType<typeof useSetGoogleAuthTokensMutation>;
export type SetGoogleAuthTokensMutationResult = Apollo.MutationResult<SetGoogleAuthTokensMutation>;
export type SetGoogleAuthTokensMutationOptions = Apollo.BaseMutationOptions<SetGoogleAuthTokensMutation, SetGoogleAuthTokensMutationVariables>;
export const UnlinkGoogleCalendarDocument = gql`
    mutation UnlinkGoogleCalendar {
  success: unlinkGoogleCalendar
}
    `;
export type UnlinkGoogleCalendarMutationFn = Apollo.MutationFunction<UnlinkGoogleCalendarMutation, UnlinkGoogleCalendarMutationVariables>;

/**
 * __useUnlinkGoogleCalendarMutation__
 *
 * To run a mutation, you first call `useUnlinkGoogleCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkGoogleCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkGoogleCalendarMutation, { data, loading, error }] = useUnlinkGoogleCalendarMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnlinkGoogleCalendarMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkGoogleCalendarMutation, UnlinkGoogleCalendarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkGoogleCalendarMutation, UnlinkGoogleCalendarMutationVariables>(UnlinkGoogleCalendarDocument, options);
      }
export type UnlinkGoogleCalendarMutationHookResult = ReturnType<typeof useUnlinkGoogleCalendarMutation>;
export type UnlinkGoogleCalendarMutationResult = Apollo.MutationResult<UnlinkGoogleCalendarMutation>;
export type UnlinkGoogleCalendarMutationOptions = Apollo.BaseMutationOptions<UnlinkGoogleCalendarMutation, UnlinkGoogleCalendarMutationVariables>;
export const GetGoogleCalendarDocument = gql`
    query GetGoogleCalendar($id: String!) {
  calendar: getCalendar(calendarId: $id) {
    id
    primary
    summary
    description
  }
}
    `;

/**
 * __useGetGoogleCalendarQuery__
 *
 * To run a query within a React component, call `useGetGoogleCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoogleCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoogleCalendarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGoogleCalendarQuery(baseOptions: Apollo.QueryHookOptions<GetGoogleCalendarQuery, GetGoogleCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGoogleCalendarQuery, GetGoogleCalendarQueryVariables>(GetGoogleCalendarDocument, options);
      }
export function useGetGoogleCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGoogleCalendarQuery, GetGoogleCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGoogleCalendarQuery, GetGoogleCalendarQueryVariables>(GetGoogleCalendarDocument, options);
        }
export function useGetGoogleCalendarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGoogleCalendarQuery, GetGoogleCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGoogleCalendarQuery, GetGoogleCalendarQueryVariables>(GetGoogleCalendarDocument, options);
        }
export type GetGoogleCalendarQueryHookResult = ReturnType<typeof useGetGoogleCalendarQuery>;
export type GetGoogleCalendarLazyQueryHookResult = ReturnType<typeof useGetGoogleCalendarLazyQuery>;
export type GetGoogleCalendarSuspenseQueryHookResult = ReturnType<typeof useGetGoogleCalendarSuspenseQuery>;
export type GetGoogleCalendarQueryResult = Apollo.QueryResult<GetGoogleCalendarQuery, GetGoogleCalendarQueryVariables>;
export const ListGoogleCalendarsDocument = gql`
    query ListGoogleCalendars {
  calendars: listCalendars {
    id
    primary
    summary
    description
  }
}
    `;

/**
 * __useListGoogleCalendarsQuery__
 *
 * To run a query within a React component, call `useListGoogleCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGoogleCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGoogleCalendarsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListGoogleCalendarsQuery(baseOptions?: Apollo.QueryHookOptions<ListGoogleCalendarsQuery, ListGoogleCalendarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGoogleCalendarsQuery, ListGoogleCalendarsQueryVariables>(ListGoogleCalendarsDocument, options);
      }
export function useListGoogleCalendarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGoogleCalendarsQuery, ListGoogleCalendarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGoogleCalendarsQuery, ListGoogleCalendarsQueryVariables>(ListGoogleCalendarsDocument, options);
        }
export function useListGoogleCalendarsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListGoogleCalendarsQuery, ListGoogleCalendarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListGoogleCalendarsQuery, ListGoogleCalendarsQueryVariables>(ListGoogleCalendarsDocument, options);
        }
export type ListGoogleCalendarsQueryHookResult = ReturnType<typeof useListGoogleCalendarsQuery>;
export type ListGoogleCalendarsLazyQueryHookResult = ReturnType<typeof useListGoogleCalendarsLazyQuery>;
export type ListGoogleCalendarsSuspenseQueryHookResult = ReturnType<typeof useListGoogleCalendarsSuspenseQuery>;
export type ListGoogleCalendarsQueryResult = Apollo.QueryResult<ListGoogleCalendarsQuery, ListGoogleCalendarsQueryVariables>;
export const LinkCalendarDocument = gql`
    mutation LinkCalendar($employeeId: String!, $calendarId: String!) {
  success: setEmployeeCalendar(employeeId: $employeeId, calendarId: $calendarId)
}
    `;
export type LinkCalendarMutationFn = Apollo.MutationFunction<LinkCalendarMutation, LinkCalendarMutationVariables>;

/**
 * __useLinkCalendarMutation__
 *
 * To run a mutation, you first call `useLinkCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkCalendarMutation, { data, loading, error }] = useLinkCalendarMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      calendarId: // value for 'calendarId'
 *   },
 * });
 */
export function useLinkCalendarMutation(baseOptions?: Apollo.MutationHookOptions<LinkCalendarMutation, LinkCalendarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkCalendarMutation, LinkCalendarMutationVariables>(LinkCalendarDocument, options);
      }
export type LinkCalendarMutationHookResult = ReturnType<typeof useLinkCalendarMutation>;
export type LinkCalendarMutationResult = Apollo.MutationResult<LinkCalendarMutation>;
export type LinkCalendarMutationOptions = Apollo.BaseMutationOptions<LinkCalendarMutation, LinkCalendarMutationVariables>;
export const UnlinkCalendarDocument = gql`
    mutation UnlinkCalendar($employeeId: String!) {
  success: clearEmployeeCalendar(employeeId: $employeeId)
}
    `;
export type UnlinkCalendarMutationFn = Apollo.MutationFunction<UnlinkCalendarMutation, UnlinkCalendarMutationVariables>;

/**
 * __useUnlinkCalendarMutation__
 *
 * To run a mutation, you first call `useUnlinkCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkCalendarMutation, { data, loading, error }] = useUnlinkCalendarMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useUnlinkCalendarMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkCalendarMutation, UnlinkCalendarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkCalendarMutation, UnlinkCalendarMutationVariables>(UnlinkCalendarDocument, options);
      }
export type UnlinkCalendarMutationHookResult = ReturnType<typeof useUnlinkCalendarMutation>;
export type UnlinkCalendarMutationResult = Apollo.MutationResult<UnlinkCalendarMutation>;
export type UnlinkCalendarMutationOptions = Apollo.BaseMutationOptions<UnlinkCalendarMutation, UnlinkCalendarMutationVariables>;
export const LocationsDocument = gql`
    query Locations($value: String!, $limit: Int, $offset: Int) {
  locations(
    limit: $limit
    offset: $offset
    where: {name: {_like: $value}, deletedAt: {_is_null: true}}
  ) {
    address
    coordinates
    id
    name
    phoneNumber
    email
    radius
    status
    type
    additionalCities
    excludedCities
    schedules {
      user {
        serviceEmployeesByUserid_aggregate(distinct_on: serviceId) {
          aggregate {
            count
          }
        }
      }
    }
    schedules_aggregate(
      distinct_on: employeeId
      where: {user: {userRole: {role: {_in: [employee, provider]}, deletedAt: {_is_null: true}}}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *      value: // value for 'value'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useLocationsQuery(baseOptions: Apollo.QueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
      }
export function useLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
        }
export function useLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
        }
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<typeof useLocationsLazyQuery>;
export type LocationsSuspenseQueryHookResult = ReturnType<typeof useLocationsSuspenseQuery>;
export type LocationsQueryResult = Apollo.QueryResult<LocationsQuery, LocationsQueryVariables>;
export const LocationByIdDocument = gql`
    query LocationById($id: uuid!) {
  locations_by_pk(id: $id) {
    address
    coordinates
    id
    providerId
    name
    phoneNumber
    email
    radius
    status
    type
    additionalCities
    excludedCities
    schedules {
      user {
        serviceEmployeesByUserid_aggregate(
          distinct_on: serviceId
          where: {service: {deletedAt: {_is_null: true}}}
        ) {
          nodes {
            service {
              name
              status
              deletedAt
            }
          }
          aggregate {
            count
          }
        }
      }
    }
    schedules_aggregate(
      distinct_on: employeeId
      where: {user: {userRole: {role: {_in: [employee, provider]}, deletedAt: {_is_null: true}}}}
    ) {
      nodes {
        user {
          name
          email
          phoneNumber
        }
      }
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useLocationByIdQuery__
 *
 * To run a query within a React component, call `useLocationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationByIdQuery(baseOptions: Apollo.QueryHookOptions<LocationByIdQuery, LocationByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationByIdQuery, LocationByIdQueryVariables>(LocationByIdDocument, options);
      }
export function useLocationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationByIdQuery, LocationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationByIdQuery, LocationByIdQueryVariables>(LocationByIdDocument, options);
        }
export function useLocationByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocationByIdQuery, LocationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationByIdQuery, LocationByIdQueryVariables>(LocationByIdDocument, options);
        }
export type LocationByIdQueryHookResult = ReturnType<typeof useLocationByIdQuery>;
export type LocationByIdLazyQueryHookResult = ReturnType<typeof useLocationByIdLazyQuery>;
export type LocationByIdSuspenseQueryHookResult = ReturnType<typeof useLocationByIdSuspenseQuery>;
export type LocationByIdQueryResult = Apollo.QueryResult<LocationByIdQuery, LocationByIdQueryVariables>;
export const LocationsAggregateDocument = gql`
    query LocationsAggregate($value: String!) {
  locations_aggregate(where: {name: {_like: $value}, deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useLocationsAggregateQuery__
 *
 * To run a query within a React component, call `useLocationsAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsAggregateQuery({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useLocationsAggregateQuery(baseOptions: Apollo.QueryHookOptions<LocationsAggregateQuery, LocationsAggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationsAggregateQuery, LocationsAggregateQueryVariables>(LocationsAggregateDocument, options);
      }
export function useLocationsAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsAggregateQuery, LocationsAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationsAggregateQuery, LocationsAggregateQueryVariables>(LocationsAggregateDocument, options);
        }
export function useLocationsAggregateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocationsAggregateQuery, LocationsAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationsAggregateQuery, LocationsAggregateQueryVariables>(LocationsAggregateDocument, options);
        }
export type LocationsAggregateQueryHookResult = ReturnType<typeof useLocationsAggregateQuery>;
export type LocationsAggregateLazyQueryHookResult = ReturnType<typeof useLocationsAggregateLazyQuery>;
export type LocationsAggregateSuspenseQueryHookResult = ReturnType<typeof useLocationsAggregateSuspenseQuery>;
export type LocationsAggregateQueryResult = Apollo.QueryResult<LocationsAggregateQuery, LocationsAggregateQueryVariables>;
export const ProviderAtHomeLocationsListDocument = gql`
    query ProviderAtHomeLocationsList($providerId: uuid!, $value: String!, $limit: Int, $offset: Int) {
  providers_by_pk(id: $providerId) {
    id
    locations(
      limit: $limit
      offset: $offset
      where: {name: {_like: $value}, deletedAt: {_is_null: true}, type: {_eq: home_radius}}
      order_by: {createdAt: desc}
    ) {
      id
      address
      coordinates
      name
      phoneNumber
      email
      radius
      status
      type
      additionalCities
      excludedCities
    }
    locations_aggregate(where: {name: {_like: $value}, deletedAt: {_is_null: true}}) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useProviderAtHomeLocationsListQuery__
 *
 * To run a query within a React component, call `useProviderAtHomeLocationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderAtHomeLocationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderAtHomeLocationsListQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      value: // value for 'value'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useProviderAtHomeLocationsListQuery(baseOptions: Apollo.QueryHookOptions<ProviderAtHomeLocationsListQuery, ProviderAtHomeLocationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderAtHomeLocationsListQuery, ProviderAtHomeLocationsListQueryVariables>(ProviderAtHomeLocationsListDocument, options);
      }
export function useProviderAtHomeLocationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderAtHomeLocationsListQuery, ProviderAtHomeLocationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderAtHomeLocationsListQuery, ProviderAtHomeLocationsListQueryVariables>(ProviderAtHomeLocationsListDocument, options);
        }
export function useProviderAtHomeLocationsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProviderAtHomeLocationsListQuery, ProviderAtHomeLocationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderAtHomeLocationsListQuery, ProviderAtHomeLocationsListQueryVariables>(ProviderAtHomeLocationsListDocument, options);
        }
export type ProviderAtHomeLocationsListQueryHookResult = ReturnType<typeof useProviderAtHomeLocationsListQuery>;
export type ProviderAtHomeLocationsListLazyQueryHookResult = ReturnType<typeof useProviderAtHomeLocationsListLazyQuery>;
export type ProviderAtHomeLocationsListSuspenseQueryHookResult = ReturnType<typeof useProviderAtHomeLocationsListSuspenseQuery>;
export type ProviderAtHomeLocationsListQueryResult = Apollo.QueryResult<ProviderAtHomeLocationsListQuery, ProviderAtHomeLocationsListQueryVariables>;
export const ProviderLocationsDocument = gql`
    query ProviderLocations($providerId: uuid!, $value: String!, $limit: Int, $offset: Int) {
  buildingProviders(
    where: {providerId: {_eq: $providerId}, deletedAt: {_is_null: true}}
  ) {
    id
    status
    scheduleLocationId
    scheduleLocation {
      id
      name
      address
      type
    }
    partnershipSchedulingType
    location {
      address
      coordinates
      id
      name
      phoneNumber
      email
      status
      type
      buildingProviders {
        id
        status
      }
      buildingManager {
        id
        name
        email
        address
        phoneNumber
      }
    }
  }
  providers_by_pk(id: $providerId) {
    id
    locations(
      limit: $limit
      offset: $offset
      where: {name: {_like: $value}, deletedAt: {_is_null: true}}
      order_by: {createdAt: desc}
    ) {
      address
      coordinates
      id
      name
      phoneNumber
      email
      radius
      status
      type
      additionalCities
      excludedCities
      schedules {
        user {
          serviceEmployeesByUserid_aggregate(distinct_on: serviceId) {
            aggregate {
              count
            }
          }
        }
      }
      schedules_aggregate(
        distinct_on: employeeId
        where: {user: {userRole: {role: {_in: [employee, provider]}, deletedAt: {_is_null: true}}}}
      ) {
        aggregate {
          count
        }
      }
    }
    locations_aggregate(where: {name: {_like: $value}, deletedAt: {_is_null: true}}) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useProviderLocationsQuery__
 *
 * To run a query within a React component, call `useProviderLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderLocationsQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      value: // value for 'value'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useProviderLocationsQuery(baseOptions: Apollo.QueryHookOptions<ProviderLocationsQuery, ProviderLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderLocationsQuery, ProviderLocationsQueryVariables>(ProviderLocationsDocument, options);
      }
export function useProviderLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderLocationsQuery, ProviderLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderLocationsQuery, ProviderLocationsQueryVariables>(ProviderLocationsDocument, options);
        }
export function useProviderLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProviderLocationsQuery, ProviderLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderLocationsQuery, ProviderLocationsQueryVariables>(ProviderLocationsDocument, options);
        }
export type ProviderLocationsQueryHookResult = ReturnType<typeof useProviderLocationsQuery>;
export type ProviderLocationsLazyQueryHookResult = ReturnType<typeof useProviderLocationsLazyQuery>;
export type ProviderLocationsSuspenseQueryHookResult = ReturnType<typeof useProviderLocationsSuspenseQuery>;
export type ProviderLocationsQueryResult = Apollo.QueryResult<ProviderLocationsQuery, ProviderLocationsQueryVariables>;
export const LocationEmployeesDocument = gql`
    query LocationEmployees($locationId: uuid!, $limit: Int, $offset: Int) {
  locations_by_pk(id: $locationId) {
    schedules(
      distinct_on: employeeId
      where: {user: {userRole: {role: {_in: [employee, provider]}, deletedAt: {_is_null: true}}}}
      limit: $limit
      offset: $offset
    ) {
      user {
        id
        name
        email
        phoneNumber
        profilePicture {
          id
          name
        }
      }
    }
    schedules_aggregate(
      distinct_on: employeeId
      where: {user: {userRole: {role: {_in: [employee, provider]}, deletedAt: {_is_null: true}}}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useLocationEmployeesQuery__
 *
 * To run a query within a React component, call `useLocationEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationEmployeesQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useLocationEmployeesQuery(baseOptions: Apollo.QueryHookOptions<LocationEmployeesQuery, LocationEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationEmployeesQuery, LocationEmployeesQueryVariables>(LocationEmployeesDocument, options);
      }
export function useLocationEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationEmployeesQuery, LocationEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationEmployeesQuery, LocationEmployeesQueryVariables>(LocationEmployeesDocument, options);
        }
export function useLocationEmployeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocationEmployeesQuery, LocationEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationEmployeesQuery, LocationEmployeesQueryVariables>(LocationEmployeesDocument, options);
        }
export type LocationEmployeesQueryHookResult = ReturnType<typeof useLocationEmployeesQuery>;
export type LocationEmployeesLazyQueryHookResult = ReturnType<typeof useLocationEmployeesLazyQuery>;
export type LocationEmployeesSuspenseQueryHookResult = ReturnType<typeof useLocationEmployeesSuspenseQuery>;
export type LocationEmployeesQueryResult = Apollo.QueryResult<LocationEmployeesQuery, LocationEmployeesQueryVariables>;
export const DeletePartnershipDocument = gql`
    mutation DeletePartnership($partnershipId: uuid!) {
  update_buildingProviders_by_pk(
    pk_columns: {id: $partnershipId}
    _set: {deletedAt: "now()"}
  ) {
    id
  }
}
    `;
export type DeletePartnershipMutationFn = Apollo.MutationFunction<DeletePartnershipMutation, DeletePartnershipMutationVariables>;

/**
 * __useDeletePartnershipMutation__
 *
 * To run a mutation, you first call `useDeletePartnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePartnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePartnershipMutation, { data, loading, error }] = useDeletePartnershipMutation({
 *   variables: {
 *      partnershipId: // value for 'partnershipId'
 *   },
 * });
 */
export function useDeletePartnershipMutation(baseOptions?: Apollo.MutationHookOptions<DeletePartnershipMutation, DeletePartnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePartnershipMutation, DeletePartnershipMutationVariables>(DeletePartnershipDocument, options);
      }
export type DeletePartnershipMutationHookResult = ReturnType<typeof useDeletePartnershipMutation>;
export type DeletePartnershipMutationResult = Apollo.MutationResult<DeletePartnershipMutation>;
export type DeletePartnershipMutationOptions = Apollo.BaseMutationOptions<DeletePartnershipMutation, DeletePartnershipMutationVariables>;
export const CreateLocationDocument = gql`
    mutation CreateLocation($address: String!, $coordinates: geography!, $name: String!, $phoneNumber: String, $email: String, $providerId: uuid!, $radius: numeric, $status: locationStatus_enum!, $type: locationType_enum!, $additionalCities: [String!], $excludedCities: [String!]) {
  insert_locations_one(
    object: {address: $address, coordinates: $coordinates, name: $name, phoneNumber: $phoneNumber, email: $email, providerId: $providerId, radius: $radius, status: $status, type: $type, additionalCities: $additionalCities, excludedCities: $excludedCities}
  ) {
    address
    coordinates
    id
    name
    phoneNumber
    email
    providerId
    radius
    status
    type
    additionalCities
    excludedCities
  }
}
    `;
export type CreateLocationMutationFn = Apollo.MutationFunction<CreateLocationMutation, CreateLocationMutationVariables>;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutation, { data, loading, error }] = useCreateLocationMutation({
 *   variables: {
 *      address: // value for 'address'
 *      coordinates: // value for 'coordinates'
 *      name: // value for 'name'
 *      phoneNumber: // value for 'phoneNumber'
 *      email: // value for 'email'
 *      providerId: // value for 'providerId'
 *      radius: // value for 'radius'
 *      status: // value for 'status'
 *      type: // value for 'type'
 *      additionalCities: // value for 'additionalCities'
 *      excludedCities: // value for 'excludedCities'
 *   },
 * });
 */
export function useCreateLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationMutation, CreateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationMutation, CreateLocationMutationVariables>(CreateLocationDocument, options);
      }
export type CreateLocationMutationHookResult = ReturnType<typeof useCreateLocationMutation>;
export type CreateLocationMutationResult = Apollo.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = Apollo.BaseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables>;
export const LocationServicesDocument = gql`
    query LocationServices($locationId: uuid!, $limit: Int, $offset: Int) {
  locations(where: {id: {_eq: $locationId}, deletedAt: {_is_null: true}}) {
    schedules {
      user {
        serviceEmployeesByUserid(
          limit: $limit
          offset: $offset
          distinct_on: serviceId
          where: {service: {deletedAt: {_is_null: true}}}
        ) {
          service {
            id
            name
          }
        }
        serviceEmployeesByUserid_aggregate(
          distinct_on: serviceId
          where: {service: {deletedAt: {_is_null: true}}}
        ) {
          aggregate {
            count
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLocationServicesQuery__
 *
 * To run a query within a React component, call `useLocationServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationServicesQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useLocationServicesQuery(baseOptions: Apollo.QueryHookOptions<LocationServicesQuery, LocationServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationServicesQuery, LocationServicesQueryVariables>(LocationServicesDocument, options);
      }
export function useLocationServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationServicesQuery, LocationServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationServicesQuery, LocationServicesQueryVariables>(LocationServicesDocument, options);
        }
export function useLocationServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocationServicesQuery, LocationServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationServicesQuery, LocationServicesQueryVariables>(LocationServicesDocument, options);
        }
export type LocationServicesQueryHookResult = ReturnType<typeof useLocationServicesQuery>;
export type LocationServicesLazyQueryHookResult = ReturnType<typeof useLocationServicesLazyQuery>;
export type LocationServicesSuspenseQueryHookResult = ReturnType<typeof useLocationServicesSuspenseQuery>;
export type LocationServicesQueryResult = Apollo.QueryResult<LocationServicesQuery, LocationServicesQueryVariables>;
export const SearchLocationServicesDocument = gql`
    query SearchLocationServices($locationId: uuid!, $limit: Int, $offset: Int, $searchByName: String!) {
  locations(where: {id: {_eq: $locationId}, deletedAt: {_is_null: true}}) {
    schedules {
      user {
        serviceEmployeesByUserid(
          where: {service: {name: {_ilike: $searchByName}, deletedAt: {_is_null: true}}}
          limit: $limit
          offset: $offset
          distinct_on: serviceId
        ) {
          service {
            id
            name
          }
        }
        serviceEmployeesByUserid_aggregate(
          where: {service: {name: {_ilike: $searchByName}, deletedAt: {_is_null: true}}}
          distinct_on: serviceId
        ) {
          aggregate {
            count
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchLocationServicesQuery__
 *
 * To run a query within a React component, call `useSearchLocationServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLocationServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLocationServicesQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchByName: // value for 'searchByName'
 *   },
 * });
 */
export function useSearchLocationServicesQuery(baseOptions: Apollo.QueryHookOptions<SearchLocationServicesQuery, SearchLocationServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchLocationServicesQuery, SearchLocationServicesQueryVariables>(SearchLocationServicesDocument, options);
      }
export function useSearchLocationServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchLocationServicesQuery, SearchLocationServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchLocationServicesQuery, SearchLocationServicesQueryVariables>(SearchLocationServicesDocument, options);
        }
export function useSearchLocationServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchLocationServicesQuery, SearchLocationServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchLocationServicesQuery, SearchLocationServicesQueryVariables>(SearchLocationServicesDocument, options);
        }
export type SearchLocationServicesQueryHookResult = ReturnType<typeof useSearchLocationServicesQuery>;
export type SearchLocationServicesLazyQueryHookResult = ReturnType<typeof useSearchLocationServicesLazyQuery>;
export type SearchLocationServicesSuspenseQueryHookResult = ReturnType<typeof useSearchLocationServicesSuspenseQuery>;
export type SearchLocationServicesQueryResult = Apollo.QueryResult<SearchLocationServicesQuery, SearchLocationServicesQueryVariables>;
export const UnavailableServiceLocationsDocument = gql`
    query UnavailableServiceLocations($locationId: uuid!) {
  unavailableServiceLocations(where: {locationId: {_eq: $locationId}}) {
    serviceId
  }
}
    `;

/**
 * __useUnavailableServiceLocationsQuery__
 *
 * To run a query within a React component, call `useUnavailableServiceLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnavailableServiceLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnavailableServiceLocationsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useUnavailableServiceLocationsQuery(baseOptions: Apollo.QueryHookOptions<UnavailableServiceLocationsQuery, UnavailableServiceLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnavailableServiceLocationsQuery, UnavailableServiceLocationsQueryVariables>(UnavailableServiceLocationsDocument, options);
      }
export function useUnavailableServiceLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnavailableServiceLocationsQuery, UnavailableServiceLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnavailableServiceLocationsQuery, UnavailableServiceLocationsQueryVariables>(UnavailableServiceLocationsDocument, options);
        }
export function useUnavailableServiceLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnavailableServiceLocationsQuery, UnavailableServiceLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnavailableServiceLocationsQuery, UnavailableServiceLocationsQueryVariables>(UnavailableServiceLocationsDocument, options);
        }
export type UnavailableServiceLocationsQueryHookResult = ReturnType<typeof useUnavailableServiceLocationsQuery>;
export type UnavailableServiceLocationsLazyQueryHookResult = ReturnType<typeof useUnavailableServiceLocationsLazyQuery>;
export type UnavailableServiceLocationsSuspenseQueryHookResult = ReturnType<typeof useUnavailableServiceLocationsSuspenseQuery>;
export type UnavailableServiceLocationsQueryResult = Apollo.QueryResult<UnavailableServiceLocationsQuery, UnavailableServiceLocationsQueryVariables>;
export const SetUnavailableServiceLocationDocument = gql`
    mutation SetUnavailableServiceLocation($locationId: uuid!, $serviceId: uuid!) {
  insert_unavailableServiceLocations_one(
    object: {locationId: $locationId, serviceId: $serviceId}
  ) {
    id
    locationId
    serviceId
  }
}
    `;
export type SetUnavailableServiceLocationMutationFn = Apollo.MutationFunction<SetUnavailableServiceLocationMutation, SetUnavailableServiceLocationMutationVariables>;

/**
 * __useSetUnavailableServiceLocationMutation__
 *
 * To run a mutation, you first call `useSetUnavailableServiceLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUnavailableServiceLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUnavailableServiceLocationMutation, { data, loading, error }] = useSetUnavailableServiceLocationMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useSetUnavailableServiceLocationMutation(baseOptions?: Apollo.MutationHookOptions<SetUnavailableServiceLocationMutation, SetUnavailableServiceLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUnavailableServiceLocationMutation, SetUnavailableServiceLocationMutationVariables>(SetUnavailableServiceLocationDocument, options);
      }
export type SetUnavailableServiceLocationMutationHookResult = ReturnType<typeof useSetUnavailableServiceLocationMutation>;
export type SetUnavailableServiceLocationMutationResult = Apollo.MutationResult<SetUnavailableServiceLocationMutation>;
export type SetUnavailableServiceLocationMutationOptions = Apollo.BaseMutationOptions<SetUnavailableServiceLocationMutation, SetUnavailableServiceLocationMutationVariables>;
export const UnsetUnavailableServiceLocationDocument = gql`
    mutation UnsetUnavailableServiceLocation($locationId: uuid!, $serviceId: uuid!) {
  delete_unavailableServiceLocations(
    where: {locationId: {_eq: $locationId}, serviceId: {_eq: $serviceId}}
  ) {
    affected_rows
  }
}
    `;
export type UnsetUnavailableServiceLocationMutationFn = Apollo.MutationFunction<UnsetUnavailableServiceLocationMutation, UnsetUnavailableServiceLocationMutationVariables>;

/**
 * __useUnsetUnavailableServiceLocationMutation__
 *
 * To run a mutation, you first call `useUnsetUnavailableServiceLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsetUnavailableServiceLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsetUnavailableServiceLocationMutation, { data, loading, error }] = useUnsetUnavailableServiceLocationMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useUnsetUnavailableServiceLocationMutation(baseOptions?: Apollo.MutationHookOptions<UnsetUnavailableServiceLocationMutation, UnsetUnavailableServiceLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsetUnavailableServiceLocationMutation, UnsetUnavailableServiceLocationMutationVariables>(UnsetUnavailableServiceLocationDocument, options);
      }
export type UnsetUnavailableServiceLocationMutationHookResult = ReturnType<typeof useUnsetUnavailableServiceLocationMutation>;
export type UnsetUnavailableServiceLocationMutationResult = Apollo.MutationResult<UnsetUnavailableServiceLocationMutation>;
export type UnsetUnavailableServiceLocationMutationOptions = Apollo.BaseMutationOptions<UnsetUnavailableServiceLocationMutation, UnsetUnavailableServiceLocationMutationVariables>;
export const GetLocationByAddressDocument = gql`
    query GetLocationByAddress($address: String!) {
  getLocationByAddress(address: $address) {
    location {
      id
      address
      buildingManager {
        id
        name
        email
        phoneNumber
        profilePictureFileId
        isEmailVerified
        isPhoneNumberVerified
      }
      buildingProviders {
        id
        providerId
        locationId
        partnershipSchedulingType
      }
      buildingManagerId
      coordinates {
        coordinates
      }
      radius
      createdAt
      deletedAt
      email
      phoneNumber
      partnershipDefaultStatus
      status
    }
  }
}
    `;

/**
 * __useGetLocationByAddressQuery__
 *
 * To run a query within a React component, call `useGetLocationByAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationByAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationByAddressQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useGetLocationByAddressQuery(baseOptions: Apollo.QueryHookOptions<GetLocationByAddressQuery, GetLocationByAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationByAddressQuery, GetLocationByAddressQueryVariables>(GetLocationByAddressDocument, options);
      }
export function useGetLocationByAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationByAddressQuery, GetLocationByAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationByAddressQuery, GetLocationByAddressQueryVariables>(GetLocationByAddressDocument, options);
        }
export function useGetLocationByAddressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationByAddressQuery, GetLocationByAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationByAddressQuery, GetLocationByAddressQueryVariables>(GetLocationByAddressDocument, options);
        }
export type GetLocationByAddressQueryHookResult = ReturnType<typeof useGetLocationByAddressQuery>;
export type GetLocationByAddressLazyQueryHookResult = ReturnType<typeof useGetLocationByAddressLazyQuery>;
export type GetLocationByAddressSuspenseQueryHookResult = ReturnType<typeof useGetLocationByAddressSuspenseQuery>;
export type GetLocationByAddressQueryResult = Apollo.QueryResult<GetLocationByAddressQuery, GetLocationByAddressQueryVariables>;
export const CreateLocationPartnershipDocument = gql`
    mutation CreateLocationPartnership($locationId: String!, $partnershipSchedulingType: String!, $scheduleLocationId: String) {
  requestLocationPartnership(
    locationId: $locationId
    partnershipSchedulingType: $partnershipSchedulingType
    scheduleLocationId: $scheduleLocationId
  ) {
    partnership {
      id
      status
      partnershipSchedulingType
    }
  }
}
    `;
export type CreateLocationPartnershipMutationFn = Apollo.MutationFunction<CreateLocationPartnershipMutation, CreateLocationPartnershipMutationVariables>;

/**
 * __useCreateLocationPartnershipMutation__
 *
 * To run a mutation, you first call `useCreateLocationPartnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationPartnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationPartnershipMutation, { data, loading, error }] = useCreateLocationPartnershipMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      partnershipSchedulingType: // value for 'partnershipSchedulingType'
 *      scheduleLocationId: // value for 'scheduleLocationId'
 *   },
 * });
 */
export function useCreateLocationPartnershipMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationPartnershipMutation, CreateLocationPartnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationPartnershipMutation, CreateLocationPartnershipMutationVariables>(CreateLocationPartnershipDocument, options);
      }
export type CreateLocationPartnershipMutationHookResult = ReturnType<typeof useCreateLocationPartnershipMutation>;
export type CreateLocationPartnershipMutationResult = Apollo.MutationResult<CreateLocationPartnershipMutation>;
export type CreateLocationPartnershipMutationOptions = Apollo.BaseMutationOptions<CreateLocationPartnershipMutation, CreateLocationPartnershipMutationVariables>;
export const UpdateBuildingDocument = gql`
    mutation UpdateBuilding($buildingId: uuid!, $name: String!) {
  update_locations_by_pk(pk_columns: {id: $buildingId}, _set: {name: $name}) {
    id
    name
  }
}
    `;
export type UpdateBuildingMutationFn = Apollo.MutationFunction<UpdateBuildingMutation, UpdateBuildingMutationVariables>;

/**
 * __useUpdateBuildingMutation__
 *
 * To run a mutation, you first call `useUpdateBuildingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBuildingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBuildingMutation, { data, loading, error }] = useUpdateBuildingMutation({
 *   variables: {
 *      buildingId: // value for 'buildingId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateBuildingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBuildingMutation, UpdateBuildingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBuildingMutation, UpdateBuildingMutationVariables>(UpdateBuildingDocument, options);
      }
export type UpdateBuildingMutationHookResult = ReturnType<typeof useUpdateBuildingMutation>;
export type UpdateBuildingMutationResult = Apollo.MutationResult<UpdateBuildingMutation>;
export type UpdateBuildingMutationOptions = Apollo.BaseMutationOptions<UpdateBuildingMutation, UpdateBuildingMutationVariables>;
export const UpdateLocationDetailsDocument = gql`
    mutation UpdateLocationDetails($id: uuid!, $name: String, $radius: numeric, $email: String, $phoneNumber: String) {
  update_locations_by_pk(
    pk_columns: {id: $id}
    _set: {name: $name, radius: $radius, email: $email, phoneNumber: $phoneNumber}
  ) {
    id
  }
}
    `;
export type UpdateLocationDetailsMutationFn = Apollo.MutationFunction<UpdateLocationDetailsMutation, UpdateLocationDetailsMutationVariables>;

/**
 * __useUpdateLocationDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateLocationDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationDetailsMutation, { data, loading, error }] = useUpdateLocationDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      radius: // value for 'radius'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdateLocationDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationDetailsMutation, UpdateLocationDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationDetailsMutation, UpdateLocationDetailsMutationVariables>(UpdateLocationDetailsDocument, options);
      }
export type UpdateLocationDetailsMutationHookResult = ReturnType<typeof useUpdateLocationDetailsMutation>;
export type UpdateLocationDetailsMutationResult = Apollo.MutationResult<UpdateLocationDetailsMutation>;
export type UpdateLocationDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateLocationDetailsMutation, UpdateLocationDetailsMutationVariables>;
export const RestoreDeletedLocationDocument = gql`
    mutation RestoreDeletedLocation($locationId: uuid!, $input: locations_set_input!) {
  update_locations(where: {id: {_eq: $locationId}}, _set: $input) {
    returning {
      id
    }
  }
}
    `;
export type RestoreDeletedLocationMutationFn = Apollo.MutationFunction<RestoreDeletedLocationMutation, RestoreDeletedLocationMutationVariables>;

/**
 * __useRestoreDeletedLocationMutation__
 *
 * To run a mutation, you first call `useRestoreDeletedLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDeletedLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDeletedLocationMutation, { data, loading, error }] = useRestoreDeletedLocationMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreDeletedLocationMutation(baseOptions?: Apollo.MutationHookOptions<RestoreDeletedLocationMutation, RestoreDeletedLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreDeletedLocationMutation, RestoreDeletedLocationMutationVariables>(RestoreDeletedLocationDocument, options);
      }
export type RestoreDeletedLocationMutationHookResult = ReturnType<typeof useRestoreDeletedLocationMutation>;
export type RestoreDeletedLocationMutationResult = Apollo.MutationResult<RestoreDeletedLocationMutation>;
export type RestoreDeletedLocationMutationOptions = Apollo.BaseMutationOptions<RestoreDeletedLocationMutation, RestoreDeletedLocationMutationVariables>;
export const FindLocationsByServiceIdDocument = gql`
    query FindLocationsByServiceId($serviceId: String!, $coordinates: GeographyCoordinatesInput) {
  findLocationsByServiceId(serviceId: $serviceId, coordinates: $coordinates) {
    id
    name
    distance
    type
    address
    coordinates {
      type
      coordinates
    }
    radius
  }
}
    `;

/**
 * __useFindLocationsByServiceIdQuery__
 *
 * To run a query within a React component, call `useFindLocationsByServiceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindLocationsByServiceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLocationsByServiceIdQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      coordinates: // value for 'coordinates'
 *   },
 * });
 */
export function useFindLocationsByServiceIdQuery(baseOptions: Apollo.QueryHookOptions<FindLocationsByServiceIdQuery, FindLocationsByServiceIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindLocationsByServiceIdQuery, FindLocationsByServiceIdQueryVariables>(FindLocationsByServiceIdDocument, options);
      }
export function useFindLocationsByServiceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindLocationsByServiceIdQuery, FindLocationsByServiceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindLocationsByServiceIdQuery, FindLocationsByServiceIdQueryVariables>(FindLocationsByServiceIdDocument, options);
        }
export function useFindLocationsByServiceIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindLocationsByServiceIdQuery, FindLocationsByServiceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindLocationsByServiceIdQuery, FindLocationsByServiceIdQueryVariables>(FindLocationsByServiceIdDocument, options);
        }
export type FindLocationsByServiceIdQueryHookResult = ReturnType<typeof useFindLocationsByServiceIdQuery>;
export type FindLocationsByServiceIdLazyQueryHookResult = ReturnType<typeof useFindLocationsByServiceIdLazyQuery>;
export type FindLocationsByServiceIdSuspenseQueryHookResult = ReturnType<typeof useFindLocationsByServiceIdSuspenseQuery>;
export type FindLocationsByServiceIdQueryResult = Apollo.QueryResult<FindLocationsByServiceIdQuery, FindLocationsByServiceIdQueryVariables>;
export const LocationHaversineDocument = gql`
    query LocationHaversine($input: LocationHaversineInputDto!) {
  locationHaversine(input: $input) {
    distance
    inside
  }
}
    `;

/**
 * __useLocationHaversineQuery__
 *
 * To run a query within a React component, call `useLocationHaversineQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationHaversineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationHaversineQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLocationHaversineQuery(baseOptions: Apollo.QueryHookOptions<LocationHaversineQuery, LocationHaversineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationHaversineQuery, LocationHaversineQueryVariables>(LocationHaversineDocument, options);
      }
export function useLocationHaversineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationHaversineQuery, LocationHaversineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationHaversineQuery, LocationHaversineQueryVariables>(LocationHaversineDocument, options);
        }
export function useLocationHaversineSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocationHaversineQuery, LocationHaversineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationHaversineQuery, LocationHaversineQueryVariables>(LocationHaversineDocument, options);
        }
export type LocationHaversineQueryHookResult = ReturnType<typeof useLocationHaversineQuery>;
export type LocationHaversineLazyQueryHookResult = ReturnType<typeof useLocationHaversineLazyQuery>;
export type LocationHaversineSuspenseQueryHookResult = ReturnType<typeof useLocationHaversineSuspenseQuery>;
export type LocationHaversineQueryResult = Apollo.QueryResult<LocationHaversineQuery, LocationHaversineQueryVariables>;
export const GetSpLocationsListDocument = gql`
    query GetSpLocationsList($searchByName: String!, $limit: Int, $offset: Int, $providerId: uuid!) {
  locations(
    where: {name: {_ilike: $searchByName}, status: {_eq: active}, deletedAt: {_is_null: true}, _or: [{providerId: {_eq: $providerId}}, {buildingProviders: {providerId: {_eq: $providerId}}}]}
    limit: $limit
    offset: $offset
    order_by: {createdAt: desc}
  ) {
    id
    name
    address
    type
    coordinates
    radius
    additionalCities
    excludedCities
  }
}
    `;

/**
 * __useGetSpLocationsListQuery__
 *
 * To run a query within a React component, call `useGetSpLocationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpLocationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpLocationsListQuery({
 *   variables: {
 *      searchByName: // value for 'searchByName'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useGetSpLocationsListQuery(baseOptions: Apollo.QueryHookOptions<GetSpLocationsListQuery, GetSpLocationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpLocationsListQuery, GetSpLocationsListQueryVariables>(GetSpLocationsListDocument, options);
      }
export function useGetSpLocationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpLocationsListQuery, GetSpLocationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpLocationsListQuery, GetSpLocationsListQueryVariables>(GetSpLocationsListDocument, options);
        }
export function useGetSpLocationsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSpLocationsListQuery, GetSpLocationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpLocationsListQuery, GetSpLocationsListQueryVariables>(GetSpLocationsListDocument, options);
        }
export type GetSpLocationsListQueryHookResult = ReturnType<typeof useGetSpLocationsListQuery>;
export type GetSpLocationsListLazyQueryHookResult = ReturnType<typeof useGetSpLocationsListLazyQuery>;
export type GetSpLocationsListSuspenseQueryHookResult = ReturnType<typeof useGetSpLocationsListSuspenseQuery>;
export type GetSpLocationsListQueryResult = Apollo.QueryResult<GetSpLocationsListQuery, GetSpLocationsListQueryVariables>;
export const AppointmentServiceNotificationDocument = gql`
    query AppointmentServiceNotification($id: uuid!) {
  appointments_by_pk(id: $id) {
    service {
      id
      color
      name
    }
    customer {
      name
    }
  }
}
    `;

/**
 * __useAppointmentServiceNotificationQuery__
 *
 * To run a query within a React component, call `useAppointmentServiceNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentServiceNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentServiceNotificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentServiceNotificationQuery(baseOptions: Apollo.QueryHookOptions<AppointmentServiceNotificationQuery, AppointmentServiceNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentServiceNotificationQuery, AppointmentServiceNotificationQueryVariables>(AppointmentServiceNotificationDocument, options);
      }
export function useAppointmentServiceNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentServiceNotificationQuery, AppointmentServiceNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentServiceNotificationQuery, AppointmentServiceNotificationQueryVariables>(AppointmentServiceNotificationDocument, options);
        }
export function useAppointmentServiceNotificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AppointmentServiceNotificationQuery, AppointmentServiceNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppointmentServiceNotificationQuery, AppointmentServiceNotificationQueryVariables>(AppointmentServiceNotificationDocument, options);
        }
export type AppointmentServiceNotificationQueryHookResult = ReturnType<typeof useAppointmentServiceNotificationQuery>;
export type AppointmentServiceNotificationLazyQueryHookResult = ReturnType<typeof useAppointmentServiceNotificationLazyQuery>;
export type AppointmentServiceNotificationSuspenseQueryHookResult = ReturnType<typeof useAppointmentServiceNotificationSuspenseQuery>;
export type AppointmentServiceNotificationQueryResult = Apollo.QueryResult<AppointmentServiceNotificationQuery, AppointmentServiceNotificationQueryVariables>;
export const PartnershipNotificationDocument = gql`
    query PartnershipNotification($id: uuid!) {
  buildingProviders_by_pk(id: $id) {
    id
    status
    provider {
      id
      name
    }
    location {
      address
      name
      buildingManager {
        name
      }
    }
  }
}
    `;

/**
 * __usePartnershipNotificationQuery__
 *
 * To run a query within a React component, call `usePartnershipNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnershipNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnershipNotificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnershipNotificationQuery(baseOptions: Apollo.QueryHookOptions<PartnershipNotificationQuery, PartnershipNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnershipNotificationQuery, PartnershipNotificationQueryVariables>(PartnershipNotificationDocument, options);
      }
export function usePartnershipNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnershipNotificationQuery, PartnershipNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnershipNotificationQuery, PartnershipNotificationQueryVariables>(PartnershipNotificationDocument, options);
        }
export function usePartnershipNotificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PartnershipNotificationQuery, PartnershipNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnershipNotificationQuery, PartnershipNotificationQueryVariables>(PartnershipNotificationDocument, options);
        }
export type PartnershipNotificationQueryHookResult = ReturnType<typeof usePartnershipNotificationQuery>;
export type PartnershipNotificationLazyQueryHookResult = ReturnType<typeof usePartnershipNotificationLazyQuery>;
export type PartnershipNotificationSuspenseQueryHookResult = ReturnType<typeof usePartnershipNotificationSuspenseQuery>;
export type PartnershipNotificationQueryResult = Apollo.QueryResult<PartnershipNotificationQuery, PartnershipNotificationQueryVariables>;
export const PaymentServiceNotificationDocument = gql`
    query PaymentServiceNotification($id: uuid!) {
  payments_by_pk(id: $id) {
    appointment {
      service {
        id
        color
        name
      }
      customer {
        name
      }
    }
  }
}
    `;

/**
 * __usePaymentServiceNotificationQuery__
 *
 * To run a query within a React component, call `usePaymentServiceNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentServiceNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentServiceNotificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentServiceNotificationQuery(baseOptions: Apollo.QueryHookOptions<PaymentServiceNotificationQuery, PaymentServiceNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentServiceNotificationQuery, PaymentServiceNotificationQueryVariables>(PaymentServiceNotificationDocument, options);
      }
export function usePaymentServiceNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentServiceNotificationQuery, PaymentServiceNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentServiceNotificationQuery, PaymentServiceNotificationQueryVariables>(PaymentServiceNotificationDocument, options);
        }
export function usePaymentServiceNotificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentServiceNotificationQuery, PaymentServiceNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentServiceNotificationQuery, PaymentServiceNotificationQueryVariables>(PaymentServiceNotificationDocument, options);
        }
export type PaymentServiceNotificationQueryHookResult = ReturnType<typeof usePaymentServiceNotificationQuery>;
export type PaymentServiceNotificationLazyQueryHookResult = ReturnType<typeof usePaymentServiceNotificationLazyQuery>;
export type PaymentServiceNotificationSuspenseQueryHookResult = ReturnType<typeof usePaymentServiceNotificationSuspenseQuery>;
export type PaymentServiceNotificationQueryResult = Apollo.QueryResult<PaymentServiceNotificationQuery, PaymentServiceNotificationQueryVariables>;
export const ServicesServiceNotificationDocument = gql`
    query ServicesServiceNotification($id: uuid!) {
  services_by_pk(id: $id) {
    id
    color
    name
  }
}
    `;

/**
 * __useServicesServiceNotificationQuery__
 *
 * To run a query within a React component, call `useServicesServiceNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicesServiceNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicesServiceNotificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useServicesServiceNotificationQuery(baseOptions: Apollo.QueryHookOptions<ServicesServiceNotificationQuery, ServicesServiceNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServicesServiceNotificationQuery, ServicesServiceNotificationQueryVariables>(ServicesServiceNotificationDocument, options);
      }
export function useServicesServiceNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServicesServiceNotificationQuery, ServicesServiceNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServicesServiceNotificationQuery, ServicesServiceNotificationQueryVariables>(ServicesServiceNotificationDocument, options);
        }
export function useServicesServiceNotificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServicesServiceNotificationQuery, ServicesServiceNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServicesServiceNotificationQuery, ServicesServiceNotificationQueryVariables>(ServicesServiceNotificationDocument, options);
        }
export type ServicesServiceNotificationQueryHookResult = ReturnType<typeof useServicesServiceNotificationQuery>;
export type ServicesServiceNotificationLazyQueryHookResult = ReturnType<typeof useServicesServiceNotificationLazyQuery>;
export type ServicesServiceNotificationSuspenseQueryHookResult = ReturnType<typeof useServicesServiceNotificationSuspenseQuery>;
export type ServicesServiceNotificationQueryResult = Apollo.QueryResult<ServicesServiceNotificationQuery, ServicesServiceNotificationQueryVariables>;
export const NotificationsDocument = gql`
    query Notifications($limit: Int!, $beforeCreatedAt: timestamptz!) {
  notifications(
    limit: $limit
    order_by: {createdAt: desc}
    where: {createdAt: {_lt: $beforeCreatedAt}}
  ) {
    id
    entityId
    entityType
    fromUserId
    toUserId
    type
    readAt
    viewedAt
    createdAt
    updatedAt
    fromUser {
      id
      name
      profilePicture {
        id
        name
      }
      location {
        name
      }
      userRole {
        provider {
          id
          name
        }
      }
    }
  }
  notifications_aggregate {
    aggregate {
      count
    }
  }
  unreadNotificationsCount: notifications_aggregate(
    where: {readAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      beforeCreatedAt: // value for 'beforeCreatedAt'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export function useNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsSuspenseQueryHookResult = ReturnType<typeof useNotificationsSuspenseQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const NewNotificationsDocument = gql`
    subscription NewNotifications($afterCreatedAt: timestamptz!) {
  notifications_stream(
    cursor: {initial_value: {createdAt: $afterCreatedAt}, ordering: ASC}
    batch_size: 1
  ) {
    id
    entityId
    entityType
    fromUserId
    toUserId
    type
    readAt
    viewedAt
    createdAt
    updatedAt
    fromUser {
      id
      name
      profilePicture {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useNewNotificationsSubscription__
 *
 * To run a query within a React component, call `useNewNotificationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewNotificationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewNotificationsSubscription({
 *   variables: {
 *      afterCreatedAt: // value for 'afterCreatedAt'
 *   },
 * });
 */
export function useNewNotificationsSubscription(baseOptions: Apollo.SubscriptionHookOptions<NewNotificationsSubscription, NewNotificationsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewNotificationsSubscription, NewNotificationsSubscriptionVariables>(NewNotificationsDocument, options);
      }
export type NewNotificationsSubscriptionHookResult = ReturnType<typeof useNewNotificationsSubscription>;
export type NewNotificationsSubscriptionResult = Apollo.SubscriptionResult<NewNotificationsSubscription>;
export const ReadNotificationDocument = gql`
    mutation ReadNotification($id: uuid!, $readAt: timestamptz!) {
  update_notifications_by_pk(pk_columns: {id: $id}, _set: {readAt: $readAt}) {
    id
    readAt
  }
}
    `;
export type ReadNotificationMutationFn = Apollo.MutationFunction<ReadNotificationMutation, ReadNotificationMutationVariables>;

/**
 * __useReadNotificationMutation__
 *
 * To run a mutation, you first call `useReadNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readNotificationMutation, { data, loading, error }] = useReadNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      readAt: // value for 'readAt'
 *   },
 * });
 */
export function useReadNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ReadNotificationMutation, ReadNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadNotificationMutation, ReadNotificationMutationVariables>(ReadNotificationDocument, options);
      }
export type ReadNotificationMutationHookResult = ReturnType<typeof useReadNotificationMutation>;
export type ReadNotificationMutationResult = Apollo.MutationResult<ReadNotificationMutation>;
export type ReadNotificationMutationOptions = Apollo.BaseMutationOptions<ReadNotificationMutation, ReadNotificationMutationVariables>;
export const ReadAllNotificationsDocument = gql`
    mutation ReadAllNotifications($readAt: timestamptz!) {
  update_notifications(_set: {readAt: $readAt}, where: {}) {
    returning {
      id
      readAt
    }
  }
}
    `;
export type ReadAllNotificationsMutationFn = Apollo.MutationFunction<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>;

/**
 * __useReadAllNotificationsMutation__
 *
 * To run a mutation, you first call `useReadAllNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadAllNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readAllNotificationsMutation, { data, loading, error }] = useReadAllNotificationsMutation({
 *   variables: {
 *      readAt: // value for 'readAt'
 *   },
 * });
 */
export function useReadAllNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>(ReadAllNotificationsDocument, options);
      }
export type ReadAllNotificationsMutationHookResult = ReturnType<typeof useReadAllNotificationsMutation>;
export type ReadAllNotificationsMutationResult = Apollo.MutationResult<ReadAllNotificationsMutation>;
export type ReadAllNotificationsMutationOptions = Apollo.BaseMutationOptions<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>;
export const ViewAllNotificationsDocument = gql`
    mutation ViewAllNotifications($viewedAt: timestamptz!) {
  update_notifications(_set: {viewedAt: $viewedAt}, where: {}) {
    returning {
      id
      viewedAt
    }
  }
}
    `;
export type ViewAllNotificationsMutationFn = Apollo.MutationFunction<ViewAllNotificationsMutation, ViewAllNotificationsMutationVariables>;

/**
 * __useViewAllNotificationsMutation__
 *
 * To run a mutation, you first call `useViewAllNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useViewAllNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [viewAllNotificationsMutation, { data, loading, error }] = useViewAllNotificationsMutation({
 *   variables: {
 *      viewedAt: // value for 'viewedAt'
 *   },
 * });
 */
export function useViewAllNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ViewAllNotificationsMutation, ViewAllNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ViewAllNotificationsMutation, ViewAllNotificationsMutationVariables>(ViewAllNotificationsDocument, options);
      }
export type ViewAllNotificationsMutationHookResult = ReturnType<typeof useViewAllNotificationsMutation>;
export type ViewAllNotificationsMutationResult = Apollo.MutationResult<ViewAllNotificationsMutation>;
export type ViewAllNotificationsMutationOptions = Apollo.BaseMutationOptions<ViewAllNotificationsMutation, ViewAllNotificationsMutationVariables>;
export const ProvidersDocument = gql`
    query Providers {
  providers {
    id
    category
    name
    email
    phoneNumber
    address
    createdAt
  }
}
    `;

/**
 * __useProvidersQuery__
 *
 * To run a query within a React component, call `useProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useProvidersQuery(baseOptions?: Apollo.QueryHookOptions<ProvidersQuery, ProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProvidersQuery, ProvidersQueryVariables>(ProvidersDocument, options);
      }
export function useProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProvidersQuery, ProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProvidersQuery, ProvidersQueryVariables>(ProvidersDocument, options);
        }
export function useProvidersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProvidersQuery, ProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProvidersQuery, ProvidersQueryVariables>(ProvidersDocument, options);
        }
export type ProvidersQueryHookResult = ReturnType<typeof useProvidersQuery>;
export type ProvidersLazyQueryHookResult = ReturnType<typeof useProvidersLazyQuery>;
export type ProvidersSuspenseQueryHookResult = ReturnType<typeof useProvidersSuspenseQuery>;
export type ProvidersQueryResult = Apollo.QueryResult<ProvidersQuery, ProvidersQueryVariables>;
export const GetCurrentProviderDocument = gql`
    query GetCurrentProvider {
  getCurrentProvider {
    id
    category
    name
    email
    phoneNumber
    address
    slug
    stripeConnectAccId
    visibility
  }
}
    `;

/**
 * __useGetCurrentProviderQuery__
 *
 * To run a query within a React component, call `useGetCurrentProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentProviderQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentProviderQuery, GetCurrentProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentProviderQuery, GetCurrentProviderQueryVariables>(GetCurrentProviderDocument, options);
      }
export function useGetCurrentProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentProviderQuery, GetCurrentProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentProviderQuery, GetCurrentProviderQueryVariables>(GetCurrentProviderDocument, options);
        }
export function useGetCurrentProviderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentProviderQuery, GetCurrentProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentProviderQuery, GetCurrentProviderQueryVariables>(GetCurrentProviderDocument, options);
        }
export type GetCurrentProviderQueryHookResult = ReturnType<typeof useGetCurrentProviderQuery>;
export type GetCurrentProviderLazyQueryHookResult = ReturnType<typeof useGetCurrentProviderLazyQuery>;
export type GetCurrentProviderSuspenseQueryHookResult = ReturnType<typeof useGetCurrentProviderSuspenseQuery>;
export type GetCurrentProviderQueryResult = Apollo.QueryResult<GetCurrentProviderQuery, GetCurrentProviderQueryVariables>;
export const ProviderByIdDocument = gql`
    query ProviderById($id: uuid!) {
  providers_by_pk(id: $id) {
    id
    category
    name
    email
    phoneNumber
    bookingCancelationWarningPeriod
    address
    createdAt
  }
}
    `;

/**
 * __useProviderByIdQuery__
 *
 * To run a query within a React component, call `useProviderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProviderByIdQuery(baseOptions: Apollo.QueryHookOptions<ProviderByIdQuery, ProviderByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderByIdQuery, ProviderByIdQueryVariables>(ProviderByIdDocument, options);
      }
export function useProviderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderByIdQuery, ProviderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderByIdQuery, ProviderByIdQueryVariables>(ProviderByIdDocument, options);
        }
export function useProviderByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProviderByIdQuery, ProviderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderByIdQuery, ProviderByIdQueryVariables>(ProviderByIdDocument, options);
        }
export type ProviderByIdQueryHookResult = ReturnType<typeof useProviderByIdQuery>;
export type ProviderByIdLazyQueryHookResult = ReturnType<typeof useProviderByIdLazyQuery>;
export type ProviderByIdSuspenseQueryHookResult = ReturnType<typeof useProviderByIdSuspenseQuery>;
export type ProviderByIdQueryResult = Apollo.QueryResult<ProviderByIdQuery, ProviderByIdQueryVariables>;
export const FormsDocument = gql`
    query Forms($limit: Int, $offset: Int) {
  form(
    limit: $limit
    offset: $offset
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: desc}
  ) {
    id
    name
    servicesForms(
      where: {status: {_eq: active}, service: {deletedAt: {_is_null: true}}}
      order_by: {createdAt: desc}
    ) {
      service {
        id
        name
      }
    }
    formQuestions_aggregate(where: {deletedAt: {_is_null: true}}) {
      aggregate {
        count
      }
    }
    formQuestions(where: {deletedAt: {_is_null: true}}) {
      id
      description
      label
      mandatory
      name
      order
      questionType
      formQuestionOptions {
        id
        value
      }
    }
  }
  form_aggregate(
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: desc}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useFormsQuery__
 *
 * To run a query within a React component, call `useFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFormsQuery(baseOptions?: Apollo.QueryHookOptions<FormsQuery, FormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormsQuery, FormsQueryVariables>(FormsDocument, options);
      }
export function useFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormsQuery, FormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormsQuery, FormsQueryVariables>(FormsDocument, options);
        }
export function useFormsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FormsQuery, FormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FormsQuery, FormsQueryVariables>(FormsDocument, options);
        }
export type FormsQueryHookResult = ReturnType<typeof useFormsQuery>;
export type FormsLazyQueryHookResult = ReturnType<typeof useFormsLazyQuery>;
export type FormsSuspenseQueryHookResult = ReturnType<typeof useFormsSuspenseQuery>;
export type FormsQueryResult = Apollo.QueryResult<FormsQuery, FormsQueryVariables>;
export const GetFormListByIdDocument = gql`
    query GetFormListById($id: uuid!) {
  form_by_pk(id: $id) {
    id
    createdAt
    deletedAt
    name
    updatedAt
    providerId
  }
  formQuestions(where: {formId: {_eq: $id}, deletedAt: {_is_null: true}}) {
    description
    formId
    id
    label
    mandatory
    name
    order
    questionType
    deletedAt
  }
}
    `;

/**
 * __useGetFormListByIdQuery__
 *
 * To run a query within a React component, call `useGetFormListByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormListByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormListByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFormListByIdQuery(baseOptions: Apollo.QueryHookOptions<GetFormListByIdQuery, GetFormListByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormListByIdQuery, GetFormListByIdQueryVariables>(GetFormListByIdDocument, options);
      }
export function useGetFormListByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormListByIdQuery, GetFormListByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormListByIdQuery, GetFormListByIdQueryVariables>(GetFormListByIdDocument, options);
        }
export function useGetFormListByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFormListByIdQuery, GetFormListByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFormListByIdQuery, GetFormListByIdQueryVariables>(GetFormListByIdDocument, options);
        }
export type GetFormListByIdQueryHookResult = ReturnType<typeof useGetFormListByIdQuery>;
export type GetFormListByIdLazyQueryHookResult = ReturnType<typeof useGetFormListByIdLazyQuery>;
export type GetFormListByIdSuspenseQueryHookResult = ReturnType<typeof useGetFormListByIdSuspenseQuery>;
export type GetFormListByIdQueryResult = Apollo.QueryResult<GetFormListByIdQuery, GetFormListByIdQueryVariables>;
export const GetFormQuestionsDocument = gql`
    query GetFormQuestions($formId: uuid!, $limit: Int, $offset: Int) {
  formQuestions(limit: $limit, offset: $offset, where: {formId: {_eq: $formId}}) {
    id
    name
  }
  formQuestions_aggregate(where: {formId: {_eq: $formId}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetFormQuestionsQuery__
 *
 * To run a query within a React component, call `useGetFormQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormQuestionsQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetFormQuestionsQuery(baseOptions: Apollo.QueryHookOptions<GetFormQuestionsQuery, GetFormQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormQuestionsQuery, GetFormQuestionsQueryVariables>(GetFormQuestionsDocument, options);
      }
export function useGetFormQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormQuestionsQuery, GetFormQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormQuestionsQuery, GetFormQuestionsQueryVariables>(GetFormQuestionsDocument, options);
        }
export function useGetFormQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFormQuestionsQuery, GetFormQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFormQuestionsQuery, GetFormQuestionsQueryVariables>(GetFormQuestionsDocument, options);
        }
export type GetFormQuestionsQueryHookResult = ReturnType<typeof useGetFormQuestionsQuery>;
export type GetFormQuestionsLazyQueryHookResult = ReturnType<typeof useGetFormQuestionsLazyQuery>;
export type GetFormQuestionsSuspenseQueryHookResult = ReturnType<typeof useGetFormQuestionsSuspenseQuery>;
export type GetFormQuestionsQueryResult = Apollo.QueryResult<GetFormQuestionsQuery, GetFormQuestionsQueryVariables>;
export const CreateFormDocument = gql`
    mutation CreateForm($name: String!, $questions: [formQuestions_insert_input!]!) {
  insert_form_one(object: {name: $name, formQuestions: {data: $questions}}) {
    id
    name
    formQuestions {
      id
      description
      formId
      label
      mandatory
      name
      order
      questionType
      formQuestionOptions {
        id
        value
      }
    }
  }
}
    `;
export type CreateFormMutationFn = Apollo.MutationFunction<CreateFormMutation, CreateFormMutationVariables>;

/**
 * __useCreateFormMutation__
 *
 * To run a mutation, you first call `useCreateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormMutation, { data, loading, error }] = useCreateFormMutation({
 *   variables: {
 *      name: // value for 'name'
 *      questions: // value for 'questions'
 *   },
 * });
 */
export function useCreateFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormMutation, CreateFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormMutation, CreateFormMutationVariables>(CreateFormDocument, options);
      }
export type CreateFormMutationHookResult = ReturnType<typeof useCreateFormMutation>;
export type CreateFormMutationResult = Apollo.MutationResult<CreateFormMutation>;
export type CreateFormMutationOptions = Apollo.BaseMutationOptions<CreateFormMutation, CreateFormMutationVariables>;
export const UpdateFormNameDocument = gql`
    mutation UpdateFormName($id: uuid!, $name: String!) {
  update_form_by_pk(pk_columns: {id: $id}, _set: {name: $name}) {
    id
    name
  }
}
    `;
export type UpdateFormNameMutationFn = Apollo.MutationFunction<UpdateFormNameMutation, UpdateFormNameMutationVariables>;

/**
 * __useUpdateFormNameMutation__
 *
 * To run a mutation, you first call `useUpdateFormNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormNameMutation, { data, loading, error }] = useUpdateFormNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateFormNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormNameMutation, UpdateFormNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormNameMutation, UpdateFormNameMutationVariables>(UpdateFormNameDocument, options);
      }
export type UpdateFormNameMutationHookResult = ReturnType<typeof useUpdateFormNameMutation>;
export type UpdateFormNameMutationResult = Apollo.MutationResult<UpdateFormNameMutation>;
export type UpdateFormNameMutationOptions = Apollo.BaseMutationOptions<UpdateFormNameMutation, UpdateFormNameMutationVariables>;
export const UpdateFormDocument = gql`
    mutation UpdateForm($deletedFormQuestionsIds: [uuid!]!, $input: [formQuestions_insert_input!]!) {
  deletedFormQuestions: update_formQuestions(
    where: {id: {_in: $deletedFormQuestionsIds}}
    _set: {deletedAt: "now()"}
  ) {
    returning {
      id
      deletedAt
    }
  }
  createdFormQuestions: insert_formQuestions(objects: $input) {
    returning {
      id
      formId
      description
      label
      mandatory
      name
      order
      questionType
      formQuestionOptions {
        id
        formQuestionId
        value
      }
    }
  }
}
    `;
export type UpdateFormMutationFn = Apollo.MutationFunction<UpdateFormMutation, UpdateFormMutationVariables>;

/**
 * __useUpdateFormMutation__
 *
 * To run a mutation, you first call `useUpdateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormMutation, { data, loading, error }] = useUpdateFormMutation({
 *   variables: {
 *      deletedFormQuestionsIds: // value for 'deletedFormQuestionsIds'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormMutation, UpdateFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormMutation, UpdateFormMutationVariables>(UpdateFormDocument, options);
      }
export type UpdateFormMutationHookResult = ReturnType<typeof useUpdateFormMutation>;
export type UpdateFormMutationResult = Apollo.MutationResult<UpdateFormMutation>;
export type UpdateFormMutationOptions = Apollo.BaseMutationOptions<UpdateFormMutation, UpdateFormMutationVariables>;
export const GetFormActiveServicesDocument = gql`
    query GetFormActiveServices($id: uuid!) {
  form_by_pk(id: $id) {
    id
    name
    servicesForms(where: {status: {_eq: active}}, order_by: {createdAt: desc}) {
      id
      status
    }
  }
}
    `;

/**
 * __useGetFormActiveServicesQuery__
 *
 * To run a query within a React component, call `useGetFormActiveServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormActiveServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormActiveServicesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFormActiveServicesQuery(baseOptions: Apollo.QueryHookOptions<GetFormActiveServicesQuery, GetFormActiveServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormActiveServicesQuery, GetFormActiveServicesQueryVariables>(GetFormActiveServicesDocument, options);
      }
export function useGetFormActiveServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormActiveServicesQuery, GetFormActiveServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormActiveServicesQuery, GetFormActiveServicesQueryVariables>(GetFormActiveServicesDocument, options);
        }
export function useGetFormActiveServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFormActiveServicesQuery, GetFormActiveServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFormActiveServicesQuery, GetFormActiveServicesQueryVariables>(GetFormActiveServicesDocument, options);
        }
export type GetFormActiveServicesQueryHookResult = ReturnType<typeof useGetFormActiveServicesQuery>;
export type GetFormActiveServicesLazyQueryHookResult = ReturnType<typeof useGetFormActiveServicesLazyQuery>;
export type GetFormActiveServicesSuspenseQueryHookResult = ReturnType<typeof useGetFormActiveServicesSuspenseQuery>;
export type GetFormActiveServicesQueryResult = Apollo.QueryResult<GetFormActiveServicesQuery, GetFormActiveServicesQueryVariables>;
export const DeleteFormDocument = gql`
    mutation DeleteForm($id: uuid!) {
  deletedForm: update_form_by_pk(pk_columns: {id: $id}, _set: {deletedAt: "now"}) {
    id
    deletedAt
  }
  deletedServiceForms: delete_servicesForms(where: {formId: {_eq: $id}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteFormMutationFn = Apollo.MutationFunction<DeleteFormMutation, DeleteFormMutationVariables>;

/**
 * __useDeleteFormMutation__
 *
 * To run a mutation, you first call `useDeleteFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormMutation, { data, loading, error }] = useDeleteFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFormMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFormMutation, DeleteFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFormMutation, DeleteFormMutationVariables>(DeleteFormDocument, options);
      }
export type DeleteFormMutationHookResult = ReturnType<typeof useDeleteFormMutation>;
export type DeleteFormMutationResult = Apollo.MutationResult<DeleteFormMutation>;
export type DeleteFormMutationOptions = Apollo.BaseMutationOptions<DeleteFormMutation, DeleteFormMutationVariables>;
export const CreateServiceFormsDocument = gql`
    mutation CreateServiceForms($name: String!, $providerId: uuid!, $questions: [formQuestions_insert_input!]!) {
  insert_form_one(
    object: {name: $name, providerId: $providerId, formQuestions: {data: $questions}}
  ) {
    id
    name
    formQuestions {
      description
      label
      mandatory
      name
      order
      questionType
    }
  }
}
    `;
export type CreateServiceFormsMutationFn = Apollo.MutationFunction<CreateServiceFormsMutation, CreateServiceFormsMutationVariables>;

/**
 * __useCreateServiceFormsMutation__
 *
 * To run a mutation, you first call `useCreateServiceFormsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceFormsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceFormsMutation, { data, loading, error }] = useCreateServiceFormsMutation({
 *   variables: {
 *      name: // value for 'name'
 *      providerId: // value for 'providerId'
 *      questions: // value for 'questions'
 *   },
 * });
 */
export function useCreateServiceFormsMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceFormsMutation, CreateServiceFormsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceFormsMutation, CreateServiceFormsMutationVariables>(CreateServiceFormsDocument, options);
      }
export type CreateServiceFormsMutationHookResult = ReturnType<typeof useCreateServiceFormsMutation>;
export type CreateServiceFormsMutationResult = Apollo.MutationResult<CreateServiceFormsMutation>;
export type CreateServiceFormsMutationOptions = Apollo.BaseMutationOptions<CreateServiceFormsMutation, CreateServiceFormsMutationVariables>;
export const UpdateFormListByIdDocument = gql`
    mutation UpdateFormListById($id: uuid!, $name: String!, $questions: [formQuestions_insert_input!]!) {
  update_form_by_pk(pk_columns: {id: $id}, _set: {name: $name}) {
    id
    name
    updatedAt
    deletedAt
    createdAt
  }
  insert_formQuestions(
    objects: $questions
    on_conflict: {constraint: formQuestions_pkey, update_columns: [name, description, order, label, questionType, mandatory, deletedAt]}
  ) {
    affected_rows
  }
}
    `;
export type UpdateFormListByIdMutationFn = Apollo.MutationFunction<UpdateFormListByIdMutation, UpdateFormListByIdMutationVariables>;

/**
 * __useUpdateFormListByIdMutation__
 *
 * To run a mutation, you first call `useUpdateFormListByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormListByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormListByIdMutation, { data, loading, error }] = useUpdateFormListByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      questions: // value for 'questions'
 *   },
 * });
 */
export function useUpdateFormListByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormListByIdMutation, UpdateFormListByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormListByIdMutation, UpdateFormListByIdMutationVariables>(UpdateFormListByIdDocument, options);
      }
export type UpdateFormListByIdMutationHookResult = ReturnType<typeof useUpdateFormListByIdMutation>;
export type UpdateFormListByIdMutationResult = Apollo.MutationResult<UpdateFormListByIdMutation>;
export type UpdateFormListByIdMutationOptions = Apollo.BaseMutationOptions<UpdateFormListByIdMutation, UpdateFormListByIdMutationVariables>;
export const CreateStripeConnectedAccountDocument = gql`
    mutation CreateStripeConnectedAccount {
  createConnectedAccount {
    created
    expires_at
    object
    url
  }
}
    `;
export type CreateStripeConnectedAccountMutationFn = Apollo.MutationFunction<CreateStripeConnectedAccountMutation, CreateStripeConnectedAccountMutationVariables>;

/**
 * __useCreateStripeConnectedAccountMutation__
 *
 * To run a mutation, you first call `useCreateStripeConnectedAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeConnectedAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeConnectedAccountMutation, { data, loading, error }] = useCreateStripeConnectedAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateStripeConnectedAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripeConnectedAccountMutation, CreateStripeConnectedAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripeConnectedAccountMutation, CreateStripeConnectedAccountMutationVariables>(CreateStripeConnectedAccountDocument, options);
      }
export type CreateStripeConnectedAccountMutationHookResult = ReturnType<typeof useCreateStripeConnectedAccountMutation>;
export type CreateStripeConnectedAccountMutationResult = Apollo.MutationResult<CreateStripeConnectedAccountMutation>;
export type CreateStripeConnectedAccountMutationOptions = Apollo.BaseMutationOptions<CreateStripeConnectedAccountMutation, CreateStripeConnectedAccountMutationVariables>;
export const IsStripeOnboardingCompletedDocument = gql`
    query IsStripeOnboardingCompleted {
  isOnboardingCompleted {
    onboardingCompleted
    businessAcc
    payoutsSchedule {
      delayDays
      interval
    }
    companyAddress {
      country
      state
      city
      address
    }
  }
}
    `;

/**
 * __useIsStripeOnboardingCompletedQuery__
 *
 * To run a query within a React component, call `useIsStripeOnboardingCompletedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsStripeOnboardingCompletedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsStripeOnboardingCompletedQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsStripeOnboardingCompletedQuery(baseOptions?: Apollo.QueryHookOptions<IsStripeOnboardingCompletedQuery, IsStripeOnboardingCompletedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsStripeOnboardingCompletedQuery, IsStripeOnboardingCompletedQueryVariables>(IsStripeOnboardingCompletedDocument, options);
      }
export function useIsStripeOnboardingCompletedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsStripeOnboardingCompletedQuery, IsStripeOnboardingCompletedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsStripeOnboardingCompletedQuery, IsStripeOnboardingCompletedQueryVariables>(IsStripeOnboardingCompletedDocument, options);
        }
export function useIsStripeOnboardingCompletedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsStripeOnboardingCompletedQuery, IsStripeOnboardingCompletedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsStripeOnboardingCompletedQuery, IsStripeOnboardingCompletedQueryVariables>(IsStripeOnboardingCompletedDocument, options);
        }
export type IsStripeOnboardingCompletedQueryHookResult = ReturnType<typeof useIsStripeOnboardingCompletedQuery>;
export type IsStripeOnboardingCompletedLazyQueryHookResult = ReturnType<typeof useIsStripeOnboardingCompletedLazyQuery>;
export type IsStripeOnboardingCompletedSuspenseQueryHookResult = ReturnType<typeof useIsStripeOnboardingCompletedSuspenseQuery>;
export type IsStripeOnboardingCompletedQueryResult = Apollo.QueryResult<IsStripeOnboardingCompletedQuery, IsStripeOnboardingCompletedQueryVariables>;
export const ProviderEmployeesDocument = gql`
    query ProviderEmployees($searchByName: String!, $limit: Int!, $offset: Int!) {
  userRoles_aggregate(
    where: {role: {_in: [employee, provider]}, user: {name: {_ilike: $searchByName}}, deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
  userRoles(
    where: {role: {_in: [employee, provider]}, user: {name: {_ilike: $searchByName}}, deletedAt: {_is_null: true}}
    limit: $limit
    offset: $offset
    order_by: {user: {name: asc}}
  ) {
    user {
      id
      name
      email
      phoneNumber
      profilePicture {
        id
        name
      }
      serviceEmployeesByUserid {
        serviceId
      }
    }
  }
}
    `;

/**
 * __useProviderEmployeesQuery__
 *
 * To run a query within a React component, call `useProviderEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderEmployeesQuery({
 *   variables: {
 *      searchByName: // value for 'searchByName'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useProviderEmployeesQuery(baseOptions: Apollo.QueryHookOptions<ProviderEmployeesQuery, ProviderEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderEmployeesQuery, ProviderEmployeesQueryVariables>(ProviderEmployeesDocument, options);
      }
export function useProviderEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderEmployeesQuery, ProviderEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderEmployeesQuery, ProviderEmployeesQueryVariables>(ProviderEmployeesDocument, options);
        }
export function useProviderEmployeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProviderEmployeesQuery, ProviderEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderEmployeesQuery, ProviderEmployeesQueryVariables>(ProviderEmployeesDocument, options);
        }
export type ProviderEmployeesQueryHookResult = ReturnType<typeof useProviderEmployeesQuery>;
export type ProviderEmployeesLazyQueryHookResult = ReturnType<typeof useProviderEmployeesLazyQuery>;
export type ProviderEmployeesSuspenseQueryHookResult = ReturnType<typeof useProviderEmployeesSuspenseQuery>;
export type ProviderEmployeesQueryResult = Apollo.QueryResult<ProviderEmployeesQuery, ProviderEmployeesQueryVariables>;
export const ServicePicturesDocument = gql`
    query ServicePictures($serviceId: uuid!, $limit: Int!, $offset: Int!) {
  servicePictures(
    where: {serviceId: {_eq: $serviceId}}
    limit: $limit
    offset: $offset
  ) {
    id
    name
    file {
      id
      name
      uploadName
    }
    size
  }
  servicePictures_aggregate {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useServicePicturesQuery__
 *
 * To run a query within a React component, call `useServicePicturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicePicturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicePicturesQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useServicePicturesQuery(baseOptions: Apollo.QueryHookOptions<ServicePicturesQuery, ServicePicturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServicePicturesQuery, ServicePicturesQueryVariables>(ServicePicturesDocument, options);
      }
export function useServicePicturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServicePicturesQuery, ServicePicturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServicePicturesQuery, ServicePicturesQueryVariables>(ServicePicturesDocument, options);
        }
export function useServicePicturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServicePicturesQuery, ServicePicturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServicePicturesQuery, ServicePicturesQueryVariables>(ServicePicturesDocument, options);
        }
export type ServicePicturesQueryHookResult = ReturnType<typeof useServicePicturesQuery>;
export type ServicePicturesLazyQueryHookResult = ReturnType<typeof useServicePicturesLazyQuery>;
export type ServicePicturesSuspenseQueryHookResult = ReturnType<typeof useServicePicturesSuspenseQuery>;
export type ServicePicturesQueryResult = Apollo.QueryResult<ServicePicturesQuery, ServicePicturesQueryVariables>;
export const AddServicePicturesDocument = gql`
    mutation AddServicePictures($servicePictures: [servicePictures_insert_input!]!) {
  insert_servicePictures(objects: $servicePictures) {
    returning {
      id
      name
      size
      file {
        id
        name
        uploadName
      }
    }
  }
}
    `;
export type AddServicePicturesMutationFn = Apollo.MutationFunction<AddServicePicturesMutation, AddServicePicturesMutationVariables>;

/**
 * __useAddServicePicturesMutation__
 *
 * To run a mutation, you first call `useAddServicePicturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddServicePicturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addServicePicturesMutation, { data, loading, error }] = useAddServicePicturesMutation({
 *   variables: {
 *      servicePictures: // value for 'servicePictures'
 *   },
 * });
 */
export function useAddServicePicturesMutation(baseOptions?: Apollo.MutationHookOptions<AddServicePicturesMutation, AddServicePicturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddServicePicturesMutation, AddServicePicturesMutationVariables>(AddServicePicturesDocument, options);
      }
export type AddServicePicturesMutationHookResult = ReturnType<typeof useAddServicePicturesMutation>;
export type AddServicePicturesMutationResult = Apollo.MutationResult<AddServicePicturesMutation>;
export type AddServicePicturesMutationOptions = Apollo.BaseMutationOptions<AddServicePicturesMutation, AddServicePicturesMutationVariables>;
export const DeleteServicePicturesDocument = gql`
    mutation DeleteServicePictures($servicePicturesIds: [uuid!]!) {
  delete_servicePictures(where: {id: {_in: $servicePicturesIds}}) {
    returning {
      id
      name
      file {
        id
        name
        uploadName
      }
      size
    }
  }
}
    `;
export type DeleteServicePicturesMutationFn = Apollo.MutationFunction<DeleteServicePicturesMutation, DeleteServicePicturesMutationVariables>;

/**
 * __useDeleteServicePicturesMutation__
 *
 * To run a mutation, you first call `useDeleteServicePicturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServicePicturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServicePicturesMutation, { data, loading, error }] = useDeleteServicePicturesMutation({
 *   variables: {
 *      servicePicturesIds: // value for 'servicePicturesIds'
 *   },
 * });
 */
export function useDeleteServicePicturesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServicePicturesMutation, DeleteServicePicturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServicePicturesMutation, DeleteServicePicturesMutationVariables>(DeleteServicePicturesDocument, options);
      }
export type DeleteServicePicturesMutationHookResult = ReturnType<typeof useDeleteServicePicturesMutation>;
export type DeleteServicePicturesMutationResult = Apollo.MutationResult<DeleteServicePicturesMutation>;
export type DeleteServicePicturesMutationOptions = Apollo.BaseMutationOptions<DeleteServicePicturesMutation, DeleteServicePicturesMutationVariables>;
export const GetCustomersDocument = gql`
    query GetCustomers($limit: Int, $offset: Int, $searchByName: String!, $providerId: uuid!) {
  customers(
    where: {_and: [{_or: [{name: {_ilike: $searchByName}}, {user: {name: {_ilike: $searchByName}}}]}, {_or: [{providerId: {_eq: $providerId}}, {appointments: {service: {providerId: {_eq: $providerId}}}}]}]}
    limit: $limit
    offset: $offset
    order_by: {name: asc_nulls_last, user: {name: asc_nulls_last}}
  ) {
    id
    name
    email
    isBlocked
    address
    phoneNumber
    providerId
    user {
      id
      name
      email
      profilePicture {
        id
        name
      }
      phoneNumber
      address
    }
    bookings: appointments_aggregate {
      aggregate {
        count
      }
    }
    amountSpent {
      amount
    }
  }
  customers_aggregate(
    where: {_and: [{_or: [{name: {_ilike: $searchByName}}, {user: {name: {_ilike: $searchByName}}}]}, {_or: [{providerId: {_eq: $providerId}}, {appointments: {service: {providerId: {_eq: $providerId}}}}]}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetCustomersQuery__
 *
 * To run a query within a React component, call `useGetCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchByName: // value for 'searchByName'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useGetCustomersQuery(baseOptions: Apollo.QueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
      }
export function useGetCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
        }
export function useGetCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
        }
export type GetCustomersQueryHookResult = ReturnType<typeof useGetCustomersQuery>;
export type GetCustomersLazyQueryHookResult = ReturnType<typeof useGetCustomersLazyQuery>;
export type GetCustomersSuspenseQueryHookResult = ReturnType<typeof useGetCustomersSuspenseQuery>;
export type GetCustomersQueryResult = Apollo.QueryResult<GetCustomersQuery, GetCustomersQueryVariables>;
export const GetProviderAndPartneredBmCustomersDocument = gql`
    query GetProviderAndPartneredBMCustomers($limit: Int, $offset: Int, $searchByName: String!) {
  customers(
    where: {_or: [{name: {_ilike: $searchByName}}, {user: {name: {_ilike: $searchByName}}}]}
    limit: $limit
    offset: $offset
    order_by: {name: asc_nulls_last, user: {name: asc_nulls_last}}
  ) {
    id
    name
    email
    isBlocked
    address
    coordinates
    apartmentNumber
    userId
    phoneNumber
    location {
      id
      name
      address
    }
    user {
      id
      name
      email
      profilePicture {
        id
        name
      }
      phoneNumber
      address
      coordinates
      apartmentNumber
    }
    bookings: appointments_aggregate {
      aggregate {
        count
      }
    }
    amountSpent {
      amount
    }
  }
  customers_aggregate(
    where: {_or: [{name: {_ilike: $searchByName}}, {user: {name: {_ilike: $searchByName}}}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetProviderAndPartneredBmCustomersQuery__
 *
 * To run a query within a React component, call `useGetProviderAndPartneredBmCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderAndPartneredBmCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderAndPartneredBmCustomersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchByName: // value for 'searchByName'
 *   },
 * });
 */
export function useGetProviderAndPartneredBmCustomersQuery(baseOptions: Apollo.QueryHookOptions<GetProviderAndPartneredBmCustomersQuery, GetProviderAndPartneredBmCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderAndPartneredBmCustomersQuery, GetProviderAndPartneredBmCustomersQueryVariables>(GetProviderAndPartneredBmCustomersDocument, options);
      }
export function useGetProviderAndPartneredBmCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderAndPartneredBmCustomersQuery, GetProviderAndPartneredBmCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderAndPartneredBmCustomersQuery, GetProviderAndPartneredBmCustomersQueryVariables>(GetProviderAndPartneredBmCustomersDocument, options);
        }
export function useGetProviderAndPartneredBmCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProviderAndPartneredBmCustomersQuery, GetProviderAndPartneredBmCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProviderAndPartneredBmCustomersQuery, GetProviderAndPartneredBmCustomersQueryVariables>(GetProviderAndPartneredBmCustomersDocument, options);
        }
export type GetProviderAndPartneredBmCustomersQueryHookResult = ReturnType<typeof useGetProviderAndPartneredBmCustomersQuery>;
export type GetProviderAndPartneredBmCustomersLazyQueryHookResult = ReturnType<typeof useGetProviderAndPartneredBmCustomersLazyQuery>;
export type GetProviderAndPartneredBmCustomersSuspenseQueryHookResult = ReturnType<typeof useGetProviderAndPartneredBmCustomersSuspenseQuery>;
export type GetProviderAndPartneredBmCustomersQueryResult = Apollo.QueryResult<GetProviderAndPartneredBmCustomersQuery, GetProviderAndPartneredBmCustomersQueryVariables>;
export const GetCustomersStatsDocument = gql`
    query GetCustomersStats($paymentStartDate: timestamptz, $paymentEndDate: timestamptz, $providerId: uuid!) {
  payments_aggregate(
    where: {createdAt: {_gte: $paymentStartDate, _lte: $paymentEndDate}, status: {_neq: cancelled}}
  ) {
    aggregate {
      sum {
        amount
      }
    }
  }
  appointments_aggregate {
    aggregate {
      count
    }
  }
  customers_aggregate(
    where: {_or: [{providerId: {_eq: $providerId}}, {appointments: {service: {providerId: {_eq: $providerId}}}}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetCustomersStatsQuery__
 *
 * To run a query within a React component, call `useGetCustomersStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersStatsQuery({
 *   variables: {
 *      paymentStartDate: // value for 'paymentStartDate'
 *      paymentEndDate: // value for 'paymentEndDate'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useGetCustomersStatsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomersStatsQuery, GetCustomersStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomersStatsQuery, GetCustomersStatsQueryVariables>(GetCustomersStatsDocument, options);
      }
export function useGetCustomersStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomersStatsQuery, GetCustomersStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomersStatsQuery, GetCustomersStatsQueryVariables>(GetCustomersStatsDocument, options);
        }
export function useGetCustomersStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomersStatsQuery, GetCustomersStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomersStatsQuery, GetCustomersStatsQueryVariables>(GetCustomersStatsDocument, options);
        }
export type GetCustomersStatsQueryHookResult = ReturnType<typeof useGetCustomersStatsQuery>;
export type GetCustomersStatsLazyQueryHookResult = ReturnType<typeof useGetCustomersStatsLazyQuery>;
export type GetCustomersStatsSuspenseQueryHookResult = ReturnType<typeof useGetCustomersStatsSuspenseQuery>;
export type GetCustomersStatsQueryResult = Apollo.QueryResult<GetCustomersStatsQuery, GetCustomersStatsQueryVariables>;
export const ProviderDataDocument = gql`
    query ProviderData($providerId: uuid!, $picturesLimit: Int!, $picturesOffset: Int!, $blockedCustomersLimit: Int!, $blockedCustomersOffset: Int!) {
  providers_by_pk(id: $providerId) {
    id
    slug
    address
    email
    name
    description
    phoneNumber
    stripeConnectAccId
    stripeClientSecret
    stripePaymentMethodId
    bookingDefaultStatus
    bookingCancelationWarningPeriod
    providerPictureByProfilePic {
      id
      name
      file {
        id
        name
        uploadName
      }
    }
    providerPictureByCoverPic {
      id
      name
      file {
        id
        name
        uploadName
      }
    }
    providerPictures(limit: $picturesLimit, offset: $picturesOffset) {
      id
      name
      file {
        id
        name
        uploadName
      }
    }
    providerPictures_aggregate {
      aggregate {
        count
      }
    }
    blockedCustomers: customers(
      where: {isBlocked: {_eq: true}}
      limit: $blockedCustomersLimit
      offset: $blockedCustomersOffset
    ) {
      id
      name
      address
      user {
        name
        email
        profilePicture {
          id
          name
        }
      }
      bookings: appointments_aggregate {
        aggregate {
          count
        }
      }
      amountSpent {
        amount
      }
    }
    blockedCustomersAggregate: customers_aggregate(where: {isBlocked: {_eq: true}}) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useProviderDataQuery__
 *
 * To run a query within a React component, call `useProviderDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderDataQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      picturesLimit: // value for 'picturesLimit'
 *      picturesOffset: // value for 'picturesOffset'
 *      blockedCustomersLimit: // value for 'blockedCustomersLimit'
 *      blockedCustomersOffset: // value for 'blockedCustomersOffset'
 *   },
 * });
 */
export function useProviderDataQuery(baseOptions: Apollo.QueryHookOptions<ProviderDataQuery, ProviderDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderDataQuery, ProviderDataQueryVariables>(ProviderDataDocument, options);
      }
export function useProviderDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderDataQuery, ProviderDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderDataQuery, ProviderDataQueryVariables>(ProviderDataDocument, options);
        }
export function useProviderDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProviderDataQuery, ProviderDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderDataQuery, ProviderDataQueryVariables>(ProviderDataDocument, options);
        }
export type ProviderDataQueryHookResult = ReturnType<typeof useProviderDataQuery>;
export type ProviderDataLazyQueryHookResult = ReturnType<typeof useProviderDataLazyQuery>;
export type ProviderDataSuspenseQueryHookResult = ReturnType<typeof useProviderDataSuspenseQuery>;
export type ProviderDataQueryResult = Apollo.QueryResult<ProviderDataQuery, ProviderDataQueryVariables>;
export const AddProviderPictureDocument = gql`
    mutation AddProviderPicture($providerId: uuid!, $fileId: uuid!, $name: String!) {
  insert_providerPictures_one(
    object: {providerId: $providerId, fileId: $fileId, name: $name}
  ) {
    id
    name
    file {
      id
      name
    }
  }
}
    `;
export type AddProviderPictureMutationFn = Apollo.MutationFunction<AddProviderPictureMutation, AddProviderPictureMutationVariables>;

/**
 * __useAddProviderPictureMutation__
 *
 * To run a mutation, you first call `useAddProviderPictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProviderPictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProviderPictureMutation, { data, loading, error }] = useAddProviderPictureMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      fileId: // value for 'fileId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAddProviderPictureMutation(baseOptions?: Apollo.MutationHookOptions<AddProviderPictureMutation, AddProviderPictureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProviderPictureMutation, AddProviderPictureMutationVariables>(AddProviderPictureDocument, options);
      }
export type AddProviderPictureMutationHookResult = ReturnType<typeof useAddProviderPictureMutation>;
export type AddProviderPictureMutationResult = Apollo.MutationResult<AddProviderPictureMutation>;
export type AddProviderPictureMutationOptions = Apollo.BaseMutationOptions<AddProviderPictureMutation, AddProviderPictureMutationVariables>;
export const AddProviderProfilePicDocument = gql`
    mutation AddProviderProfilePic($providerId: uuid!, $providerPictureId: uuid!) {
  update_providers_by_pk(
    pk_columns: {id: $providerId}
    _set: {profilePic: $providerPictureId}
  ) {
    id
    address
    email
    name
    phoneNumber
    providerPictureByProfilePic {
      id
      name
      file {
        id
        name
        uploadName
      }
    }
    providerPictureByCoverPic {
      id
      name
      file {
        id
        name
        uploadName
      }
    }
    providerPictures_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;
export type AddProviderProfilePicMutationFn = Apollo.MutationFunction<AddProviderProfilePicMutation, AddProviderProfilePicMutationVariables>;

/**
 * __useAddProviderProfilePicMutation__
 *
 * To run a mutation, you first call `useAddProviderProfilePicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProviderProfilePicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProviderProfilePicMutation, { data, loading, error }] = useAddProviderProfilePicMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      providerPictureId: // value for 'providerPictureId'
 *   },
 * });
 */
export function useAddProviderProfilePicMutation(baseOptions?: Apollo.MutationHookOptions<AddProviderProfilePicMutation, AddProviderProfilePicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProviderProfilePicMutation, AddProviderProfilePicMutationVariables>(AddProviderProfilePicDocument, options);
      }
export type AddProviderProfilePicMutationHookResult = ReturnType<typeof useAddProviderProfilePicMutation>;
export type AddProviderProfilePicMutationResult = Apollo.MutationResult<AddProviderProfilePicMutation>;
export type AddProviderProfilePicMutationOptions = Apollo.BaseMutationOptions<AddProviderProfilePicMutation, AddProviderProfilePicMutationVariables>;
export const AddProviderCoverPicDocument = gql`
    mutation AddProviderCoverPic($providerId: uuid!, $providerPictureId: uuid!) {
  update_providers_by_pk(
    pk_columns: {id: $providerId}
    _set: {coverPic: $providerPictureId}
  ) {
    id
    address
    email
    name
    phoneNumber
    providerPictureByProfilePic {
      id
      name
      file {
        id
        name
        uploadName
      }
    }
    providerPictureByCoverPic {
      id
      name
      file {
        id
        name
        uploadName
      }
    }
    providerPictures_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;
export type AddProviderCoverPicMutationFn = Apollo.MutationFunction<AddProviderCoverPicMutation, AddProviderCoverPicMutationVariables>;

/**
 * __useAddProviderCoverPicMutation__
 *
 * To run a mutation, you first call `useAddProviderCoverPicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProviderCoverPicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProviderCoverPicMutation, { data, loading, error }] = useAddProviderCoverPicMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      providerPictureId: // value for 'providerPictureId'
 *   },
 * });
 */
export function useAddProviderCoverPicMutation(baseOptions?: Apollo.MutationHookOptions<AddProviderCoverPicMutation, AddProviderCoverPicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProviderCoverPicMutation, AddProviderCoverPicMutationVariables>(AddProviderCoverPicDocument, options);
      }
export type AddProviderCoverPicMutationHookResult = ReturnType<typeof useAddProviderCoverPicMutation>;
export type AddProviderCoverPicMutationResult = Apollo.MutationResult<AddProviderCoverPicMutation>;
export type AddProviderCoverPicMutationOptions = Apollo.BaseMutationOptions<AddProviderCoverPicMutation, AddProviderCoverPicMutationVariables>;
export const DeleteProviderProfilePicDocument = gql`
    mutation DeleteProviderProfilePic($providerId: uuid!, $providerPictureId: uuid!) {
  update_providers_by_pk(pk_columns: {id: $providerId}, _set: {profilePic: null}) {
    id
    address
    email
    name
    phoneNumber
    providerPictureByProfilePic {
      id
      name
      file {
        id
        name
        uploadName
      }
    }
    providerPictureByCoverPic {
      id
      name
      file {
        id
        name
        uploadName
      }
    }
    providerPictures_aggregate {
      aggregate {
        count
      }
    }
  }
  delete_providerPictures_by_pk(id: $providerPictureId) {
    id
  }
}
    `;
export type DeleteProviderProfilePicMutationFn = Apollo.MutationFunction<DeleteProviderProfilePicMutation, DeleteProviderProfilePicMutationVariables>;

/**
 * __useDeleteProviderProfilePicMutation__
 *
 * To run a mutation, you first call `useDeleteProviderProfilePicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderProfilePicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderProfilePicMutation, { data, loading, error }] = useDeleteProviderProfilePicMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      providerPictureId: // value for 'providerPictureId'
 *   },
 * });
 */
export function useDeleteProviderProfilePicMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProviderProfilePicMutation, DeleteProviderProfilePicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProviderProfilePicMutation, DeleteProviderProfilePicMutationVariables>(DeleteProviderProfilePicDocument, options);
      }
export type DeleteProviderProfilePicMutationHookResult = ReturnType<typeof useDeleteProviderProfilePicMutation>;
export type DeleteProviderProfilePicMutationResult = Apollo.MutationResult<DeleteProviderProfilePicMutation>;
export type DeleteProviderProfilePicMutationOptions = Apollo.BaseMutationOptions<DeleteProviderProfilePicMutation, DeleteProviderProfilePicMutationVariables>;
export const DeleteProviderCoverPicDocument = gql`
    mutation DeleteProviderCoverPic($providerId: uuid!, $providerPictureId: uuid!) {
  update_providers_by_pk(pk_columns: {id: $providerId}, _set: {coverPic: null}) {
    id
    address
    email
    name
    phoneNumber
    providerPictureByProfilePic {
      id
      name
      file {
        id
        name
        uploadName
      }
    }
    providerPictureByCoverPic {
      id
      name
      file {
        id
        name
        uploadName
      }
    }
    providerPictures_aggregate {
      aggregate {
        count
      }
    }
  }
  delete_providerPictures_by_pk(id: $providerPictureId) {
    id
  }
}
    `;
export type DeleteProviderCoverPicMutationFn = Apollo.MutationFunction<DeleteProviderCoverPicMutation, DeleteProviderCoverPicMutationVariables>;

/**
 * __useDeleteProviderCoverPicMutation__
 *
 * To run a mutation, you first call `useDeleteProviderCoverPicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderCoverPicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderCoverPicMutation, { data, loading, error }] = useDeleteProviderCoverPicMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      providerPictureId: // value for 'providerPictureId'
 *   },
 * });
 */
export function useDeleteProviderCoverPicMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProviderCoverPicMutation, DeleteProviderCoverPicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProviderCoverPicMutation, DeleteProviderCoverPicMutationVariables>(DeleteProviderCoverPicDocument, options);
      }
export type DeleteProviderCoverPicMutationHookResult = ReturnType<typeof useDeleteProviderCoverPicMutation>;
export type DeleteProviderCoverPicMutationResult = Apollo.MutationResult<DeleteProviderCoverPicMutation>;
export type DeleteProviderCoverPicMutationOptions = Apollo.BaseMutationOptions<DeleteProviderCoverPicMutation, DeleteProviderCoverPicMutationVariables>;
export const DeleteProviderPicturesDocument = gql`
    mutation DeleteProviderPictures($providerPicturesIds: [uuid!]!) {
  delete_providerPictures(where: {id: {_in: $providerPicturesIds}}) {
    returning {
      id
      name
      file {
        id
        name
        uploadName
      }
    }
  }
}
    `;
export type DeleteProviderPicturesMutationFn = Apollo.MutationFunction<DeleteProviderPicturesMutation, DeleteProviderPicturesMutationVariables>;

/**
 * __useDeleteProviderPicturesMutation__
 *
 * To run a mutation, you first call `useDeleteProviderPicturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderPicturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderPicturesMutation, { data, loading, error }] = useDeleteProviderPicturesMutation({
 *   variables: {
 *      providerPicturesIds: // value for 'providerPicturesIds'
 *   },
 * });
 */
export function useDeleteProviderPicturesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProviderPicturesMutation, DeleteProviderPicturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProviderPicturesMutation, DeleteProviderPicturesMutationVariables>(DeleteProviderPicturesDocument, options);
      }
export type DeleteProviderPicturesMutationHookResult = ReturnType<typeof useDeleteProviderPicturesMutation>;
export type DeleteProviderPicturesMutationResult = Apollo.MutationResult<DeleteProviderPicturesMutation>;
export type DeleteProviderPicturesMutationOptions = Apollo.BaseMutationOptions<DeleteProviderPicturesMutation, DeleteProviderPicturesMutationVariables>;
export const AddProviderPicturesDocument = gql`
    mutation AddProviderPictures($providerPictures: [providerPictures_insert_input!]!) {
  insert_providerPictures(objects: $providerPictures) {
    returning {
      id
      name
      file {
        id
        name
        uploadName
      }
    }
  }
}
    `;
export type AddProviderPicturesMutationFn = Apollo.MutationFunction<AddProviderPicturesMutation, AddProviderPicturesMutationVariables>;

/**
 * __useAddProviderPicturesMutation__
 *
 * To run a mutation, you first call `useAddProviderPicturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProviderPicturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProviderPicturesMutation, { data, loading, error }] = useAddProviderPicturesMutation({
 *   variables: {
 *      providerPictures: // value for 'providerPictures'
 *   },
 * });
 */
export function useAddProviderPicturesMutation(baseOptions?: Apollo.MutationHookOptions<AddProviderPicturesMutation, AddProviderPicturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProviderPicturesMutation, AddProviderPicturesMutationVariables>(AddProviderPicturesDocument, options);
      }
export type AddProviderPicturesMutationHookResult = ReturnType<typeof useAddProviderPicturesMutation>;
export type AddProviderPicturesMutationResult = Apollo.MutationResult<AddProviderPicturesMutation>;
export type AddProviderPicturesMutationOptions = Apollo.BaseMutationOptions<AddProviderPicturesMutation, AddProviderPicturesMutationVariables>;
export const PayoutsDocument = gql`
    query Payouts($limit: Float!, $startingAfter: String) {
  payouts(limit: $limit, startingAfter: $startingAfter) {
    data {
      id
      date
      amountCaptured
      fees
      status
    }
    totalCount
  }
}
    `;

/**
 * __usePayoutsQuery__
 *
 * To run a query within a React component, call `usePayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayoutsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      startingAfter: // value for 'startingAfter'
 *   },
 * });
 */
export function usePayoutsQuery(baseOptions: Apollo.QueryHookOptions<PayoutsQuery, PayoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayoutsQuery, PayoutsQueryVariables>(PayoutsDocument, options);
      }
export function usePayoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayoutsQuery, PayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayoutsQuery, PayoutsQueryVariables>(PayoutsDocument, options);
        }
export function usePayoutsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PayoutsQuery, PayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayoutsQuery, PayoutsQueryVariables>(PayoutsDocument, options);
        }
export type PayoutsQueryHookResult = ReturnType<typeof usePayoutsQuery>;
export type PayoutsLazyQueryHookResult = ReturnType<typeof usePayoutsLazyQuery>;
export type PayoutsSuspenseQueryHookResult = ReturnType<typeof usePayoutsSuspenseQuery>;
export type PayoutsQueryResult = Apollo.QueryResult<PayoutsQuery, PayoutsQueryVariables>;
export const AppointmentsDocument = gql`
    subscription Appointments($employeeIds: [uuid!] = [], $providerIds: [uuid!] = [], $afterStartDate: timestamptz!, $beforeStartDate: timestamptz!) {
  appointments(
    where: {_and: [{startDate: {_gte: $afterStartDate}}, {startDate: {_lte: $beforeStartDate}}, {jobStatus: {_in: [completed, pending, scheduled, partial]}}, {_or: [{employeeId: {_in: $employeeIds}}, {service: {providerId: {_in: $providerIds}}}]}]}
  ) {
    id
    customerId
    employeeId
    startDate
    endDate
    jobStatus
    customer {
      id
      name
      user {
        id
        name
      }
    }
    service {
      id
      name
      color
    }
  }
}
    `;

/**
 * __useAppointmentsSubscription__
 *
 * To run a query within a React component, call `useAppointmentsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentsSubscription({
 *   variables: {
 *      employeeIds: // value for 'employeeIds'
 *      providerIds: // value for 'providerIds'
 *      afterStartDate: // value for 'afterStartDate'
 *      beforeStartDate: // value for 'beforeStartDate'
 *   },
 * });
 */
export function useAppointmentsSubscription(baseOptions: Apollo.SubscriptionHookOptions<AppointmentsSubscription, AppointmentsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AppointmentsSubscription, AppointmentsSubscriptionVariables>(AppointmentsDocument, options);
      }
export type AppointmentsSubscriptionHookResult = ReturnType<typeof useAppointmentsSubscription>;
export type AppointmentsSubscriptionResult = Apollo.SubscriptionResult<AppointmentsSubscription>;
export const GetAppointmentsKpisDocument = gql`
    query GetAppointmentsKPIS($startDate: timestamptz!, $endDate: timestamptz!) {
  pendingAppointments: appointments_aggregate(
    where: {jobStatus: {_in: [pending]}}
  ) {
    aggregate {
      count
    }
  }
  processedAppointments: appointments_aggregate(
    where: {jobStatus: {_in: [cancelled, completed, scheduled, partial, rejected]}}
  ) {
    aggregate {
      count
    }
  }
  todayAppointments: appointments_aggregate(
    where: {jobStatus: {_in: [completed, scheduled]}, startDate: {_gte: $startDate}, endDate: {_lte: $endDate}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetAppointmentsKpisQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsKpisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsKpisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsKpisQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetAppointmentsKpisQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentsKpisQuery, GetAppointmentsKpisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsKpisQuery, GetAppointmentsKpisQueryVariables>(GetAppointmentsKpisDocument, options);
      }
export function useGetAppointmentsKpisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsKpisQuery, GetAppointmentsKpisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsKpisQuery, GetAppointmentsKpisQueryVariables>(GetAppointmentsKpisDocument, options);
        }
export function useGetAppointmentsKpisSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppointmentsKpisQuery, GetAppointmentsKpisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentsKpisQuery, GetAppointmentsKpisQueryVariables>(GetAppointmentsKpisDocument, options);
        }
export type GetAppointmentsKpisQueryHookResult = ReturnType<typeof useGetAppointmentsKpisQuery>;
export type GetAppointmentsKpisLazyQueryHookResult = ReturnType<typeof useGetAppointmentsKpisLazyQuery>;
export type GetAppointmentsKpisSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentsKpisSuspenseQuery>;
export type GetAppointmentsKpisQueryResult = Apollo.QueryResult<GetAppointmentsKpisQuery, GetAppointmentsKpisQueryVariables>;
export const GetProviderEmployeesDocument = gql`
    query GetProviderEmployees($searchByName: String) {
  userRoles(
    where: {deletedAt: {_is_null: true}, user: {name: {_ilike: $searchByName}}}
    order_by: {user: {name: asc}}
  ) {
    user {
      id
      name
    }
  }
}
    `;

/**
 * __useGetProviderEmployeesQuery__
 *
 * To run a query within a React component, call `useGetProviderEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderEmployeesQuery({
 *   variables: {
 *      searchByName: // value for 'searchByName'
 *   },
 * });
 */
export function useGetProviderEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<GetProviderEmployeesQuery, GetProviderEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderEmployeesQuery, GetProviderEmployeesQueryVariables>(GetProviderEmployeesDocument, options);
      }
export function useGetProviderEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderEmployeesQuery, GetProviderEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderEmployeesQuery, GetProviderEmployeesQueryVariables>(GetProviderEmployeesDocument, options);
        }
export function useGetProviderEmployeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProviderEmployeesQuery, GetProviderEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProviderEmployeesQuery, GetProviderEmployeesQueryVariables>(GetProviderEmployeesDocument, options);
        }
export type GetProviderEmployeesQueryHookResult = ReturnType<typeof useGetProviderEmployeesQuery>;
export type GetProviderEmployeesLazyQueryHookResult = ReturnType<typeof useGetProviderEmployeesLazyQuery>;
export type GetProviderEmployeesSuspenseQueryHookResult = ReturnType<typeof useGetProviderEmployeesSuspenseQuery>;
export type GetProviderEmployeesQueryResult = Apollo.QueryResult<GetProviderEmployeesQuery, GetProviderEmployeesQueryVariables>;
export const TeamDocument = gql`
    query Team($limit: Int, $offset: Int) {
  userRoles(
    limit: $limit
    offset: $offset
    where: {deletedAt: {_is_null: true}}
    order_by: {user: {name: asc}}
  ) {
    role
    user {
      id
      name
      email
      phoneNumber
      profilePicture {
        id
        name
      }
    }
  }
  userRoles_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useTeamQuery__
 *
 * To run a query within a React component, call `useTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useTeamQuery(baseOptions?: Apollo.QueryHookOptions<TeamQuery, TeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
      }
export function useTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamQuery, TeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
        }
export function useTeamSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeamQuery, TeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
        }
export type TeamQueryHookResult = ReturnType<typeof useTeamQuery>;
export type TeamLazyQueryHookResult = ReturnType<typeof useTeamLazyQuery>;
export type TeamSuspenseQueryHookResult = ReturnType<typeof useTeamSuspenseQuery>;
export type TeamQueryResult = Apollo.QueryResult<TeamQuery, TeamQueryVariables>;
export const UpdateBlockedCustomersDocument = gql`
    mutation UpdateBlockedCustomers($customersIds: [uuid!]!, $isBlocked: Boolean!) {
  update_customers(
    where: {id: {_in: $customersIds}}
    _set: {isBlocked: $isBlocked}
  ) {
    returning {
      id
      isBlocked
      name
      address
      user {
        name
        email
        profilePicture {
          id
          name
        }
      }
      bookings: appointments_aggregate {
        aggregate {
          count
        }
      }
      amountSpent {
        amount
      }
    }
  }
}
    `;
export type UpdateBlockedCustomersMutationFn = Apollo.MutationFunction<UpdateBlockedCustomersMutation, UpdateBlockedCustomersMutationVariables>;

/**
 * __useUpdateBlockedCustomersMutation__
 *
 * To run a mutation, you first call `useUpdateBlockedCustomersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlockedCustomersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlockedCustomersMutation, { data, loading, error }] = useUpdateBlockedCustomersMutation({
 *   variables: {
 *      customersIds: // value for 'customersIds'
 *      isBlocked: // value for 'isBlocked'
 *   },
 * });
 */
export function useUpdateBlockedCustomersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlockedCustomersMutation, UpdateBlockedCustomersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlockedCustomersMutation, UpdateBlockedCustomersMutationVariables>(UpdateBlockedCustomersDocument, options);
      }
export type UpdateBlockedCustomersMutationHookResult = ReturnType<typeof useUpdateBlockedCustomersMutation>;
export type UpdateBlockedCustomersMutationResult = Apollo.MutationResult<UpdateBlockedCustomersMutation>;
export type UpdateBlockedCustomersMutationOptions = Apollo.BaseMutationOptions<UpdateBlockedCustomersMutation, UpdateBlockedCustomersMutationVariables>;
export const ProviderBySlugDocument = gql`
    query ProviderBySlug($slug: String!) {
  providers(where: {slug: {_eq: $slug}}) {
    name
    description
    category
    slug
    providerPictureByProfilePic {
      id
      name
      file {
        id
        name
        uploadName
      }
    }
    providerPictureByCoverPic {
      id
      name
      file {
        id
        name
        uploadName
      }
    }
    providerPictures {
      id
      name
      file {
        id
        name
        uploadName
      }
    }
    providerPictures_aggregate {
      aggregate {
        count
      }
    }
    services {
      id
      name
      description
      duration
      customerCanPickEmployee
      sku
      providerId
      servicePictures {
        id
        name
        size
        file {
          id
          name
        }
      }
      servicePricings(order_by: {basePrice: asc}) {
        id
        basePrice
        currency
      }
      serviceEmployees_aggregate {
        aggregate {
          count
        }
      }
      serviceOptions(where: {status: {_eq: active}, deletedAt: {_is_null: true}}) {
        name
        id
        status
        serviceOptionSections {
          name
          order
          id
          mandatory
          type
          serviceOptionSectionOptions {
            id
            name
            order
            price
            quantity
          }
        }
      }
      servicesForms(
        where: {status: {_eq: active}, form: {deletedAt: {_is_null: true}}}
      ) {
        id
        formId
        status
        form {
          id
          name
          formQuestions(where: {deletedAt: {_is_null: true}}) {
            id
            label
            mandatory
            name
            order
            questionType
            options: formQuestionOptions {
              id
              value
            }
          }
        }
      }
      servicePricing {
        basePrice
        checkoutPayment
        fees
        taxes
        minimumDeposit
        paymentFormat
        currency
      }
    }
    services_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useProviderBySlugQuery__
 *
 * To run a query within a React component, call `useProviderBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useProviderBySlugQuery(baseOptions: Apollo.QueryHookOptions<ProviderBySlugQuery, ProviderBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderBySlugQuery, ProviderBySlugQueryVariables>(ProviderBySlugDocument, options);
      }
export function useProviderBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderBySlugQuery, ProviderBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderBySlugQuery, ProviderBySlugQueryVariables>(ProviderBySlugDocument, options);
        }
export function useProviderBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProviderBySlugQuery, ProviderBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderBySlugQuery, ProviderBySlugQueryVariables>(ProviderBySlugDocument, options);
        }
export type ProviderBySlugQueryHookResult = ReturnType<typeof useProviderBySlugQuery>;
export type ProviderBySlugLazyQueryHookResult = ReturnType<typeof useProviderBySlugLazyQuery>;
export type ProviderBySlugSuspenseQueryHookResult = ReturnType<typeof useProviderBySlugSuspenseQuery>;
export type ProviderBySlugQueryResult = Apollo.QueryResult<ProviderBySlugQuery, ProviderBySlugQueryVariables>;
export const AvailableLocationsByTypeDocument = gql`
    query AvailableLocationsByType($locationName: String!, $locationType: locationType_enum!, $limit: Int!, $offset: Int!, $providerId: uuid!, $serviceId: uuid!) {
  locations(
    limit: $limit
    offset: $offset
    where: {name: {_ilike: $locationName}, type: {_eq: $locationType}, _or: [{providerId: {_eq: $providerId}}, {buildingProviders: {providerId: {_eq: $providerId}, deletedAt: {_is_null: true}}}], deletedAt: {_is_null: true}, _not: {unavailableServiceLocations: {serviceId: {_eq: $serviceId}}}}
  ) {
    id
    name
    address
    radius
    buildingManagerId
    buildingManager {
      id
      name
      address
    }
    coordinates
  }
  locations_aggregate(
    where: {name: {_ilike: $locationName}, type: {_eq: $locationType}, _or: [{providerId: {_eq: $providerId}}, {buildingProviders: {providerId: {_eq: $providerId}}}], deletedAt: {_is_null: true}, _not: {unavailableServiceLocations: {serviceId: {_eq: $serviceId}}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAvailableLocationsByTypeQuery__
 *
 * To run a query within a React component, call `useAvailableLocationsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableLocationsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableLocationsByTypeQuery({
 *   variables: {
 *      locationName: // value for 'locationName'
 *      locationType: // value for 'locationType'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      providerId: // value for 'providerId'
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useAvailableLocationsByTypeQuery(baseOptions: Apollo.QueryHookOptions<AvailableLocationsByTypeQuery, AvailableLocationsByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableLocationsByTypeQuery, AvailableLocationsByTypeQueryVariables>(AvailableLocationsByTypeDocument, options);
      }
export function useAvailableLocationsByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableLocationsByTypeQuery, AvailableLocationsByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableLocationsByTypeQuery, AvailableLocationsByTypeQueryVariables>(AvailableLocationsByTypeDocument, options);
        }
export function useAvailableLocationsByTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailableLocationsByTypeQuery, AvailableLocationsByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableLocationsByTypeQuery, AvailableLocationsByTypeQueryVariables>(AvailableLocationsByTypeDocument, options);
        }
export type AvailableLocationsByTypeQueryHookResult = ReturnType<typeof useAvailableLocationsByTypeQuery>;
export type AvailableLocationsByTypeLazyQueryHookResult = ReturnType<typeof useAvailableLocationsByTypeLazyQuery>;
export type AvailableLocationsByTypeSuspenseQueryHookResult = ReturnType<typeof useAvailableLocationsByTypeSuspenseQuery>;
export type AvailableLocationsByTypeQueryResult = Apollo.QueryResult<AvailableLocationsByTypeQuery, AvailableLocationsByTypeQueryVariables>;
export const GetAppointmentsDocument = gql`
    query GetAppointments($jobStatus: [jobStatus_enum!]!, $limit: Int!, $offset: Int!) {
  appointments(
    where: {jobStatus: {_in: $jobStatus}}
    limit: $limit
    offset: $offset
    order_by: {startDate: asc, id: desc}
  ) {
    id
    customerId
    employeeId
    startDate
    endDate
    paymentStatus
    jobStatus
    createdByUserId
    ...AppointmentServiceOptionAnswers
    ...AppointmentPricing
    customer {
      id
      name
      phoneNumber
      email
      address
      user {
        id
        name
        phoneNumber
        email
        address
        profilePicture {
          id
          name
        }
      }
    }
    payments_aggregate(where: {status: {_neq: cancelled}}) {
      aggregate {
        sum {
          amount
        }
      }
    }
    service {
      id
      name
      color
      sku
    }
  }
  appointments_aggregate(where: {jobStatus: {_in: $jobStatus}}) {
    aggregate {
      count
    }
  }
}
    ${AppointmentServiceOptionAnswersFragmentDoc}
${AppointmentPricingFragmentDoc}`;

/**
 * __useGetAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsQuery({
 *   variables: {
 *      jobStatus: // value for 'jobStatus'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
      }
export function useGetAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
        }
export function useGetAppointmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
        }
export type GetAppointmentsQueryHookResult = ReturnType<typeof useGetAppointmentsQuery>;
export type GetAppointmentsLazyQueryHookResult = ReturnType<typeof useGetAppointmentsLazyQuery>;
export type GetAppointmentsSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentsSuspenseQuery>;
export type GetAppointmentsQueryResult = Apollo.QueryResult<GetAppointmentsQuery, GetAppointmentsQueryVariables>;
export const GetAppointmentByIdDocument = gql`
    query GetAppointmentById($id: uuid!) {
  appointments_by_pk(id: $id) {
    id
    customerId
    employeeId
    serviceId
    startDate
    endDate
    paymentStatus
    createdByUserId
    address
    coordinates
    jobStatus
    notes
    ...AppointmentPricing
    ...AppointmentPayments
    ...AppointmentFormAnswers
    ...AppointmentServiceOptionAnswers
    userByAbortedId {
      id
      name
      email
      phoneNumber
    }
    userByEmployeeid {
      id
      name
      email
      phoneNumber
      profilePicture {
        id
        name
      }
    }
    customer {
      id
      name
      phoneNumber
      email
      address
      coordinates
      stripeCustomerId
      bmStripePaymentMethodId
      user {
        id
        name
        phoneNumber
        email
        address
        coordinates
        stripePaymentMethodId
        profilePicture {
          id
          name
        }
      }
    }
    payments_aggregate(where: {status: {_neq: cancelled}}) {
      aggregate {
        sum {
          amount
        }
      }
    }
    service {
      id
      name
      color
      sku
      duration
      customerCanPickEmployee
      serviceOptions {
        id
        name
        serviceOptionSections {
          id
          name
          serviceOptionSectionOptions {
            id
            name
            price
            quantity
            serviceOptionAnswers(where: {appointmentId: {_eq: $id}}) {
              id
              quantity
              serviceOptionSectionOption {
                serviceOptionSection {
                  name
                }
              }
            }
          }
          type
        }
      }
      provider {
        id
        slug
        name
        email
        phoneNumber
        bookingCancelationWarningPeriod
        forms(where: {deletedAt: {_is_null: true}}) {
          id
          name
          formQuestions {
            id
            questionType
            name
            label
            description
          }
          formAnswers {
            id
            answer
            formQuestionId
          }
        }
      }
      servicePricing {
        minimumDeposit
        paymentFormat
        taxes
      }
      serviceEmployees_aggregate {
        aggregate {
          count
        }
      }
    }
    location {
      id
      name
      address
      coordinates
      type
    }
    apartmentNumber
  }
}
    ${AppointmentPricingFragmentDoc}
${AppointmentPaymentsFragmentDoc}
${AppointmentFormAnswersFragmentDoc}
${AppointmentServiceOptionAnswersFragmentDoc}`;

/**
 * __useGetAppointmentByIdQuery__
 *
 * To run a query within a React component, call `useGetAppointmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAppointmentByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentByIdQuery, GetAppointmentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentByIdQuery, GetAppointmentByIdQueryVariables>(GetAppointmentByIdDocument, options);
      }
export function useGetAppointmentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentByIdQuery, GetAppointmentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentByIdQuery, GetAppointmentByIdQueryVariables>(GetAppointmentByIdDocument, options);
        }
export function useGetAppointmentByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppointmentByIdQuery, GetAppointmentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentByIdQuery, GetAppointmentByIdQueryVariables>(GetAppointmentByIdDocument, options);
        }
export type GetAppointmentByIdQueryHookResult = ReturnType<typeof useGetAppointmentByIdQuery>;
export type GetAppointmentByIdLazyQueryHookResult = ReturnType<typeof useGetAppointmentByIdLazyQuery>;
export type GetAppointmentByIdSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentByIdSuspenseQuery>;
export type GetAppointmentByIdQueryResult = Apollo.QueryResult<GetAppointmentByIdQuery, GetAppointmentByIdQueryVariables>;
export const GetDashboardTimeoutsDocument = gql`
    query GetDashboardTimeouts($startDate: timestamptz!) {
  timeouts(
    where: {startDate: {_gt: $startDate}}
    limit: 5
    offset: 0
    order_by: {startDate: asc, id: desc}
  ) {
    id
    startDate
    endDate
    user {
      id
      name
    }
    location {
      id
      name
    }
    service {
      id
      name
    }
  }
}
    `;

/**
 * __useGetDashboardTimeoutsQuery__
 *
 * To run a query within a React component, call `useGetDashboardTimeoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardTimeoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardTimeoutsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetDashboardTimeoutsQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardTimeoutsQuery, GetDashboardTimeoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardTimeoutsQuery, GetDashboardTimeoutsQueryVariables>(GetDashboardTimeoutsDocument, options);
      }
export function useGetDashboardTimeoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardTimeoutsQuery, GetDashboardTimeoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardTimeoutsQuery, GetDashboardTimeoutsQueryVariables>(GetDashboardTimeoutsDocument, options);
        }
export function useGetDashboardTimeoutsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDashboardTimeoutsQuery, GetDashboardTimeoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardTimeoutsQuery, GetDashboardTimeoutsQueryVariables>(GetDashboardTimeoutsDocument, options);
        }
export type GetDashboardTimeoutsQueryHookResult = ReturnType<typeof useGetDashboardTimeoutsQuery>;
export type GetDashboardTimeoutsLazyQueryHookResult = ReturnType<typeof useGetDashboardTimeoutsLazyQuery>;
export type GetDashboardTimeoutsSuspenseQueryHookResult = ReturnType<typeof useGetDashboardTimeoutsSuspenseQuery>;
export type GetDashboardTimeoutsQueryResult = Apollo.QueryResult<GetDashboardTimeoutsQuery, GetDashboardTimeoutsQueryVariables>;
export const GetDashboardAppointmentsDocument = gql`
    query GetDashboardAppointments($jobStatus: [jobStatus_enum!]!) {
  appointments(
    where: {jobStatus: {_in: $jobStatus}, startDate: {_gt: "now()"}}
    limit: 5
    offset: 0
    order_by: {startDate: asc, id: desc}
  ) {
    id
    startDate
    customer {
      id
      name
      user {
        id
        name
        profilePicture {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetDashboardAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetDashboardAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardAppointmentsQuery({
 *   variables: {
 *      jobStatus: // value for 'jobStatus'
 *   },
 * });
 */
export function useGetDashboardAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardAppointmentsQuery, GetDashboardAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardAppointmentsQuery, GetDashboardAppointmentsQueryVariables>(GetDashboardAppointmentsDocument, options);
      }
export function useGetDashboardAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardAppointmentsQuery, GetDashboardAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardAppointmentsQuery, GetDashboardAppointmentsQueryVariables>(GetDashboardAppointmentsDocument, options);
        }
export function useGetDashboardAppointmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDashboardAppointmentsQuery, GetDashboardAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardAppointmentsQuery, GetDashboardAppointmentsQueryVariables>(GetDashboardAppointmentsDocument, options);
        }
export type GetDashboardAppointmentsQueryHookResult = ReturnType<typeof useGetDashboardAppointmentsQuery>;
export type GetDashboardAppointmentsLazyQueryHookResult = ReturnType<typeof useGetDashboardAppointmentsLazyQuery>;
export type GetDashboardAppointmentsSuspenseQueryHookResult = ReturnType<typeof useGetDashboardAppointmentsSuspenseQuery>;
export type GetDashboardAppointmentsQueryResult = Apollo.QueryResult<GetDashboardAppointmentsQuery, GetDashboardAppointmentsQueryVariables>;
export const UpdateAppointmentNotesDocument = gql`
    mutation UpdateAppointmentNotes($id: uuid!, $notes: String!) {
  update_appointments_by_pk(pk_columns: {id: $id}, _set: {notes: $notes}) {
    notes
  }
}
    `;
export type UpdateAppointmentNotesMutationFn = Apollo.MutationFunction<UpdateAppointmentNotesMutation, UpdateAppointmentNotesMutationVariables>;

/**
 * __useUpdateAppointmentNotesMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentNotesMutation, { data, loading, error }] = useUpdateAppointmentNotesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateAppointmentNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentNotesMutation, UpdateAppointmentNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentNotesMutation, UpdateAppointmentNotesMutationVariables>(UpdateAppointmentNotesDocument, options);
      }
export type UpdateAppointmentNotesMutationHookResult = ReturnType<typeof useUpdateAppointmentNotesMutation>;
export type UpdateAppointmentNotesMutationResult = Apollo.MutationResult<UpdateAppointmentNotesMutation>;
export type UpdateAppointmentNotesMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentNotesMutation, UpdateAppointmentNotesMutationVariables>;
export const SpRefundSinglePaymentDocument = gql`
    mutation SpRefundSinglePayment($appointmentId: String!, $paymentId: String!) {
  SpRefundPayment(apptId: $appointmentId, paymentId: $paymentId) {
    id
  }
}
    `;
export type SpRefundSinglePaymentMutationFn = Apollo.MutationFunction<SpRefundSinglePaymentMutation, SpRefundSinglePaymentMutationVariables>;

/**
 * __useSpRefundSinglePaymentMutation__
 *
 * To run a mutation, you first call `useSpRefundSinglePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSpRefundSinglePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [spRefundSinglePaymentMutation, { data, loading, error }] = useSpRefundSinglePaymentMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useSpRefundSinglePaymentMutation(baseOptions?: Apollo.MutationHookOptions<SpRefundSinglePaymentMutation, SpRefundSinglePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SpRefundSinglePaymentMutation, SpRefundSinglePaymentMutationVariables>(SpRefundSinglePaymentDocument, options);
      }
export type SpRefundSinglePaymentMutationHookResult = ReturnType<typeof useSpRefundSinglePaymentMutation>;
export type SpRefundSinglePaymentMutationResult = Apollo.MutationResult<SpRefundSinglePaymentMutation>;
export type SpRefundSinglePaymentMutationOptions = Apollo.BaseMutationOptions<SpRefundSinglePaymentMutation, SpRefundSinglePaymentMutationVariables>;
export const SpUpdateAppointmentPaymentStatusDocument = gql`
    mutation SpUpdateAppointmentPaymentStatus($appointmentId: String!, $status: String!) {
  SpUpdateApptPaymentStatus(apptId: $appointmentId, status: $status) {
    id
  }
}
    `;
export type SpUpdateAppointmentPaymentStatusMutationFn = Apollo.MutationFunction<SpUpdateAppointmentPaymentStatusMutation, SpUpdateAppointmentPaymentStatusMutationVariables>;

/**
 * __useSpUpdateAppointmentPaymentStatusMutation__
 *
 * To run a mutation, you first call `useSpUpdateAppointmentPaymentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSpUpdateAppointmentPaymentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [spUpdateAppointmentPaymentStatusMutation, { data, loading, error }] = useSpUpdateAppointmentPaymentStatusMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSpUpdateAppointmentPaymentStatusMutation(baseOptions?: Apollo.MutationHookOptions<SpUpdateAppointmentPaymentStatusMutation, SpUpdateAppointmentPaymentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SpUpdateAppointmentPaymentStatusMutation, SpUpdateAppointmentPaymentStatusMutationVariables>(SpUpdateAppointmentPaymentStatusDocument, options);
      }
export type SpUpdateAppointmentPaymentStatusMutationHookResult = ReturnType<typeof useSpUpdateAppointmentPaymentStatusMutation>;
export type SpUpdateAppointmentPaymentStatusMutationResult = Apollo.MutationResult<SpUpdateAppointmentPaymentStatusMutation>;
export type SpUpdateAppointmentPaymentStatusMutationOptions = Apollo.BaseMutationOptions<SpUpdateAppointmentPaymentStatusMutation, SpUpdateAppointmentPaymentStatusMutationVariables>;
export const ApproveAppointmentDocument = gql`
    mutation ApproveAppointment($id: String!) {
  ApproveAppointment(appointmentId: $id) {
    id
    jobStatus
  }
}
    `;
export type ApproveAppointmentMutationFn = Apollo.MutationFunction<ApproveAppointmentMutation, ApproveAppointmentMutationVariables>;

/**
 * __useApproveAppointmentMutation__
 *
 * To run a mutation, you first call `useApproveAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveAppointmentMutation, { data, loading, error }] = useApproveAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<ApproveAppointmentMutation, ApproveAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveAppointmentMutation, ApproveAppointmentMutationVariables>(ApproveAppointmentDocument, options);
      }
export type ApproveAppointmentMutationHookResult = ReturnType<typeof useApproveAppointmentMutation>;
export type ApproveAppointmentMutationResult = Apollo.MutationResult<ApproveAppointmentMutation>;
export type ApproveAppointmentMutationOptions = Apollo.BaseMutationOptions<ApproveAppointmentMutation, ApproveAppointmentMutationVariables>;
export const CompleteAppointmentDocument = gql`
    mutation CompleteAppointment($id: String!) {
  SPMarkAppointmentCompleted(appointmentId: $id) {
    id
    jobStatus
  }
}
    `;
export type CompleteAppointmentMutationFn = Apollo.MutationFunction<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>;

/**
 * __useCompleteAppointmentMutation__
 *
 * To run a mutation, you first call `useCompleteAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAppointmentMutation, { data, loading, error }] = useCompleteAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompleteAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>(CompleteAppointmentDocument, options);
      }
export type CompleteAppointmentMutationHookResult = ReturnType<typeof useCompleteAppointmentMutation>;
export type CompleteAppointmentMutationResult = Apollo.MutationResult<CompleteAppointmentMutation>;
export type CompleteAppointmentMutationOptions = Apollo.BaseMutationOptions<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>;
export const SetAppointmentPartialDocument = gql`
    mutation SetAppointmentPartial($id: String!) {
  SPMarkAppointmentPartial(appointmentId: $id) {
    id
    jobStatus
  }
}
    `;
export type SetAppointmentPartialMutationFn = Apollo.MutationFunction<SetAppointmentPartialMutation, SetAppointmentPartialMutationVariables>;

/**
 * __useSetAppointmentPartialMutation__
 *
 * To run a mutation, you first call `useSetAppointmentPartialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAppointmentPartialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAppointmentPartialMutation, { data, loading, error }] = useSetAppointmentPartialMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetAppointmentPartialMutation(baseOptions?: Apollo.MutationHookOptions<SetAppointmentPartialMutation, SetAppointmentPartialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAppointmentPartialMutation, SetAppointmentPartialMutationVariables>(SetAppointmentPartialDocument, options);
      }
export type SetAppointmentPartialMutationHookResult = ReturnType<typeof useSetAppointmentPartialMutation>;
export type SetAppointmentPartialMutationResult = Apollo.MutationResult<SetAppointmentPartialMutation>;
export type SetAppointmentPartialMutationOptions = Apollo.BaseMutationOptions<SetAppointmentPartialMutation, SetAppointmentPartialMutationVariables>;
export const SetAppointmentScheduledDocument = gql`
    mutation SetAppointmentScheduled($id: String!) {
  SPMarkAppointmentScheduled(appointmentId: $id) {
    id
    jobStatus
  }
}
    `;
export type SetAppointmentScheduledMutationFn = Apollo.MutationFunction<SetAppointmentScheduledMutation, SetAppointmentScheduledMutationVariables>;

/**
 * __useSetAppointmentScheduledMutation__
 *
 * To run a mutation, you first call `useSetAppointmentScheduledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAppointmentScheduledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAppointmentScheduledMutation, { data, loading, error }] = useSetAppointmentScheduledMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetAppointmentScheduledMutation(baseOptions?: Apollo.MutationHookOptions<SetAppointmentScheduledMutation, SetAppointmentScheduledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAppointmentScheduledMutation, SetAppointmentScheduledMutationVariables>(SetAppointmentScheduledDocument, options);
      }
export type SetAppointmentScheduledMutationHookResult = ReturnType<typeof useSetAppointmentScheduledMutation>;
export type SetAppointmentScheduledMutationResult = Apollo.MutationResult<SetAppointmentScheduledMutation>;
export type SetAppointmentScheduledMutationOptions = Apollo.BaseMutationOptions<SetAppointmentScheduledMutation, SetAppointmentScheduledMutationVariables>;
export const GetEmployeesListDocument = gql`
    query GetEmployeesList($limit: Int, $offset: Int, $searchByName: String!, $serviceId: uuid!) {
  users(
    where: {name: {_ilike: $searchByName}, userRole: {role: {_in: [employee, provider]}, deletedAt: {_is_null: true}}, serviceEmployees: {serviceId: {_eq: $serviceId}}}
    limit: $limit
    offset: $offset
    order_by: {name: asc}
  ) {
    id
    name
    completedAppointments: appointmentsByEmployeeid_aggregate(
      where: {jobStatus: {_eq: completed}}
    ) {
      aggregate {
        count
      }
    }
    profilePicture {
      id
      name
    }
  }
  users_aggregate(
    where: {name: {_ilike: $searchByName}, userRole: {role: {_in: [employee, provider]}, deletedAt: {_is_null: true}}, serviceEmployees: {serviceId: {_eq: $serviceId}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetEmployeesListQuery__
 *
 * To run a query within a React component, call `useGetEmployeesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchByName: // value for 'searchByName'
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useGetEmployeesListQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeesListQuery, GetEmployeesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesListQuery, GetEmployeesListQueryVariables>(GetEmployeesListDocument, options);
      }
export function useGetEmployeesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesListQuery, GetEmployeesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesListQuery, GetEmployeesListQueryVariables>(GetEmployeesListDocument, options);
        }
export function useGetEmployeesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmployeesListQuery, GetEmployeesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeesListQuery, GetEmployeesListQueryVariables>(GetEmployeesListDocument, options);
        }
export type GetEmployeesListQueryHookResult = ReturnType<typeof useGetEmployeesListQuery>;
export type GetEmployeesListLazyQueryHookResult = ReturnType<typeof useGetEmployeesListLazyQuery>;
export type GetEmployeesListSuspenseQueryHookResult = ReturnType<typeof useGetEmployeesListSuspenseQuery>;
export type GetEmployeesListQueryResult = Apollo.QueryResult<GetEmployeesListQuery, GetEmployeesListQueryVariables>;
export const UpdateServiceOptionsStatusDocument = gql`
    mutation UpdateServiceOptionsStatus($id: uuid!, $status: serviceOptionsStatus_enum) {
  update_serviceOptions_by_pk(pk_columns: {id: $id}, _set: {status: $status}) {
    id
    name
    status
  }
}
    `;
export type UpdateServiceOptionsStatusMutationFn = Apollo.MutationFunction<UpdateServiceOptionsStatusMutation, UpdateServiceOptionsStatusMutationVariables>;

/**
 * __useUpdateServiceOptionsStatusMutation__
 *
 * To run a mutation, you first call `useUpdateServiceOptionsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceOptionsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceOptionsStatusMutation, { data, loading, error }] = useUpdateServiceOptionsStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateServiceOptionsStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceOptionsStatusMutation, UpdateServiceOptionsStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceOptionsStatusMutation, UpdateServiceOptionsStatusMutationVariables>(UpdateServiceOptionsStatusDocument, options);
      }
export type UpdateServiceOptionsStatusMutationHookResult = ReturnType<typeof useUpdateServiceOptionsStatusMutation>;
export type UpdateServiceOptionsStatusMutationResult = Apollo.MutationResult<UpdateServiceOptionsStatusMutation>;
export type UpdateServiceOptionsStatusMutationOptions = Apollo.BaseMutationOptions<UpdateServiceOptionsStatusMutation, UpdateServiceOptionsStatusMutationVariables>;
export const UpdateServicePricingPaymentFormatByIdDocument = gql`
    mutation UpdateServicePricingPaymentFormatById($id: uuid!, $paymentFormat: paymentFormat_enum) {
  update_servicePricings(
    where: {serviceId: {_eq: $id}}
    _set: {paymentFormat: $paymentFormat}
  ) {
    returning {
      id
      basePrice
      minimumDeposit
      taxes
      fees
      paymentFormat
      checkoutPayment
      currency
    }
  }
}
    `;
export type UpdateServicePricingPaymentFormatByIdMutationFn = Apollo.MutationFunction<UpdateServicePricingPaymentFormatByIdMutation, UpdateServicePricingPaymentFormatByIdMutationVariables>;

/**
 * __useUpdateServicePricingPaymentFormatByIdMutation__
 *
 * To run a mutation, you first call `useUpdateServicePricingPaymentFormatByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServicePricingPaymentFormatByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServicePricingPaymentFormatByIdMutation, { data, loading, error }] = useUpdateServicePricingPaymentFormatByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      paymentFormat: // value for 'paymentFormat'
 *   },
 * });
 */
export function useUpdateServicePricingPaymentFormatByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServicePricingPaymentFormatByIdMutation, UpdateServicePricingPaymentFormatByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServicePricingPaymentFormatByIdMutation, UpdateServicePricingPaymentFormatByIdMutationVariables>(UpdateServicePricingPaymentFormatByIdDocument, options);
      }
export type UpdateServicePricingPaymentFormatByIdMutationHookResult = ReturnType<typeof useUpdateServicePricingPaymentFormatByIdMutation>;
export type UpdateServicePricingPaymentFormatByIdMutationResult = Apollo.MutationResult<UpdateServicePricingPaymentFormatByIdMutation>;
export type UpdateServicePricingPaymentFormatByIdMutationOptions = Apollo.BaseMutationOptions<UpdateServicePricingPaymentFormatByIdMutation, UpdateServicePricingPaymentFormatByIdMutationVariables>;
export const DeleteLocationsByIdDocument = gql`
    mutation DeleteLocationsById($locationIds: [uuid!]) {
  update_locations(where: {id: {_in: $locationIds}}, _set: {deletedAt: "now()"}) {
    returning {
      id
      deletedAt
    }
  }
  delete_schedule(where: {locationId: {_in: $locationIds}}) {
    returning {
      id
    }
  }
  delete_timeouts(where: {locationId: {_in: $locationIds}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteLocationsByIdMutationFn = Apollo.MutationFunction<DeleteLocationsByIdMutation, DeleteLocationsByIdMutationVariables>;

/**
 * __useDeleteLocationsByIdMutation__
 *
 * To run a mutation, you first call `useDeleteLocationsByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationsByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationsByIdMutation, { data, loading, error }] = useDeleteLocationsByIdMutation({
 *   variables: {
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useDeleteLocationsByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationsByIdMutation, DeleteLocationsByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationsByIdMutation, DeleteLocationsByIdMutationVariables>(DeleteLocationsByIdDocument, options);
      }
export type DeleteLocationsByIdMutationHookResult = ReturnType<typeof useDeleteLocationsByIdMutation>;
export type DeleteLocationsByIdMutationResult = Apollo.MutationResult<DeleteLocationsByIdMutation>;
export type DeleteLocationsByIdMutationOptions = Apollo.BaseMutationOptions<DeleteLocationsByIdMutation, DeleteLocationsByIdMutationVariables>;
export const GetFutureAppointmentsByLocationIdsDocument = gql`
    query GetFutureAppointmentsByLocationIds($locationIds: [uuid!]) {
  appointments(
    where: {locationId: {_in: $locationIds}, startDate: {_gte: "now()"}}
  ) {
    id
    startDate
  }
}
    `;

/**
 * __useGetFutureAppointmentsByLocationIdsQuery__
 *
 * To run a query within a React component, call `useGetFutureAppointmentsByLocationIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFutureAppointmentsByLocationIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFutureAppointmentsByLocationIdsQuery({
 *   variables: {
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useGetFutureAppointmentsByLocationIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetFutureAppointmentsByLocationIdsQuery, GetFutureAppointmentsByLocationIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFutureAppointmentsByLocationIdsQuery, GetFutureAppointmentsByLocationIdsQueryVariables>(GetFutureAppointmentsByLocationIdsDocument, options);
      }
export function useGetFutureAppointmentsByLocationIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFutureAppointmentsByLocationIdsQuery, GetFutureAppointmentsByLocationIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFutureAppointmentsByLocationIdsQuery, GetFutureAppointmentsByLocationIdsQueryVariables>(GetFutureAppointmentsByLocationIdsDocument, options);
        }
export function useGetFutureAppointmentsByLocationIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFutureAppointmentsByLocationIdsQuery, GetFutureAppointmentsByLocationIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFutureAppointmentsByLocationIdsQuery, GetFutureAppointmentsByLocationIdsQueryVariables>(GetFutureAppointmentsByLocationIdsDocument, options);
        }
export type GetFutureAppointmentsByLocationIdsQueryHookResult = ReturnType<typeof useGetFutureAppointmentsByLocationIdsQuery>;
export type GetFutureAppointmentsByLocationIdsLazyQueryHookResult = ReturnType<typeof useGetFutureAppointmentsByLocationIdsLazyQuery>;
export type GetFutureAppointmentsByLocationIdsSuspenseQueryHookResult = ReturnType<typeof useGetFutureAppointmentsByLocationIdsSuspenseQuery>;
export type GetFutureAppointmentsByLocationIdsQueryResult = Apollo.QueryResult<GetFutureAppointmentsByLocationIdsQuery, GetFutureAppointmentsByLocationIdsQueryVariables>;
export const CreateEmployeeDocument = gql`
    mutation CreateEmployee($name: String!, $email: String!, $phoneNumber: String!, $profilePictureFileId: String) {
  createEmployee(
    employee: {name: $name, email: $email, phoneNumber: $phoneNumber, profilePictureFileId: $profilePictureFileId}
  ) {
    id
    name
    phoneNumber
    email
    profilePictureFileId
    profilePicture {
      id
      name
    }
    createdAt
  }
}
    `;
export type CreateEmployeeMutationFn = Apollo.MutationFunction<CreateEmployeeMutation, CreateEmployeeMutationVariables>;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeMutation, { data, loading, error }] = useCreateEmployeeMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      profilePictureFileId: // value for 'profilePictureFileId'
 *   },
 * });
 */
export function useCreateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
      }
export type CreateEmployeeMutationHookResult = ReturnType<typeof useCreateEmployeeMutation>;
export type CreateEmployeeMutationResult = Apollo.MutationResult<CreateEmployeeMutation>;
export type CreateEmployeeMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>;
export const EditEmployeeDocument = gql`
    mutation EditEmployee($id: uuid!, $name: String!, $phoneNumber: String!, $profilePictureFileId: uuid) {
  update_users_by_pk(
    pk_columns: {id: $id}
    _set: {profilePictureFileId: $profilePictureFileId, name: $name, phoneNumber: $phoneNumber}
  ) {
    id
    name
    phoneNumber
    email
    profilePictureFileId
    profilePicture {
      id
      name
    }
  }
}
    `;
export type EditEmployeeMutationFn = Apollo.MutationFunction<EditEmployeeMutation, EditEmployeeMutationVariables>;

/**
 * __useEditEmployeeMutation__
 *
 * To run a mutation, you first call `useEditEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editEmployeeMutation, { data, loading, error }] = useEditEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      phoneNumber: // value for 'phoneNumber'
 *      profilePictureFileId: // value for 'profilePictureFileId'
 *   },
 * });
 */
export function useEditEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<EditEmployeeMutation, EditEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditEmployeeMutation, EditEmployeeMutationVariables>(EditEmployeeDocument, options);
      }
export type EditEmployeeMutationHookResult = ReturnType<typeof useEditEmployeeMutation>;
export type EditEmployeeMutationResult = Apollo.MutationResult<EditEmployeeMutation>;
export type EditEmployeeMutationOptions = Apollo.BaseMutationOptions<EditEmployeeMutation, EditEmployeeMutationVariables>;
export const ServicesByEmployeeIdDocument = gql`
    query ServicesByEmployeeId($employeeId: uuid!, $limit: Int, $offset: Int) {
  services(
    where: {serviceEmployees: {userId: {_eq: $employeeId}}, deletedAt: {_is_null: true}}
    order_by: {status: asc}
  ) {
    id
    name
    status
    serviceEmployees {
      id
      userId
      serviceId
    }
  }
}
    `;

/**
 * __useServicesByEmployeeIdQuery__
 *
 * To run a query within a React component, call `useServicesByEmployeeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicesByEmployeeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicesByEmployeeIdQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useServicesByEmployeeIdQuery(baseOptions: Apollo.QueryHookOptions<ServicesByEmployeeIdQuery, ServicesByEmployeeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServicesByEmployeeIdQuery, ServicesByEmployeeIdQueryVariables>(ServicesByEmployeeIdDocument, options);
      }
export function useServicesByEmployeeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServicesByEmployeeIdQuery, ServicesByEmployeeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServicesByEmployeeIdQuery, ServicesByEmployeeIdQueryVariables>(ServicesByEmployeeIdDocument, options);
        }
export function useServicesByEmployeeIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServicesByEmployeeIdQuery, ServicesByEmployeeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServicesByEmployeeIdQuery, ServicesByEmployeeIdQueryVariables>(ServicesByEmployeeIdDocument, options);
        }
export type ServicesByEmployeeIdQueryHookResult = ReturnType<typeof useServicesByEmployeeIdQuery>;
export type ServicesByEmployeeIdLazyQueryHookResult = ReturnType<typeof useServicesByEmployeeIdLazyQuery>;
export type ServicesByEmployeeIdSuspenseQueryHookResult = ReturnType<typeof useServicesByEmployeeIdSuspenseQuery>;
export type ServicesByEmployeeIdQueryResult = Apollo.QueryResult<ServicesByEmployeeIdQuery, ServicesByEmployeeIdQueryVariables>;
export const AvailabilitiesByEmployeeIdDocument = gql`
    query AvailabilitiesByEmployeeId($employeeId: uuid!, $afterStartDate: date!, $afterStartTimestamp: timestamptz!, $beforeStartDate: date!, $beforeStartTimestamp: timestamptz!) {
  schedule(
    where: {employeeId: {_eq: $employeeId}, startingAt: {_lte: $beforeStartDate}, endingAt: {_gte: $afterStartDate}}
  ) {
    id
    startTime
    endTime
    repeatableDayOfWeek
    startingAt
    endingAt
    locationId
    employeeId
  }
  timeouts(
    where: {userId: {_eq: $employeeId}, startDate: {_lte: $beforeStartTimestamp}, endDate: {_gte: $afterStartTimestamp}}
  ) {
    id
    userId
    locationId
    serviceId
    startDate
    endDate
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAvailabilitiesByEmployeeIdQuery__
 *
 * To run a query within a React component, call `useAvailabilitiesByEmployeeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilitiesByEmployeeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailabilitiesByEmployeeIdQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      afterStartDate: // value for 'afterStartDate'
 *      afterStartTimestamp: // value for 'afterStartTimestamp'
 *      beforeStartDate: // value for 'beforeStartDate'
 *      beforeStartTimestamp: // value for 'beforeStartTimestamp'
 *   },
 * });
 */
export function useAvailabilitiesByEmployeeIdQuery(baseOptions: Apollo.QueryHookOptions<AvailabilitiesByEmployeeIdQuery, AvailabilitiesByEmployeeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailabilitiesByEmployeeIdQuery, AvailabilitiesByEmployeeIdQueryVariables>(AvailabilitiesByEmployeeIdDocument, options);
      }
export function useAvailabilitiesByEmployeeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailabilitiesByEmployeeIdQuery, AvailabilitiesByEmployeeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailabilitiesByEmployeeIdQuery, AvailabilitiesByEmployeeIdQueryVariables>(AvailabilitiesByEmployeeIdDocument, options);
        }
export function useAvailabilitiesByEmployeeIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailabilitiesByEmployeeIdQuery, AvailabilitiesByEmployeeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailabilitiesByEmployeeIdQuery, AvailabilitiesByEmployeeIdQueryVariables>(AvailabilitiesByEmployeeIdDocument, options);
        }
export type AvailabilitiesByEmployeeIdQueryHookResult = ReturnType<typeof useAvailabilitiesByEmployeeIdQuery>;
export type AvailabilitiesByEmployeeIdLazyQueryHookResult = ReturnType<typeof useAvailabilitiesByEmployeeIdLazyQuery>;
export type AvailabilitiesByEmployeeIdSuspenseQueryHookResult = ReturnType<typeof useAvailabilitiesByEmployeeIdSuspenseQuery>;
export type AvailabilitiesByEmployeeIdQueryResult = Apollo.QueryResult<AvailabilitiesByEmployeeIdQuery, AvailabilitiesByEmployeeIdQueryVariables>;
export const AddEmployeeScheduleDocument = gql`
    mutation AddEmployeeSchedule($input: [schedule_insert_input!]!) {
  insert_schedule(
    objects: $input
    on_conflict: {constraint: schedule_pkey, update_columns: [employeeId, locationId, startTime, endTime, repeatableDayOfWeek, startingAt, endingAt]}
  ) {
    returning {
      createdAt
      employeeId
      endTime
      id
      locationId
      repeatableDayOfWeek
      startTime
      startingAt
      endingAt
      updatedAt
    }
  }
}
    `;
export type AddEmployeeScheduleMutationFn = Apollo.MutationFunction<AddEmployeeScheduleMutation, AddEmployeeScheduleMutationVariables>;

/**
 * __useAddEmployeeScheduleMutation__
 *
 * To run a mutation, you first call `useAddEmployeeScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEmployeeScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEmployeeScheduleMutation, { data, loading, error }] = useAddEmployeeScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEmployeeScheduleMutation(baseOptions?: Apollo.MutationHookOptions<AddEmployeeScheduleMutation, AddEmployeeScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEmployeeScheduleMutation, AddEmployeeScheduleMutationVariables>(AddEmployeeScheduleDocument, options);
      }
export type AddEmployeeScheduleMutationHookResult = ReturnType<typeof useAddEmployeeScheduleMutation>;
export type AddEmployeeScheduleMutationResult = Apollo.MutationResult<AddEmployeeScheduleMutation>;
export type AddEmployeeScheduleMutationOptions = Apollo.BaseMutationOptions<AddEmployeeScheduleMutation, AddEmployeeScheduleMutationVariables>;
export const GetServiceOptionAnswersDocument = gql`
    query GetServiceOptionAnswers($serviceOptionId: uuid!) {
  serviceOptionAnswers(
    where: {serviceOptionSectionOptionsId: {_eq: $serviceOptionId}}
  ) {
    id
    serviceOptionSectionOptionsId
  }
}
    `;

/**
 * __useGetServiceOptionAnswersQuery__
 *
 * To run a query within a React component, call `useGetServiceOptionAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceOptionAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceOptionAnswersQuery({
 *   variables: {
 *      serviceOptionId: // value for 'serviceOptionId'
 *   },
 * });
 */
export function useGetServiceOptionAnswersQuery(baseOptions: Apollo.QueryHookOptions<GetServiceOptionAnswersQuery, GetServiceOptionAnswersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceOptionAnswersQuery, GetServiceOptionAnswersQueryVariables>(GetServiceOptionAnswersDocument, options);
      }
export function useGetServiceOptionAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceOptionAnswersQuery, GetServiceOptionAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceOptionAnswersQuery, GetServiceOptionAnswersQueryVariables>(GetServiceOptionAnswersDocument, options);
        }
export function useGetServiceOptionAnswersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceOptionAnswersQuery, GetServiceOptionAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceOptionAnswersQuery, GetServiceOptionAnswersQueryVariables>(GetServiceOptionAnswersDocument, options);
        }
export type GetServiceOptionAnswersQueryHookResult = ReturnType<typeof useGetServiceOptionAnswersQuery>;
export type GetServiceOptionAnswersLazyQueryHookResult = ReturnType<typeof useGetServiceOptionAnswersLazyQuery>;
export type GetServiceOptionAnswersSuspenseQueryHookResult = ReturnType<typeof useGetServiceOptionAnswersSuspenseQuery>;
export type GetServiceOptionAnswersQueryResult = Apollo.QueryResult<GetServiceOptionAnswersQuery, GetServiceOptionAnswersQueryVariables>;
export const RemoveEmployeeScheduleByIdDocument = gql`
    mutation RemoveEmployeeScheduleById($id: uuid!) {
  delete_schedule_by_pk(id: $id) {
    id
  }
}
    `;
export type RemoveEmployeeScheduleByIdMutationFn = Apollo.MutationFunction<RemoveEmployeeScheduleByIdMutation, RemoveEmployeeScheduleByIdMutationVariables>;

/**
 * __useRemoveEmployeeScheduleByIdMutation__
 *
 * To run a mutation, you first call `useRemoveEmployeeScheduleByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEmployeeScheduleByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEmployeeScheduleByIdMutation, { data, loading, error }] = useRemoveEmployeeScheduleByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveEmployeeScheduleByIdMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEmployeeScheduleByIdMutation, RemoveEmployeeScheduleByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEmployeeScheduleByIdMutation, RemoveEmployeeScheduleByIdMutationVariables>(RemoveEmployeeScheduleByIdDocument, options);
      }
export type RemoveEmployeeScheduleByIdMutationHookResult = ReturnType<typeof useRemoveEmployeeScheduleByIdMutation>;
export type RemoveEmployeeScheduleByIdMutationResult = Apollo.MutationResult<RemoveEmployeeScheduleByIdMutation>;
export type RemoveEmployeeScheduleByIdMutationOptions = Apollo.BaseMutationOptions<RemoveEmployeeScheduleByIdMutation, RemoveEmployeeScheduleByIdMutationVariables>;
export const AddEmployeeTimeoutDocument = gql`
    mutation AddEmployeeTimeout($input: [timeouts_insert_input!]!) {
  insert_timeouts(
    objects: $input
    on_conflict: {constraint: timeouts_pkey, update_columns: [userId, locationId, serviceId, startDate, endDate]}
  ) {
    returning {
      id
      userId
      locationId
      serviceId
      startDate
      endDate
      createdAt
      updatedAt
    }
  }
}
    `;
export type AddEmployeeTimeoutMutationFn = Apollo.MutationFunction<AddEmployeeTimeoutMutation, AddEmployeeTimeoutMutationVariables>;

/**
 * __useAddEmployeeTimeoutMutation__
 *
 * To run a mutation, you first call `useAddEmployeeTimeoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEmployeeTimeoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEmployeeTimeoutMutation, { data, loading, error }] = useAddEmployeeTimeoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEmployeeTimeoutMutation(baseOptions?: Apollo.MutationHookOptions<AddEmployeeTimeoutMutation, AddEmployeeTimeoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEmployeeTimeoutMutation, AddEmployeeTimeoutMutationVariables>(AddEmployeeTimeoutDocument, options);
      }
export type AddEmployeeTimeoutMutationHookResult = ReturnType<typeof useAddEmployeeTimeoutMutation>;
export type AddEmployeeTimeoutMutationResult = Apollo.MutationResult<AddEmployeeTimeoutMutation>;
export type AddEmployeeTimeoutMutationOptions = Apollo.BaseMutationOptions<AddEmployeeTimeoutMutation, AddEmployeeTimeoutMutationVariables>;
export const RemoveEmployeeTimeoutByIdDocument = gql`
    mutation RemoveEmployeeTimeoutById($id: uuid!) {
  delete_timeouts_by_pk(id: $id) {
    id
    userId
    locationId
    serviceId
    startDate
    endDate
    createdAt
    updatedAt
  }
}
    `;
export type RemoveEmployeeTimeoutByIdMutationFn = Apollo.MutationFunction<RemoveEmployeeTimeoutByIdMutation, RemoveEmployeeTimeoutByIdMutationVariables>;

/**
 * __useRemoveEmployeeTimeoutByIdMutation__
 *
 * To run a mutation, you first call `useRemoveEmployeeTimeoutByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEmployeeTimeoutByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEmployeeTimeoutByIdMutation, { data, loading, error }] = useRemoveEmployeeTimeoutByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveEmployeeTimeoutByIdMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEmployeeTimeoutByIdMutation, RemoveEmployeeTimeoutByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEmployeeTimeoutByIdMutation, RemoveEmployeeTimeoutByIdMutationVariables>(RemoveEmployeeTimeoutByIdDocument, options);
      }
export type RemoveEmployeeTimeoutByIdMutationHookResult = ReturnType<typeof useRemoveEmployeeTimeoutByIdMutation>;
export type RemoveEmployeeTimeoutByIdMutationResult = Apollo.MutationResult<RemoveEmployeeTimeoutByIdMutation>;
export type RemoveEmployeeTimeoutByIdMutationOptions = Apollo.BaseMutationOptions<RemoveEmployeeTimeoutByIdMutation, RemoveEmployeeTimeoutByIdMutationVariables>;
export const SchedulesConflictsDocument = gql`
    query SchedulesConflicts($employeeId: uuid!, $startingAt: timestamptz!, $endingAt: timestamptz!, $locationId: uuid) {
  timeouts(
    where: {_and: [{_or: [{_and: [{startDate: {_lte: $startingAt}}, {endDate: {_is_null: true}}]}, {_and: [{startDate: {_lte: $startingAt}}, {endDate: {_gte: $startingAt}}]}, {_and: [{startDate: {_gte: $startingAt}}, {endDate: {_lte: $endingAt}}]}, {_and: [{startDate: {_gte: $startingAt}}, {startDate: {_lte: $endingAt}}]}]}, {userId: {_eq: $employeeId}}, {_or: [{locationId: {_eq: $locationId}}, {locationId: {_is_null: true}}]}]}
  ) {
    id
    userId
    locationId
    serviceId
    startDate
    endDate
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSchedulesConflictsQuery__
 *
 * To run a query within a React component, call `useSchedulesConflictsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchedulesConflictsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulesConflictsQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      startingAt: // value for 'startingAt'
 *      endingAt: // value for 'endingAt'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useSchedulesConflictsQuery(baseOptions: Apollo.QueryHookOptions<SchedulesConflictsQuery, SchedulesConflictsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchedulesConflictsQuery, SchedulesConflictsQueryVariables>(SchedulesConflictsDocument, options);
      }
export function useSchedulesConflictsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchedulesConflictsQuery, SchedulesConflictsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchedulesConflictsQuery, SchedulesConflictsQueryVariables>(SchedulesConflictsDocument, options);
        }
export function useSchedulesConflictsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchedulesConflictsQuery, SchedulesConflictsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchedulesConflictsQuery, SchedulesConflictsQueryVariables>(SchedulesConflictsDocument, options);
        }
export type SchedulesConflictsQueryHookResult = ReturnType<typeof useSchedulesConflictsQuery>;
export type SchedulesConflictsLazyQueryHookResult = ReturnType<typeof useSchedulesConflictsLazyQuery>;
export type SchedulesConflictsSuspenseQueryHookResult = ReturnType<typeof useSchedulesConflictsSuspenseQuery>;
export type SchedulesConflictsQueryResult = Apollo.QueryResult<SchedulesConflictsQuery, SchedulesConflictsQueryVariables>;
export const SchedulesWithoutEndDateConflictsDocument = gql`
    query SchedulesWithoutEndDateConflicts($employeeId: uuid!, $startingAt: timestamptz!, $locationId: uuid) {
  timeouts(
    where: {_and: [{userId: {_eq: $employeeId}}, {_or: [{_and: [{startDate: {_lte: $startingAt}}, {endDate: {_is_null: true}}]}, {_and: [{startDate: {_lte: $startingAt}}, {endDate: {_gte: $startingAt}}]}, {_and: [{startDate: {_gte: $startingAt}}, {endDate: {_is_null: true}}]}, {_and: [{startDate: {_gte: $startingAt}}, {endDate: {_gte: $startingAt}}]}]}, {_or: [{locationId: {_eq: $locationId}}, {locationId: {_is_null: true}}]}]}
  ) {
    id
    userId
    locationId
    serviceId
    startDate
    endDate
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSchedulesWithoutEndDateConflictsQuery__
 *
 * To run a query within a React component, call `useSchedulesWithoutEndDateConflictsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchedulesWithoutEndDateConflictsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulesWithoutEndDateConflictsQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      startingAt: // value for 'startingAt'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useSchedulesWithoutEndDateConflictsQuery(baseOptions: Apollo.QueryHookOptions<SchedulesWithoutEndDateConflictsQuery, SchedulesWithoutEndDateConflictsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchedulesWithoutEndDateConflictsQuery, SchedulesWithoutEndDateConflictsQueryVariables>(SchedulesWithoutEndDateConflictsDocument, options);
      }
export function useSchedulesWithoutEndDateConflictsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchedulesWithoutEndDateConflictsQuery, SchedulesWithoutEndDateConflictsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchedulesWithoutEndDateConflictsQuery, SchedulesWithoutEndDateConflictsQueryVariables>(SchedulesWithoutEndDateConflictsDocument, options);
        }
export function useSchedulesWithoutEndDateConflictsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchedulesWithoutEndDateConflictsQuery, SchedulesWithoutEndDateConflictsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchedulesWithoutEndDateConflictsQuery, SchedulesWithoutEndDateConflictsQueryVariables>(SchedulesWithoutEndDateConflictsDocument, options);
        }
export type SchedulesWithoutEndDateConflictsQueryHookResult = ReturnType<typeof useSchedulesWithoutEndDateConflictsQuery>;
export type SchedulesWithoutEndDateConflictsLazyQueryHookResult = ReturnType<typeof useSchedulesWithoutEndDateConflictsLazyQuery>;
export type SchedulesWithoutEndDateConflictsSuspenseQueryHookResult = ReturnType<typeof useSchedulesWithoutEndDateConflictsSuspenseQuery>;
export type SchedulesWithoutEndDateConflictsQueryResult = Apollo.QueryResult<SchedulesWithoutEndDateConflictsQuery, SchedulesWithoutEndDateConflictsQueryVariables>;
export const AppointmentConflictsDocument = gql`
    query AppointmentConflicts($startDate: timestamptz, $endDate: timestamptz, $locationIds: [uuid!], $serviceIds: [uuid!], $employeeIds: [uuid!]) {
  appointments(
    where: {_and: [{startDate: {_gte: $startDate}}, {endDate: {_lte: $endDate}}], _or: [{locationId: {_in: $locationIds}}, {serviceId: {_in: $serviceIds}}, {employeeId: {_in: $employeeIds}}]}
  ) {
    id
  }
}
    `;

/**
 * __useAppointmentConflictsQuery__
 *
 * To run a query within a React component, call `useAppointmentConflictsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentConflictsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentConflictsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      locationIds: // value for 'locationIds'
 *      serviceIds: // value for 'serviceIds'
 *      employeeIds: // value for 'employeeIds'
 *   },
 * });
 */
export function useAppointmentConflictsQuery(baseOptions?: Apollo.QueryHookOptions<AppointmentConflictsQuery, AppointmentConflictsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentConflictsQuery, AppointmentConflictsQueryVariables>(AppointmentConflictsDocument, options);
      }
export function useAppointmentConflictsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentConflictsQuery, AppointmentConflictsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentConflictsQuery, AppointmentConflictsQueryVariables>(AppointmentConflictsDocument, options);
        }
export function useAppointmentConflictsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AppointmentConflictsQuery, AppointmentConflictsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppointmentConflictsQuery, AppointmentConflictsQueryVariables>(AppointmentConflictsDocument, options);
        }
export type AppointmentConflictsQueryHookResult = ReturnType<typeof useAppointmentConflictsQuery>;
export type AppointmentConflictsLazyQueryHookResult = ReturnType<typeof useAppointmentConflictsLazyQuery>;
export type AppointmentConflictsSuspenseQueryHookResult = ReturnType<typeof useAppointmentConflictsSuspenseQuery>;
export type AppointmentConflictsQueryResult = Apollo.QueryResult<AppointmentConflictsQuery, AppointmentConflictsQueryVariables>;
export const UpcomingEmployeesAppointmentsDocument = gql`
    query UpcomingEmployeesAppointments($userIds: [uuid!]!) {
  appointments_aggregate(
    where: {startDate: {_gte: "now()"}, employeeId: {_in: $userIds}}
  ) {
    aggregate {
      count
    }
    nodes {
      userByEmployeeid {
        name
      }
    }
  }
}
    `;

/**
 * __useUpcomingEmployeesAppointmentsQuery__
 *
 * To run a query within a React component, call `useUpcomingEmployeesAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingEmployeesAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingEmployeesAppointmentsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useUpcomingEmployeesAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<UpcomingEmployeesAppointmentsQuery, UpcomingEmployeesAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpcomingEmployeesAppointmentsQuery, UpcomingEmployeesAppointmentsQueryVariables>(UpcomingEmployeesAppointmentsDocument, options);
      }
export function useUpcomingEmployeesAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpcomingEmployeesAppointmentsQuery, UpcomingEmployeesAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpcomingEmployeesAppointmentsQuery, UpcomingEmployeesAppointmentsQueryVariables>(UpcomingEmployeesAppointmentsDocument, options);
        }
export function useUpcomingEmployeesAppointmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpcomingEmployeesAppointmentsQuery, UpcomingEmployeesAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpcomingEmployeesAppointmentsQuery, UpcomingEmployeesAppointmentsQueryVariables>(UpcomingEmployeesAppointmentsDocument, options);
        }
export type UpcomingEmployeesAppointmentsQueryHookResult = ReturnType<typeof useUpcomingEmployeesAppointmentsQuery>;
export type UpcomingEmployeesAppointmentsLazyQueryHookResult = ReturnType<typeof useUpcomingEmployeesAppointmentsLazyQuery>;
export type UpcomingEmployeesAppointmentsSuspenseQueryHookResult = ReturnType<typeof useUpcomingEmployeesAppointmentsSuspenseQuery>;
export type UpcomingEmployeesAppointmentsQueryResult = Apollo.QueryResult<UpcomingEmployeesAppointmentsQuery, UpcomingEmployeesAppointmentsQueryVariables>;
export const DeleteEmployeesDocument = gql`
    mutation DeleteEmployees($usersIds: [uuid!]!) {
  update_userRoles(where: {userId: {_in: $usersIds}}, _set: {deletedAt: "now()"}) {
    returning {
      userId
    }
  }
  delete_schedule(
    where: {startingAt: {_gte: "now()"}, employeeId: {_in: $usersIds}}
  ) {
    affected_rows
  }
  delete_timeouts(where: {startDate: {_gte: "now()"}, userId: {_in: $usersIds}}) {
    affected_rows
  }
}
    `;
export type DeleteEmployeesMutationFn = Apollo.MutationFunction<DeleteEmployeesMutation, DeleteEmployeesMutationVariables>;

/**
 * __useDeleteEmployeesMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeesMutation, { data, loading, error }] = useDeleteEmployeesMutation({
 *   variables: {
 *      usersIds: // value for 'usersIds'
 *   },
 * });
 */
export function useDeleteEmployeesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeesMutation, DeleteEmployeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeesMutation, DeleteEmployeesMutationVariables>(DeleteEmployeesDocument, options);
      }
export type DeleteEmployeesMutationHookResult = ReturnType<typeof useDeleteEmployeesMutation>;
export type DeleteEmployeesMutationResult = Apollo.MutationResult<DeleteEmployeesMutation>;
export type DeleteEmployeesMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeesMutation, DeleteEmployeesMutationVariables>;
export const ProviderCardDocument = gql`
    query ProviderCard {
  getProviderCard {
    id
    brand
    expMonth
    expYear
    last4
    name
  }
}
    `;

/**
 * __useProviderCardQuery__
 *
 * To run a query within a React component, call `useProviderCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderCardQuery(baseOptions?: Apollo.QueryHookOptions<ProviderCardQuery, ProviderCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderCardQuery, ProviderCardQueryVariables>(ProviderCardDocument, options);
      }
export function useProviderCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderCardQuery, ProviderCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderCardQuery, ProviderCardQueryVariables>(ProviderCardDocument, options);
        }
export function useProviderCardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProviderCardQuery, ProviderCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderCardQuery, ProviderCardQueryVariables>(ProviderCardDocument, options);
        }
export type ProviderCardQueryHookResult = ReturnType<typeof useProviderCardQuery>;
export type ProviderCardLazyQueryHookResult = ReturnType<typeof useProviderCardLazyQuery>;
export type ProviderCardSuspenseQueryHookResult = ReturnType<typeof useProviderCardSuspenseQuery>;
export type ProviderCardQueryResult = Apollo.QueryResult<ProviderCardQuery, ProviderCardQueryVariables>;
export const CreateProviderSetupIntentDocument = gql`
    mutation CreateProviderSetupIntent($confirmationTokenId: String!) {
  createProviderSetupIntent(confirmationTokenId: $confirmationTokenId) {
    clientSecret
    status
  }
}
    `;
export type CreateProviderSetupIntentMutationFn = Apollo.MutationFunction<CreateProviderSetupIntentMutation, CreateProviderSetupIntentMutationVariables>;

/**
 * __useCreateProviderSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateProviderSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProviderSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProviderSetupIntentMutation, { data, loading, error }] = useCreateProviderSetupIntentMutation({
 *   variables: {
 *      confirmationTokenId: // value for 'confirmationTokenId'
 *   },
 * });
 */
export function useCreateProviderSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateProviderSetupIntentMutation, CreateProviderSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProviderSetupIntentMutation, CreateProviderSetupIntentMutationVariables>(CreateProviderSetupIntentDocument, options);
      }
export type CreateProviderSetupIntentMutationHookResult = ReturnType<typeof useCreateProviderSetupIntentMutation>;
export type CreateProviderSetupIntentMutationResult = Apollo.MutationResult<CreateProviderSetupIntentMutation>;
export type CreateProviderSetupIntentMutationOptions = Apollo.BaseMutationOptions<CreateProviderSetupIntentMutation, CreateProviderSetupIntentMutationVariables>;
export const DeleteProviderPaymentMethodDocument = gql`
    mutation DeleteProviderPaymentMethod {
  deleteProviderPaymentMethod {
    id
  }
}
    `;
export type DeleteProviderPaymentMethodMutationFn = Apollo.MutationFunction<DeleteProviderPaymentMethodMutation, DeleteProviderPaymentMethodMutationVariables>;

/**
 * __useDeleteProviderPaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeleteProviderPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderPaymentMethodMutation, { data, loading, error }] = useDeleteProviderPaymentMethodMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteProviderPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProviderPaymentMethodMutation, DeleteProviderPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProviderPaymentMethodMutation, DeleteProviderPaymentMethodMutationVariables>(DeleteProviderPaymentMethodDocument, options);
      }
export type DeleteProviderPaymentMethodMutationHookResult = ReturnType<typeof useDeleteProviderPaymentMethodMutation>;
export type DeleteProviderPaymentMethodMutationResult = Apollo.MutationResult<DeleteProviderPaymentMethodMutation>;
export type DeleteProviderPaymentMethodMutationOptions = Apollo.BaseMutationOptions<DeleteProviderPaymentMethodMutation, DeleteProviderPaymentMethodMutationVariables>;
export const CountUnpaidAppointmentsDocument = gql`
    query CountUnpaidAppointments($providerId: uuid!) {
  appointments_aggregate(
    where: {service: {providerId: {_eq: $providerId}}, providerMonthlyPaymentId: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useCountUnpaidAppointmentsQuery__
 *
 * To run a query within a React component, call `useCountUnpaidAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountUnpaidAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountUnpaidAppointmentsQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useCountUnpaidAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<CountUnpaidAppointmentsQuery, CountUnpaidAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountUnpaidAppointmentsQuery, CountUnpaidAppointmentsQueryVariables>(CountUnpaidAppointmentsDocument, options);
      }
export function useCountUnpaidAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountUnpaidAppointmentsQuery, CountUnpaidAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountUnpaidAppointmentsQuery, CountUnpaidAppointmentsQueryVariables>(CountUnpaidAppointmentsDocument, options);
        }
export function useCountUnpaidAppointmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountUnpaidAppointmentsQuery, CountUnpaidAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountUnpaidAppointmentsQuery, CountUnpaidAppointmentsQueryVariables>(CountUnpaidAppointmentsDocument, options);
        }
export type CountUnpaidAppointmentsQueryHookResult = ReturnType<typeof useCountUnpaidAppointmentsQuery>;
export type CountUnpaidAppointmentsLazyQueryHookResult = ReturnType<typeof useCountUnpaidAppointmentsLazyQuery>;
export type CountUnpaidAppointmentsSuspenseQueryHookResult = ReturnType<typeof useCountUnpaidAppointmentsSuspenseQuery>;
export type CountUnpaidAppointmentsQueryResult = Apollo.QueryResult<CountUnpaidAppointmentsQuery, CountUnpaidAppointmentsQueryVariables>;
export const ProviderPaymentsDocument = gql`
    query ProviderPayments($limit: Float!, $startingAfter: String) {
  providerPayments(limit: $limit, startingAfter: $startingAfter) {
    data {
      id
      date
      amount
      status
      currency
    }
    totalCount
  }
}
    `;

/**
 * __useProviderPaymentsQuery__
 *
 * To run a query within a React component, call `useProviderPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderPaymentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      startingAfter: // value for 'startingAfter'
 *   },
 * });
 */
export function useProviderPaymentsQuery(baseOptions: Apollo.QueryHookOptions<ProviderPaymentsQuery, ProviderPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderPaymentsQuery, ProviderPaymentsQueryVariables>(ProviderPaymentsDocument, options);
      }
export function useProviderPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderPaymentsQuery, ProviderPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderPaymentsQuery, ProviderPaymentsQueryVariables>(ProviderPaymentsDocument, options);
        }
export function useProviderPaymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProviderPaymentsQuery, ProviderPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderPaymentsQuery, ProviderPaymentsQueryVariables>(ProviderPaymentsDocument, options);
        }
export type ProviderPaymentsQueryHookResult = ReturnType<typeof useProviderPaymentsQuery>;
export type ProviderPaymentsLazyQueryHookResult = ReturnType<typeof useProviderPaymentsLazyQuery>;
export type ProviderPaymentsSuspenseQueryHookResult = ReturnType<typeof useProviderPaymentsSuspenseQuery>;
export type ProviderPaymentsQueryResult = Apollo.QueryResult<ProviderPaymentsQuery, ProviderPaymentsQueryVariables>;
export const EditProviderBookingSettingsDocument = gql`
    mutation EditProviderBookingSettings($providerId: uuid!, $bookingStatus: bookingStatus_enum!, $bookingCancelationWarningPeriod: Int) {
  update_providers_by_pk(
    pk_columns: {id: $providerId}
    _set: {bookingDefaultStatus: $bookingStatus, bookingCancelationWarningPeriod: $bookingCancelationWarningPeriod}
  ) {
    id
    bookingDefaultStatus
    bookingCancelationWarningPeriod
  }
}
    `;
export type EditProviderBookingSettingsMutationFn = Apollo.MutationFunction<EditProviderBookingSettingsMutation, EditProviderBookingSettingsMutationVariables>;

/**
 * __useEditProviderBookingSettingsMutation__
 *
 * To run a mutation, you first call `useEditProviderBookingSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProviderBookingSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProviderBookingSettingsMutation, { data, loading, error }] = useEditProviderBookingSettingsMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      bookingStatus: // value for 'bookingStatus'
 *      bookingCancelationWarningPeriod: // value for 'bookingCancelationWarningPeriod'
 *   },
 * });
 */
export function useEditProviderBookingSettingsMutation(baseOptions?: Apollo.MutationHookOptions<EditProviderBookingSettingsMutation, EditProviderBookingSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProviderBookingSettingsMutation, EditProviderBookingSettingsMutationVariables>(EditProviderBookingSettingsDocument, options);
      }
export type EditProviderBookingSettingsMutationHookResult = ReturnType<typeof useEditProviderBookingSettingsMutation>;
export type EditProviderBookingSettingsMutationResult = Apollo.MutationResult<EditProviderBookingSettingsMutation>;
export type EditProviderBookingSettingsMutationOptions = Apollo.BaseMutationOptions<EditProviderBookingSettingsMutation, EditProviderBookingSettingsMutationVariables>;
export const EditProviderBusinessDetailsDocument = gql`
    mutation EditProviderBusinessDetails($providerId: uuid!, $name: String!, $address: String!, $phoneNumber: String!) {
  update_providers_by_pk(
    pk_columns: {id: $providerId}
    _set: {name: $name, address: $address, phoneNumber: $phoneNumber}
  ) {
    id
    name
    address
    phoneNumber
  }
}
    `;
export type EditProviderBusinessDetailsMutationFn = Apollo.MutationFunction<EditProviderBusinessDetailsMutation, EditProviderBusinessDetailsMutationVariables>;

/**
 * __useEditProviderBusinessDetailsMutation__
 *
 * To run a mutation, you first call `useEditProviderBusinessDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProviderBusinessDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProviderBusinessDetailsMutation, { data, loading, error }] = useEditProviderBusinessDetailsMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      name: // value for 'name'
 *      address: // value for 'address'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useEditProviderBusinessDetailsMutation(baseOptions?: Apollo.MutationHookOptions<EditProviderBusinessDetailsMutation, EditProviderBusinessDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProviderBusinessDetailsMutation, EditProviderBusinessDetailsMutationVariables>(EditProviderBusinessDetailsDocument, options);
      }
export type EditProviderBusinessDetailsMutationHookResult = ReturnType<typeof useEditProviderBusinessDetailsMutation>;
export type EditProviderBusinessDetailsMutationResult = Apollo.MutationResult<EditProviderBusinessDetailsMutation>;
export type EditProviderBusinessDetailsMutationOptions = Apollo.BaseMutationOptions<EditProviderBusinessDetailsMutation, EditProviderBusinessDetailsMutationVariables>;
export const EditProviderBusinessDescriptionDocument = gql`
    mutation EditProviderBusinessDescription($providerId: uuid!, $description: String!) {
  update_providers_by_pk(
    pk_columns: {id: $providerId}
    _set: {description: $description}
  ) {
    id
    description
  }
}
    `;
export type EditProviderBusinessDescriptionMutationFn = Apollo.MutationFunction<EditProviderBusinessDescriptionMutation, EditProviderBusinessDescriptionMutationVariables>;

/**
 * __useEditProviderBusinessDescriptionMutation__
 *
 * To run a mutation, you first call `useEditProviderBusinessDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProviderBusinessDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProviderBusinessDescriptionMutation, { data, loading, error }] = useEditProviderBusinessDescriptionMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useEditProviderBusinessDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<EditProviderBusinessDescriptionMutation, EditProviderBusinessDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProviderBusinessDescriptionMutation, EditProviderBusinessDescriptionMutationVariables>(EditProviderBusinessDescriptionDocument, options);
      }
export type EditProviderBusinessDescriptionMutationHookResult = ReturnType<typeof useEditProviderBusinessDescriptionMutation>;
export type EditProviderBusinessDescriptionMutationResult = Apollo.MutationResult<EditProviderBusinessDescriptionMutation>;
export type EditProviderBusinessDescriptionMutationOptions = Apollo.BaseMutationOptions<EditProviderBusinessDescriptionMutation, EditProviderBusinessDescriptionMutationVariables>;
export const GetFutureAppointmentsByServiceIdsDocument = gql`
    query GetFutureAppointmentsByServiceIds($serviceIds: [uuid!]) {
  appointments(where: {serviceId: {_in: $serviceIds}, startDate: {_gte: "now()"}}) {
    id
    startDate
  }
}
    `;

/**
 * __useGetFutureAppointmentsByServiceIdsQuery__
 *
 * To run a query within a React component, call `useGetFutureAppointmentsByServiceIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFutureAppointmentsByServiceIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFutureAppointmentsByServiceIdsQuery({
 *   variables: {
 *      serviceIds: // value for 'serviceIds'
 *   },
 * });
 */
export function useGetFutureAppointmentsByServiceIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetFutureAppointmentsByServiceIdsQuery, GetFutureAppointmentsByServiceIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFutureAppointmentsByServiceIdsQuery, GetFutureAppointmentsByServiceIdsQueryVariables>(GetFutureAppointmentsByServiceIdsDocument, options);
      }
export function useGetFutureAppointmentsByServiceIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFutureAppointmentsByServiceIdsQuery, GetFutureAppointmentsByServiceIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFutureAppointmentsByServiceIdsQuery, GetFutureAppointmentsByServiceIdsQueryVariables>(GetFutureAppointmentsByServiceIdsDocument, options);
        }
export function useGetFutureAppointmentsByServiceIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFutureAppointmentsByServiceIdsQuery, GetFutureAppointmentsByServiceIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFutureAppointmentsByServiceIdsQuery, GetFutureAppointmentsByServiceIdsQueryVariables>(GetFutureAppointmentsByServiceIdsDocument, options);
        }
export type GetFutureAppointmentsByServiceIdsQueryHookResult = ReturnType<typeof useGetFutureAppointmentsByServiceIdsQuery>;
export type GetFutureAppointmentsByServiceIdsLazyQueryHookResult = ReturnType<typeof useGetFutureAppointmentsByServiceIdsLazyQuery>;
export type GetFutureAppointmentsByServiceIdsSuspenseQueryHookResult = ReturnType<typeof useGetFutureAppointmentsByServiceIdsSuspenseQuery>;
export type GetFutureAppointmentsByServiceIdsQueryResult = Apollo.QueryResult<GetFutureAppointmentsByServiceIdsQuery, GetFutureAppointmentsByServiceIdsQueryVariables>;
export const UpdateServiceByIdDocument = gql`
    mutation UpdateServiceById($id: uuid!, $input: services_set_input!) {
  update_services_by_pk(pk_columns: {id: $id}, _set: $input) {
    id
    name
    sku
    featured
    status
    description
  }
}
    `;
export type UpdateServiceByIdMutationFn = Apollo.MutationFunction<UpdateServiceByIdMutation, UpdateServiceByIdMutationVariables>;

/**
 * __useUpdateServiceByIdMutation__
 *
 * To run a mutation, you first call `useUpdateServiceByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceByIdMutation, { data, loading, error }] = useUpdateServiceByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateServiceByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceByIdMutation, UpdateServiceByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceByIdMutation, UpdateServiceByIdMutationVariables>(UpdateServiceByIdDocument, options);
      }
export type UpdateServiceByIdMutationHookResult = ReturnType<typeof useUpdateServiceByIdMutation>;
export type UpdateServiceByIdMutationResult = Apollo.MutationResult<UpdateServiceByIdMutation>;
export type UpdateServiceByIdMutationOptions = Apollo.BaseMutationOptions<UpdateServiceByIdMutation, UpdateServiceByIdMutationVariables>;
export const DeleteServiceByIdDocument = gql`
    mutation DeleteServiceById($serviceIds: [uuid!]) {
  update_services(where: {id: {_in: $serviceIds}}, _set: {deletedAt: "now()"}) {
    returning {
      id
    }
  }
  delete_timeouts(where: {serviceId: {_in: $serviceIds}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteServiceByIdMutationFn = Apollo.MutationFunction<DeleteServiceByIdMutation, DeleteServiceByIdMutationVariables>;

/**
 * __useDeleteServiceByIdMutation__
 *
 * To run a mutation, you first call `useDeleteServiceByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceByIdMutation, { data, loading, error }] = useDeleteServiceByIdMutation({
 *   variables: {
 *      serviceIds: // value for 'serviceIds'
 *   },
 * });
 */
export function useDeleteServiceByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceByIdMutation, DeleteServiceByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceByIdMutation, DeleteServiceByIdMutationVariables>(DeleteServiceByIdDocument, options);
      }
export type DeleteServiceByIdMutationHookResult = ReturnType<typeof useDeleteServiceByIdMutation>;
export type DeleteServiceByIdMutationResult = Apollo.MutationResult<DeleteServiceByIdMutation>;
export type DeleteServiceByIdMutationOptions = Apollo.BaseMutationOptions<DeleteServiceByIdMutation, DeleteServiceByIdMutationVariables>;
export const AvailableAppointmentDateTimeSlotsDocument = gql`
    query AvailableAppointmentDateTimeSlots($inputs: TimeSlotsDto!) {
  availableAppointmentDateTimeSlots(inputs: $inputs) {
    availableSlots {
      date
      employeeId
    }
  }
}
    `;

/**
 * __useAvailableAppointmentDateTimeSlotsQuery__
 *
 * To run a query within a React component, call `useAvailableAppointmentDateTimeSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableAppointmentDateTimeSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableAppointmentDateTimeSlotsQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useAvailableAppointmentDateTimeSlotsQuery(baseOptions: Apollo.QueryHookOptions<AvailableAppointmentDateTimeSlotsQuery, AvailableAppointmentDateTimeSlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableAppointmentDateTimeSlotsQuery, AvailableAppointmentDateTimeSlotsQueryVariables>(AvailableAppointmentDateTimeSlotsDocument, options);
      }
export function useAvailableAppointmentDateTimeSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableAppointmentDateTimeSlotsQuery, AvailableAppointmentDateTimeSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableAppointmentDateTimeSlotsQuery, AvailableAppointmentDateTimeSlotsQueryVariables>(AvailableAppointmentDateTimeSlotsDocument, options);
        }
export function useAvailableAppointmentDateTimeSlotsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailableAppointmentDateTimeSlotsQuery, AvailableAppointmentDateTimeSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableAppointmentDateTimeSlotsQuery, AvailableAppointmentDateTimeSlotsQueryVariables>(AvailableAppointmentDateTimeSlotsDocument, options);
        }
export type AvailableAppointmentDateTimeSlotsQueryHookResult = ReturnType<typeof useAvailableAppointmentDateTimeSlotsQuery>;
export type AvailableAppointmentDateTimeSlotsLazyQueryHookResult = ReturnType<typeof useAvailableAppointmentDateTimeSlotsLazyQuery>;
export type AvailableAppointmentDateTimeSlotsSuspenseQueryHookResult = ReturnType<typeof useAvailableAppointmentDateTimeSlotsSuspenseQuery>;
export type AvailableAppointmentDateTimeSlotsQueryResult = Apollo.QueryResult<AvailableAppointmentDateTimeSlotsQuery, AvailableAppointmentDateTimeSlotsQueryVariables>;
export const CreateAppointmentSpDocument = gql`
    mutation CreateAppointmentSP($serviceId: String!, $customerId: String!, $employeeId: String!, $locationId: String!, $date: DateTime!, $address: String!, $optionAnswers: [CreateApptServiceOptionAnswers!]!, $coordinates: [Float!]!, $apartmentNumber: String, $formAnswers: [CreateApptServiceFormAnswers!]!) {
  createAppointmentSP(
    data: {serviceId: $serviceId, customerId: $customerId, employeeId: $employeeId, locationId: $locationId, address: $address, date: $date, createApptServiceOptionAnswers: $optionAnswers, coordinates: $coordinates, apartmentNumber: $apartmentNumber, createApptServiceFormAnswers: $formAnswers}
  ) {
    id
    customerId
    employeeId
    startDate
    endDate
    jobStatus
    address
    apartmentNumber
    coordinates {
      coordinates
    }
    service {
      name
      color
    }
  }
}
    `;
export type CreateAppointmentSpMutationFn = Apollo.MutationFunction<CreateAppointmentSpMutation, CreateAppointmentSpMutationVariables>;

/**
 * __useCreateAppointmentSpMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentSpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentSpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentSpMutation, { data, loading, error }] = useCreateAppointmentSpMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      customerId: // value for 'customerId'
 *      employeeId: // value for 'employeeId'
 *      locationId: // value for 'locationId'
 *      date: // value for 'date'
 *      address: // value for 'address'
 *      optionAnswers: // value for 'optionAnswers'
 *      coordinates: // value for 'coordinates'
 *      apartmentNumber: // value for 'apartmentNumber'
 *      formAnswers: // value for 'formAnswers'
 *   },
 * });
 */
export function useCreateAppointmentSpMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentSpMutation, CreateAppointmentSpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentSpMutation, CreateAppointmentSpMutationVariables>(CreateAppointmentSpDocument, options);
      }
export type CreateAppointmentSpMutationHookResult = ReturnType<typeof useCreateAppointmentSpMutation>;
export type CreateAppointmentSpMutationResult = Apollo.MutationResult<CreateAppointmentSpMutation>;
export type CreateAppointmentSpMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentSpMutation, CreateAppointmentSpMutationVariables>;
export const ProviderBookingDefaultStatusDocument = gql`
    query ProviderBookingDefaultStatus($providerId: uuid!) {
  providers_by_pk(id: $providerId) {
    bookingDefaultStatus
  }
}
    `;

/**
 * __useProviderBookingDefaultStatusQuery__
 *
 * To run a query within a React component, call `useProviderBookingDefaultStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderBookingDefaultStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderBookingDefaultStatusQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useProviderBookingDefaultStatusQuery(baseOptions: Apollo.QueryHookOptions<ProviderBookingDefaultStatusQuery, ProviderBookingDefaultStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderBookingDefaultStatusQuery, ProviderBookingDefaultStatusQueryVariables>(ProviderBookingDefaultStatusDocument, options);
      }
export function useProviderBookingDefaultStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderBookingDefaultStatusQuery, ProviderBookingDefaultStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderBookingDefaultStatusQuery, ProviderBookingDefaultStatusQueryVariables>(ProviderBookingDefaultStatusDocument, options);
        }
export function useProviderBookingDefaultStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProviderBookingDefaultStatusQuery, ProviderBookingDefaultStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderBookingDefaultStatusQuery, ProviderBookingDefaultStatusQueryVariables>(ProviderBookingDefaultStatusDocument, options);
        }
export type ProviderBookingDefaultStatusQueryHookResult = ReturnType<typeof useProviderBookingDefaultStatusQuery>;
export type ProviderBookingDefaultStatusLazyQueryHookResult = ReturnType<typeof useProviderBookingDefaultStatusLazyQuery>;
export type ProviderBookingDefaultStatusSuspenseQueryHookResult = ReturnType<typeof useProviderBookingDefaultStatusSuspenseQuery>;
export type ProviderBookingDefaultStatusQueryResult = Apollo.QueryResult<ProviderBookingDefaultStatusQuery, ProviderBookingDefaultStatusQueryVariables>;
export const SearchProvidersAndServicesNearbyDocument = gql`
    query SearchProvidersAndServicesNearby($location: geography!, $distanceInMeters: Float!) {
  providers(
    where: {status: {_eq: approved}, visibility: {_eq: public}, _or: [{locations: {deletedAt: {_is_null: true}, coordinates: {_st_d_within: {distance: $distanceInMeters, from: $location}}}}, {buildingProviders: {status: {_eq: approved}, location: {coordinates: {_st_d_within: {distance: $distanceInMeters, from: $location}}}}}]}
  ) {
    id
    name
    providerPictureByProfilePic {
      id
      name
      file {
        id
        name
        uploadName
      }
    }
    providerPictureByCoverPic {
      id
      name
      file {
        id
        name
        uploadName
      }
    }
    buildingProviders {
      id
      location {
        address
      }
    }
    slug
    category
    status
    locations(where: {status: {_eq: active}, deletedAt: {_is_null: true}}) {
      id
      name
      address
      type
    }
    services(where: {status: {_eq: active}, deletedAt: {_is_null: true}}) {
      id
      sku
      name
      featured
      description
      servicePricing {
        id
        basePrice
      }
    }
  }
}
    `;

/**
 * __useSearchProvidersAndServicesNearbyQuery__
 *
 * To run a query within a React component, call `useSearchProvidersAndServicesNearbyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProvidersAndServicesNearbyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProvidersAndServicesNearbyQuery({
 *   variables: {
 *      location: // value for 'location'
 *      distanceInMeters: // value for 'distanceInMeters'
 *   },
 * });
 */
export function useSearchProvidersAndServicesNearbyQuery(baseOptions: Apollo.QueryHookOptions<SearchProvidersAndServicesNearbyQuery, SearchProvidersAndServicesNearbyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchProvidersAndServicesNearbyQuery, SearchProvidersAndServicesNearbyQueryVariables>(SearchProvidersAndServicesNearbyDocument, options);
      }
export function useSearchProvidersAndServicesNearbyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchProvidersAndServicesNearbyQuery, SearchProvidersAndServicesNearbyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchProvidersAndServicesNearbyQuery, SearchProvidersAndServicesNearbyQueryVariables>(SearchProvidersAndServicesNearbyDocument, options);
        }
export function useSearchProvidersAndServicesNearbySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchProvidersAndServicesNearbyQuery, SearchProvidersAndServicesNearbyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchProvidersAndServicesNearbyQuery, SearchProvidersAndServicesNearbyQueryVariables>(SearchProvidersAndServicesNearbyDocument, options);
        }
export type SearchProvidersAndServicesNearbyQueryHookResult = ReturnType<typeof useSearchProvidersAndServicesNearbyQuery>;
export type SearchProvidersAndServicesNearbyLazyQueryHookResult = ReturnType<typeof useSearchProvidersAndServicesNearbyLazyQuery>;
export type SearchProvidersAndServicesNearbySuspenseQueryHookResult = ReturnType<typeof useSearchProvidersAndServicesNearbySuspenseQuery>;
export type SearchProvidersAndServicesNearbyQueryResult = Apollo.QueryResult<SearchProvidersAndServicesNearbyQuery, SearchProvidersAndServicesNearbyQueryVariables>;
export const ProviderVisibilityDocument = gql`
    query ProviderVisibility {
  getProviderVisibility {
    status {
      hasActiveLocations
      hasEmployeesWithSchedules
      hasActiveServices
      hasPaymentMethod
      hasGeneralSettings
      hasPublicProfileSettings
      isApprovedByAdmin
    }
    visibility
  }
}
    `;

/**
 * __useProviderVisibilityQuery__
 *
 * To run a query within a React component, call `useProviderVisibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderVisibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderVisibilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderVisibilityQuery(baseOptions?: Apollo.QueryHookOptions<ProviderVisibilityQuery, ProviderVisibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderVisibilityQuery, ProviderVisibilityQueryVariables>(ProviderVisibilityDocument, options);
      }
export function useProviderVisibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderVisibilityQuery, ProviderVisibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderVisibilityQuery, ProviderVisibilityQueryVariables>(ProviderVisibilityDocument, options);
        }
export function useProviderVisibilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProviderVisibilityQuery, ProviderVisibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderVisibilityQuery, ProviderVisibilityQueryVariables>(ProviderVisibilityDocument, options);
        }
export type ProviderVisibilityQueryHookResult = ReturnType<typeof useProviderVisibilityQuery>;
export type ProviderVisibilityLazyQueryHookResult = ReturnType<typeof useProviderVisibilityLazyQuery>;
export type ProviderVisibilitySuspenseQueryHookResult = ReturnType<typeof useProviderVisibilitySuspenseQuery>;
export type ProviderVisibilityQueryResult = Apollo.QueryResult<ProviderVisibilityQuery, ProviderVisibilityQueryVariables>;
export const ProvidersInBuildingByAddressDocument = gql`
    query ProvidersInBuildingByAddress($address: String) {
  providers(
    where: {buildingProviders: {status: {_eq: approved}, location: {address: {_eq: $address}, buildingManagerId: {_is_null: false}}}}
  ) {
    ...ProvidersInBuilding
  }
}
    ${ProvidersInBuildingFragmentDoc}`;

/**
 * __useProvidersInBuildingByAddressQuery__
 *
 * To run a query within a React component, call `useProvidersInBuildingByAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useProvidersInBuildingByAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProvidersInBuildingByAddressQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useProvidersInBuildingByAddressQuery(baseOptions?: Apollo.QueryHookOptions<ProvidersInBuildingByAddressQuery, ProvidersInBuildingByAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProvidersInBuildingByAddressQuery, ProvidersInBuildingByAddressQueryVariables>(ProvidersInBuildingByAddressDocument, options);
      }
export function useProvidersInBuildingByAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProvidersInBuildingByAddressQuery, ProvidersInBuildingByAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProvidersInBuildingByAddressQuery, ProvidersInBuildingByAddressQueryVariables>(ProvidersInBuildingByAddressDocument, options);
        }
export function useProvidersInBuildingByAddressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProvidersInBuildingByAddressQuery, ProvidersInBuildingByAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProvidersInBuildingByAddressQuery, ProvidersInBuildingByAddressQueryVariables>(ProvidersInBuildingByAddressDocument, options);
        }
export type ProvidersInBuildingByAddressQueryHookResult = ReturnType<typeof useProvidersInBuildingByAddressQuery>;
export type ProvidersInBuildingByAddressLazyQueryHookResult = ReturnType<typeof useProvidersInBuildingByAddressLazyQuery>;
export type ProvidersInBuildingByAddressSuspenseQueryHookResult = ReturnType<typeof useProvidersInBuildingByAddressSuspenseQuery>;
export type ProvidersInBuildingByAddressQueryResult = Apollo.QueryResult<ProvidersInBuildingByAddressQuery, ProvidersInBuildingByAddressQueryVariables>;
export const ProvidersInBuildingByCoordinatesDocument = gql`
    query ProvidersInBuildingByCoordinates($coordinates: geography) {
  providers(
    where: {buildingProviders: {status: {_eq: approved}, location: {coordinates: {_eq: $coordinates}, buildingManagerId: {_is_null: false}}}}
  ) {
    ...ProvidersInBuilding
  }
}
    ${ProvidersInBuildingFragmentDoc}`;

/**
 * __useProvidersInBuildingByCoordinatesQuery__
 *
 * To run a query within a React component, call `useProvidersInBuildingByCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProvidersInBuildingByCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProvidersInBuildingByCoordinatesQuery({
 *   variables: {
 *      coordinates: // value for 'coordinates'
 *   },
 * });
 */
export function useProvidersInBuildingByCoordinatesQuery(baseOptions?: Apollo.QueryHookOptions<ProvidersInBuildingByCoordinatesQuery, ProvidersInBuildingByCoordinatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProvidersInBuildingByCoordinatesQuery, ProvidersInBuildingByCoordinatesQueryVariables>(ProvidersInBuildingByCoordinatesDocument, options);
      }
export function useProvidersInBuildingByCoordinatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProvidersInBuildingByCoordinatesQuery, ProvidersInBuildingByCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProvidersInBuildingByCoordinatesQuery, ProvidersInBuildingByCoordinatesQueryVariables>(ProvidersInBuildingByCoordinatesDocument, options);
        }
export function useProvidersInBuildingByCoordinatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProvidersInBuildingByCoordinatesQuery, ProvidersInBuildingByCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProvidersInBuildingByCoordinatesQuery, ProvidersInBuildingByCoordinatesQueryVariables>(ProvidersInBuildingByCoordinatesDocument, options);
        }
export type ProvidersInBuildingByCoordinatesQueryHookResult = ReturnType<typeof useProvidersInBuildingByCoordinatesQuery>;
export type ProvidersInBuildingByCoordinatesLazyQueryHookResult = ReturnType<typeof useProvidersInBuildingByCoordinatesLazyQuery>;
export type ProvidersInBuildingByCoordinatesSuspenseQueryHookResult = ReturnType<typeof useProvidersInBuildingByCoordinatesSuspenseQuery>;
export type ProvidersInBuildingByCoordinatesQueryResult = Apollo.QueryResult<ProvidersInBuildingByCoordinatesQuery, ProvidersInBuildingByCoordinatesQueryVariables>;
export const ServicesDocument = gql`
    query Services($limit: Int, $offset: Int, $searchByName: String!) {
  services(
    limit: $limit
    offset: $offset
    where: {name: {_ilike: $searchByName}, deletedAt: {_is_null: true}}
    order_by: {createdAt: desc}
  ) {
    id
    name
    sku
    offTime
    pictures
    maxBookings
    duration
    description
    status
    featured
    serviceEmployees {
      id
      userId
      serviceId
    }
  }
  services_aggregate(
    where: {name: {_ilike: $searchByName}, deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useServicesQuery__
 *
 * To run a query within a React component, call `useServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchByName: // value for 'searchByName'
 *   },
 * });
 */
export function useServicesQuery(baseOptions: Apollo.QueryHookOptions<ServicesQuery, ServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
      }
export function useServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServicesQuery, ServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
        }
export function useServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServicesQuery, ServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
        }
export type ServicesQueryHookResult = ReturnType<typeof useServicesQuery>;
export type ServicesLazyQueryHookResult = ReturnType<typeof useServicesLazyQuery>;
export type ServicesSuspenseQueryHookResult = ReturnType<typeof useServicesSuspenseQuery>;
export type ServicesQueryResult = Apollo.QueryResult<ServicesQuery, ServicesQueryVariables>;
export const CreateServiceDocument = gql`
    mutation CreateService($providerId: uuid!, $name: String!, $sku: String!, $description: String!) {
  insert_services_one(
    object: {name: $name, status: draft, sku: $sku, description: $description, providerId: $providerId, servicePricing: {data: {paymentFormat: fixed, currency: CAD}}}
  ) {
    id
    name
    sku
    description
    status
  }
}
    `;
export type CreateServiceMutationFn = Apollo.MutationFunction<CreateServiceMutation, CreateServiceMutationVariables>;

/**
 * __useCreateServiceMutation__
 *
 * To run a mutation, you first call `useCreateServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceMutation, { data, loading, error }] = useCreateServiceMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      name: // value for 'name'
 *      sku: // value for 'sku'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceMutation, CreateServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceMutation, CreateServiceMutationVariables>(CreateServiceDocument, options);
      }
export type CreateServiceMutationHookResult = ReturnType<typeof useCreateServiceMutation>;
export type CreateServiceMutationResult = Apollo.MutationResult<CreateServiceMutation>;
export type CreateServiceMutationOptions = Apollo.BaseMutationOptions<CreateServiceMutation, CreateServiceMutationVariables>;
export const EditServiceByIdDocument = gql`
    mutation EditServiceById($id: uuid!, $name: String!, $sku: String!, $description: String!) {
  update_services_by_pk(
    pk_columns: {id: $id}
    _set: {sku: $sku, name: $name, description: $description}
  ) {
    id
    name
    sku
    description
  }
}
    `;
export type EditServiceByIdMutationFn = Apollo.MutationFunction<EditServiceByIdMutation, EditServiceByIdMutationVariables>;

/**
 * __useEditServiceByIdMutation__
 *
 * To run a mutation, you first call `useEditServiceByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditServiceByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editServiceByIdMutation, { data, loading, error }] = useEditServiceByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      sku: // value for 'sku'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useEditServiceByIdMutation(baseOptions?: Apollo.MutationHookOptions<EditServiceByIdMutation, EditServiceByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditServiceByIdMutation, EditServiceByIdMutationVariables>(EditServiceByIdDocument, options);
      }
export type EditServiceByIdMutationHookResult = ReturnType<typeof useEditServiceByIdMutation>;
export type EditServiceByIdMutationResult = Apollo.MutationResult<EditServiceByIdMutation>;
export type EditServiceByIdMutationOptions = Apollo.BaseMutationOptions<EditServiceByIdMutation, EditServiceByIdMutationVariables>;
export const GetServiceByIdDocument = gql`
    query GetServiceById($id: uuid!) {
  services_by_pk(id: $id) {
    id
    name
    sku
    description
    status
    offTime
    duration
    color
    customerCanPickEmployee
    maxBookings
    featured
    providerId
    provider {
      id
      name
      visibility
    }
    servicePricings {
      id
      basePrice
      minimumDeposit
      taxes
      fees
      paymentFormat
      checkoutPayment
      currency
    }
    servicePricing {
      id
      basePrice
      minimumDeposit
      taxes
      fees
      paymentFormat
      checkoutPayment
      currency
    }
    serviceEmployees {
      user {
        id
        name
      }
    }
    serviceEmployees_aggregate(
      where: {user: {userRole: {deletedAt: {_is_null: true}}}}
    ) {
      aggregate {
        count
      }
    }
    servicePricings {
      id
      basePrice
    }
    serviceOptions(where: {status: {_eq: active}, deletedAt: {_is_null: true}}) {
      id
      name
      status
      serviceOptionSections {
        id
        mandatory
        name
        type
        order
        serviceOptionSectionOptions {
          id
          name
          price
          order
          quantity
        }
      }
    }
    servicesForms(
      where: {status: {_eq: active}, form: {deletedAt: {_is_null: true}}}
    ) {
      id
      formId
      status
      form {
        id
        name
        formQuestions(where: {deletedAt: {_is_null: true}}) {
          id
          label
          mandatory
          name
          order
          questionType
          options: formQuestionOptions {
            id
            value
          }
          formAnswers {
            formId
            formQuestionId
            answer
            optionId
            fileId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetServiceByIdQuery__
 *
 * To run a query within a React component, call `useGetServiceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServiceByIdQuery(baseOptions: Apollo.QueryHookOptions<GetServiceByIdQuery, GetServiceByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceByIdQuery, GetServiceByIdQueryVariables>(GetServiceByIdDocument, options);
      }
export function useGetServiceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceByIdQuery, GetServiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceByIdQuery, GetServiceByIdQueryVariables>(GetServiceByIdDocument, options);
        }
export function useGetServiceByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceByIdQuery, GetServiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceByIdQuery, GetServiceByIdQueryVariables>(GetServiceByIdDocument, options);
        }
export type GetServiceByIdQueryHookResult = ReturnType<typeof useGetServiceByIdQuery>;
export type GetServiceByIdLazyQueryHookResult = ReturnType<typeof useGetServiceByIdLazyQuery>;
export type GetServiceByIdSuspenseQueryHookResult = ReturnType<typeof useGetServiceByIdSuspenseQuery>;
export type GetServiceByIdQueryResult = Apollo.QueryResult<GetServiceByIdQuery, GetServiceByIdQueryVariables>;
export const GetPublicServiceDocument = gql`
    query GetPublicService($slug: String!, $serviceId: uuid!) {
  providers(where: {slug: {_eq: $slug}}) {
    slug
    services(where: {id: {_eq: $serviceId}}) {
      id
      name
      sku
      description
      duration
      providerId
      servicePricing {
        id
        basePrice
        fees
        minimumDeposit
        currency
        taxes
        checkoutPayment
        paymentFormat
      }
      servicePictures {
        id
        name
        file {
          id
          name
          uploadName
        }
      }
      serviceOptions(where: {status: {_eq: active}, deletedAt: {_is_null: true}}) {
        id
        name
        status
        serviceOptionSections {
          id
          mandatory
          name
          type
          order
          serviceOptionSectionOptions {
            id
            name
            price
            order
            quantity
          }
        }
      }
      servicesForms(
        where: {status: {_eq: active}, form: {deletedAt: {_is_null: true}}}
      ) {
        id
        formId
        status
        form {
          id
          name
          formQuestions(where: {deletedAt: {_is_null: true}}) {
            id
            label
            mandatory
            name
            order
            questionType
            options: formQuestionOptions {
              id
              value
            }
          }
        }
      }
      servicePictures_aggregate {
        aggregate {
          count
        }
      }
      serviceEmployees_aggregate {
        aggregate {
          count
        }
      }
    }
  }
}
    `;

/**
 * __useGetPublicServiceQuery__
 *
 * To run a query within a React component, call `useGetPublicServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicServiceQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useGetPublicServiceQuery(baseOptions: Apollo.QueryHookOptions<GetPublicServiceQuery, GetPublicServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicServiceQuery, GetPublicServiceQueryVariables>(GetPublicServiceDocument, options);
      }
export function useGetPublicServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicServiceQuery, GetPublicServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicServiceQuery, GetPublicServiceQueryVariables>(GetPublicServiceDocument, options);
        }
export function useGetPublicServiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPublicServiceQuery, GetPublicServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublicServiceQuery, GetPublicServiceQueryVariables>(GetPublicServiceDocument, options);
        }
export type GetPublicServiceQueryHookResult = ReturnType<typeof useGetPublicServiceQuery>;
export type GetPublicServiceLazyQueryHookResult = ReturnType<typeof useGetPublicServiceLazyQuery>;
export type GetPublicServiceSuspenseQueryHookResult = ReturnType<typeof useGetPublicServiceSuspenseQuery>;
export type GetPublicServiceQueryResult = Apollo.QueryResult<GetPublicServiceQuery, GetPublicServiceQueryVariables>;
export const GetServiceFormsDocument = gql`
    query GetServiceForms($serviceId: uuid!, $limit: Int, $offset: Int) {
  servicesForms(
    limit: $limit
    offset: $offset
    where: {serviceId: {_eq: $serviceId}}
    order_by: {createdAt: desc}
  ) {
    id
    status
    form {
      id
      name
    }
  }
  servicesForms_aggregate(where: {serviceId: {_eq: $serviceId}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetServiceFormsQuery__
 *
 * To run a query within a React component, call `useGetServiceFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceFormsQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetServiceFormsQuery(baseOptions: Apollo.QueryHookOptions<GetServiceFormsQuery, GetServiceFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceFormsQuery, GetServiceFormsQueryVariables>(GetServiceFormsDocument, options);
      }
export function useGetServiceFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceFormsQuery, GetServiceFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceFormsQuery, GetServiceFormsQueryVariables>(GetServiceFormsDocument, options);
        }
export function useGetServiceFormsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceFormsQuery, GetServiceFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceFormsQuery, GetServiceFormsQueryVariables>(GetServiceFormsDocument, options);
        }
export type GetServiceFormsQueryHookResult = ReturnType<typeof useGetServiceFormsQuery>;
export type GetServiceFormsLazyQueryHookResult = ReturnType<typeof useGetServiceFormsLazyQuery>;
export type GetServiceFormsSuspenseQueryHookResult = ReturnType<typeof useGetServiceFormsSuspenseQuery>;
export type GetServiceFormsQueryResult = Apollo.QueryResult<GetServiceFormsQuery, GetServiceFormsQueryVariables>;
export const GetServiceDetailsByIdDocument = gql`
    query GetServiceDetailsById($id: uuid!) {
  services_by_pk(id: $id) {
    id
    name
    sku
    description
    status
    offTime
    duration
    color
    customerCanPickEmployee
    maxBookings
    featured
  }
}
    `;

/**
 * __useGetServiceDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetServiceDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceDetailsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServiceDetailsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetServiceDetailsByIdQuery, GetServiceDetailsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceDetailsByIdQuery, GetServiceDetailsByIdQueryVariables>(GetServiceDetailsByIdDocument, options);
      }
export function useGetServiceDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceDetailsByIdQuery, GetServiceDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceDetailsByIdQuery, GetServiceDetailsByIdQueryVariables>(GetServiceDetailsByIdDocument, options);
        }
export function useGetServiceDetailsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceDetailsByIdQuery, GetServiceDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceDetailsByIdQuery, GetServiceDetailsByIdQueryVariables>(GetServiceDetailsByIdDocument, options);
        }
export type GetServiceDetailsByIdQueryHookResult = ReturnType<typeof useGetServiceDetailsByIdQuery>;
export type GetServiceDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetServiceDetailsByIdLazyQuery>;
export type GetServiceDetailsByIdSuspenseQueryHookResult = ReturnType<typeof useGetServiceDetailsByIdSuspenseQuery>;
export type GetServiceDetailsByIdQueryResult = Apollo.QueryResult<GetServiceDetailsByIdQuery, GetServiceDetailsByIdQueryVariables>;
export const GetServiceProviderDocument = gql`
    query GetServiceProvider($id: uuid!) {
  services_by_pk(id: $id) {
    servicePictures {
      id
      file {
        id
        name
      }
    }
    provider {
      id
      name
      category
      providerPictureByProfilePic {
        id
        name
        file {
          id
          name
          uploadName
        }
      }
    }
  }
}
    `;

/**
 * __useGetServiceProviderQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServiceProviderQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderQuery, GetServiceProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderQuery, GetServiceProviderQueryVariables>(GetServiceProviderDocument, options);
      }
export function useGetServiceProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderQuery, GetServiceProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderQuery, GetServiceProviderQueryVariables>(GetServiceProviderDocument, options);
        }
export function useGetServiceProviderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceProviderQuery, GetServiceProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderQuery, GetServiceProviderQueryVariables>(GetServiceProviderDocument, options);
        }
export type GetServiceProviderQueryHookResult = ReturnType<typeof useGetServiceProviderQuery>;
export type GetServiceProviderLazyQueryHookResult = ReturnType<typeof useGetServiceProviderLazyQuery>;
export type GetServiceProviderSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderSuspenseQuery>;
export type GetServiceProviderQueryResult = Apollo.QueryResult<GetServiceProviderQuery, GetServiceProviderQueryVariables>;
export const UpdateServiceStatusDocument = gql`
    mutation UpdateServiceStatus($id: uuid!, $status: serviceStatus_enum) {
  update_services_by_pk(pk_columns: {id: $id}, _set: {status: $status}) {
    id
  }
}
    `;
export type UpdateServiceStatusMutationFn = Apollo.MutationFunction<UpdateServiceStatusMutation, UpdateServiceStatusMutationVariables>;

/**
 * __useUpdateServiceStatusMutation__
 *
 * To run a mutation, you first call `useUpdateServiceStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceStatusMutation, { data, loading, error }] = useUpdateServiceStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateServiceStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceStatusMutation, UpdateServiceStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceStatusMutation, UpdateServiceStatusMutationVariables>(UpdateServiceStatusDocument, options);
      }
export type UpdateServiceStatusMutationHookResult = ReturnType<typeof useUpdateServiceStatusMutation>;
export type UpdateServiceStatusMutationResult = Apollo.MutationResult<UpdateServiceStatusMutation>;
export type UpdateServiceStatusMutationOptions = Apollo.BaseMutationOptions<UpdateServiceStatusMutation, UpdateServiceStatusMutationVariables>;
export const UpdateServiceFormStatusDocument = gql`
    mutation UpdateServiceFormStatus($id: uuid!, $status: serviceFormStatus_enum) {
  update_servicesForms_by_pk(pk_columns: {id: $id}, _set: {status: $status}) {
    id
    status
  }
}
    `;
export type UpdateServiceFormStatusMutationFn = Apollo.MutationFunction<UpdateServiceFormStatusMutation, UpdateServiceFormStatusMutationVariables>;

/**
 * __useUpdateServiceFormStatusMutation__
 *
 * To run a mutation, you first call `useUpdateServiceFormStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceFormStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceFormStatusMutation, { data, loading, error }] = useUpdateServiceFormStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateServiceFormStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceFormStatusMutation, UpdateServiceFormStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceFormStatusMutation, UpdateServiceFormStatusMutationVariables>(UpdateServiceFormStatusDocument, options);
      }
export type UpdateServiceFormStatusMutationHookResult = ReturnType<typeof useUpdateServiceFormStatusMutation>;
export type UpdateServiceFormStatusMutationResult = Apollo.MutationResult<UpdateServiceFormStatusMutation>;
export type UpdateServiceFormStatusMutationOptions = Apollo.BaseMutationOptions<UpdateServiceFormStatusMutation, UpdateServiceFormStatusMutationVariables>;
export const GetFormsDocument = gql`
    query GetForms($searchByName: String!, $limit: Int!, $offset: Int!) {
  form_aggregate(
    where: {name: {_ilike: $searchByName}, deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
  form(
    where: {name: {_ilike: $searchByName}, deletedAt: {_is_null: true}}
    limit: $limit
    offset: $offset
    order_by: {createdAt: desc}
  ) {
    id
    name
    servicesForms {
      id
      serviceId
    }
  }
}
    `;

/**
 * __useGetFormsQuery__
 *
 * To run a query within a React component, call `useGetFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormsQuery({
 *   variables: {
 *      searchByName: // value for 'searchByName'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetFormsQuery(baseOptions: Apollo.QueryHookOptions<GetFormsQuery, GetFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormsQuery, GetFormsQueryVariables>(GetFormsDocument, options);
      }
export function useGetFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormsQuery, GetFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormsQuery, GetFormsQueryVariables>(GetFormsDocument, options);
        }
export function useGetFormsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFormsQuery, GetFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFormsQuery, GetFormsQueryVariables>(GetFormsDocument, options);
        }
export type GetFormsQueryHookResult = ReturnType<typeof useGetFormsQuery>;
export type GetFormsLazyQueryHookResult = ReturnType<typeof useGetFormsLazyQuery>;
export type GetFormsSuspenseQueryHookResult = ReturnType<typeof useGetFormsSuspenseQuery>;
export type GetFormsQueryResult = Apollo.QueryResult<GetFormsQuery, GetFormsQueryVariables>;
export const DeleteServiceFormDocument = gql`
    mutation DeleteServiceForm($id: uuid!) {
  delete_servicesForms_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteServiceFormMutationFn = Apollo.MutationFunction<DeleteServiceFormMutation, DeleteServiceFormMutationVariables>;

/**
 * __useDeleteServiceFormMutation__
 *
 * To run a mutation, you first call `useDeleteServiceFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceFormMutation, { data, loading, error }] = useDeleteServiceFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteServiceFormMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceFormMutation, DeleteServiceFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceFormMutation, DeleteServiceFormMutationVariables>(DeleteServiceFormDocument, options);
      }
export type DeleteServiceFormMutationHookResult = ReturnType<typeof useDeleteServiceFormMutation>;
export type DeleteServiceFormMutationResult = Apollo.MutationResult<DeleteServiceFormMutation>;
export type DeleteServiceFormMutationOptions = Apollo.BaseMutationOptions<DeleteServiceFormMutation, DeleteServiceFormMutationVariables>;
export const InsertServiceFormDocument = gql`
    mutation InsertServiceForm($input: servicesForms_insert_input!) {
  insert_servicesForms_one(object: $input) {
    id
    status
    form {
      id
      name
    }
  }
}
    `;
export type InsertServiceFormMutationFn = Apollo.MutationFunction<InsertServiceFormMutation, InsertServiceFormMutationVariables>;

/**
 * __useInsertServiceFormMutation__
 *
 * To run a mutation, you first call `useInsertServiceFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertServiceFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertServiceFormMutation, { data, loading, error }] = useInsertServiceFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertServiceFormMutation(baseOptions?: Apollo.MutationHookOptions<InsertServiceFormMutation, InsertServiceFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertServiceFormMutation, InsertServiceFormMutationVariables>(InsertServiceFormDocument, options);
      }
export type InsertServiceFormMutationHookResult = ReturnType<typeof useInsertServiceFormMutation>;
export type InsertServiceFormMutationResult = Apollo.MutationResult<InsertServiceFormMutation>;
export type InsertServiceFormMutationOptions = Apollo.BaseMutationOptions<InsertServiceFormMutation, InsertServiceFormMutationVariables>;
export const ImportFormsToServiceDocument = gql`
    mutation ImportFormsToService($serviceFormIds: [servicesForms_insert_input!]!) {
  insert_servicesForms(objects: $serviceFormIds) {
    returning {
      id
      serviceId
      status
      formId
    }
  }
}
    `;
export type ImportFormsToServiceMutationFn = Apollo.MutationFunction<ImportFormsToServiceMutation, ImportFormsToServiceMutationVariables>;

/**
 * __useImportFormsToServiceMutation__
 *
 * To run a mutation, you first call `useImportFormsToServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportFormsToServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importFormsToServiceMutation, { data, loading, error }] = useImportFormsToServiceMutation({
 *   variables: {
 *      serviceFormIds: // value for 'serviceFormIds'
 *   },
 * });
 */
export function useImportFormsToServiceMutation(baseOptions?: Apollo.MutationHookOptions<ImportFormsToServiceMutation, ImportFormsToServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportFormsToServiceMutation, ImportFormsToServiceMutationVariables>(ImportFormsToServiceDocument, options);
      }
export type ImportFormsToServiceMutationHookResult = ReturnType<typeof useImportFormsToServiceMutation>;
export type ImportFormsToServiceMutationResult = Apollo.MutationResult<ImportFormsToServiceMutation>;
export type ImportFormsToServiceMutationOptions = Apollo.BaseMutationOptions<ImportFormsToServiceMutation, ImportFormsToServiceMutationVariables>;
export const UpdateServiceOffTimeDocument = gql`
    mutation UpdateServiceOffTime($id: uuid!, $offTime: numeric) {
  update_services_by_pk(pk_columns: {id: $id}, _set: {offTime: $offTime}) {
    id
    name
    sku
    description
    status
    offTime
    duration
    color
    featured
  }
}
    `;
export type UpdateServiceOffTimeMutationFn = Apollo.MutationFunction<UpdateServiceOffTimeMutation, UpdateServiceOffTimeMutationVariables>;

/**
 * __useUpdateServiceOffTimeMutation__
 *
 * To run a mutation, you first call `useUpdateServiceOffTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceOffTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceOffTimeMutation, { data, loading, error }] = useUpdateServiceOffTimeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      offTime: // value for 'offTime'
 *   },
 * });
 */
export function useUpdateServiceOffTimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceOffTimeMutation, UpdateServiceOffTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceOffTimeMutation, UpdateServiceOffTimeMutationVariables>(UpdateServiceOffTimeDocument, options);
      }
export type UpdateServiceOffTimeMutationHookResult = ReturnType<typeof useUpdateServiceOffTimeMutation>;
export type UpdateServiceOffTimeMutationResult = Apollo.MutationResult<UpdateServiceOffTimeMutation>;
export type UpdateServiceOffTimeMutationOptions = Apollo.BaseMutationOptions<UpdateServiceOffTimeMutation, UpdateServiceOffTimeMutationVariables>;
export const UpdateServiceDurationDocument = gql`
    mutation UpdateServiceDuration($id: uuid!, $duration: numeric) {
  update_services_by_pk(pk_columns: {id: $id}, _set: {duration: $duration}) {
    id
    name
    sku
    description
    status
    offTime
    duration
    color
    featured
  }
}
    `;
export type UpdateServiceDurationMutationFn = Apollo.MutationFunction<UpdateServiceDurationMutation, UpdateServiceDurationMutationVariables>;

/**
 * __useUpdateServiceDurationMutation__
 *
 * To run a mutation, you first call `useUpdateServiceDurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceDurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceDurationMutation, { data, loading, error }] = useUpdateServiceDurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useUpdateServiceDurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceDurationMutation, UpdateServiceDurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceDurationMutation, UpdateServiceDurationMutationVariables>(UpdateServiceDurationDocument, options);
      }
export type UpdateServiceDurationMutationHookResult = ReturnType<typeof useUpdateServiceDurationMutation>;
export type UpdateServiceDurationMutationResult = Apollo.MutationResult<UpdateServiceDurationMutation>;
export type UpdateServiceDurationMutationOptions = Apollo.BaseMutationOptions<UpdateServiceDurationMutation, UpdateServiceDurationMutationVariables>;
export const UpdateServiceColorDocument = gql`
    mutation UpdateServiceColor($id: uuid!, $color: String) {
  update_services_by_pk(pk_columns: {id: $id}, _set: {color: $color}) {
    id
    name
    sku
    description
    status
    offTime
    duration
    color
    featured
  }
}
    `;
export type UpdateServiceColorMutationFn = Apollo.MutationFunction<UpdateServiceColorMutation, UpdateServiceColorMutationVariables>;

/**
 * __useUpdateServiceColorMutation__
 *
 * To run a mutation, you first call `useUpdateServiceColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceColorMutation, { data, loading, error }] = useUpdateServiceColorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useUpdateServiceColorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceColorMutation, UpdateServiceColorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceColorMutation, UpdateServiceColorMutationVariables>(UpdateServiceColorDocument, options);
      }
export type UpdateServiceColorMutationHookResult = ReturnType<typeof useUpdateServiceColorMutation>;
export type UpdateServiceColorMutationResult = Apollo.MutationResult<UpdateServiceColorMutation>;
export type UpdateServiceColorMutationOptions = Apollo.BaseMutationOptions<UpdateServiceColorMutation, UpdateServiceColorMutationVariables>;
export const ServicesTableDocument = gql`
    query ServicesTable($value: String!, $limit: Int!, $offset: Int!, $status: [serviceStatus_enum!]) {
  filteredServices: services(
    limit: $limit
    offset: $offset
    where: {deletedAt: {_is_null: true}, _and: [{_or: [{name: {_ilike: $value}}, {sku: {_ilike: $value}}]}, {_or: {status: {_in: $status}}}]}
    order_by: {createdAt: desc}
  ) {
    color
    customerCanPickEmployee
    description
    duration
    id
    name
    sku
    maxBookings
    status
    featured
  }
  filteredServicesAggregate: services_aggregate(
    where: {deletedAt: {_is_null: true}, _and: [{_or: [{name: {_ilike: $value}}, {sku: {_ilike: $value}}]}, {_or: {status: {_in: $status}}}]}
  ) {
    aggregate {
      count
    }
  }
  allServicesAggregate: services_aggregate(where: {deletedAt: {_is_null: true}}) {
    nodes {
      id
      status
    }
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useServicesTableQuery__
 *
 * To run a query within a React component, call `useServicesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicesTableQuery({
 *   variables: {
 *      value: // value for 'value'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useServicesTableQuery(baseOptions: Apollo.QueryHookOptions<ServicesTableQuery, ServicesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServicesTableQuery, ServicesTableQueryVariables>(ServicesTableDocument, options);
      }
export function useServicesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServicesTableQuery, ServicesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServicesTableQuery, ServicesTableQueryVariables>(ServicesTableDocument, options);
        }
export function useServicesTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServicesTableQuery, ServicesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServicesTableQuery, ServicesTableQueryVariables>(ServicesTableDocument, options);
        }
export type ServicesTableQueryHookResult = ReturnType<typeof useServicesTableQuery>;
export type ServicesTableLazyQueryHookResult = ReturnType<typeof useServicesTableLazyQuery>;
export type ServicesTableSuspenseQueryHookResult = ReturnType<typeof useServicesTableSuspenseQuery>;
export type ServicesTableQueryResult = Apollo.QueryResult<ServicesTableQuery, ServicesTableQueryVariables>;
export const ServiceEmployeesDocument = gql`
    query ServiceEmployees($serviceId: uuid!, $limit: Int!, $offset: Int!) {
  services(where: {id: {_eq: $serviceId}, deletedAt: {_is_null: true}}) {
    id
    serviceEmployees(
      limit: $limit
      offset: $offset
      where: {user: {userRole: {deletedAt: {_is_null: true}}}}
    ) {
      id
      user {
        id
        name
        email
        phoneNumber
        profilePicture {
          id
          name
        }
      }
    }
    serviceEmployees_aggregate(
      where: {user: {userRole: {deletedAt: {_is_null: true}}}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useServiceEmployeesQuery__
 *
 * To run a query within a React component, call `useServiceEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceEmployeesQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useServiceEmployeesQuery(baseOptions: Apollo.QueryHookOptions<ServiceEmployeesQuery, ServiceEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceEmployeesQuery, ServiceEmployeesQueryVariables>(ServiceEmployeesDocument, options);
      }
export function useServiceEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceEmployeesQuery, ServiceEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceEmployeesQuery, ServiceEmployeesQueryVariables>(ServiceEmployeesDocument, options);
        }
export function useServiceEmployeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceEmployeesQuery, ServiceEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceEmployeesQuery, ServiceEmployeesQueryVariables>(ServiceEmployeesDocument, options);
        }
export type ServiceEmployeesQueryHookResult = ReturnType<typeof useServiceEmployeesQuery>;
export type ServiceEmployeesLazyQueryHookResult = ReturnType<typeof useServiceEmployeesLazyQuery>;
export type ServiceEmployeesSuspenseQueryHookResult = ReturnType<typeof useServiceEmployeesSuspenseQuery>;
export type ServiceEmployeesQueryResult = Apollo.QueryResult<ServiceEmployeesQuery, ServiceEmployeesQueryVariables>;
export const AddServiceEmployeesDocument = gql`
    mutation AddServiceEmployees($serviceEmployeesIds: [serviceEmployees_insert_input!]!) {
  insert_serviceEmployees(objects: $serviceEmployeesIds) {
    returning {
      service {
        id
        serviceEmployees {
          id
          user {
            id
            name
            email
            phoneNumber
            profilePicture {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
export type AddServiceEmployeesMutationFn = Apollo.MutationFunction<AddServiceEmployeesMutation, AddServiceEmployeesMutationVariables>;

/**
 * __useAddServiceEmployeesMutation__
 *
 * To run a mutation, you first call `useAddServiceEmployeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddServiceEmployeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addServiceEmployeesMutation, { data, loading, error }] = useAddServiceEmployeesMutation({
 *   variables: {
 *      serviceEmployeesIds: // value for 'serviceEmployeesIds'
 *   },
 * });
 */
export function useAddServiceEmployeesMutation(baseOptions?: Apollo.MutationHookOptions<AddServiceEmployeesMutation, AddServiceEmployeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddServiceEmployeesMutation, AddServiceEmployeesMutationVariables>(AddServiceEmployeesDocument, options);
      }
export type AddServiceEmployeesMutationHookResult = ReturnType<typeof useAddServiceEmployeesMutation>;
export type AddServiceEmployeesMutationResult = Apollo.MutationResult<AddServiceEmployeesMutation>;
export type AddServiceEmployeesMutationOptions = Apollo.BaseMutationOptions<AddServiceEmployeesMutation, AddServiceEmployeesMutationVariables>;
export const DeleteServiceEmployeeDocument = gql`
    mutation DeleteServiceEmployee($id: uuid!) {
  delete_serviceEmployees_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteServiceEmployeeMutationFn = Apollo.MutationFunction<DeleteServiceEmployeeMutation, DeleteServiceEmployeeMutationVariables>;

/**
 * __useDeleteServiceEmployeeMutation__
 *
 * To run a mutation, you first call `useDeleteServiceEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceEmployeeMutation, { data, loading, error }] = useDeleteServiceEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteServiceEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceEmployeeMutation, DeleteServiceEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceEmployeeMutation, DeleteServiceEmployeeMutationVariables>(DeleteServiceEmployeeDocument, options);
      }
export type DeleteServiceEmployeeMutationHookResult = ReturnType<typeof useDeleteServiceEmployeeMutation>;
export type DeleteServiceEmployeeMutationResult = Apollo.MutationResult<DeleteServiceEmployeeMutation>;
export type DeleteServiceEmployeeMutationOptions = Apollo.BaseMutationOptions<DeleteServiceEmployeeMutation, DeleteServiceEmployeeMutationVariables>;
export const InsertServicePricingDocument = gql`
    mutation InsertServicePricing($serviceId: uuid!, $checkoutPayment: jsonb, $fees: jsonb, $paymentFormat: paymentFormat_enum, $taxes: Boolean, $basePrice: float8!, $minimumDeposit: float8, $currency: currencies_enum) {
  insert_servicePricings_one(
    object: {serviceId: $serviceId, checkoutPayment: $checkoutPayment, fees: $fees, paymentFormat: $paymentFormat, taxes: $taxes, basePrice: $basePrice, minimumDeposit: $minimumDeposit, currency: $currency}
  ) {
    id
    basePrice
    minimumDeposit
    taxes
    fees
    paymentFormat
    checkoutPayment
    currency
  }
}
    `;
export type InsertServicePricingMutationFn = Apollo.MutationFunction<InsertServicePricingMutation, InsertServicePricingMutationVariables>;

/**
 * __useInsertServicePricingMutation__
 *
 * To run a mutation, you first call `useInsertServicePricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertServicePricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertServicePricingMutation, { data, loading, error }] = useInsertServicePricingMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      checkoutPayment: // value for 'checkoutPayment'
 *      fees: // value for 'fees'
 *      paymentFormat: // value for 'paymentFormat'
 *      taxes: // value for 'taxes'
 *      basePrice: // value for 'basePrice'
 *      minimumDeposit: // value for 'minimumDeposit'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useInsertServicePricingMutation(baseOptions?: Apollo.MutationHookOptions<InsertServicePricingMutation, InsertServicePricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertServicePricingMutation, InsertServicePricingMutationVariables>(InsertServicePricingDocument, options);
      }
export type InsertServicePricingMutationHookResult = ReturnType<typeof useInsertServicePricingMutation>;
export type InsertServicePricingMutationResult = Apollo.MutationResult<InsertServicePricingMutation>;
export type InsertServicePricingMutationOptions = Apollo.BaseMutationOptions<InsertServicePricingMutation, InsertServicePricingMutationVariables>;
export const UpdateServicePricingByIdDocument = gql`
    mutation UpdateServicePricingById($serviceId: uuid!, $checkoutPayment: jsonb, $fees: jsonb, $paymentFormat: paymentFormat_enum, $taxes: Boolean, $basePrice: float8!, $minimumDeposit: float8, $currency: currencies_enum) {
  update_servicePricings(
    where: {serviceId: {_eq: $serviceId}}
    _set: {checkoutPayment: $checkoutPayment, fees: $fees, paymentFormat: $paymentFormat, taxes: $taxes, basePrice: $basePrice, minimumDeposit: $minimumDeposit, currency: $currency}
  ) {
    returning {
      id
      basePrice
      minimumDeposit
      taxes
      fees
      paymentFormat
      checkoutPayment
      currency
    }
  }
}
    `;
export type UpdateServicePricingByIdMutationFn = Apollo.MutationFunction<UpdateServicePricingByIdMutation, UpdateServicePricingByIdMutationVariables>;

/**
 * __useUpdateServicePricingByIdMutation__
 *
 * To run a mutation, you first call `useUpdateServicePricingByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServicePricingByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServicePricingByIdMutation, { data, loading, error }] = useUpdateServicePricingByIdMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      checkoutPayment: // value for 'checkoutPayment'
 *      fees: // value for 'fees'
 *      paymentFormat: // value for 'paymentFormat'
 *      taxes: // value for 'taxes'
 *      basePrice: // value for 'basePrice'
 *      minimumDeposit: // value for 'minimumDeposit'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useUpdateServicePricingByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServicePricingByIdMutation, UpdateServicePricingByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServicePricingByIdMutation, UpdateServicePricingByIdMutationVariables>(UpdateServicePricingByIdDocument, options);
      }
export type UpdateServicePricingByIdMutationHookResult = ReturnType<typeof useUpdateServicePricingByIdMutation>;
export type UpdateServicePricingByIdMutationResult = Apollo.MutationResult<UpdateServicePricingByIdMutation>;
export type UpdateServicePricingByIdMutationOptions = Apollo.BaseMutationOptions<UpdateServicePricingByIdMutation, UpdateServicePricingByIdMutationVariables>;
export const UpdateServiceRestrictionsDocument = gql`
    mutation UpdateServiceRestrictions($id: uuid!, $customerCanPickEmployee: Boolean, $maxBookings: numeric, $checkoutPayment: jsonb) {
  update_services_by_pk(
    pk_columns: {id: $id}
    _set: {customerCanPickEmployee: $customerCanPickEmployee, maxBookings: $maxBookings}
  ) {
    id
    color
    customerCanPickEmployee
    description
    duration
    maxBookings
    name
    offTime
    pictures
  }
  update_servicePricings(
    where: {serviceId: {_eq: $id}}
    _set: {checkoutPayment: $checkoutPayment}
  ) {
    returning {
      id
      basePrice
      checkoutPayment
      currency
      fees
      minimumDeposit
      paymentFormat
      taxes
    }
  }
}
    `;
export type UpdateServiceRestrictionsMutationFn = Apollo.MutationFunction<UpdateServiceRestrictionsMutation, UpdateServiceRestrictionsMutationVariables>;

/**
 * __useUpdateServiceRestrictionsMutation__
 *
 * To run a mutation, you first call `useUpdateServiceRestrictionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceRestrictionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceRestrictionsMutation, { data, loading, error }] = useUpdateServiceRestrictionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customerCanPickEmployee: // value for 'customerCanPickEmployee'
 *      maxBookings: // value for 'maxBookings'
 *      checkoutPayment: // value for 'checkoutPayment'
 *   },
 * });
 */
export function useUpdateServiceRestrictionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceRestrictionsMutation, UpdateServiceRestrictionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceRestrictionsMutation, UpdateServiceRestrictionsMutationVariables>(UpdateServiceRestrictionsDocument, options);
      }
export type UpdateServiceRestrictionsMutationHookResult = ReturnType<typeof useUpdateServiceRestrictionsMutation>;
export type UpdateServiceRestrictionsMutationResult = Apollo.MutationResult<UpdateServiceRestrictionsMutation>;
export type UpdateServiceRestrictionsMutationOptions = Apollo.BaseMutationOptions<UpdateServiceRestrictionsMutation, UpdateServiceRestrictionsMutationVariables>;
export const GetEmployeesDocument = gql`
    query GetEmployees($searchValue: String!) {
  users(
    where: {name: {_ilike: $searchValue}, userRole: {role: {_in: [employee, provider]}, deletedAt: {_is_null: true}}}
  ) {
    id
    name
  }
}
    `;

/**
 * __useGetEmployeesQuery__
 *
 * To run a query within a React component, call `useGetEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesQuery({
 *   variables: {
 *      searchValue: // value for 'searchValue'
 *   },
 * });
 */
export function useGetEmployeesQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
      }
export function useGetEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
        }
export function useGetEmployeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
        }
export type GetEmployeesQueryHookResult = ReturnType<typeof useGetEmployeesQuery>;
export type GetEmployeesLazyQueryHookResult = ReturnType<typeof useGetEmployeesLazyQuery>;
export type GetEmployeesSuspenseQueryHookResult = ReturnType<typeof useGetEmployeesSuspenseQuery>;
export type GetEmployeesQueryResult = Apollo.QueryResult<GetEmployeesQuery, GetEmployeesQueryVariables>;
export const GetLocationsDocument = gql`
    query GetLocations($searchValue: String!, $providerId: uuid!) {
  locations(
    where: {name: {_ilike: $searchValue}, _or: [{providerId: {_eq: $providerId}}, {buildingProviders: {_and: [{providerId: {_eq: $providerId}}, {partnershipSchedulingType: {_eq: custom}}, {status: {_eq: approved}}]}}], deletedAt: {_is_null: true}}
  ) {
    id
    name
  }
}
    `;

/**
 * __useGetLocationsQuery__
 *
 * To run a query within a React component, call `useGetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsQuery({
 *   variables: {
 *      searchValue: // value for 'searchValue'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useGetLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
      }
export function useGetLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
        }
export function useGetLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
        }
export type GetLocationsQueryHookResult = ReturnType<typeof useGetLocationsQuery>;
export type GetLocationsLazyQueryHookResult = ReturnType<typeof useGetLocationsLazyQuery>;
export type GetLocationsSuspenseQueryHookResult = ReturnType<typeof useGetLocationsSuspenseQuery>;
export type GetLocationsQueryResult = Apollo.QueryResult<GetLocationsQuery, GetLocationsQueryVariables>;
export const GetServicesDocument = gql`
    query GetServices($searchValue: String!) {
  services(where: {name: {_ilike: $searchValue}, deletedAt: {_is_null: true}}) {
    id
    name
  }
}
    `;

/**
 * __useGetServicesQuery__
 *
 * To run a query within a React component, call `useGetServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServicesQuery({
 *   variables: {
 *      searchValue: // value for 'searchValue'
 *   },
 * });
 */
export function useGetServicesQuery(baseOptions: Apollo.QueryHookOptions<GetServicesQuery, GetServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServicesQuery, GetServicesQueryVariables>(GetServicesDocument, options);
      }
export function useGetServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServicesQuery, GetServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServicesQuery, GetServicesQueryVariables>(GetServicesDocument, options);
        }
export function useGetServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServicesQuery, GetServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServicesQuery, GetServicesQueryVariables>(GetServicesDocument, options);
        }
export type GetServicesQueryHookResult = ReturnType<typeof useGetServicesQuery>;
export type GetServicesLazyQueryHookResult = ReturnType<typeof useGetServicesLazyQuery>;
export type GetServicesSuspenseQueryHookResult = ReturnType<typeof useGetServicesSuspenseQuery>;
export type GetServicesQueryResult = Apollo.QueryResult<GetServicesQuery, GetServicesQueryVariables>;
export const CreateTimeoutDocument = gql`
    mutation CreateTimeout($timeouts: [timeouts_insert_input!]!) {
  insert_timeouts(objects: $timeouts) {
    returning {
      id
      startDate
      endDate
      userId
      serviceId
      locationId
    }
  }
}
    `;
export type CreateTimeoutMutationFn = Apollo.MutationFunction<CreateTimeoutMutation, CreateTimeoutMutationVariables>;

/**
 * __useCreateTimeoutMutation__
 *
 * To run a mutation, you first call `useCreateTimeoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimeoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimeoutMutation, { data, loading, error }] = useCreateTimeoutMutation({
 *   variables: {
 *      timeouts: // value for 'timeouts'
 *   },
 * });
 */
export function useCreateTimeoutMutation(baseOptions?: Apollo.MutationHookOptions<CreateTimeoutMutation, CreateTimeoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTimeoutMutation, CreateTimeoutMutationVariables>(CreateTimeoutDocument, options);
      }
export type CreateTimeoutMutationHookResult = ReturnType<typeof useCreateTimeoutMutation>;
export type CreateTimeoutMutationResult = Apollo.MutationResult<CreateTimeoutMutation>;
export type CreateTimeoutMutationOptions = Apollo.BaseMutationOptions<CreateTimeoutMutation, CreateTimeoutMutationVariables>;
export const GetServicesOptionsByServiceIdDocument = gql`
    query GetServicesOptionsByServiceId($serviceId: uuid!, $limit: Int!, $offset: Int!) {
  serviceOptions_aggregate(
    where: {serviceId: {_eq: $serviceId}, deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
  serviceOptions(
    where: {serviceId: {_eq: $serviceId}, deletedAt: {_is_null: true}}
    limit: $limit
    offset: $offset
  ) {
    id
    name
    status
    serviceId
    serviceOptionSections {
      id
      name
      order
      mandatory
      type
      serviceOptionSectionOptions {
        id
        name
        order
        price
        quantity
      }
    }
  }
}
    `;

/**
 * __useGetServicesOptionsByServiceIdQuery__
 *
 * To run a query within a React component, call `useGetServicesOptionsByServiceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServicesOptionsByServiceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServicesOptionsByServiceIdQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetServicesOptionsByServiceIdQuery(baseOptions: Apollo.QueryHookOptions<GetServicesOptionsByServiceIdQuery, GetServicesOptionsByServiceIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServicesOptionsByServiceIdQuery, GetServicesOptionsByServiceIdQueryVariables>(GetServicesOptionsByServiceIdDocument, options);
      }
export function useGetServicesOptionsByServiceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServicesOptionsByServiceIdQuery, GetServicesOptionsByServiceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServicesOptionsByServiceIdQuery, GetServicesOptionsByServiceIdQueryVariables>(GetServicesOptionsByServiceIdDocument, options);
        }
export function useGetServicesOptionsByServiceIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServicesOptionsByServiceIdQuery, GetServicesOptionsByServiceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServicesOptionsByServiceIdQuery, GetServicesOptionsByServiceIdQueryVariables>(GetServicesOptionsByServiceIdDocument, options);
        }
export type GetServicesOptionsByServiceIdQueryHookResult = ReturnType<typeof useGetServicesOptionsByServiceIdQuery>;
export type GetServicesOptionsByServiceIdLazyQueryHookResult = ReturnType<typeof useGetServicesOptionsByServiceIdLazyQuery>;
export type GetServicesOptionsByServiceIdSuspenseQueryHookResult = ReturnType<typeof useGetServicesOptionsByServiceIdSuspenseQuery>;
export type GetServicesOptionsByServiceIdQueryResult = Apollo.QueryResult<GetServicesOptionsByServiceIdQuery, GetServicesOptionsByServiceIdQueryVariables>;
export const InsertServiceOptionsDocument = gql`
    mutation InsertServiceOptions($name: String!, $serviceOptionSections: serviceOptionSection_arr_rel_insert_input!, $serviceId: uuid!, $status: serviceOptionsStatus_enum) {
  insert_serviceOptions_one(
    object: {serviceId: $serviceId, name: $name, status: $status, serviceOptionSections: $serviceOptionSections}
  ) {
    id
    name
    status
    serviceId
    serviceOptionSections {
      id
      name
      order
      mandatory
      type
      serviceOptionSectionOptions {
        id
        name
        order
        price
        quantity
      }
    }
  }
}
    `;
export type InsertServiceOptionsMutationFn = Apollo.MutationFunction<InsertServiceOptionsMutation, InsertServiceOptionsMutationVariables>;

/**
 * __useInsertServiceOptionsMutation__
 *
 * To run a mutation, you first call `useInsertServiceOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertServiceOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertServiceOptionsMutation, { data, loading, error }] = useInsertServiceOptionsMutation({
 *   variables: {
 *      name: // value for 'name'
 *      serviceOptionSections: // value for 'serviceOptionSections'
 *      serviceId: // value for 'serviceId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useInsertServiceOptionsMutation(baseOptions?: Apollo.MutationHookOptions<InsertServiceOptionsMutation, InsertServiceOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertServiceOptionsMutation, InsertServiceOptionsMutationVariables>(InsertServiceOptionsDocument, options);
      }
export type InsertServiceOptionsMutationHookResult = ReturnType<typeof useInsertServiceOptionsMutation>;
export type InsertServiceOptionsMutationResult = Apollo.MutationResult<InsertServiceOptionsMutation>;
export type InsertServiceOptionsMutationOptions = Apollo.BaseMutationOptions<InsertServiceOptionsMutation, InsertServiceOptionsMutationVariables>;
export const UpdateServiceOptionNameDocument = gql`
    mutation UpdateServiceOptionName($id: uuid!, $name: String!) {
  update_serviceOptions(where: {id: {_eq: $id}}, _set: {name: $name}) {
    returning {
      id
      name
    }
  }
}
    `;
export type UpdateServiceOptionNameMutationFn = Apollo.MutationFunction<UpdateServiceOptionNameMutation, UpdateServiceOptionNameMutationVariables>;

/**
 * __useUpdateServiceOptionNameMutation__
 *
 * To run a mutation, you first call `useUpdateServiceOptionNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceOptionNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceOptionNameMutation, { data, loading, error }] = useUpdateServiceOptionNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateServiceOptionNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceOptionNameMutation, UpdateServiceOptionNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceOptionNameMutation, UpdateServiceOptionNameMutationVariables>(UpdateServiceOptionNameDocument, options);
      }
export type UpdateServiceOptionNameMutationHookResult = ReturnType<typeof useUpdateServiceOptionNameMutation>;
export type UpdateServiceOptionNameMutationResult = Apollo.MutationResult<UpdateServiceOptionNameMutation>;
export type UpdateServiceOptionNameMutationOptions = Apollo.BaseMutationOptions<UpdateServiceOptionNameMutation, UpdateServiceOptionNameMutationVariables>;
export const UpdateServiceOptionsDocument = gql`
    mutation UpdateServiceOptions($id: uuid!, $input: serviceOptions_insert_input!) {
  serviceOptionsDeleted: update_serviceOptions(
    where: {id: {_eq: $id}}
    _set: {deletedAt: "now()"}
  ) {
    returning {
      id
      deletedAt
    }
  }
  serviceOptionsCreated: insert_serviceOptions_one(object: $input) {
    id
    name
    status
    serviceId
    serviceOptionSections {
      id
      name
      order
      mandatory
      type
      serviceOptionSectionOptions {
        id
        name
        order
        price
        quantity
      }
    }
  }
}
    `;
export type UpdateServiceOptionsMutationFn = Apollo.MutationFunction<UpdateServiceOptionsMutation, UpdateServiceOptionsMutationVariables>;

/**
 * __useUpdateServiceOptionsMutation__
 *
 * To run a mutation, you first call `useUpdateServiceOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceOptionsMutation, { data, loading, error }] = useUpdateServiceOptionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateServiceOptionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceOptionsMutation, UpdateServiceOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceOptionsMutation, UpdateServiceOptionsMutationVariables>(UpdateServiceOptionsDocument, options);
      }
export type UpdateServiceOptionsMutationHookResult = ReturnType<typeof useUpdateServiceOptionsMutation>;
export type UpdateServiceOptionsMutationResult = Apollo.MutationResult<UpdateServiceOptionsMutation>;
export type UpdateServiceOptionsMutationOptions = Apollo.BaseMutationOptions<UpdateServiceOptionsMutation, UpdateServiceOptionsMutationVariables>;
export const DeleteServiceOptionsDocument = gql`
    mutation DeleteServiceOptions($ids: [uuid!]) {
  update_serviceOptions(where: {id: {_in: $ids}}, _set: {deletedAt: "now()"}) {
    returning {
      id
      deletedAt
    }
  }
}
    `;
export type DeleteServiceOptionsMutationFn = Apollo.MutationFunction<DeleteServiceOptionsMutation, DeleteServiceOptionsMutationVariables>;

/**
 * __useDeleteServiceOptionsMutation__
 *
 * To run a mutation, you first call `useDeleteServiceOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceOptionsMutation, { data, loading, error }] = useDeleteServiceOptionsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteServiceOptionsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceOptionsMutation, DeleteServiceOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceOptionsMutation, DeleteServiceOptionsMutationVariables>(DeleteServiceOptionsDocument, options);
      }
export type DeleteServiceOptionsMutationHookResult = ReturnType<typeof useDeleteServiceOptionsMutation>;
export type DeleteServiceOptionsMutationResult = Apollo.MutationResult<DeleteServiceOptionsMutation>;
export type DeleteServiceOptionsMutationOptions = Apollo.BaseMutationOptions<DeleteServiceOptionsMutation, DeleteServiceOptionsMutationVariables>;
export const ValidateServiceDetailSubmissionDocument = gql`
    query ValidateServiceDetailSubmission($id: String!) {
  validateServiceById(id: $id) {
    canSubmit
    isOverviewValid
    paymentCheckoutValid
    hasEmployees
    hasPrice
  }
}
    `;

/**
 * __useValidateServiceDetailSubmissionQuery__
 *
 * To run a query within a React component, call `useValidateServiceDetailSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateServiceDetailSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateServiceDetailSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useValidateServiceDetailSubmissionQuery(baseOptions: Apollo.QueryHookOptions<ValidateServiceDetailSubmissionQuery, ValidateServiceDetailSubmissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateServiceDetailSubmissionQuery, ValidateServiceDetailSubmissionQueryVariables>(ValidateServiceDetailSubmissionDocument, options);
      }
export function useValidateServiceDetailSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateServiceDetailSubmissionQuery, ValidateServiceDetailSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateServiceDetailSubmissionQuery, ValidateServiceDetailSubmissionQueryVariables>(ValidateServiceDetailSubmissionDocument, options);
        }
export function useValidateServiceDetailSubmissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateServiceDetailSubmissionQuery, ValidateServiceDetailSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateServiceDetailSubmissionQuery, ValidateServiceDetailSubmissionQueryVariables>(ValidateServiceDetailSubmissionDocument, options);
        }
export type ValidateServiceDetailSubmissionQueryHookResult = ReturnType<typeof useValidateServiceDetailSubmissionQuery>;
export type ValidateServiceDetailSubmissionLazyQueryHookResult = ReturnType<typeof useValidateServiceDetailSubmissionLazyQuery>;
export type ValidateServiceDetailSubmissionSuspenseQueryHookResult = ReturnType<typeof useValidateServiceDetailSubmissionSuspenseQuery>;
export type ValidateServiceDetailSubmissionQueryResult = Apollo.QueryResult<ValidateServiceDetailSubmissionQuery, ValidateServiceDetailSubmissionQueryVariables>;
export const GetSpServicesListDocument = gql`
    query GetSPServicesList($searchByName: String!, $limit: Int!, $offset: Int!, $providerId: uuid!) {
  services(
    where: {name: {_ilike: $searchByName}, status: {_eq: active}, deletedAt: {_is_null: true}, providerId: {_eq: $providerId}, serviceEmployees: {user: {id: {_is_null: false}, userRole: {providerId: {_eq: $providerId}, deletedAt: {_is_null: true}}}}}
    limit: $limit
    offset: $offset
    order_by: {createdAt: desc}
  ) {
    id
    providerId
    name
    sku
    duration
    customerCanPickEmployee
    featured
    serviceEmployees {
      user {
        id
        name
      }
    }
    servicePricing {
      basePrice
      minimumDeposit
      fees
      checkoutPayment
      paymentFormat
      taxes
    }
    serviceOptions(where: {status: {_eq: active}, deletedAt: {_is_null: true}}) {
      name
      id
      status
      serviceOptionSections {
        name
        order
        id
        mandatory
        type
        serviceOptionSectionOptions {
          id
          name
          order
          price
          quantity
        }
      }
    }
    servicesForms(
      where: {status: {_eq: active}, form: {deletedAt: {_is_null: true}}}
    ) {
      id
      formId
      status
      form {
        id
        name
        formQuestions(where: {deletedAt: {_is_null: true}}) {
          id
          label
          mandatory
          name
          order
          questionType
          options: formQuestionOptions {
            id
            value
          }
        }
      }
    }
  }
  services_aggregate(
    where: {name: {_ilike: $searchByName}, status: {_eq: active}, providerId: {_eq: $providerId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetSpServicesListQuery__
 *
 * To run a query within a React component, call `useGetSpServicesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpServicesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpServicesListQuery({
 *   variables: {
 *      searchByName: // value for 'searchByName'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useGetSpServicesListQuery(baseOptions: Apollo.QueryHookOptions<GetSpServicesListQuery, GetSpServicesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpServicesListQuery, GetSpServicesListQueryVariables>(GetSpServicesListDocument, options);
      }
export function useGetSpServicesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpServicesListQuery, GetSpServicesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpServicesListQuery, GetSpServicesListQueryVariables>(GetSpServicesListDocument, options);
        }
export function useGetSpServicesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSpServicesListQuery, GetSpServicesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpServicesListQuery, GetSpServicesListQueryVariables>(GetSpServicesListDocument, options);
        }
export type GetSpServicesListQueryHookResult = ReturnType<typeof useGetSpServicesListQuery>;
export type GetSpServicesListLazyQueryHookResult = ReturnType<typeof useGetSpServicesListLazyQuery>;
export type GetSpServicesListSuspenseQueryHookResult = ReturnType<typeof useGetSpServicesListSuspenseQuery>;
export type GetSpServicesListQueryResult = Apollo.QueryResult<GetSpServicesListQuery, GetSpServicesListQueryVariables>;
export const GetSpServicesListbyLocationDocument = gql`
    query GetSpServicesListbyLocation($limit: Int, $offset: Int, $providerId: uuid!, $locationId: uuid!, $searchByName: String!) {
  services(
    where: {providerId: {_eq: $providerId}, name: {_ilike: $searchByName}, status: {_eq: active}, deletedAt: {_is_null: true}, _not: {unavailableServiceLocations: {locationId: {_eq: $locationId}}}, serviceEmployees: {user: {id: {_is_null: false}, userRole: {providerId: {_eq: $providerId}, deletedAt: {_is_null: true}}}}, provider: {_or: [{locations: {id: {_eq: $locationId}}}, {buildingProviders: {locationId: {_eq: $locationId}}}]}}
    limit: $limit
    offset: $offset
    order_by: {createdAt: desc}
  ) {
    id
    providerId
    name
    description
    sku
    duration
    customerCanPickEmployee
    featured
    serviceEmployees {
      user {
        id
        name
      }
    }
    servicePricing {
      basePrice
      minimumDeposit
      fees
      checkoutPayment
      paymentFormat
      taxes
    }
    serviceOptions(where: {status: {_eq: active}, deletedAt: {_is_null: true}}) {
      name
      id
      status
      serviceOptionSections {
        name
        order
        id
        mandatory
        type
        serviceOptionSectionOptions {
          id
          name
          order
          price
          quantity
        }
      }
    }
    servicesForms(
      where: {status: {_eq: active}, form: {deletedAt: {_is_null: true}}}
    ) {
      id
      formId
      status
      form {
        id
        name
        formQuestions(where: {deletedAt: {_is_null: true}}) {
          id
          label
          mandatory
          name
          order
          questionType
          options: formQuestionOptions {
            id
            value
          }
        }
      }
    }
  }
  services_aggregate(
    where: {providerId: {_eq: $providerId}, name: {_ilike: $searchByName}, status: {_eq: active}, deletedAt: {_is_null: true}, _not: {unavailableServiceLocations: {locationId: {_eq: $locationId}}}, serviceEmployees: {user: {id: {_is_null: false}, userRole: {providerId: {_eq: $providerId}, deletedAt: {_is_null: true}}}}, provider: {_or: [{locations: {id: {_eq: $locationId}}}, {buildingProviders: {locationId: {_eq: $locationId}}}]}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetSpServicesListbyLocationQuery__
 *
 * To run a query within a React component, call `useGetSpServicesListbyLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpServicesListbyLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpServicesListbyLocationQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      providerId: // value for 'providerId'
 *      locationId: // value for 'locationId'
 *      searchByName: // value for 'searchByName'
 *   },
 * });
 */
export function useGetSpServicesListbyLocationQuery(baseOptions: Apollo.QueryHookOptions<GetSpServicesListbyLocationQuery, GetSpServicesListbyLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpServicesListbyLocationQuery, GetSpServicesListbyLocationQueryVariables>(GetSpServicesListbyLocationDocument, options);
      }
export function useGetSpServicesListbyLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpServicesListbyLocationQuery, GetSpServicesListbyLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpServicesListbyLocationQuery, GetSpServicesListbyLocationQueryVariables>(GetSpServicesListbyLocationDocument, options);
        }
export function useGetSpServicesListbyLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSpServicesListbyLocationQuery, GetSpServicesListbyLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpServicesListbyLocationQuery, GetSpServicesListbyLocationQueryVariables>(GetSpServicesListbyLocationDocument, options);
        }
export type GetSpServicesListbyLocationQueryHookResult = ReturnType<typeof useGetSpServicesListbyLocationQuery>;
export type GetSpServicesListbyLocationLazyQueryHookResult = ReturnType<typeof useGetSpServicesListbyLocationLazyQuery>;
export type GetSpServicesListbyLocationSuspenseQueryHookResult = ReturnType<typeof useGetSpServicesListbyLocationSuspenseQuery>;
export type GetSpServicesListbyLocationQueryResult = Apollo.QueryResult<GetSpServicesListbyLocationQuery, GetSpServicesListbyLocationQueryVariables>;
export const GetBmServicesListDocument = gql`
    query GetBMServicesList($limit: Int, $offset: Int, $providerId: uuid!, $locationId: uuid!, $searchByName: String!) {
  services(
    where: {name: {_ilike: $searchByName}, status: {_eq: active}, providerId: {_eq: $providerId}, serviceEmployees: {user: {id: {_is_null: false}, userRole: {providerId: {_eq: $providerId}, deletedAt: {_is_null: true}}}}, _not: {unavailableServiceLocations: {locationId: {_eq: $locationId}}}}
    limit: $limit
    offset: $offset
    order_by: {createdAt: desc}
  ) {
    id
    providerId
    name
    sku
    duration
    description
    customerCanPickEmployee
    featured
    serviceEmployees {
      user {
        id
        name
      }
    }
    servicePricing {
      basePrice
      minimumDeposit
      fees
      checkoutPayment
      paymentFormat
      taxes
    }
    serviceOptions(where: {status: {_eq: active}, deletedAt: {_is_null: true}}) {
      name
      id
      status
      serviceOptionSections {
        name
        order
        id
        mandatory
        type
        serviceOptionSectionOptions {
          id
          name
          order
          price
          quantity
        }
      }
    }
    servicesForms(
      where: {status: {_eq: active}, form: {deletedAt: {_is_null: true}}}
    ) {
      id
      formId
      status
      form {
        id
        name
        formQuestions(where: {deletedAt: {_is_null: true}}) {
          id
          label
          mandatory
          name
          order
          questionType
          options: formQuestionOptions {
            id
            value
          }
        }
      }
    }
  }
  services_aggregate(
    where: {name: {_ilike: $searchByName}, status: {_eq: active}, providerId: {_eq: $providerId}, _not: {unavailableServiceLocations: {locationId: {_eq: $locationId}}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetBmServicesListQuery__
 *
 * To run a query within a React component, call `useGetBmServicesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBmServicesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBmServicesListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      providerId: // value for 'providerId'
 *      locationId: // value for 'locationId'
 *      searchByName: // value for 'searchByName'
 *   },
 * });
 */
export function useGetBmServicesListQuery(baseOptions: Apollo.QueryHookOptions<GetBmServicesListQuery, GetBmServicesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBmServicesListQuery, GetBmServicesListQueryVariables>(GetBmServicesListDocument, options);
      }
export function useGetBmServicesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBmServicesListQuery, GetBmServicesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBmServicesListQuery, GetBmServicesListQueryVariables>(GetBmServicesListDocument, options);
        }
export function useGetBmServicesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBmServicesListQuery, GetBmServicesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBmServicesListQuery, GetBmServicesListQueryVariables>(GetBmServicesListDocument, options);
        }
export type GetBmServicesListQueryHookResult = ReturnType<typeof useGetBmServicesListQuery>;
export type GetBmServicesListLazyQueryHookResult = ReturnType<typeof useGetBmServicesListLazyQuery>;
export type GetBmServicesListSuspenseQueryHookResult = ReturnType<typeof useGetBmServicesListSuspenseQuery>;
export type GetBmServicesListQueryResult = Apollo.QueryResult<GetBmServicesListQuery, GetBmServicesListQueryVariables>;
export const LoginDocument = gql`
    query Login($email: String!, $password: String!) {
  login(user: {email: $email, password: $password}) {
    accessToken
    refreshToken
  }
}
    `;

/**
 * __useLoginQuery__
 *
 * To run a query within a React component, call `useLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginQuery({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginQuery(baseOptions: Apollo.QueryHookOptions<LoginQuery, LoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginQuery, LoginQueryVariables>(LoginDocument, options);
      }
export function useLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginQuery, LoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginQuery, LoginQueryVariables>(LoginDocument, options);
        }
export function useLoginSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LoginQuery, LoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoginQuery, LoginQueryVariables>(LoginDocument, options);
        }
export type LoginQueryHookResult = ReturnType<typeof useLoginQuery>;
export type LoginLazyQueryHookResult = ReturnType<typeof useLoginLazyQuery>;
export type LoginSuspenseQueryHookResult = ReturnType<typeof useLoginSuspenseQuery>;
export type LoginQueryResult = Apollo.QueryResult<LoginQuery, LoginQueryVariables>;
export const RegisterDocument = gql`
    mutation Register($name: String!, $email: String!, $phoneNumber: String, $password: String!) {
  register(
    user: {name: $name, email: $email, phoneNumber: $phoneNumber, password: $password}
  ) {
    accessToken
    refreshToken
  }
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const RequestForgotPasswordDocument = gql`
    mutation RequestForgotPassword($email: String!) {
  requestForgotPassword(email: $email)
}
    `;
export type RequestForgotPasswordMutationFn = Apollo.MutationFunction<RequestForgotPasswordMutation, RequestForgotPasswordMutationVariables>;

/**
 * __useRequestForgotPasswordMutation__
 *
 * To run a mutation, you first call `useRequestForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestForgotPasswordMutation, { data, loading, error }] = useRequestForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<RequestForgotPasswordMutation, RequestForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestForgotPasswordMutation, RequestForgotPasswordMutationVariables>(RequestForgotPasswordDocument, options);
      }
export type RequestForgotPasswordMutationHookResult = ReturnType<typeof useRequestForgotPasswordMutation>;
export type RequestForgotPasswordMutationResult = Apollo.MutationResult<RequestForgotPasswordMutation>;
export type RequestForgotPasswordMutationOptions = Apollo.BaseMutationOptions<RequestForgotPasswordMutation, RequestForgotPasswordMutationVariables>;
export const CodeValidationDocument = gql`
    mutation CodeValidation($email: String!, $verificationToken: String!) {
  forgotPassword(email: $email, verificationToken: $verificationToken) {
    accessToken
    refreshToken
  }
}
    `;
export type CodeValidationMutationFn = Apollo.MutationFunction<CodeValidationMutation, CodeValidationMutationVariables>;

/**
 * __useCodeValidationMutation__
 *
 * To run a mutation, you first call `useCodeValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCodeValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [codeValidationMutation, { data, loading, error }] = useCodeValidationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      verificationToken: // value for 'verificationToken'
 *   },
 * });
 */
export function useCodeValidationMutation(baseOptions?: Apollo.MutationHookOptions<CodeValidationMutation, CodeValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CodeValidationMutation, CodeValidationMutationVariables>(CodeValidationDocument, options);
      }
export type CodeValidationMutationHookResult = ReturnType<typeof useCodeValidationMutation>;
export type CodeValidationMutationResult = Apollo.MutationResult<CodeValidationMutation>;
export type CodeValidationMutationOptions = Apollo.BaseMutationOptions<CodeValidationMutation, CodeValidationMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($password: String!) {
  changePassword(password: $password)
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const GetAllUsersDocument = gql`
    query GetAllUsers {
  getAllUsers {
    id
    email
    phoneNumber
  }
}
    `;

/**
 * __useGetAllUsersQuery__
 *
 * To run a query within a React component, call `useGetAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
      }
export function useGetAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
        }
export function useGetAllUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
        }
export type GetAllUsersQueryHookResult = ReturnType<typeof useGetAllUsersQuery>;
export type GetAllUsersLazyQueryHookResult = ReturnType<typeof useGetAllUsersLazyQuery>;
export type GetAllUsersSuspenseQueryHookResult = ReturnType<typeof useGetAllUsersSuspenseQuery>;
export type GetAllUsersQueryResult = Apollo.QueryResult<GetAllUsersQuery, GetAllUsersQueryVariables>;
export const UserByIdDocument = gql`
    query UserById($id: uuid!) {
  users_by_pk(id: $id) {
    id
    name
    email
    phoneNumber
    isEmailVerified
    isPhoneNumberVerified
    profilePicture {
      id
      name
    }
    userRole {
      role
      calendarId
    }
    completedAppointments: appointmentsByEmployeeid_aggregate(
      where: {jobStatus: {_eq: completed}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useUserByIdQuery__
 *
 * To run a query within a React component, call `useUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserByIdQuery(baseOptions: Apollo.QueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
      }
export function useUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
        }
export function useUserByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
        }
export type UserByIdQueryHookResult = ReturnType<typeof useUserByIdQuery>;
export type UserByIdLazyQueryHookResult = ReturnType<typeof useUserByIdLazyQuery>;
export type UserByIdSuspenseQueryHookResult = ReturnType<typeof useUserByIdSuspenseQuery>;
export type UserByIdQueryResult = Apollo.QueryResult<UserByIdQuery, UserByIdQueryVariables>;
export const UserKpiByIdDocument = gql`
    query UserKPIById($id: uuid!, $startDate: timestamptz!, $endDate: timestamptz!) {
  appointments: appointments_aggregate(
    where: {employeeId: {_eq: $id}, startDate: {_lte: $endDate, _gte: $startDate}, endDate: {_lte: $endDate, _gte: $startDate}}
  ) {
    aggregate {
      count
    }
  }
  timeouts: timeouts_aggregate(
    where: {userId: {_eq: $id}, startDate: {_lte: $endDate, _gte: $startDate}, endDate: {_lte: $endDate, _gte: $startDate}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useUserKpiByIdQuery__
 *
 * To run a query within a React component, call `useUserKpiByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserKpiByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserKpiByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useUserKpiByIdQuery(baseOptions: Apollo.QueryHookOptions<UserKpiByIdQuery, UserKpiByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserKpiByIdQuery, UserKpiByIdQueryVariables>(UserKpiByIdDocument, options);
      }
export function useUserKpiByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserKpiByIdQuery, UserKpiByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserKpiByIdQuery, UserKpiByIdQueryVariables>(UserKpiByIdDocument, options);
        }
export function useUserKpiByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserKpiByIdQuery, UserKpiByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserKpiByIdQuery, UserKpiByIdQueryVariables>(UserKpiByIdDocument, options);
        }
export type UserKpiByIdQueryHookResult = ReturnType<typeof useUserKpiByIdQuery>;
export type UserKpiByIdLazyQueryHookResult = ReturnType<typeof useUserKpiByIdLazyQuery>;
export type UserKpiByIdSuspenseQueryHookResult = ReturnType<typeof useUserKpiByIdSuspenseQuery>;
export type UserKpiByIdQueryResult = Apollo.QueryResult<UserKpiByIdQuery, UserKpiByIdQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  getCurrentUser {
    id
    name
    email
    phoneNumber
    profilePictureFileId
    isEmailVerified
    isPhoneNumberVerified
    userRole {
      role
    }
    address
    apartmentNumber
    coordinates {
      type
      coordinates
    }
    location {
      id
      name
      status
      transitionStatus
    }
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export function useCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const UserDataDocument = gql`
    query UserData($id: uuid!) {
  users_by_pk(id: $id) {
    id
    name
    phoneNumber
    address
    coordinates
    email
    profilePicture {
      id
      name
      uploadName
    }
  }
}
    `;

/**
 * __useUserDataQuery__
 *
 * To run a query within a React component, call `useUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDataQuery(baseOptions: Apollo.QueryHookOptions<UserDataQuery, UserDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDataQuery, UserDataQueryVariables>(UserDataDocument, options);
      }
export function useUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDataQuery, UserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDataQuery, UserDataQueryVariables>(UserDataDocument, options);
        }
export function useUserDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserDataQuery, UserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserDataQuery, UserDataQueryVariables>(UserDataDocument, options);
        }
export type UserDataQueryHookResult = ReturnType<typeof useUserDataQuery>;
export type UserDataLazyQueryHookResult = ReturnType<typeof useUserDataLazyQuery>;
export type UserDataSuspenseQueryHookResult = ReturnType<typeof useUserDataSuspenseQuery>;
export type UserDataQueryResult = Apollo.QueryResult<UserDataQuery, UserDataQueryVariables>;
export const AddUserProfilePicDocument = gql`
    mutation AddUserProfilePic($userId: uuid!, $fileId: uuid!) {
  update_users_by_pk(
    pk_columns: {id: $userId}
    _set: {profilePictureFileId: $fileId}
  ) {
    id
    name
    phoneNumber
    address
    email
    profilePicture {
      id
      name
      uploadName
    }
  }
}
    `;
export type AddUserProfilePicMutationFn = Apollo.MutationFunction<AddUserProfilePicMutation, AddUserProfilePicMutationVariables>;

/**
 * __useAddUserProfilePicMutation__
 *
 * To run a mutation, you first call `useAddUserProfilePicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserProfilePicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserProfilePicMutation, { data, loading, error }] = useAddUserProfilePicMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useAddUserProfilePicMutation(baseOptions?: Apollo.MutationHookOptions<AddUserProfilePicMutation, AddUserProfilePicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserProfilePicMutation, AddUserProfilePicMutationVariables>(AddUserProfilePicDocument, options);
      }
export type AddUserProfilePicMutationHookResult = ReturnType<typeof useAddUserProfilePicMutation>;
export type AddUserProfilePicMutationResult = Apollo.MutationResult<AddUserProfilePicMutation>;
export type AddUserProfilePicMutationOptions = Apollo.BaseMutationOptions<AddUserProfilePicMutation, AddUserProfilePicMutationVariables>;
export const DeleteUserProfilePicDocument = gql`
    mutation DeleteUserProfilePic($userId: uuid!) {
  update_users_by_pk(
    pk_columns: {id: $userId}
    _set: {profilePictureFileId: null}
  ) {
    id
    name
    phoneNumber
    address
    email
    profilePicture {
      id
      name
      uploadName
    }
  }
}
    `;
export type DeleteUserProfilePicMutationFn = Apollo.MutationFunction<DeleteUserProfilePicMutation, DeleteUserProfilePicMutationVariables>;

/**
 * __useDeleteUserProfilePicMutation__
 *
 * To run a mutation, you first call `useDeleteUserProfilePicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserProfilePicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserProfilePicMutation, { data, loading, error }] = useDeleteUserProfilePicMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserProfilePicMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserProfilePicMutation, DeleteUserProfilePicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserProfilePicMutation, DeleteUserProfilePicMutationVariables>(DeleteUserProfilePicDocument, options);
      }
export type DeleteUserProfilePicMutationHookResult = ReturnType<typeof useDeleteUserProfilePicMutation>;
export type DeleteUserProfilePicMutationResult = Apollo.MutationResult<DeleteUserProfilePicMutation>;
export type DeleteUserProfilePicMutationOptions = Apollo.BaseMutationOptions<DeleteUserProfilePicMutation, DeleteUserProfilePicMutationVariables>;
export const EditUserDetailsDocument = gql`
    mutation EditUserDetails($userId: uuid!, $name: String!) {
  update_users_by_pk(pk_columns: {id: $userId}, _set: {name: $name}) {
    id
    name
    address
    email
    profilePicture {
      id
      name
      uploadName
    }
  }
}
    `;
export type EditUserDetailsMutationFn = Apollo.MutationFunction<EditUserDetailsMutation, EditUserDetailsMutationVariables>;

/**
 * __useEditUserDetailsMutation__
 *
 * To run a mutation, you first call `useEditUserDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserDetailsMutation, { data, loading, error }] = useEditUserDetailsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEditUserDetailsMutation(baseOptions?: Apollo.MutationHookOptions<EditUserDetailsMutation, EditUserDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUserDetailsMutation, EditUserDetailsMutationVariables>(EditUserDetailsDocument, options);
      }
export type EditUserDetailsMutationHookResult = ReturnType<typeof useEditUserDetailsMutation>;
export type EditUserDetailsMutationResult = Apollo.MutationResult<EditUserDetailsMutation>;
export type EditUserDetailsMutationOptions = Apollo.BaseMutationOptions<EditUserDetailsMutation, EditUserDetailsMutationVariables>;
export const EditUserPhoneNumberDocument = gql`
    mutation EditUserPhoneNumber($phoneNumber: String!) {
  updateUserPhone(phoneNumber: $phoneNumber) {
    id
    phoneNumber
    isPhoneNumberVerified
  }
}
    `;
export type EditUserPhoneNumberMutationFn = Apollo.MutationFunction<EditUserPhoneNumberMutation, EditUserPhoneNumberMutationVariables>;

/**
 * __useEditUserPhoneNumberMutation__
 *
 * To run a mutation, you first call `useEditUserPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserPhoneNumberMutation, { data, loading, error }] = useEditUserPhoneNumberMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useEditUserPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<EditUserPhoneNumberMutation, EditUserPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUserPhoneNumberMutation, EditUserPhoneNumberMutationVariables>(EditUserPhoneNumberDocument, options);
      }
export type EditUserPhoneNumberMutationHookResult = ReturnType<typeof useEditUserPhoneNumberMutation>;
export type EditUserPhoneNumberMutationResult = Apollo.MutationResult<EditUserPhoneNumberMutation>;
export type EditUserPhoneNumberMutationOptions = Apollo.BaseMutationOptions<EditUserPhoneNumberMutation, EditUserPhoneNumberMutationVariables>;
export const UpdateUserAddressDocument = gql`
    mutation UpdateUserAddress($userId: uuid!, $address: String!, $coordinates: geography!, $apartmentNumber: String) {
  update_users_by_pk(
    pk_columns: {id: $userId}
    _set: {address: $address, apartmentNumber: $apartmentNumber, coordinates: $coordinates}
  ) {
    id
    name
    phoneNumber
    address
    coordinates
    email
    profilePicture {
      id
      name
      uploadName
    }
  }
}
    `;
export type UpdateUserAddressMutationFn = Apollo.MutationFunction<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>;

/**
 * __useUpdateUserAddressMutation__
 *
 * To run a mutation, you first call `useUpdateUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAddressMutation, { data, loading, error }] = useUpdateUserAddressMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      address: // value for 'address'
 *      coordinates: // value for 'coordinates'
 *      apartmentNumber: // value for 'apartmentNumber'
 *   },
 * });
 */
export function useUpdateUserAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>(UpdateUserAddressDocument, options);
      }
export type UpdateUserAddressMutationHookResult = ReturnType<typeof useUpdateUserAddressMutation>;
export type UpdateUserAddressMutationResult = Apollo.MutationResult<UpdateUserAddressMutation>;
export type UpdateUserAddressMutationOptions = Apollo.BaseMutationOptions<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>;
export const BuildingManagerLocationsByAddressDocument = gql`
    query BuildingManagerLocationsByAddress($address: String!) {
  locations(
    where: {address: {_eq: $address}, buildingManagerId: {_is_null: false}}
  ) {
    id
    address
    buildingManager {
      id
      name
      email
      phoneNumber
    }
  }
}
    `;

/**
 * __useBuildingManagerLocationsByAddressQuery__
 *
 * To run a query within a React component, call `useBuildingManagerLocationsByAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingManagerLocationsByAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingManagerLocationsByAddressQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useBuildingManagerLocationsByAddressQuery(baseOptions: Apollo.QueryHookOptions<BuildingManagerLocationsByAddressQuery, BuildingManagerLocationsByAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildingManagerLocationsByAddressQuery, BuildingManagerLocationsByAddressQueryVariables>(BuildingManagerLocationsByAddressDocument, options);
      }
export function useBuildingManagerLocationsByAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildingManagerLocationsByAddressQuery, BuildingManagerLocationsByAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildingManagerLocationsByAddressQuery, BuildingManagerLocationsByAddressQueryVariables>(BuildingManagerLocationsByAddressDocument, options);
        }
export function useBuildingManagerLocationsByAddressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingManagerLocationsByAddressQuery, BuildingManagerLocationsByAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BuildingManagerLocationsByAddressQuery, BuildingManagerLocationsByAddressQueryVariables>(BuildingManagerLocationsByAddressDocument, options);
        }
export type BuildingManagerLocationsByAddressQueryHookResult = ReturnType<typeof useBuildingManagerLocationsByAddressQuery>;
export type BuildingManagerLocationsByAddressLazyQueryHookResult = ReturnType<typeof useBuildingManagerLocationsByAddressLazyQuery>;
export type BuildingManagerLocationsByAddressSuspenseQueryHookResult = ReturnType<typeof useBuildingManagerLocationsByAddressSuspenseQuery>;
export type BuildingManagerLocationsByAddressQueryResult = Apollo.QueryResult<BuildingManagerLocationsByAddressQuery, BuildingManagerLocationsByAddressQueryVariables>;
export const GetUserFutureAppointmentsDocument = gql`
    query GetUserFutureAppointments($limit: Int!, $offset: Int!, $jobStatus: [jobStatus_enum!]!) {
  appointments(
    limit: $limit
    offset: $offset
    where: {jobStatus: {_in: $jobStatus}, startDate: {_gte: "now()"}}
    order_by: {startDate: asc, id: desc}
  ) {
    id
    startDate
    jobStatus
    paymentStatus
    createdByUserId
    service {
      id
      name
      description
      servicePictures {
        id
        name
      }
    }
  }
  appointments_aggregate(
    where: {jobStatus: {_in: $jobStatus}, startDate: {_gte: "now()"}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetUserFutureAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetUserFutureAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFutureAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFutureAppointmentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      jobStatus: // value for 'jobStatus'
 *   },
 * });
 */
export function useGetUserFutureAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<GetUserFutureAppointmentsQuery, GetUserFutureAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFutureAppointmentsQuery, GetUserFutureAppointmentsQueryVariables>(GetUserFutureAppointmentsDocument, options);
      }
export function useGetUserFutureAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFutureAppointmentsQuery, GetUserFutureAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFutureAppointmentsQuery, GetUserFutureAppointmentsQueryVariables>(GetUserFutureAppointmentsDocument, options);
        }
export function useGetUserFutureAppointmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserFutureAppointmentsQuery, GetUserFutureAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserFutureAppointmentsQuery, GetUserFutureAppointmentsQueryVariables>(GetUserFutureAppointmentsDocument, options);
        }
export type GetUserFutureAppointmentsQueryHookResult = ReturnType<typeof useGetUserFutureAppointmentsQuery>;
export type GetUserFutureAppointmentsLazyQueryHookResult = ReturnType<typeof useGetUserFutureAppointmentsLazyQuery>;
export type GetUserFutureAppointmentsSuspenseQueryHookResult = ReturnType<typeof useGetUserFutureAppointmentsSuspenseQuery>;
export type GetUserFutureAppointmentsQueryResult = Apollo.QueryResult<GetUserFutureAppointmentsQuery, GetUserFutureAppointmentsQueryVariables>;
export const GetUserPastAppointmentsDocument = gql`
    query GetUserPastAppointments($limit: Int!, $offset: Int!, $jobStatus: [jobStatus_enum!]!) {
  appointments(
    limit: $limit
    offset: $offset
    where: {jobStatus: {_in: $jobStatus}, startDate: {_lt: "now()"}}
    order_by: {startDate: asc, id: desc}
  ) {
    id
    startDate
    jobStatus
    paymentStatus
    createdByUserId
    service {
      id
      name
      sku
      description
      duration
      providerId
      provider {
        id
        visibility
      }
      servicePricing {
        id
        basePrice
        fees
        minimumDeposit
        currency
        taxes
        checkoutPayment
        paymentFormat
      }
      servicePictures {
        id
        name
        file {
          id
          name
          uploadName
        }
      }
      serviceOptions(where: {status: {_eq: active}, deletedAt: {_is_null: true}}) {
        id
        name
        status
        serviceOptionSections {
          id
          mandatory
          name
          type
          order
          serviceOptionSectionOptions {
            id
            name
            price
            order
            quantity
          }
        }
      }
      servicesForms(
        where: {status: {_eq: active}, form: {deletedAt: {_is_null: true}}}
      ) {
        id
        formId
        status
        form {
          id
          name
          formQuestions(where: {deletedAt: {_is_null: true}}) {
            id
            label
            mandatory
            name
            order
            questionType
            options: formQuestionOptions {
              id
              value
            }
            formAnswers {
              formId
              formQuestionId
              answer
              optionId
              fileId
            }
          }
        }
      }
    }
  }
  appointments_aggregate(
    where: {jobStatus: {_in: [completed, cancelled, rejected]}, startDate: {_lt: "now()"}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetUserPastAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetUserPastAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPastAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPastAppointmentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      jobStatus: // value for 'jobStatus'
 *   },
 * });
 */
export function useGetUserPastAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<GetUserPastAppointmentsQuery, GetUserPastAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPastAppointmentsQuery, GetUserPastAppointmentsQueryVariables>(GetUserPastAppointmentsDocument, options);
      }
export function useGetUserPastAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPastAppointmentsQuery, GetUserPastAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPastAppointmentsQuery, GetUserPastAppointmentsQueryVariables>(GetUserPastAppointmentsDocument, options);
        }
export function useGetUserPastAppointmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserPastAppointmentsQuery, GetUserPastAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPastAppointmentsQuery, GetUserPastAppointmentsQueryVariables>(GetUserPastAppointmentsDocument, options);
        }
export type GetUserPastAppointmentsQueryHookResult = ReturnType<typeof useGetUserPastAppointmentsQuery>;
export type GetUserPastAppointmentsLazyQueryHookResult = ReturnType<typeof useGetUserPastAppointmentsLazyQuery>;
export type GetUserPastAppointmentsSuspenseQueryHookResult = ReturnType<typeof useGetUserPastAppointmentsSuspenseQuery>;
export type GetUserPastAppointmentsQueryResult = Apollo.QueryResult<GetUserPastAppointmentsQuery, GetUserPastAppointmentsQueryVariables>;
export const GetUserDraftAppointmentsDocument = gql`
    query GetUserDraftAppointments {
  appointments(
    where: {jobStatus: {_eq: draft}}
    order_by: {startDate: asc, id: desc}
  ) {
    id
    startDate
    jobStatus
    paymentStatus
    service {
      id
      name
      description
      servicePictures {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetUserDraftAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetUserDraftAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDraftAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDraftAppointmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserDraftAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserDraftAppointmentsQuery, GetUserDraftAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDraftAppointmentsQuery, GetUserDraftAppointmentsQueryVariables>(GetUserDraftAppointmentsDocument, options);
      }
export function useGetUserDraftAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDraftAppointmentsQuery, GetUserDraftAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDraftAppointmentsQuery, GetUserDraftAppointmentsQueryVariables>(GetUserDraftAppointmentsDocument, options);
        }
export function useGetUserDraftAppointmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserDraftAppointmentsQuery, GetUserDraftAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserDraftAppointmentsQuery, GetUserDraftAppointmentsQueryVariables>(GetUserDraftAppointmentsDocument, options);
        }
export type GetUserDraftAppointmentsQueryHookResult = ReturnType<typeof useGetUserDraftAppointmentsQuery>;
export type GetUserDraftAppointmentsLazyQueryHookResult = ReturnType<typeof useGetUserDraftAppointmentsLazyQuery>;
export type GetUserDraftAppointmentsSuspenseQueryHookResult = ReturnType<typeof useGetUserDraftAppointmentsSuspenseQuery>;
export type GetUserDraftAppointmentsQueryResult = Apollo.QueryResult<GetUserDraftAppointmentsQuery, GetUserDraftAppointmentsQueryVariables>;
export const GetUpfrontAppointmentDetailsDocument = gql`
    query GetUpfrontAppointmentDetails($serviceId: String!, $employeeId: String!, $locationId: String!, $date: DateTime!, $address: String!, $optionAnswers: [CreateApptServiceOptionAnswers!]!, $coordinates: [Float!]!, $apartmentNumber: String, $formAnswers: [CreateApptServiceFormAnswers!]!) {
  getUpfrontAppointmentDetails(
    data: {serviceId: $serviceId, employeeId: $employeeId, locationId: $locationId, address: $address, date: $date, createApptServiceOptionAnswers: $optionAnswers, coordinates: $coordinates, apartmentNumber: $apartmentNumber, createApptServiceFormAnswers: $formAnswers}
  ) {
    data {
      details {
        date
        employeeName
        locationName
      }
      formsNames
      payPrice {
        deposit
        fees
        serviceFee
        taxes
        options
        total
      }
      price {
        deposit
        fees
        options {
          name
          price
          quantity
        }
        service {
          duration
          name
          price
        }
        subtotal
        taxes
        total
      }
    }
    errors {
      details
      forms
      payPrice
      price
    }
  }
}
    `;

/**
 * __useGetUpfrontAppointmentDetailsQuery__
 *
 * To run a query within a React component, call `useGetUpfrontAppointmentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpfrontAppointmentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpfrontAppointmentDetailsQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      employeeId: // value for 'employeeId'
 *      locationId: // value for 'locationId'
 *      date: // value for 'date'
 *      address: // value for 'address'
 *      optionAnswers: // value for 'optionAnswers'
 *      coordinates: // value for 'coordinates'
 *      apartmentNumber: // value for 'apartmentNumber'
 *      formAnswers: // value for 'formAnswers'
 *   },
 * });
 */
export function useGetUpfrontAppointmentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetUpfrontAppointmentDetailsQuery, GetUpfrontAppointmentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUpfrontAppointmentDetailsQuery, GetUpfrontAppointmentDetailsQueryVariables>(GetUpfrontAppointmentDetailsDocument, options);
      }
export function useGetUpfrontAppointmentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpfrontAppointmentDetailsQuery, GetUpfrontAppointmentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUpfrontAppointmentDetailsQuery, GetUpfrontAppointmentDetailsQueryVariables>(GetUpfrontAppointmentDetailsDocument, options);
        }
export function useGetUpfrontAppointmentDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUpfrontAppointmentDetailsQuery, GetUpfrontAppointmentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUpfrontAppointmentDetailsQuery, GetUpfrontAppointmentDetailsQueryVariables>(GetUpfrontAppointmentDetailsDocument, options);
        }
export type GetUpfrontAppointmentDetailsQueryHookResult = ReturnType<typeof useGetUpfrontAppointmentDetailsQuery>;
export type GetUpfrontAppointmentDetailsLazyQueryHookResult = ReturnType<typeof useGetUpfrontAppointmentDetailsLazyQuery>;
export type GetUpfrontAppointmentDetailsSuspenseQueryHookResult = ReturnType<typeof useGetUpfrontAppointmentDetailsSuspenseQuery>;
export type GetUpfrontAppointmentDetailsQueryResult = Apollo.QueryResult<GetUpfrontAppointmentDetailsQuery, GetUpfrontAppointmentDetailsQueryVariables>;
export const UserCardDocument = gql`
    query UserCard {
  getUserCard {
    id
    brand
    expMonth
    expYear
    last4
    name
  }
}
    `;

/**
 * __useUserCardQuery__
 *
 * To run a query within a React component, call `useUserCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserCardQuery(baseOptions?: Apollo.QueryHookOptions<UserCardQuery, UserCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCardQuery, UserCardQueryVariables>(UserCardDocument, options);
      }
export function useUserCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCardQuery, UserCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCardQuery, UserCardQueryVariables>(UserCardDocument, options);
        }
export function useUserCardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserCardQuery, UserCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserCardQuery, UserCardQueryVariables>(UserCardDocument, options);
        }
export type UserCardQueryHookResult = ReturnType<typeof useUserCardQuery>;
export type UserCardLazyQueryHookResult = ReturnType<typeof useUserCardLazyQuery>;
export type UserCardSuspenseQueryHookResult = ReturnType<typeof useUserCardSuspenseQuery>;
export type UserCardQueryResult = Apollo.QueryResult<UserCardQuery, UserCardQueryVariables>;
export const CreateUserSetupIntentDocument = gql`
    mutation CreateUserSetupIntent($confirmationTokenId: String!) {
  createUserSetupIntent(confirmationTokenId: $confirmationTokenId) {
    clientSecret
    status
  }
}
    `;
export type CreateUserSetupIntentMutationFn = Apollo.MutationFunction<CreateUserSetupIntentMutation, CreateUserSetupIntentMutationVariables>;

/**
 * __useCreateUserSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateUserSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserSetupIntentMutation, { data, loading, error }] = useCreateUserSetupIntentMutation({
 *   variables: {
 *      confirmationTokenId: // value for 'confirmationTokenId'
 *   },
 * });
 */
export function useCreateUserSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserSetupIntentMutation, CreateUserSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserSetupIntentMutation, CreateUserSetupIntentMutationVariables>(CreateUserSetupIntentDocument, options);
      }
export type CreateUserSetupIntentMutationHookResult = ReturnType<typeof useCreateUserSetupIntentMutation>;
export type CreateUserSetupIntentMutationResult = Apollo.MutationResult<CreateUserSetupIntentMutation>;
export type CreateUserSetupIntentMutationOptions = Apollo.BaseMutationOptions<CreateUserSetupIntentMutation, CreateUserSetupIntentMutationVariables>;
export const DeleteUserPaymentMethodDocument = gql`
    mutation DeleteUserPaymentMethod {
  deleteUserPaymentMethod {
    id
  }
}
    `;
export type DeleteUserPaymentMethodMutationFn = Apollo.MutationFunction<DeleteUserPaymentMethodMutation, DeleteUserPaymentMethodMutationVariables>;

/**
 * __useDeleteUserPaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeleteUserPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserPaymentMethodMutation, { data, loading, error }] = useDeleteUserPaymentMethodMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteUserPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserPaymentMethodMutation, DeleteUserPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserPaymentMethodMutation, DeleteUserPaymentMethodMutationVariables>(DeleteUserPaymentMethodDocument, options);
      }
export type DeleteUserPaymentMethodMutationHookResult = ReturnType<typeof useDeleteUserPaymentMethodMutation>;
export type DeleteUserPaymentMethodMutationResult = Apollo.MutationResult<DeleteUserPaymentMethodMutation>;
export type DeleteUserPaymentMethodMutationOptions = Apollo.BaseMutationOptions<DeleteUserPaymentMethodMutation, DeleteUserPaymentMethodMutationVariables>;
export const CreateAppointmentPaymentIntentUserDocument = gql`
    mutation CreateAppointmentPaymentIntentUser($serviceId: String!, $locationId: String!, $optionAnswers: [CreateApptServiceOptionAnswers!]!) {
  createAppointmentPaymentIntentUser(
    data: {serviceId: $serviceId, locationId: $locationId, createApptServiceOptionAnswers: $optionAnswers}
  ) {
    clientSecret
    generatedAppointmentId
    paymentIntentId
    connectedAccountId
  }
}
    `;
export type CreateAppointmentPaymentIntentUserMutationFn = Apollo.MutationFunction<CreateAppointmentPaymentIntentUserMutation, CreateAppointmentPaymentIntentUserMutationVariables>;

/**
 * __useCreateAppointmentPaymentIntentUserMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentPaymentIntentUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentPaymentIntentUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentPaymentIntentUserMutation, { data, loading, error }] = useCreateAppointmentPaymentIntentUserMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      locationId: // value for 'locationId'
 *      optionAnswers: // value for 'optionAnswers'
 *   },
 * });
 */
export function useCreateAppointmentPaymentIntentUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentPaymentIntentUserMutation, CreateAppointmentPaymentIntentUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentPaymentIntentUserMutation, CreateAppointmentPaymentIntentUserMutationVariables>(CreateAppointmentPaymentIntentUserDocument, options);
      }
export type CreateAppointmentPaymentIntentUserMutationHookResult = ReturnType<typeof useCreateAppointmentPaymentIntentUserMutation>;
export type CreateAppointmentPaymentIntentUserMutationResult = Apollo.MutationResult<CreateAppointmentPaymentIntentUserMutation>;
export type CreateAppointmentPaymentIntentUserMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentPaymentIntentUserMutation, CreateAppointmentPaymentIntentUserMutationVariables>;
export const CreateAppointmentPaymentIntentAnonymousDocument = gql`
    mutation CreateAppointmentPaymentIntentAnonymous($serviceId: String!, $optionAnswers: [CreateApptServiceOptionAnswers!]!, $locationId: String!, $name: String!, $email: String!, $phoneNumber: String) {
  createAppointmentPaymentIntentAnonymous(
    data: {serviceId: $serviceId, createApptServiceOptionAnswers: $optionAnswers, locationId: $locationId, name: $name, email: $email, phoneNumber: $phoneNumber}
  ) {
    clientSecret
    generatedAppointmentId
    paymentIntentId
    connectedAccountId
  }
}
    `;
export type CreateAppointmentPaymentIntentAnonymousMutationFn = Apollo.MutationFunction<CreateAppointmentPaymentIntentAnonymousMutation, CreateAppointmentPaymentIntentAnonymousMutationVariables>;

/**
 * __useCreateAppointmentPaymentIntentAnonymousMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentPaymentIntentAnonymousMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentPaymentIntentAnonymousMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentPaymentIntentAnonymousMutation, { data, loading, error }] = useCreateAppointmentPaymentIntentAnonymousMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      optionAnswers: // value for 'optionAnswers'
 *      locationId: // value for 'locationId'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useCreateAppointmentPaymentIntentAnonymousMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentPaymentIntentAnonymousMutation, CreateAppointmentPaymentIntentAnonymousMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentPaymentIntentAnonymousMutation, CreateAppointmentPaymentIntentAnonymousMutationVariables>(CreateAppointmentPaymentIntentAnonymousDocument, options);
      }
export type CreateAppointmentPaymentIntentAnonymousMutationHookResult = ReturnType<typeof useCreateAppointmentPaymentIntentAnonymousMutation>;
export type CreateAppointmentPaymentIntentAnonymousMutationResult = Apollo.MutationResult<CreateAppointmentPaymentIntentAnonymousMutation>;
export type CreateAppointmentPaymentIntentAnonymousMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentPaymentIntentAnonymousMutation, CreateAppointmentPaymentIntentAnonymousMutationVariables>;
export const CreateBookedAppointmentPaymentIntentDocument = gql`
    mutation CreateBookedAppointmentPaymentIntent($appointmentId: String!) {
  createBookedAppointmentPaymentIntent(appointmentId: $appointmentId) {
    clientSecret
    connectedAccountId
    paymentIntentId
  }
}
    `;
export type CreateBookedAppointmentPaymentIntentMutationFn = Apollo.MutationFunction<CreateBookedAppointmentPaymentIntentMutation, CreateBookedAppointmentPaymentIntentMutationVariables>;

/**
 * __useCreateBookedAppointmentPaymentIntentMutation__
 *
 * To run a mutation, you first call `useCreateBookedAppointmentPaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookedAppointmentPaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookedAppointmentPaymentIntentMutation, { data, loading, error }] = useCreateBookedAppointmentPaymentIntentMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useCreateBookedAppointmentPaymentIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookedAppointmentPaymentIntentMutation, CreateBookedAppointmentPaymentIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookedAppointmentPaymentIntentMutation, CreateBookedAppointmentPaymentIntentMutationVariables>(CreateBookedAppointmentPaymentIntentDocument, options);
      }
export type CreateBookedAppointmentPaymentIntentMutationHookResult = ReturnType<typeof useCreateBookedAppointmentPaymentIntentMutation>;
export type CreateBookedAppointmentPaymentIntentMutationResult = Apollo.MutationResult<CreateBookedAppointmentPaymentIntentMutation>;
export type CreateBookedAppointmentPaymentIntentMutationOptions = Apollo.BaseMutationOptions<CreateBookedAppointmentPaymentIntentMutation, CreateBookedAppointmentPaymentIntentMutationVariables>;
export type AccountLinkDtoKeySpecifier = ('created' | 'expires_at' | 'object' | 'url' | AccountLinkDtoKeySpecifier)[];
export type AccountLinkDtoFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	expires_at?: FieldPolicy<any> | FieldReadFunction<any>,
	object?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminCustomerListDtoKeySpecifier = ('customers' | 'customersAggregate' | AdminCustomerListDtoKeySpecifier)[];
export type AdminCustomerListDtoFieldPolicy = {
	customers?: FieldPolicy<any> | FieldReadFunction<any>,
	customersAggregate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AggregateKeySpecifier = ('aggregate' | AggregateKeySpecifier)[];
export type AggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AggregateSumKeySpecifier = ('aggregate' | AggregateSumKeySpecifier)[];
export type AggregateSumFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AmountKeySpecifier = ('amount' | AmountKeySpecifier)[];
export type AmountFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppointmentKeySpecifier = ('address' | 'coordinates' | 'createdAt' | 'createdByUserId' | 'customerId' | 'employeeId' | 'endDate' | 'id' | 'jobStatus' | 'locationId' | 'notes' | 'paymentStatus' | 'serviceId' | 'startDate' | 'updatedAt' | AppointmentKeySpecifier)[];
export type AppointmentFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	customerId?: FieldPolicy<any> | FieldReadFunction<any>,
	employeeId?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	jobStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppointmentLocationDtoKeySpecifier = ('address' | 'id' | 'radius' | AppointmentLocationDtoKeySpecifier)[];
export type AppointmentLocationDtoFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	radius?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppointmentServiceDtoKeySpecifier = ('provider' | 'sku' | AppointmentServiceDtoKeySpecifier)[];
export type AppointmentServiceDtoFieldPolicy = {
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AvailableAppointmentDateTimeSlotsDtoKeySpecifier = ('availableSlots' | AvailableAppointmentDateTimeSlotsDtoKeySpecifier)[];
export type AvailableAppointmentDateTimeSlotsDtoFieldPolicy = {
	availableSlots?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BuildingManagerCustomerListDtoKeySpecifier = ('allAppointmentsAggregate' | 'allCustomersAggregate' | 'filteredCustomers' | 'filteredCustomersAggregate' | BuildingManagerCustomerListDtoKeySpecifier)[];
export type BuildingManagerCustomerListDtoFieldPolicy = {
	allAppointmentsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	allCustomersAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	filteredCustomers?: FieldPolicy<any> | FieldReadFunction<any>,
	filteredCustomersAggregate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BuildingManagerCustomerListEntryDtoKeySpecifier = ('address' | 'amountSpent' | 'apartmentNumber' | 'bmStripeCustomerId' | 'bmStripePaymentMethodId' | 'bookings' | 'coordinates' | 'createdAt' | 'deletedAt' | 'email' | 'id' | 'isBlocked' | 'locationId' | 'name' | 'phoneNumber' | 'stripePaymentMethodId' | 'user' | BuildingManagerCustomerListEntryDtoKeySpecifier)[];
export type BuildingManagerCustomerListEntryDtoFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	amountSpent?: FieldPolicy<any> | FieldReadFunction<any>,
	apartmentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	bmStripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	bmStripePaymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	bookings?: FieldPolicy<any> | FieldReadFunction<any>,
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isBlocked?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	stripePaymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BuildingManagerCustomerWithAppointmentsDtoKeySpecifier = ('address' | 'amountSpent' | 'apartmentNumber' | 'appointments' | 'appointmentsAggregate' | 'bmStripeCustomerId' | 'bmStripePaymentMethodId' | 'bookings' | 'coordinates' | 'createdAt' | 'deletedAt' | 'email' | 'id' | 'isBlocked' | 'locationId' | 'name' | 'phoneNumber' | 'stripePaymentMethodId' | 'user' | BuildingManagerCustomerWithAppointmentsDtoKeySpecifier)[];
export type BuildingManagerCustomerWithAppointmentsDtoFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	amountSpent?: FieldPolicy<any> | FieldReadFunction<any>,
	apartmentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	appointments?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bmStripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	bmStripePaymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	bookings?: FieldPolicy<any> | FieldReadFunction<any>,
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isBlocked?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	stripePaymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CalendarListEntryDtoKeySpecifier = ('accessRole' | 'description' | 'id' | 'primary' | 'summary' | 'timeZone' | CalendarListEntryDtoKeySpecifier)[];
export type CalendarListEntryDtoFieldPolicy = {
	accessRole?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	primary?: FieldPolicy<any> | FieldReadFunction<any>,
	summary?: FieldPolicy<any> | FieldReadFunction<any>,
	timeZone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutSesssionDtoKeySpecifier = ('id' | 'token' | CheckoutSesssionDtoKeySpecifier)[];
export type CheckoutSesssionDtoFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CompanyAddressDtoKeySpecifier = ('address' | 'city' | 'country' | 'state' | CompanyAddressDtoKeySpecifier)[];
export type CompanyAddressDtoFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CountKeySpecifier = ('count' | CountKeySpecifier)[];
export type CountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateAppointmentPaymentIntentDtoKeySpecifier = ('clientSecret' | 'connectedAccountId' | 'generatedAppointmentId' | 'paymentIntentId' | CreateAppointmentPaymentIntentDtoKeySpecifier)[];
export type CreateAppointmentPaymentIntentDtoFieldPolicy = {
	clientSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	connectedAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	generatedAppointmentId?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentIntentId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateApptBMKeySpecifier = ('id' | CreateApptBMKeySpecifier)[];
export type CreateApptBMFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateApptSPKeySpecifier = ('address' | 'apartmentNumber' | 'coordinates' | 'customerId' | 'employeeId' | 'endDate' | 'id' | 'jobStatus' | 'service' | 'startDate' | CreateApptSPKeySpecifier)[];
export type CreateApptSPFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	apartmentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	customerId?: FieldPolicy<any> | FieldReadFunction<any>,
	employeeId?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	jobStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateApptSPServiceKeySpecifier = ('color' | 'name' | CreateApptSPServiceKeySpecifier)[];
export type CreateApptSPServiceFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateApptUserKeySpecifier = ('id' | CreateApptUserKeySpecifier)[];
export type CreateApptUserFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateBookedAppointmentPaymentIntentDtoKeySpecifier = ('clientSecret' | 'connectedAccountId' | 'paymentIntentId' | CreateBookedAppointmentPaymentIntentDtoKeySpecifier)[];
export type CreateBookedAppointmentPaymentIntentDtoFieldPolicy = {
	clientSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	connectedAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentIntentId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateEmployeeDtoKeySpecifier = ('createdAt' | 'email' | 'id' | 'name' | 'phoneNumber' | 'profilePicture' | 'profilePictureFileId' | CreateEmployeeDtoKeySpecifier)[];
export type CreateEmployeeDtoFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePicture?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePictureFileId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerKeySpecifier = ('address' | 'apartmentNumber' | 'bmStripeCustomerId' | 'coordinates' | 'createdAt' | 'deletedAt' | 'email' | 'id' | 'isBlocked' | 'locationId' | 'name' | 'phoneNumber' | 'providerId' | 'stripeCustomerId' | 'updatedAt' | 'user' | 'userId' | CustomerKeySpecifier)[];
export type CustomerFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	apartmentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	bmStripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isBlocked?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerAppointmentDataKeySpecifier = ('createdAt' | 'endDate' | 'id' | 'jobStatus' | 'location' | 'paymentStatus' | 'payments_aggregate' | 'service' | 'startDate' | 'updatedAt' | CustomerAppointmentDataKeySpecifier)[];
export type CustomerAppointmentDataFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	jobStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	payments_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerCardDtoKeySpecifier = ('brand' | 'expMonth' | 'expYear' | 'id' | 'last4' | 'name' | CustomerCardDtoKeySpecifier)[];
export type CustomerCardDtoFieldPolicy = {
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	expMonth?: FieldPolicy<any> | FieldReadFunction<any>,
	expYear?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last4?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerEntryDtoKeySpecifier = ('address' | 'amountSpent' | 'apartmentNumber' | 'bmStripeCustomerId' | 'bmStripePaymentMethodId' | 'bookings' | 'coordinates' | 'createdAt' | 'deletedAt' | 'email' | 'id' | 'isBlocked' | 'locationId' | 'name' | 'phoneNumber' | 'stripePaymentMethodId' | 'user' | CustomerEntryDtoKeySpecifier)[];
export type CustomerEntryDtoFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	amountSpent?: FieldPolicy<any> | FieldReadFunction<any>,
	apartmentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	bmStripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	bmStripePaymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	bookings?: FieldPolicy<any> | FieldReadFunction<any>,
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isBlocked?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	stripePaymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerServicesKeySpecifier = ('category' | 'providers' | CustomerServicesKeySpecifier)[];
export type CustomerServicesFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	providers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerServicesProviderKeySpecifier = ('address' | 'email' | 'id' | 'name' | 'phoneNumber' | 'services' | CustomerServicesProviderKeySpecifier)[];
export type CustomerServicesProviderFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	services?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerServicesServiceKeySpecifier = ('color' | 'description' | 'duration' | 'id' | 'name' | 'nextAvailableDate' | CustomerServicesServiceKeySpecifier)[];
export type CustomerServicesServiceFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nextAvailableDate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerUserDtoKeySpecifier = ('address' | 'apartmentNumber' | 'coordinates' | 'createdAt' | 'email' | 'id' | 'name' | 'phoneNumber' | 'profilePicture' | CustomerUserDtoKeySpecifier)[];
export type CustomerUserDtoFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	apartmentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePicture?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteCustomerPaymentMethodDtoKeySpecifier = ('id' | DeleteCustomerPaymentMethodDtoKeySpecifier)[];
export type DeleteCustomerPaymentMethodDtoFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteFileDtoKeySpecifier = ('deletedFile' | DeleteFileDtoKeySpecifier)[];
export type DeleteFileDtoFieldPolicy = {
	deletedFile?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeletePaymentMethodDtoKeySpecifier = ('id' | DeletePaymentMethodDtoKeySpecifier)[];
export type DeletePaymentMethodDtoFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmployeeKeySpecifier = ('id' | 'name' | 'profilePicture' | EmployeeKeySpecifier)[];
export type EmployeeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePicture?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExportAppointmentBase64KeySpecifier = ('base64' | ExportAppointmentBase64KeySpecifier)[];
export type ExportAppointmentBase64FieldPolicy = {
	base64?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GeographyCoordinatesKeySpecifier = ('coordinates' | 'type' | GeographyCoordinatesKeySpecifier)[];
export type GeographyCoordinatesFieldPolicy = {
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetAppointmentPaymentDetailsKeySpecifier = ('options' | 'serviceFee' | 'taxes' | 'travelFees' | GetAppointmentPaymentDetailsKeySpecifier)[];
export type GetAppointmentPaymentDetailsFieldPolicy = {
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceFee?: FieldPolicy<any> | FieldReadFunction<any>,
	taxes?: FieldPolicy<any> | FieldReadFunction<any>,
	travelFees?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetUpfrontAppointmentDetailsKeySpecifier = ('data' | 'errors' | GetUpfrontAppointmentDetailsKeySpecifier)[];
export type GetUpfrontAppointmentDetailsFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetUpfrontAppointmentDetailsDataKeySpecifier = ('details' | 'formsNames' | 'payPrice' | 'price' | GetUpfrontAppointmentDetailsDataKeySpecifier)[];
export type GetUpfrontAppointmentDetailsDataFieldPolicy = {
	details?: FieldPolicy<any> | FieldReadFunction<any>,
	formsNames?: FieldPolicy<any> | FieldReadFunction<any>,
	payPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetUpfrontAppointmentDetailsDataDetailsKeySpecifier = ('date' | 'employeeName' | 'locationName' | GetUpfrontAppointmentDetailsDataDetailsKeySpecifier)[];
export type GetUpfrontAppointmentDetailsDataDetailsFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	employeeName?: FieldPolicy<any> | FieldReadFunction<any>,
	locationName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetUpfrontAppointmentDetailsDataPayPriceKeySpecifier = ('deposit' | 'fees' | 'options' | 'serviceFee' | 'taxes' | 'total' | GetUpfrontAppointmentDetailsDataPayPriceKeySpecifier)[];
export type GetUpfrontAppointmentDetailsDataPayPriceFieldPolicy = {
	deposit?: FieldPolicy<any> | FieldReadFunction<any>,
	fees?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceFee?: FieldPolicy<any> | FieldReadFunction<any>,
	taxes?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetUpfrontAppointmentDetailsDataPriceKeySpecifier = ('deposit' | 'fees' | 'options' | 'service' | 'subtotal' | 'taxes' | 'total' | GetUpfrontAppointmentDetailsDataPriceKeySpecifier)[];
export type GetUpfrontAppointmentDetailsDataPriceFieldPolicy = {
	deposit?: FieldPolicy<any> | FieldReadFunction<any>,
	fees?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotal?: FieldPolicy<any> | FieldReadFunction<any>,
	taxes?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetUpfrontAppointmentDetailsDataPriceOptionsKeySpecifier = ('name' | 'price' | 'quantity' | GetUpfrontAppointmentDetailsDataPriceOptionsKeySpecifier)[];
export type GetUpfrontAppointmentDetailsDataPriceOptionsFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetUpfrontAppointmentDetailsDataPriceServiceKeySpecifier = ('duration' | 'name' | 'price' | GetUpfrontAppointmentDetailsDataPriceServiceKeySpecifier)[];
export type GetUpfrontAppointmentDetailsDataPriceServiceFieldPolicy = {
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetUpfrontAppointmentDetailsErrorsKeySpecifier = ('details' | 'forms' | 'payPrice' | 'price' | GetUpfrontAppointmentDetailsErrorsKeySpecifier)[];
export type GetUpfrontAppointmentDetailsErrorsFieldPolicy = {
	details?: FieldPolicy<any> | FieldReadFunction<any>,
	forms?: FieldPolicy<any> | FieldReadFunction<any>,
	payPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HaversineDtoKeySpecifier = ('distance' | 'inside' | HaversineDtoKeySpecifier)[];
export type HaversineDtoFieldPolicy = {
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	inside?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocationKeySpecifier = ('address' | 'buildingManager' | 'buildingManagerId' | 'buildingProviders' | 'coordinates' | 'createdAt' | 'deletedAt' | 'email' | 'id' | 'name' | 'partnershipDefaultStatus' | 'phoneNumber' | 'radius' | 'status' | 'transitionStatus' | 'updatedAt' | LocationKeySpecifier)[];
export type LocationFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingManager?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingManagerId?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	partnershipDefaultStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	radius?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	transitionStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocationBuildingManagerKeySpecifier = ('email' | 'id' | 'isEmailVerified' | 'isPhoneNumberVerified' | 'name' | 'phoneNumber' | 'profilePictureFileId' | LocationBuildingManagerKeySpecifier)[];
export type LocationBuildingManagerFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isEmailVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	isPhoneNumberVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePictureFileId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocationBuildingProviderKeySpecifier = ('id' | 'locationId' | 'partnershipSchedulingType' | 'providerId' | 'status' | LocationBuildingProviderKeySpecifier)[];
export type LocationBuildingProviderFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	partnershipSchedulingType?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocationDtoKeySpecifier = ('location' | LocationDtoKeySpecifier)[];
export type LocationDtoFieldPolicy = {
	location?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocationWithDistanceKeySpecifier = ('address' | 'coordinates' | 'distance' | 'id' | 'name' | 'radius' | 'type' | LocationWithDistanceKeySpecifier)[];
export type LocationWithDistanceFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	radius?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LogoutDtoKeySpecifier = ('deletedSessions' | LogoutDtoKeySpecifier)[];
export type LogoutDtoFieldPolicy = {
	deletedSessions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OnboardingCompletedDtoKeySpecifier = ('businessAcc' | 'companyAddress' | 'onboardingCompleted' | 'payoutsSchedule' | OnboardingCompletedDtoKeySpecifier)[];
export type OnboardingCompletedDtoFieldPolicy = {
	businessAcc?: FieldPolicy<any> | FieldReadFunction<any>,
	companyAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	onboardingCompleted?: FieldPolicy<any> | FieldReadFunction<any>,
	payoutsSchedule?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PartnershipDtoKeySpecifier = ('partnership' | PartnershipDtoKeySpecifier)[];
export type PartnershipDtoFieldPolicy = {
	partnership?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentKeySpecifier = ('currency' | 'products' | PaymentKeySpecifier)[];
export type PaymentFieldPolicy = {
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayoutDtoKeySpecifier = ('amountCaptured' | 'date' | 'fees' | 'id' | 'status' | PayoutDtoKeySpecifier)[];
export type PayoutDtoFieldPolicy = {
	amountCaptured?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	fees?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayoutsDtoKeySpecifier = ('data' | 'totalCount' | PayoutsDtoKeySpecifier)[];
export type PayoutsDtoFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayoutsScheduleDtoKeySpecifier = ('delayDays' | 'interval' | PayoutsScheduleDtoKeySpecifier)[];
export type PayoutsScheduleDtoFieldPolicy = {
	delayDays?: FieldPolicy<any> | FieldReadFunction<any>,
	interval?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProfilePictureKeySpecifier = ('id' | 'name' | 'uploadName' | ProfilePictureKeySpecifier)[];
export type ProfilePictureFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProfilePictureDtoKeySpecifier = ('id' | 'name' | ProfilePictureDtoKeySpecifier)[];
export type ProfilePictureDtoFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProviderKeySpecifier = ('address' | 'category' | 'email' | 'id' | 'name' | 'phoneNumber' | 'slug' | 'status' | 'stripeConnectAccId' | 'stripeCustomerId' | 'type' | 'visibility' | ProviderKeySpecifier)[];
export type ProviderFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeConnectAccId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProviderPaymentDtoKeySpecifier = ('amount' | 'currency' | 'date' | 'id' | 'status' | ProviderPaymentDtoKeySpecifier)[];
export type ProviderPaymentDtoFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProviderPaymentsDtoKeySpecifier = ('data' | 'totalCount' | ProviderPaymentsDtoKeySpecifier)[];
export type ProviderPaymentsDtoFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProviderVisibilityDtoKeySpecifier = ('status' | 'visibility' | ProviderVisibilityDtoKeySpecifier)[];
export type ProviderVisibilityDtoFieldPolicy = {
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProviderVisibilityStatusDtoKeySpecifier = ('hasActiveLocations' | 'hasActiveServices' | 'hasEmployeesWithSchedules' | 'hasGeneralSettings' | 'hasPaymentMethod' | 'hasPublicProfileSettings' | 'isApprovedByAdmin' | ProviderVisibilityStatusDtoKeySpecifier)[];
export type ProviderVisibilityStatusDtoFieldPolicy = {
	hasActiveLocations?: FieldPolicy<any> | FieldReadFunction<any>,
	hasActiveServices?: FieldPolicy<any> | FieldReadFunction<any>,
	hasEmployeesWithSchedules?: FieldPolicy<any> | FieldReadFunction<any>,
	hasGeneralSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPaymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPublicProfileSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	isApprovedByAdmin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServiceProviderDtoKeySpecifier = ('id' | 'name' | ServiceProviderDtoKeySpecifier)[];
export type ServiceProviderDtoFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SessionUserIdKeySpecifier = ('id' | SessionUserIdKeySpecifier)[];
export type SessionUserIdFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SetupCustomerIntentDtoKeySpecifier = ('clientSecret' | 'status' | SetupCustomerIntentDtoKeySpecifier)[];
export type SetupCustomerIntentDtoFieldPolicy = {
	clientSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SetupIntentDtoKeySpecifier = ('clientSecret' | 'status' | SetupIntentDtoKeySpecifier)[];
export type SetupIntentDtoFieldPolicy = {
	clientSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SumKeySpecifier = ('sum' | SumKeySpecifier)[];
export type SumFieldPolicy = {
	sum?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TimeSlotDtoKeySpecifier = ('date' | 'employeeId' | TimeSlotDtoKeySpecifier)[];
export type TimeSlotDtoFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	employeeId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadFileUrlDtoKeySpecifier = ('entityType' | 'id' | 'name' | 'signedUrl' | 'uploadName' | UploadFileUrlDtoKeySpecifier)[];
export type UploadFileUrlDtoFieldPolicy = {
	entityType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	signedUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserKeySpecifier = ('address' | 'apartmentNumber' | 'coordinates' | 'email' | 'id' | 'isEmailVerified' | 'isPhoneNumberVerified' | 'location' | 'name' | 'password' | 'phoneNumber' | 'profilePicture' | 'profilePictureFileId' | 'stripeCustomerId' | 'userRole' | UserKeySpecifier)[];
export type UserFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	apartmentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isEmailVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	isPhoneNumberVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	password?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePicture?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePictureFileId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	userRole?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserRolesEntityKeySpecifier = ('role' | UserRolesEntityKeySpecifier)[];
export type UserRolesEntityFieldPolicy = {
	role?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserSessionDtoKeySpecifier = ('accessToken' | 'refreshToken' | UserSessionDtoKeySpecifier)[];
export type UserSessionDtoFieldPolicy = {
	accessToken?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserWithoutPasswordKeySpecifier = ('address' | 'apartmentNumber' | 'coordinates' | 'email' | 'id' | 'isEmailVerified' | 'isPhoneNumberVerified' | 'location' | 'name' | 'phoneNumber' | 'profilePicture' | 'profilePictureFileId' | 'stripeCustomerId' | 'userRole' | UserWithoutPasswordKeySpecifier)[];
export type UserWithoutPasswordFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	apartmentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isEmailVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	isPhoneNumberVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePicture?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePictureFileId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	userRole?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ValidateServiceKeySpecifier = ('canSubmit' | 'hasEmployees' | 'hasPrice' | 'isOverviewValid' | 'paymentCheckoutValid' | ValidateServiceKeySpecifier)[];
export type ValidateServiceFieldPolicy = {
	canSubmit?: FieldPolicy<any> | FieldReadFunction<any>,
	hasEmployees?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	isOverviewValid?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentCheckoutValid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointmentPricingKeySpecifier = ('appointment' | 'appointmentId' | 'basePrice' | 'checkoutPayment' | 'currency' | 'fees' | 'id' | 'minimumDeposit' | 'paymentFormat' | 'taxRate' | 'taxes' | appointmentPricingKeySpecifier)[];
export type appointmentPricingFieldPolicy = {
	appointment?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentId?: FieldPolicy<any> | FieldReadFunction<any>,
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	fees?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>,
	taxes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointmentPricing_aggregateKeySpecifier = ('aggregate' | 'nodes' | appointmentPricing_aggregateKeySpecifier)[];
export type appointmentPricing_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointmentPricing_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | appointmentPricing_aggregate_fieldsKeySpecifier)[];
export type appointmentPricing_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointmentPricing_avg_fieldsKeySpecifier = ('basePrice' | 'minimumDeposit' | 'taxRate' | appointmentPricing_avg_fieldsKeySpecifier)[];
export type appointmentPricing_avg_fieldsFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointmentPricing_max_fieldsKeySpecifier = ('appointmentId' | 'basePrice' | 'id' | 'minimumDeposit' | 'paymentFormat' | 'taxRate' | appointmentPricing_max_fieldsKeySpecifier)[];
export type appointmentPricing_max_fieldsFieldPolicy = {
	appointmentId?: FieldPolicy<any> | FieldReadFunction<any>,
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointmentPricing_min_fieldsKeySpecifier = ('appointmentId' | 'basePrice' | 'id' | 'minimumDeposit' | 'paymentFormat' | 'taxRate' | appointmentPricing_min_fieldsKeySpecifier)[];
export type appointmentPricing_min_fieldsFieldPolicy = {
	appointmentId?: FieldPolicy<any> | FieldReadFunction<any>,
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointmentPricing_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | appointmentPricing_mutation_responseKeySpecifier)[];
export type appointmentPricing_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointmentPricing_stddev_fieldsKeySpecifier = ('basePrice' | 'minimumDeposit' | 'taxRate' | appointmentPricing_stddev_fieldsKeySpecifier)[];
export type appointmentPricing_stddev_fieldsFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointmentPricing_stddev_pop_fieldsKeySpecifier = ('basePrice' | 'minimumDeposit' | 'taxRate' | appointmentPricing_stddev_pop_fieldsKeySpecifier)[];
export type appointmentPricing_stddev_pop_fieldsFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointmentPricing_stddev_samp_fieldsKeySpecifier = ('basePrice' | 'minimumDeposit' | 'taxRate' | appointmentPricing_stddev_samp_fieldsKeySpecifier)[];
export type appointmentPricing_stddev_samp_fieldsFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointmentPricing_sum_fieldsKeySpecifier = ('basePrice' | 'minimumDeposit' | 'taxRate' | appointmentPricing_sum_fieldsKeySpecifier)[];
export type appointmentPricing_sum_fieldsFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointmentPricing_var_pop_fieldsKeySpecifier = ('basePrice' | 'minimumDeposit' | 'taxRate' | appointmentPricing_var_pop_fieldsKeySpecifier)[];
export type appointmentPricing_var_pop_fieldsFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointmentPricing_var_samp_fieldsKeySpecifier = ('basePrice' | 'minimumDeposit' | 'taxRate' | appointmentPricing_var_samp_fieldsKeySpecifier)[];
export type appointmentPricing_var_samp_fieldsFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointmentPricing_variance_fieldsKeySpecifier = ('basePrice' | 'minimumDeposit' | 'taxRate' | appointmentPricing_variance_fieldsKeySpecifier)[];
export type appointmentPricing_variance_fieldsFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointmentsKeySpecifier = ('abortedByUserId' | 'address' | 'apartmentNumber' | 'appointmentPricing' | 'coordinates' | 'createdAt' | 'createdByUserId' | 'customer' | 'customerId' | 'employeeId' | 'endDate' | 'eventId' | 'formAnswers' | 'formAnswers_aggregate' | 'id' | 'jobStatus' | 'jobStatusByJobstatus' | 'location' | 'locationId' | 'notes' | 'paymentStatus' | 'paymentStatusByPaymentstatus' | 'payments' | 'payments_aggregate' | 'providerMonthlyPaymentId' | 'refunds' | 'refunds_aggregate' | 'service' | 'serviceId' | 'serviceOptionAnswers' | 'serviceOptionAnswers_aggregate' | 'startDate' | 'updatedAt' | 'updatedByUserId' | 'userByAbortedId' | 'userByEmployeeid' | appointmentsKeySpecifier)[];
export type appointmentsFieldPolicy = {
	abortedByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	apartmentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentPricing?: FieldPolicy<any> | FieldReadFunction<any>,
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	customer?: FieldPolicy<any> | FieldReadFunction<any>,
	customerId?: FieldPolicy<any> | FieldReadFunction<any>,
	employeeId?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	formAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	formAnswers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	jobStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	jobStatusByJobstatus?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatusByPaymentstatus?: FieldPolicy<any> | FieldReadFunction<any>,
	payments?: FieldPolicy<any> | FieldReadFunction<any>,
	payments_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providerMonthlyPaymentId?: FieldPolicy<any> | FieldReadFunction<any>,
	refunds?: FieldPolicy<any> | FieldReadFunction<any>,
	refunds_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionAnswers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	userByAbortedId?: FieldPolicy<any> | FieldReadFunction<any>,
	userByEmployeeid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointments_aggregateKeySpecifier = ('aggregate' | 'nodes' | appointments_aggregateKeySpecifier)[];
export type appointments_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointments_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | appointments_aggregate_fieldsKeySpecifier)[];
export type appointments_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointments_max_fieldsKeySpecifier = ('abortedByUserId' | 'address' | 'apartmentNumber' | 'createdAt' | 'createdByUserId' | 'customerId' | 'employeeId' | 'endDate' | 'eventId' | 'id' | 'locationId' | 'notes' | 'providerMonthlyPaymentId' | 'serviceId' | 'startDate' | 'updatedAt' | 'updatedByUserId' | appointments_max_fieldsKeySpecifier)[];
export type appointments_max_fieldsFieldPolicy = {
	abortedByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	apartmentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	customerId?: FieldPolicy<any> | FieldReadFunction<any>,
	employeeId?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	providerMonthlyPaymentId?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedByUserId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointments_min_fieldsKeySpecifier = ('abortedByUserId' | 'address' | 'apartmentNumber' | 'createdAt' | 'createdByUserId' | 'customerId' | 'employeeId' | 'endDate' | 'eventId' | 'id' | 'locationId' | 'notes' | 'providerMonthlyPaymentId' | 'serviceId' | 'startDate' | 'updatedAt' | 'updatedByUserId' | appointments_min_fieldsKeySpecifier)[];
export type appointments_min_fieldsFieldPolicy = {
	abortedByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	apartmentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	customerId?: FieldPolicy<any> | FieldReadFunction<any>,
	employeeId?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	providerMonthlyPaymentId?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedByUserId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type appointments_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | appointments_mutation_responseKeySpecifier)[];
export type appointments_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bookingStatusKeySpecifier = ('value' | bookingStatusKeySpecifier)[];
export type bookingStatusFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bookingStatus_aggregateKeySpecifier = ('aggregate' | 'nodes' | bookingStatus_aggregateKeySpecifier)[];
export type bookingStatus_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bookingStatus_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | bookingStatus_aggregate_fieldsKeySpecifier)[];
export type bookingStatus_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bookingStatus_max_fieldsKeySpecifier = ('value' | bookingStatus_max_fieldsKeySpecifier)[];
export type bookingStatus_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bookingStatus_min_fieldsKeySpecifier = ('value' | bookingStatus_min_fieldsKeySpecifier)[];
export type bookingStatus_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bookingStatus_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | bookingStatus_mutation_responseKeySpecifier)[];
export type bookingStatus_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buildingProvidersKeySpecifier = ('createdAt' | 'deletedAt' | 'id' | 'location' | 'locationId' | 'partnershipSchedulingType' | 'provider' | 'providerId' | 'scheduleLocation' | 'scheduleLocationId' | 'status' | 'updatedAt' | buildingProvidersKeySpecifier)[];
export type buildingProvidersFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	partnershipSchedulingType?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduleLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduleLocationId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buildingProviders_aggregateKeySpecifier = ('aggregate' | 'nodes' | buildingProviders_aggregateKeySpecifier)[];
export type buildingProviders_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buildingProviders_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | buildingProviders_aggregate_fieldsKeySpecifier)[];
export type buildingProviders_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buildingProviders_max_fieldsKeySpecifier = ('createdAt' | 'deletedAt' | 'id' | 'locationId' | 'providerId' | 'scheduleLocationId' | 'updatedAt' | buildingProviders_max_fieldsKeySpecifier)[];
export type buildingProviders_max_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduleLocationId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buildingProviders_min_fieldsKeySpecifier = ('createdAt' | 'deletedAt' | 'id' | 'locationId' | 'providerId' | 'scheduleLocationId' | 'updatedAt' | buildingProviders_min_fieldsKeySpecifier)[];
export type buildingProviders_min_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduleLocationId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buildingProviders_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | buildingProviders_mutation_responseKeySpecifier)[];
export type buildingProviders_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buildingTypeKeySpecifier = ('value' | buildingTypeKeySpecifier)[];
export type buildingTypeFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buildingType_aggregateKeySpecifier = ('aggregate' | 'nodes' | buildingType_aggregateKeySpecifier)[];
export type buildingType_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buildingType_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | buildingType_aggregate_fieldsKeySpecifier)[];
export type buildingType_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buildingType_max_fieldsKeySpecifier = ('value' | buildingType_max_fieldsKeySpecifier)[];
export type buildingType_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buildingType_min_fieldsKeySpecifier = ('value' | buildingType_min_fieldsKeySpecifier)[];
export type buildingType_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buildingType_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | buildingType_mutation_responseKeySpecifier)[];
export type buildingType_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type cardKeySpecifier = ('brand' | 'expMonth' | 'expYear' | 'id' | 'last4' | 'name' | cardKeySpecifier)[];
export type cardFieldPolicy = {
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	expMonth?: FieldPolicy<any> | FieldReadFunction<any>,
	expYear?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last4?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type checkoutSessionsKeySpecifier = ('createdAt' | 'expiresAt' | 'id' | 'revokedAt' | 'token' | 'updatedAt' | checkoutSessionsKeySpecifier)[];
export type checkoutSessionsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	revokedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type checkoutSessions_aggregateKeySpecifier = ('aggregate' | 'nodes' | checkoutSessions_aggregateKeySpecifier)[];
export type checkoutSessions_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type checkoutSessions_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | checkoutSessions_aggregate_fieldsKeySpecifier)[];
export type checkoutSessions_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type checkoutSessions_max_fieldsKeySpecifier = ('expiresAt' | 'id' | 'revokedAt' | 'token' | 'updatedAt' | checkoutSessions_max_fieldsKeySpecifier)[];
export type checkoutSessions_max_fieldsFieldPolicy = {
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	revokedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type checkoutSessions_min_fieldsKeySpecifier = ('expiresAt' | 'id' | 'revokedAt' | 'token' | 'updatedAt' | checkoutSessions_min_fieldsKeySpecifier)[];
export type checkoutSessions_min_fieldsFieldPolicy = {
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	revokedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type checkoutSessions_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | checkoutSessions_mutation_responseKeySpecifier)[];
export type checkoutSessions_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type currenciesKeySpecifier = ('payments' | 'payments_aggregate' | 'servicePricings' | 'servicePricings_aggregate' | 'value' | currenciesKeySpecifier)[];
export type currenciesFieldPolicy = {
	payments?: FieldPolicy<any> | FieldReadFunction<any>,
	payments_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePricings?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePricings_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type currencies_aggregateKeySpecifier = ('aggregate' | 'nodes' | currencies_aggregateKeySpecifier)[];
export type currencies_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type currencies_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | currencies_aggregate_fieldsKeySpecifier)[];
export type currencies_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type currencies_max_fieldsKeySpecifier = ('value' | currencies_max_fieldsKeySpecifier)[];
export type currencies_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type currencies_min_fieldsKeySpecifier = ('value' | currencies_min_fieldsKeySpecifier)[];
export type currencies_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type currencies_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | currencies_mutation_responseKeySpecifier)[];
export type currencies_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customerAmountSpentKeySpecifier = ('amount' | 'customer' | 'customerId' | customerAmountSpentKeySpecifier)[];
export type customerAmountSpentFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	customer?: FieldPolicy<any> | FieldReadFunction<any>,
	customerId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customerAmountSpent_aggregateKeySpecifier = ('aggregate' | 'nodes' | customerAmountSpent_aggregateKeySpecifier)[];
export type customerAmountSpent_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customerAmountSpent_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | customerAmountSpent_aggregate_fieldsKeySpecifier)[];
export type customerAmountSpent_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customerAmountSpent_avg_fieldsKeySpecifier = ('amount' | customerAmountSpent_avg_fieldsKeySpecifier)[];
export type customerAmountSpent_avg_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customerAmountSpent_max_fieldsKeySpecifier = ('amount' | 'customerId' | customerAmountSpent_max_fieldsKeySpecifier)[];
export type customerAmountSpent_max_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	customerId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customerAmountSpent_min_fieldsKeySpecifier = ('amount' | 'customerId' | customerAmountSpent_min_fieldsKeySpecifier)[];
export type customerAmountSpent_min_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	customerId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customerAmountSpent_stddev_fieldsKeySpecifier = ('amount' | customerAmountSpent_stddev_fieldsKeySpecifier)[];
export type customerAmountSpent_stddev_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customerAmountSpent_stddev_pop_fieldsKeySpecifier = ('amount' | customerAmountSpent_stddev_pop_fieldsKeySpecifier)[];
export type customerAmountSpent_stddev_pop_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customerAmountSpent_stddev_samp_fieldsKeySpecifier = ('amount' | customerAmountSpent_stddev_samp_fieldsKeySpecifier)[];
export type customerAmountSpent_stddev_samp_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customerAmountSpent_sum_fieldsKeySpecifier = ('amount' | customerAmountSpent_sum_fieldsKeySpecifier)[];
export type customerAmountSpent_sum_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customerAmountSpent_var_pop_fieldsKeySpecifier = ('amount' | customerAmountSpent_var_pop_fieldsKeySpecifier)[];
export type customerAmountSpent_var_pop_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customerAmountSpent_var_samp_fieldsKeySpecifier = ('amount' | customerAmountSpent_var_samp_fieldsKeySpecifier)[];
export type customerAmountSpent_var_samp_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customerAmountSpent_variance_fieldsKeySpecifier = ('amount' | customerAmountSpent_variance_fieldsKeySpecifier)[];
export type customerAmountSpent_variance_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customersKeySpecifier = ('address' | 'amountSpent' | 'apartmentNumber' | 'appointments' | 'appointments_aggregate' | 'bmStripeCustomerId' | 'bmStripePaymentMethodId' | 'checkoutSessionId' | 'coordinates' | 'createdAt' | 'deletedAt' | 'email' | 'id' | 'isBlocked' | 'location' | 'locationId' | 'name' | 'phoneNumber' | 'provider' | 'providerId' | 'stripeClientSecret' | 'stripeCustomerId' | 'stripePaymentMethodId' | 'updatedAt' | 'user' | 'userId' | customersKeySpecifier)[];
export type customersFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	amountSpent?: FieldPolicy<any> | FieldReadFunction<any>,
	apartmentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	appointments?: FieldPolicy<any> | FieldReadFunction<any>,
	appointments_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bmStripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	bmStripePaymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutSessionId?: FieldPolicy<any> | FieldReadFunction<any>,
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isBlocked?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeClientSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripePaymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customers_aggregateKeySpecifier = ('aggregate' | 'nodes' | customers_aggregateKeySpecifier)[];
export type customers_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customers_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | customers_aggregate_fieldsKeySpecifier)[];
export type customers_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customers_max_fieldsKeySpecifier = ('address' | 'apartmentNumber' | 'bmStripeCustomerId' | 'bmStripePaymentMethodId' | 'checkoutSessionId' | 'createdAt' | 'deletedAt' | 'email' | 'id' | 'locationId' | 'name' | 'phoneNumber' | 'providerId' | 'stripeClientSecret' | 'stripeCustomerId' | 'stripePaymentMethodId' | 'updatedAt' | 'userId' | customers_max_fieldsKeySpecifier)[];
export type customers_max_fieldsFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	apartmentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	bmStripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	bmStripePaymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutSessionId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeClientSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripePaymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customers_min_fieldsKeySpecifier = ('address' | 'apartmentNumber' | 'bmStripeCustomerId' | 'bmStripePaymentMethodId' | 'checkoutSessionId' | 'createdAt' | 'deletedAt' | 'email' | 'id' | 'locationId' | 'name' | 'phoneNumber' | 'providerId' | 'stripeClientSecret' | 'stripeCustomerId' | 'stripePaymentMethodId' | 'updatedAt' | 'userId' | customers_min_fieldsKeySpecifier)[];
export type customers_min_fieldsFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	apartmentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	bmStripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	bmStripePaymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutSessionId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeClientSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripePaymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customers_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | customers_mutation_responseKeySpecifier)[];
export type customers_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type entityTypeKeySpecifier = ('value' | entityTypeKeySpecifier)[];
export type entityTypeFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type entityType_aggregateKeySpecifier = ('aggregate' | 'nodes' | entityType_aggregateKeySpecifier)[];
export type entityType_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type entityType_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | entityType_aggregate_fieldsKeySpecifier)[];
export type entityType_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type entityType_max_fieldsKeySpecifier = ('value' | entityType_max_fieldsKeySpecifier)[];
export type entityType_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type entityType_min_fieldsKeySpecifier = ('value' | entityType_min_fieldsKeySpecifier)[];
export type entityType_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type entityType_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | entityType_mutation_responseKeySpecifier)[];
export type entityType_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type filesKeySpecifier = ('assignedId' | 'checkoutSessionId' | 'createdAt' | 'deletedAt' | 'entityType' | 'formAnswer' | 'id' | 'name' | 'private' | 'provider' | 'providerId' | 'updatedAt' | 'uploadName' | 'uploadedByUserId' | 'user' | 'userPicture' | filesKeySpecifier)[];
export type filesFieldPolicy = {
	assignedId?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutSessionId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	entityType?: FieldPolicy<any> | FieldReadFunction<any>,
	formAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	private?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadName?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userPicture?: FieldPolicy<any> | FieldReadFunction<any>
};
export type files_aggregateKeySpecifier = ('aggregate' | 'nodes' | files_aggregateKeySpecifier)[];
export type files_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type files_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | files_aggregate_fieldsKeySpecifier)[];
export type files_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type files_max_fieldsKeySpecifier = ('assignedId' | 'checkoutSessionId' | 'createdAt' | 'deletedAt' | 'id' | 'name' | 'providerId' | 'updatedAt' | 'uploadName' | 'uploadedByUserId' | files_max_fieldsKeySpecifier)[];
export type files_max_fieldsFieldPolicy = {
	assignedId?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutSessionId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadName?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedByUserId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type files_min_fieldsKeySpecifier = ('assignedId' | 'checkoutSessionId' | 'createdAt' | 'deletedAt' | 'id' | 'name' | 'providerId' | 'updatedAt' | 'uploadName' | 'uploadedByUserId' | files_min_fieldsKeySpecifier)[];
export type files_min_fieldsFieldPolicy = {
	assignedId?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutSessionId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadName?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedByUserId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type files_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | files_mutation_responseKeySpecifier)[];
export type files_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formKeySpecifier = ('createdAt' | 'deletedAt' | 'formAnswers' | 'formAnswers_aggregate' | 'formQuestions' | 'formQuestions_aggregate' | 'id' | 'name' | 'provider' | 'providerId' | 'servicesForms' | 'servicesForms_aggregate' | 'updatedAt' | formKeySpecifier)[];
export type formFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	formAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	formAnswers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesForms?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesForms_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formAnswersKeySpecifier = ('answer' | 'appointment' | 'appointmentId' | 'file' | 'fileId' | 'form' | 'formId' | 'formQuestion' | 'formQuestionId' | 'id' | 'option' | 'optionId' | formAnswersKeySpecifier)[];
export type formAnswersFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	appointment?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentId?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	form?: FieldPolicy<any> | FieldReadFunction<any>,
	formId?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestion?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	option?: FieldPolicy<any> | FieldReadFunction<any>,
	optionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formAnswers_aggregateKeySpecifier = ('aggregate' | 'nodes' | formAnswers_aggregateKeySpecifier)[];
export type formAnswers_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formAnswers_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | formAnswers_aggregate_fieldsKeySpecifier)[];
export type formAnswers_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formAnswers_max_fieldsKeySpecifier = ('answer' | 'appointmentId' | 'fileId' | 'formId' | 'formQuestionId' | 'id' | 'optionId' | formAnswers_max_fieldsKeySpecifier)[];
export type formAnswers_max_fieldsFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentId?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	formId?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	optionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formAnswers_min_fieldsKeySpecifier = ('answer' | 'appointmentId' | 'fileId' | 'formId' | 'formQuestionId' | 'id' | 'optionId' | formAnswers_min_fieldsKeySpecifier)[];
export type formAnswers_min_fieldsFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentId?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	formId?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	optionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formAnswers_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | formAnswers_mutation_responseKeySpecifier)[];
export type formAnswers_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestionOptionsKeySpecifier = ('formQuestion' | 'formQuestionId' | 'id' | 'value' | formQuestionOptionsKeySpecifier)[];
export type formQuestionOptionsFieldPolicy = {
	formQuestion?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestionOptions_aggregateKeySpecifier = ('aggregate' | 'nodes' | formQuestionOptions_aggregateKeySpecifier)[];
export type formQuestionOptions_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestionOptions_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | formQuestionOptions_aggregate_fieldsKeySpecifier)[];
export type formQuestionOptions_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestionOptions_max_fieldsKeySpecifier = ('formQuestionId' | 'id' | 'value' | formQuestionOptions_max_fieldsKeySpecifier)[];
export type formQuestionOptions_max_fieldsFieldPolicy = {
	formQuestionId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestionOptions_min_fieldsKeySpecifier = ('formQuestionId' | 'id' | 'value' | formQuestionOptions_min_fieldsKeySpecifier)[];
export type formQuestionOptions_min_fieldsFieldPolicy = {
	formQuestionId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestionOptions_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | formQuestionOptions_mutation_responseKeySpecifier)[];
export type formQuestionOptions_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestionTypeKeySpecifier = ('formQuestions' | 'formQuestions_aggregate' | 'value' | formQuestionTypeKeySpecifier)[];
export type formQuestionTypeFieldPolicy = {
	formQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestionType_aggregateKeySpecifier = ('aggregate' | 'nodes' | formQuestionType_aggregateKeySpecifier)[];
export type formQuestionType_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestionType_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | formQuestionType_aggregate_fieldsKeySpecifier)[];
export type formQuestionType_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestionType_max_fieldsKeySpecifier = ('value' | formQuestionType_max_fieldsKeySpecifier)[];
export type formQuestionType_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestionType_min_fieldsKeySpecifier = ('value' | formQuestionType_min_fieldsKeySpecifier)[];
export type formQuestionType_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestionType_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | formQuestionType_mutation_responseKeySpecifier)[];
export type formQuestionType_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestionsKeySpecifier = ('createdAt' | 'deletedAt' | 'description' | 'form' | 'formAnswers' | 'formAnswers_aggregate' | 'formId' | 'formQuestionOptions' | 'formQuestionOptions_aggregate' | 'formQuestionType' | 'id' | 'label' | 'mandatory' | 'name' | 'order' | 'questionType' | 'updatedAt' | formQuestionsKeySpecifier)[];
export type formQuestionsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	form?: FieldPolicy<any> | FieldReadFunction<any>,
	formAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	formAnswers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	formId?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionOptions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	mandatory?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	questionType?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestions_aggregateKeySpecifier = ('aggregate' | 'nodes' | formQuestions_aggregateKeySpecifier)[];
export type formQuestions_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestions_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | formQuestions_aggregate_fieldsKeySpecifier)[];
export type formQuestions_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestions_avg_fieldsKeySpecifier = ('order' | formQuestions_avg_fieldsKeySpecifier)[];
export type formQuestions_avg_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestions_max_fieldsKeySpecifier = ('createdAt' | 'deletedAt' | 'description' | 'formId' | 'id' | 'label' | 'name' | 'order' | 'updatedAt' | formQuestions_max_fieldsKeySpecifier)[];
export type formQuestions_max_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	formId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestions_min_fieldsKeySpecifier = ('createdAt' | 'deletedAt' | 'description' | 'formId' | 'id' | 'label' | 'name' | 'order' | 'updatedAt' | formQuestions_min_fieldsKeySpecifier)[];
export type formQuestions_min_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	formId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestions_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | formQuestions_mutation_responseKeySpecifier)[];
export type formQuestions_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestions_stddev_fieldsKeySpecifier = ('order' | formQuestions_stddev_fieldsKeySpecifier)[];
export type formQuestions_stddev_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestions_stddev_pop_fieldsKeySpecifier = ('order' | formQuestions_stddev_pop_fieldsKeySpecifier)[];
export type formQuestions_stddev_pop_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestions_stddev_samp_fieldsKeySpecifier = ('order' | formQuestions_stddev_samp_fieldsKeySpecifier)[];
export type formQuestions_stddev_samp_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestions_sum_fieldsKeySpecifier = ('order' | formQuestions_sum_fieldsKeySpecifier)[];
export type formQuestions_sum_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestions_var_pop_fieldsKeySpecifier = ('order' | formQuestions_var_pop_fieldsKeySpecifier)[];
export type formQuestions_var_pop_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestions_var_samp_fieldsKeySpecifier = ('order' | formQuestions_var_samp_fieldsKeySpecifier)[];
export type formQuestions_var_samp_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type formQuestions_variance_fieldsKeySpecifier = ('order' | formQuestions_variance_fieldsKeySpecifier)[];
export type formQuestions_variance_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type form_aggregateKeySpecifier = ('aggregate' | 'nodes' | form_aggregateKeySpecifier)[];
export type form_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type form_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | form_aggregate_fieldsKeySpecifier)[];
export type form_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type form_max_fieldsKeySpecifier = ('createdAt' | 'deletedAt' | 'id' | 'name' | 'providerId' | 'updatedAt' | form_max_fieldsKeySpecifier)[];
export type form_max_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type form_min_fieldsKeySpecifier = ('createdAt' | 'deletedAt' | 'id' | 'name' | 'providerId' | 'updatedAt' | form_min_fieldsKeySpecifier)[];
export type form_min_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type form_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | form_mutation_responseKeySpecifier)[];
export type form_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type jobStatusKeySpecifier = ('appointments' | 'appointments_aggregate' | 'value' | jobStatusKeySpecifier)[];
export type jobStatusFieldPolicy = {
	appointments?: FieldPolicy<any> | FieldReadFunction<any>,
	appointments_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type jobStatus_aggregateKeySpecifier = ('aggregate' | 'nodes' | jobStatus_aggregateKeySpecifier)[];
export type jobStatus_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type jobStatus_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | jobStatus_aggregate_fieldsKeySpecifier)[];
export type jobStatus_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type jobStatus_max_fieldsKeySpecifier = ('value' | jobStatus_max_fieldsKeySpecifier)[];
export type jobStatus_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type jobStatus_min_fieldsKeySpecifier = ('value' | jobStatus_min_fieldsKeySpecifier)[];
export type jobStatus_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type jobStatus_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | jobStatus_mutation_responseKeySpecifier)[];
export type jobStatus_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type localeKeySpecifier = ('value' | localeKeySpecifier)[];
export type localeFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locale_aggregateKeySpecifier = ('aggregate' | 'nodes' | locale_aggregateKeySpecifier)[];
export type locale_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locale_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | locale_aggregate_fieldsKeySpecifier)[];
export type locale_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locale_max_fieldsKeySpecifier = ('value' | locale_max_fieldsKeySpecifier)[];
export type locale_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locale_min_fieldsKeySpecifier = ('value' | locale_min_fieldsKeySpecifier)[];
export type locale_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locale_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | locale_mutation_responseKeySpecifier)[];
export type locale_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locationStatusKeySpecifier = ('locations' | 'locations_aggregate' | 'value' | locationStatusKeySpecifier)[];
export type locationStatusFieldPolicy = {
	locations?: FieldPolicy<any> | FieldReadFunction<any>,
	locations_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locationStatus_aggregateKeySpecifier = ('aggregate' | 'nodes' | locationStatus_aggregateKeySpecifier)[];
export type locationStatus_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locationStatus_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | locationStatus_aggregate_fieldsKeySpecifier)[];
export type locationStatus_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locationStatus_max_fieldsKeySpecifier = ('value' | locationStatus_max_fieldsKeySpecifier)[];
export type locationStatus_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locationStatus_min_fieldsKeySpecifier = ('value' | locationStatus_min_fieldsKeySpecifier)[];
export type locationStatus_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locationStatus_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | locationStatus_mutation_responseKeySpecifier)[];
export type locationStatus_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locationTypeKeySpecifier = ('locations' | 'locations_aggregate' | 'value' | locationTypeKeySpecifier)[];
export type locationTypeFieldPolicy = {
	locations?: FieldPolicy<any> | FieldReadFunction<any>,
	locations_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locationType_aggregateKeySpecifier = ('aggregate' | 'nodes' | locationType_aggregateKeySpecifier)[];
export type locationType_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locationType_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | locationType_aggregate_fieldsKeySpecifier)[];
export type locationType_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locationType_max_fieldsKeySpecifier = ('value' | locationType_max_fieldsKeySpecifier)[];
export type locationType_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locationType_min_fieldsKeySpecifier = ('value' | locationType_min_fieldsKeySpecifier)[];
export type locationType_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locationType_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | locationType_mutation_responseKeySpecifier)[];
export type locationType_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locationsKeySpecifier = ('additionalCities' | 'address' | 'appointments' | 'appointments_aggregate' | 'buildingManager' | 'buildingManagerId' | 'buildingProviders' | 'buildingProviders_aggregate' | 'buildingType' | 'buildingTypeByBuildingtype' | 'coordinates' | 'createdAt' | 'deletedAt' | 'email' | 'excludedCities' | 'id' | 'locationStatus' | 'locationType' | 'name' | 'partnershipDefaultStatus' | 'phoneNumber' | 'provider' | 'providerId' | 'radius' | 'schedules' | 'schedules_aggregate' | 'status' | 'timeouts' | 'timeouts_aggregate' | 'transitionStatus' | 'type' | 'unavailableServiceLocations' | 'unavailableServiceLocations_aggregate' | 'updatedAt' | locationsKeySpecifier)[];
export type locationsFieldPolicy = {
	additionalCities?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	appointments?: FieldPolicy<any> | FieldReadFunction<any>,
	appointments_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingManager?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingManagerId?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingProviders_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingType?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingTypeByBuildingtype?: FieldPolicy<any> | FieldReadFunction<any>,
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	excludedCities?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	locationType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	partnershipDefaultStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	radius?: FieldPolicy<any> | FieldReadFunction<any>,
	schedules?: FieldPolicy<any> | FieldReadFunction<any>,
	schedules_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	timeouts?: FieldPolicy<any> | FieldReadFunction<any>,
	timeouts_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	transitionStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	unavailableServiceLocations?: FieldPolicy<any> | FieldReadFunction<any>,
	unavailableServiceLocations_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_aggregateKeySpecifier = ('aggregate' | 'nodes' | locations_aggregateKeySpecifier)[];
export type locations_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | locations_aggregate_fieldsKeySpecifier)[];
export type locations_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_avg_fieldsKeySpecifier = ('radius' | locations_avg_fieldsKeySpecifier)[];
export type locations_avg_fieldsFieldPolicy = {
	radius?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_max_fieldsKeySpecifier = ('additionalCities' | 'address' | 'buildingManagerId' | 'createdAt' | 'deletedAt' | 'email' | 'excludedCities' | 'id' | 'name' | 'phoneNumber' | 'providerId' | 'radius' | 'updatedAt' | locations_max_fieldsKeySpecifier)[];
export type locations_max_fieldsFieldPolicy = {
	additionalCities?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingManagerId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	excludedCities?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	radius?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_min_fieldsKeySpecifier = ('additionalCities' | 'address' | 'buildingManagerId' | 'createdAt' | 'deletedAt' | 'email' | 'excludedCities' | 'id' | 'name' | 'phoneNumber' | 'providerId' | 'radius' | 'updatedAt' | locations_min_fieldsKeySpecifier)[];
export type locations_min_fieldsFieldPolicy = {
	additionalCities?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingManagerId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	excludedCities?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	radius?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | locations_mutation_responseKeySpecifier)[];
export type locations_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_stddev_fieldsKeySpecifier = ('radius' | locations_stddev_fieldsKeySpecifier)[];
export type locations_stddev_fieldsFieldPolicy = {
	radius?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_stddev_pop_fieldsKeySpecifier = ('radius' | locations_stddev_pop_fieldsKeySpecifier)[];
export type locations_stddev_pop_fieldsFieldPolicy = {
	radius?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_stddev_samp_fieldsKeySpecifier = ('radius' | locations_stddev_samp_fieldsKeySpecifier)[];
export type locations_stddev_samp_fieldsFieldPolicy = {
	radius?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_sum_fieldsKeySpecifier = ('radius' | locations_sum_fieldsKeySpecifier)[];
export type locations_sum_fieldsFieldPolicy = {
	radius?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_var_pop_fieldsKeySpecifier = ('radius' | locations_var_pop_fieldsKeySpecifier)[];
export type locations_var_pop_fieldsFieldPolicy = {
	radius?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_var_samp_fieldsKeySpecifier = ('radius' | locations_var_samp_fieldsKeySpecifier)[];
export type locations_var_samp_fieldsFieldPolicy = {
	radius?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_variance_fieldsKeySpecifier = ('radius' | locations_variance_fieldsKeySpecifier)[];
export type locations_variance_fieldsFieldPolicy = {
	radius?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_with_distanceKeySpecifier = ('address' | 'coordinates' | 'distance' | 'id' | 'name' | 'radius' | 'schedules' | 'schedules_aggregate' | 'type' | locations_with_distanceKeySpecifier)[];
export type locations_with_distanceFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	radius?: FieldPolicy<any> | FieldReadFunction<any>,
	schedules?: FieldPolicy<any> | FieldReadFunction<any>,
	schedules_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_with_distance_aggregateKeySpecifier = ('aggregate' | 'nodes' | locations_with_distance_aggregateKeySpecifier)[];
export type locations_with_distance_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_with_distance_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | locations_with_distance_aggregate_fieldsKeySpecifier)[];
export type locations_with_distance_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_with_distance_avg_fieldsKeySpecifier = ('distance' | 'radius' | locations_with_distance_avg_fieldsKeySpecifier)[];
export type locations_with_distance_avg_fieldsFieldPolicy = {
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	radius?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_with_distance_max_fieldsKeySpecifier = ('address' | 'distance' | 'id' | 'name' | 'radius' | 'type' | locations_with_distance_max_fieldsKeySpecifier)[];
export type locations_with_distance_max_fieldsFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	radius?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_with_distance_min_fieldsKeySpecifier = ('address' | 'distance' | 'id' | 'name' | 'radius' | 'type' | locations_with_distance_min_fieldsKeySpecifier)[];
export type locations_with_distance_min_fieldsFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	radius?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_with_distance_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | locations_with_distance_mutation_responseKeySpecifier)[];
export type locations_with_distance_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_with_distance_stddev_fieldsKeySpecifier = ('distance' | 'radius' | locations_with_distance_stddev_fieldsKeySpecifier)[];
export type locations_with_distance_stddev_fieldsFieldPolicy = {
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	radius?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_with_distance_stddev_pop_fieldsKeySpecifier = ('distance' | 'radius' | locations_with_distance_stddev_pop_fieldsKeySpecifier)[];
export type locations_with_distance_stddev_pop_fieldsFieldPolicy = {
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	radius?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_with_distance_stddev_samp_fieldsKeySpecifier = ('distance' | 'radius' | locations_with_distance_stddev_samp_fieldsKeySpecifier)[];
export type locations_with_distance_stddev_samp_fieldsFieldPolicy = {
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	radius?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_with_distance_sum_fieldsKeySpecifier = ('distance' | 'radius' | locations_with_distance_sum_fieldsKeySpecifier)[];
export type locations_with_distance_sum_fieldsFieldPolicy = {
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	radius?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_with_distance_var_pop_fieldsKeySpecifier = ('distance' | 'radius' | locations_with_distance_var_pop_fieldsKeySpecifier)[];
export type locations_with_distance_var_pop_fieldsFieldPolicy = {
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	radius?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_with_distance_var_samp_fieldsKeySpecifier = ('distance' | 'radius' | locations_with_distance_var_samp_fieldsKeySpecifier)[];
export type locations_with_distance_var_samp_fieldsFieldPolicy = {
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	radius?: FieldPolicy<any> | FieldReadFunction<any>
};
export type locations_with_distance_variance_fieldsKeySpecifier = ('distance' | 'radius' | locations_with_distance_variance_fieldsKeySpecifier)[];
export type locations_with_distance_variance_fieldsFieldPolicy = {
	distance?: FieldPolicy<any> | FieldReadFunction<any>,
	radius?: FieldPolicy<any> | FieldReadFunction<any>
};
export type mutation_rootKeySpecifier = ('ApproveAppointment' | 'SPMarkAppointmentCompleted' | 'SPMarkAppointmentPartial' | 'SPMarkAppointmentScheduled' | 'SpRefundPayment' | 'SpUpdateApptPaymentStatus' | 'cancelCheckoutSession' | 'cancelRejectAppointment' | 'changePassword' | 'clearEmployeeCalendar' | 'createAppointmentAnonymous' | 'createAppointmentBM' | 'createAppointmentPaymentIntent' | 'createAppointmentPaymentIntentAnonymous' | 'createAppointmentPaymentIntentUser' | 'createAppointmentSP' | 'createAppointmentUser' | 'createBookedAppointmentPaymentIntent' | 'createConnectedAccount' | 'createCustomer' | 'createCustomerSetupIntent' | 'createEmployee' | 'createMonthlySpPayments' | 'createPayment' | 'createProviderSetupIntent' | 'createUserSetupIntent' | 'deleteCustomerPaymentMethod' | 'deleteFile' | 'deleteProviderPaymentMethod' | 'deleteUserPaymentMethod' | 'delete_appointmentPricing' | 'delete_appointmentPricing_by_pk' | 'delete_appointments' | 'delete_appointments_by_pk' | 'delete_bookingStatus' | 'delete_bookingStatus_by_pk' | 'delete_buildingProviders' | 'delete_buildingProviders_by_pk' | 'delete_buildingType' | 'delete_buildingType_by_pk' | 'delete_checkoutSessions' | 'delete_checkoutSessions_by_pk' | 'delete_currencies' | 'delete_currencies_by_pk' | 'delete_customers' | 'delete_customers_by_pk' | 'delete_entityType' | 'delete_entityType_by_pk' | 'delete_files' | 'delete_files_by_pk' | 'delete_form' | 'delete_formAnswers' | 'delete_formAnswers_by_pk' | 'delete_formQuestionOptions' | 'delete_formQuestionOptions_by_pk' | 'delete_formQuestionType' | 'delete_formQuestionType_by_pk' | 'delete_formQuestions' | 'delete_formQuestions_by_pk' | 'delete_form_by_pk' | 'delete_jobStatus' | 'delete_jobStatus_by_pk' | 'delete_locale' | 'delete_locale_by_pk' | 'delete_locationStatus' | 'delete_locationStatus_by_pk' | 'delete_locationType' | 'delete_locationType_by_pk' | 'delete_locations' | 'delete_locations_by_pk' | 'delete_locations_with_distance' | 'delete_notificationType' | 'delete_notificationType_by_pk' | 'delete_notifications' | 'delete_notifications_by_pk' | 'delete_partnershipSchedulingType' | 'delete_partnershipSchedulingType_by_pk' | 'delete_partnershipStatus' | 'delete_partnershipStatus_by_pk' | 'delete_paymentFormat' | 'delete_paymentFormat_by_pk' | 'delete_paymentStatus' | 'delete_paymentStatus_by_pk' | 'delete_payments' | 'delete_payments_by_pk' | 'delete_providerCategory' | 'delete_providerCategory_by_pk' | 'delete_providerMonthlyPayments' | 'delete_providerMonthlyPayments_by_pk' | 'delete_providerPictures' | 'delete_providerPictures_by_pk' | 'delete_providerRole' | 'delete_providerRole_by_pk' | 'delete_providerStatus' | 'delete_providerStatus_by_pk' | 'delete_providerType' | 'delete_providerType_by_pk' | 'delete_providerVisibility' | 'delete_providerVisibility_by_pk' | 'delete_providers' | 'delete_providers_by_pk' | 'delete_refunds' | 'delete_refunds_by_pk' | 'delete_relationshipStatus' | 'delete_relationshipStatus_by_pk' | 'delete_schedule' | 'delete_schedule_by_pk' | 'delete_serviceEmployees' | 'delete_serviceEmployees_by_pk' | 'delete_serviceFormStatus' | 'delete_serviceFormStatus_by_pk' | 'delete_serviceOptionAnswers' | 'delete_serviceOptionAnswers_by_pk' | 'delete_serviceOptionSection' | 'delete_serviceOptionSectionOptions' | 'delete_serviceOptionSectionOptions_by_pk' | 'delete_serviceOptionSection_by_pk' | 'delete_serviceOptions' | 'delete_serviceOptionsStatus' | 'delete_serviceOptionsStatus_by_pk' | 'delete_serviceOptions_by_pk' | 'delete_servicePictures' | 'delete_servicePictures_by_pk' | 'delete_servicePricings' | 'delete_servicePricings_by_pk' | 'delete_serviceSectionOptionQuantityType' | 'delete_serviceSectionOptionQuantityType_by_pk' | 'delete_serviceSectionOptionType' | 'delete_serviceSectionOptionType_by_pk' | 'delete_serviceStatus' | 'delete_serviceStatus_by_pk' | 'delete_services' | 'delete_servicesForms' | 'delete_servicesForms_by_pk' | 'delete_services_by_pk' | 'delete_sessions' | 'delete_sessions_by_pk' | 'delete_timeouts' | 'delete_timeouts_by_pk' | 'delete_transitionStatus' | 'delete_transitionStatus_by_pk' | 'delete_unavailableServiceLocations' | 'delete_unavailableServiceLocations_by_pk' | 'delete_userRole' | 'delete_userRole_by_pk' | 'delete_userRoles' | 'delete_userRoles_by_pk' | 'delete_users' | 'delete_users_by_pk' | 'exportAppointments' | 'forgotPassword' | 'getCheckoutSession' | 'handleGoogleOAuthCallback' | 'insert_appointmentPricing' | 'insert_appointmentPricing_one' | 'insert_appointments' | 'insert_appointments_one' | 'insert_bookingStatus' | 'insert_bookingStatus_one' | 'insert_buildingProviders' | 'insert_buildingProviders_one' | 'insert_buildingType' | 'insert_buildingType_one' | 'insert_checkoutSessions' | 'insert_checkoutSessions_one' | 'insert_currencies' | 'insert_currencies_one' | 'insert_customers' | 'insert_customers_one' | 'insert_entityType' | 'insert_entityType_one' | 'insert_files' | 'insert_files_one' | 'insert_form' | 'insert_formAnswers' | 'insert_formAnswers_one' | 'insert_formQuestionOptions' | 'insert_formQuestionOptions_one' | 'insert_formQuestionType' | 'insert_formQuestionType_one' | 'insert_formQuestions' | 'insert_formQuestions_one' | 'insert_form_one' | 'insert_jobStatus' | 'insert_jobStatus_one' | 'insert_locale' | 'insert_locale_one' | 'insert_locationStatus' | 'insert_locationStatus_one' | 'insert_locationType' | 'insert_locationType_one' | 'insert_locations' | 'insert_locations_one' | 'insert_locations_with_distance' | 'insert_locations_with_distance_one' | 'insert_notificationType' | 'insert_notificationType_one' | 'insert_notifications' | 'insert_notifications_one' | 'insert_partnershipSchedulingType' | 'insert_partnershipSchedulingType_one' | 'insert_partnershipStatus' | 'insert_partnershipStatus_one' | 'insert_paymentFormat' | 'insert_paymentFormat_one' | 'insert_paymentStatus' | 'insert_paymentStatus_one' | 'insert_payments' | 'insert_payments_one' | 'insert_providerCategory' | 'insert_providerCategory_one' | 'insert_providerMonthlyPayments' | 'insert_providerMonthlyPayments_one' | 'insert_providerPictures' | 'insert_providerPictures_one' | 'insert_providerRole' | 'insert_providerRole_one' | 'insert_providerStatus' | 'insert_providerStatus_one' | 'insert_providerType' | 'insert_providerType_one' | 'insert_providerVisibility' | 'insert_providerVisibility_one' | 'insert_providers' | 'insert_providers_one' | 'insert_refunds' | 'insert_refunds_one' | 'insert_relationshipStatus' | 'insert_relationshipStatus_one' | 'insert_schedule' | 'insert_schedule_one' | 'insert_serviceEmployees' | 'insert_serviceEmployees_one' | 'insert_serviceFormStatus' | 'insert_serviceFormStatus_one' | 'insert_serviceOptionAnswers' | 'insert_serviceOptionAnswers_one' | 'insert_serviceOptionSection' | 'insert_serviceOptionSectionOptions' | 'insert_serviceOptionSectionOptions_one' | 'insert_serviceOptionSection_one' | 'insert_serviceOptions' | 'insert_serviceOptionsStatus' | 'insert_serviceOptionsStatus_one' | 'insert_serviceOptions_one' | 'insert_servicePictures' | 'insert_servicePictures_one' | 'insert_servicePricings' | 'insert_servicePricings_one' | 'insert_serviceSectionOptionQuantityType' | 'insert_serviceSectionOptionQuantityType_one' | 'insert_serviceSectionOptionType' | 'insert_serviceSectionOptionType_one' | 'insert_serviceStatus' | 'insert_serviceStatus_one' | 'insert_services' | 'insert_servicesForms' | 'insert_servicesForms_one' | 'insert_services_one' | 'insert_sessions' | 'insert_sessions_one' | 'insert_timeouts' | 'insert_timeouts_one' | 'insert_transitionStatus' | 'insert_transitionStatus_one' | 'insert_unavailableServiceLocations' | 'insert_unavailableServiceLocations_one' | 'insert_userRole' | 'insert_userRole_one' | 'insert_userRoles' | 'insert_userRoles_one' | 'insert_users' | 'insert_users_one' | 'logout' | 'modifyAppointment' | 'payBookedAppointment' | 'refreshTokens' | 'register' | 'registerBuildingManager' | 'registerProvider' | 'requestForgotPassword' | 'requestLocationPartnership' | 'requestVerifyEmail' | 'requestVerifyPhoneNumber' | 'setEmployeeCalendar' | 'unlinkGoogleCalendar' | 'updateUserPhone' | 'update_appointmentPricing' | 'update_appointmentPricing_by_pk' | 'update_appointmentPricing_many' | 'update_appointments' | 'update_appointments_by_pk' | 'update_appointments_many' | 'update_bookingStatus' | 'update_bookingStatus_by_pk' | 'update_bookingStatus_many' | 'update_buildingProviders' | 'update_buildingProviders_by_pk' | 'update_buildingProviders_many' | 'update_buildingType' | 'update_buildingType_by_pk' | 'update_buildingType_many' | 'update_checkoutSessions' | 'update_checkoutSessions_by_pk' | 'update_checkoutSessions_many' | 'update_currencies' | 'update_currencies_by_pk' | 'update_currencies_many' | 'update_customers' | 'update_customers_by_pk' | 'update_customers_many' | 'update_entityType' | 'update_entityType_by_pk' | 'update_entityType_many' | 'update_files' | 'update_files_by_pk' | 'update_files_many' | 'update_form' | 'update_formAnswers' | 'update_formAnswers_by_pk' | 'update_formAnswers_many' | 'update_formQuestionOptions' | 'update_formQuestionOptions_by_pk' | 'update_formQuestionOptions_many' | 'update_formQuestionType' | 'update_formQuestionType_by_pk' | 'update_formQuestionType_many' | 'update_formQuestions' | 'update_formQuestions_by_pk' | 'update_formQuestions_many' | 'update_form_by_pk' | 'update_form_many' | 'update_jobStatus' | 'update_jobStatus_by_pk' | 'update_jobStatus_many' | 'update_locale' | 'update_locale_by_pk' | 'update_locale_many' | 'update_locationStatus' | 'update_locationStatus_by_pk' | 'update_locationStatus_many' | 'update_locationType' | 'update_locationType_by_pk' | 'update_locationType_many' | 'update_locations' | 'update_locations_by_pk' | 'update_locations_many' | 'update_locations_with_distance' | 'update_locations_with_distance_many' | 'update_notificationType' | 'update_notificationType_by_pk' | 'update_notificationType_many' | 'update_notifications' | 'update_notifications_by_pk' | 'update_notifications_many' | 'update_partnershipSchedulingType' | 'update_partnershipSchedulingType_by_pk' | 'update_partnershipSchedulingType_many' | 'update_partnershipStatus' | 'update_partnershipStatus_by_pk' | 'update_partnershipStatus_many' | 'update_paymentFormat' | 'update_paymentFormat_by_pk' | 'update_paymentFormat_many' | 'update_paymentStatus' | 'update_paymentStatus_by_pk' | 'update_paymentStatus_many' | 'update_payments' | 'update_payments_by_pk' | 'update_payments_many' | 'update_providerCategory' | 'update_providerCategory_by_pk' | 'update_providerCategory_many' | 'update_providerMonthlyPayments' | 'update_providerMonthlyPayments_by_pk' | 'update_providerMonthlyPayments_many' | 'update_providerPictures' | 'update_providerPictures_by_pk' | 'update_providerPictures_many' | 'update_providerRole' | 'update_providerRole_by_pk' | 'update_providerRole_many' | 'update_providerStatus' | 'update_providerStatus_by_pk' | 'update_providerStatus_many' | 'update_providerType' | 'update_providerType_by_pk' | 'update_providerType_many' | 'update_providerVisibility' | 'update_providerVisibility_by_pk' | 'update_providerVisibility_many' | 'update_providers' | 'update_providers_by_pk' | 'update_providers_many' | 'update_refunds' | 'update_refunds_by_pk' | 'update_refunds_many' | 'update_relationshipStatus' | 'update_relationshipStatus_by_pk' | 'update_relationshipStatus_many' | 'update_schedule' | 'update_schedule_by_pk' | 'update_schedule_many' | 'update_serviceEmployees' | 'update_serviceEmployees_by_pk' | 'update_serviceEmployees_many' | 'update_serviceFormStatus' | 'update_serviceFormStatus_by_pk' | 'update_serviceFormStatus_many' | 'update_serviceOptionAnswers' | 'update_serviceOptionAnswers_by_pk' | 'update_serviceOptionAnswers_many' | 'update_serviceOptionSection' | 'update_serviceOptionSectionOptions' | 'update_serviceOptionSectionOptions_by_pk' | 'update_serviceOptionSectionOptions_many' | 'update_serviceOptionSection_by_pk' | 'update_serviceOptionSection_many' | 'update_serviceOptions' | 'update_serviceOptionsStatus' | 'update_serviceOptionsStatus_by_pk' | 'update_serviceOptionsStatus_many' | 'update_serviceOptions_by_pk' | 'update_serviceOptions_many' | 'update_servicePictures' | 'update_servicePictures_by_pk' | 'update_servicePictures_many' | 'update_servicePricings' | 'update_servicePricings_by_pk' | 'update_servicePricings_many' | 'update_serviceSectionOptionQuantityType' | 'update_serviceSectionOptionQuantityType_by_pk' | 'update_serviceSectionOptionQuantityType_many' | 'update_serviceSectionOptionType' | 'update_serviceSectionOptionType_by_pk' | 'update_serviceSectionOptionType_many' | 'update_serviceStatus' | 'update_serviceStatus_by_pk' | 'update_serviceStatus_many' | 'update_services' | 'update_servicesForms' | 'update_servicesForms_by_pk' | 'update_servicesForms_many' | 'update_services_by_pk' | 'update_services_many' | 'update_sessions' | 'update_sessions_by_pk' | 'update_sessions_many' | 'update_timeouts' | 'update_timeouts_by_pk' | 'update_timeouts_many' | 'update_transitionStatus' | 'update_transitionStatus_by_pk' | 'update_transitionStatus_many' | 'update_unavailableServiceLocations' | 'update_unavailableServiceLocations_by_pk' | 'update_unavailableServiceLocations_many' | 'update_userRole' | 'update_userRole_by_pk' | 'update_userRole_many' | 'update_userRoles' | 'update_userRoles_by_pk' | 'update_userRoles_many' | 'update_users' | 'update_users_by_pk' | 'update_users_many' | 'verifyEmail' | 'verifyPhoneNumber' | mutation_rootKeySpecifier)[];
export type mutation_rootFieldPolicy = {
	ApproveAppointment?: FieldPolicy<any> | FieldReadFunction<any>,
	SPMarkAppointmentCompleted?: FieldPolicy<any> | FieldReadFunction<any>,
	SPMarkAppointmentPartial?: FieldPolicy<any> | FieldReadFunction<any>,
	SPMarkAppointmentScheduled?: FieldPolicy<any> | FieldReadFunction<any>,
	SpRefundPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	SpUpdateApptPaymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelCheckoutSession?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelRejectAppointment?: FieldPolicy<any> | FieldReadFunction<any>,
	changePassword?: FieldPolicy<any> | FieldReadFunction<any>,
	clearEmployeeCalendar?: FieldPolicy<any> | FieldReadFunction<any>,
	createAppointmentAnonymous?: FieldPolicy<any> | FieldReadFunction<any>,
	createAppointmentBM?: FieldPolicy<any> | FieldReadFunction<any>,
	createAppointmentPaymentIntent?: FieldPolicy<any> | FieldReadFunction<any>,
	createAppointmentPaymentIntentAnonymous?: FieldPolicy<any> | FieldReadFunction<any>,
	createAppointmentPaymentIntentUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createAppointmentSP?: FieldPolicy<any> | FieldReadFunction<any>,
	createAppointmentUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createBookedAppointmentPaymentIntent?: FieldPolicy<any> | FieldReadFunction<any>,
	createConnectedAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	createCustomer?: FieldPolicy<any> | FieldReadFunction<any>,
	createCustomerSetupIntent?: FieldPolicy<any> | FieldReadFunction<any>,
	createEmployee?: FieldPolicy<any> | FieldReadFunction<any>,
	createMonthlySpPayments?: FieldPolicy<any> | FieldReadFunction<any>,
	createPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	createProviderSetupIntent?: FieldPolicy<any> | FieldReadFunction<any>,
	createUserSetupIntent?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCustomerPaymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteFile?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteProviderPaymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUserPaymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_appointmentPricing?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_appointmentPricing_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_appointments?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_appointments_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_bookingStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_bookingStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_buildingProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_buildingProviders_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_buildingType?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_buildingType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_checkoutSessions?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_checkoutSessions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_currencies?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_currencies_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_customers?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_customers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_entityType?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_entityType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_files?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_files_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_form?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_formAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_formAnswers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_formQuestionOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_formQuestionOptions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_formQuestionType?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_formQuestionType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_formQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_formQuestions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_form_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_jobStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_jobStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_locale?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_locale_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_locationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_locationStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_locationType?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_locationType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_locations?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_locations_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_locations_with_distance?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_notificationType?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_notificationType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_notifications_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_partnershipSchedulingType?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_partnershipSchedulingType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_partnershipStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_partnershipStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_paymentFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_paymentFormat_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_paymentStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_payments?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_payments_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_providerCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_providerCategory_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_providerMonthlyPayments?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_providerMonthlyPayments_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_providerPictures?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_providerPictures_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_providerRole?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_providerRole_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_providerStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_providerStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_providerType?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_providerType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_providerVisibility?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_providerVisibility_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_providers?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_providers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_refunds?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_refunds_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_relationshipStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_relationshipStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_schedule?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_schedule_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceEmployees?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceEmployees_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceFormStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceFormStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceOptionAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceOptionAnswers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceOptionSection?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceOptionSectionOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceOptionSectionOptions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceOptionSection_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceOptionsStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceOptionsStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceOptions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_servicePictures?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_servicePictures_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_servicePricings?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_servicePricings_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceSectionOptionQuantityType?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceSectionOptionQuantityType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceSectionOptionType?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceSectionOptionType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_serviceStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_services?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_servicesForms?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_servicesForms_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_services_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_sessions?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_sessions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_timeouts?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_timeouts_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_transitionStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_transitionStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_unavailableServiceLocations?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_unavailableServiceLocations_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_userRole?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_userRole_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_userRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_userRoles_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_users?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_users_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	exportAppointments?: FieldPolicy<any> | FieldReadFunction<any>,
	forgotPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	getCheckoutSession?: FieldPolicy<any> | FieldReadFunction<any>,
	handleGoogleOAuthCallback?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_appointmentPricing?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_appointmentPricing_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_appointments?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_appointments_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_bookingStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_bookingStatus_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_buildingProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_buildingProviders_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_buildingType?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_buildingType_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_checkoutSessions?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_checkoutSessions_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_currencies?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_currencies_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_customers?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_customers_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_entityType?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_entityType_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_files?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_files_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_form?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_formAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_formAnswers_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_formQuestionOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_formQuestionOptions_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_formQuestionType?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_formQuestionType_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_formQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_formQuestions_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_form_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_jobStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_jobStatus_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_locale?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_locale_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_locationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_locationStatus_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_locationType?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_locationType_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_locations?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_locations_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_locations_with_distance?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_locations_with_distance_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_notificationType?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_notificationType_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_notifications_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_partnershipSchedulingType?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_partnershipSchedulingType_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_partnershipStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_partnershipStatus_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_paymentFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_paymentFormat_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_paymentStatus_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_payments?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_payments_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_providerCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_providerCategory_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_providerMonthlyPayments?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_providerMonthlyPayments_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_providerPictures?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_providerPictures_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_providerRole?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_providerRole_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_providerStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_providerStatus_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_providerType?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_providerType_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_providerVisibility?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_providerVisibility_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_providers?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_providers_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_refunds?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_refunds_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_relationshipStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_relationshipStatus_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_schedule?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_schedule_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceEmployees?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceEmployees_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceFormStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceFormStatus_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceOptionAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceOptionAnswers_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceOptionSection?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceOptionSectionOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceOptionSectionOptions_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceOptionSection_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceOptionsStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceOptionsStatus_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceOptions_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_servicePictures?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_servicePictures_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_servicePricings?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_servicePricings_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceSectionOptionQuantityType?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceSectionOptionQuantityType_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceSectionOptionType?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceSectionOptionType_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_serviceStatus_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_services?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_servicesForms?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_servicesForms_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_services_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_sessions?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_sessions_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_timeouts?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_timeouts_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_transitionStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_transitionStatus_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_unavailableServiceLocations?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_unavailableServiceLocations_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_userRole?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_userRole_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_userRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_userRoles_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_users?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_users_one?: FieldPolicy<any> | FieldReadFunction<any>,
	logout?: FieldPolicy<any> | FieldReadFunction<any>,
	modifyAppointment?: FieldPolicy<any> | FieldReadFunction<any>,
	payBookedAppointment?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshTokens?: FieldPolicy<any> | FieldReadFunction<any>,
	register?: FieldPolicy<any> | FieldReadFunction<any>,
	registerBuildingManager?: FieldPolicy<any> | FieldReadFunction<any>,
	registerProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	requestForgotPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	requestLocationPartnership?: FieldPolicy<any> | FieldReadFunction<any>,
	requestVerifyEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	requestVerifyPhoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	setEmployeeCalendar?: FieldPolicy<any> | FieldReadFunction<any>,
	unlinkGoogleCalendar?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUserPhone?: FieldPolicy<any> | FieldReadFunction<any>,
	update_appointmentPricing?: FieldPolicy<any> | FieldReadFunction<any>,
	update_appointmentPricing_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_appointmentPricing_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_appointments?: FieldPolicy<any> | FieldReadFunction<any>,
	update_appointments_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_appointments_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bookingStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bookingStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bookingStatus_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_buildingProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	update_buildingProviders_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_buildingProviders_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_buildingType?: FieldPolicy<any> | FieldReadFunction<any>,
	update_buildingType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_buildingType_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_checkoutSessions?: FieldPolicy<any> | FieldReadFunction<any>,
	update_checkoutSessions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_checkoutSessions_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_currencies?: FieldPolicy<any> | FieldReadFunction<any>,
	update_currencies_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_currencies_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_customers?: FieldPolicy<any> | FieldReadFunction<any>,
	update_customers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_customers_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_entityType?: FieldPolicy<any> | FieldReadFunction<any>,
	update_entityType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_entityType_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_files?: FieldPolicy<any> | FieldReadFunction<any>,
	update_files_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_files_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_form?: FieldPolicy<any> | FieldReadFunction<any>,
	update_formAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	update_formAnswers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_formAnswers_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_formQuestionOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	update_formQuestionOptions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_formQuestionOptions_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_formQuestionType?: FieldPolicy<any> | FieldReadFunction<any>,
	update_formQuestionType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_formQuestionType_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_formQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	update_formQuestions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_formQuestions_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_form_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_form_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_jobStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	update_jobStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_jobStatus_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_locale?: FieldPolicy<any> | FieldReadFunction<any>,
	update_locale_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_locale_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_locationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	update_locationStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_locationStatus_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_locationType?: FieldPolicy<any> | FieldReadFunction<any>,
	update_locationType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_locationType_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_locations?: FieldPolicy<any> | FieldReadFunction<any>,
	update_locations_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_locations_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_locations_with_distance?: FieldPolicy<any> | FieldReadFunction<any>,
	update_locations_with_distance_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_notificationType?: FieldPolicy<any> | FieldReadFunction<any>,
	update_notificationType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_notificationType_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	update_notifications_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_notifications_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_partnershipSchedulingType?: FieldPolicy<any> | FieldReadFunction<any>,
	update_partnershipSchedulingType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_partnershipSchedulingType_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_partnershipStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	update_partnershipStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_partnershipStatus_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_paymentFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	update_paymentFormat_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_paymentFormat_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	update_paymentStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_paymentStatus_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_payments?: FieldPolicy<any> | FieldReadFunction<any>,
	update_payments_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_payments_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerCategory_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerCategory_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerMonthlyPayments?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerMonthlyPayments_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerMonthlyPayments_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerPictures?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerPictures_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerPictures_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerRole?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerRole_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerRole_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerStatus_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerType?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerType_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerVisibility?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerVisibility_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providerVisibility_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providers?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_providers_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_refunds?: FieldPolicy<any> | FieldReadFunction<any>,
	update_refunds_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_refunds_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_relationshipStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	update_relationshipStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_relationshipStatus_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_schedule?: FieldPolicy<any> | FieldReadFunction<any>,
	update_schedule_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_schedule_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceEmployees?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceEmployees_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceEmployees_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceFormStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceFormStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceFormStatus_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceOptionAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceOptionAnswers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceOptionAnswers_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceOptionSection?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceOptionSectionOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceOptionSectionOptions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceOptionSectionOptions_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceOptionSection_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceOptionSection_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceOptionsStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceOptionsStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceOptionsStatus_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceOptions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceOptions_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_servicePictures?: FieldPolicy<any> | FieldReadFunction<any>,
	update_servicePictures_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_servicePictures_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_servicePricings?: FieldPolicy<any> | FieldReadFunction<any>,
	update_servicePricings_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_servicePricings_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceSectionOptionQuantityType?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceSectionOptionQuantityType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceSectionOptionQuantityType_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceSectionOptionType?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceSectionOptionType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceSectionOptionType_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_serviceStatus_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_services?: FieldPolicy<any> | FieldReadFunction<any>,
	update_servicesForms?: FieldPolicy<any> | FieldReadFunction<any>,
	update_servicesForms_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_servicesForms_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_services_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_services_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_sessions?: FieldPolicy<any> | FieldReadFunction<any>,
	update_sessions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_sessions_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_timeouts?: FieldPolicy<any> | FieldReadFunction<any>,
	update_timeouts_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_timeouts_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_transitionStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	update_transitionStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_transitionStatus_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_unavailableServiceLocations?: FieldPolicy<any> | FieldReadFunction<any>,
	update_unavailableServiceLocations_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_unavailableServiceLocations_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_userRole?: FieldPolicy<any> | FieldReadFunction<any>,
	update_userRole_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_userRole_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_userRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	update_userRoles_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_userRoles_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_users?: FieldPolicy<any> | FieldReadFunction<any>,
	update_users_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_users_many?: FieldPolicy<any> | FieldReadFunction<any>,
	verifyEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	verifyPhoneNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type nest_buildingProvidersKeySpecifier = ('id' | 'partnershipSchedulingType' | 'status' | nest_buildingProvidersKeySpecifier)[];
export type nest_buildingProvidersFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	partnershipSchedulingType?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type notificationTypeKeySpecifier = ('notifications' | 'notifications_aggregate' | 'value' | notificationTypeKeySpecifier)[];
export type notificationTypeFieldPolicy = {
	notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type notificationType_aggregateKeySpecifier = ('aggregate' | 'nodes' | notificationType_aggregateKeySpecifier)[];
export type notificationType_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type notificationType_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | notificationType_aggregate_fieldsKeySpecifier)[];
export type notificationType_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type notificationType_max_fieldsKeySpecifier = ('value' | notificationType_max_fieldsKeySpecifier)[];
export type notificationType_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type notificationType_min_fieldsKeySpecifier = ('value' | notificationType_min_fieldsKeySpecifier)[];
export type notificationType_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type notificationType_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | notificationType_mutation_responseKeySpecifier)[];
export type notificationType_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type notificationsKeySpecifier = ('createdAt' | 'entityId' | 'entityType' | 'fromUser' | 'fromUserId' | 'id' | 'notificationType' | 'readAt' | 'toUser' | 'toUserId' | 'type' | 'updatedAt' | 'viewedAt' | notificationsKeySpecifier)[];
export type notificationsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	entityId?: FieldPolicy<any> | FieldReadFunction<any>,
	entityType?: FieldPolicy<any> | FieldReadFunction<any>,
	fromUser?: FieldPolicy<any> | FieldReadFunction<any>,
	fromUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationType?: FieldPolicy<any> | FieldReadFunction<any>,
	readAt?: FieldPolicy<any> | FieldReadFunction<any>,
	toUser?: FieldPolicy<any> | FieldReadFunction<any>,
	toUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	viewedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type notifications_aggregateKeySpecifier = ('aggregate' | 'nodes' | notifications_aggregateKeySpecifier)[];
export type notifications_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type notifications_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | notifications_aggregate_fieldsKeySpecifier)[];
export type notifications_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type notifications_max_fieldsKeySpecifier = ('createdAt' | 'entityId' | 'fromUserId' | 'id' | 'readAt' | 'toUserId' | 'updatedAt' | 'viewedAt' | notifications_max_fieldsKeySpecifier)[];
export type notifications_max_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	entityId?: FieldPolicy<any> | FieldReadFunction<any>,
	fromUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	readAt?: FieldPolicy<any> | FieldReadFunction<any>,
	toUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	viewedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type notifications_min_fieldsKeySpecifier = ('createdAt' | 'entityId' | 'fromUserId' | 'id' | 'readAt' | 'toUserId' | 'updatedAt' | 'viewedAt' | notifications_min_fieldsKeySpecifier)[];
export type notifications_min_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	entityId?: FieldPolicy<any> | FieldReadFunction<any>,
	fromUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	readAt?: FieldPolicy<any> | FieldReadFunction<any>,
	toUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	viewedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type notifications_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | notifications_mutation_responseKeySpecifier)[];
export type notifications_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type partnershipSchedulingTypeKeySpecifier = ('value' | partnershipSchedulingTypeKeySpecifier)[];
export type partnershipSchedulingTypeFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type partnershipSchedulingType_aggregateKeySpecifier = ('aggregate' | 'nodes' | partnershipSchedulingType_aggregateKeySpecifier)[];
export type partnershipSchedulingType_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type partnershipSchedulingType_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | partnershipSchedulingType_aggregate_fieldsKeySpecifier)[];
export type partnershipSchedulingType_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type partnershipSchedulingType_max_fieldsKeySpecifier = ('value' | partnershipSchedulingType_max_fieldsKeySpecifier)[];
export type partnershipSchedulingType_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type partnershipSchedulingType_min_fieldsKeySpecifier = ('value' | partnershipSchedulingType_min_fieldsKeySpecifier)[];
export type partnershipSchedulingType_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type partnershipSchedulingType_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | partnershipSchedulingType_mutation_responseKeySpecifier)[];
export type partnershipSchedulingType_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type partnershipStatusKeySpecifier = ('value' | partnershipStatusKeySpecifier)[];
export type partnershipStatusFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type partnershipStatus_aggregateKeySpecifier = ('aggregate' | 'nodes' | partnershipStatus_aggregateKeySpecifier)[];
export type partnershipStatus_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type partnershipStatus_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | partnershipStatus_aggregate_fieldsKeySpecifier)[];
export type partnershipStatus_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type partnershipStatus_max_fieldsKeySpecifier = ('value' | partnershipStatus_max_fieldsKeySpecifier)[];
export type partnershipStatus_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type partnershipStatus_min_fieldsKeySpecifier = ('value' | partnershipStatus_min_fieldsKeySpecifier)[];
export type partnershipStatus_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type partnershipStatus_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | partnershipStatus_mutation_responseKeySpecifier)[];
export type partnershipStatus_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type paymentFormatKeySpecifier = ('servicePricings' | 'servicePricings_aggregate' | 'value' | paymentFormatKeySpecifier)[];
export type paymentFormatFieldPolicy = {
	servicePricings?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePricings_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type paymentFormat_aggregateKeySpecifier = ('aggregate' | 'nodes' | paymentFormat_aggregateKeySpecifier)[];
export type paymentFormat_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type paymentFormat_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | paymentFormat_aggregate_fieldsKeySpecifier)[];
export type paymentFormat_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type paymentFormat_max_fieldsKeySpecifier = ('value' | paymentFormat_max_fieldsKeySpecifier)[];
export type paymentFormat_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type paymentFormat_min_fieldsKeySpecifier = ('value' | paymentFormat_min_fieldsKeySpecifier)[];
export type paymentFormat_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type paymentFormat_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | paymentFormat_mutation_responseKeySpecifier)[];
export type paymentFormat_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type paymentStatusKeySpecifier = ('appointments' | 'appointments_aggregate' | 'payments' | 'payments_aggregate' | 'value' | paymentStatusKeySpecifier)[];
export type paymentStatusFieldPolicy = {
	appointments?: FieldPolicy<any> | FieldReadFunction<any>,
	appointments_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	payments?: FieldPolicy<any> | FieldReadFunction<any>,
	payments_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type paymentStatus_aggregateKeySpecifier = ('aggregate' | 'nodes' | paymentStatus_aggregateKeySpecifier)[];
export type paymentStatus_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type paymentStatus_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | paymentStatus_aggregate_fieldsKeySpecifier)[];
export type paymentStatus_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type paymentStatus_max_fieldsKeySpecifier = ('value' | paymentStatus_max_fieldsKeySpecifier)[];
export type paymentStatus_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type paymentStatus_min_fieldsKeySpecifier = ('value' | paymentStatus_min_fieldsKeySpecifier)[];
export type paymentStatus_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type paymentStatus_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | paymentStatus_mutation_responseKeySpecifier)[];
export type paymentStatus_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type paymentsKeySpecifier = ('amount' | 'appointment' | 'appointmentId' | 'createdAt' | 'currency' | 'currencyByCurrency' | 'deletedAt' | 'description' | 'id' | 'paymentStatus' | 'refund' | 'refund_aggregate' | 'sources' | 'status' | 'stripePaymentIntentId' | 'updatedAt' | paymentsKeySpecifier)[];
export type paymentsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	appointment?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyByCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	refund?: FieldPolicy<any> | FieldReadFunction<any>,
	refund_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	sources?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	stripePaymentIntentId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type payments_aggregateKeySpecifier = ('aggregate' | 'nodes' | payments_aggregateKeySpecifier)[];
export type payments_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type payments_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | payments_aggregate_fieldsKeySpecifier)[];
export type payments_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type payments_avg_fieldsKeySpecifier = ('amount' | payments_avg_fieldsKeySpecifier)[];
export type payments_avg_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type payments_max_fieldsKeySpecifier = ('amount' | 'appointmentId' | 'createdAt' | 'deletedAt' | 'description' | 'id' | 'stripePaymentIntentId' | 'updatedAt' | payments_max_fieldsKeySpecifier)[];
export type payments_max_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	stripePaymentIntentId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type payments_min_fieldsKeySpecifier = ('amount' | 'appointmentId' | 'createdAt' | 'deletedAt' | 'description' | 'id' | 'stripePaymentIntentId' | 'updatedAt' | payments_min_fieldsKeySpecifier)[];
export type payments_min_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	stripePaymentIntentId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type payments_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | payments_mutation_responseKeySpecifier)[];
export type payments_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type payments_stddev_fieldsKeySpecifier = ('amount' | payments_stddev_fieldsKeySpecifier)[];
export type payments_stddev_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type payments_stddev_pop_fieldsKeySpecifier = ('amount' | payments_stddev_pop_fieldsKeySpecifier)[];
export type payments_stddev_pop_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type payments_stddev_samp_fieldsKeySpecifier = ('amount' | payments_stddev_samp_fieldsKeySpecifier)[];
export type payments_stddev_samp_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type payments_sum_fieldsKeySpecifier = ('amount' | payments_sum_fieldsKeySpecifier)[];
export type payments_sum_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type payments_var_pop_fieldsKeySpecifier = ('amount' | payments_var_pop_fieldsKeySpecifier)[];
export type payments_var_pop_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type payments_var_samp_fieldsKeySpecifier = ('amount' | payments_var_samp_fieldsKeySpecifier)[];
export type payments_var_samp_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type payments_variance_fieldsKeySpecifier = ('amount' | payments_variance_fieldsKeySpecifier)[];
export type payments_variance_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerCategoryKeySpecifier = ('providers' | 'providers_aggregate' | 'value' | providerCategoryKeySpecifier)[];
export type providerCategoryFieldPolicy = {
	providers?: FieldPolicy<any> | FieldReadFunction<any>,
	providers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerCategory_aggregateKeySpecifier = ('aggregate' | 'nodes' | providerCategory_aggregateKeySpecifier)[];
export type providerCategory_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerCategory_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | providerCategory_aggregate_fieldsKeySpecifier)[];
export type providerCategory_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerCategory_max_fieldsKeySpecifier = ('value' | providerCategory_max_fieldsKeySpecifier)[];
export type providerCategory_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerCategory_min_fieldsKeySpecifier = ('value' | providerCategory_min_fieldsKeySpecifier)[];
export type providerCategory_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerCategory_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | providerCategory_mutation_responseKeySpecifier)[];
export type providerCategory_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerMonthlyPaymentsKeySpecifier = ('amount' | 'appointments' | 'appointments_aggregate' | 'createdAt' | 'deletedAt' | 'id' | 'month' | 'paymentId' | 'provider' | 'providerId' | 'status' | 'updatedAt' | providerMonthlyPaymentsKeySpecifier)[];
export type providerMonthlyPaymentsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	appointments?: FieldPolicy<any> | FieldReadFunction<any>,
	appointments_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	month?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentId?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerMonthlyPayments_aggregateKeySpecifier = ('aggregate' | 'nodes' | providerMonthlyPayments_aggregateKeySpecifier)[];
export type providerMonthlyPayments_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerMonthlyPayments_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | providerMonthlyPayments_aggregate_fieldsKeySpecifier)[];
export type providerMonthlyPayments_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerMonthlyPayments_avg_fieldsKeySpecifier = ('amount' | providerMonthlyPayments_avg_fieldsKeySpecifier)[];
export type providerMonthlyPayments_avg_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerMonthlyPayments_max_fieldsKeySpecifier = ('amount' | 'createdAt' | 'deletedAt' | 'id' | 'month' | 'paymentId' | 'providerId' | 'updatedAt' | providerMonthlyPayments_max_fieldsKeySpecifier)[];
export type providerMonthlyPayments_max_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	month?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentId?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerMonthlyPayments_min_fieldsKeySpecifier = ('amount' | 'createdAt' | 'deletedAt' | 'id' | 'month' | 'paymentId' | 'providerId' | 'updatedAt' | providerMonthlyPayments_min_fieldsKeySpecifier)[];
export type providerMonthlyPayments_min_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	month?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentId?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerMonthlyPayments_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | providerMonthlyPayments_mutation_responseKeySpecifier)[];
export type providerMonthlyPayments_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerMonthlyPayments_stddev_fieldsKeySpecifier = ('amount' | providerMonthlyPayments_stddev_fieldsKeySpecifier)[];
export type providerMonthlyPayments_stddev_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerMonthlyPayments_stddev_pop_fieldsKeySpecifier = ('amount' | providerMonthlyPayments_stddev_pop_fieldsKeySpecifier)[];
export type providerMonthlyPayments_stddev_pop_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerMonthlyPayments_stddev_samp_fieldsKeySpecifier = ('amount' | providerMonthlyPayments_stddev_samp_fieldsKeySpecifier)[];
export type providerMonthlyPayments_stddev_samp_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerMonthlyPayments_sum_fieldsKeySpecifier = ('amount' | providerMonthlyPayments_sum_fieldsKeySpecifier)[];
export type providerMonthlyPayments_sum_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerMonthlyPayments_var_pop_fieldsKeySpecifier = ('amount' | providerMonthlyPayments_var_pop_fieldsKeySpecifier)[];
export type providerMonthlyPayments_var_pop_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerMonthlyPayments_var_samp_fieldsKeySpecifier = ('amount' | providerMonthlyPayments_var_samp_fieldsKeySpecifier)[];
export type providerMonthlyPayments_var_samp_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerMonthlyPayments_variance_fieldsKeySpecifier = ('amount' | providerMonthlyPayments_variance_fieldsKeySpecifier)[];
export type providerMonthlyPayments_variance_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerPicturesKeySpecifier = ('createdAt' | 'file' | 'fileId' | 'id' | 'name' | 'provider' | 'providerId' | 'providers' | 'providersByProfilepic' | 'providersByProfilepic_aggregate' | 'providers_aggregate' | 'updatedAt' | providerPicturesKeySpecifier)[];
export type providerPicturesFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	providers?: FieldPolicy<any> | FieldReadFunction<any>,
	providersByProfilepic?: FieldPolicy<any> | FieldReadFunction<any>,
	providersByProfilepic_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerPictures_aggregateKeySpecifier = ('aggregate' | 'nodes' | providerPictures_aggregateKeySpecifier)[];
export type providerPictures_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerPictures_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | providerPictures_aggregate_fieldsKeySpecifier)[];
export type providerPictures_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerPictures_max_fieldsKeySpecifier = ('createdAt' | 'fileId' | 'id' | 'name' | 'providerId' | 'updatedAt' | providerPictures_max_fieldsKeySpecifier)[];
export type providerPictures_max_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerPictures_min_fieldsKeySpecifier = ('createdAt' | 'fileId' | 'id' | 'name' | 'providerId' | 'updatedAt' | providerPictures_min_fieldsKeySpecifier)[];
export type providerPictures_min_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerPictures_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | providerPictures_mutation_responseKeySpecifier)[];
export type providerPictures_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerRoleKeySpecifier = ('value' | providerRoleKeySpecifier)[];
export type providerRoleFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerRole_aggregateKeySpecifier = ('aggregate' | 'nodes' | providerRole_aggregateKeySpecifier)[];
export type providerRole_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerRole_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | providerRole_aggregate_fieldsKeySpecifier)[];
export type providerRole_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerRole_max_fieldsKeySpecifier = ('value' | providerRole_max_fieldsKeySpecifier)[];
export type providerRole_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerRole_min_fieldsKeySpecifier = ('value' | providerRole_min_fieldsKeySpecifier)[];
export type providerRole_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerRole_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | providerRole_mutation_responseKeySpecifier)[];
export type providerRole_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerStatusKeySpecifier = ('providers' | 'providers_aggregate' | 'value' | providerStatusKeySpecifier)[];
export type providerStatusFieldPolicy = {
	providers?: FieldPolicy<any> | FieldReadFunction<any>,
	providers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerStatus_aggregateKeySpecifier = ('aggregate' | 'nodes' | providerStatus_aggregateKeySpecifier)[];
export type providerStatus_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerStatus_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | providerStatus_aggregate_fieldsKeySpecifier)[];
export type providerStatus_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerStatus_max_fieldsKeySpecifier = ('value' | providerStatus_max_fieldsKeySpecifier)[];
export type providerStatus_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerStatus_min_fieldsKeySpecifier = ('value' | providerStatus_min_fieldsKeySpecifier)[];
export type providerStatus_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerStatus_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | providerStatus_mutation_responseKeySpecifier)[];
export type providerStatus_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerTypeKeySpecifier = ('providers' | 'providers_aggregate' | 'value' | providerTypeKeySpecifier)[];
export type providerTypeFieldPolicy = {
	providers?: FieldPolicy<any> | FieldReadFunction<any>,
	providers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerType_aggregateKeySpecifier = ('aggregate' | 'nodes' | providerType_aggregateKeySpecifier)[];
export type providerType_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerType_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | providerType_aggregate_fieldsKeySpecifier)[];
export type providerType_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerType_max_fieldsKeySpecifier = ('value' | providerType_max_fieldsKeySpecifier)[];
export type providerType_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerType_min_fieldsKeySpecifier = ('value' | providerType_min_fieldsKeySpecifier)[];
export type providerType_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerType_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | providerType_mutation_responseKeySpecifier)[];
export type providerType_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerVisibilityKeySpecifier = ('providers' | 'providers_aggregate' | 'value' | providerVisibilityKeySpecifier)[];
export type providerVisibilityFieldPolicy = {
	providers?: FieldPolicy<any> | FieldReadFunction<any>,
	providers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerVisibility_aggregateKeySpecifier = ('aggregate' | 'nodes' | providerVisibility_aggregateKeySpecifier)[];
export type providerVisibility_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerVisibility_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | providerVisibility_aggregate_fieldsKeySpecifier)[];
export type providerVisibility_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerVisibility_max_fieldsKeySpecifier = ('value' | providerVisibility_max_fieldsKeySpecifier)[];
export type providerVisibility_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerVisibility_min_fieldsKeySpecifier = ('value' | providerVisibility_min_fieldsKeySpecifier)[];
export type providerVisibility_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providerVisibility_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | providerVisibility_mutation_responseKeySpecifier)[];
export type providerVisibility_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providersKeySpecifier = ('address' | 'authTokens' | 'bookingCancelationWarningPeriod' | 'bookingDefaultStatus' | 'bookingStatus' | 'buildingProviders' | 'buildingProviders_aggregate' | 'category' | 'coverPic' | 'createdAt' | 'customers' | 'customers_aggregate' | 'deletedAt' | 'description' | 'email' | 'forms' | 'forms_aggregate' | 'id' | 'locations' | 'locations_aggregate' | 'name' | 'phoneNumber' | 'profilePic' | 'providerCategory' | 'providerPayments' | 'providerPayments_aggregate' | 'providerPictureByCoverPic' | 'providerPictureByProfilePic' | 'providerPictures' | 'providerPictures_aggregate' | 'providerStatus' | 'providerType' | 'providerVisibility' | 'services' | 'services_aggregate' | 'slug' | 'status' | 'stripeClientSecret' | 'stripeConnectAccId' | 'stripeCustomerId' | 'stripePaymentMethodId' | 'type' | 'updatedAt' | 'userRoles' | 'userRoles_aggregate' | 'visibility' | providersKeySpecifier)[];
export type providersFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	authTokens?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingCancelationWarningPeriod?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingDefaultStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingProviders_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	coverPic?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	customers?: FieldPolicy<any> | FieldReadFunction<any>,
	customers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	forms?: FieldPolicy<any> | FieldReadFunction<any>,
	forms_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locations?: FieldPolicy<any> | FieldReadFunction<any>,
	locations_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePic?: FieldPolicy<any> | FieldReadFunction<any>,
	providerCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	providerPayments?: FieldPolicy<any> | FieldReadFunction<any>,
	providerPayments_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providerPictureByCoverPic?: FieldPolicy<any> | FieldReadFunction<any>,
	providerPictureByProfilePic?: FieldPolicy<any> | FieldReadFunction<any>,
	providerPictures?: FieldPolicy<any> | FieldReadFunction<any>,
	providerPictures_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providerStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	providerType?: FieldPolicy<any> | FieldReadFunction<any>,
	providerVisibility?: FieldPolicy<any> | FieldReadFunction<any>,
	services?: FieldPolicy<any> | FieldReadFunction<any>,
	services_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeClientSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeConnectAccId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripePaymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	userRoles_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providers_aggregateKeySpecifier = ('aggregate' | 'nodes' | providers_aggregateKeySpecifier)[];
export type providers_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providers_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | providers_aggregate_fieldsKeySpecifier)[];
export type providers_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providers_avg_fieldsKeySpecifier = ('bookingCancelationWarningPeriod' | providers_avg_fieldsKeySpecifier)[];
export type providers_avg_fieldsFieldPolicy = {
	bookingCancelationWarningPeriod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providers_max_fieldsKeySpecifier = ('address' | 'bookingCancelationWarningPeriod' | 'coverPic' | 'createdAt' | 'deletedAt' | 'description' | 'email' | 'id' | 'name' | 'phoneNumber' | 'profilePic' | 'slug' | 'stripeClientSecret' | 'stripeConnectAccId' | 'stripeCustomerId' | 'stripePaymentMethodId' | 'updatedAt' | providers_max_fieldsKeySpecifier)[];
export type providers_max_fieldsFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingCancelationWarningPeriod?: FieldPolicy<any> | FieldReadFunction<any>,
	coverPic?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePic?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeClientSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeConnectAccId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripePaymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providers_min_fieldsKeySpecifier = ('address' | 'bookingCancelationWarningPeriod' | 'coverPic' | 'createdAt' | 'deletedAt' | 'description' | 'email' | 'id' | 'name' | 'phoneNumber' | 'profilePic' | 'slug' | 'stripeClientSecret' | 'stripeConnectAccId' | 'stripeCustomerId' | 'stripePaymentMethodId' | 'updatedAt' | providers_min_fieldsKeySpecifier)[];
export type providers_min_fieldsFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingCancelationWarningPeriod?: FieldPolicy<any> | FieldReadFunction<any>,
	coverPic?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePic?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeClientSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeConnectAccId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripePaymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providers_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | providers_mutation_responseKeySpecifier)[];
export type providers_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providers_stddev_fieldsKeySpecifier = ('bookingCancelationWarningPeriod' | providers_stddev_fieldsKeySpecifier)[];
export type providers_stddev_fieldsFieldPolicy = {
	bookingCancelationWarningPeriod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providers_stddev_pop_fieldsKeySpecifier = ('bookingCancelationWarningPeriod' | providers_stddev_pop_fieldsKeySpecifier)[];
export type providers_stddev_pop_fieldsFieldPolicy = {
	bookingCancelationWarningPeriod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providers_stddev_samp_fieldsKeySpecifier = ('bookingCancelationWarningPeriod' | providers_stddev_samp_fieldsKeySpecifier)[];
export type providers_stddev_samp_fieldsFieldPolicy = {
	bookingCancelationWarningPeriod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providers_sum_fieldsKeySpecifier = ('bookingCancelationWarningPeriod' | providers_sum_fieldsKeySpecifier)[];
export type providers_sum_fieldsFieldPolicy = {
	bookingCancelationWarningPeriod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providers_var_pop_fieldsKeySpecifier = ('bookingCancelationWarningPeriod' | providers_var_pop_fieldsKeySpecifier)[];
export type providers_var_pop_fieldsFieldPolicy = {
	bookingCancelationWarningPeriod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providers_var_samp_fieldsKeySpecifier = ('bookingCancelationWarningPeriod' | providers_var_samp_fieldsKeySpecifier)[];
export type providers_var_samp_fieldsFieldPolicy = {
	bookingCancelationWarningPeriod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type providers_variance_fieldsKeySpecifier = ('bookingCancelationWarningPeriod' | providers_variance_fieldsKeySpecifier)[];
export type providers_variance_fieldsFieldPolicy = {
	bookingCancelationWarningPeriod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type query_rootKeySpecifier = ('CustomerCard' | 'appointmentPricing' | 'appointmentPricing_aggregate' | 'appointmentPricing_by_pk' | 'appointments' | 'appointments_aggregate' | 'appointments_by_pk' | 'availableAppointmentDateTimeSlots' | 'bookingStatus' | 'bookingStatus_aggregate' | 'bookingStatus_by_pk' | 'buildingProviders' | 'buildingProviders_aggregate' | 'buildingProviders_by_pk' | 'buildingType' | 'buildingType_aggregate' | 'buildingType_by_pk' | 'canProviderReceivePayments' | 'checkoutSessions' | 'checkoutSessions_aggregate' | 'checkoutSessions_by_pk' | 'currencies' | 'currencies_aggregate' | 'currencies_by_pk' | 'customerAmountSpent' | 'customerAmountSpent_aggregate' | 'customers' | 'customers_aggregate' | 'customers_by_pk' | 'entityType' | 'entityType_aggregate' | 'entityType_by_pk' | 'files' | 'files_aggregate' | 'files_by_pk' | 'findLocationsByServiceId' | 'form' | 'formAnswers' | 'formAnswers_aggregate' | 'formAnswers_by_pk' | 'formQuestionOptions' | 'formQuestionOptions_aggregate' | 'formQuestionOptions_by_pk' | 'formQuestionType' | 'formQuestionType_aggregate' | 'formQuestionType_by_pk' | 'formQuestions' | 'formQuestions_aggregate' | 'formQuestions_by_pk' | 'form_aggregate' | 'form_by_pk' | 'getAdminCustomerDetails' | 'getAdminCustomerList' | 'getAllUsers' | 'getAppointmentPaymentDetails' | 'getBMCustomerDetails' | 'getBMCustomerList' | 'getCalendar' | 'getCheckoutPrivateFile' | 'getCurrentProvider' | 'getCurrentUser' | 'getCustomerServices' | 'getEmployeesByServiceIdAndLocationId' | 'getGoogleOAuthUrl' | 'getLocationByAddress' | 'getPrivateFile' | 'getProviderCard' | 'getProviderVisibility' | 'getPublicUploadFileUrl' | 'getUpfrontAppointmentDetails' | 'getUploadFileUrl' | 'getUserCard' | 'get_nearby_locations' | 'get_nearby_locations_aggregate' | 'haversine' | 'isGoogleCalendarLinked' | 'isOnboardingCompleted' | 'jobStatus' | 'jobStatus_aggregate' | 'jobStatus_by_pk' | 'listCalendars' | 'locale' | 'locale_aggregate' | 'locale_by_pk' | 'locationHaversine' | 'locationStatus' | 'locationStatus_aggregate' | 'locationStatus_by_pk' | 'locationType' | 'locationType_aggregate' | 'locationType_by_pk' | 'locations' | 'locations_aggregate' | 'locations_by_pk' | 'locations_with_distance' | 'locations_with_distance_aggregate' | 'login' | 'notificationType' | 'notificationType_aggregate' | 'notificationType_by_pk' | 'notifications' | 'notifications_aggregate' | 'notifications_by_pk' | 'partnershipSchedulingType' | 'partnershipSchedulingType_aggregate' | 'partnershipSchedulingType_by_pk' | 'partnershipStatus' | 'partnershipStatus_aggregate' | 'partnershipStatus_by_pk' | 'paymentFormat' | 'paymentFormat_aggregate' | 'paymentFormat_by_pk' | 'paymentStatus' | 'paymentStatus_aggregate' | 'paymentStatus_by_pk' | 'payments' | 'payments_aggregate' | 'payments_by_pk' | 'payouts' | 'providerCategory' | 'providerCategory_aggregate' | 'providerCategory_by_pk' | 'providerMonthlyPayments' | 'providerMonthlyPayments_aggregate' | 'providerMonthlyPayments_by_pk' | 'providerPayments' | 'providerPictures' | 'providerPictures_aggregate' | 'providerPictures_by_pk' | 'providerRole' | 'providerRole_aggregate' | 'providerRole_by_pk' | 'providerStatus' | 'providerStatus_aggregate' | 'providerStatus_by_pk' | 'providerType' | 'providerType_aggregate' | 'providerType_by_pk' | 'providerVisibility' | 'providerVisibility_aggregate' | 'providerVisibility_by_pk' | 'providers' | 'providers_aggregate' | 'providers_by_pk' | 'refunds' | 'refunds_aggregate' | 'refunds_by_pk' | 'relationshipStatus' | 'relationshipStatus_aggregate' | 'relationshipStatus_by_pk' | 'schedule' | 'schedule_aggregate' | 'schedule_by_pk' | 'serviceEmployees' | 'serviceEmployees_aggregate' | 'serviceEmployees_by_pk' | 'serviceFormStatus' | 'serviceFormStatus_aggregate' | 'serviceFormStatus_by_pk' | 'serviceOptionAnswers' | 'serviceOptionAnswers_aggregate' | 'serviceOptionAnswers_by_pk' | 'serviceOptionSection' | 'serviceOptionSectionOptions' | 'serviceOptionSectionOptions_aggregate' | 'serviceOptionSectionOptions_by_pk' | 'serviceOptionSection_aggregate' | 'serviceOptionSection_by_pk' | 'serviceOptions' | 'serviceOptionsStatus' | 'serviceOptionsStatus_aggregate' | 'serviceOptionsStatus_by_pk' | 'serviceOptions_aggregate' | 'serviceOptions_by_pk' | 'servicePictures' | 'servicePictures_aggregate' | 'servicePictures_by_pk' | 'servicePricings' | 'servicePricings_aggregate' | 'servicePricings_by_pk' | 'serviceSectionOptionQuantityType' | 'serviceSectionOptionQuantityType_aggregate' | 'serviceSectionOptionQuantityType_by_pk' | 'serviceSectionOptionType' | 'serviceSectionOptionType_aggregate' | 'serviceSectionOptionType_by_pk' | 'serviceStatus' | 'serviceStatus_aggregate' | 'serviceStatus_by_pk' | 'services' | 'servicesForms' | 'servicesForms_aggregate' | 'servicesForms_by_pk' | 'services_aggregate' | 'services_by_pk' | 'sessions' | 'sessions_aggregate' | 'sessions_by_pk' | 'timeouts' | 'timeouts_aggregate' | 'timeouts_by_pk' | 'transitionStatus' | 'transitionStatus_aggregate' | 'transitionStatus_by_pk' | 'unavailableServiceLocations' | 'unavailableServiceLocations_aggregate' | 'unavailableServiceLocations_by_pk' | 'userRole' | 'userRole_aggregate' | 'userRole_by_pk' | 'userRoles' | 'userRoles_aggregate' | 'userRoles_by_pk' | 'users' | 'users_aggregate' | 'users_by_pk' | 'validateServiceById' | query_rootKeySpecifier)[];
export type query_rootFieldPolicy = {
	CustomerCard?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentPricing?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentPricing_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentPricing_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	appointments?: FieldPolicy<any> | FieldReadFunction<any>,
	appointments_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	appointments_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	availableAppointmentDateTimeSlots?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingProviders_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingProviders_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingType?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingType_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	canProviderReceivePayments?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutSessions?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutSessions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutSessions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	currencies?: FieldPolicy<any> | FieldReadFunction<any>,
	currencies_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	currencies_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	customerAmountSpent?: FieldPolicy<any> | FieldReadFunction<any>,
	customerAmountSpent_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	customers?: FieldPolicy<any> | FieldReadFunction<any>,
	customers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	customers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	entityType?: FieldPolicy<any> | FieldReadFunction<any>,
	entityType_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	entityType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	files_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	files_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	findLocationsByServiceId?: FieldPolicy<any> | FieldReadFunction<any>,
	form?: FieldPolicy<any> | FieldReadFunction<any>,
	formAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	formAnswers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	formAnswers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionOptions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionOptions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionType?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionType_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	form_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	form_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	getAdminCustomerDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	getAdminCustomerList?: FieldPolicy<any> | FieldReadFunction<any>,
	getAllUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	getAppointmentPaymentDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	getBMCustomerDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	getBMCustomerList?: FieldPolicy<any> | FieldReadFunction<any>,
	getCalendar?: FieldPolicy<any> | FieldReadFunction<any>,
	getCheckoutPrivateFile?: FieldPolicy<any> | FieldReadFunction<any>,
	getCurrentProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	getCurrentUser?: FieldPolicy<any> | FieldReadFunction<any>,
	getCustomerServices?: FieldPolicy<any> | FieldReadFunction<any>,
	getEmployeesByServiceIdAndLocationId?: FieldPolicy<any> | FieldReadFunction<any>,
	getGoogleOAuthUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	getLocationByAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	getPrivateFile?: FieldPolicy<any> | FieldReadFunction<any>,
	getProviderCard?: FieldPolicy<any> | FieldReadFunction<any>,
	getProviderVisibility?: FieldPolicy<any> | FieldReadFunction<any>,
	getPublicUploadFileUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	getUpfrontAppointmentDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	getUploadFileUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	getUserCard?: FieldPolicy<any> | FieldReadFunction<any>,
	get_nearby_locations?: FieldPolicy<any> | FieldReadFunction<any>,
	get_nearby_locations_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	haversine?: FieldPolicy<any> | FieldReadFunction<any>,
	isGoogleCalendarLinked?: FieldPolicy<any> | FieldReadFunction<any>,
	isOnboardingCompleted?: FieldPolicy<any> | FieldReadFunction<any>,
	jobStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	jobStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	jobStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	listCalendars?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	locale_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	locale_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	locationHaversine?: FieldPolicy<any> | FieldReadFunction<any>,
	locationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	locationStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	locationStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	locationType?: FieldPolicy<any> | FieldReadFunction<any>,
	locationType_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	locationType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	locations?: FieldPolicy<any> | FieldReadFunction<any>,
	locations_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	locations_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	locations_with_distance?: FieldPolicy<any> | FieldReadFunction<any>,
	locations_with_distance_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	login?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationType?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationType_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	partnershipSchedulingType?: FieldPolicy<any> | FieldReadFunction<any>,
	partnershipSchedulingType_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	partnershipSchedulingType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	partnershipStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	partnershipStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	partnershipStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentFormat_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentFormat_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	payments?: FieldPolicy<any> | FieldReadFunction<any>,
	payments_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	payments_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	payouts?: FieldPolicy<any> | FieldReadFunction<any>,
	providerCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	providerCategory_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providerCategory_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	providerMonthlyPayments?: FieldPolicy<any> | FieldReadFunction<any>,
	providerMonthlyPayments_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providerMonthlyPayments_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	providerPayments?: FieldPolicy<any> | FieldReadFunction<any>,
	providerPictures?: FieldPolicy<any> | FieldReadFunction<any>,
	providerPictures_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providerPictures_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	providerRole?: FieldPolicy<any> | FieldReadFunction<any>,
	providerRole_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providerRole_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	providerStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	providerStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providerStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	providerType?: FieldPolicy<any> | FieldReadFunction<any>,
	providerType_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providerType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	providerVisibility?: FieldPolicy<any> | FieldReadFunction<any>,
	providerVisibility_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providerVisibility_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	providers?: FieldPolicy<any> | FieldReadFunction<any>,
	providers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	refunds?: FieldPolicy<any> | FieldReadFunction<any>,
	refunds_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	refunds_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	relationshipStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	relationshipStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	relationshipStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	schedule?: FieldPolicy<any> | FieldReadFunction<any>,
	schedule_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	schedule_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceEmployees?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceEmployees_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceEmployees_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceFormStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceFormStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceFormStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionAnswers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionAnswers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSection?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSectionOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSectionOptions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSectionOptions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSection_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSection_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionsStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionsStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionsStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePictures?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePictures_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePictures_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePricings?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePricings_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePricings_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceSectionOptionQuantityType?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceSectionOptionQuantityType_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceSectionOptionQuantityType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceSectionOptionType?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceSectionOptionType_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceSectionOptionType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	services?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesForms?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesForms_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesForms_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	services_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	services_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	timeouts?: FieldPolicy<any> | FieldReadFunction<any>,
	timeouts_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	timeouts_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	transitionStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	transitionStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	transitionStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	unavailableServiceLocations?: FieldPolicy<any> | FieldReadFunction<any>,
	unavailableServiceLocations_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	unavailableServiceLocations_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	userRole?: FieldPolicy<any> | FieldReadFunction<any>,
	userRole_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	userRole_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	userRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	userRoles_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	userRoles_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	users_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	users_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	validateServiceById?: FieldPolicy<any> | FieldReadFunction<any>
};
export type refundsKeySpecifier = ('amount' | 'appointment' | 'appointmentId' | 'createdAt' | 'currency' | 'deletedAt' | 'id' | 'payment' | 'paymentId' | 'sources' | 'status' | 'stripeRefundId' | 'updatedAt' | refundsKeySpecifier)[];
export type refundsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	appointment?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentId?: FieldPolicy<any> | FieldReadFunction<any>,
	sources?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeRefundId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type refunds_aggregateKeySpecifier = ('aggregate' | 'nodes' | refunds_aggregateKeySpecifier)[];
export type refunds_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type refunds_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | refunds_aggregate_fieldsKeySpecifier)[];
export type refunds_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type refunds_avg_fieldsKeySpecifier = ('amount' | refunds_avg_fieldsKeySpecifier)[];
export type refunds_avg_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type refunds_max_fieldsKeySpecifier = ('amount' | 'appointmentId' | 'createdAt' | 'currency' | 'deletedAt' | 'id' | 'paymentId' | 'stripeRefundId' | 'updatedAt' | refunds_max_fieldsKeySpecifier)[];
export type refunds_max_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeRefundId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type refunds_min_fieldsKeySpecifier = ('amount' | 'appointmentId' | 'createdAt' | 'currency' | 'deletedAt' | 'id' | 'paymentId' | 'stripeRefundId' | 'updatedAt' | refunds_min_fieldsKeySpecifier)[];
export type refunds_min_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeRefundId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type refunds_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | refunds_mutation_responseKeySpecifier)[];
export type refunds_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type refunds_stddev_fieldsKeySpecifier = ('amount' | refunds_stddev_fieldsKeySpecifier)[];
export type refunds_stddev_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type refunds_stddev_pop_fieldsKeySpecifier = ('amount' | refunds_stddev_pop_fieldsKeySpecifier)[];
export type refunds_stddev_pop_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type refunds_stddev_samp_fieldsKeySpecifier = ('amount' | refunds_stddev_samp_fieldsKeySpecifier)[];
export type refunds_stddev_samp_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type refunds_sum_fieldsKeySpecifier = ('amount' | refunds_sum_fieldsKeySpecifier)[];
export type refunds_sum_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type refunds_var_pop_fieldsKeySpecifier = ('amount' | refunds_var_pop_fieldsKeySpecifier)[];
export type refunds_var_pop_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type refunds_var_samp_fieldsKeySpecifier = ('amount' | refunds_var_samp_fieldsKeySpecifier)[];
export type refunds_var_samp_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type refunds_variance_fieldsKeySpecifier = ('amount' | refunds_variance_fieldsKeySpecifier)[];
export type refunds_variance_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type relationshipStatusKeySpecifier = ('value' | relationshipStatusKeySpecifier)[];
export type relationshipStatusFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type relationshipStatus_aggregateKeySpecifier = ('aggregate' | 'nodes' | relationshipStatus_aggregateKeySpecifier)[];
export type relationshipStatus_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type relationshipStatus_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | relationshipStatus_aggregate_fieldsKeySpecifier)[];
export type relationshipStatus_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type relationshipStatus_max_fieldsKeySpecifier = ('value' | relationshipStatus_max_fieldsKeySpecifier)[];
export type relationshipStatus_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type relationshipStatus_min_fieldsKeySpecifier = ('value' | relationshipStatus_min_fieldsKeySpecifier)[];
export type relationshipStatus_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type relationshipStatus_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | relationshipStatus_mutation_responseKeySpecifier)[];
export type relationshipStatus_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type scheduleKeySpecifier = ('createdAt' | 'deletedAt' | 'employeeId' | 'endTime' | 'endingAt' | 'id' | 'location' | 'locationId' | 'repeatableDayOfWeek' | 'startTime' | 'startingAt' | 'timezone' | 'updatedAt' | 'user' | scheduleKeySpecifier)[];
export type scheduleFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	employeeId?: FieldPolicy<any> | FieldReadFunction<any>,
	endTime?: FieldPolicy<any> | FieldReadFunction<any>,
	endingAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	repeatableDayOfWeek?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>,
	startingAt?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type schedule_aggregateKeySpecifier = ('aggregate' | 'nodes' | schedule_aggregateKeySpecifier)[];
export type schedule_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type schedule_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | schedule_aggregate_fieldsKeySpecifier)[];
export type schedule_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type schedule_max_fieldsKeySpecifier = ('createdAt' | 'deletedAt' | 'employeeId' | 'endTime' | 'endingAt' | 'id' | 'locationId' | 'repeatableDayOfWeek' | 'startTime' | 'startingAt' | 'timezone' | 'updatedAt' | schedule_max_fieldsKeySpecifier)[];
export type schedule_max_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	employeeId?: FieldPolicy<any> | FieldReadFunction<any>,
	endTime?: FieldPolicy<any> | FieldReadFunction<any>,
	endingAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	repeatableDayOfWeek?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>,
	startingAt?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type schedule_min_fieldsKeySpecifier = ('createdAt' | 'deletedAt' | 'employeeId' | 'endTime' | 'endingAt' | 'id' | 'locationId' | 'repeatableDayOfWeek' | 'startTime' | 'startingAt' | 'timezone' | 'updatedAt' | schedule_min_fieldsKeySpecifier)[];
export type schedule_min_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	employeeId?: FieldPolicy<any> | FieldReadFunction<any>,
	endTime?: FieldPolicy<any> | FieldReadFunction<any>,
	endingAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	repeatableDayOfWeek?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>,
	startingAt?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type schedule_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | schedule_mutation_responseKeySpecifier)[];
export type schedule_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceEmployeesKeySpecifier = ('id' | 'service' | 'serviceId' | 'user' | 'userId' | serviceEmployeesKeySpecifier)[];
export type serviceEmployeesFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceEmployees_aggregateKeySpecifier = ('aggregate' | 'nodes' | serviceEmployees_aggregateKeySpecifier)[];
export type serviceEmployees_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceEmployees_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | serviceEmployees_aggregate_fieldsKeySpecifier)[];
export type serviceEmployees_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceEmployees_max_fieldsKeySpecifier = ('id' | 'serviceId' | 'userId' | serviceEmployees_max_fieldsKeySpecifier)[];
export type serviceEmployees_max_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceEmployees_min_fieldsKeySpecifier = ('id' | 'serviceId' | 'userId' | serviceEmployees_min_fieldsKeySpecifier)[];
export type serviceEmployees_min_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceEmployees_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | serviceEmployees_mutation_responseKeySpecifier)[];
export type serviceEmployees_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceFormStatusKeySpecifier = ('servicesForms' | 'servicesForms_aggregate' | 'value' | serviceFormStatusKeySpecifier)[];
export type serviceFormStatusFieldPolicy = {
	servicesForms?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesForms_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceFormStatus_aggregateKeySpecifier = ('aggregate' | 'nodes' | serviceFormStatus_aggregateKeySpecifier)[];
export type serviceFormStatus_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceFormStatus_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | serviceFormStatus_aggregate_fieldsKeySpecifier)[];
export type serviceFormStatus_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceFormStatus_max_fieldsKeySpecifier = ('value' | serviceFormStatus_max_fieldsKeySpecifier)[];
export type serviceFormStatus_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceFormStatus_min_fieldsKeySpecifier = ('value' | serviceFormStatus_min_fieldsKeySpecifier)[];
export type serviceFormStatus_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceFormStatus_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | serviceFormStatus_mutation_responseKeySpecifier)[];
export type serviceFormStatus_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionAnswersKeySpecifier = ('appointment' | 'appointmentId' | 'id' | 'quantity' | 'serviceOptionSectionOption' | 'serviceOptionSectionOptionsId' | serviceOptionAnswersKeySpecifier)[];
export type serviceOptionAnswersFieldPolicy = {
	appointment?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSectionOption?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSectionOptionsId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionAnswers_aggregateKeySpecifier = ('aggregate' | 'nodes' | serviceOptionAnswers_aggregateKeySpecifier)[];
export type serviceOptionAnswers_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionAnswers_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | serviceOptionAnswers_aggregate_fieldsKeySpecifier)[];
export type serviceOptionAnswers_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionAnswers_avg_fieldsKeySpecifier = ('quantity' | serviceOptionAnswers_avg_fieldsKeySpecifier)[];
export type serviceOptionAnswers_avg_fieldsFieldPolicy = {
	quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionAnswers_max_fieldsKeySpecifier = ('appointmentId' | 'id' | 'quantity' | 'serviceOptionSectionOptionsId' | serviceOptionAnswers_max_fieldsKeySpecifier)[];
export type serviceOptionAnswers_max_fieldsFieldPolicy = {
	appointmentId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSectionOptionsId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionAnswers_min_fieldsKeySpecifier = ('appointmentId' | 'id' | 'quantity' | 'serviceOptionSectionOptionsId' | serviceOptionAnswers_min_fieldsKeySpecifier)[];
export type serviceOptionAnswers_min_fieldsFieldPolicy = {
	appointmentId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSectionOptionsId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionAnswers_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | serviceOptionAnswers_mutation_responseKeySpecifier)[];
export type serviceOptionAnswers_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionAnswers_stddev_fieldsKeySpecifier = ('quantity' | serviceOptionAnswers_stddev_fieldsKeySpecifier)[];
export type serviceOptionAnswers_stddev_fieldsFieldPolicy = {
	quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionAnswers_stddev_pop_fieldsKeySpecifier = ('quantity' | serviceOptionAnswers_stddev_pop_fieldsKeySpecifier)[];
export type serviceOptionAnswers_stddev_pop_fieldsFieldPolicy = {
	quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionAnswers_stddev_samp_fieldsKeySpecifier = ('quantity' | serviceOptionAnswers_stddev_samp_fieldsKeySpecifier)[];
export type serviceOptionAnswers_stddev_samp_fieldsFieldPolicy = {
	quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionAnswers_sum_fieldsKeySpecifier = ('quantity' | serviceOptionAnswers_sum_fieldsKeySpecifier)[];
export type serviceOptionAnswers_sum_fieldsFieldPolicy = {
	quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionAnswers_var_pop_fieldsKeySpecifier = ('quantity' | serviceOptionAnswers_var_pop_fieldsKeySpecifier)[];
export type serviceOptionAnswers_var_pop_fieldsFieldPolicy = {
	quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionAnswers_var_samp_fieldsKeySpecifier = ('quantity' | serviceOptionAnswers_var_samp_fieldsKeySpecifier)[];
export type serviceOptionAnswers_var_samp_fieldsFieldPolicy = {
	quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionAnswers_variance_fieldsKeySpecifier = ('quantity' | serviceOptionAnswers_variance_fieldsKeySpecifier)[];
export type serviceOptionAnswers_variance_fieldsFieldPolicy = {
	quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSectionKeySpecifier = ('createdAt' | 'id' | 'mandatory' | 'name' | 'order' | 'serviceOption' | 'serviceOptionId' | 'serviceOptionSectionOptions' | 'serviceOptionSectionOptions_aggregate' | 'serviceSectionOptionType' | 'type' | 'updatedAt' | serviceOptionSectionKeySpecifier)[];
export type serviceOptionSectionFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mandatory?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOption?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionId?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSectionOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSectionOptions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceSectionOptionType?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSectionOptionsKeySpecifier = ('createdAt' | 'id' | 'name' | 'order' | 'price' | 'quantity' | 'serviceOptionAnswers' | 'serviceOptionAnswers_aggregate' | 'serviceOptionSection' | 'serviceOptionSectionId' | 'serviceSectionOptionQuantityType' | 'updatedAt' | serviceOptionSectionOptionsKeySpecifier)[];
export type serviceOptionSectionOptionsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionAnswers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSection?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSectionId?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceSectionOptionQuantityType?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSectionOptions_aggregateKeySpecifier = ('aggregate' | 'nodes' | serviceOptionSectionOptions_aggregateKeySpecifier)[];
export type serviceOptionSectionOptions_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSectionOptions_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | serviceOptionSectionOptions_aggregate_fieldsKeySpecifier)[];
export type serviceOptionSectionOptions_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSectionOptions_avg_fieldsKeySpecifier = ('order' | 'price' | serviceOptionSectionOptions_avg_fieldsKeySpecifier)[];
export type serviceOptionSectionOptions_avg_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSectionOptions_max_fieldsKeySpecifier = ('createdAt' | 'id' | 'name' | 'order' | 'price' | 'serviceOptionSectionId' | 'updatedAt' | serviceOptionSectionOptions_max_fieldsKeySpecifier)[];
export type serviceOptionSectionOptions_max_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSectionId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSectionOptions_min_fieldsKeySpecifier = ('createdAt' | 'id' | 'name' | 'order' | 'price' | 'serviceOptionSectionId' | 'updatedAt' | serviceOptionSectionOptions_min_fieldsKeySpecifier)[];
export type serviceOptionSectionOptions_min_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSectionId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSectionOptions_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | serviceOptionSectionOptions_mutation_responseKeySpecifier)[];
export type serviceOptionSectionOptions_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSectionOptions_stddev_fieldsKeySpecifier = ('order' | 'price' | serviceOptionSectionOptions_stddev_fieldsKeySpecifier)[];
export type serviceOptionSectionOptions_stddev_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSectionOptions_stddev_pop_fieldsKeySpecifier = ('order' | 'price' | serviceOptionSectionOptions_stddev_pop_fieldsKeySpecifier)[];
export type serviceOptionSectionOptions_stddev_pop_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSectionOptions_stddev_samp_fieldsKeySpecifier = ('order' | 'price' | serviceOptionSectionOptions_stddev_samp_fieldsKeySpecifier)[];
export type serviceOptionSectionOptions_stddev_samp_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSectionOptions_sum_fieldsKeySpecifier = ('order' | 'price' | serviceOptionSectionOptions_sum_fieldsKeySpecifier)[];
export type serviceOptionSectionOptions_sum_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSectionOptions_var_pop_fieldsKeySpecifier = ('order' | 'price' | serviceOptionSectionOptions_var_pop_fieldsKeySpecifier)[];
export type serviceOptionSectionOptions_var_pop_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSectionOptions_var_samp_fieldsKeySpecifier = ('order' | 'price' | serviceOptionSectionOptions_var_samp_fieldsKeySpecifier)[];
export type serviceOptionSectionOptions_var_samp_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSectionOptions_variance_fieldsKeySpecifier = ('order' | 'price' | serviceOptionSectionOptions_variance_fieldsKeySpecifier)[];
export type serviceOptionSectionOptions_variance_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSection_aggregateKeySpecifier = ('aggregate' | 'nodes' | serviceOptionSection_aggregateKeySpecifier)[];
export type serviceOptionSection_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSection_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | serviceOptionSection_aggregate_fieldsKeySpecifier)[];
export type serviceOptionSection_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSection_avg_fieldsKeySpecifier = ('order' | serviceOptionSection_avg_fieldsKeySpecifier)[];
export type serviceOptionSection_avg_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSection_max_fieldsKeySpecifier = ('createdAt' | 'id' | 'name' | 'order' | 'serviceOptionId' | 'updatedAt' | serviceOptionSection_max_fieldsKeySpecifier)[];
export type serviceOptionSection_max_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSection_min_fieldsKeySpecifier = ('createdAt' | 'id' | 'name' | 'order' | 'serviceOptionId' | 'updatedAt' | serviceOptionSection_min_fieldsKeySpecifier)[];
export type serviceOptionSection_min_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSection_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | serviceOptionSection_mutation_responseKeySpecifier)[];
export type serviceOptionSection_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSection_stddev_fieldsKeySpecifier = ('order' | serviceOptionSection_stddev_fieldsKeySpecifier)[];
export type serviceOptionSection_stddev_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSection_stddev_pop_fieldsKeySpecifier = ('order' | serviceOptionSection_stddev_pop_fieldsKeySpecifier)[];
export type serviceOptionSection_stddev_pop_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSection_stddev_samp_fieldsKeySpecifier = ('order' | serviceOptionSection_stddev_samp_fieldsKeySpecifier)[];
export type serviceOptionSection_stddev_samp_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSection_sum_fieldsKeySpecifier = ('order' | serviceOptionSection_sum_fieldsKeySpecifier)[];
export type serviceOptionSection_sum_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSection_var_pop_fieldsKeySpecifier = ('order' | serviceOptionSection_var_pop_fieldsKeySpecifier)[];
export type serviceOptionSection_var_pop_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSection_var_samp_fieldsKeySpecifier = ('order' | serviceOptionSection_var_samp_fieldsKeySpecifier)[];
export type serviceOptionSection_var_samp_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionSection_variance_fieldsKeySpecifier = ('order' | serviceOptionSection_variance_fieldsKeySpecifier)[];
export type serviceOptionSection_variance_fieldsFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionsKeySpecifier = ('createdAt' | 'deletedAt' | 'id' | 'name' | 'service' | 'serviceId' | 'serviceOptionSections' | 'serviceOptionSections_aggregate' | 'serviceOptionsStatus' | 'status' | 'updatedAt' | serviceOptionsKeySpecifier)[];
export type serviceOptionsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSections?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSections_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionsStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionsStatusKeySpecifier = ('serviceOptions' | 'serviceOptions_aggregate' | 'value' | serviceOptionsStatusKeySpecifier)[];
export type serviceOptionsStatusFieldPolicy = {
	serviceOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionsStatus_aggregateKeySpecifier = ('aggregate' | 'nodes' | serviceOptionsStatus_aggregateKeySpecifier)[];
export type serviceOptionsStatus_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionsStatus_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | serviceOptionsStatus_aggregate_fieldsKeySpecifier)[];
export type serviceOptionsStatus_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionsStatus_max_fieldsKeySpecifier = ('value' | serviceOptionsStatus_max_fieldsKeySpecifier)[];
export type serviceOptionsStatus_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionsStatus_min_fieldsKeySpecifier = ('value' | serviceOptionsStatus_min_fieldsKeySpecifier)[];
export type serviceOptionsStatus_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptionsStatus_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | serviceOptionsStatus_mutation_responseKeySpecifier)[];
export type serviceOptionsStatus_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptions_aggregateKeySpecifier = ('aggregate' | 'nodes' | serviceOptions_aggregateKeySpecifier)[];
export type serviceOptions_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptions_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | serviceOptions_aggregate_fieldsKeySpecifier)[];
export type serviceOptions_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptions_max_fieldsKeySpecifier = ('createdAt' | 'deletedAt' | 'id' | 'name' | 'serviceId' | 'updatedAt' | serviceOptions_max_fieldsKeySpecifier)[];
export type serviceOptions_max_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptions_min_fieldsKeySpecifier = ('createdAt' | 'deletedAt' | 'id' | 'name' | 'serviceId' | 'updatedAt' | serviceOptions_min_fieldsKeySpecifier)[];
export type serviceOptions_min_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceOptions_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | serviceOptions_mutation_responseKeySpecifier)[];
export type serviceOptions_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePicturesKeySpecifier = ('createdAt' | 'file' | 'fileId' | 'id' | 'name' | 'service' | 'serviceId' | 'services' | 'services_aggregate' | 'size' | 'updatedAt' | servicePicturesKeySpecifier)[];
export type servicePicturesFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	services?: FieldPolicy<any> | FieldReadFunction<any>,
	services_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePictures_aggregateKeySpecifier = ('aggregate' | 'nodes' | servicePictures_aggregateKeySpecifier)[];
export type servicePictures_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePictures_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | servicePictures_aggregate_fieldsKeySpecifier)[];
export type servicePictures_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePictures_max_fieldsKeySpecifier = ('createdAt' | 'fileId' | 'id' | 'name' | 'serviceId' | 'size' | 'updatedAt' | servicePictures_max_fieldsKeySpecifier)[];
export type servicePictures_max_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePictures_min_fieldsKeySpecifier = ('createdAt' | 'fileId' | 'id' | 'name' | 'serviceId' | 'size' | 'updatedAt' | servicePictures_min_fieldsKeySpecifier)[];
export type servicePictures_min_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePictures_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | servicePictures_mutation_responseKeySpecifier)[];
export type servicePictures_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePricingsKeySpecifier = ('basePrice' | 'checkoutPayment' | 'createdAt' | 'currency' | 'currencyByCurrency' | 'fees' | 'id' | 'minimumDeposit' | 'paymentFormat' | 'paymentFormatByPaymentformat' | 'service' | 'serviceId' | 'taxes' | 'updatedAt' | servicePricingsKeySpecifier)[];
export type servicePricingsFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyByCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	fees?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentFormatByPaymentformat?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	taxes?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePricings_aggregateKeySpecifier = ('aggregate' | 'nodes' | servicePricings_aggregateKeySpecifier)[];
export type servicePricings_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePricings_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | servicePricings_aggregate_fieldsKeySpecifier)[];
export type servicePricings_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePricings_avg_fieldsKeySpecifier = ('basePrice' | 'minimumDeposit' | servicePricings_avg_fieldsKeySpecifier)[];
export type servicePricings_avg_fieldsFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePricings_max_fieldsKeySpecifier = ('basePrice' | 'createdAt' | 'id' | 'minimumDeposit' | 'serviceId' | 'updatedAt' | servicePricings_max_fieldsKeySpecifier)[];
export type servicePricings_max_fieldsFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePricings_min_fieldsKeySpecifier = ('basePrice' | 'createdAt' | 'id' | 'minimumDeposit' | 'serviceId' | 'updatedAt' | servicePricings_min_fieldsKeySpecifier)[];
export type servicePricings_min_fieldsFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePricings_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | servicePricings_mutation_responseKeySpecifier)[];
export type servicePricings_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePricings_stddev_fieldsKeySpecifier = ('basePrice' | 'minimumDeposit' | servicePricings_stddev_fieldsKeySpecifier)[];
export type servicePricings_stddev_fieldsFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePricings_stddev_pop_fieldsKeySpecifier = ('basePrice' | 'minimumDeposit' | servicePricings_stddev_pop_fieldsKeySpecifier)[];
export type servicePricings_stddev_pop_fieldsFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePricings_stddev_samp_fieldsKeySpecifier = ('basePrice' | 'minimumDeposit' | servicePricings_stddev_samp_fieldsKeySpecifier)[];
export type servicePricings_stddev_samp_fieldsFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePricings_sum_fieldsKeySpecifier = ('basePrice' | 'minimumDeposit' | servicePricings_sum_fieldsKeySpecifier)[];
export type servicePricings_sum_fieldsFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePricings_var_pop_fieldsKeySpecifier = ('basePrice' | 'minimumDeposit' | servicePricings_var_pop_fieldsKeySpecifier)[];
export type servicePricings_var_pop_fieldsFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePricings_var_samp_fieldsKeySpecifier = ('basePrice' | 'minimumDeposit' | servicePricings_var_samp_fieldsKeySpecifier)[];
export type servicePricings_var_samp_fieldsFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicePricings_variance_fieldsKeySpecifier = ('basePrice' | 'minimumDeposit' | servicePricings_variance_fieldsKeySpecifier)[];
export type servicePricings_variance_fieldsFieldPolicy = {
	basePrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeposit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceSectionOptionQuantityTypeKeySpecifier = ('serviceOptionSectionOptions' | 'serviceOptionSectionOptions_aggregate' | 'value' | serviceSectionOptionQuantityTypeKeySpecifier)[];
export type serviceSectionOptionQuantityTypeFieldPolicy = {
	serviceOptionSectionOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSectionOptions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceSectionOptionQuantityType_aggregateKeySpecifier = ('aggregate' | 'nodes' | serviceSectionOptionQuantityType_aggregateKeySpecifier)[];
export type serviceSectionOptionQuantityType_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceSectionOptionQuantityType_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | serviceSectionOptionQuantityType_aggregate_fieldsKeySpecifier)[];
export type serviceSectionOptionQuantityType_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceSectionOptionQuantityType_max_fieldsKeySpecifier = ('value' | serviceSectionOptionQuantityType_max_fieldsKeySpecifier)[];
export type serviceSectionOptionQuantityType_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceSectionOptionQuantityType_min_fieldsKeySpecifier = ('value' | serviceSectionOptionQuantityType_min_fieldsKeySpecifier)[];
export type serviceSectionOptionQuantityType_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceSectionOptionQuantityType_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | serviceSectionOptionQuantityType_mutation_responseKeySpecifier)[];
export type serviceSectionOptionQuantityType_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceSectionOptionTypeKeySpecifier = ('serviceOptionSections' | 'serviceOptionSections_aggregate' | 'value' | serviceSectionOptionTypeKeySpecifier)[];
export type serviceSectionOptionTypeFieldPolicy = {
	serviceOptionSections?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSections_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceSectionOptionType_aggregateKeySpecifier = ('aggregate' | 'nodes' | serviceSectionOptionType_aggregateKeySpecifier)[];
export type serviceSectionOptionType_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceSectionOptionType_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | serviceSectionOptionType_aggregate_fieldsKeySpecifier)[];
export type serviceSectionOptionType_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceSectionOptionType_max_fieldsKeySpecifier = ('value' | serviceSectionOptionType_max_fieldsKeySpecifier)[];
export type serviceSectionOptionType_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceSectionOptionType_min_fieldsKeySpecifier = ('value' | serviceSectionOptionType_min_fieldsKeySpecifier)[];
export type serviceSectionOptionType_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceSectionOptionType_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | serviceSectionOptionType_mutation_responseKeySpecifier)[];
export type serviceSectionOptionType_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceStatusKeySpecifier = ('services' | 'services_aggregate' | 'value' | serviceStatusKeySpecifier)[];
export type serviceStatusFieldPolicy = {
	services?: FieldPolicy<any> | FieldReadFunction<any>,
	services_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceStatus_aggregateKeySpecifier = ('aggregate' | 'nodes' | serviceStatus_aggregateKeySpecifier)[];
export type serviceStatus_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceStatus_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | serviceStatus_aggregate_fieldsKeySpecifier)[];
export type serviceStatus_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceStatus_max_fieldsKeySpecifier = ('value' | serviceStatus_max_fieldsKeySpecifier)[];
export type serviceStatus_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceStatus_min_fieldsKeySpecifier = ('value' | serviceStatus_min_fieldsKeySpecifier)[];
export type serviceStatus_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceStatus_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | serviceStatus_mutation_responseKeySpecifier)[];
export type serviceStatus_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicesKeySpecifier = ('appointments' | 'appointments_aggregate' | 'color' | 'createdAt' | 'customerCanPickEmployee' | 'deletedAt' | 'description' | 'duration' | 'featured' | 'id' | 'maxBookings' | 'name' | 'offTime' | 'pictures' | 'provider' | 'providerId' | 'serviceEmployees' | 'serviceEmployees_aggregate' | 'serviceOptions' | 'serviceOptions_aggregate' | 'servicePicture' | 'servicePictures' | 'servicePictures_aggregate' | 'servicePricing' | 'servicePricings' | 'servicePricings_aggregate' | 'serviceStatus' | 'servicesForms' | 'servicesForms_aggregate' | 'sku' | 'status' | 'timeouts' | 'timeouts_aggregate' | 'unavailableServiceLocations' | 'unavailableServiceLocations_aggregate' | 'updatedAt' | servicesKeySpecifier)[];
export type servicesFieldPolicy = {
	appointments?: FieldPolicy<any> | FieldReadFunction<any>,
	appointments_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	customerCanPickEmployee?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	featured?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maxBookings?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	offTime?: FieldPolicy<any> | FieldReadFunction<any>,
	pictures?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceEmployees?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceEmployees_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePicture?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePictures?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePictures_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePricing?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePricings?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePricings_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesForms?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesForms_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	timeouts?: FieldPolicy<any> | FieldReadFunction<any>,
	timeouts_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	unavailableServiceLocations?: FieldPolicy<any> | FieldReadFunction<any>,
	unavailableServiceLocations_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicesFormsKeySpecifier = ('createdAt' | 'form' | 'formId' | 'id' | 'service' | 'serviceFormStatus' | 'serviceId' | 'status' | 'updatedAt' | servicesFormsKeySpecifier)[];
export type servicesFormsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	form?: FieldPolicy<any> | FieldReadFunction<any>,
	formId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceFormStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicesForms_aggregateKeySpecifier = ('aggregate' | 'nodes' | servicesForms_aggregateKeySpecifier)[];
export type servicesForms_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicesForms_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | servicesForms_aggregate_fieldsKeySpecifier)[];
export type servicesForms_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicesForms_max_fieldsKeySpecifier = ('createdAt' | 'formId' | 'id' | 'serviceId' | 'updatedAt' | servicesForms_max_fieldsKeySpecifier)[];
export type servicesForms_max_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	formId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicesForms_min_fieldsKeySpecifier = ('createdAt' | 'formId' | 'id' | 'serviceId' | 'updatedAt' | servicesForms_min_fieldsKeySpecifier)[];
export type servicesForms_min_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	formId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type servicesForms_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | servicesForms_mutation_responseKeySpecifier)[];
export type servicesForms_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type services_aggregateKeySpecifier = ('aggregate' | 'nodes' | services_aggregateKeySpecifier)[];
export type services_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type services_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | services_aggregate_fieldsKeySpecifier)[];
export type services_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type services_avg_fieldsKeySpecifier = ('duration' | 'maxBookings' | 'offTime' | services_avg_fieldsKeySpecifier)[];
export type services_avg_fieldsFieldPolicy = {
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	maxBookings?: FieldPolicy<any> | FieldReadFunction<any>,
	offTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type services_max_fieldsKeySpecifier = ('color' | 'createdAt' | 'deletedAt' | 'description' | 'duration' | 'id' | 'maxBookings' | 'name' | 'offTime' | 'pictures' | 'providerId' | 'sku' | 'updatedAt' | services_max_fieldsKeySpecifier)[];
export type services_max_fieldsFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maxBookings?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	offTime?: FieldPolicy<any> | FieldReadFunction<any>,
	pictures?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type services_min_fieldsKeySpecifier = ('color' | 'createdAt' | 'deletedAt' | 'description' | 'duration' | 'id' | 'maxBookings' | 'name' | 'offTime' | 'pictures' | 'providerId' | 'sku' | 'updatedAt' | services_min_fieldsKeySpecifier)[];
export type services_min_fieldsFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maxBookings?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	offTime?: FieldPolicy<any> | FieldReadFunction<any>,
	pictures?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type services_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | services_mutation_responseKeySpecifier)[];
export type services_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type services_stddev_fieldsKeySpecifier = ('duration' | 'maxBookings' | 'offTime' | services_stddev_fieldsKeySpecifier)[];
export type services_stddev_fieldsFieldPolicy = {
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	maxBookings?: FieldPolicy<any> | FieldReadFunction<any>,
	offTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type services_stddev_pop_fieldsKeySpecifier = ('duration' | 'maxBookings' | 'offTime' | services_stddev_pop_fieldsKeySpecifier)[];
export type services_stddev_pop_fieldsFieldPolicy = {
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	maxBookings?: FieldPolicy<any> | FieldReadFunction<any>,
	offTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type services_stddev_samp_fieldsKeySpecifier = ('duration' | 'maxBookings' | 'offTime' | services_stddev_samp_fieldsKeySpecifier)[];
export type services_stddev_samp_fieldsFieldPolicy = {
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	maxBookings?: FieldPolicy<any> | FieldReadFunction<any>,
	offTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type services_sum_fieldsKeySpecifier = ('duration' | 'maxBookings' | 'offTime' | services_sum_fieldsKeySpecifier)[];
export type services_sum_fieldsFieldPolicy = {
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	maxBookings?: FieldPolicy<any> | FieldReadFunction<any>,
	offTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type services_var_pop_fieldsKeySpecifier = ('duration' | 'maxBookings' | 'offTime' | services_var_pop_fieldsKeySpecifier)[];
export type services_var_pop_fieldsFieldPolicy = {
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	maxBookings?: FieldPolicy<any> | FieldReadFunction<any>,
	offTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type services_var_samp_fieldsKeySpecifier = ('duration' | 'maxBookings' | 'offTime' | services_var_samp_fieldsKeySpecifier)[];
export type services_var_samp_fieldsFieldPolicy = {
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	maxBookings?: FieldPolicy<any> | FieldReadFunction<any>,
	offTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type services_variance_fieldsKeySpecifier = ('duration' | 'maxBookings' | 'offTime' | services_variance_fieldsKeySpecifier)[];
export type services_variance_fieldsFieldPolicy = {
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	maxBookings?: FieldPolicy<any> | FieldReadFunction<any>,
	offTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type sessionsKeySpecifier = ('createdAt' | 'id' | 'refreshToken' | 'user' | 'userId' | sessionsKeySpecifier)[];
export type sessionsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type sessions_aggregateKeySpecifier = ('aggregate' | 'nodes' | sessions_aggregateKeySpecifier)[];
export type sessions_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type sessions_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | sessions_aggregate_fieldsKeySpecifier)[];
export type sessions_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type sessions_max_fieldsKeySpecifier = ('createdAt' | 'id' | 'refreshToken' | 'userId' | sessions_max_fieldsKeySpecifier)[];
export type sessions_max_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type sessions_min_fieldsKeySpecifier = ('createdAt' | 'id' | 'refreshToken' | 'userId' | sessions_min_fieldsKeySpecifier)[];
export type sessions_min_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type sessions_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | sessions_mutation_responseKeySpecifier)[];
export type sessions_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type subscription_rootKeySpecifier = ('appointmentPricing' | 'appointmentPricing_aggregate' | 'appointmentPricing_by_pk' | 'appointmentPricing_stream' | 'appointments' | 'appointments_aggregate' | 'appointments_by_pk' | 'appointments_stream' | 'bookingStatus' | 'bookingStatus_aggregate' | 'bookingStatus_by_pk' | 'bookingStatus_stream' | 'buildingProviders' | 'buildingProviders_aggregate' | 'buildingProviders_by_pk' | 'buildingProviders_stream' | 'buildingType' | 'buildingType_aggregate' | 'buildingType_by_pk' | 'buildingType_stream' | 'checkoutSessions' | 'checkoutSessions_aggregate' | 'checkoutSessions_by_pk' | 'checkoutSessions_stream' | 'currencies' | 'currencies_aggregate' | 'currencies_by_pk' | 'currencies_stream' | 'customerAmountSpent' | 'customerAmountSpent_aggregate' | 'customerAmountSpent_stream' | 'customers' | 'customers_aggregate' | 'customers_by_pk' | 'customers_stream' | 'entityType' | 'entityType_aggregate' | 'entityType_by_pk' | 'entityType_stream' | 'files' | 'files_aggregate' | 'files_by_pk' | 'files_stream' | 'form' | 'formAnswers' | 'formAnswers_aggregate' | 'formAnswers_by_pk' | 'formAnswers_stream' | 'formQuestionOptions' | 'formQuestionOptions_aggregate' | 'formQuestionOptions_by_pk' | 'formQuestionOptions_stream' | 'formQuestionType' | 'formQuestionType_aggregate' | 'formQuestionType_by_pk' | 'formQuestionType_stream' | 'formQuestions' | 'formQuestions_aggregate' | 'formQuestions_by_pk' | 'formQuestions_stream' | 'form_aggregate' | 'form_by_pk' | 'form_stream' | 'get_nearby_locations' | 'get_nearby_locations_aggregate' | 'jobStatus' | 'jobStatus_aggregate' | 'jobStatus_by_pk' | 'jobStatus_stream' | 'locale' | 'locale_aggregate' | 'locale_by_pk' | 'locale_stream' | 'locationStatus' | 'locationStatus_aggregate' | 'locationStatus_by_pk' | 'locationStatus_stream' | 'locationType' | 'locationType_aggregate' | 'locationType_by_pk' | 'locationType_stream' | 'locations' | 'locations_aggregate' | 'locations_by_pk' | 'locations_stream' | 'locations_with_distance' | 'locations_with_distance_aggregate' | 'locations_with_distance_stream' | 'notificationType' | 'notificationType_aggregate' | 'notificationType_by_pk' | 'notificationType_stream' | 'notifications' | 'notifications_aggregate' | 'notifications_by_pk' | 'notifications_stream' | 'partnershipSchedulingType' | 'partnershipSchedulingType_aggregate' | 'partnershipSchedulingType_by_pk' | 'partnershipSchedulingType_stream' | 'partnershipStatus' | 'partnershipStatus_aggregate' | 'partnershipStatus_by_pk' | 'partnershipStatus_stream' | 'paymentFormat' | 'paymentFormat_aggregate' | 'paymentFormat_by_pk' | 'paymentFormat_stream' | 'paymentStatus' | 'paymentStatus_aggregate' | 'paymentStatus_by_pk' | 'paymentStatus_stream' | 'payments' | 'payments_aggregate' | 'payments_by_pk' | 'payments_stream' | 'providerCategory' | 'providerCategory_aggregate' | 'providerCategory_by_pk' | 'providerCategory_stream' | 'providerMonthlyPayments' | 'providerMonthlyPayments_aggregate' | 'providerMonthlyPayments_by_pk' | 'providerMonthlyPayments_stream' | 'providerPictures' | 'providerPictures_aggregate' | 'providerPictures_by_pk' | 'providerPictures_stream' | 'providerRole' | 'providerRole_aggregate' | 'providerRole_by_pk' | 'providerRole_stream' | 'providerStatus' | 'providerStatus_aggregate' | 'providerStatus_by_pk' | 'providerStatus_stream' | 'providerType' | 'providerType_aggregate' | 'providerType_by_pk' | 'providerType_stream' | 'providerVisibility' | 'providerVisibility_aggregate' | 'providerVisibility_by_pk' | 'providerVisibility_stream' | 'providers' | 'providers_aggregate' | 'providers_by_pk' | 'providers_stream' | 'refunds' | 'refunds_aggregate' | 'refunds_by_pk' | 'refunds_stream' | 'relationshipStatus' | 'relationshipStatus_aggregate' | 'relationshipStatus_by_pk' | 'relationshipStatus_stream' | 'schedule' | 'schedule_aggregate' | 'schedule_by_pk' | 'schedule_stream' | 'serviceEmployees' | 'serviceEmployees_aggregate' | 'serviceEmployees_by_pk' | 'serviceEmployees_stream' | 'serviceFormStatus' | 'serviceFormStatus_aggregate' | 'serviceFormStatus_by_pk' | 'serviceFormStatus_stream' | 'serviceOptionAnswers' | 'serviceOptionAnswers_aggregate' | 'serviceOptionAnswers_by_pk' | 'serviceOptionAnswers_stream' | 'serviceOptionSection' | 'serviceOptionSectionOptions' | 'serviceOptionSectionOptions_aggregate' | 'serviceOptionSectionOptions_by_pk' | 'serviceOptionSectionOptions_stream' | 'serviceOptionSection_aggregate' | 'serviceOptionSection_by_pk' | 'serviceOptionSection_stream' | 'serviceOptions' | 'serviceOptionsStatus' | 'serviceOptionsStatus_aggregate' | 'serviceOptionsStatus_by_pk' | 'serviceOptionsStatus_stream' | 'serviceOptions_aggregate' | 'serviceOptions_by_pk' | 'serviceOptions_stream' | 'servicePictures' | 'servicePictures_aggregate' | 'servicePictures_by_pk' | 'servicePictures_stream' | 'servicePricings' | 'servicePricings_aggregate' | 'servicePricings_by_pk' | 'servicePricings_stream' | 'serviceSectionOptionQuantityType' | 'serviceSectionOptionQuantityType_aggregate' | 'serviceSectionOptionQuantityType_by_pk' | 'serviceSectionOptionQuantityType_stream' | 'serviceSectionOptionType' | 'serviceSectionOptionType_aggregate' | 'serviceSectionOptionType_by_pk' | 'serviceSectionOptionType_stream' | 'serviceStatus' | 'serviceStatus_aggregate' | 'serviceStatus_by_pk' | 'serviceStatus_stream' | 'services' | 'servicesForms' | 'servicesForms_aggregate' | 'servicesForms_by_pk' | 'servicesForms_stream' | 'services_aggregate' | 'services_by_pk' | 'services_stream' | 'sessions' | 'sessions_aggregate' | 'sessions_by_pk' | 'sessions_stream' | 'timeouts' | 'timeouts_aggregate' | 'timeouts_by_pk' | 'timeouts_stream' | 'transitionStatus' | 'transitionStatus_aggregate' | 'transitionStatus_by_pk' | 'transitionStatus_stream' | 'unavailableServiceLocations' | 'unavailableServiceLocations_aggregate' | 'unavailableServiceLocations_by_pk' | 'unavailableServiceLocations_stream' | 'userRole' | 'userRole_aggregate' | 'userRole_by_pk' | 'userRole_stream' | 'userRoles' | 'userRoles_aggregate' | 'userRoles_by_pk' | 'userRoles_stream' | 'users' | 'users_aggregate' | 'users_by_pk' | 'users_stream' | subscription_rootKeySpecifier)[];
export type subscription_rootFieldPolicy = {
	appointmentPricing?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentPricing_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentPricing_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentPricing_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	appointments?: FieldPolicy<any> | FieldReadFunction<any>,
	appointments_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	appointments_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	appointments_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	bookingStatus_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingProviders_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingProviders_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingProviders_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingType?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingType_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingType_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutSessions?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutSessions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutSessions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutSessions_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	currencies?: FieldPolicy<any> | FieldReadFunction<any>,
	currencies_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	currencies_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	currencies_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	customerAmountSpent?: FieldPolicy<any> | FieldReadFunction<any>,
	customerAmountSpent_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	customerAmountSpent_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	customers?: FieldPolicy<any> | FieldReadFunction<any>,
	customers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	customers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	customers_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	entityType?: FieldPolicy<any> | FieldReadFunction<any>,
	entityType_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	entityType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	entityType_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	files_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	files_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	files_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	form?: FieldPolicy<any> | FieldReadFunction<any>,
	formAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	formAnswers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	formAnswers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	formAnswers_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionOptions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionOptions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionOptions_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionType?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionType_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestionType_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	formQuestions_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	form_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	form_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	form_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	get_nearby_locations?: FieldPolicy<any> | FieldReadFunction<any>,
	get_nearby_locations_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	jobStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	jobStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	jobStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	jobStatus_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	locale_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	locale_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	locale_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	locationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	locationStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	locationStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	locationStatus_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	locationType?: FieldPolicy<any> | FieldReadFunction<any>,
	locationType_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	locationType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	locationType_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	locations?: FieldPolicy<any> | FieldReadFunction<any>,
	locations_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	locations_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	locations_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	locations_with_distance?: FieldPolicy<any> | FieldReadFunction<any>,
	locations_with_distance_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	locations_with_distance_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationType?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationType_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationType_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	partnershipSchedulingType?: FieldPolicy<any> | FieldReadFunction<any>,
	partnershipSchedulingType_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	partnershipSchedulingType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	partnershipSchedulingType_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	partnershipStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	partnershipStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	partnershipStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	partnershipStatus_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentFormat_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentFormat_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentFormat_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	payments?: FieldPolicy<any> | FieldReadFunction<any>,
	payments_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	payments_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	payments_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	providerCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	providerCategory_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providerCategory_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	providerCategory_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	providerMonthlyPayments?: FieldPolicy<any> | FieldReadFunction<any>,
	providerMonthlyPayments_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providerMonthlyPayments_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	providerMonthlyPayments_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	providerPictures?: FieldPolicy<any> | FieldReadFunction<any>,
	providerPictures_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providerPictures_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	providerPictures_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	providerRole?: FieldPolicy<any> | FieldReadFunction<any>,
	providerRole_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providerRole_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	providerRole_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	providerStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	providerStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providerStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	providerStatus_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	providerType?: FieldPolicy<any> | FieldReadFunction<any>,
	providerType_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providerType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	providerType_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	providerVisibility?: FieldPolicy<any> | FieldReadFunction<any>,
	providerVisibility_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providerVisibility_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	providerVisibility_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	providers?: FieldPolicy<any> | FieldReadFunction<any>,
	providers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	providers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	providers_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	refunds?: FieldPolicy<any> | FieldReadFunction<any>,
	refunds_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	refunds_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	refunds_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	relationshipStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	relationshipStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	relationshipStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	relationshipStatus_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	schedule?: FieldPolicy<any> | FieldReadFunction<any>,
	schedule_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	schedule_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	schedule_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceEmployees?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceEmployees_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceEmployees_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceEmployees_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceFormStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceFormStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceFormStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceFormStatus_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionAnswers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionAnswers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionAnswers_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSection?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSectionOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSectionOptions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSectionOptions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSectionOptions_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSection_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSection_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionSection_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionsStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionsStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionsStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptionsStatus_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceOptions_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePictures?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePictures_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePictures_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePictures_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePricings?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePricings_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePricings_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePricings_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceSectionOptionQuantityType?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceSectionOptionQuantityType_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceSectionOptionQuantityType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceSectionOptionQuantityType_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceSectionOptionType?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceSectionOptionType_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceSectionOptionType_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceSectionOptionType_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceStatus_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	services?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesForms?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesForms_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesForms_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesForms_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	services_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	services_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	services_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	timeouts?: FieldPolicy<any> | FieldReadFunction<any>,
	timeouts_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	timeouts_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	timeouts_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	transitionStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	transitionStatus_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	transitionStatus_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	transitionStatus_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	unavailableServiceLocations?: FieldPolicy<any> | FieldReadFunction<any>,
	unavailableServiceLocations_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	unavailableServiceLocations_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	unavailableServiceLocations_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	userRole?: FieldPolicy<any> | FieldReadFunction<any>,
	userRole_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	userRole_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	userRole_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	userRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	userRoles_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	userRoles_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	userRoles_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	users_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	users_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	users_stream?: FieldPolicy<any> | FieldReadFunction<any>
};
export type timeoutsKeySpecifier = ('createdAt' | 'endDate' | 'id' | 'location' | 'locationId' | 'service' | 'serviceId' | 'startDate' | 'updatedAt' | 'user' | 'userId' | timeoutsKeySpecifier)[];
export type timeoutsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type timeouts_aggregateKeySpecifier = ('aggregate' | 'nodes' | timeouts_aggregateKeySpecifier)[];
export type timeouts_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type timeouts_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | timeouts_aggregate_fieldsKeySpecifier)[];
export type timeouts_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type timeouts_max_fieldsKeySpecifier = ('createdAt' | 'endDate' | 'id' | 'locationId' | 'serviceId' | 'startDate' | 'updatedAt' | 'userId' | timeouts_max_fieldsKeySpecifier)[];
export type timeouts_max_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type timeouts_min_fieldsKeySpecifier = ('createdAt' | 'endDate' | 'id' | 'locationId' | 'serviceId' | 'startDate' | 'updatedAt' | 'userId' | timeouts_min_fieldsKeySpecifier)[];
export type timeouts_min_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type timeouts_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | timeouts_mutation_responseKeySpecifier)[];
export type timeouts_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type transitionStatusKeySpecifier = ('value' | transitionStatusKeySpecifier)[];
export type transitionStatusFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type transitionStatus_aggregateKeySpecifier = ('aggregate' | 'nodes' | transitionStatus_aggregateKeySpecifier)[];
export type transitionStatus_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type transitionStatus_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | transitionStatus_aggregate_fieldsKeySpecifier)[];
export type transitionStatus_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type transitionStatus_max_fieldsKeySpecifier = ('value' | transitionStatus_max_fieldsKeySpecifier)[];
export type transitionStatus_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type transitionStatus_min_fieldsKeySpecifier = ('value' | transitionStatus_min_fieldsKeySpecifier)[];
export type transitionStatus_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type transitionStatus_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | transitionStatus_mutation_responseKeySpecifier)[];
export type transitionStatus_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type unavailableServiceLocationsKeySpecifier = ('createdAt' | 'id' | 'location' | 'locationId' | 'service' | 'serviceId' | 'updatedAt' | unavailableServiceLocationsKeySpecifier)[];
export type unavailableServiceLocationsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type unavailableServiceLocations_aggregateKeySpecifier = ('aggregate' | 'nodes' | unavailableServiceLocations_aggregateKeySpecifier)[];
export type unavailableServiceLocations_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type unavailableServiceLocations_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | unavailableServiceLocations_aggregate_fieldsKeySpecifier)[];
export type unavailableServiceLocations_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type unavailableServiceLocations_max_fieldsKeySpecifier = ('createdAt' | 'id' | 'locationId' | 'serviceId' | 'updatedAt' | unavailableServiceLocations_max_fieldsKeySpecifier)[];
export type unavailableServiceLocations_max_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type unavailableServiceLocations_min_fieldsKeySpecifier = ('createdAt' | 'id' | 'locationId' | 'serviceId' | 'updatedAt' | unavailableServiceLocations_min_fieldsKeySpecifier)[];
export type unavailableServiceLocations_min_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type unavailableServiceLocations_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | unavailableServiceLocations_mutation_responseKeySpecifier)[];
export type unavailableServiceLocations_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type userRoleKeySpecifier = ('userRoles' | 'userRoles_aggregate' | 'value' | userRoleKeySpecifier)[];
export type userRoleFieldPolicy = {
	userRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	userRoles_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type userRole_aggregateKeySpecifier = ('aggregate' | 'nodes' | userRole_aggregateKeySpecifier)[];
export type userRole_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type userRole_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | userRole_aggregate_fieldsKeySpecifier)[];
export type userRole_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type userRole_max_fieldsKeySpecifier = ('value' | userRole_max_fieldsKeySpecifier)[];
export type userRole_max_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type userRole_min_fieldsKeySpecifier = ('value' | userRole_min_fieldsKeySpecifier)[];
export type userRole_min_fieldsFieldPolicy = {
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type userRole_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | userRole_mutation_responseKeySpecifier)[];
export type userRole_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type userRolesKeySpecifier = ('calendarId' | 'createdAt' | 'deletedAt' | 'provider' | 'providerId' | 'role' | 'updatedAt' | 'user' | 'userId' | 'userRole' | userRolesKeySpecifier)[];
export type userRolesFieldPolicy = {
	calendarId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>,
	userRole?: FieldPolicy<any> | FieldReadFunction<any>
};
export type userRoles_aggregateKeySpecifier = ('aggregate' | 'nodes' | userRoles_aggregateKeySpecifier)[];
export type userRoles_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type userRoles_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | userRoles_aggregate_fieldsKeySpecifier)[];
export type userRoles_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type userRoles_max_fieldsKeySpecifier = ('calendarId' | 'createdAt' | 'deletedAt' | 'providerId' | 'updatedAt' | 'userId' | userRoles_max_fieldsKeySpecifier)[];
export type userRoles_max_fieldsFieldPolicy = {
	calendarId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type userRoles_min_fieldsKeySpecifier = ('calendarId' | 'createdAt' | 'deletedAt' | 'providerId' | 'updatedAt' | 'userId' | userRoles_min_fieldsKeySpecifier)[];
export type userRoles_min_fieldsFieldPolicy = {
	calendarId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type userRoles_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | userRoles_mutation_responseKeySpecifier)[];
export type userRoles_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type usersKeySpecifier = ('address' | 'apartmentNumber' | 'appointmentsByEmployeeid' | 'appointmentsByEmployeeid_aggregate' | 'coordinates' | 'createdAt' | 'customers' | 'customers_aggregate' | 'email' | 'file' | 'id' | 'isEmailVerified' | 'isPhoneNumberVerified' | 'locale' | 'location' | 'name' | 'notifications' | 'notificationsByUserid' | 'notificationsByUserid_aggregate' | 'password' | 'phoneNumber' | 'profilePicture' | 'profilePictureFileId' | 'schedules' | 'schedulesByEmployeeid' | 'schedulesByEmployeeid_aggregate' | 'sentNotifications' | 'sentNotifications_aggregate' | 'serviceEmployees' | 'serviceEmployeesByUserid' | 'serviceEmployeesByUserid_aggregate' | 'sessions' | 'sessionsByUserid' | 'sessionsByUserid_aggregate' | 'stripeCustomerId' | 'stripePaymentMethodId' | 'timeouts' | 'timeoutsByUserid' | 'timeoutsByUserid_aggregate' | 'updatedAt' | 'userRole' | usersKeySpecifier)[];
export type usersFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	apartmentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentsByEmployeeid?: FieldPolicy<any> | FieldReadFunction<any>,
	appointmentsByEmployeeid_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	coordinates?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	customers?: FieldPolicy<any> | FieldReadFunction<any>,
	customers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isEmailVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	isPhoneNumberVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationsByUserid?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationsByUserid_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	password?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePicture?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePictureFileId?: FieldPolicy<any> | FieldReadFunction<any>,
	schedules?: FieldPolicy<any> | FieldReadFunction<any>,
	schedulesByEmployeeid?: FieldPolicy<any> | FieldReadFunction<any>,
	schedulesByEmployeeid_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	sentNotifications?: FieldPolicy<any> | FieldReadFunction<any>,
	sentNotifications_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceEmployees?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceEmployeesByUserid?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceEmployeesByUserid_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionsByUserid?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionsByUserid_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripePaymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	timeouts?: FieldPolicy<any> | FieldReadFunction<any>,
	timeoutsByUserid?: FieldPolicy<any> | FieldReadFunction<any>,
	timeoutsByUserid_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userRole?: FieldPolicy<any> | FieldReadFunction<any>
};
export type users_aggregateKeySpecifier = ('aggregate' | 'nodes' | users_aggregateKeySpecifier)[];
export type users_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type users_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | users_aggregate_fieldsKeySpecifier)[];
export type users_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type users_max_fieldsKeySpecifier = ('address' | 'apartmentNumber' | 'createdAt' | 'email' | 'id' | 'name' | 'password' | 'phoneNumber' | 'profilePictureFileId' | 'stripeCustomerId' | 'stripePaymentMethodId' | 'updatedAt' | users_max_fieldsKeySpecifier)[];
export type users_max_fieldsFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	apartmentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	password?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePictureFileId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripePaymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type users_min_fieldsKeySpecifier = ('address' | 'apartmentNumber' | 'createdAt' | 'email' | 'id' | 'name' | 'password' | 'phoneNumber' | 'profilePictureFileId' | 'stripeCustomerId' | 'stripePaymentMethodId' | 'updatedAt' | users_min_fieldsKeySpecifier)[];
export type users_min_fieldsFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	apartmentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	password?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	profilePictureFileId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>,
	stripePaymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type users_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | users_mutation_responseKeySpecifier)[];
export type users_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	AccountLinkDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountLinkDtoKeySpecifier | (() => undefined | AccountLinkDtoKeySpecifier),
		fields?: AccountLinkDtoFieldPolicy,
	},
	AdminCustomerListDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminCustomerListDtoKeySpecifier | (() => undefined | AdminCustomerListDtoKeySpecifier),
		fields?: AdminCustomerListDtoFieldPolicy,
	},
	Aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AggregateKeySpecifier | (() => undefined | AggregateKeySpecifier),
		fields?: AggregateFieldPolicy,
	},
	AggregateSum?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AggregateSumKeySpecifier | (() => undefined | AggregateSumKeySpecifier),
		fields?: AggregateSumFieldPolicy,
	},
	Amount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AmountKeySpecifier | (() => undefined | AmountKeySpecifier),
		fields?: AmountFieldPolicy,
	},
	Appointment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppointmentKeySpecifier | (() => undefined | AppointmentKeySpecifier),
		fields?: AppointmentFieldPolicy,
	},
	AppointmentLocationDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppointmentLocationDtoKeySpecifier | (() => undefined | AppointmentLocationDtoKeySpecifier),
		fields?: AppointmentLocationDtoFieldPolicy,
	},
	AppointmentServiceDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppointmentServiceDtoKeySpecifier | (() => undefined | AppointmentServiceDtoKeySpecifier),
		fields?: AppointmentServiceDtoFieldPolicy,
	},
	AvailableAppointmentDateTimeSlotsDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AvailableAppointmentDateTimeSlotsDtoKeySpecifier | (() => undefined | AvailableAppointmentDateTimeSlotsDtoKeySpecifier),
		fields?: AvailableAppointmentDateTimeSlotsDtoFieldPolicy,
	},
	BuildingManagerCustomerListDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BuildingManagerCustomerListDtoKeySpecifier | (() => undefined | BuildingManagerCustomerListDtoKeySpecifier),
		fields?: BuildingManagerCustomerListDtoFieldPolicy,
	},
	BuildingManagerCustomerListEntryDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BuildingManagerCustomerListEntryDtoKeySpecifier | (() => undefined | BuildingManagerCustomerListEntryDtoKeySpecifier),
		fields?: BuildingManagerCustomerListEntryDtoFieldPolicy,
	},
	BuildingManagerCustomerWithAppointmentsDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BuildingManagerCustomerWithAppointmentsDtoKeySpecifier | (() => undefined | BuildingManagerCustomerWithAppointmentsDtoKeySpecifier),
		fields?: BuildingManagerCustomerWithAppointmentsDtoFieldPolicy,
	},
	CalendarListEntryDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CalendarListEntryDtoKeySpecifier | (() => undefined | CalendarListEntryDtoKeySpecifier),
		fields?: CalendarListEntryDtoFieldPolicy,
	},
	CheckoutSesssionDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutSesssionDtoKeySpecifier | (() => undefined | CheckoutSesssionDtoKeySpecifier),
		fields?: CheckoutSesssionDtoFieldPolicy,
	},
	CompanyAddressDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CompanyAddressDtoKeySpecifier | (() => undefined | CompanyAddressDtoKeySpecifier),
		fields?: CompanyAddressDtoFieldPolicy,
	},
	Count?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CountKeySpecifier | (() => undefined | CountKeySpecifier),
		fields?: CountFieldPolicy,
	},
	CreateAppointmentPaymentIntentDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateAppointmentPaymentIntentDtoKeySpecifier | (() => undefined | CreateAppointmentPaymentIntentDtoKeySpecifier),
		fields?: CreateAppointmentPaymentIntentDtoFieldPolicy,
	},
	CreateApptBM?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateApptBMKeySpecifier | (() => undefined | CreateApptBMKeySpecifier),
		fields?: CreateApptBMFieldPolicy,
	},
	CreateApptSP?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateApptSPKeySpecifier | (() => undefined | CreateApptSPKeySpecifier),
		fields?: CreateApptSPFieldPolicy,
	},
	CreateApptSPService?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateApptSPServiceKeySpecifier | (() => undefined | CreateApptSPServiceKeySpecifier),
		fields?: CreateApptSPServiceFieldPolicy,
	},
	CreateApptUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateApptUserKeySpecifier | (() => undefined | CreateApptUserKeySpecifier),
		fields?: CreateApptUserFieldPolicy,
	},
	CreateBookedAppointmentPaymentIntentDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateBookedAppointmentPaymentIntentDtoKeySpecifier | (() => undefined | CreateBookedAppointmentPaymentIntentDtoKeySpecifier),
		fields?: CreateBookedAppointmentPaymentIntentDtoFieldPolicy,
	},
	CreateEmployeeDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateEmployeeDtoKeySpecifier | (() => undefined | CreateEmployeeDtoKeySpecifier),
		fields?: CreateEmployeeDtoFieldPolicy,
	},
	Customer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerKeySpecifier | (() => undefined | CustomerKeySpecifier),
		fields?: CustomerFieldPolicy,
	},
	CustomerAppointmentData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerAppointmentDataKeySpecifier | (() => undefined | CustomerAppointmentDataKeySpecifier),
		fields?: CustomerAppointmentDataFieldPolicy,
	},
	CustomerCardDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerCardDtoKeySpecifier | (() => undefined | CustomerCardDtoKeySpecifier),
		fields?: CustomerCardDtoFieldPolicy,
	},
	CustomerEntryDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerEntryDtoKeySpecifier | (() => undefined | CustomerEntryDtoKeySpecifier),
		fields?: CustomerEntryDtoFieldPolicy,
	},
	CustomerServices?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerServicesKeySpecifier | (() => undefined | CustomerServicesKeySpecifier),
		fields?: CustomerServicesFieldPolicy,
	},
	CustomerServicesProvider?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerServicesProviderKeySpecifier | (() => undefined | CustomerServicesProviderKeySpecifier),
		fields?: CustomerServicesProviderFieldPolicy,
	},
	CustomerServicesService?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerServicesServiceKeySpecifier | (() => undefined | CustomerServicesServiceKeySpecifier),
		fields?: CustomerServicesServiceFieldPolicy,
	},
	CustomerUserDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerUserDtoKeySpecifier | (() => undefined | CustomerUserDtoKeySpecifier),
		fields?: CustomerUserDtoFieldPolicy,
	},
	DeleteCustomerPaymentMethodDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteCustomerPaymentMethodDtoKeySpecifier | (() => undefined | DeleteCustomerPaymentMethodDtoKeySpecifier),
		fields?: DeleteCustomerPaymentMethodDtoFieldPolicy,
	},
	DeleteFileDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteFileDtoKeySpecifier | (() => undefined | DeleteFileDtoKeySpecifier),
		fields?: DeleteFileDtoFieldPolicy,
	},
	DeletePaymentMethodDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeletePaymentMethodDtoKeySpecifier | (() => undefined | DeletePaymentMethodDtoKeySpecifier),
		fields?: DeletePaymentMethodDtoFieldPolicy,
	},
	Employee?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmployeeKeySpecifier | (() => undefined | EmployeeKeySpecifier),
		fields?: EmployeeFieldPolicy,
	},
	ExportAppointmentBase64?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExportAppointmentBase64KeySpecifier | (() => undefined | ExportAppointmentBase64KeySpecifier),
		fields?: ExportAppointmentBase64FieldPolicy,
	},
	GeographyCoordinates?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GeographyCoordinatesKeySpecifier | (() => undefined | GeographyCoordinatesKeySpecifier),
		fields?: GeographyCoordinatesFieldPolicy,
	},
	GetAppointmentPaymentDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetAppointmentPaymentDetailsKeySpecifier | (() => undefined | GetAppointmentPaymentDetailsKeySpecifier),
		fields?: GetAppointmentPaymentDetailsFieldPolicy,
	},
	GetUpfrontAppointmentDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetUpfrontAppointmentDetailsKeySpecifier | (() => undefined | GetUpfrontAppointmentDetailsKeySpecifier),
		fields?: GetUpfrontAppointmentDetailsFieldPolicy,
	},
	GetUpfrontAppointmentDetailsData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetUpfrontAppointmentDetailsDataKeySpecifier | (() => undefined | GetUpfrontAppointmentDetailsDataKeySpecifier),
		fields?: GetUpfrontAppointmentDetailsDataFieldPolicy,
	},
	GetUpfrontAppointmentDetailsDataDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetUpfrontAppointmentDetailsDataDetailsKeySpecifier | (() => undefined | GetUpfrontAppointmentDetailsDataDetailsKeySpecifier),
		fields?: GetUpfrontAppointmentDetailsDataDetailsFieldPolicy,
	},
	GetUpfrontAppointmentDetailsDataPayPrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetUpfrontAppointmentDetailsDataPayPriceKeySpecifier | (() => undefined | GetUpfrontAppointmentDetailsDataPayPriceKeySpecifier),
		fields?: GetUpfrontAppointmentDetailsDataPayPriceFieldPolicy,
	},
	GetUpfrontAppointmentDetailsDataPrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetUpfrontAppointmentDetailsDataPriceKeySpecifier | (() => undefined | GetUpfrontAppointmentDetailsDataPriceKeySpecifier),
		fields?: GetUpfrontAppointmentDetailsDataPriceFieldPolicy,
	},
	GetUpfrontAppointmentDetailsDataPriceOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetUpfrontAppointmentDetailsDataPriceOptionsKeySpecifier | (() => undefined | GetUpfrontAppointmentDetailsDataPriceOptionsKeySpecifier),
		fields?: GetUpfrontAppointmentDetailsDataPriceOptionsFieldPolicy,
	},
	GetUpfrontAppointmentDetailsDataPriceService?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetUpfrontAppointmentDetailsDataPriceServiceKeySpecifier | (() => undefined | GetUpfrontAppointmentDetailsDataPriceServiceKeySpecifier),
		fields?: GetUpfrontAppointmentDetailsDataPriceServiceFieldPolicy,
	},
	GetUpfrontAppointmentDetailsErrors?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetUpfrontAppointmentDetailsErrorsKeySpecifier | (() => undefined | GetUpfrontAppointmentDetailsErrorsKeySpecifier),
		fields?: GetUpfrontAppointmentDetailsErrorsFieldPolicy,
	},
	HaversineDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HaversineDtoKeySpecifier | (() => undefined | HaversineDtoKeySpecifier),
		fields?: HaversineDtoFieldPolicy,
	},
	Location?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocationKeySpecifier | (() => undefined | LocationKeySpecifier),
		fields?: LocationFieldPolicy,
	},
	LocationBuildingManager?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocationBuildingManagerKeySpecifier | (() => undefined | LocationBuildingManagerKeySpecifier),
		fields?: LocationBuildingManagerFieldPolicy,
	},
	LocationBuildingProvider?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocationBuildingProviderKeySpecifier | (() => undefined | LocationBuildingProviderKeySpecifier),
		fields?: LocationBuildingProviderFieldPolicy,
	},
	LocationDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocationDtoKeySpecifier | (() => undefined | LocationDtoKeySpecifier),
		fields?: LocationDtoFieldPolicy,
	},
	LocationWithDistance?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocationWithDistanceKeySpecifier | (() => undefined | LocationWithDistanceKeySpecifier),
		fields?: LocationWithDistanceFieldPolicy,
	},
	LogoutDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LogoutDtoKeySpecifier | (() => undefined | LogoutDtoKeySpecifier),
		fields?: LogoutDtoFieldPolicy,
	},
	OnboardingCompletedDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OnboardingCompletedDtoKeySpecifier | (() => undefined | OnboardingCompletedDtoKeySpecifier),
		fields?: OnboardingCompletedDtoFieldPolicy,
	},
	PartnershipDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PartnershipDtoKeySpecifier | (() => undefined | PartnershipDtoKeySpecifier),
		fields?: PartnershipDtoFieldPolicy,
	},
	Payment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentKeySpecifier | (() => undefined | PaymentKeySpecifier),
		fields?: PaymentFieldPolicy,
	},
	PayoutDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayoutDtoKeySpecifier | (() => undefined | PayoutDtoKeySpecifier),
		fields?: PayoutDtoFieldPolicy,
	},
	PayoutsDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayoutsDtoKeySpecifier | (() => undefined | PayoutsDtoKeySpecifier),
		fields?: PayoutsDtoFieldPolicy,
	},
	PayoutsScheduleDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayoutsScheduleDtoKeySpecifier | (() => undefined | PayoutsScheduleDtoKeySpecifier),
		fields?: PayoutsScheduleDtoFieldPolicy,
	},
	ProfilePicture?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProfilePictureKeySpecifier | (() => undefined | ProfilePictureKeySpecifier),
		fields?: ProfilePictureFieldPolicy,
	},
	ProfilePictureDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProfilePictureDtoKeySpecifier | (() => undefined | ProfilePictureDtoKeySpecifier),
		fields?: ProfilePictureDtoFieldPolicy,
	},
	Provider?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProviderKeySpecifier | (() => undefined | ProviderKeySpecifier),
		fields?: ProviderFieldPolicy,
	},
	ProviderPaymentDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProviderPaymentDtoKeySpecifier | (() => undefined | ProviderPaymentDtoKeySpecifier),
		fields?: ProviderPaymentDtoFieldPolicy,
	},
	ProviderPaymentsDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProviderPaymentsDtoKeySpecifier | (() => undefined | ProviderPaymentsDtoKeySpecifier),
		fields?: ProviderPaymentsDtoFieldPolicy,
	},
	ProviderVisibilityDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProviderVisibilityDtoKeySpecifier | (() => undefined | ProviderVisibilityDtoKeySpecifier),
		fields?: ProviderVisibilityDtoFieldPolicy,
	},
	ProviderVisibilityStatusDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProviderVisibilityStatusDtoKeySpecifier | (() => undefined | ProviderVisibilityStatusDtoKeySpecifier),
		fields?: ProviderVisibilityStatusDtoFieldPolicy,
	},
	ServiceProviderDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServiceProviderDtoKeySpecifier | (() => undefined | ServiceProviderDtoKeySpecifier),
		fields?: ServiceProviderDtoFieldPolicy,
	},
	SessionUserId?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SessionUserIdKeySpecifier | (() => undefined | SessionUserIdKeySpecifier),
		fields?: SessionUserIdFieldPolicy,
	},
	SetupCustomerIntentDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SetupCustomerIntentDtoKeySpecifier | (() => undefined | SetupCustomerIntentDtoKeySpecifier),
		fields?: SetupCustomerIntentDtoFieldPolicy,
	},
	SetupIntentDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SetupIntentDtoKeySpecifier | (() => undefined | SetupIntentDtoKeySpecifier),
		fields?: SetupIntentDtoFieldPolicy,
	},
	Sum?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SumKeySpecifier | (() => undefined | SumKeySpecifier),
		fields?: SumFieldPolicy,
	},
	TimeSlotDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TimeSlotDtoKeySpecifier | (() => undefined | TimeSlotDtoKeySpecifier),
		fields?: TimeSlotDtoFieldPolicy,
	},
	UploadFileUrlDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadFileUrlDtoKeySpecifier | (() => undefined | UploadFileUrlDtoKeySpecifier),
		fields?: UploadFileUrlDtoFieldPolicy,
	},
	User?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier),
		fields?: UserFieldPolicy,
	},
	UserRolesEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserRolesEntityKeySpecifier | (() => undefined | UserRolesEntityKeySpecifier),
		fields?: UserRolesEntityFieldPolicy,
	},
	UserSessionDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserSessionDtoKeySpecifier | (() => undefined | UserSessionDtoKeySpecifier),
		fields?: UserSessionDtoFieldPolicy,
	},
	UserWithoutPassword?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserWithoutPasswordKeySpecifier | (() => undefined | UserWithoutPasswordKeySpecifier),
		fields?: UserWithoutPasswordFieldPolicy,
	},
	ValidateService?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ValidateServiceKeySpecifier | (() => undefined | ValidateServiceKeySpecifier),
		fields?: ValidateServiceFieldPolicy,
	},
	appointmentPricing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointmentPricingKeySpecifier | (() => undefined | appointmentPricingKeySpecifier),
		fields?: appointmentPricingFieldPolicy,
	},
	appointmentPricing_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointmentPricing_aggregateKeySpecifier | (() => undefined | appointmentPricing_aggregateKeySpecifier),
		fields?: appointmentPricing_aggregateFieldPolicy,
	},
	appointmentPricing_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointmentPricing_aggregate_fieldsKeySpecifier | (() => undefined | appointmentPricing_aggregate_fieldsKeySpecifier),
		fields?: appointmentPricing_aggregate_fieldsFieldPolicy,
	},
	appointmentPricing_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointmentPricing_avg_fieldsKeySpecifier | (() => undefined | appointmentPricing_avg_fieldsKeySpecifier),
		fields?: appointmentPricing_avg_fieldsFieldPolicy,
	},
	appointmentPricing_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointmentPricing_max_fieldsKeySpecifier | (() => undefined | appointmentPricing_max_fieldsKeySpecifier),
		fields?: appointmentPricing_max_fieldsFieldPolicy,
	},
	appointmentPricing_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointmentPricing_min_fieldsKeySpecifier | (() => undefined | appointmentPricing_min_fieldsKeySpecifier),
		fields?: appointmentPricing_min_fieldsFieldPolicy,
	},
	appointmentPricing_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointmentPricing_mutation_responseKeySpecifier | (() => undefined | appointmentPricing_mutation_responseKeySpecifier),
		fields?: appointmentPricing_mutation_responseFieldPolicy,
	},
	appointmentPricing_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointmentPricing_stddev_fieldsKeySpecifier | (() => undefined | appointmentPricing_stddev_fieldsKeySpecifier),
		fields?: appointmentPricing_stddev_fieldsFieldPolicy,
	},
	appointmentPricing_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointmentPricing_stddev_pop_fieldsKeySpecifier | (() => undefined | appointmentPricing_stddev_pop_fieldsKeySpecifier),
		fields?: appointmentPricing_stddev_pop_fieldsFieldPolicy,
	},
	appointmentPricing_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointmentPricing_stddev_samp_fieldsKeySpecifier | (() => undefined | appointmentPricing_stddev_samp_fieldsKeySpecifier),
		fields?: appointmentPricing_stddev_samp_fieldsFieldPolicy,
	},
	appointmentPricing_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointmentPricing_sum_fieldsKeySpecifier | (() => undefined | appointmentPricing_sum_fieldsKeySpecifier),
		fields?: appointmentPricing_sum_fieldsFieldPolicy,
	},
	appointmentPricing_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointmentPricing_var_pop_fieldsKeySpecifier | (() => undefined | appointmentPricing_var_pop_fieldsKeySpecifier),
		fields?: appointmentPricing_var_pop_fieldsFieldPolicy,
	},
	appointmentPricing_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointmentPricing_var_samp_fieldsKeySpecifier | (() => undefined | appointmentPricing_var_samp_fieldsKeySpecifier),
		fields?: appointmentPricing_var_samp_fieldsFieldPolicy,
	},
	appointmentPricing_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointmentPricing_variance_fieldsKeySpecifier | (() => undefined | appointmentPricing_variance_fieldsKeySpecifier),
		fields?: appointmentPricing_variance_fieldsFieldPolicy,
	},
	appointments?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointmentsKeySpecifier | (() => undefined | appointmentsKeySpecifier),
		fields?: appointmentsFieldPolicy,
	},
	appointments_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointments_aggregateKeySpecifier | (() => undefined | appointments_aggregateKeySpecifier),
		fields?: appointments_aggregateFieldPolicy,
	},
	appointments_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointments_aggregate_fieldsKeySpecifier | (() => undefined | appointments_aggregate_fieldsKeySpecifier),
		fields?: appointments_aggregate_fieldsFieldPolicy,
	},
	appointments_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointments_max_fieldsKeySpecifier | (() => undefined | appointments_max_fieldsKeySpecifier),
		fields?: appointments_max_fieldsFieldPolicy,
	},
	appointments_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointments_min_fieldsKeySpecifier | (() => undefined | appointments_min_fieldsKeySpecifier),
		fields?: appointments_min_fieldsFieldPolicy,
	},
	appointments_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | appointments_mutation_responseKeySpecifier | (() => undefined | appointments_mutation_responseKeySpecifier),
		fields?: appointments_mutation_responseFieldPolicy,
	},
	bookingStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bookingStatusKeySpecifier | (() => undefined | bookingStatusKeySpecifier),
		fields?: bookingStatusFieldPolicy,
	},
	bookingStatus_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bookingStatus_aggregateKeySpecifier | (() => undefined | bookingStatus_aggregateKeySpecifier),
		fields?: bookingStatus_aggregateFieldPolicy,
	},
	bookingStatus_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bookingStatus_aggregate_fieldsKeySpecifier | (() => undefined | bookingStatus_aggregate_fieldsKeySpecifier),
		fields?: bookingStatus_aggregate_fieldsFieldPolicy,
	},
	bookingStatus_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bookingStatus_max_fieldsKeySpecifier | (() => undefined | bookingStatus_max_fieldsKeySpecifier),
		fields?: bookingStatus_max_fieldsFieldPolicy,
	},
	bookingStatus_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bookingStatus_min_fieldsKeySpecifier | (() => undefined | bookingStatus_min_fieldsKeySpecifier),
		fields?: bookingStatus_min_fieldsFieldPolicy,
	},
	bookingStatus_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bookingStatus_mutation_responseKeySpecifier | (() => undefined | bookingStatus_mutation_responseKeySpecifier),
		fields?: bookingStatus_mutation_responseFieldPolicy,
	},
	buildingProviders?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buildingProvidersKeySpecifier | (() => undefined | buildingProvidersKeySpecifier),
		fields?: buildingProvidersFieldPolicy,
	},
	buildingProviders_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buildingProviders_aggregateKeySpecifier | (() => undefined | buildingProviders_aggregateKeySpecifier),
		fields?: buildingProviders_aggregateFieldPolicy,
	},
	buildingProviders_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buildingProviders_aggregate_fieldsKeySpecifier | (() => undefined | buildingProviders_aggregate_fieldsKeySpecifier),
		fields?: buildingProviders_aggregate_fieldsFieldPolicy,
	},
	buildingProviders_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buildingProviders_max_fieldsKeySpecifier | (() => undefined | buildingProviders_max_fieldsKeySpecifier),
		fields?: buildingProviders_max_fieldsFieldPolicy,
	},
	buildingProviders_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buildingProviders_min_fieldsKeySpecifier | (() => undefined | buildingProviders_min_fieldsKeySpecifier),
		fields?: buildingProviders_min_fieldsFieldPolicy,
	},
	buildingProviders_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buildingProviders_mutation_responseKeySpecifier | (() => undefined | buildingProviders_mutation_responseKeySpecifier),
		fields?: buildingProviders_mutation_responseFieldPolicy,
	},
	buildingType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buildingTypeKeySpecifier | (() => undefined | buildingTypeKeySpecifier),
		fields?: buildingTypeFieldPolicy,
	},
	buildingType_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buildingType_aggregateKeySpecifier | (() => undefined | buildingType_aggregateKeySpecifier),
		fields?: buildingType_aggregateFieldPolicy,
	},
	buildingType_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buildingType_aggregate_fieldsKeySpecifier | (() => undefined | buildingType_aggregate_fieldsKeySpecifier),
		fields?: buildingType_aggregate_fieldsFieldPolicy,
	},
	buildingType_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buildingType_max_fieldsKeySpecifier | (() => undefined | buildingType_max_fieldsKeySpecifier),
		fields?: buildingType_max_fieldsFieldPolicy,
	},
	buildingType_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buildingType_min_fieldsKeySpecifier | (() => undefined | buildingType_min_fieldsKeySpecifier),
		fields?: buildingType_min_fieldsFieldPolicy,
	},
	buildingType_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buildingType_mutation_responseKeySpecifier | (() => undefined | buildingType_mutation_responseKeySpecifier),
		fields?: buildingType_mutation_responseFieldPolicy,
	},
	card?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | cardKeySpecifier | (() => undefined | cardKeySpecifier),
		fields?: cardFieldPolicy,
	},
	checkoutSessions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | checkoutSessionsKeySpecifier | (() => undefined | checkoutSessionsKeySpecifier),
		fields?: checkoutSessionsFieldPolicy,
	},
	checkoutSessions_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | checkoutSessions_aggregateKeySpecifier | (() => undefined | checkoutSessions_aggregateKeySpecifier),
		fields?: checkoutSessions_aggregateFieldPolicy,
	},
	checkoutSessions_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | checkoutSessions_aggregate_fieldsKeySpecifier | (() => undefined | checkoutSessions_aggregate_fieldsKeySpecifier),
		fields?: checkoutSessions_aggregate_fieldsFieldPolicy,
	},
	checkoutSessions_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | checkoutSessions_max_fieldsKeySpecifier | (() => undefined | checkoutSessions_max_fieldsKeySpecifier),
		fields?: checkoutSessions_max_fieldsFieldPolicy,
	},
	checkoutSessions_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | checkoutSessions_min_fieldsKeySpecifier | (() => undefined | checkoutSessions_min_fieldsKeySpecifier),
		fields?: checkoutSessions_min_fieldsFieldPolicy,
	},
	checkoutSessions_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | checkoutSessions_mutation_responseKeySpecifier | (() => undefined | checkoutSessions_mutation_responseKeySpecifier),
		fields?: checkoutSessions_mutation_responseFieldPolicy,
	},
	currencies?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | currenciesKeySpecifier | (() => undefined | currenciesKeySpecifier),
		fields?: currenciesFieldPolicy,
	},
	currencies_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | currencies_aggregateKeySpecifier | (() => undefined | currencies_aggregateKeySpecifier),
		fields?: currencies_aggregateFieldPolicy,
	},
	currencies_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | currencies_aggregate_fieldsKeySpecifier | (() => undefined | currencies_aggregate_fieldsKeySpecifier),
		fields?: currencies_aggregate_fieldsFieldPolicy,
	},
	currencies_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | currencies_max_fieldsKeySpecifier | (() => undefined | currencies_max_fieldsKeySpecifier),
		fields?: currencies_max_fieldsFieldPolicy,
	},
	currencies_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | currencies_min_fieldsKeySpecifier | (() => undefined | currencies_min_fieldsKeySpecifier),
		fields?: currencies_min_fieldsFieldPolicy,
	},
	currencies_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | currencies_mutation_responseKeySpecifier | (() => undefined | currencies_mutation_responseKeySpecifier),
		fields?: currencies_mutation_responseFieldPolicy,
	},
	customerAmountSpent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customerAmountSpentKeySpecifier | (() => undefined | customerAmountSpentKeySpecifier),
		fields?: customerAmountSpentFieldPolicy,
	},
	customerAmountSpent_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customerAmountSpent_aggregateKeySpecifier | (() => undefined | customerAmountSpent_aggregateKeySpecifier),
		fields?: customerAmountSpent_aggregateFieldPolicy,
	},
	customerAmountSpent_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customerAmountSpent_aggregate_fieldsKeySpecifier | (() => undefined | customerAmountSpent_aggregate_fieldsKeySpecifier),
		fields?: customerAmountSpent_aggregate_fieldsFieldPolicy,
	},
	customerAmountSpent_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customerAmountSpent_avg_fieldsKeySpecifier | (() => undefined | customerAmountSpent_avg_fieldsKeySpecifier),
		fields?: customerAmountSpent_avg_fieldsFieldPolicy,
	},
	customerAmountSpent_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customerAmountSpent_max_fieldsKeySpecifier | (() => undefined | customerAmountSpent_max_fieldsKeySpecifier),
		fields?: customerAmountSpent_max_fieldsFieldPolicy,
	},
	customerAmountSpent_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customerAmountSpent_min_fieldsKeySpecifier | (() => undefined | customerAmountSpent_min_fieldsKeySpecifier),
		fields?: customerAmountSpent_min_fieldsFieldPolicy,
	},
	customerAmountSpent_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customerAmountSpent_stddev_fieldsKeySpecifier | (() => undefined | customerAmountSpent_stddev_fieldsKeySpecifier),
		fields?: customerAmountSpent_stddev_fieldsFieldPolicy,
	},
	customerAmountSpent_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customerAmountSpent_stddev_pop_fieldsKeySpecifier | (() => undefined | customerAmountSpent_stddev_pop_fieldsKeySpecifier),
		fields?: customerAmountSpent_stddev_pop_fieldsFieldPolicy,
	},
	customerAmountSpent_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customerAmountSpent_stddev_samp_fieldsKeySpecifier | (() => undefined | customerAmountSpent_stddev_samp_fieldsKeySpecifier),
		fields?: customerAmountSpent_stddev_samp_fieldsFieldPolicy,
	},
	customerAmountSpent_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customerAmountSpent_sum_fieldsKeySpecifier | (() => undefined | customerAmountSpent_sum_fieldsKeySpecifier),
		fields?: customerAmountSpent_sum_fieldsFieldPolicy,
	},
	customerAmountSpent_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customerAmountSpent_var_pop_fieldsKeySpecifier | (() => undefined | customerAmountSpent_var_pop_fieldsKeySpecifier),
		fields?: customerAmountSpent_var_pop_fieldsFieldPolicy,
	},
	customerAmountSpent_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customerAmountSpent_var_samp_fieldsKeySpecifier | (() => undefined | customerAmountSpent_var_samp_fieldsKeySpecifier),
		fields?: customerAmountSpent_var_samp_fieldsFieldPolicy,
	},
	customerAmountSpent_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customerAmountSpent_variance_fieldsKeySpecifier | (() => undefined | customerAmountSpent_variance_fieldsKeySpecifier),
		fields?: customerAmountSpent_variance_fieldsFieldPolicy,
	},
	customers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customersKeySpecifier | (() => undefined | customersKeySpecifier),
		fields?: customersFieldPolicy,
	},
	customers_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customers_aggregateKeySpecifier | (() => undefined | customers_aggregateKeySpecifier),
		fields?: customers_aggregateFieldPolicy,
	},
	customers_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customers_aggregate_fieldsKeySpecifier | (() => undefined | customers_aggregate_fieldsKeySpecifier),
		fields?: customers_aggregate_fieldsFieldPolicy,
	},
	customers_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customers_max_fieldsKeySpecifier | (() => undefined | customers_max_fieldsKeySpecifier),
		fields?: customers_max_fieldsFieldPolicy,
	},
	customers_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customers_min_fieldsKeySpecifier | (() => undefined | customers_min_fieldsKeySpecifier),
		fields?: customers_min_fieldsFieldPolicy,
	},
	customers_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customers_mutation_responseKeySpecifier | (() => undefined | customers_mutation_responseKeySpecifier),
		fields?: customers_mutation_responseFieldPolicy,
	},
	entityType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | entityTypeKeySpecifier | (() => undefined | entityTypeKeySpecifier),
		fields?: entityTypeFieldPolicy,
	},
	entityType_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | entityType_aggregateKeySpecifier | (() => undefined | entityType_aggregateKeySpecifier),
		fields?: entityType_aggregateFieldPolicy,
	},
	entityType_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | entityType_aggregate_fieldsKeySpecifier | (() => undefined | entityType_aggregate_fieldsKeySpecifier),
		fields?: entityType_aggregate_fieldsFieldPolicy,
	},
	entityType_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | entityType_max_fieldsKeySpecifier | (() => undefined | entityType_max_fieldsKeySpecifier),
		fields?: entityType_max_fieldsFieldPolicy,
	},
	entityType_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | entityType_min_fieldsKeySpecifier | (() => undefined | entityType_min_fieldsKeySpecifier),
		fields?: entityType_min_fieldsFieldPolicy,
	},
	entityType_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | entityType_mutation_responseKeySpecifier | (() => undefined | entityType_mutation_responseKeySpecifier),
		fields?: entityType_mutation_responseFieldPolicy,
	},
	files?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | filesKeySpecifier | (() => undefined | filesKeySpecifier),
		fields?: filesFieldPolicy,
	},
	files_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | files_aggregateKeySpecifier | (() => undefined | files_aggregateKeySpecifier),
		fields?: files_aggregateFieldPolicy,
	},
	files_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | files_aggregate_fieldsKeySpecifier | (() => undefined | files_aggregate_fieldsKeySpecifier),
		fields?: files_aggregate_fieldsFieldPolicy,
	},
	files_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | files_max_fieldsKeySpecifier | (() => undefined | files_max_fieldsKeySpecifier),
		fields?: files_max_fieldsFieldPolicy,
	},
	files_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | files_min_fieldsKeySpecifier | (() => undefined | files_min_fieldsKeySpecifier),
		fields?: files_min_fieldsFieldPolicy,
	},
	files_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | files_mutation_responseKeySpecifier | (() => undefined | files_mutation_responseKeySpecifier),
		fields?: files_mutation_responseFieldPolicy,
	},
	form?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formKeySpecifier | (() => undefined | formKeySpecifier),
		fields?: formFieldPolicy,
	},
	formAnswers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formAnswersKeySpecifier | (() => undefined | formAnswersKeySpecifier),
		fields?: formAnswersFieldPolicy,
	},
	formAnswers_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formAnswers_aggregateKeySpecifier | (() => undefined | formAnswers_aggregateKeySpecifier),
		fields?: formAnswers_aggregateFieldPolicy,
	},
	formAnswers_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formAnswers_aggregate_fieldsKeySpecifier | (() => undefined | formAnswers_aggregate_fieldsKeySpecifier),
		fields?: formAnswers_aggregate_fieldsFieldPolicy,
	},
	formAnswers_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formAnswers_max_fieldsKeySpecifier | (() => undefined | formAnswers_max_fieldsKeySpecifier),
		fields?: formAnswers_max_fieldsFieldPolicy,
	},
	formAnswers_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formAnswers_min_fieldsKeySpecifier | (() => undefined | formAnswers_min_fieldsKeySpecifier),
		fields?: formAnswers_min_fieldsFieldPolicy,
	},
	formAnswers_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formAnswers_mutation_responseKeySpecifier | (() => undefined | formAnswers_mutation_responseKeySpecifier),
		fields?: formAnswers_mutation_responseFieldPolicy,
	},
	formQuestionOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestionOptionsKeySpecifier | (() => undefined | formQuestionOptionsKeySpecifier),
		fields?: formQuestionOptionsFieldPolicy,
	},
	formQuestionOptions_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestionOptions_aggregateKeySpecifier | (() => undefined | formQuestionOptions_aggregateKeySpecifier),
		fields?: formQuestionOptions_aggregateFieldPolicy,
	},
	formQuestionOptions_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestionOptions_aggregate_fieldsKeySpecifier | (() => undefined | formQuestionOptions_aggregate_fieldsKeySpecifier),
		fields?: formQuestionOptions_aggregate_fieldsFieldPolicy,
	},
	formQuestionOptions_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestionOptions_max_fieldsKeySpecifier | (() => undefined | formQuestionOptions_max_fieldsKeySpecifier),
		fields?: formQuestionOptions_max_fieldsFieldPolicy,
	},
	formQuestionOptions_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestionOptions_min_fieldsKeySpecifier | (() => undefined | formQuestionOptions_min_fieldsKeySpecifier),
		fields?: formQuestionOptions_min_fieldsFieldPolicy,
	},
	formQuestionOptions_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestionOptions_mutation_responseKeySpecifier | (() => undefined | formQuestionOptions_mutation_responseKeySpecifier),
		fields?: formQuestionOptions_mutation_responseFieldPolicy,
	},
	formQuestionType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestionTypeKeySpecifier | (() => undefined | formQuestionTypeKeySpecifier),
		fields?: formQuestionTypeFieldPolicy,
	},
	formQuestionType_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestionType_aggregateKeySpecifier | (() => undefined | formQuestionType_aggregateKeySpecifier),
		fields?: formQuestionType_aggregateFieldPolicy,
	},
	formQuestionType_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestionType_aggregate_fieldsKeySpecifier | (() => undefined | formQuestionType_aggregate_fieldsKeySpecifier),
		fields?: formQuestionType_aggregate_fieldsFieldPolicy,
	},
	formQuestionType_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestionType_max_fieldsKeySpecifier | (() => undefined | formQuestionType_max_fieldsKeySpecifier),
		fields?: formQuestionType_max_fieldsFieldPolicy,
	},
	formQuestionType_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestionType_min_fieldsKeySpecifier | (() => undefined | formQuestionType_min_fieldsKeySpecifier),
		fields?: formQuestionType_min_fieldsFieldPolicy,
	},
	formQuestionType_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestionType_mutation_responseKeySpecifier | (() => undefined | formQuestionType_mutation_responseKeySpecifier),
		fields?: formQuestionType_mutation_responseFieldPolicy,
	},
	formQuestions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestionsKeySpecifier | (() => undefined | formQuestionsKeySpecifier),
		fields?: formQuestionsFieldPolicy,
	},
	formQuestions_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestions_aggregateKeySpecifier | (() => undefined | formQuestions_aggregateKeySpecifier),
		fields?: formQuestions_aggregateFieldPolicy,
	},
	formQuestions_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestions_aggregate_fieldsKeySpecifier | (() => undefined | formQuestions_aggregate_fieldsKeySpecifier),
		fields?: formQuestions_aggregate_fieldsFieldPolicy,
	},
	formQuestions_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestions_avg_fieldsKeySpecifier | (() => undefined | formQuestions_avg_fieldsKeySpecifier),
		fields?: formQuestions_avg_fieldsFieldPolicy,
	},
	formQuestions_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestions_max_fieldsKeySpecifier | (() => undefined | formQuestions_max_fieldsKeySpecifier),
		fields?: formQuestions_max_fieldsFieldPolicy,
	},
	formQuestions_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestions_min_fieldsKeySpecifier | (() => undefined | formQuestions_min_fieldsKeySpecifier),
		fields?: formQuestions_min_fieldsFieldPolicy,
	},
	formQuestions_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestions_mutation_responseKeySpecifier | (() => undefined | formQuestions_mutation_responseKeySpecifier),
		fields?: formQuestions_mutation_responseFieldPolicy,
	},
	formQuestions_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestions_stddev_fieldsKeySpecifier | (() => undefined | formQuestions_stddev_fieldsKeySpecifier),
		fields?: formQuestions_stddev_fieldsFieldPolicy,
	},
	formQuestions_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestions_stddev_pop_fieldsKeySpecifier | (() => undefined | formQuestions_stddev_pop_fieldsKeySpecifier),
		fields?: formQuestions_stddev_pop_fieldsFieldPolicy,
	},
	formQuestions_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestions_stddev_samp_fieldsKeySpecifier | (() => undefined | formQuestions_stddev_samp_fieldsKeySpecifier),
		fields?: formQuestions_stddev_samp_fieldsFieldPolicy,
	},
	formQuestions_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestions_sum_fieldsKeySpecifier | (() => undefined | formQuestions_sum_fieldsKeySpecifier),
		fields?: formQuestions_sum_fieldsFieldPolicy,
	},
	formQuestions_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestions_var_pop_fieldsKeySpecifier | (() => undefined | formQuestions_var_pop_fieldsKeySpecifier),
		fields?: formQuestions_var_pop_fieldsFieldPolicy,
	},
	formQuestions_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestions_var_samp_fieldsKeySpecifier | (() => undefined | formQuestions_var_samp_fieldsKeySpecifier),
		fields?: formQuestions_var_samp_fieldsFieldPolicy,
	},
	formQuestions_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | formQuestions_variance_fieldsKeySpecifier | (() => undefined | formQuestions_variance_fieldsKeySpecifier),
		fields?: formQuestions_variance_fieldsFieldPolicy,
	},
	form_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | form_aggregateKeySpecifier | (() => undefined | form_aggregateKeySpecifier),
		fields?: form_aggregateFieldPolicy,
	},
	form_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | form_aggregate_fieldsKeySpecifier | (() => undefined | form_aggregate_fieldsKeySpecifier),
		fields?: form_aggregate_fieldsFieldPolicy,
	},
	form_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | form_max_fieldsKeySpecifier | (() => undefined | form_max_fieldsKeySpecifier),
		fields?: form_max_fieldsFieldPolicy,
	},
	form_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | form_min_fieldsKeySpecifier | (() => undefined | form_min_fieldsKeySpecifier),
		fields?: form_min_fieldsFieldPolicy,
	},
	form_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | form_mutation_responseKeySpecifier | (() => undefined | form_mutation_responseKeySpecifier),
		fields?: form_mutation_responseFieldPolicy,
	},
	jobStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | jobStatusKeySpecifier | (() => undefined | jobStatusKeySpecifier),
		fields?: jobStatusFieldPolicy,
	},
	jobStatus_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | jobStatus_aggregateKeySpecifier | (() => undefined | jobStatus_aggregateKeySpecifier),
		fields?: jobStatus_aggregateFieldPolicy,
	},
	jobStatus_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | jobStatus_aggregate_fieldsKeySpecifier | (() => undefined | jobStatus_aggregate_fieldsKeySpecifier),
		fields?: jobStatus_aggregate_fieldsFieldPolicy,
	},
	jobStatus_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | jobStatus_max_fieldsKeySpecifier | (() => undefined | jobStatus_max_fieldsKeySpecifier),
		fields?: jobStatus_max_fieldsFieldPolicy,
	},
	jobStatus_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | jobStatus_min_fieldsKeySpecifier | (() => undefined | jobStatus_min_fieldsKeySpecifier),
		fields?: jobStatus_min_fieldsFieldPolicy,
	},
	jobStatus_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | jobStatus_mutation_responseKeySpecifier | (() => undefined | jobStatus_mutation_responseKeySpecifier),
		fields?: jobStatus_mutation_responseFieldPolicy,
	},
	locale?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | localeKeySpecifier | (() => undefined | localeKeySpecifier),
		fields?: localeFieldPolicy,
	},
	locale_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locale_aggregateKeySpecifier | (() => undefined | locale_aggregateKeySpecifier),
		fields?: locale_aggregateFieldPolicy,
	},
	locale_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locale_aggregate_fieldsKeySpecifier | (() => undefined | locale_aggregate_fieldsKeySpecifier),
		fields?: locale_aggregate_fieldsFieldPolicy,
	},
	locale_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locale_max_fieldsKeySpecifier | (() => undefined | locale_max_fieldsKeySpecifier),
		fields?: locale_max_fieldsFieldPolicy,
	},
	locale_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locale_min_fieldsKeySpecifier | (() => undefined | locale_min_fieldsKeySpecifier),
		fields?: locale_min_fieldsFieldPolicy,
	},
	locale_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locale_mutation_responseKeySpecifier | (() => undefined | locale_mutation_responseKeySpecifier),
		fields?: locale_mutation_responseFieldPolicy,
	},
	locationStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locationStatusKeySpecifier | (() => undefined | locationStatusKeySpecifier),
		fields?: locationStatusFieldPolicy,
	},
	locationStatus_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locationStatus_aggregateKeySpecifier | (() => undefined | locationStatus_aggregateKeySpecifier),
		fields?: locationStatus_aggregateFieldPolicy,
	},
	locationStatus_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locationStatus_aggregate_fieldsKeySpecifier | (() => undefined | locationStatus_aggregate_fieldsKeySpecifier),
		fields?: locationStatus_aggregate_fieldsFieldPolicy,
	},
	locationStatus_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locationStatus_max_fieldsKeySpecifier | (() => undefined | locationStatus_max_fieldsKeySpecifier),
		fields?: locationStatus_max_fieldsFieldPolicy,
	},
	locationStatus_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locationStatus_min_fieldsKeySpecifier | (() => undefined | locationStatus_min_fieldsKeySpecifier),
		fields?: locationStatus_min_fieldsFieldPolicy,
	},
	locationStatus_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locationStatus_mutation_responseKeySpecifier | (() => undefined | locationStatus_mutation_responseKeySpecifier),
		fields?: locationStatus_mutation_responseFieldPolicy,
	},
	locationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locationTypeKeySpecifier | (() => undefined | locationTypeKeySpecifier),
		fields?: locationTypeFieldPolicy,
	},
	locationType_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locationType_aggregateKeySpecifier | (() => undefined | locationType_aggregateKeySpecifier),
		fields?: locationType_aggregateFieldPolicy,
	},
	locationType_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locationType_aggregate_fieldsKeySpecifier | (() => undefined | locationType_aggregate_fieldsKeySpecifier),
		fields?: locationType_aggregate_fieldsFieldPolicy,
	},
	locationType_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locationType_max_fieldsKeySpecifier | (() => undefined | locationType_max_fieldsKeySpecifier),
		fields?: locationType_max_fieldsFieldPolicy,
	},
	locationType_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locationType_min_fieldsKeySpecifier | (() => undefined | locationType_min_fieldsKeySpecifier),
		fields?: locationType_min_fieldsFieldPolicy,
	},
	locationType_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locationType_mutation_responseKeySpecifier | (() => undefined | locationType_mutation_responseKeySpecifier),
		fields?: locationType_mutation_responseFieldPolicy,
	},
	locations?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locationsKeySpecifier | (() => undefined | locationsKeySpecifier),
		fields?: locationsFieldPolicy,
	},
	locations_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_aggregateKeySpecifier | (() => undefined | locations_aggregateKeySpecifier),
		fields?: locations_aggregateFieldPolicy,
	},
	locations_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_aggregate_fieldsKeySpecifier | (() => undefined | locations_aggregate_fieldsKeySpecifier),
		fields?: locations_aggregate_fieldsFieldPolicy,
	},
	locations_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_avg_fieldsKeySpecifier | (() => undefined | locations_avg_fieldsKeySpecifier),
		fields?: locations_avg_fieldsFieldPolicy,
	},
	locations_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_max_fieldsKeySpecifier | (() => undefined | locations_max_fieldsKeySpecifier),
		fields?: locations_max_fieldsFieldPolicy,
	},
	locations_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_min_fieldsKeySpecifier | (() => undefined | locations_min_fieldsKeySpecifier),
		fields?: locations_min_fieldsFieldPolicy,
	},
	locations_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_mutation_responseKeySpecifier | (() => undefined | locations_mutation_responseKeySpecifier),
		fields?: locations_mutation_responseFieldPolicy,
	},
	locations_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_stddev_fieldsKeySpecifier | (() => undefined | locations_stddev_fieldsKeySpecifier),
		fields?: locations_stddev_fieldsFieldPolicy,
	},
	locations_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_stddev_pop_fieldsKeySpecifier | (() => undefined | locations_stddev_pop_fieldsKeySpecifier),
		fields?: locations_stddev_pop_fieldsFieldPolicy,
	},
	locations_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_stddev_samp_fieldsKeySpecifier | (() => undefined | locations_stddev_samp_fieldsKeySpecifier),
		fields?: locations_stddev_samp_fieldsFieldPolicy,
	},
	locations_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_sum_fieldsKeySpecifier | (() => undefined | locations_sum_fieldsKeySpecifier),
		fields?: locations_sum_fieldsFieldPolicy,
	},
	locations_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_var_pop_fieldsKeySpecifier | (() => undefined | locations_var_pop_fieldsKeySpecifier),
		fields?: locations_var_pop_fieldsFieldPolicy,
	},
	locations_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_var_samp_fieldsKeySpecifier | (() => undefined | locations_var_samp_fieldsKeySpecifier),
		fields?: locations_var_samp_fieldsFieldPolicy,
	},
	locations_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_variance_fieldsKeySpecifier | (() => undefined | locations_variance_fieldsKeySpecifier),
		fields?: locations_variance_fieldsFieldPolicy,
	},
	locations_with_distance?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_with_distanceKeySpecifier | (() => undefined | locations_with_distanceKeySpecifier),
		fields?: locations_with_distanceFieldPolicy,
	},
	locations_with_distance_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_with_distance_aggregateKeySpecifier | (() => undefined | locations_with_distance_aggregateKeySpecifier),
		fields?: locations_with_distance_aggregateFieldPolicy,
	},
	locations_with_distance_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_with_distance_aggregate_fieldsKeySpecifier | (() => undefined | locations_with_distance_aggregate_fieldsKeySpecifier),
		fields?: locations_with_distance_aggregate_fieldsFieldPolicy,
	},
	locations_with_distance_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_with_distance_avg_fieldsKeySpecifier | (() => undefined | locations_with_distance_avg_fieldsKeySpecifier),
		fields?: locations_with_distance_avg_fieldsFieldPolicy,
	},
	locations_with_distance_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_with_distance_max_fieldsKeySpecifier | (() => undefined | locations_with_distance_max_fieldsKeySpecifier),
		fields?: locations_with_distance_max_fieldsFieldPolicy,
	},
	locations_with_distance_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_with_distance_min_fieldsKeySpecifier | (() => undefined | locations_with_distance_min_fieldsKeySpecifier),
		fields?: locations_with_distance_min_fieldsFieldPolicy,
	},
	locations_with_distance_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_with_distance_mutation_responseKeySpecifier | (() => undefined | locations_with_distance_mutation_responseKeySpecifier),
		fields?: locations_with_distance_mutation_responseFieldPolicy,
	},
	locations_with_distance_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_with_distance_stddev_fieldsKeySpecifier | (() => undefined | locations_with_distance_stddev_fieldsKeySpecifier),
		fields?: locations_with_distance_stddev_fieldsFieldPolicy,
	},
	locations_with_distance_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_with_distance_stddev_pop_fieldsKeySpecifier | (() => undefined | locations_with_distance_stddev_pop_fieldsKeySpecifier),
		fields?: locations_with_distance_stddev_pop_fieldsFieldPolicy,
	},
	locations_with_distance_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_with_distance_stddev_samp_fieldsKeySpecifier | (() => undefined | locations_with_distance_stddev_samp_fieldsKeySpecifier),
		fields?: locations_with_distance_stddev_samp_fieldsFieldPolicy,
	},
	locations_with_distance_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_with_distance_sum_fieldsKeySpecifier | (() => undefined | locations_with_distance_sum_fieldsKeySpecifier),
		fields?: locations_with_distance_sum_fieldsFieldPolicy,
	},
	locations_with_distance_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_with_distance_var_pop_fieldsKeySpecifier | (() => undefined | locations_with_distance_var_pop_fieldsKeySpecifier),
		fields?: locations_with_distance_var_pop_fieldsFieldPolicy,
	},
	locations_with_distance_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_with_distance_var_samp_fieldsKeySpecifier | (() => undefined | locations_with_distance_var_samp_fieldsKeySpecifier),
		fields?: locations_with_distance_var_samp_fieldsFieldPolicy,
	},
	locations_with_distance_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | locations_with_distance_variance_fieldsKeySpecifier | (() => undefined | locations_with_distance_variance_fieldsKeySpecifier),
		fields?: locations_with_distance_variance_fieldsFieldPolicy,
	},
	mutation_root?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | mutation_rootKeySpecifier | (() => undefined | mutation_rootKeySpecifier),
		fields?: mutation_rootFieldPolicy,
	},
	nest_buildingProviders?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | nest_buildingProvidersKeySpecifier | (() => undefined | nest_buildingProvidersKeySpecifier),
		fields?: nest_buildingProvidersFieldPolicy,
	},
	notificationType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | notificationTypeKeySpecifier | (() => undefined | notificationTypeKeySpecifier),
		fields?: notificationTypeFieldPolicy,
	},
	notificationType_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | notificationType_aggregateKeySpecifier | (() => undefined | notificationType_aggregateKeySpecifier),
		fields?: notificationType_aggregateFieldPolicy,
	},
	notificationType_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | notificationType_aggregate_fieldsKeySpecifier | (() => undefined | notificationType_aggregate_fieldsKeySpecifier),
		fields?: notificationType_aggregate_fieldsFieldPolicy,
	},
	notificationType_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | notificationType_max_fieldsKeySpecifier | (() => undefined | notificationType_max_fieldsKeySpecifier),
		fields?: notificationType_max_fieldsFieldPolicy,
	},
	notificationType_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | notificationType_min_fieldsKeySpecifier | (() => undefined | notificationType_min_fieldsKeySpecifier),
		fields?: notificationType_min_fieldsFieldPolicy,
	},
	notificationType_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | notificationType_mutation_responseKeySpecifier | (() => undefined | notificationType_mutation_responseKeySpecifier),
		fields?: notificationType_mutation_responseFieldPolicy,
	},
	notifications?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | notificationsKeySpecifier | (() => undefined | notificationsKeySpecifier),
		fields?: notificationsFieldPolicy,
	},
	notifications_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | notifications_aggregateKeySpecifier | (() => undefined | notifications_aggregateKeySpecifier),
		fields?: notifications_aggregateFieldPolicy,
	},
	notifications_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | notifications_aggregate_fieldsKeySpecifier | (() => undefined | notifications_aggregate_fieldsKeySpecifier),
		fields?: notifications_aggregate_fieldsFieldPolicy,
	},
	notifications_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | notifications_max_fieldsKeySpecifier | (() => undefined | notifications_max_fieldsKeySpecifier),
		fields?: notifications_max_fieldsFieldPolicy,
	},
	notifications_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | notifications_min_fieldsKeySpecifier | (() => undefined | notifications_min_fieldsKeySpecifier),
		fields?: notifications_min_fieldsFieldPolicy,
	},
	notifications_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | notifications_mutation_responseKeySpecifier | (() => undefined | notifications_mutation_responseKeySpecifier),
		fields?: notifications_mutation_responseFieldPolicy,
	},
	partnershipSchedulingType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | partnershipSchedulingTypeKeySpecifier | (() => undefined | partnershipSchedulingTypeKeySpecifier),
		fields?: partnershipSchedulingTypeFieldPolicy,
	},
	partnershipSchedulingType_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | partnershipSchedulingType_aggregateKeySpecifier | (() => undefined | partnershipSchedulingType_aggregateKeySpecifier),
		fields?: partnershipSchedulingType_aggregateFieldPolicy,
	},
	partnershipSchedulingType_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | partnershipSchedulingType_aggregate_fieldsKeySpecifier | (() => undefined | partnershipSchedulingType_aggregate_fieldsKeySpecifier),
		fields?: partnershipSchedulingType_aggregate_fieldsFieldPolicy,
	},
	partnershipSchedulingType_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | partnershipSchedulingType_max_fieldsKeySpecifier | (() => undefined | partnershipSchedulingType_max_fieldsKeySpecifier),
		fields?: partnershipSchedulingType_max_fieldsFieldPolicy,
	},
	partnershipSchedulingType_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | partnershipSchedulingType_min_fieldsKeySpecifier | (() => undefined | partnershipSchedulingType_min_fieldsKeySpecifier),
		fields?: partnershipSchedulingType_min_fieldsFieldPolicy,
	},
	partnershipSchedulingType_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | partnershipSchedulingType_mutation_responseKeySpecifier | (() => undefined | partnershipSchedulingType_mutation_responseKeySpecifier),
		fields?: partnershipSchedulingType_mutation_responseFieldPolicy,
	},
	partnershipStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | partnershipStatusKeySpecifier | (() => undefined | partnershipStatusKeySpecifier),
		fields?: partnershipStatusFieldPolicy,
	},
	partnershipStatus_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | partnershipStatus_aggregateKeySpecifier | (() => undefined | partnershipStatus_aggregateKeySpecifier),
		fields?: partnershipStatus_aggregateFieldPolicy,
	},
	partnershipStatus_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | partnershipStatus_aggregate_fieldsKeySpecifier | (() => undefined | partnershipStatus_aggregate_fieldsKeySpecifier),
		fields?: partnershipStatus_aggregate_fieldsFieldPolicy,
	},
	partnershipStatus_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | partnershipStatus_max_fieldsKeySpecifier | (() => undefined | partnershipStatus_max_fieldsKeySpecifier),
		fields?: partnershipStatus_max_fieldsFieldPolicy,
	},
	partnershipStatus_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | partnershipStatus_min_fieldsKeySpecifier | (() => undefined | partnershipStatus_min_fieldsKeySpecifier),
		fields?: partnershipStatus_min_fieldsFieldPolicy,
	},
	partnershipStatus_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | partnershipStatus_mutation_responseKeySpecifier | (() => undefined | partnershipStatus_mutation_responseKeySpecifier),
		fields?: partnershipStatus_mutation_responseFieldPolicy,
	},
	paymentFormat?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | paymentFormatKeySpecifier | (() => undefined | paymentFormatKeySpecifier),
		fields?: paymentFormatFieldPolicy,
	},
	paymentFormat_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | paymentFormat_aggregateKeySpecifier | (() => undefined | paymentFormat_aggregateKeySpecifier),
		fields?: paymentFormat_aggregateFieldPolicy,
	},
	paymentFormat_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | paymentFormat_aggregate_fieldsKeySpecifier | (() => undefined | paymentFormat_aggregate_fieldsKeySpecifier),
		fields?: paymentFormat_aggregate_fieldsFieldPolicy,
	},
	paymentFormat_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | paymentFormat_max_fieldsKeySpecifier | (() => undefined | paymentFormat_max_fieldsKeySpecifier),
		fields?: paymentFormat_max_fieldsFieldPolicy,
	},
	paymentFormat_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | paymentFormat_min_fieldsKeySpecifier | (() => undefined | paymentFormat_min_fieldsKeySpecifier),
		fields?: paymentFormat_min_fieldsFieldPolicy,
	},
	paymentFormat_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | paymentFormat_mutation_responseKeySpecifier | (() => undefined | paymentFormat_mutation_responseKeySpecifier),
		fields?: paymentFormat_mutation_responseFieldPolicy,
	},
	paymentStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | paymentStatusKeySpecifier | (() => undefined | paymentStatusKeySpecifier),
		fields?: paymentStatusFieldPolicy,
	},
	paymentStatus_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | paymentStatus_aggregateKeySpecifier | (() => undefined | paymentStatus_aggregateKeySpecifier),
		fields?: paymentStatus_aggregateFieldPolicy,
	},
	paymentStatus_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | paymentStatus_aggregate_fieldsKeySpecifier | (() => undefined | paymentStatus_aggregate_fieldsKeySpecifier),
		fields?: paymentStatus_aggregate_fieldsFieldPolicy,
	},
	paymentStatus_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | paymentStatus_max_fieldsKeySpecifier | (() => undefined | paymentStatus_max_fieldsKeySpecifier),
		fields?: paymentStatus_max_fieldsFieldPolicy,
	},
	paymentStatus_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | paymentStatus_min_fieldsKeySpecifier | (() => undefined | paymentStatus_min_fieldsKeySpecifier),
		fields?: paymentStatus_min_fieldsFieldPolicy,
	},
	paymentStatus_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | paymentStatus_mutation_responseKeySpecifier | (() => undefined | paymentStatus_mutation_responseKeySpecifier),
		fields?: paymentStatus_mutation_responseFieldPolicy,
	},
	payments?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | paymentsKeySpecifier | (() => undefined | paymentsKeySpecifier),
		fields?: paymentsFieldPolicy,
	},
	payments_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | payments_aggregateKeySpecifier | (() => undefined | payments_aggregateKeySpecifier),
		fields?: payments_aggregateFieldPolicy,
	},
	payments_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | payments_aggregate_fieldsKeySpecifier | (() => undefined | payments_aggregate_fieldsKeySpecifier),
		fields?: payments_aggregate_fieldsFieldPolicy,
	},
	payments_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | payments_avg_fieldsKeySpecifier | (() => undefined | payments_avg_fieldsKeySpecifier),
		fields?: payments_avg_fieldsFieldPolicy,
	},
	payments_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | payments_max_fieldsKeySpecifier | (() => undefined | payments_max_fieldsKeySpecifier),
		fields?: payments_max_fieldsFieldPolicy,
	},
	payments_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | payments_min_fieldsKeySpecifier | (() => undefined | payments_min_fieldsKeySpecifier),
		fields?: payments_min_fieldsFieldPolicy,
	},
	payments_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | payments_mutation_responseKeySpecifier | (() => undefined | payments_mutation_responseKeySpecifier),
		fields?: payments_mutation_responseFieldPolicy,
	},
	payments_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | payments_stddev_fieldsKeySpecifier | (() => undefined | payments_stddev_fieldsKeySpecifier),
		fields?: payments_stddev_fieldsFieldPolicy,
	},
	payments_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | payments_stddev_pop_fieldsKeySpecifier | (() => undefined | payments_stddev_pop_fieldsKeySpecifier),
		fields?: payments_stddev_pop_fieldsFieldPolicy,
	},
	payments_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | payments_stddev_samp_fieldsKeySpecifier | (() => undefined | payments_stddev_samp_fieldsKeySpecifier),
		fields?: payments_stddev_samp_fieldsFieldPolicy,
	},
	payments_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | payments_sum_fieldsKeySpecifier | (() => undefined | payments_sum_fieldsKeySpecifier),
		fields?: payments_sum_fieldsFieldPolicy,
	},
	payments_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | payments_var_pop_fieldsKeySpecifier | (() => undefined | payments_var_pop_fieldsKeySpecifier),
		fields?: payments_var_pop_fieldsFieldPolicy,
	},
	payments_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | payments_var_samp_fieldsKeySpecifier | (() => undefined | payments_var_samp_fieldsKeySpecifier),
		fields?: payments_var_samp_fieldsFieldPolicy,
	},
	payments_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | payments_variance_fieldsKeySpecifier | (() => undefined | payments_variance_fieldsKeySpecifier),
		fields?: payments_variance_fieldsFieldPolicy,
	},
	providerCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerCategoryKeySpecifier | (() => undefined | providerCategoryKeySpecifier),
		fields?: providerCategoryFieldPolicy,
	},
	providerCategory_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerCategory_aggregateKeySpecifier | (() => undefined | providerCategory_aggregateKeySpecifier),
		fields?: providerCategory_aggregateFieldPolicy,
	},
	providerCategory_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerCategory_aggregate_fieldsKeySpecifier | (() => undefined | providerCategory_aggregate_fieldsKeySpecifier),
		fields?: providerCategory_aggregate_fieldsFieldPolicy,
	},
	providerCategory_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerCategory_max_fieldsKeySpecifier | (() => undefined | providerCategory_max_fieldsKeySpecifier),
		fields?: providerCategory_max_fieldsFieldPolicy,
	},
	providerCategory_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerCategory_min_fieldsKeySpecifier | (() => undefined | providerCategory_min_fieldsKeySpecifier),
		fields?: providerCategory_min_fieldsFieldPolicy,
	},
	providerCategory_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerCategory_mutation_responseKeySpecifier | (() => undefined | providerCategory_mutation_responseKeySpecifier),
		fields?: providerCategory_mutation_responseFieldPolicy,
	},
	providerMonthlyPayments?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerMonthlyPaymentsKeySpecifier | (() => undefined | providerMonthlyPaymentsKeySpecifier),
		fields?: providerMonthlyPaymentsFieldPolicy,
	},
	providerMonthlyPayments_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerMonthlyPayments_aggregateKeySpecifier | (() => undefined | providerMonthlyPayments_aggregateKeySpecifier),
		fields?: providerMonthlyPayments_aggregateFieldPolicy,
	},
	providerMonthlyPayments_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerMonthlyPayments_aggregate_fieldsKeySpecifier | (() => undefined | providerMonthlyPayments_aggregate_fieldsKeySpecifier),
		fields?: providerMonthlyPayments_aggregate_fieldsFieldPolicy,
	},
	providerMonthlyPayments_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerMonthlyPayments_avg_fieldsKeySpecifier | (() => undefined | providerMonthlyPayments_avg_fieldsKeySpecifier),
		fields?: providerMonthlyPayments_avg_fieldsFieldPolicy,
	},
	providerMonthlyPayments_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerMonthlyPayments_max_fieldsKeySpecifier | (() => undefined | providerMonthlyPayments_max_fieldsKeySpecifier),
		fields?: providerMonthlyPayments_max_fieldsFieldPolicy,
	},
	providerMonthlyPayments_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerMonthlyPayments_min_fieldsKeySpecifier | (() => undefined | providerMonthlyPayments_min_fieldsKeySpecifier),
		fields?: providerMonthlyPayments_min_fieldsFieldPolicy,
	},
	providerMonthlyPayments_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerMonthlyPayments_mutation_responseKeySpecifier | (() => undefined | providerMonthlyPayments_mutation_responseKeySpecifier),
		fields?: providerMonthlyPayments_mutation_responseFieldPolicy,
	},
	providerMonthlyPayments_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerMonthlyPayments_stddev_fieldsKeySpecifier | (() => undefined | providerMonthlyPayments_stddev_fieldsKeySpecifier),
		fields?: providerMonthlyPayments_stddev_fieldsFieldPolicy,
	},
	providerMonthlyPayments_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerMonthlyPayments_stddev_pop_fieldsKeySpecifier | (() => undefined | providerMonthlyPayments_stddev_pop_fieldsKeySpecifier),
		fields?: providerMonthlyPayments_stddev_pop_fieldsFieldPolicy,
	},
	providerMonthlyPayments_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerMonthlyPayments_stddev_samp_fieldsKeySpecifier | (() => undefined | providerMonthlyPayments_stddev_samp_fieldsKeySpecifier),
		fields?: providerMonthlyPayments_stddev_samp_fieldsFieldPolicy,
	},
	providerMonthlyPayments_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerMonthlyPayments_sum_fieldsKeySpecifier | (() => undefined | providerMonthlyPayments_sum_fieldsKeySpecifier),
		fields?: providerMonthlyPayments_sum_fieldsFieldPolicy,
	},
	providerMonthlyPayments_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerMonthlyPayments_var_pop_fieldsKeySpecifier | (() => undefined | providerMonthlyPayments_var_pop_fieldsKeySpecifier),
		fields?: providerMonthlyPayments_var_pop_fieldsFieldPolicy,
	},
	providerMonthlyPayments_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerMonthlyPayments_var_samp_fieldsKeySpecifier | (() => undefined | providerMonthlyPayments_var_samp_fieldsKeySpecifier),
		fields?: providerMonthlyPayments_var_samp_fieldsFieldPolicy,
	},
	providerMonthlyPayments_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerMonthlyPayments_variance_fieldsKeySpecifier | (() => undefined | providerMonthlyPayments_variance_fieldsKeySpecifier),
		fields?: providerMonthlyPayments_variance_fieldsFieldPolicy,
	},
	providerPictures?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerPicturesKeySpecifier | (() => undefined | providerPicturesKeySpecifier),
		fields?: providerPicturesFieldPolicy,
	},
	providerPictures_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerPictures_aggregateKeySpecifier | (() => undefined | providerPictures_aggregateKeySpecifier),
		fields?: providerPictures_aggregateFieldPolicy,
	},
	providerPictures_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerPictures_aggregate_fieldsKeySpecifier | (() => undefined | providerPictures_aggregate_fieldsKeySpecifier),
		fields?: providerPictures_aggregate_fieldsFieldPolicy,
	},
	providerPictures_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerPictures_max_fieldsKeySpecifier | (() => undefined | providerPictures_max_fieldsKeySpecifier),
		fields?: providerPictures_max_fieldsFieldPolicy,
	},
	providerPictures_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerPictures_min_fieldsKeySpecifier | (() => undefined | providerPictures_min_fieldsKeySpecifier),
		fields?: providerPictures_min_fieldsFieldPolicy,
	},
	providerPictures_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerPictures_mutation_responseKeySpecifier | (() => undefined | providerPictures_mutation_responseKeySpecifier),
		fields?: providerPictures_mutation_responseFieldPolicy,
	},
	providerRole?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerRoleKeySpecifier | (() => undefined | providerRoleKeySpecifier),
		fields?: providerRoleFieldPolicy,
	},
	providerRole_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerRole_aggregateKeySpecifier | (() => undefined | providerRole_aggregateKeySpecifier),
		fields?: providerRole_aggregateFieldPolicy,
	},
	providerRole_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerRole_aggregate_fieldsKeySpecifier | (() => undefined | providerRole_aggregate_fieldsKeySpecifier),
		fields?: providerRole_aggregate_fieldsFieldPolicy,
	},
	providerRole_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerRole_max_fieldsKeySpecifier | (() => undefined | providerRole_max_fieldsKeySpecifier),
		fields?: providerRole_max_fieldsFieldPolicy,
	},
	providerRole_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerRole_min_fieldsKeySpecifier | (() => undefined | providerRole_min_fieldsKeySpecifier),
		fields?: providerRole_min_fieldsFieldPolicy,
	},
	providerRole_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerRole_mutation_responseKeySpecifier | (() => undefined | providerRole_mutation_responseKeySpecifier),
		fields?: providerRole_mutation_responseFieldPolicy,
	},
	providerStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerStatusKeySpecifier | (() => undefined | providerStatusKeySpecifier),
		fields?: providerStatusFieldPolicy,
	},
	providerStatus_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerStatus_aggregateKeySpecifier | (() => undefined | providerStatus_aggregateKeySpecifier),
		fields?: providerStatus_aggregateFieldPolicy,
	},
	providerStatus_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerStatus_aggregate_fieldsKeySpecifier | (() => undefined | providerStatus_aggregate_fieldsKeySpecifier),
		fields?: providerStatus_aggregate_fieldsFieldPolicy,
	},
	providerStatus_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerStatus_max_fieldsKeySpecifier | (() => undefined | providerStatus_max_fieldsKeySpecifier),
		fields?: providerStatus_max_fieldsFieldPolicy,
	},
	providerStatus_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerStatus_min_fieldsKeySpecifier | (() => undefined | providerStatus_min_fieldsKeySpecifier),
		fields?: providerStatus_min_fieldsFieldPolicy,
	},
	providerStatus_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerStatus_mutation_responseKeySpecifier | (() => undefined | providerStatus_mutation_responseKeySpecifier),
		fields?: providerStatus_mutation_responseFieldPolicy,
	},
	providerType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerTypeKeySpecifier | (() => undefined | providerTypeKeySpecifier),
		fields?: providerTypeFieldPolicy,
	},
	providerType_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerType_aggregateKeySpecifier | (() => undefined | providerType_aggregateKeySpecifier),
		fields?: providerType_aggregateFieldPolicy,
	},
	providerType_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerType_aggregate_fieldsKeySpecifier | (() => undefined | providerType_aggregate_fieldsKeySpecifier),
		fields?: providerType_aggregate_fieldsFieldPolicy,
	},
	providerType_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerType_max_fieldsKeySpecifier | (() => undefined | providerType_max_fieldsKeySpecifier),
		fields?: providerType_max_fieldsFieldPolicy,
	},
	providerType_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerType_min_fieldsKeySpecifier | (() => undefined | providerType_min_fieldsKeySpecifier),
		fields?: providerType_min_fieldsFieldPolicy,
	},
	providerType_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerType_mutation_responseKeySpecifier | (() => undefined | providerType_mutation_responseKeySpecifier),
		fields?: providerType_mutation_responseFieldPolicy,
	},
	providerVisibility?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerVisibilityKeySpecifier | (() => undefined | providerVisibilityKeySpecifier),
		fields?: providerVisibilityFieldPolicy,
	},
	providerVisibility_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerVisibility_aggregateKeySpecifier | (() => undefined | providerVisibility_aggregateKeySpecifier),
		fields?: providerVisibility_aggregateFieldPolicy,
	},
	providerVisibility_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerVisibility_aggregate_fieldsKeySpecifier | (() => undefined | providerVisibility_aggregate_fieldsKeySpecifier),
		fields?: providerVisibility_aggregate_fieldsFieldPolicy,
	},
	providerVisibility_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerVisibility_max_fieldsKeySpecifier | (() => undefined | providerVisibility_max_fieldsKeySpecifier),
		fields?: providerVisibility_max_fieldsFieldPolicy,
	},
	providerVisibility_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerVisibility_min_fieldsKeySpecifier | (() => undefined | providerVisibility_min_fieldsKeySpecifier),
		fields?: providerVisibility_min_fieldsFieldPolicy,
	},
	providerVisibility_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providerVisibility_mutation_responseKeySpecifier | (() => undefined | providerVisibility_mutation_responseKeySpecifier),
		fields?: providerVisibility_mutation_responseFieldPolicy,
	},
	providers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providersKeySpecifier | (() => undefined | providersKeySpecifier),
		fields?: providersFieldPolicy,
	},
	providers_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providers_aggregateKeySpecifier | (() => undefined | providers_aggregateKeySpecifier),
		fields?: providers_aggregateFieldPolicy,
	},
	providers_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providers_aggregate_fieldsKeySpecifier | (() => undefined | providers_aggregate_fieldsKeySpecifier),
		fields?: providers_aggregate_fieldsFieldPolicy,
	},
	providers_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providers_avg_fieldsKeySpecifier | (() => undefined | providers_avg_fieldsKeySpecifier),
		fields?: providers_avg_fieldsFieldPolicy,
	},
	providers_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providers_max_fieldsKeySpecifier | (() => undefined | providers_max_fieldsKeySpecifier),
		fields?: providers_max_fieldsFieldPolicy,
	},
	providers_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providers_min_fieldsKeySpecifier | (() => undefined | providers_min_fieldsKeySpecifier),
		fields?: providers_min_fieldsFieldPolicy,
	},
	providers_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providers_mutation_responseKeySpecifier | (() => undefined | providers_mutation_responseKeySpecifier),
		fields?: providers_mutation_responseFieldPolicy,
	},
	providers_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providers_stddev_fieldsKeySpecifier | (() => undefined | providers_stddev_fieldsKeySpecifier),
		fields?: providers_stddev_fieldsFieldPolicy,
	},
	providers_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providers_stddev_pop_fieldsKeySpecifier | (() => undefined | providers_stddev_pop_fieldsKeySpecifier),
		fields?: providers_stddev_pop_fieldsFieldPolicy,
	},
	providers_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providers_stddev_samp_fieldsKeySpecifier | (() => undefined | providers_stddev_samp_fieldsKeySpecifier),
		fields?: providers_stddev_samp_fieldsFieldPolicy,
	},
	providers_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providers_sum_fieldsKeySpecifier | (() => undefined | providers_sum_fieldsKeySpecifier),
		fields?: providers_sum_fieldsFieldPolicy,
	},
	providers_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providers_var_pop_fieldsKeySpecifier | (() => undefined | providers_var_pop_fieldsKeySpecifier),
		fields?: providers_var_pop_fieldsFieldPolicy,
	},
	providers_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providers_var_samp_fieldsKeySpecifier | (() => undefined | providers_var_samp_fieldsKeySpecifier),
		fields?: providers_var_samp_fieldsFieldPolicy,
	},
	providers_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | providers_variance_fieldsKeySpecifier | (() => undefined | providers_variance_fieldsKeySpecifier),
		fields?: providers_variance_fieldsFieldPolicy,
	},
	query_root?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | query_rootKeySpecifier | (() => undefined | query_rootKeySpecifier),
		fields?: query_rootFieldPolicy,
	},
	refunds?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | refundsKeySpecifier | (() => undefined | refundsKeySpecifier),
		fields?: refundsFieldPolicy,
	},
	refunds_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | refunds_aggregateKeySpecifier | (() => undefined | refunds_aggregateKeySpecifier),
		fields?: refunds_aggregateFieldPolicy,
	},
	refunds_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | refunds_aggregate_fieldsKeySpecifier | (() => undefined | refunds_aggregate_fieldsKeySpecifier),
		fields?: refunds_aggregate_fieldsFieldPolicy,
	},
	refunds_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | refunds_avg_fieldsKeySpecifier | (() => undefined | refunds_avg_fieldsKeySpecifier),
		fields?: refunds_avg_fieldsFieldPolicy,
	},
	refunds_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | refunds_max_fieldsKeySpecifier | (() => undefined | refunds_max_fieldsKeySpecifier),
		fields?: refunds_max_fieldsFieldPolicy,
	},
	refunds_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | refunds_min_fieldsKeySpecifier | (() => undefined | refunds_min_fieldsKeySpecifier),
		fields?: refunds_min_fieldsFieldPolicy,
	},
	refunds_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | refunds_mutation_responseKeySpecifier | (() => undefined | refunds_mutation_responseKeySpecifier),
		fields?: refunds_mutation_responseFieldPolicy,
	},
	refunds_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | refunds_stddev_fieldsKeySpecifier | (() => undefined | refunds_stddev_fieldsKeySpecifier),
		fields?: refunds_stddev_fieldsFieldPolicy,
	},
	refunds_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | refunds_stddev_pop_fieldsKeySpecifier | (() => undefined | refunds_stddev_pop_fieldsKeySpecifier),
		fields?: refunds_stddev_pop_fieldsFieldPolicy,
	},
	refunds_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | refunds_stddev_samp_fieldsKeySpecifier | (() => undefined | refunds_stddev_samp_fieldsKeySpecifier),
		fields?: refunds_stddev_samp_fieldsFieldPolicy,
	},
	refunds_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | refunds_sum_fieldsKeySpecifier | (() => undefined | refunds_sum_fieldsKeySpecifier),
		fields?: refunds_sum_fieldsFieldPolicy,
	},
	refunds_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | refunds_var_pop_fieldsKeySpecifier | (() => undefined | refunds_var_pop_fieldsKeySpecifier),
		fields?: refunds_var_pop_fieldsFieldPolicy,
	},
	refunds_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | refunds_var_samp_fieldsKeySpecifier | (() => undefined | refunds_var_samp_fieldsKeySpecifier),
		fields?: refunds_var_samp_fieldsFieldPolicy,
	},
	refunds_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | refunds_variance_fieldsKeySpecifier | (() => undefined | refunds_variance_fieldsKeySpecifier),
		fields?: refunds_variance_fieldsFieldPolicy,
	},
	relationshipStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | relationshipStatusKeySpecifier | (() => undefined | relationshipStatusKeySpecifier),
		fields?: relationshipStatusFieldPolicy,
	},
	relationshipStatus_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | relationshipStatus_aggregateKeySpecifier | (() => undefined | relationshipStatus_aggregateKeySpecifier),
		fields?: relationshipStatus_aggregateFieldPolicy,
	},
	relationshipStatus_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | relationshipStatus_aggregate_fieldsKeySpecifier | (() => undefined | relationshipStatus_aggregate_fieldsKeySpecifier),
		fields?: relationshipStatus_aggregate_fieldsFieldPolicy,
	},
	relationshipStatus_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | relationshipStatus_max_fieldsKeySpecifier | (() => undefined | relationshipStatus_max_fieldsKeySpecifier),
		fields?: relationshipStatus_max_fieldsFieldPolicy,
	},
	relationshipStatus_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | relationshipStatus_min_fieldsKeySpecifier | (() => undefined | relationshipStatus_min_fieldsKeySpecifier),
		fields?: relationshipStatus_min_fieldsFieldPolicy,
	},
	relationshipStatus_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | relationshipStatus_mutation_responseKeySpecifier | (() => undefined | relationshipStatus_mutation_responseKeySpecifier),
		fields?: relationshipStatus_mutation_responseFieldPolicy,
	},
	schedule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | scheduleKeySpecifier | (() => undefined | scheduleKeySpecifier),
		fields?: scheduleFieldPolicy,
	},
	schedule_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | schedule_aggregateKeySpecifier | (() => undefined | schedule_aggregateKeySpecifier),
		fields?: schedule_aggregateFieldPolicy,
	},
	schedule_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | schedule_aggregate_fieldsKeySpecifier | (() => undefined | schedule_aggregate_fieldsKeySpecifier),
		fields?: schedule_aggregate_fieldsFieldPolicy,
	},
	schedule_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | schedule_max_fieldsKeySpecifier | (() => undefined | schedule_max_fieldsKeySpecifier),
		fields?: schedule_max_fieldsFieldPolicy,
	},
	schedule_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | schedule_min_fieldsKeySpecifier | (() => undefined | schedule_min_fieldsKeySpecifier),
		fields?: schedule_min_fieldsFieldPolicy,
	},
	schedule_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | schedule_mutation_responseKeySpecifier | (() => undefined | schedule_mutation_responseKeySpecifier),
		fields?: schedule_mutation_responseFieldPolicy,
	},
	serviceEmployees?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceEmployeesKeySpecifier | (() => undefined | serviceEmployeesKeySpecifier),
		fields?: serviceEmployeesFieldPolicy,
	},
	serviceEmployees_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceEmployees_aggregateKeySpecifier | (() => undefined | serviceEmployees_aggregateKeySpecifier),
		fields?: serviceEmployees_aggregateFieldPolicy,
	},
	serviceEmployees_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceEmployees_aggregate_fieldsKeySpecifier | (() => undefined | serviceEmployees_aggregate_fieldsKeySpecifier),
		fields?: serviceEmployees_aggregate_fieldsFieldPolicy,
	},
	serviceEmployees_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceEmployees_max_fieldsKeySpecifier | (() => undefined | serviceEmployees_max_fieldsKeySpecifier),
		fields?: serviceEmployees_max_fieldsFieldPolicy,
	},
	serviceEmployees_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceEmployees_min_fieldsKeySpecifier | (() => undefined | serviceEmployees_min_fieldsKeySpecifier),
		fields?: serviceEmployees_min_fieldsFieldPolicy,
	},
	serviceEmployees_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceEmployees_mutation_responseKeySpecifier | (() => undefined | serviceEmployees_mutation_responseKeySpecifier),
		fields?: serviceEmployees_mutation_responseFieldPolicy,
	},
	serviceFormStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceFormStatusKeySpecifier | (() => undefined | serviceFormStatusKeySpecifier),
		fields?: serviceFormStatusFieldPolicy,
	},
	serviceFormStatus_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceFormStatus_aggregateKeySpecifier | (() => undefined | serviceFormStatus_aggregateKeySpecifier),
		fields?: serviceFormStatus_aggregateFieldPolicy,
	},
	serviceFormStatus_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceFormStatus_aggregate_fieldsKeySpecifier | (() => undefined | serviceFormStatus_aggregate_fieldsKeySpecifier),
		fields?: serviceFormStatus_aggregate_fieldsFieldPolicy,
	},
	serviceFormStatus_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceFormStatus_max_fieldsKeySpecifier | (() => undefined | serviceFormStatus_max_fieldsKeySpecifier),
		fields?: serviceFormStatus_max_fieldsFieldPolicy,
	},
	serviceFormStatus_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceFormStatus_min_fieldsKeySpecifier | (() => undefined | serviceFormStatus_min_fieldsKeySpecifier),
		fields?: serviceFormStatus_min_fieldsFieldPolicy,
	},
	serviceFormStatus_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceFormStatus_mutation_responseKeySpecifier | (() => undefined | serviceFormStatus_mutation_responseKeySpecifier),
		fields?: serviceFormStatus_mutation_responseFieldPolicy,
	},
	serviceOptionAnswers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionAnswersKeySpecifier | (() => undefined | serviceOptionAnswersKeySpecifier),
		fields?: serviceOptionAnswersFieldPolicy,
	},
	serviceOptionAnswers_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionAnswers_aggregateKeySpecifier | (() => undefined | serviceOptionAnswers_aggregateKeySpecifier),
		fields?: serviceOptionAnswers_aggregateFieldPolicy,
	},
	serviceOptionAnswers_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionAnswers_aggregate_fieldsKeySpecifier | (() => undefined | serviceOptionAnswers_aggregate_fieldsKeySpecifier),
		fields?: serviceOptionAnswers_aggregate_fieldsFieldPolicy,
	},
	serviceOptionAnswers_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionAnswers_avg_fieldsKeySpecifier | (() => undefined | serviceOptionAnswers_avg_fieldsKeySpecifier),
		fields?: serviceOptionAnswers_avg_fieldsFieldPolicy,
	},
	serviceOptionAnswers_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionAnswers_max_fieldsKeySpecifier | (() => undefined | serviceOptionAnswers_max_fieldsKeySpecifier),
		fields?: serviceOptionAnswers_max_fieldsFieldPolicy,
	},
	serviceOptionAnswers_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionAnswers_min_fieldsKeySpecifier | (() => undefined | serviceOptionAnswers_min_fieldsKeySpecifier),
		fields?: serviceOptionAnswers_min_fieldsFieldPolicy,
	},
	serviceOptionAnswers_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionAnswers_mutation_responseKeySpecifier | (() => undefined | serviceOptionAnswers_mutation_responseKeySpecifier),
		fields?: serviceOptionAnswers_mutation_responseFieldPolicy,
	},
	serviceOptionAnswers_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionAnswers_stddev_fieldsKeySpecifier | (() => undefined | serviceOptionAnswers_stddev_fieldsKeySpecifier),
		fields?: serviceOptionAnswers_stddev_fieldsFieldPolicy,
	},
	serviceOptionAnswers_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionAnswers_stddev_pop_fieldsKeySpecifier | (() => undefined | serviceOptionAnswers_stddev_pop_fieldsKeySpecifier),
		fields?: serviceOptionAnswers_stddev_pop_fieldsFieldPolicy,
	},
	serviceOptionAnswers_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionAnswers_stddev_samp_fieldsKeySpecifier | (() => undefined | serviceOptionAnswers_stddev_samp_fieldsKeySpecifier),
		fields?: serviceOptionAnswers_stddev_samp_fieldsFieldPolicy,
	},
	serviceOptionAnswers_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionAnswers_sum_fieldsKeySpecifier | (() => undefined | serviceOptionAnswers_sum_fieldsKeySpecifier),
		fields?: serviceOptionAnswers_sum_fieldsFieldPolicy,
	},
	serviceOptionAnswers_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionAnswers_var_pop_fieldsKeySpecifier | (() => undefined | serviceOptionAnswers_var_pop_fieldsKeySpecifier),
		fields?: serviceOptionAnswers_var_pop_fieldsFieldPolicy,
	},
	serviceOptionAnswers_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionAnswers_var_samp_fieldsKeySpecifier | (() => undefined | serviceOptionAnswers_var_samp_fieldsKeySpecifier),
		fields?: serviceOptionAnswers_var_samp_fieldsFieldPolicy,
	},
	serviceOptionAnswers_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionAnswers_variance_fieldsKeySpecifier | (() => undefined | serviceOptionAnswers_variance_fieldsKeySpecifier),
		fields?: serviceOptionAnswers_variance_fieldsFieldPolicy,
	},
	serviceOptionSection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSectionKeySpecifier | (() => undefined | serviceOptionSectionKeySpecifier),
		fields?: serviceOptionSectionFieldPolicy,
	},
	serviceOptionSectionOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSectionOptionsKeySpecifier | (() => undefined | serviceOptionSectionOptionsKeySpecifier),
		fields?: serviceOptionSectionOptionsFieldPolicy,
	},
	serviceOptionSectionOptions_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSectionOptions_aggregateKeySpecifier | (() => undefined | serviceOptionSectionOptions_aggregateKeySpecifier),
		fields?: serviceOptionSectionOptions_aggregateFieldPolicy,
	},
	serviceOptionSectionOptions_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSectionOptions_aggregate_fieldsKeySpecifier | (() => undefined | serviceOptionSectionOptions_aggregate_fieldsKeySpecifier),
		fields?: serviceOptionSectionOptions_aggregate_fieldsFieldPolicy,
	},
	serviceOptionSectionOptions_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSectionOptions_avg_fieldsKeySpecifier | (() => undefined | serviceOptionSectionOptions_avg_fieldsKeySpecifier),
		fields?: serviceOptionSectionOptions_avg_fieldsFieldPolicy,
	},
	serviceOptionSectionOptions_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSectionOptions_max_fieldsKeySpecifier | (() => undefined | serviceOptionSectionOptions_max_fieldsKeySpecifier),
		fields?: serviceOptionSectionOptions_max_fieldsFieldPolicy,
	},
	serviceOptionSectionOptions_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSectionOptions_min_fieldsKeySpecifier | (() => undefined | serviceOptionSectionOptions_min_fieldsKeySpecifier),
		fields?: serviceOptionSectionOptions_min_fieldsFieldPolicy,
	},
	serviceOptionSectionOptions_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSectionOptions_mutation_responseKeySpecifier | (() => undefined | serviceOptionSectionOptions_mutation_responseKeySpecifier),
		fields?: serviceOptionSectionOptions_mutation_responseFieldPolicy,
	},
	serviceOptionSectionOptions_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSectionOptions_stddev_fieldsKeySpecifier | (() => undefined | serviceOptionSectionOptions_stddev_fieldsKeySpecifier),
		fields?: serviceOptionSectionOptions_stddev_fieldsFieldPolicy,
	},
	serviceOptionSectionOptions_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSectionOptions_stddev_pop_fieldsKeySpecifier | (() => undefined | serviceOptionSectionOptions_stddev_pop_fieldsKeySpecifier),
		fields?: serviceOptionSectionOptions_stddev_pop_fieldsFieldPolicy,
	},
	serviceOptionSectionOptions_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSectionOptions_stddev_samp_fieldsKeySpecifier | (() => undefined | serviceOptionSectionOptions_stddev_samp_fieldsKeySpecifier),
		fields?: serviceOptionSectionOptions_stddev_samp_fieldsFieldPolicy,
	},
	serviceOptionSectionOptions_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSectionOptions_sum_fieldsKeySpecifier | (() => undefined | serviceOptionSectionOptions_sum_fieldsKeySpecifier),
		fields?: serviceOptionSectionOptions_sum_fieldsFieldPolicy,
	},
	serviceOptionSectionOptions_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSectionOptions_var_pop_fieldsKeySpecifier | (() => undefined | serviceOptionSectionOptions_var_pop_fieldsKeySpecifier),
		fields?: serviceOptionSectionOptions_var_pop_fieldsFieldPolicy,
	},
	serviceOptionSectionOptions_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSectionOptions_var_samp_fieldsKeySpecifier | (() => undefined | serviceOptionSectionOptions_var_samp_fieldsKeySpecifier),
		fields?: serviceOptionSectionOptions_var_samp_fieldsFieldPolicy,
	},
	serviceOptionSectionOptions_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSectionOptions_variance_fieldsKeySpecifier | (() => undefined | serviceOptionSectionOptions_variance_fieldsKeySpecifier),
		fields?: serviceOptionSectionOptions_variance_fieldsFieldPolicy,
	},
	serviceOptionSection_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSection_aggregateKeySpecifier | (() => undefined | serviceOptionSection_aggregateKeySpecifier),
		fields?: serviceOptionSection_aggregateFieldPolicy,
	},
	serviceOptionSection_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSection_aggregate_fieldsKeySpecifier | (() => undefined | serviceOptionSection_aggregate_fieldsKeySpecifier),
		fields?: serviceOptionSection_aggregate_fieldsFieldPolicy,
	},
	serviceOptionSection_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSection_avg_fieldsKeySpecifier | (() => undefined | serviceOptionSection_avg_fieldsKeySpecifier),
		fields?: serviceOptionSection_avg_fieldsFieldPolicy,
	},
	serviceOptionSection_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSection_max_fieldsKeySpecifier | (() => undefined | serviceOptionSection_max_fieldsKeySpecifier),
		fields?: serviceOptionSection_max_fieldsFieldPolicy,
	},
	serviceOptionSection_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSection_min_fieldsKeySpecifier | (() => undefined | serviceOptionSection_min_fieldsKeySpecifier),
		fields?: serviceOptionSection_min_fieldsFieldPolicy,
	},
	serviceOptionSection_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSection_mutation_responseKeySpecifier | (() => undefined | serviceOptionSection_mutation_responseKeySpecifier),
		fields?: serviceOptionSection_mutation_responseFieldPolicy,
	},
	serviceOptionSection_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSection_stddev_fieldsKeySpecifier | (() => undefined | serviceOptionSection_stddev_fieldsKeySpecifier),
		fields?: serviceOptionSection_stddev_fieldsFieldPolicy,
	},
	serviceOptionSection_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSection_stddev_pop_fieldsKeySpecifier | (() => undefined | serviceOptionSection_stddev_pop_fieldsKeySpecifier),
		fields?: serviceOptionSection_stddev_pop_fieldsFieldPolicy,
	},
	serviceOptionSection_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSection_stddev_samp_fieldsKeySpecifier | (() => undefined | serviceOptionSection_stddev_samp_fieldsKeySpecifier),
		fields?: serviceOptionSection_stddev_samp_fieldsFieldPolicy,
	},
	serviceOptionSection_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSection_sum_fieldsKeySpecifier | (() => undefined | serviceOptionSection_sum_fieldsKeySpecifier),
		fields?: serviceOptionSection_sum_fieldsFieldPolicy,
	},
	serviceOptionSection_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSection_var_pop_fieldsKeySpecifier | (() => undefined | serviceOptionSection_var_pop_fieldsKeySpecifier),
		fields?: serviceOptionSection_var_pop_fieldsFieldPolicy,
	},
	serviceOptionSection_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSection_var_samp_fieldsKeySpecifier | (() => undefined | serviceOptionSection_var_samp_fieldsKeySpecifier),
		fields?: serviceOptionSection_var_samp_fieldsFieldPolicy,
	},
	serviceOptionSection_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionSection_variance_fieldsKeySpecifier | (() => undefined | serviceOptionSection_variance_fieldsKeySpecifier),
		fields?: serviceOptionSection_variance_fieldsFieldPolicy,
	},
	serviceOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionsKeySpecifier | (() => undefined | serviceOptionsKeySpecifier),
		fields?: serviceOptionsFieldPolicy,
	},
	serviceOptionsStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionsStatusKeySpecifier | (() => undefined | serviceOptionsStatusKeySpecifier),
		fields?: serviceOptionsStatusFieldPolicy,
	},
	serviceOptionsStatus_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionsStatus_aggregateKeySpecifier | (() => undefined | serviceOptionsStatus_aggregateKeySpecifier),
		fields?: serviceOptionsStatus_aggregateFieldPolicy,
	},
	serviceOptionsStatus_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionsStatus_aggregate_fieldsKeySpecifier | (() => undefined | serviceOptionsStatus_aggregate_fieldsKeySpecifier),
		fields?: serviceOptionsStatus_aggregate_fieldsFieldPolicy,
	},
	serviceOptionsStatus_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionsStatus_max_fieldsKeySpecifier | (() => undefined | serviceOptionsStatus_max_fieldsKeySpecifier),
		fields?: serviceOptionsStatus_max_fieldsFieldPolicy,
	},
	serviceOptionsStatus_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionsStatus_min_fieldsKeySpecifier | (() => undefined | serviceOptionsStatus_min_fieldsKeySpecifier),
		fields?: serviceOptionsStatus_min_fieldsFieldPolicy,
	},
	serviceOptionsStatus_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptionsStatus_mutation_responseKeySpecifier | (() => undefined | serviceOptionsStatus_mutation_responseKeySpecifier),
		fields?: serviceOptionsStatus_mutation_responseFieldPolicy,
	},
	serviceOptions_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptions_aggregateKeySpecifier | (() => undefined | serviceOptions_aggregateKeySpecifier),
		fields?: serviceOptions_aggregateFieldPolicy,
	},
	serviceOptions_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptions_aggregate_fieldsKeySpecifier | (() => undefined | serviceOptions_aggregate_fieldsKeySpecifier),
		fields?: serviceOptions_aggregate_fieldsFieldPolicy,
	},
	serviceOptions_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptions_max_fieldsKeySpecifier | (() => undefined | serviceOptions_max_fieldsKeySpecifier),
		fields?: serviceOptions_max_fieldsFieldPolicy,
	},
	serviceOptions_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptions_min_fieldsKeySpecifier | (() => undefined | serviceOptions_min_fieldsKeySpecifier),
		fields?: serviceOptions_min_fieldsFieldPolicy,
	},
	serviceOptions_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceOptions_mutation_responseKeySpecifier | (() => undefined | serviceOptions_mutation_responseKeySpecifier),
		fields?: serviceOptions_mutation_responseFieldPolicy,
	},
	servicePictures?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePicturesKeySpecifier | (() => undefined | servicePicturesKeySpecifier),
		fields?: servicePicturesFieldPolicy,
	},
	servicePictures_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePictures_aggregateKeySpecifier | (() => undefined | servicePictures_aggregateKeySpecifier),
		fields?: servicePictures_aggregateFieldPolicy,
	},
	servicePictures_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePictures_aggregate_fieldsKeySpecifier | (() => undefined | servicePictures_aggregate_fieldsKeySpecifier),
		fields?: servicePictures_aggregate_fieldsFieldPolicy,
	},
	servicePictures_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePictures_max_fieldsKeySpecifier | (() => undefined | servicePictures_max_fieldsKeySpecifier),
		fields?: servicePictures_max_fieldsFieldPolicy,
	},
	servicePictures_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePictures_min_fieldsKeySpecifier | (() => undefined | servicePictures_min_fieldsKeySpecifier),
		fields?: servicePictures_min_fieldsFieldPolicy,
	},
	servicePictures_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePictures_mutation_responseKeySpecifier | (() => undefined | servicePictures_mutation_responseKeySpecifier),
		fields?: servicePictures_mutation_responseFieldPolicy,
	},
	servicePricings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePricingsKeySpecifier | (() => undefined | servicePricingsKeySpecifier),
		fields?: servicePricingsFieldPolicy,
	},
	servicePricings_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePricings_aggregateKeySpecifier | (() => undefined | servicePricings_aggregateKeySpecifier),
		fields?: servicePricings_aggregateFieldPolicy,
	},
	servicePricings_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePricings_aggregate_fieldsKeySpecifier | (() => undefined | servicePricings_aggregate_fieldsKeySpecifier),
		fields?: servicePricings_aggregate_fieldsFieldPolicy,
	},
	servicePricings_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePricings_avg_fieldsKeySpecifier | (() => undefined | servicePricings_avg_fieldsKeySpecifier),
		fields?: servicePricings_avg_fieldsFieldPolicy,
	},
	servicePricings_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePricings_max_fieldsKeySpecifier | (() => undefined | servicePricings_max_fieldsKeySpecifier),
		fields?: servicePricings_max_fieldsFieldPolicy,
	},
	servicePricings_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePricings_min_fieldsKeySpecifier | (() => undefined | servicePricings_min_fieldsKeySpecifier),
		fields?: servicePricings_min_fieldsFieldPolicy,
	},
	servicePricings_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePricings_mutation_responseKeySpecifier | (() => undefined | servicePricings_mutation_responseKeySpecifier),
		fields?: servicePricings_mutation_responseFieldPolicy,
	},
	servicePricings_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePricings_stddev_fieldsKeySpecifier | (() => undefined | servicePricings_stddev_fieldsKeySpecifier),
		fields?: servicePricings_stddev_fieldsFieldPolicy,
	},
	servicePricings_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePricings_stddev_pop_fieldsKeySpecifier | (() => undefined | servicePricings_stddev_pop_fieldsKeySpecifier),
		fields?: servicePricings_stddev_pop_fieldsFieldPolicy,
	},
	servicePricings_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePricings_stddev_samp_fieldsKeySpecifier | (() => undefined | servicePricings_stddev_samp_fieldsKeySpecifier),
		fields?: servicePricings_stddev_samp_fieldsFieldPolicy,
	},
	servicePricings_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePricings_sum_fieldsKeySpecifier | (() => undefined | servicePricings_sum_fieldsKeySpecifier),
		fields?: servicePricings_sum_fieldsFieldPolicy,
	},
	servicePricings_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePricings_var_pop_fieldsKeySpecifier | (() => undefined | servicePricings_var_pop_fieldsKeySpecifier),
		fields?: servicePricings_var_pop_fieldsFieldPolicy,
	},
	servicePricings_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePricings_var_samp_fieldsKeySpecifier | (() => undefined | servicePricings_var_samp_fieldsKeySpecifier),
		fields?: servicePricings_var_samp_fieldsFieldPolicy,
	},
	servicePricings_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicePricings_variance_fieldsKeySpecifier | (() => undefined | servicePricings_variance_fieldsKeySpecifier),
		fields?: servicePricings_variance_fieldsFieldPolicy,
	},
	serviceSectionOptionQuantityType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceSectionOptionQuantityTypeKeySpecifier | (() => undefined | serviceSectionOptionQuantityTypeKeySpecifier),
		fields?: serviceSectionOptionQuantityTypeFieldPolicy,
	},
	serviceSectionOptionQuantityType_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceSectionOptionQuantityType_aggregateKeySpecifier | (() => undefined | serviceSectionOptionQuantityType_aggregateKeySpecifier),
		fields?: serviceSectionOptionQuantityType_aggregateFieldPolicy,
	},
	serviceSectionOptionQuantityType_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceSectionOptionQuantityType_aggregate_fieldsKeySpecifier | (() => undefined | serviceSectionOptionQuantityType_aggregate_fieldsKeySpecifier),
		fields?: serviceSectionOptionQuantityType_aggregate_fieldsFieldPolicy,
	},
	serviceSectionOptionQuantityType_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceSectionOptionQuantityType_max_fieldsKeySpecifier | (() => undefined | serviceSectionOptionQuantityType_max_fieldsKeySpecifier),
		fields?: serviceSectionOptionQuantityType_max_fieldsFieldPolicy,
	},
	serviceSectionOptionQuantityType_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceSectionOptionQuantityType_min_fieldsKeySpecifier | (() => undefined | serviceSectionOptionQuantityType_min_fieldsKeySpecifier),
		fields?: serviceSectionOptionQuantityType_min_fieldsFieldPolicy,
	},
	serviceSectionOptionQuantityType_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceSectionOptionQuantityType_mutation_responseKeySpecifier | (() => undefined | serviceSectionOptionQuantityType_mutation_responseKeySpecifier),
		fields?: serviceSectionOptionQuantityType_mutation_responseFieldPolicy,
	},
	serviceSectionOptionType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceSectionOptionTypeKeySpecifier | (() => undefined | serviceSectionOptionTypeKeySpecifier),
		fields?: serviceSectionOptionTypeFieldPolicy,
	},
	serviceSectionOptionType_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceSectionOptionType_aggregateKeySpecifier | (() => undefined | serviceSectionOptionType_aggregateKeySpecifier),
		fields?: serviceSectionOptionType_aggregateFieldPolicy,
	},
	serviceSectionOptionType_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceSectionOptionType_aggregate_fieldsKeySpecifier | (() => undefined | serviceSectionOptionType_aggregate_fieldsKeySpecifier),
		fields?: serviceSectionOptionType_aggregate_fieldsFieldPolicy,
	},
	serviceSectionOptionType_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceSectionOptionType_max_fieldsKeySpecifier | (() => undefined | serviceSectionOptionType_max_fieldsKeySpecifier),
		fields?: serviceSectionOptionType_max_fieldsFieldPolicy,
	},
	serviceSectionOptionType_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceSectionOptionType_min_fieldsKeySpecifier | (() => undefined | serviceSectionOptionType_min_fieldsKeySpecifier),
		fields?: serviceSectionOptionType_min_fieldsFieldPolicy,
	},
	serviceSectionOptionType_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceSectionOptionType_mutation_responseKeySpecifier | (() => undefined | serviceSectionOptionType_mutation_responseKeySpecifier),
		fields?: serviceSectionOptionType_mutation_responseFieldPolicy,
	},
	serviceStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceStatusKeySpecifier | (() => undefined | serviceStatusKeySpecifier),
		fields?: serviceStatusFieldPolicy,
	},
	serviceStatus_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceStatus_aggregateKeySpecifier | (() => undefined | serviceStatus_aggregateKeySpecifier),
		fields?: serviceStatus_aggregateFieldPolicy,
	},
	serviceStatus_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceStatus_aggregate_fieldsKeySpecifier | (() => undefined | serviceStatus_aggregate_fieldsKeySpecifier),
		fields?: serviceStatus_aggregate_fieldsFieldPolicy,
	},
	serviceStatus_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceStatus_max_fieldsKeySpecifier | (() => undefined | serviceStatus_max_fieldsKeySpecifier),
		fields?: serviceStatus_max_fieldsFieldPolicy,
	},
	serviceStatus_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceStatus_min_fieldsKeySpecifier | (() => undefined | serviceStatus_min_fieldsKeySpecifier),
		fields?: serviceStatus_min_fieldsFieldPolicy,
	},
	serviceStatus_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceStatus_mutation_responseKeySpecifier | (() => undefined | serviceStatus_mutation_responseKeySpecifier),
		fields?: serviceStatus_mutation_responseFieldPolicy,
	},
	services?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicesKeySpecifier | (() => undefined | servicesKeySpecifier),
		fields?: servicesFieldPolicy,
	},
	servicesForms?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicesFormsKeySpecifier | (() => undefined | servicesFormsKeySpecifier),
		fields?: servicesFormsFieldPolicy,
	},
	servicesForms_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicesForms_aggregateKeySpecifier | (() => undefined | servicesForms_aggregateKeySpecifier),
		fields?: servicesForms_aggregateFieldPolicy,
	},
	servicesForms_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicesForms_aggregate_fieldsKeySpecifier | (() => undefined | servicesForms_aggregate_fieldsKeySpecifier),
		fields?: servicesForms_aggregate_fieldsFieldPolicy,
	},
	servicesForms_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicesForms_max_fieldsKeySpecifier | (() => undefined | servicesForms_max_fieldsKeySpecifier),
		fields?: servicesForms_max_fieldsFieldPolicy,
	},
	servicesForms_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicesForms_min_fieldsKeySpecifier | (() => undefined | servicesForms_min_fieldsKeySpecifier),
		fields?: servicesForms_min_fieldsFieldPolicy,
	},
	servicesForms_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | servicesForms_mutation_responseKeySpecifier | (() => undefined | servicesForms_mutation_responseKeySpecifier),
		fields?: servicesForms_mutation_responseFieldPolicy,
	},
	services_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | services_aggregateKeySpecifier | (() => undefined | services_aggregateKeySpecifier),
		fields?: services_aggregateFieldPolicy,
	},
	services_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | services_aggregate_fieldsKeySpecifier | (() => undefined | services_aggregate_fieldsKeySpecifier),
		fields?: services_aggregate_fieldsFieldPolicy,
	},
	services_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | services_avg_fieldsKeySpecifier | (() => undefined | services_avg_fieldsKeySpecifier),
		fields?: services_avg_fieldsFieldPolicy,
	},
	services_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | services_max_fieldsKeySpecifier | (() => undefined | services_max_fieldsKeySpecifier),
		fields?: services_max_fieldsFieldPolicy,
	},
	services_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | services_min_fieldsKeySpecifier | (() => undefined | services_min_fieldsKeySpecifier),
		fields?: services_min_fieldsFieldPolicy,
	},
	services_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | services_mutation_responseKeySpecifier | (() => undefined | services_mutation_responseKeySpecifier),
		fields?: services_mutation_responseFieldPolicy,
	},
	services_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | services_stddev_fieldsKeySpecifier | (() => undefined | services_stddev_fieldsKeySpecifier),
		fields?: services_stddev_fieldsFieldPolicy,
	},
	services_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | services_stddev_pop_fieldsKeySpecifier | (() => undefined | services_stddev_pop_fieldsKeySpecifier),
		fields?: services_stddev_pop_fieldsFieldPolicy,
	},
	services_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | services_stddev_samp_fieldsKeySpecifier | (() => undefined | services_stddev_samp_fieldsKeySpecifier),
		fields?: services_stddev_samp_fieldsFieldPolicy,
	},
	services_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | services_sum_fieldsKeySpecifier | (() => undefined | services_sum_fieldsKeySpecifier),
		fields?: services_sum_fieldsFieldPolicy,
	},
	services_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | services_var_pop_fieldsKeySpecifier | (() => undefined | services_var_pop_fieldsKeySpecifier),
		fields?: services_var_pop_fieldsFieldPolicy,
	},
	services_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | services_var_samp_fieldsKeySpecifier | (() => undefined | services_var_samp_fieldsKeySpecifier),
		fields?: services_var_samp_fieldsFieldPolicy,
	},
	services_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | services_variance_fieldsKeySpecifier | (() => undefined | services_variance_fieldsKeySpecifier),
		fields?: services_variance_fieldsFieldPolicy,
	},
	sessions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | sessionsKeySpecifier | (() => undefined | sessionsKeySpecifier),
		fields?: sessionsFieldPolicy,
	},
	sessions_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | sessions_aggregateKeySpecifier | (() => undefined | sessions_aggregateKeySpecifier),
		fields?: sessions_aggregateFieldPolicy,
	},
	sessions_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | sessions_aggregate_fieldsKeySpecifier | (() => undefined | sessions_aggregate_fieldsKeySpecifier),
		fields?: sessions_aggregate_fieldsFieldPolicy,
	},
	sessions_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | sessions_max_fieldsKeySpecifier | (() => undefined | sessions_max_fieldsKeySpecifier),
		fields?: sessions_max_fieldsFieldPolicy,
	},
	sessions_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | sessions_min_fieldsKeySpecifier | (() => undefined | sessions_min_fieldsKeySpecifier),
		fields?: sessions_min_fieldsFieldPolicy,
	},
	sessions_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | sessions_mutation_responseKeySpecifier | (() => undefined | sessions_mutation_responseKeySpecifier),
		fields?: sessions_mutation_responseFieldPolicy,
	},
	subscription_root?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | subscription_rootKeySpecifier | (() => undefined | subscription_rootKeySpecifier),
		fields?: subscription_rootFieldPolicy,
	},
	timeouts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | timeoutsKeySpecifier | (() => undefined | timeoutsKeySpecifier),
		fields?: timeoutsFieldPolicy,
	},
	timeouts_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | timeouts_aggregateKeySpecifier | (() => undefined | timeouts_aggregateKeySpecifier),
		fields?: timeouts_aggregateFieldPolicy,
	},
	timeouts_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | timeouts_aggregate_fieldsKeySpecifier | (() => undefined | timeouts_aggregate_fieldsKeySpecifier),
		fields?: timeouts_aggregate_fieldsFieldPolicy,
	},
	timeouts_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | timeouts_max_fieldsKeySpecifier | (() => undefined | timeouts_max_fieldsKeySpecifier),
		fields?: timeouts_max_fieldsFieldPolicy,
	},
	timeouts_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | timeouts_min_fieldsKeySpecifier | (() => undefined | timeouts_min_fieldsKeySpecifier),
		fields?: timeouts_min_fieldsFieldPolicy,
	},
	timeouts_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | timeouts_mutation_responseKeySpecifier | (() => undefined | timeouts_mutation_responseKeySpecifier),
		fields?: timeouts_mutation_responseFieldPolicy,
	},
	transitionStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | transitionStatusKeySpecifier | (() => undefined | transitionStatusKeySpecifier),
		fields?: transitionStatusFieldPolicy,
	},
	transitionStatus_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | transitionStatus_aggregateKeySpecifier | (() => undefined | transitionStatus_aggregateKeySpecifier),
		fields?: transitionStatus_aggregateFieldPolicy,
	},
	transitionStatus_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | transitionStatus_aggregate_fieldsKeySpecifier | (() => undefined | transitionStatus_aggregate_fieldsKeySpecifier),
		fields?: transitionStatus_aggregate_fieldsFieldPolicy,
	},
	transitionStatus_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | transitionStatus_max_fieldsKeySpecifier | (() => undefined | transitionStatus_max_fieldsKeySpecifier),
		fields?: transitionStatus_max_fieldsFieldPolicy,
	},
	transitionStatus_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | transitionStatus_min_fieldsKeySpecifier | (() => undefined | transitionStatus_min_fieldsKeySpecifier),
		fields?: transitionStatus_min_fieldsFieldPolicy,
	},
	transitionStatus_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | transitionStatus_mutation_responseKeySpecifier | (() => undefined | transitionStatus_mutation_responseKeySpecifier),
		fields?: transitionStatus_mutation_responseFieldPolicy,
	},
	unavailableServiceLocations?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | unavailableServiceLocationsKeySpecifier | (() => undefined | unavailableServiceLocationsKeySpecifier),
		fields?: unavailableServiceLocationsFieldPolicy,
	},
	unavailableServiceLocations_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | unavailableServiceLocations_aggregateKeySpecifier | (() => undefined | unavailableServiceLocations_aggregateKeySpecifier),
		fields?: unavailableServiceLocations_aggregateFieldPolicy,
	},
	unavailableServiceLocations_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | unavailableServiceLocations_aggregate_fieldsKeySpecifier | (() => undefined | unavailableServiceLocations_aggregate_fieldsKeySpecifier),
		fields?: unavailableServiceLocations_aggregate_fieldsFieldPolicy,
	},
	unavailableServiceLocations_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | unavailableServiceLocations_max_fieldsKeySpecifier | (() => undefined | unavailableServiceLocations_max_fieldsKeySpecifier),
		fields?: unavailableServiceLocations_max_fieldsFieldPolicy,
	},
	unavailableServiceLocations_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | unavailableServiceLocations_min_fieldsKeySpecifier | (() => undefined | unavailableServiceLocations_min_fieldsKeySpecifier),
		fields?: unavailableServiceLocations_min_fieldsFieldPolicy,
	},
	unavailableServiceLocations_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | unavailableServiceLocations_mutation_responseKeySpecifier | (() => undefined | unavailableServiceLocations_mutation_responseKeySpecifier),
		fields?: unavailableServiceLocations_mutation_responseFieldPolicy,
	},
	userRole?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | userRoleKeySpecifier | (() => undefined | userRoleKeySpecifier),
		fields?: userRoleFieldPolicy,
	},
	userRole_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | userRole_aggregateKeySpecifier | (() => undefined | userRole_aggregateKeySpecifier),
		fields?: userRole_aggregateFieldPolicy,
	},
	userRole_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | userRole_aggregate_fieldsKeySpecifier | (() => undefined | userRole_aggregate_fieldsKeySpecifier),
		fields?: userRole_aggregate_fieldsFieldPolicy,
	},
	userRole_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | userRole_max_fieldsKeySpecifier | (() => undefined | userRole_max_fieldsKeySpecifier),
		fields?: userRole_max_fieldsFieldPolicy,
	},
	userRole_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | userRole_min_fieldsKeySpecifier | (() => undefined | userRole_min_fieldsKeySpecifier),
		fields?: userRole_min_fieldsFieldPolicy,
	},
	userRole_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | userRole_mutation_responseKeySpecifier | (() => undefined | userRole_mutation_responseKeySpecifier),
		fields?: userRole_mutation_responseFieldPolicy,
	},
	userRoles?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | userRolesKeySpecifier | (() => undefined | userRolesKeySpecifier),
		fields?: userRolesFieldPolicy,
	},
	userRoles_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | userRoles_aggregateKeySpecifier | (() => undefined | userRoles_aggregateKeySpecifier),
		fields?: userRoles_aggregateFieldPolicy,
	},
	userRoles_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | userRoles_aggregate_fieldsKeySpecifier | (() => undefined | userRoles_aggregate_fieldsKeySpecifier),
		fields?: userRoles_aggregate_fieldsFieldPolicy,
	},
	userRoles_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | userRoles_max_fieldsKeySpecifier | (() => undefined | userRoles_max_fieldsKeySpecifier),
		fields?: userRoles_max_fieldsFieldPolicy,
	},
	userRoles_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | userRoles_min_fieldsKeySpecifier | (() => undefined | userRoles_min_fieldsKeySpecifier),
		fields?: userRoles_min_fieldsFieldPolicy,
	},
	userRoles_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | userRoles_mutation_responseKeySpecifier | (() => undefined | userRoles_mutation_responseKeySpecifier),
		fields?: userRoles_mutation_responseFieldPolicy,
	},
	users?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | usersKeySpecifier | (() => undefined | usersKeySpecifier),
		fields?: usersFieldPolicy,
	},
	users_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | users_aggregateKeySpecifier | (() => undefined | users_aggregateKeySpecifier),
		fields?: users_aggregateFieldPolicy,
	},
	users_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | users_aggregate_fieldsKeySpecifier | (() => undefined | users_aggregate_fieldsKeySpecifier),
		fields?: users_aggregate_fieldsFieldPolicy,
	},
	users_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | users_max_fieldsKeySpecifier | (() => undefined | users_max_fieldsKeySpecifier),
		fields?: users_max_fieldsFieldPolicy,
	},
	users_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | users_min_fieldsKeySpecifier | (() => undefined | users_min_fieldsKeySpecifier),
		fields?: users_min_fieldsFieldPolicy,
	},
	users_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | users_mutation_responseKeySpecifier | (() => undefined | users_mutation_responseKeySpecifier),
		fields?: users_mutation_responseFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;